var tt = Object.defineProperty;
var rt = (e, t, n) => t in e ? tt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var pe = (e, t, n) => (rt(e, typeof t != "symbol" ? t + "" : t, n), n);
import { ref, watch, getCurrentScope, onScopeDispose, unref, computed, getCurrentInstance, onMounted, nextTick, watchEffect, defineComponent, openBlock, createBlock, resolveDynamicComponent, normalizeClass, withCtx, renderSlot, createVNode, h, provide, inject, createElementBlock, createElementVNode, createCommentVNode, Transition, createTextVNode, toDisplayString, Fragment, renderList, withDirectives, mergeProps, vModelDynamic, useSlots, withModifiers, vShow, normalizeProps, guardReactiveProps, reactive, toRefs, Teleport, onBeforeUnmount, resolveComponent, toRaw, normalizeStyle, toHandlers, TransitionGroup, createApp, shallowRef, onUnmounted, withKeys, toRef, isRef, resolveDirective, version as version$1, isProxy } from "vue";
const mapSpaceToMarginBottomClassName = (e) => ({
  "mb-0": e === "none",
  "mb-1": e === "2xs",
  "mb-2": e === "xs",
  "mb-3": e === "sm",
  "mb-4": e === "md",
  "mb-6": e === "lg",
  "mb-8": e === "xl",
  "mb-10": e === "2xl",
  "mb-16": e === "3xl"
}), mapHeightToClassName = (e) => ({
  "h-full": e === "full",
  "h-screen": e === "screen",
  "h-fit": e === "touchable"
}), mapWidthToClassName = (e) => ({
  "w-full": e === "full"
}), mapGrowToClassName = (e) => ({
  grow: e,
  "grow-0": !e
}), mapSpaceToSpaceXClassName = (e) => ({
  "space-x-0": e === "none",
  "space-x-1": e === "2xs",
  "space-x-2": e === "xs",
  "space-x-3": e === "sm",
  "space-x-4": e === "md",
  "space-x-6": e === "lg",
  "space-x-8": e === "xl",
  "space-x-10": e === "2xl",
  "space-x-16": e === "3xl"
}), mapSpaceToSpaceYClassName = (e) => ({
  "space-y-0": e === "none",
  "space-y-1": e === "2xs",
  "space-y-2": e === "xs",
  "space-y-3": e === "sm",
  "space-y-4": e === "md",
  "space-y-6": e === "lg",
  "space-y-8": e === "xl",
  "space-y-10": e === "2xl",
  "space-y-16": e === "3xl"
}), mapToneToClassName = (e) => ({
  "bg-white": e === "base",
  "bg-yellow-300": e === "warning",
  "bg-red-300": e === "error",
  "bg-green-300": e === "success",
  "bg-blue-300": e === "info",
  "bg-brand-orange": e === "primary",
  "bg-black-90": e === "high-emphasis",
  "bg-black-60": e === "medium-emphasis",
  "bg-black-40": e === "low-emphasis",
  "bg-black-20": e === "disabled",
  "bg-transparent": e === "transparent"
}), mapBackgroundToTextClassName = (e) => ({
  "text-ivory-200": e === "primary",
  "text-black-07": e === "secondary",
  "text-black-44": e === "tertiary",
  "text-white": e === "base"
}), mapMaxLinesToLineClampClasses = (e) => ({
  "line-clamp-1": e === "1",
  "line-clamp-2": e === "2",
  "line-clamp-3": e === "3",
  "line-clamp-4": e === "4",
  "line-clamp-5": e === "5",
  "line-clamp-6": e === "6",
  "line-clamp-none": e === "none"
}), mapBackgroundToClassName = (e) => ({
  "bg-brand-background": e === "primary",
  "bg-black-7": e === "secondary"
}), mapBorderRadiusToClassName = (e) => ({
  "rounded-none": e === "none",
  "rounded-sm": e === "sm",
  "rounded-md": e === "md",
  "rounded-lg": e === "lg",
  "rounded-xl": e === "xl",
  "rounded-2xl": e === "2xl",
  "rounded-3xl": e === "3xl",
  "rounded-full": e === "full"
}), mapJoinedToClasses = (e) => ({
  "rounded-l-none border-l-1": e === "left",
  "rounded-r-none border-r-0": e === "right"
}), mapBorderToBorderClassName = (e) => ({
  "border border-hidden": e === "none",
  "border border-solid": e === "solid"
}), mapBorderToneToBorderClassName = (e) => ({
  "border-grey-300": e === "default",
  "border-grey-200": e === "secondary",
  "border-grey-900": e === "high-emphasis",
  "border-red-300": e === "error"
}), mapWeightToBorderWidthClassName = (e) => ({
  "border-t-[0.5px]": e === "regular",
  "border-t-2": e === "strong"
}), mapToneToFormFieldFocusRingClasses$1 = ({
  tone: e,
  focused: t,
  disabled: n
}) => ({
  "border-red-300": e === "error" && !t && n,
  "border-red-300 hover:ring-1 ring-red-300": e === "error" && !t && !n,
  "ring-2 ring-red-300 border-transparent": e === "error" && t,
  "border-grey-200": e === "primary" && !t && n,
  "border-grey-200 hover:ring-1 ring-grey-300": e === "primary" && !t && !n,
  "ring-2 ring-grey-900 border-transparent": e === "primary" && t
}), mapBoxShadowToClassName = (e) => ({
  "shadow-none": e === "none",
  "shadow-sm": e === "sm",
  "shadow-md": e === "md",
  "shadow-lg": e === "lg",
  "shadow-xl": e === "xl"
}), mapAlignToItemsAlignClassName = (e) => ({
  "items-start mr-auto": e === "left",
  "items-center ml-auto mr-auto": e === "center",
  "items-end ml-auto": e === "right"
}), mapVerticalAlignToAlignItemsClassName = (e) => ({
  "flex items-start content-start": e === "top",
  "flex items-center content-center": e === "center",
  "flex items-end content-end": e === "bottom"
}), mapWrapToFlexWrapClassName = (e) => ({
  "flex flex-wrap": e === "normal",
  "flex flex-wrap-reverse": e === "reverse"
}), mapColumnWidthToColumnClassName = (e, t, n) => ({
  "flex-auto": !n && e === "auto",
  "flex-none": !n && e === "content",
  ...t === "row" ? {
    "w-full": Boolean(n) || e === "full",
    "w-1/2": !n && e === "1/2",
    "w-1/3": !n && e === "1/3",
    "w-2/3": !n && e === "2/3",
    "w-1/4": !n && e === "1/4",
    "w-3/4": !n && e === "3/4",
    "w-1/5": !n && e === "1/5",
    "w-2/5": !n && e === "2/5",
    "w-3/5": !n && e === "3/5",
    "w-4/5": !n && e === "4/5",
    "w-1/6": !n && e === "1/6",
    "w-5/6": !n && e === "5/6"
  } : {
    "h-full": Boolean(n) || e === "full",
    "h-1/2": !n && e === "1/2",
    "h-1/3": !n && e === "1/3",
    "h-2/3": !n && e === "2/3",
    "h-1/4": !n && e === "1/4",
    "h-3/4": !n && e === "3/4",
    "h-1/5": !n && e === "1/5",
    "h-2/5": !n && e === "2/5",
    "h-3/5": !n && e === "3/5",
    "h-4/5": !n && e === "4/5",
    "h-1/6": !n && e === "1/6",
    "h-5/6": !n && e === "5/6"
  }
}), mapContentBlockWidthToWidthClassName = (e) => ({
  "w-full max-w-screen-sm": e === "sm",
  "w-full max-w-screen-md": e === "md",
  "w-full max-w-screen-lg": e === "lg",
  "w-full max-w-screen-xl": e === "xl"
}), mapAlignToContentBlockMarginClassName = (e) => ({
  "mr-auto": e === "left",
  "mr-auto ml-auto": e === "center",
  "ml-auto": e === "right"
}), mapAlignToJustifyContentClassName = (e) => ({
  "justify-start": e === "left",
  "justify-center": e === "center",
  "justify-end": e === "right",
  "justify-between": e === "spaceBetween"
}), mapPaddingToPaddingClassName = (e) => ({
  "p-none": e === "none",
  "p-1": e === "2xs",
  "p-2": e === "xs",
  "p-3": e === "sm",
  "p-4": e === "md",
  "p-6": e === "lg",
  "p-8": e === "xl",
  "p-10": e === "2xl",
  "p-16": e === "3xl"
}), mapPaddingYToPaddingYClassName = (e) => ({
  "p-none": e === "none",
  "py-1": e === "2xs",
  "py-2": e === "xs",
  "py-3": e === "sm",
  "py-4": e === "md",
  "py-6": e === "lg",
  "py-8": e === "xl",
  "py-10": e === "2xl",
  "py-16": e === "3xl"
}), mapPaddingTopToPaddingTopClassName = (e) => ({
  "p-none": e === "none",
  "pt-1": e === "2xs",
  "pt-2": e === "xs",
  "pt-3": e === "sm",
  "pt-4": e === "md",
  "pt-6": e === "lg",
  "pt-8": e === "xl",
  "pt-10": e === "2xl",
  "pt-16": e === "3xl"
}), mapPaddingRightToPaddingRightClassName = (e) => ({
  "p-none": e === "none",
  "pr-1": e === "2xs",
  "pr-2": e === "xs",
  "pr-3": e === "sm",
  "pr-4": e === "md",
  "pr-6": e === "lg",
  "pr-8": e === "xl",
  "pr-10": e === "2xl",
  "pr-16": e === "3xl"
}), mapPaddingBottomToPaddingBottomClassName = (e) => ({
  "p-none": e === "none",
  "pb-1": e === "2xs",
  "pb-2": e === "xs",
  "pb-3": e === "sm",
  "pb-4": e === "md",
  "pb-6": e === "lg",
  "pb-8": e === "xl",
  "pb-10": e === "2xl",
  "pb-16": e === "3xl"
}), mapPaddingLeftToPaddingLeftClassName = (e) => ({
  "p-none": e === "none",
  "pl-1": e === "2xs",
  "pl-2": e === "xs",
  "pl-3": e === "sm",
  "pl-4": e === "md",
  "pl-6": e === "lg",
  "pl-8": e === "xl",
  "pl-10": e === "2xl",
  "pl-16": e === "3xl"
}), mapPaddingXToPaddingXClassName = (e) => ({
  "p-none": e === "none",
  "px-1": e === "2xs",
  "px-2": e === "xs",
  "px-3": e === "sm",
  "px-4": e === "md",
  "px-6": e === "lg",
  "px-8": e === "xl",
  "px-10": e === "2xl",
  "px-16": e === "3xl"
}), mapColumnsToGridColumnsClassName = (e) => ({
  "grid-cols-1": e === "1",
  "grid-cols-2": e === "2",
  "grid-cols-3": e === "3",
  "grid-cols-4": e === "4",
  "grid-cols-5": e === "5",
  "grid-cols-6": e === "6",
  "grid-cols-7": e === "7",
  "grid-cols-8": e === "8"
}), mapSpaceToGapClassName = (e) => ({
  "gap-0": e === "none",
  "gap-1": e === "2xs",
  "gap-2": e === "xs",
  "gap-3": e === "sm",
  "gap-4": e === "md",
  "gap-6": e === "lg",
  "gap-8": e === "xl",
  "gap-10": e === "2xl",
  "gap-16": e === "3xl"
}), mapSpaceToColumnSpaceClassName = (e) => ({
  "gap-x-0": e === "none",
  "gap-x-1": e === "2xs",
  "gap-x-2": e === "xs",
  "gap-x-3": e === "sm",
  "gap-x-4": e === "md",
  "gap-x-6": e === "lg",
  "gap-x-8": e === "xl",
  "gap-x-10": e === "2xl",
  "gap-x-16": e === "3xl"
}), mapContentAlignToContentAlignClassName = (e) => ({
  "flex items-start justify-start": e === "left",
  "flex items-center justify-center": e === "center",
  "flex items-right justify-end": e === "right"
}), mapTextAlignToContentAlignClassName = (e) => ({
  "text-start": e === "left",
  "text-center": e === "center",
  "text-end": e === "right"
}), mapSizeToButtonClasses = (e) => ({
  "px-6 h-12": e === "lg",
  "px-5 h-10": e === "md",
  "px-4 h-9": e === "sm"
}), mapSizeToButtonLeftIconOffsetClasses = (e) => ({
  "-ml-4": e === "lg",
  "-ml-3": e === "md",
  "-ml-2": e === "sm"
}), mapSizeToButtonRightIconOffsetClasses = (e) => ({
  "-mr-4": e === "lg",
  "-mr-3": e === "md",
  "-mr-2": e === "sm"
}), mapSizeToIcon = (e) => ({
  "w-12 h-12 stroke-3": e === "xl",
  // 48px
  "w-9 h-9 stroke-2.5": e === "lg",
  // 36px
  "w-6 h-6 stroke-2": e === "md",
  // 24px
  "w-5 h-5 stroke-1.5": e === "sm",
  // 20px
  "w-3 h-3 stroke-1": e === "xs"
  // 12px
}), mapSizeToShape = (e) => ({
  "w-20 h-20 stroke-2.5": e === "xl",
  // 80x80
  "w-12 h-12 stroke-2.5": e === "lg",
  // 48x48
  "w-10 h-10 stroke-2": e === "md",
  // 40x40
  "w-8 h-8 stroke-1.5": e === "sm",
  // 32x32
  "w-5 h-5 stroke-1.5": e === "xs"
  // 20x20
}), mapBadgeSizeToIconSize = (e) => ({
  xs: "xs",
  sm: "sm",
  md: "sm",
  lg: "md",
  xl: "lg"
})[e], mapShapeStyleToShape = (e) => ({
  "stroke-dash-4-4 fill-none stroke-current": e === "dashed-line",
  // 24px
  "fill-current stroke-none": e === "filled"
  // 24px
}), mapWidthToButtonClasses = (e) => ({
  "w-max": e === "auto",
  "w-full": e === "full"
}), mapDisabledAndLoadingToButtonClasses = ({
  disabled: e,
  loading: t
}) => ({
  "focus-visible:ring-2 focus-visible:ring-brand-orange focus-visible:ring-opacity-30 active:scale-96": !e && !t,
  "cursor-default": e || t
}), mapVariantToButtonClasses = ({
  variant: e,
  disabled: t,
  loading: n
}) => ({
  ...e === "primary" && {
    "bg-brand-orange": !t,
    "bg-grey-100": t,
    "hover:shadow-button hover:bg-brand-orange hover:bg-opacity-80": !n && !t
  },
  ...e === "secondary-legacy" && {
    "bg-grey-100": !0,
    "hover:shadow-button": !n && !t
  },
  ...e === "secondary" && {
    "bg-transparent": !t,
    "bg-grey-100": t,
    "hover:shadow-button": !n && !t
  },
  ...e === "tertiary" && {
    "bg-transparent border border-brand-orange": !t,
    "bg-transparent border border-grey-200": t,
    "hover:bg-brand-orange hover:bg-opacity-25": !n && !t
  },
  ...e === "text" && {
    "bg-transparent border-brand-orange": !t,
    "bg-transparent": t,
    "hover:bg-brand-orange hover:bg-opacity-25": !n && !t
  }
}), mapSizeToTitleHeadingClasses = (e) => ({
  "font-display-medium text-3xl md:text-4xl": e === "4xl",
  "font-text-bold md:font-display-bold text-2xl md:text-3xl": e === "3xl",
  "font-text-bold text-xl md:text-2xl": e === "2xl",
  "font-text-bold text-lg md:text-xl": e === "xl",
  "font-text-bold text-lg": e === "lg",
  "font-text-bold text-base": e === "md",
  "font-text-bold text-sm": e === "sm"
}), mapSizeToDisplayHeadingClasses = (e) => ({
  "font-display-medium text-8xl lg:text-9xl": e === "2xl",
  "font-display-medium text-5xl md:text-6xl lg:text-8xl": e === "xl",
  "font-display-medium text-5xl md:text-6xl lg:text-7xl": e === "lg",
  "font-display-medium text-4xl md:text-5xl lg:text-6xl": e === "md",
  "font-display-medium text-4xl md:text-5xl": e === "sm"
}), mapSizeToBodyTextClasses = (e) => ({
  "font-display-regular text-3xl md:text-4xl": e === "4xl",
  "font-text-regular md:font-display-regular text-2xl md:text-3xl": e === "3xl",
  "font-text-regular text-xl md:text-2xl": e === "2xl",
  "font-text-regular text-lg md:text-xl": e === "xl",
  "font-text-regular text-lg": e === "lg",
  "font-text-regular text-base": e === "md",
  "font-text-regular text-sm": e === "sm",
  "font-text-regular text-xs": e === "xs"
}), mapSizeToInteractiveTextClasses = (e) => ({
  "text-xl": e === "xl",
  "text-lg": e === "lg",
  "text-base": e === "md",
  "text-sm": e === "sm",
  "text-xs": e === "xs"
}), mapWeightToInteractiveTextClasses = (e) => ({
  "font-text-bold": e === "strong",
  "font-text-regular": e === "regular"
}), mapToneToTextClasses = (e) => ({
  "text-white": e === "base",
  "text-yellow-300": e === "warning",
  "text-red-300": e === "error",
  "text-green-300": e === "success",
  "text-blue-300": e === "info",
  "text-brand-orange": e === "primary",
  "text-black-90": e === "high-emphasis",
  "text-black-60": e === "medium-emphasis",
  "text-black-40": e === "low-emphasis",
  "text-black-20": e === "disabled"
}), mapAlignToTextClasses = (e) => ({
  "text-left": e === "left",
  "text-center": e === "center",
  "text-right": e === "right"
}), mapDisabledToCursorClasses = (e) => ({
  "cursor-default": e
}), mapSkeletonHeightToHeight = (e) => ({
  "h-0": e === "none",
  "h-1": e === "2xs",
  "h-2": e === "xs",
  "h-3": e === "sm",
  "h-4": e === "md",
  "h-6": e === "lg",
  "h-8": e === "xl",
  "h-10": e === "2xl",
  "h-16": e === "3xl",
  "h-fit": e === "content"
}), mapSkeletonWidthToWidth = (e) => ({
  "w-0": e === "none",
  "w-1": e === "2xs",
  "w-2": e === "xs",
  "w-3": e === "sm",
  "w-4": e === "md",
  "w-6": e === "lg",
  "w-8": e === "xl",
  "w-10": e === "2xl",
  "w-16": e === "3xl",
  "w-1/2": e === "1/2",
  "w-1/3": e === "1/3",
  "w-2/3": e === "2/3",
  "w-1/4": e === "1/4",
  "w-3/4": e === "3/4",
  "w-1/5": e === "1/5",
  "w-2/5": e === "2/5",
  "w-3/5": e === "3/5",
  "w-4/5": e === "4/5",
  "w-1/6": e === "1/6",
  "w-5/6": e === "5/6",
  "w-full": e === "full",
  "w-fit": e === "content"
}), mapColumnDirectionToClasses = (e) => ({
  "flex-row": e === "row",
  "flex-col justify-between h-full": e === "column"
});
var _a;
const isClient = typeof window < "u", isString$2 = (e) => typeof e == "string", noop$2 = () => {
}, isIOS = isClient && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function resolveUnref(e) {
  return typeof e == "function" ? e() : unref(e);
}
function createFilterWrapper(e, t) {
  function n(...s) {
    return new Promise((i, a) => {
      Promise.resolve(e(() => t.apply(this, s), { fn: t, thisArg: this, args: s })).then(i).catch(a);
    });
  }
  return n;
}
function debounceFilter(e, t = {}) {
  let n, s, i = noop$2;
  const a = (l) => {
    clearTimeout(l), i(), i = noop$2;
  };
  return (l) => {
    const c = resolveUnref(e), u = resolveUnref(t.maxWait);
    return n && a(n), c <= 0 || u !== void 0 && u <= 0 ? (s && (a(s), s = null), Promise.resolve(l())) : new Promise((d, p) => {
      i = t.rejectOnCancel ? p : d, u && !s && (s = setTimeout(() => {
        n && a(n), s = null, d(l());
      }, u)), n = setTimeout(() => {
        s && a(s), s = null, d(l());
      }, c);
    });
  };
}
function identity$4(e) {
  return e;
}
function tryOnScopeDispose(e) {
  return getCurrentScope() ? (onScopeDispose(e), !0) : !1;
}
function useDebounceFn(e, t = 200, n = {}) {
  return createFilterWrapper(debounceFilter(t, n), e);
}
function refDebounced(e, t = 200, n = {}) {
  const s = ref(e.value), i = useDebounceFn(() => {
    s.value = e.value;
  }, t, n);
  return watch(e, () => i()), s;
}
function resolveRef(e) {
  return typeof e == "function" ? computed(e) : ref(e);
}
function tryOnMounted(e, t = !0) {
  getCurrentInstance() ? onMounted(e) : t ? e() : nextTick(e);
}
function unrefElement(e) {
  var t;
  const n = resolveUnref(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const defaultWindow = isClient ? window : void 0;
function useEventListener(...e) {
  let t, n, s, i;
  if (isString$2(e[0]) || Array.isArray(e[0]) ? ([n, s, i] = e, t = defaultWindow) : [t, n, s, i] = e, !t)
    return noop$2;
  Array.isArray(n) || (n = [n]), Array.isArray(s) || (s = [s]);
  const a = [], o = () => {
    a.forEach((d) => d()), a.length = 0;
  }, l = (d, p, f, g) => (d.addEventListener(p, f, g), () => d.removeEventListener(p, f, g)), c = watch(() => [unrefElement(t), resolveUnref(i)], ([d, p]) => {
    o(), d && a.push(...n.flatMap((f) => s.map((g) => l(d, f, g, p))));
  }, { immediate: !0, flush: "post" }), u = () => {
    c(), o();
  };
  return tryOnScopeDispose(u), u;
}
let _iOSWorkaround = !1;
function onClickOutside(e, t, n = {}) {
  const { window: s = defaultWindow, ignore: i = [], capture: a = !0, detectIframe: o = !1 } = n;
  if (!s)
    return;
  isIOS && !_iOSWorkaround && (_iOSWorkaround = !0, Array.from(s.document.body.children).forEach((f) => f.addEventListener("click", noop$2)));
  let l = !0;
  const c = (f) => i.some((g) => {
    if (typeof g == "string")
      return Array.from(s.document.querySelectorAll(g)).some((C) => C === f.target || f.composedPath().includes(C));
    {
      const C = unrefElement(g);
      return C && (f.target === C || f.composedPath().includes(C));
    }
  }), d = [
    useEventListener(s, "click", (f) => {
      const g = unrefElement(e);
      if (!(!g || g === f.target || f.composedPath().includes(g))) {
        if (f.detail === 0 && (l = !c(f)), !l) {
          l = !0;
          return;
        }
        t(f);
      }
    }, { passive: !0, capture: a }),
    useEventListener(s, "pointerdown", (f) => {
      const g = unrefElement(e);
      g && (l = !f.composedPath().includes(g) && !c(f));
    }, { passive: !0 }),
    o && useEventListener(s, "blur", (f) => {
      var g;
      const C = unrefElement(e);
      ((g = s.document.activeElement) == null ? void 0 : g.tagName) === "IFRAME" && !(C != null && C.contains(s.document.activeElement)) && t(f);
    })
  ].filter(Boolean);
  return () => d.forEach((f) => f());
}
var __defProp$n = Object.defineProperty, __defProps$9 = Object.defineProperties, __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors, __getOwnPropSymbols$p = Object.getOwnPropertySymbols, __hasOwnProp$p = Object.prototype.hasOwnProperty, __propIsEnum$p = Object.prototype.propertyIsEnumerable, __defNormalProp$n = (e, t, n) => t in e ? __defProp$n(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, __spreadValues$n = (e, t) => {
  for (var n in t || (t = {}))
    __hasOwnProp$p.call(t, n) && __defNormalProp$n(e, n, t[n]);
  if (__getOwnPropSymbols$p)
    for (var n of __getOwnPropSymbols$p(t))
      __propIsEnum$p.call(t, n) && __defNormalProp$n(e, n, t[n]);
  return e;
}, __spreadProps$9 = (e, t) => __defProps$9(e, __getOwnPropDescs$9(t));
const createKeyPredicate = (e) => typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
function onKeyStroke(...e) {
  let t, n, s = {};
  e.length === 3 ? (t = e[0], n = e[1], s = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, n = e[0], s = e[1]) : (t = e[0], n = e[1]) : (t = !0, n = e[0]);
  const { target: i = defaultWindow, eventName: a = "keydown", passive: o = !1 } = s, l = createKeyPredicate(t);
  return useEventListener(i, a, (u) => {
    l(u) && n(u);
  }, o);
}
function onKeyDown(e, t, n = {}) {
  return onKeyStroke(e, t, __spreadProps$9(__spreadValues$n({}, n), { eventName: "keydown" }));
}
function onKeyUp(e, t, n = {}) {
  return onKeyStroke(e, t, __spreadProps$9(__spreadValues$n({}, n), { eventName: "keyup" }));
}
function useSupported(e, t = !1) {
  const n = ref(), s = () => n.value = Boolean(e());
  return s(), tryOnMounted(s, t), n;
}
function useMediaQuery(e, t = {}) {
  const { window: n = defaultWindow } = t, s = useSupported(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let i;
  const a = ref(!1), o = () => {
    i && ("removeEventListener" in i ? i.removeEventListener("change", l) : i.removeListener(l));
  }, l = () => {
    s.value && (o(), i = n.matchMedia(resolveRef(e).value), a.value = i.matches, "addEventListener" in i ? i.addEventListener("change", l) : i.addListener(l));
  };
  return watchEffect(l), tryOnScopeDispose(() => o()), a;
}
const _global = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, globalKey = "__vueuse_ssr_handlers__";
_global[globalKey] = _global[globalKey] || {};
_global[globalKey];
var SwipeDirection;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(SwipeDirection || (SwipeDirection = {}));
var __defProp$2 = Object.defineProperty, __getOwnPropSymbols$1 = Object.getOwnPropertySymbols, __hasOwnProp$1 = Object.prototype.hasOwnProperty, __propIsEnum$1 = Object.prototype.propertyIsEnumerable, __defNormalProp$2 = (e, t, n) => t in e ? __defProp$2(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, __spreadValues$1 = (e, t) => {
  for (var n in t || (t = {}))
    __hasOwnProp$1.call(t, n) && __defNormalProp$2(e, n, t[n]);
  if (__getOwnPropSymbols$1)
    for (var n of __getOwnPropSymbols$1(t))
      __propIsEnum$1.call(t, n) && __defNormalProp$2(e, n, t[n]);
  return e;
};
const _TransitionPresets = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
__spreadValues$1({
  linear: identity$4
}, _TransitionPresets);
const MEDIA_MATCH = {
  DESKTOP: "desktop",
  LAPTOP: "laptop",
  TABLET: "tablet",
  MOBILE: "mobile"
}, TONE = {
  BASE: "base",
  WARNING: "warning",
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  PRIMARY: "primary",
  HIGH_EMPHASIS: "high-emphasis",
  MEDIUM_EMPHASIS: "medium-emphasis",
  LOW_EMPHASIS: "low-emphasis",
  DISABLED: "disabled",
  TRANSPARENT: "transparent"
}, responsiveRange = [
  MEDIA_MATCH.DESKTOP,
  MEDIA_MATCH.LAPTOP,
  MEDIA_MATCH.TABLET,
  MEDIA_MATCH.MOBILE
], breakpoints = {
  [MEDIA_MATCH.TABLET]: 640,
  [MEDIA_MATCH.LAPTOP]: 1024,
  [MEDIA_MATCH.DESKTOP]: 1280
}, useMediaMatch = () => {
  const e = useMediaQuery(
    `screen and (min-width: ${breakpoints.desktop}px)`
  ), t = useMediaQuery(
    `screen and (min-width: ${breakpoints.laptop}px)`
  ), n = useMediaQuery(
    `screen and (min-width: ${breakpoints.tablet}px)`
  );
  return computed(() => e.value ? MEDIA_MATCH.DESKTOP : t.value ? MEDIA_MATCH.LAPTOP : n.value ? MEDIA_MATCH.TABLET : MEDIA_MATCH.MOBILE);
}, useResponsiveProp = (e, t) => computed(() => {
  if (typeof e == "string" || typeof e > "u")
    return e;
  const n = {};
  for (const [s, i] of responsiveRange.entries()) {
    const a = responsiveRange[s - 1];
    i in e ? n[i] = e[i] : a in n ? n[i] = n[a] : n[i] = void 0;
  }
  return n[t.value];
}), mapBorderToneToClassName = (e) => ({
  "outline outline-1 outline-offset-0 outline-white": e === "base",
  "outline outline-1 outline-offset-0 outline-yellow-300": e === "warning",
  "outline outline-1 outline-offset-0 outline-red-300": e === "error",
  "outline outline-1 outline-offset-0 outline-green-300": e === "success",
  "outline outline-1 outline-offset-0 outline-blue-300": e === "info",
  "outline outline-1 outline-offset-0 outline-brand-orange": e === "primary",
  "outline outline-1 outline-offset-0 outline-black-90": e === "high-emphasis",
  "outline outline-1 outline-offset-0 outline-black-60": e === "medium-emphasis",
  "outline outline-1 outline-offset-0 outline-black-40": e === "low-emphasis",
  "outline outline-1 outline-offset-0 outline-black-20": e === "disabled",
  "outline outline-1 outline-offset-0 outline-transparent": e === "transparent"
}), mapBorderToneOnHoverToClassName = (e) => ({
  "hover:outline hover:outline-2 hover:outline-white": e === "base",
  "hover:outline hover:outline-2 hover:outline-yellow-300": e === "warning",
  "hover:outline hover:outline-2 hover:outline-red-300": e === "error",
  "hover:outline hover:outline-2 hover:outline-green-300": e === "success",
  "hover:outline hover:outline-2 hover:outline-blue-300": e === "info",
  "hover:outline hover:outline-2 hover:outline-brand-orange": e === "primary",
  "hover:outline hover:outline-2 hover:outline-black-90": e === "high-emphasis",
  "hover:outline hover:outline-2 hover:outline-black-60": e === "medium-emphasis",
  "hover:outline hover:outline-2 hover:outline-black-40": e === "low-emphasis",
  "hover:outline hover:outline-2 hover:outline-black-20": e === "disabled",
  "hover:outline hover:outline-2 hover:outline-transparent": e === "transparent"
}), mapBorderToneOnSelectToClassName = (e) => ({
  "outline outline-2 outline-offset-0 outline-white": e === "base",
  "outline outline-2 outline-offset-0 outline-yellow-300": e === "warning",
  "outline outline-2 outline-offset-0 outline-red-300": e === "error",
  "outline outline-2 outline-offset-0 outline-green-300": e === "success",
  "outline outline-2 outline-offset-0 outline-blue-300": e === "info",
  "outline outline-2 outline-offset-0 outline-brand-orange": e === "primary",
  "outline outline-2 outline-offset-0 outline-black-90": e === "high-emphasis",
  "outline outline-2 outline-offset-0 outline-black-60": e === "medium-emphasis",
  "outline outline-2 outline-offset-0 outline-black-40": e === "low-emphasis",
  "outline outline-2 outline-offset-0 outline-black-20": e === "disabled",
  "outline outline-2 outline-offset-0 outline-transparent": e === "transparent"
}), _sfc_main$2K = /* @__PURE__ */ defineComponent({
  __name: "Box",
  props: {
    component: { default: "div" },
    tone: { default: void 0 },
    borderTone: { default: void 0 },
    borderToneOnHover: { default: void 0 },
    borderToneOnSelect: { default: void 0 },
    background: { default: void 0 },
    borderRadius: { default: void 0 },
    boxShadow: { default: void 0 },
    padding: { default: void 0 },
    paddingY: { default: void 0 },
    paddingX: { default: void 0 },
    paddingTop: { default: void 0 },
    paddingRight: { default: void 0 },
    paddingBottom: { default: void 0 },
    paddingLeft: { default: void 0 },
    height: { default: void 0 },
    width: null,
    verticalAlign: { default: void 0 },
    contentAlign: { default: void 0 },
    textAlign: { default: void 0 },
    grow: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = ref(null), s = useMediaMatch(), i = useResponsiveProp(t.padding, s), a = useResponsiveProp(t.paddingY, s), o = useResponsiveProp(t.paddingX, s), l = useResponsiveProp(
      t.paddingTop,
      s
    ), c = useResponsiveProp(
      t.paddingRight,
      s
    ), u = useResponsiveProp(
      t.paddingBottom,
      s
    ), d = useResponsiveProp(
      t.paddingLeft,
      s
    ), p = useResponsiveProp(
      t.borderRadius,
      s
    ), f = useResponsiveProp(
      t.boxShadow,
      s
    ), g = useResponsiveProp(
      t.verticalAlign,
      s
    ), C = useResponsiveProp(t.height, s), k = useResponsiveProp(t.width, s), M = useResponsiveProp(
      t.contentAlign,
      s
    ), _ = useResponsiveProp(
      t.textAlign,
      s
    ), S = () => ({
      ...t.tone && mapToneToClassName(t.tone),
      ...t.borderToneOnHover && mapBorderToneOnHoverToClassName(t.borderToneOnHover),
      ...t.borderToneOnSelect && mapBorderToneOnSelectToClassName(t.borderToneOnSelect),
      ...t.borderTone && mapBorderToneToClassName(t.borderTone),
      ...t.background && mapBackgroundToClassName(t.background),
      ...p.value && mapBorderRadiusToClassName(p.value),
      ...f.value && mapBoxShadowToClassName(f.value),
      ...i.value && mapPaddingToPaddingClassName(i.value),
      ...a.value && mapPaddingYToPaddingYClassName(a.value),
      ...o.value && mapPaddingXToPaddingXClassName(o.value),
      ...l.value && mapPaddingTopToPaddingTopClassName(l.value),
      ...c.value && mapPaddingRightToPaddingRightClassName(c.value),
      ...u.value && mapPaddingBottomToPaddingBottomClassName(u.value),
      ...d.value && mapPaddingLeftToPaddingLeftClassName(d.value),
      ...C.value && mapHeightToClassName(C.value),
      ...k.value && mapWidthToClassName(k.value),
      ...g.value && mapVerticalAlignToAlignItemsClassName(g.value),
      ...M.value && mapContentAlignToContentAlignClassName(M.value),
      ..._.value && mapTextAlignToContentAlignClassName(_.value),
      ...t.grow && mapGrowToClassName(t.grow)
    });
    return (E, P) => (openBlock(), createBlock(resolveDynamicComponent(e.component), {
      ref_key: "boxRef",
      ref: n,
      class: normalizeClass(S())
    }, {
      default: withCtx(() => [
        renderSlot(E.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), mapPreserveNewlinesToClasses = (e) => ({
  "whitespace-pre-line": e
});
function r(e) {
  var t, n, s = "";
  if (typeof e == "string" || typeof e == "number")
    s += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = r(e[t])) && (s && (s += " "), s += n);
    else
      for (t in e)
        e[t] && (s && (s += " "), s += t);
  return s;
}
function clsx() {
  for (var e, t, n = 0, s = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = r(e)) && (s && (s += " "), s += t);
  return s;
}
function twJoin() {
  for (var e = 0, t, n, s = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = toValue(t)) && (s && (s += " "), s += n);
  return s;
}
function toValue(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", s = 0; s < e.length; s++)
    e[s] && (t = toValue(e[s])) && (n && (n += " "), n += t);
  return n;
}
var CLASS_PART_SEPARATOR = "-";
function createClassUtils(e) {
  var t = createClassMap(e), n = e.conflictingClassGroups, s = e.conflictingClassGroupModifiers, i = s === void 0 ? {} : s;
  function a(l) {
    var c = l.split(CLASS_PART_SEPARATOR);
    return c[0] === "" && c.length !== 1 && c.shift(), getGroupRecursive(c, t) || getGroupIdForArbitraryProperty(l);
  }
  function o(l, c) {
    var u = n[l] || [];
    return c && i[l] ? [].concat(u, i[l]) : u;
  }
  return {
    getClassGroupId: a,
    getConflictingClassGroupIds: o
  };
}
function getGroupRecursive(e, t) {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], s = t.nextPart.get(n), i = s ? getGroupRecursive(e.slice(1), s) : void 0;
  if (i)
    return i;
  if (t.validators.length !== 0) {
    var a = e.join(CLASS_PART_SEPARATOR);
    return (o = t.validators.find(function(l) {
      var c = l.validator;
      return c(a);
    })) == null ? void 0 : o.classGroupId;
  }
}
var arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(e) {
  if (arbitraryPropertyRegex.test(e)) {
    var t = arbitraryPropertyRegex.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function createClassMap(e) {
  var t = e.theme, n = e.prefix, s = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = getPrefixedClassGroupEntries(Object.entries(e.classGroups), n);
  return i.forEach(function(a) {
    var o = a[0], l = a[1];
    processClassesRecursively(l, s, o, t);
  }), s;
}
function processClassesRecursively(e, t, n, s) {
  e.forEach(function(i) {
    if (typeof i == "string") {
      var a = i === "" ? t : getPart(t, i);
      a.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (isThemeGetter(i)) {
        processClassesRecursively(i(s), t, n, s);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(function(o) {
      var l = o[0], c = o[1];
      processClassesRecursively(c, getPart(t, l), n, s);
    });
  });
}
function getPart(e, t) {
  var n = e;
  return t.split(CLASS_PART_SEPARATOR).forEach(function(s) {
    n.nextPart.has(s) || n.nextPart.set(s, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(s);
  }), n;
}
function isThemeGetter(e) {
  return e.isThemeGetter;
}
function getPrefixedClassGroupEntries(e, t) {
  return t ? e.map(function(n) {
    var s = n[0], i = n[1], a = i.map(function(o) {
      return typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(function(l) {
        var c = l[0], u = l[1];
        return [t + c, u];
      })) : o;
    });
    return [s, a];
  }) : e;
}
function createLruCache(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
  function i(a, o) {
    n.set(a, o), t++, t > e && (t = 0, s = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(o) {
      var l = n.get(o);
      if (l !== void 0)
        return l;
      if ((l = s.get(o)) !== void 0)
        return i(o, l), l;
    },
    set: function(o, l) {
      n.has(o) ? n.set(o, l) : i(o, l);
    }
  };
}
var IMPORTANT_MODIFIER = "!";
function createSplitModifiers(e) {
  var t = e.separator || ":", n = t.length === 1, s = t[0], i = t.length;
  return function(o) {
    for (var l = [], c = 0, u = 0, d, p = 0; p < o.length; p++) {
      var f = o[p];
      if (c === 0) {
        if (f === s && (n || o.slice(p, p + i) === t)) {
          l.push(o.slice(u, p)), u = p + i;
          continue;
        }
        if (f === "/") {
          d = p;
          continue;
        }
      }
      f === "[" ? c++ : f === "]" && c--;
    }
    var g = l.length === 0 ? o : o.substring(u), C = g.startsWith(IMPORTANT_MODIFIER), k = C ? g.substring(1) : g, M = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: C,
      baseClassName: k,
      maybePostfixModifierPosition: M
    };
  };
}
function sortModifiers(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(s) {
    var i = s[0] === "[";
    i ? (t.push.apply(t, n.sort().concat([s])), n = []) : n.push(s);
  }), t.push.apply(t, n.sort()), t;
}
function createConfigUtils(e) {
  return {
    cache: createLruCache(e.cacheSize),
    splitModifiers: createSplitModifiers(e),
    ...createClassUtils(e)
  };
}
var SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(e, t) {
  var n = t.splitModifiers, s = t.getClassGroupId, i = t.getConflictingClassGroupIds, a = /* @__PURE__ */ new Set();
  return e.trim().split(SPLIT_CLASSES_REGEX).map(function(o) {
    var l = n(o), c = l.modifiers, u = l.hasImportantModifier, d = l.baseClassName, p = l.maybePostfixModifierPosition, f = s(p ? d.substring(0, p) : d), g = Boolean(p);
    if (!f) {
      if (!p)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      if (f = s(d), !f)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      g = !1;
    }
    var C = sortModifiers(c).join(":"), k = u ? C + IMPORTANT_MODIFIER : C;
    return {
      isTailwindClass: !0,
      modifierId: k,
      classGroupId: f,
      originalClassName: o,
      hasPostfixModifier: g
    };
  }).reverse().filter(function(o) {
    if (!o.isTailwindClass)
      return !0;
    var l = o.modifierId, c = o.classGroupId, u = o.hasPostfixModifier, d = l + c;
    return a.has(d) ? !1 : (a.add(d), i(c, u).forEach(function(p) {
      return a.add(l + p);
    }), !0);
  }).reverse().map(function(o) {
    return o.originalClassName;
  }).join(" ");
}
function createTailwindMerge() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var s, i, a, o = l;
  function l(u) {
    var d = t[0], p = t.slice(1), f = p.reduce(function(g, C) {
      return C(g);
    }, d());
    return s = createConfigUtils(f), i = s.cache.get, a = s.cache.set, o = c, c(u);
  }
  function c(u) {
    var d = i(u);
    if (d)
      return d;
    var p = mergeClassList(u, s);
    return a(u, p), p;
  }
  return function() {
    return o(twJoin.apply(null, arguments));
  };
}
function fromTheme(e) {
  var t = function(s) {
    return s[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i, fractionRegex = /^\d+\/\d+$/, stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]), tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, shadowRegex = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function isLength$4(e) {
  return isNumber$3(e) || stringLengths.has(e) || fractionRegex.test(e) || isArbitraryLength(e);
}
function isArbitraryLength(e) {
  return getIsArbitraryValue(e, "length", isLengthOnly);
}
function isArbitrarySize(e) {
  return getIsArbitraryValue(e, "size", isNever);
}
function isArbitraryPosition(e) {
  return getIsArbitraryValue(e, "position", isNever);
}
function isArbitraryUrl(e) {
  return getIsArbitraryValue(e, "url", isUrl);
}
function isArbitraryNumber(e) {
  return getIsArbitraryValue(e, "number", isNumber$3);
}
function isNumber$3(e) {
  return !Number.isNaN(Number(e));
}
function isPercent(e) {
  return e.endsWith("%") && isNumber$3(e.slice(0, -1));
}
function isInteger(e) {
  return isIntegerOnly(e) || getIsArbitraryValue(e, "number", isIntegerOnly);
}
function isArbitraryValue(e) {
  return arbitraryValueRegex.test(e);
}
function isAny() {
  return !0;
}
function isTshirtSize(e) {
  return tshirtUnitRegex.test(e);
}
function isArbitraryShadow(e) {
  return getIsArbitraryValue(e, "", isShadow);
}
function getIsArbitraryValue(e, t, n) {
  var s = arbitraryValueRegex.exec(e);
  return s ? s[1] ? s[1] === t : n(s[2]) : !1;
}
function isLengthOnly(e) {
  return lengthUnitRegex.test(e);
}
function isNever() {
  return !1;
}
function isUrl(e) {
  return e.startsWith("url(");
}
function isIntegerOnly(e) {
  return Number.isInteger(Number(e));
}
function isShadow(e) {
  return shadowRegex.test(e);
}
function getDefaultConfig() {
  var e = fromTheme("colors"), t = fromTheme("spacing"), n = fromTheme("blur"), s = fromTheme("brightness"), i = fromTheme("borderColor"), a = fromTheme("borderRadius"), o = fromTheme("borderSpacing"), l = fromTheme("borderWidth"), c = fromTheme("contrast"), u = fromTheme("grayscale"), d = fromTheme("hueRotate"), p = fromTheme("invert"), f = fromTheme("gap"), g = fromTheme("gradientColorStops"), C = fromTheme("gradientColorStopPositions"), k = fromTheme("inset"), M = fromTheme("margin"), _ = fromTheme("opacity"), S = fromTheme("padding"), E = fromTheme("saturate"), P = fromTheme("scale"), $ = fromTheme("sepia"), A = fromTheme("skew"), I = fromTheme("space"), D = fromTheme("translate"), R = function() {
    return ["auto", "contain", "none"];
  }, Y = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, q = function() {
    return ["auto", isArbitraryValue, t];
  }, j = function() {
    return [isArbitraryValue, t];
  }, X = function() {
    return ["", isLength$4];
  }, ee = function() {
    return ["auto", isNumber$3, isArbitraryValue];
  }, G = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, H = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, F = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, B = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, z = function() {
    return ["", "0", isArbitraryValue];
  }, K = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, Z = function() {
    return [isNumber$3, isArbitraryNumber];
  }, re = function() {
    return [isNumber$3, isArbitraryValue];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [isAny],
      spacing: [isLength$4],
      blur: ["none", "", isTshirtSize, isArbitraryValue],
      brightness: Z(),
      borderColor: [e],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryValue],
      borderSpacing: j(),
      borderWidth: X(),
      contrast: Z(),
      grayscale: z(),
      hueRotate: re(),
      invert: z(),
      gap: j(),
      gradientColorStops: [e],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: q(),
      margin: q(),
      opacity: Z(),
      padding: j(),
      saturate: Z(),
      scale: Z(),
      sepia: z(),
      skew: re(),
      space: j(),
      translate: j()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": K()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": K()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(G(), [isArbitraryValue])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: Y()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": Y()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": Y()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: R()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": R()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": R()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [k]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [k]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [k]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [k]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [k]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [k]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [k]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [k]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [k]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: q()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: z()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: z()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": ee()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": ee()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": ee()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": ee()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(B())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(B(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(B(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [S]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [S]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [S]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [S]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [S]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [S]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [S]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [S]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [S]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [M]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [M]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [M]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [M]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [M]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [M]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [M]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [M]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [M]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [I]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [I]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", isArbitraryValue, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", isArbitraryValue, isLength$4]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize, isArbitraryValue]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", isArbitraryValue, isLength$4]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [isArbitraryValue, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber$3, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isArbitraryValue, isLength$4]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [_]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [_]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(H(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength$4]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isArbitraryValue, isLength$4]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: j()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [_]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(G(), [isArbitraryPosition])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryUrl]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [C]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [C]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [C]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [g]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [l]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [l]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [l]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [l]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [l]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [l]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [l]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [l]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [l]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [_]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(H(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [l]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [l]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [_]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: H()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(H())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isArbitraryValue, isLength$4]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength$4]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: X()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [_]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength$4]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": F()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": F()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [s]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [p]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [E]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [$]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [s]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [p]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [E]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [$]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: re()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: re()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [P]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [P]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [P]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [D]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [D]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": j()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": j()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": j()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": j()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": j()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": j()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": j()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": j()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": j()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": j()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": j()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": j()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": j()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": j()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": j()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": j()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": j()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": j()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength$4, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
const classMerge = (...e) => twMerge(clsx(e)), _sfc_main$2J = /* @__PURE__ */ defineComponent({
  __name: "Text",
  props: {
    component: { default: "div" },
    variant: { default: "body" },
    size: { default: "lg" },
    tone: { default: "high-emphasis" },
    align: { default: "left" },
    maxLines: { default: void 0 },
    interactiveTextWeight: { default: "regular" },
    preserveNewlines: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = useMediaMatch(), s = useResponsiveProp(t.align, n), i = useResponsiveProp(
      t.maxLines,
      n
    ), a = (l, c) => l === "body" ? mapSizeToBodyTextClasses(c) : mapSizeToInteractiveTextClasses(c), o = () => classMerge({
      ...t.size && t.variant && a(t.variant, t.size),
      ...t.tone && mapToneToTextClasses(t.tone),
      ...s.value && mapAlignToTextClasses(s.value),
      ...i.value && mapMaxLinesToLineClampClasses(i.value),
      ...t.interactiveTextWeight && t.variant === "interactive" && mapWeightToInteractiveTextClasses(t.interactiveTextWeight),
      ...t.preserveNewlines && mapPreserveNewlinesToClasses(t.preserveNewlines)
    });
    return (l, c) => (openBlock(), createBlock(resolveDynamicComponent(e.component), {
      "data-testid": "text",
      class: normalizeClass(o())
    }, {
      default: withCtx(() => [
        renderSlot(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), _sfc_main$2I = /* @__PURE__ */ defineComponent({
  __name: "Pill",
  props: {
    tone: { default: "high-emphasis" }
  },
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$2K, {
      tone: e.tone,
      "border-radius": "sm",
      padding: "2xs",
      component: "span",
      class: "w-fit cursor-default select-none"
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$2J, {
          size: "xs",
          class: "uppercase",
          tone: "base",
          variant: "interactive",
          "interactive-text-weight": "strong"
        }, {
          default: withCtx(() => [
            renderSlot(t.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["tone"]));
  }
}), _sfc_main$2H = defineComponent({
  props: {
    space: {
      type: [Object, String]
    },
    align: {
      type: [Object, String]
    }
  },
  setup(e, { slots: t }) {
    const n = useMediaMatch(), s = useResponsiveProp(e.space, n), i = useResponsiveProp(e.align, n), a = () => classMerge("flex flex-col", {
      ...i.value && mapAlignToItemsAlignClassName(i.value)
    }), o = () => classMerge("last:mb-0", {
      ...s.value && mapSpaceToMarginBottomClassName(s.value)
    });
    return () => h(_sfc_main$2K, { class: a() }, () => {
      var l;
      return (((l = t.default) == null ? void 0 : l.call(t)) || []).map((c) => {
        const u = o();
        return Array.isArray(c.children) ? c.children.map(
          (d) => h(d, { class: u })
        ) : h(c, { class: u });
      });
    });
  }
}), _sfc_main$2G = /* @__PURE__ */ defineComponent({
  __name: "Accordion",
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$2H, { space: "sm" }, {
      default: withCtx(() => [
        renderSlot(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), shouldCollapseBelow = (e, t) => {
  const n = responsiveRange.findIndex(
    (i) => i === t
  );
  return responsiveRange.findIndex(
    (i) => i === e.value
  ) > n;
}, shouldCollapseAbove = (e, t) => {
  const n = responsiveRange.findIndex(
    (i) => i === t
  );
  return responsiveRange.findIndex(
    (i) => i === e.value
  ) < n;
}, _sfc_main$2F = /* @__PURE__ */ defineComponent({
  __name: "Columns",
  props: {
    space: { default: "none" },
    collapseBelow: { default: void 0 },
    verticalAlign: { default: void 0 },
    direction: { default: "row" }
  },
  setup(e) {
    const t = e, n = useMediaMatch(), s = useResponsiveProp(t.space, n), i = useResponsiveProp(
      t.verticalAlign,
      n
    ), a = useResponsiveProp(
      t.direction,
      n
    ), o = computed(
      () => t.collapseBelow ? shouldCollapseBelow(n, t.collapseBelow) : !1
    ), l = () => classMerge({
      ...i.value && mapVerticalAlignToAlignItemsClassName(i.value),
      ...o.value ? {
        flex: !1,
        "flex-wrap": "wrap",
        ...s.value && mapSpaceToSpaceYClassName(s.value)
      } : {
        flex: !0,
        ...a.value && mapColumnDirectionToClasses(a.value),
        ...s.value && {
          ...a.value === "row" ? mapSpaceToSpaceXClassName(s.value) : mapSpaceToSpaceYClassName(s.value)
        }
      }
    });
    return provide("mediaMatch", n), provide("collapseBelow", t.collapseBelow), provide("direction", t.direction), (c, u) => (openBlock(), createBlock(_sfc_main$2K, {
      class: normalizeClass(l())
    }, {
      default: withCtx(() => [
        renderSlot(c.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), _sfc_main$2E = /* @__PURE__ */ defineComponent({
  __name: "Column",
  props: {
    width: { default: "auto" }
  },
  setup(e) {
    const t = e, n = inject("mediaMatch", null), s = computed(
      () => (n == null ? void 0 : n.value) || MEDIA_MATCH.DESKTOP
    ), i = inject("collapseBelow", null), a = useResponsiveProp(
      t.width,
      s
    ), o = inject("direction", "row"), l = computed(
      () => i && (n != null && n.value) ? shouldCollapseBelow(n, i) : !1
    ), c = () => classMerge({
      ...a.value && mapColumnWidthToColumnClassName(
        a.value,
        o,
        l.value
      )
    });
    return (u, d) => (openBlock(), createBlock(_sfc_main$2K, {
      class: normalizeClass(c())
    }, {
      default: withCtx(() => [
        renderSlot(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), _sfc_main$2D = /* @__PURE__ */ defineComponent({
  __name: "IconWrapper",
  props: {
    tone: { default: "high-emphasis" },
    size: { default: "md" }
  },
  setup(e) {
    const t = e, n = () => classMerge({
      ...t.tone && mapToneToTextClasses(t.tone),
      ...t.size && mapSizeToIcon(t.size)
    });
    return (s, i) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(n())
    }, [
      renderSlot(s.$slots, "default")
    ], 2));
  }
}), _hoisted_1$1R = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6888)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M6 9L12 15L18 9",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$2C = /* @__PURE__ */ defineComponent({
  __name: "ChevronDownIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1R
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), DATA_TEST_ID$b = {
  ACCORDION__OPTION__LABEL: "accordion_option_label",
  ACCORDION__OPTION__CONTENT: "accordion_option_content",
  ACCORDION__OPTION__DIVIDER: "accordion_option_divider"
}, _sfc_main$2B = /* @__PURE__ */ defineComponent({
  __name: "Divider",
  props: {
    tone: { default: "default" },
    weight: { default: "regular" }
  },
  setup(e) {
    const t = e, n = () => classMerge({
      ...t.tone && mapBorderToneToBorderClassName(t.tone),
      ...t.weight && mapWeightToBorderWidthClassName(t.weight)
    });
    return (s, i) => (openBlock(), createElementBlock("hr", {
      class: normalizeClass(n())
    }, null, 2));
  }
}), _sfc_main$2A = /* @__PURE__ */ defineComponent({
  __name: "AccordionItem",
  props: {
    id: null,
    isExpanded: { type: Boolean, default: !1 },
    withDivider: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = ref(t.isExpanded);
    watch(
      () => t.isExpanded,
      (a) => {
        n.value = a;
      }
    );
    const s = () => {
      n.value = !n.value;
    }, i = () => classMerge("transition-transform", {
      "rotate-180": n.value
    });
    return (a, o) => (openBlock(), createBlock(_sfc_main$2H, { space: "xs" }, {
      default: withCtx(() => [
        createVNode(_sfc_main$2K, {
          component: "button",
          onClick: s,
          class: "select-none",
          "data-testid": `${unref(DATA_TEST_ID$b).ACCORDION__OPTION__LABEL}-${e.id}`
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$2H, {
              space: e.withDivider ? "md" : "none"
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$2F, {
                  space: "sm",
                  "vertical-align": "center"
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2E, null, {
                      default: withCtx(() => [
                        renderSlot(a.$slots, "label", {}, void 0, !0)
                      ]),
                      _: 3
                    }),
                    createVNode(_sfc_main$2E, { width: "content" }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$2K, {
                          class: normalizeClass(i())
                        }, {
                          default: withCtx(() => [
                            createVNode(_sfc_main$2C)
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 3
                }),
                e.withDivider && !n.value ? (openBlock(), createBlock(_sfc_main$2B, {
                  key: 0,
                  tone: "secondary",
                  "data-testid": `${unref(DATA_TEST_ID$b).ACCORDION__OPTION__DIVIDER}-${e.id}`
                }, null, 8, ["data-testid"])) : createCommentVNode("", !0)
              ]),
              _: 3
            }, 8, ["space"])
          ]),
          _: 3
        }, 8, ["data-testid"]),
        createVNode(Transition, null, {
          default: withCtx(() => [
            n.value ? (openBlock(), createBlock(_sfc_main$2H, {
              key: 0,
              space: "md"
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$2K, {
                  "data-testid": `${unref(DATA_TEST_ID$b).ACCORDION__OPTION__CONTENT}-${e.id}`
                }, {
                  default: withCtx(() => [
                    renderSlot(a.$slots, "content", {}, void 0, !0)
                  ]),
                  _: 3
                }, 8, ["data-testid"]),
                e.withDivider ? (openBlock(), createBlock(_sfc_main$2B, {
                  key: 0,
                  tone: "secondary",
                  "data-testid": `${unref(DATA_TEST_ID$b).ACCORDION__OPTION__DIVIDER}-${e.id}`
                }, null, 8, ["data-testid"])) : createCommentVNode("", !0)
              ]),
              _: 3
            })) : createCommentVNode("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), AccordionItem_vue_vue_type_style_index_0_scoped_b1737440_lang = "", _export_sfc$1 = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, i] of t)
    n[s] = i;
  return n;
}, AccordionItem = /* @__PURE__ */ _export_sfc$1(_sfc_main$2A, [["__scopeId", "data-v-b1737440"]]), mapHeightToHeightClassName = (e) => ({
  "h-full": e === "full"
}), mapMinHeightToHeightClassName = (e) => ({
  "min-h-[11rem]": e === "xs",
  "min-h-[12rem]": e === "sm",
  "min-h-[15rem]": e === "md",
  "min-h-[18rem]": e === "lg",
  "min-h-[22.5rem]": e === "xl",
  "min-h-[26.75rem]": e === "2xl"
}), mapMaxHeightToHeightClassName = (e) => ({
  "max-h-[11rem]": e === "xs",
  "max-h-[12rem]": e === "sm",
  "max-h-[15rem]": e === "md",
  "max-h-[18rem]": e === "lg",
  "max-h-[22.5rem]": e === "xl",
  "max-h-[26.75rem]": e === "2xl"
}), DATA_TEST_ID$a = {
  MODULE_CONTAINER: "module-container"
}, _sfc_main$2z = /* @__PURE__ */ defineComponent({
  __name: "ModuleContainer",
  props: {
    verticalAlign: { default: void 0 },
    height: { default: void 0 },
    minHeight: { default: void 0 },
    maxHeight: { default: void 0 },
    padding: { default: void 0 },
    tone: { default: void 0 }
  },
  setup(e) {
    const t = e, n = () => classMerge({
      ...t.tone && {
        relative: !0,
        "overflow-hidden": !0
      },
      ...t.height && mapHeightToHeightClassName(t.height),
      ...t.minHeight && mapMinHeightToHeightClassName(t.minHeight),
      ...t.maxHeight && mapMaxHeightToHeightClassName(t.maxHeight)
    });
    return (s, i) => (openBlock(), createBlock(_sfc_main$2K, {
      "border-radius": "lg",
      tone: "base",
      "data-testid": unref(DATA_TEST_ID$a).MODULE_CONTAINER,
      padding: t.padding ?? { desktop: "lg", tablet: "sm" },
      "vertical-align": e.verticalAlign,
      class: normalizeClass(n())
    }, {
      default: withCtx(() => [
        e.tone ? (openBlock(), createBlock(_sfc_main$2K, {
          key: 0,
          class: "w-1 absolute inset-y-0 left-0",
          tone: e.tone
        }, null, 8, ["tone"])) : createCommentVNode("", !0),
        renderSlot(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["data-testid", "padding", "vertical-align", "class"]));
  }
}), _hoisted_1$1Q = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6951)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M5 12L10 17L20 7",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$2y = /* @__PURE__ */ defineComponent({
  __name: "TickIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1Q
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _sfc_main$2x = defineComponent({
  props: {
    space: {
      type: [Object, String]
    },
    align: {
      type: [Object, String]
    },
    verticalAlign: {
      type: String
    },
    wrap: {
      type: String
    }
  },
  setup(e, { slots: t }) {
    const n = useMediaMatch(), s = useResponsiveProp(e.space, n), i = useResponsiveProp(e.align, n), a = () => classMerge("flex flex-row", {
      ...i.value && mapAlignToJustifyContentClassName(i.value),
      ...e.verticalAlign && mapVerticalAlignToAlignItemsClassName(e.verticalAlign),
      ...e.wrap && mapWrapToFlexWrapClassName(e.wrap),
      ...s.value && mapSpaceToGapClassName(s.value)
    });
    return () => h(_sfc_main$2K, { class: a() }, () => {
      var o;
      return (((o = t.default) == null ? void 0 : o.call(t)) || []).map((l) => h(l, {}));
    });
  }
}), _sfc_main$2w = /* @__PURE__ */ defineComponent({
  __name: "Checkbox",
  props: {
    id: null,
    modelValue: { type: Boolean },
    value: { type: Boolean },
    border: { default: "solid" },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, s = ref(!1), i = computed(() => n.modelValue || n.value), a = (d) => {
      d.code === "Space" && t("update:modelValue", !i.value);
    }, o = () => i.value ? n.disabled ? "low-emphasis" : "high-emphasis" : "base", l = () => classMerge({
      "transition-all": !n.disabled,
      "ring-2": s.value && !n.disabled,
      "border-grey-200 hover:ring-1 ring-grey-300": !s.value && !n.disabled,
      "ring-grey-900 hover:ring-2 border-transparent": (s.value || i.value) && !n.disabled,
      ...n.border && mapBorderToBorderClassName(n.border),
      ...mapDisabledToCursorClasses(n.disabled)
    }), c = () => classMerge("transition-opacity", {
      "opacity-0 group-hover:opacity-50": !i.value && !n.disabled,
      "opacity-0": !i.value && n.disabled,
      "opacity-50": s.value && !i.value && !n.disabled
    }), u = () => classMerge("select-none", {
      "cursor-not-allowed": n.disabled,
      "cursor-pointer": !n.disabled
    });
    return (d, p) => (openBlock(), createBlock(_sfc_main$2x, {
      class: "group",
      space: "xs",
      "vertical-align": "center"
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$2K, {
          class: normalizeClass([l(), "styledCheckbox cursor-pointer rounded focus:outline-none"]),
          tone: o(),
          tabindex: e.disabled ? "-1" : "1",
          "vertical-align": "center",
          "content-align": "center",
          onClick: p[0] || (p[0] = (f) => !e.disabled && d.$emit("update:modelValue", !unref(i))),
          onFocus: p[1] || (p[1] = (f) => s.value = !0),
          onBlur: p[2] || (p[2] = (f) => s.value = !1),
          onKeydown: a
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$2K, {
              class: normalizeClass(c())
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$2y, {
                  tone: unref(i) ? "base" : "low-emphasis",
                  size: "sm"
                }, null, 8, ["tone"])
              ]),
              _: 1
            }, 8, ["class"]),
            createVNode(_sfc_main$2K, {
              id: e.id,
              checked: unref(i),
              disabled: e.disabled,
              component: "input",
              class: "sr-only",
              type: "checkbox",
              tabindex: "-1"
            }, null, 8, ["id", "checked", "disabled"])
          ]),
          _: 1
        }, 8, ["class", "tone", "tabindex"]),
        e.label ? (openBlock(), createBlock(_sfc_main$2J, {
          key: 0,
          for: e.id,
          tone: e.disabled ? "low-emphasis" : "medium-emphasis",
          class: normalizeClass(u()),
          size: "md",
          component: "label"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(e.label), 1)
          ]),
          _: 1
        }, 8, ["for", "tone", "class"])) : createCommentVNode("", !0)
      ]),
      _: 1
    }));
  }
}), Checkbox_vue_vue_type_style_index_0_lang = "", _sfc_main$2v = /* @__PURE__ */ defineComponent({
  __name: "ContentBlock",
  props: {
    width: { default: "lg" },
    align: { default: void 0 },
    padding: { default: void 0 }
  },
  setup(e) {
    const t = e, n = useMediaMatch(), s = useResponsiveProp(
      t.width,
      n
    ), i = useResponsiveProp(t.align, n), a = useResponsiveProp(t.padding, n), o = () => classMerge({
      ...s.value && mapContentBlockWidthToWidthClassName(s.value),
      ...i.value && mapAlignToContentBlockMarginClassName(i.value),
      ...a.value && mapPaddingToPaddingClassName(a.value)
    });
    return (l, c) => (openBlock(), createBlock(_sfc_main$2K, {
      class: normalizeClass(o())
    }, {
      default: withCtx(() => [
        renderSlot(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), _hoisted_1$1P = ["stroke-dasharray", "stroke-dashoffset", "stroke"], _hoisted_2$g = ["stroke-width", "y1", "transform"], _sfc_main$2u = /* @__PURE__ */ defineComponent({
  __name: "Donut",
  props: {
    gapWidth: { default: 2 },
    items: null
  },
  setup(e) {
    const t = e, n = "#F0F0F0", s = 60, i = s * 2, a = 25, o = (i - a) / 2, l = 2 * Math.PI * o, c = 1e-7, u = s - a, d = `0 0 ${i} ${i}`, p = computed(() => {
      var C;
      let g = 0;
      return (C = t.items) == null ? void 0 : C.map((k) => {
        const M = k.amount / 100 * l + c, _ = g;
        return g += M, {
          dashArray: `${M} ${l - M}`,
          dashOffset: _ ? l - _ : 0,
          dashArrayLength: M,
          color: k.hexcolor
        };
      });
    }), f = computed(() => {
      var C;
      let g = 0;
      return (C = t.items) == null ? void 0 : C.map((k) => {
        const M = k.amount / 100 * 360;
        return g += M, {
          rotate: g
        };
      });
    });
    return (g, C) => (openBlock(), createElementBlock("svg", {
      width: "100%",
      height: "100%",
      viewBox: d,
      transform: "rotate(-90)"
    }, [
      createElementVNode("circle", {
        r: o,
        cx: s,
        cy: s,
        stroke: n,
        "stroke-width": a,
        fill: "none"
      }),
      (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(p), (k, M) => (openBlock(), createElementBlock("circle", {
        class: "transition-stroke-dash duration-medium ease-in-out",
        key: M,
        r: o,
        cx: s,
        cy: s,
        "stroke-dasharray": k.dashArray,
        "stroke-dashoffset": k.dashOffset,
        "stroke-width": a,
        fill: "none",
        stroke: k.color
      }, null, 8, _hoisted_1$1P))), 128)),
      (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(f), (k, M) => (openBlock(), createElementBlock("line", {
        class: "duration-500 transition-all ease-in-out",
        key: M,
        stroke: n,
        "stroke-width": e.gapWidth,
        x1: s,
        y1: s + u,
        x2: s,
        y2: i,
        transform: `rotate(${k.rotate - 90}, ${s}, ${s})`
      }, null, 8, _hoisted_2$g))), 128))
    ]));
  }
}), _sfc_main$2t = /* @__PURE__ */ defineComponent({
  __name: "Overlay",
  props: {
    isVisible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = () => classMerge({
      animated: t.isVisible
    });
    return (s, i) => e.isVisible ? (openBlock(), createBlock(_sfc_main$2K, {
      key: 0,
      class: normalizeClass(["fixed top-0 left-0 bottom-0 right-0 bg-grey-600 transition-opacity z-40", n()])
    }, null, 8, ["class"])) : createCommentVNode("", !0);
  }
}), Overlay_vue_vue_type_style_index_0_lang$1 = "", _sfc_main$2s = defineComponent({
  props: {
    columns: {
      type: [Object, String]
    },
    space: {
      type: [Object, String]
    },
    columnSpace: {
      type: [Object, String]
    }
  },
  setup(e, { slots: t }) {
    const n = useMediaMatch(), s = useResponsiveProp(
      e.columns || "1",
      n
    ), i = useResponsiveProp(e.space, n), a = useResponsiveProp(
      e.columnSpace,
      n
    ), o = () => classMerge("grid", {
      ...s.value && mapColumnsToGridColumnsClassName(s.value),
      ...i.value && mapSpaceToGapClassName(i.value),
      ...a.value && mapSpaceToColumnSpaceClassName(a.value)
    });
    return () => h(_sfc_main$2K, { class: o() }, () => {
      var l;
      return (((l = t.default) == null ? void 0 : l.call(t)) || []).map((c) => c);
    });
  }
}), _sfc_main$2r = /* @__PURE__ */ defineComponent({
  __name: "Hidden",
  props: {
    below: { default: void 0 },
    above: { default: void 0 }
  },
  setup(e) {
    const t = e, n = useMediaMatch(), s = computed(() => t.below ? shouldCollapseBelow(n, t.below) : t.above ? shouldCollapseAbove(n, t.above) : !1), i = () => classMerge({
      hidden: s.value
    });
    return (a, o) => (openBlock(), createBlock(_sfc_main$2K, {
      class: normalizeClass(i())
    }, {
      default: withCtx(() => [
        renderSlot(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
/*! maska v2.1.7 | (c) Alexander Shabunevich | Released under the MIT license */
var W = Object.defineProperty, b = (e, t, n) => t in e ? W(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, m = (e, t, n) => (b(e, typeof t != "symbol" ? t + "" : t, n), n);
const O = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
};
class w {
  constructor(t = {}) {
    m(this, "opts", {}), m(this, "memo", /* @__PURE__ */ new Map());
    var n;
    const s = { ...t };
    if (s.tokens != null) {
      s.tokens = s.tokensReplace ? { ...s.tokens } : { ...O, ...s.tokens };
      for (const i of Object.values(s.tokens))
        typeof i.pattern == "string" && (i.pattern = new RegExp(i.pattern));
    } else
      s.tokens = O;
    Array.isArray(s.mask) && (s.mask.length > 1 ? s.mask.sort((i, a) => i.length - a.length) : s.mask = (n = s.mask[0]) != null ? n : ""), s.mask === "" && (s.mask = null), this.opts = s;
  }
  masked(t) {
    return this.process(t, this.findMask(t));
  }
  unmasked(t) {
    return this.process(t, this.findMask(t), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const n = this.findMask(t);
    if (this.opts.mask == null || n == null)
      return !1;
    const s = this.process(t, n).length;
    return typeof this.opts.mask == "string" ? s >= this.opts.mask.length : typeof this.opts.mask == "function" ? s >= n.length : this.opts.mask.filter((i) => s >= i.length).length === this.opts.mask.length;
  }
  findMask(t) {
    var n, s;
    const i = this.opts.mask;
    if (i == null)
      return null;
    if (typeof i == "string")
      return i;
    if (typeof i == "function")
      return i(t);
    const a = this.process(t, (n = i.slice(-1).pop()) != null ? n : "", !1);
    return (s = i.find((o) => this.process(t, o, !1).length >= a.length)) != null ? s : "";
  }
  escapeMask(t) {
    const n = [], s = [];
    return t.split("").forEach((i, a) => {
      i === "!" && t[a - 1] !== "!" ? s.push(a - s.length) : n.push(i);
    }), { mask: n.join(""), escaped: s };
  }
  process(t, n, s = !0) {
    var i;
    if (n == null)
      return t;
    const a = `value=${t},mask=${n},masked=${s ? 1 : 0}`;
    if (this.memo.has(a))
      return this.memo.get(a);
    const { mask: o, escaped: l } = this.escapeMask(n), c = [], u = this.opts.tokens != null ? this.opts.tokens : {}, d = this.isReversed() ? -1 : 1, p = this.isReversed() ? "unshift" : "push", f = this.isReversed() ? 0 : o.length - 1, g = this.isReversed() ? () => _ > -1 && S > -1 : () => _ < o.length && S < t.length, C = (E) => !this.isReversed() && E <= f || this.isReversed() && E >= f;
    let k, M = -1, _ = this.isReversed() ? o.length - 1 : 0, S = this.isReversed() ? t.length - 1 : 0;
    for (; g(); ) {
      const E = o.charAt(_), P = u[E], $ = (P == null ? void 0 : P.transform) != null ? P.transform(t.charAt(S)) : t.charAt(S);
      if (!l.includes(_) && P != null) {
        if ($.match(P.pattern) != null)
          c[p]($), P.repeated ? (M === -1 ? M = _ : _ === f && _ !== M && (_ = M - d), f === M && (_ -= d)) : P.multiple && (_ -= d), _ += d;
        else if (P.multiple) {
          const A = ((i = c[S - d]) == null ? void 0 : i.match(P.pattern)) != null, I = o.charAt(_ + d);
          A && I !== "" && u[I] == null ? (_ += d, S -= d) : c[p]("");
        } else
          $ === k ? k = void 0 : P.optional && (_ += d, S -= d);
        S += d;
      } else
        s && !this.isEager() && c[p](E), $ === E && !this.isEager() ? S += d : k = E, this.isEager() || (_ += d);
      if (this.isEager())
        for (; C(_) && (u[o.charAt(_)] == null || l.includes(_)); )
          s ? c[p](o.charAt(_)) : o.charAt(_) === t.charAt(S) && (S += d), _ += d;
    }
    return this.memo.set(a, c.join("")), this.memo.get(a);
  }
}
const V = (e) => JSON.parse(e.replaceAll("'", '"')), T = (e, t = {}) => {
  const n = { ...t };
  return e.dataset.maska != null && e.dataset.maska !== "" && (n.mask = L(e.dataset.maska)), e.dataset.maskaEager != null && (n.eager = y(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (n.reversed = y(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (n.tokensReplace = y(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (n.tokens = x(e.dataset.maskaTokens)), n;
}, y = (e) => e !== "" ? Boolean(JSON.parse(e)) : !0, L = (e) => e.startsWith("[") && e.endsWith("]") ? V(e) : e, x = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return V(e);
  const t = {};
  return e.split("|").forEach((n) => {
    const s = n.split(":");
    t[s[0]] = {
      pattern: new RegExp(s[1]),
      optional: s[2] === "optional",
      multiple: s[2] === "multiple",
      repeated: s[2] === "repeated"
    };
  }), t;
};
class J {
  constructor(t, n = {}) {
    m(this, "items", /* @__PURE__ */ new Map()), m(this, "beforeinputEvent", (s) => {
      const i = s.target, a = this.items.get(i);
      a.isEager() && "inputType" in s && s.inputType.startsWith("delete") && a.unmasked(i.value).length <= 1 && this.setMaskedValue(i, "");
    }), m(this, "inputEvent", (s) => {
      if (s instanceof CustomEvent && s.type === "input" && s.detail != null && typeof s.detail == "object" && "masked" in s.detail)
        return;
      const i = s.target, a = this.items.get(i), o = i.value, l = i.selectionStart, c = i.selectionEnd;
      let u = o;
      if (a.isEager()) {
        const d = a.masked(o), p = a.unmasked(o);
        p === "" && "data" in s && s.data != null ? u = s.data : p !== a.unmasked(d) && (u = p);
      }
      if (this.setMaskedValue(i, u), "inputType" in s && (s.inputType.startsWith("delete") || l != null && l < o.length))
        try {
          i.setSelectionRange(l, c);
        } catch {
        }
    }), this.options = n, typeof t == "string" ? this.init(
      Array.from(document.querySelectorAll(t)),
      this.getMaskOpts(n)
    ) : this.init(
      "length" in t ? Array.from(t) : [t],
      this.getMaskOpts(n)
    );
  }
  destroy() {
    for (const t of this.items.keys())
      t.removeEventListener("input", this.inputEvent), t.removeEventListener("beforeinput", this.beforeinputEvent);
    this.items.clear();
  }
  needUpdateOptions(t, n) {
    const s = this.items.get(t), i = new w(T(t, this.getMaskOpts(n)));
    return JSON.stringify(s.opts) !== JSON.stringify(i.opts);
  }
  needUpdateValue(t) {
    const n = t.dataset.maskaValue;
    return n == null && t.value !== "" || n != null && n !== t.value;
  }
  getMaskOpts(t) {
    const { onMaska: n, preProcess: s, postProcess: i, ...a } = t;
    return a;
  }
  init(t, n) {
    for (const s of t) {
      const i = new w(T(s, n));
      this.items.set(s, i), s.value !== "" && this.setMaskedValue(s, s.value), s.addEventListener("input", this.inputEvent), s.addEventListener("beforeinput", this.beforeinputEvent);
    }
  }
  setMaskedValue(t, n) {
    const s = this.items.get(t);
    this.options.preProcess != null && (n = this.options.preProcess(n));
    const i = s.masked(n), a = s.unmasked(s.isEager() ? i : n), o = s.completed(n), l = { masked: i, unmasked: a, completed: o };
    n = i, this.options.postProcess != null && (n = this.options.postProcess(n)), t.value = n, t.dataset.maskaValue = n, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((c) => c(l)) : this.options.onMaska(l)), t.dispatchEvent(new CustomEvent("maska", { detail: l })), t.dispatchEvent(new CustomEvent("input", { detail: l }));
  }
}
const v = /* @__PURE__ */ new WeakMap(), N = (e) => {
  setTimeout(() => {
    var t;
    ((t = v.get(e)) == null ? void 0 : t.needUpdateValue(e)) === !0 && e.dispatchEvent(new CustomEvent("input"));
  });
}, U = (e, t) => {
  const n = e instanceof HTMLInputElement ? e : e.querySelector("input"), s = { ...t.arg };
  if (n == null)
    return;
  N(n);
  const i = v.get(n);
  if (i != null) {
    if (!i.needUpdateOptions(n, s))
      return;
    i.destroy();
  }
  if (t.value != null) {
    const a = t.value, o = (l) => {
      a.masked = l.masked, a.unmasked = l.unmasked, a.completed = l.completed;
    };
    s.onMaska = s.onMaska == null ? o : Array.isArray(s.onMaska) ? [...s.onMaska, o] : [s.onMaska, o];
  }
  v.set(n, new J(n, s));
}, DATA_TEST_ID$9 = {
  LABEL: "field_label-label"
}, _sfc_main$2q = /* @__PURE__ */ defineComponent({
  __name: "FieldLabel",
  props: {
    forId: null,
    disabled: { type: Boolean, default: !1 },
    tone: { default: "primary" }
  },
  setup(e) {
    const t = e, n = () => t.disabled ? "disabled" : t.tone === "error" ? "error" : "medium-emphasis", s = () => classMerge(mapDisabledToCursorClasses(t.disabled), "cursor-pointer w-fit");
    return (i, a) => (openBlock(), createBlock(_sfc_main$2J, {
      for: e.forId,
      tone: n(),
      class: normalizeClass(s()),
      component: "label",
      size: "sm",
      "data-testid": unref(DATA_TEST_ID$9).LABEL
    }, {
      default: withCtx(() => [
        renderSlot(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["for", "tone", "class", "data-testid"]));
  }
}), _hoisted_1$1O = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6964)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M18 6L6 18M6 6L18 18",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$2p = /* @__PURE__ */ defineComponent({
  __name: "CrossIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1O
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), DATA_TEST_ID$8 = {
  CONTAINER: "text-field_container",
  INPUT: "text-field_input",
  CLEAR_BUTTON: "text-field_clear-button",
  PREFIX: "text-field_prefix",
  SUFFIX: "text-field_suffix",
  DESCRIPTION: "text-field_description",
  MESSAGE: "text-field_message",
  ICON_LEFT: "text-field_icon-left",
  ICON_RIGHT: "text-field_icon-right"
}, _hoisted_1$1N = ["id", "type", "placeholder", "maxlength", "disabled", "data-testid"], _sfc_main$2o = /* @__PURE__ */ defineComponent({
  __name: "TextField",
  props: {
    id: null,
    modelValue: { default: "" },
    label: { default: void 0 },
    type: { default: "text" },
    tone: { default: "primary" },
    placeholder: { default: void 0 },
    maxLength: { default: void 0 },
    borderRadius: { default: "lg" },
    border: { default: "solid" },
    description: { default: void 0 },
    align: { default: "left" },
    message: { default: void 0 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    mask: { default: void 0 },
    maskTokens: { default: void 0 },
    maskOptions: { default: void 0 },
    autoFocus: { type: Boolean, default: !1 },
    joined: { default: void 0 },
    showClear: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, s = ref(), i = ref(!1), a = ref(n.modelValue);
    watch(n, (M) => {
      M.modelValue !== a.value && (a.value = M.modelValue);
    });
    const o = (M) => {
      n.disabled || (a.value = M.target.value, t("update:modelValue", a.value));
    }, l = () => {
      n.disabled || (i.value = !0);
    }, c = () => {
      n.disabled || (i.value = !1);
    }, u = () => {
      a.value = "", t("update:modelValue", "");
    }, d = useMediaMatch(), p = useResponsiveProp(n.align, d), f = () => classMerge({
      ...mapToneToFormFieldFocusRingClasses$1({
        tone: n.tone,
        focused: i.value,
        disabled: n.disabled
      }),
      ...n.borderRadius && mapBorderRadiusToClassName(n.borderRadius),
      ...n.border && mapBorderToBorderClassName(n.border),
      ...n.joined && mapJoinedToClasses(n.joined)
    }), g = () => n.disabled ? "disabled" : n.tone === "error" ? "error" : "medium-emphasis", C = () => classMerge({
      "text-black-20": n.disabled,
      ...p.value && mapAlignToTextClasses(p.value),
      ...mapDisabledToCursorClasses(n.disabled)
    }), k = () => classMerge({
      "opacity-1 w-[1.1rem]": i.value && a.value.length > 0,
      "opacity-0 w-0 delay-100": !i.value || a.value.length === 0
    });
    return onMounted(() => {
      n.autoFocus && s.value.focus();
    }), (M, _) => (openBlock(), createBlock(_sfc_main$2H, {
      class: "relative",
      space: "2xs",
      "data-testid": unref(DATA_TEST_ID$8).CONTAINER
    }, {
      default: withCtx(() => [
        e.label ? (openBlock(), createBlock(_sfc_main$2q, {
          key: 0,
          forId: e.id,
          tone: e.tone,
          disabled: e.disabled
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(e.label), 1)
          ]),
          _: 1
        }, 8, ["forId", "tone", "disabled"])) : createCommentVNode("", !0),
        createVNode(_sfc_main$2K, {
          tone: "base",
          class: normalizeClass([f(), "transition-all"]),
          "padding-x": "sm"
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$2F, {
              space: "xs",
              "vertical-align": "center"
            }, {
              default: withCtx(() => [
                M.$slots["icon-left"] ? (openBlock(), createBlock(_sfc_main$2E, {
                  key: 0,
                  width: "content"
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2K, {
                      class: "select-none",
                      "data-testid": unref(DATA_TEST_ID$8).ICON_LEFT
                    }, {
                      default: withCtx(() => [
                        renderSlot(M.$slots, "icon-left", {
                          tone: e.disabled ? "disabled" : "medium-emphasis"
                        })
                      ]),
                      _: 3
                    }, 8, ["data-testid"])
                  ]),
                  _: 3
                })) : createCommentVNode("", !0),
                e.prefix ? (openBlock(), createBlock(_sfc_main$2E, {
                  key: 1,
                  width: "content"
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2J, {
                      size: "lg",
                      class: "select-none",
                      tone: g(),
                      "data-testid": unref(DATA_TEST_ID$8).PREFIX
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(e.prefix), 1)
                      ]),
                      _: 1
                    }, 8, ["tone", "data-testid"])
                  ]),
                  _: 1
                })) : createCommentVNode("", !0),
                createVNode(_sfc_main$2E, null, {
                  default: withCtx(() => [
                    withDirectives(createElementVNode("input", mergeProps(
                      {
                        ref_key: "inputRef",
                        ref: s,
                        "onUpdate:modelValue": _[0] || (_[0] = (S) => a.value = S)
                      },
                      e.mask && {
                        "data-maska": e.mask,
                        ...e.maskTokens && { "data-maska-tokens": e.maskTokens }
                      },
                      {
                        id: e.id,
                        type: e.type,
                        placeholder: e.placeholder,
                        maxlength: e.maxLength,
                        disabled: e.disabled,
                        class: [C(), "w-full py-3 border-none bg-transparent !outline-none"],
                        "data-testid": unref(DATA_TEST_ID$8).INPUT,
                        onInput: o,
                        onFocus: l,
                        onBlur: c,
                        autocomplete: "off"
                      }
                    ), null, 16, _hoisted_1$1N), [
                      [unref(U), void 0, e.maskOptions],
                      [vModelDynamic, a.value]
                    ])
                  ]),
                  _: 1
                }),
                e.suffix ? (openBlock(), createBlock(_sfc_main$2E, {
                  key: 2,
                  width: "content"
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2J, {
                      size: "lg",
                      class: "select-none",
                      tone: e.disabled ? "disabled" : "medium-emphasis",
                      "data-testid": unref(DATA_TEST_ID$8).SUFFIX
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(e.suffix), 1)
                      ]),
                      _: 1
                    }, 8, ["tone", "data-testid"])
                  ]),
                  _: 1
                })) : createCommentVNode("", !0),
                M.$slots["icon-right"] ? (openBlock(), createBlock(_sfc_main$2E, {
                  key: 3,
                  width: "content"
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2K, {
                      class: "select-none",
                      "data-testid": unref(DATA_TEST_ID$8).ICON_RIGHT
                    }, {
                      default: withCtx(() => [
                        renderSlot(M.$slots, "icon-right", {
                          tone: e.disabled ? "disabled" : "high-emphasis"
                        })
                      ]),
                      _: 3
                    }, 8, ["data-testid"])
                  ]),
                  _: 3
                })) : createCommentVNode("", !0),
                e.showClear ? (openBlock(), createBlock(_sfc_main$2E, {
                  key: 4,
                  width: "content"
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2K, {
                      class: normalizeClass([k(), "transition-all"]),
                      role: "button",
                      "data-testid": unref(DATA_TEST_ID$8).CLEAR_BUTTON,
                      "vertical-align": "center",
                      onClick: u
                    }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$2p, {
                          size: "sm",
                          tone: "low-emphasis"
                        })
                      ]),
                      _: 1
                    }, 8, ["class", "data-testid"])
                  ]),
                  _: 1
                })) : createCommentVNode("", !0)
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["class"]),
        e.description ? (openBlock(), createBlock(_sfc_main$2J, {
          key: 1,
          size: "sm",
          tone: g(),
          "data-testid": unref(DATA_TEST_ID$8).DESCRIPTION
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(e.description), 1)
          ]),
          _: 1
        }, 8, ["tone", "data-testid"])) : createCommentVNode("", !0),
        e.message ? (openBlock(), createBlock(_sfc_main$2J, {
          key: 2,
          size: "sm",
          tone: g(),
          "data-testid": unref(DATA_TEST_ID$8).MESSAGE
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(e.message), 1)
          ]),
          _: 1
        }, 8, ["tone", "data-testid"])) : createCommentVNode("", !0)
      ]),
      _: 3
    }, 8, ["data-testid"]));
  }
}), TextField_vue_vue_type_style_index_0_lang = "", _hoisted_1$1M = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_4547_465)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      fill: "currentColor",
      d: "M11.94 2C12.4212 2.00033 12.8951 2.11677 13.3216 2.33944C13.7482 2.5621 14.1147 2.88441 14.39 3.279L14.498 3.443L22.929 17.517C23.1816 17.955 23.319 18.4499 23.3283 18.9555C23.3376 19.461 23.2184 19.9607 22.9821 20.4077C22.7457 20.8547 22.3998 21.2344 21.9767 21.5113C21.5536 21.7882 21.0672 21.9532 20.563 21.991L20.363 22H3.507C3.00219 21.994 2.50713 21.8602 2.06796 21.6112C1.6288 21.3622 1.25983 21.006 0.995465 20.5759C0.731098 20.1458 0.579938 19.6558 0.556076 19.1515C0.532215 18.6473 0.636429 18.1451 0.859004 17.692L0.960004 17.503L9.385 3.438C9.65148 2.99901 10.0266 2.63609 10.4741 2.38421C10.9216 2.13234 11.4265 2.00002 11.94 2ZM12.01 16L11.883 16.007C11.64 16.0359 11.4159 16.153 11.2534 16.336C11.0909 16.519 11.0011 16.7552 11.0011 17C11.0011 17.2448 11.0909 17.481 11.2534 17.664C11.4159 17.847 11.64 17.9641 11.883 17.993L12 18L12.127 17.993C12.3701 17.9641 12.5941 17.847 12.7566 17.664C12.9191 17.481 13.0089 17.2448 13.0089 17C13.0089 16.7552 12.9191 16.519 12.7566 16.336C12.5941 16.153 12.3701 16.0359 12.127 16.007L12.01 16ZM12 8C11.7551 8.00003 11.5187 8.08996 11.3356 8.25272C11.1526 8.41547 11.0357 8.63975 11.007 8.883L11 9V13L11.007 13.117C11.0359 13.36 11.153 13.5841 11.336 13.7466C11.519 13.9091 11.7552 13.9989 12 13.9989C12.2448 13.9989 12.481 13.9091 12.664 13.7466C12.847 13.5841 12.9641 13.36 12.993 13.117L13 13V9L12.993 8.883C12.9643 8.63975 12.8474 8.41547 12.6644 8.25272C12.4813 8.08996 12.2449 8.00003 12 8Z"
    })
  ])
], -1), _sfc_main$2n = /* @__PURE__ */ defineComponent({
  __name: "CautionIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1M
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1L = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6959)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$2m = /* @__PURE__ */ defineComponent({
  __name: "AlertCircleIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1L
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1K = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6960)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$2l = /* @__PURE__ */ defineComponent({
  __name: "CircleCheckIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1K
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1J = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6953)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12 8H12.01M11 12H12V16H13M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$2k = /* @__PURE__ */ defineComponent({
  __name: "InfoIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1J
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _sfc_main$2j = /* @__PURE__ */ defineComponent({
  __name: "Alert",
  props: {
    tone: { default: TONE.WARNING }
  },
  setup(e) {
    const t = e, n = computed(() => {
      switch (t.tone) {
        case TONE.WARNING:
          return _sfc_main$2n;
        case TONE.ERROR:
          return _sfc_main$2m;
        case TONE.SUCCESS:
          return _sfc_main$2l;
        case TONE.INFO:
          return _sfc_main$2k;
        default:
          return null;
      }
    });
    return (s, i) => (openBlock(), createBlock(_sfc_main$2K, {
      tone: "base",
      "border-tone": e.tone,
      "border-radius": "lg",
      class: "overflow-hidden"
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$2K, {
          padding: "md",
          tone: e.tone,
          class: "bg-opacity-10"
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$2H, { space: "xs" }, {
              default: withCtx(() => [
                createVNode(_sfc_main$2x, {
                  space: "xs",
                  "vertical-align": "center"
                }, {
                  default: withCtx(() => [
                    unref(n) ? (openBlock(), createBlock(resolveDynamicComponent(unref(n)), {
                      key: 0,
                      tone: e.tone,
                      size: "sm"
                    }, null, 8, ["tone"])) : createCommentVNode("", !0),
                    createVNode(_sfc_main$2J, {
                      size: "sm",
                      class: "uppercase",
                      variant: "interactive",
                      "interactive-text-weight": "strong"
                    }, {
                      default: withCtx(() => [
                        renderSlot(s.$slots, "heading")
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                }),
                createVNode(_sfc_main$2J, {
                  size: "md",
                  tone: "medium-emphasis"
                }, {
                  default: withCtx(() => [
                    renderSlot(s.$slots, "message")
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["tone"])
      ]),
      _: 3
    }, 8, ["border-tone"]));
  }
}), _hoisted_1$1I = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  class: "animate-spin",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1551_8309)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$2i = /* @__PURE__ */ defineComponent({
  __name: "SpinnerIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1I
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _sfc_main$2h = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    size: { default: "lg" },
    variant: { default: "primary" },
    text: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    width: { default: "auto" }
  },
  setup(e) {
    const t = e, n = useMediaMatch(), s = useResponsiveProp(
      t.width,
      n
    ), i = () => classMerge({
      ...mapSizeToButtonClasses(t.size),
      ...s.value && mapWidthToButtonClasses(s.value),
      ...mapDisabledAndLoadingToButtonClasses({
        disabled: t.disabled,
        loading: t.loading
      }),
      ...mapVariantToButtonClasses({
        variant: t.variant,
        disabled: t.disabled,
        loading: t.loading
      })
    }), a = () => classMerge(mapSizeToButtonLeftIconOffsetClasses(t.size)), o = () => classMerge(mapSizeToButtonRightIconOffsetClasses(t.size)), l = () => classMerge("transition-all", {
      "-translate-y-0": !t.loading,
      "-translate-y-full opacity-0 invisible": t.loading
    }), c = () => classMerge("absolute transition-all ease-in-out -translate-x-1/2 left-2/4", {
      "translate-y-full opacity-0 invisible": !t.loading,
      "translate-y-0": t.loading
    }), u = () => t.disabled ? "disabled" : !t.variant || t.variant === "secondary-legacy" ? "high-emphasis" : t.variant === "text-secondary" ? "medium-emphasis" : ["secondary", "tertiary", "text"].includes(t.variant) ? "primary" : "base";
    return (d, p) => (openBlock(), createBlock(_sfc_main$2K, {
      component: "button",
      class: normalizeClass(["relative h-12 transition-all ease-in-out !outline-none whitespace-nowrap", i()]),
      "border-radius": "full",
      disabled: e.loading || e.disabled
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$2x, {
          space: "2xs",
          "vertical-align": "center",
          align: "center"
        }, {
          default: withCtx(() => [
            d.$slots["icon-left"] ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(a())
            }, [
              renderSlot(d.$slots, "icon-left", {
                tone: u()
              })
            ], 2)) : createCommentVNode("", !0),
            createVNode(_sfc_main$2K, {
              class: normalizeClass(c())
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$2i, {
                  size: "sm",
                  tone: u()
                }, null, 8, ["tone"])
              ]),
              _: 1
            }, 8, ["class"]),
            createVNode(_sfc_main$2J, {
              size: e.size,
              variant: "interactive",
              tone: u(),
              class: normalizeClass(l()),
              "interactive-text-weight": "strong",
              align: "center"
            }, {
              default: withCtx(() => [
                renderSlot(d.$slots, "default", {}, () => [
                  createTextVNode(toDisplayString(e.text), 1)
                ])
              ]),
              _: 3
            }, 8, ["size", "tone", "class"]),
            d.$slots["icon-right"] ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: normalizeClass(o())
            }, [
              renderSlot(d.$slots, "icon-right", {
                tone: u()
              })
            ], 2)) : createCommentVNode("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["class", "disabled"]));
  }
}), _hoisted_1$1H = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6887)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M15 6L9 12L15 18",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$2g = /* @__PURE__ */ defineComponent({
  __name: "ChevronLeftIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1H
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1G = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6886)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M9 6L15 12L9 18",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$2f = /* @__PURE__ */ defineComponent({
  __name: "ChevronRightIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1G
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _sfc_main$2e = /* @__PURE__ */ defineComponent({
  __name: "Pagination",
  props: {
    hasPreviousPage: { type: Boolean },
    hasNextPage: { type: Boolean }
  },
  emits: ["onPreviousPageClick", "onNextPageClick"],
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$2x, {
      space: "sm",
      align: "center"
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$2h, {
          disabled: !e.hasPreviousPage,
          size: "md",
          variant: "text-secondary",
          onClick: n[0] || (n[0] = (s) => t.$emit("onPreviousPageClick"))
        }, {
          "icon-left": withCtx(() => [
            createVNode(_sfc_main$2g, {
              tone: e.hasPreviousPage ? "medium-emphasis" : "disabled",
              size: "sm"
            }, null, 8, ["tone"])
          ]),
          default: withCtx(() => [
            createTextVNode(" Back ")
          ]),
          _: 1
        }, 8, ["disabled"]),
        createVNode(_sfc_main$2h, {
          disabled: !e.hasNextPage,
          size: "md",
          variant: "text-secondary",
          onClick: n[1] || (n[1] = (s) => t.$emit("onNextPageClick"))
        }, {
          "icon-right": withCtx(() => [
            createVNode(_sfc_main$2f, {
              tone: e.hasNextPage ? "medium-emphasis" : "disabled",
              size: "sm"
            }, null, 8, ["tone"])
          ]),
          default: withCtx(() => [
            createTextVNode(" Next ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }));
  }
}), mapSizeToTdPadding = (e) => ({
  "": e === "xs",
  "py-2 pr-2 first-of-type:pl-1 last-of-type:pr-1": e === "sm",
  "py-3 pr-3 first-of-type:pl-2 last-of-type:pr-2": e === "md"
}), mapSizeToThPadding = (e) => ({
  "": e === "xs",
  "pt-1 pb-3 pr-3 first-of-type:pl-1 last-of-type:pr-1": e === "sm",
  "pt-2 pb-4 pr-4 first-of-type:pl-2 last-of-type:pr-2": e === "md"
}), mapHoverableToTableRowClasses = (e) => ({
  "[&>tr]:cursor-pointer [&>tr]:transition-colors [&>tr]:duration-75 [&>tr:hover]:bg-grey-40 [&>tr:focus]:bg-grey-40 [&>tr:focus]:outline-none": e
}), mapTrVariantsToClasses = (e) => ({
  "sticky top-0": e === "sticky"
}), _sfc_main$2d = /* @__PURE__ */ defineComponent({
  __name: "Tr",
  props: {
    variant: { default: void 0 },
    tone: { default: void 0 }
  },
  setup(e) {
    const t = e, n = () => classMerge({
      ...t.variant && mapTrVariantsToClasses(t.variant),
      ...t.tone && mapToneToClassName(t.tone)
    });
    return (s, i) => (openBlock(), createElementBlock("tr", {
      class: normalizeClass(n())
    }, [
      renderSlot(s.$slots, "default")
    ], 2));
  }
}), _sfc_main$2c = /* @__PURE__ */ defineComponent({
  __name: "Td",
  props: {
    align: { default: "left" }
  },
  setup(e) {
    const t = inject("tableSize", "md"), n = () => classMerge(mapSizeToTdPadding(t));
    return (s, i) => (openBlock(), createElementBlock("td", mergeProps({ class: "first-of-type:rounded-l-lg last-of-type:rounded-r-lg" }, e.align && { align: e.align }, {
      class: n()
    }), [
      renderSlot(s.$slots, "default")
    ], 16));
  }
}), _hoisted_1$1F = { class: "table-fixed min-w-[100%]" }, _hoisted_2$f = { key: 0 }, _hoisted_3$d = { key: 2 }, _sfc_main$2b = /* @__PURE__ */ defineComponent({
  __name: "Table",
  props: {
    size: { default: "md" },
    hasNextPage: { type: Boolean, default: !1 },
    hasPreviousPage: { type: Boolean, default: !1 },
    showPagination: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    rowCount: { default: 0 },
    hoverable: { type: Boolean, default: !0 }
  },
  emits: ["onPreviousPageClick", "onNextPageClick"],
  setup(e) {
    const t = e;
    return provide("tableSize", t.size), (n, s) => (openBlock(), createBlock(_sfc_main$2K, { class: "relative" }, {
      default: withCtx(() => [
        e.isLoading ? (openBlock(), createBlock(_sfc_main$2K, {
          key: 0,
          "data-testid": "table_refresh-loader",
          class: "absolute z-10 w-full h-full opacity-50",
          tone: "base"
        })) : createCommentVNode("", !0),
        n.$slots["empty-message"] && t.rowCount === 0 ? (openBlock(), createBlock(_sfc_main$2K, {
          key: 1,
          "vertical-align": "center",
          class: "h-[328px]",
          "content-align": "center"
        }, {
          default: withCtx(() => [
            renderSlot(n.$slots, "empty-message")
          ]),
          _: 3
        })) : createCommentVNode("", !0),
        !n.$slots["empty-message"] || t.rowCount > 0 ? (openBlock(), createBlock(_sfc_main$2H, {
          key: 2,
          space: "md"
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$2K, null, {
              default: withCtx(() => [
                createElementVNode("table", _hoisted_1$1F, [
                  n.$slots.thead ? (openBlock(), createElementBlock("thead", _hoisted_2$f, [
                    renderSlot(n.$slots, "thead")
                  ])) : createCommentVNode("", !0),
                  n.$slots.tbody ? (openBlock(), createElementBlock("tbody", {
                    key: 1,
                    class: normalizeClass(unref(mapHoverableToTableRowClasses)(t.hoverable))
                  }, [
                    renderSlot(n.$slots, "tbody")
                  ], 2)) : createCommentVNode("", !0),
                  n.$slots.tfoot ? (openBlock(), createElementBlock("tfoot", _hoisted_3$d, [
                    createVNode(_sfc_main$2d, null, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$2c, {
                          class: "pt-1",
                          size: e.size,
                          colspan: "100%"
                        }, null, 8, ["size"])
                      ]),
                      _: 1
                    }),
                    createVNode(_sfc_main$2d, null, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$2c, {
                          class: "pt-0 pb-1",
                          size: e.size,
                          colspan: "100%"
                        }, {
                          default: withCtx(() => [
                            createVNode(_sfc_main$2B, { tone: "secondary" })
                          ]),
                          _: 1
                        }, 8, ["size"])
                      ]),
                      _: 1
                    }),
                    renderSlot(n.$slots, "tfoot")
                  ])) : createCommentVNode("", !0)
                ])
              ]),
              _: 3
            }),
            e.showPagination ? (openBlock(), createBlock(_sfc_main$2e, {
              key: 0,
              "has-previous-page": e.hasPreviousPage,
              "has-next-page": e.hasNextPage,
              onOnPreviousPageClick: s[0] || (s[0] = (i) => n.$emit("onPreviousPageClick")),
              onOnNextPageClick: s[1] || (s[1] = (i) => n.$emit("onNextPageClick"))
            }, null, 8, ["has-previous-page", "has-next-page"])) : createCommentVNode("", !0)
          ]),
          _: 3
        })) : createCommentVNode("", !0)
      ]),
      _: 3
    }));
  }
}), _sfc_main$2a = /* @__PURE__ */ defineComponent({
  __name: "Th",
  props: {
    align: { default: "left" }
  },
  setup(e) {
    const t = inject("tableSize", "md"), n = () => classMerge(mapSizeToThPadding(t));
    return (s, i) => (openBlock(), createElementBlock("th", {
      class: normalizeClass(["font-normal align-top", n()])
    }, [
      createVNode(_sfc_main$2J, mergeProps({
        size: "sm",
        tone: "low-emphasis"
      }, e.align && { align: e.align }), {
        default: withCtx(() => [
          renderSlot(s.$slots, "default")
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), createDateMask = () => ({
  mask: "##/##/####"
}), createCurrencyMask = ({
  locale: e,
  currency: t,
  min: n = 0,
  max: s = 1e8
}) => {
  const i = new Intl.NumberFormat(e, {
    style: "currency",
    currency: t
  });
  return {
    mask: "0.99",
    maskTokens: "0:\\d:multiple|9:\\d:optional",
    maskOptions: {
      preProcess: (a) => a.replace(/[$,]/g, ""),
      postProcess: (a) => {
        if (!a)
          return "";
        const o = 3 - (a.includes(".") ? a.length - a.indexOf(".") : 0);
        let l = parseFloat(a);
        return n && l < n && (l = n), s && l > s && (l = s), i.format(l).slice(0, o ? -o : void 0);
      }
    }
  };
}, createUnitsMask = () => ({
  mask: "0.9999",
  maskTokens: "0:\\d:multiple|9:\\d:optional"
}), createPercentageMask = ({
  max: e = 0,
  min: t = 100
}) => ({
  mask: "0.9999",
  maskTokens: "0:\\d:multiple|9:\\d:optional",
  maskOptions: {
    preProcess: (n) => {
      const s = Math.abs(parseInt(n)), i = Math.max(s, t);
      return Math.min(i, e).toString();
    }
  }
}), createDateOfBirthMask = () => ({
  mask: "##/##/####"
}), createAccountBSBMask = () => ({
  mask: "###-###",
  maskOptions: {
    postProcess: (e) => e ? e.replace(/-/g, "") : ""
  }
}), createAccountNumberMask = () => ({
  mask: "#########"
}), _hoisted_1$1E = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1359_6907)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M19.4254 4.57417C17.785 2.93384 13.1245 4.92807 9.0289 9.02995C4.92807 13.1308 2.93384 17.785 4.57417 19.4264C6.2145 21.0657 10.8751 19.0715 14.9706 14.9696C19.0715 10.8688 21.0657 6.21555 19.4254 4.57417Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M4.57417 4.57417C2.93384 6.2145 4.92807 10.8751 9.02995 14.9706C13.1308 19.0715 17.785 21.0657 19.4264 19.4254C21.0657 17.785 19.0715 13.1245 14.9696 9.0289C10.8688 4.92807 6.21555 2.93384 4.57417 4.57417Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$29 = /* @__PURE__ */ defineComponent({
  __name: "BalancedIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1E
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1D = { class: "absolute inset-0 flex items-center justify-center" }, __default__$5 = {
  inheritAttrs: !1
}, _sfc_main$28 = /* @__PURE__ */ defineComponent({
  ...__default__$5,
  __name: "ShapeWrapper",
  props: {
    tone: { default: void 0 },
    background: { default: void 0 },
    size: { default: "md" },
    shapeStyle: { default: "filled" }
  },
  setup(e) {
    const t = e, n = () => classMerge({
      ...t.background && mapBackgroundToTextClassName(t.background),
      ...t.tone && mapToneToTextClasses(t.tone),
      ...t.size && mapSizeToShape(t.size)
    }), s = () => ({
      ...t.shapeStyle && mapShapeStyleToShape(t.shapeStyle)
    });
    return (i, a) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["relative w-full-h-full", n()])
    }, [
      createElementVNode("div", {
        class: normalizeClass(["absolute inset-0 w-full h-full", s()])
      }, [
        renderSlot(i.$slots, "shape")
      ], 2),
      createElementVNode("div", _hoisted_1$1D, [
        renderSlot(i.$slots, "icon")
      ])
    ], 2));
  }
}), _hoisted_1$1C = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "-2 -2 84 84",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("circle", {
    cx: "40",
    cy: "40.002",
    r: "40"
  })
], -1), _sfc_main$27 = /* @__PURE__ */ defineComponent({
  __name: "Circle",
  props: {
    tone: { default: void 0 },
    background: { default: void 0 },
    size: { default: "md" },
    shapeStyle: { default: "filled" }
  },
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$28, {
      tone: e.tone,
      background: e.background,
      size: e.size,
      "shape-style": e.shapeStyle
    }, {
      shape: withCtx(() => [
        _hoisted_1$1C
      ]),
      icon: withCtx(() => [
        renderSlot(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["tone", "background", "size", "shape-style"]));
  }
}), _sfc_main$26 = /* @__PURE__ */ defineComponent({
  __name: "BalancedBadge",
  props: {
    size: { default: "md" }
  },
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$27, {
      size: e.size,
      shapeStyle: "filled",
      tone: "high-emphasis"
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$29, {
          size: unref(mapBadgeSizeToIconSize)(e.size),
          tone: "base"
        }, null, 8, ["size"])
      ]),
      _: 1
    }, 8, ["size"]));
  }
}), _hoisted_1$1B = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "-2 -2 84 84",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", { d: "M39.9998 2L78.042 29.6393L63.5112 74.3607H16.4884L1.95752 29.6393L39.9998 2Z" })
], -1), _sfc_main$25 = /* @__PURE__ */ defineComponent({
  __name: "Pentagon",
  props: {
    tone: { default: void 0 },
    background: { default: void 0 },
    size: { default: "md" },
    shapeStyle: { default: "filled" }
  },
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$28, {
      tone: e.tone,
      background: e.background,
      size: e.size,
      "shape-style": e.shapeStyle
    }, {
      shape: withCtx(() => [
        _hoisted_1$1B
      ]),
      icon: withCtx(() => [
        renderSlot(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["tone", "background", "size", "shape-style"]));
  }
}), _hoisted_1$1A = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6956)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12 3L8 10H16L12 3Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M17 20C18.6569 20 20 18.6569 20 17C20 15.3431 18.6569 14 17 14C15.3431 14 14 15.3431 14 17C14 18.6569 15.3431 20 17 20Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M9 14H5C4.44772 14 4 14.4477 4 15V19C4 19.5523 4.44772 20 5 20H9C9.55228 20 10 19.5523 10 19V15C10 14.4477 9.55228 14 9 14Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$24 = /* @__PURE__ */ defineComponent({
  __name: "TriangleSquareCircleIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1A
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _sfc_main$23 = /* @__PURE__ */ defineComponent({
  __name: "CustomBadge",
  props: {
    size: { default: "md" }
  },
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$25, {
      size: e.size,
      shapeStyle: "dashed-line",
      tone: "primary"
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$24, {
          size: unref(mapBadgeSizeToIconSize)(e.size),
          tone: "primary"
        }, null, 8, ["size"])
      ]),
      _: 1
    }, 8, ["size"]));
  }
}), _hoisted_1$1z = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_3925_2680)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M12 19.5C12 17.015 10.21 15 8 15M12 19.5V4M12 19.5C12 17.015 13.79 15 16 15M8 11C10.21 11 12 13.015 12 15.5C12 13.015 13.79 11 16 11M8 7C10.21 7 12 9.015 12 11.5C12 9.015 13.79 7 16 7",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$22 = /* @__PURE__ */ defineComponent({
  __name: "GrowthIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1z
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1y = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "-2 -2 84 84",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", { d: "M40 0L74.641 20V60L40 80L5.35898 60V20L40 0Z" })
], -1), _sfc_main$21 = /* @__PURE__ */ defineComponent({
  __name: "Hexagon",
  props: {
    tone: { default: void 0 },
    background: { default: void 0 },
    size: { default: "md" },
    shapeStyle: { default: "filled" }
  },
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$28, {
      tone: e.tone,
      background: e.background,
      size: e.size,
      "shape-style": e.shapeStyle
    }, {
      shape: withCtx(() => [
        _hoisted_1$1y
      ]),
      icon: withCtx(() => [
        renderSlot(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["tone", "background", "size", "shape-style"]));
  }
}), _sfc_main$20 = /* @__PURE__ */ defineComponent({
  __name: "GrowthBadge",
  props: {
    size: { default: "md" }
  },
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$21, {
      size: e.size,
      shapeStyle: "filled",
      tone: "low-emphasis"
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$22, {
          size: unref(mapBadgeSizeToIconSize)(e.size),
          tone: "base"
        }, null, 8, ["size"])
      ]),
      _: 1
    }, 8, ["size"]));
  }
}), _hoisted_1$1x = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1359_6906)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M10 12L8 9.8L8.6 8.8M6 5H18L21 10L12.5 19.5C12.4348 19.5665 12.357 19.6194 12.2712 19.6554C12.1853 19.6915 12.0931 19.7101 12 19.7101C11.9069 19.7101 11.8147 19.6915 11.7288 19.6554C11.643 19.6194 11.5652 19.5665 11.5 19.5L3 10L6 5Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1$ = /* @__PURE__ */ defineComponent({
  __name: "HighGrowthIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1x
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1w = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "-2 -2 84 84",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", { d: "M0 40L40 0L80 40L40 80L0 40Z" })
], -1), _sfc_main$1_ = /* @__PURE__ */ defineComponent({
  __name: "Diamond",
  props: {
    tone: { default: void 0 },
    background: { default: void 0 },
    size: { default: "md" },
    shapeStyle: { default: "filled" }
  },
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$28, {
      tone: e.tone,
      background: e.background,
      size: e.size,
      "shape-style": e.shapeStyle
    }, {
      shape: withCtx(() => [
        _hoisted_1$1w
      ]),
      icon: withCtx(() => [
        renderSlot(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["tone", "background", "size", "shape-style"]));
  }
}), _sfc_main$1Z = /* @__PURE__ */ defineComponent({
  __name: "HighGrowthBadge",
  props: {
    size: { default: "md" }
  },
  setup(e) {
    return (t, n) => (openBlock(), createBlock(_sfc_main$1_, {
      size: e.size,
      shapeStyle: "filled",
      tone: "primary"
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$1$, {
          size: unref(mapBadgeSizeToIconSize)(e.size),
          tone: "base"
        }, null, 8, ["size"])
      ]),
      _: 1
    }, 8, ["size"]));
  }
}), _hoisted_1$1v = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_3229_2420)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M10 16.5L12 13.5M12 13.5L14 16.5M12 13.5V11.5M12 11.5L15 10.5M12 11.5L9 10.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M12 8C12.2761 8 12.5 7.77614 12.5 7.5C12.5 7.22386 12.2761 7 12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8Z",
      fill: "currentColor",
      "fill-opacity": "0.9",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1Y = /* @__PURE__ */ defineComponent({
  __name: "AccessibleIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1v
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1u = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1339_6189)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M17.657 16.6567L13.414 20.8997C13.039 21.2743 12.5306 21.4848 12.0005 21.4848C11.4704 21.4848 10.962 21.2743 10.587 20.8997L6.343 16.6567C5.22422 15.5379 4.46234 14.1124 4.15369 12.5606C3.84504 11.0087 4.00349 9.40022 4.60901 7.93844C5.21452 6.47665 6.2399 5.22725 7.55548 4.34821C8.87107 3.46918 10.4178 3 12 3C13.5822 3 15.1289 3.46918 16.4445 4.34821C17.7601 5.22725 18.7855 6.47665 19.391 7.93844C19.9965 9.40022 20.155 11.0087 19.8463 12.5606C19.5377 14.1124 18.7758 15.5379 17.657 16.6567Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1X = /* @__PURE__ */ defineComponent({
  __name: "AddressIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1u
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1t = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_2491_2171)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M12 8V12M12 16H12.01M8.7 3H15.3C15.6 3 15.8 3.1 16 3.3L20.7 8C20.9 8.2 21 8.4 21 8.7V15.3C21 15.6 20.9 15.8 20.7 16L16 20.7C15.8 20.9 15.6 21 15.3 21H8.7C8.4 21 8.2 20.9 8 20.7L3.3 16C3.1 15.8 3 15.6 3 15.3V8.7C3 8.4 3.1 8.2 3.3 8L8 3.3C8.2 3.1 8.4 3 8.7 3Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1W = /* @__PURE__ */ defineComponent({
  __name: "AlertOctagonIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1t
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1s = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "vector-effect": "non-scaling-stroke",
    d: "M18.613 7.67713L20.3541 10.3567C20.8021 11.0461 21.0303 11.8861 20.9968 12.7219C20.9703 13.3788 20.785 14.0225 20.4606 14.5834L19.3282 16.542C18.8856 17.3073 18.084 17.7828 17.2361 17.7828C17.2156 17.7828 17.1952 17.7825 17.1746 17.782L16.1321 17.7544C15.3525 17.7338 14.6617 17.2255 14.3721 16.4595L13.9556 15.358C13.9235 15.2729 13.851 15.2427 13.7938 15.2427C13.7452 15.2427 13.7001 15.2639 13.6668 15.3024L13.4201 15.5883C13.3251 15.6985 13.1898 15.7617 13.0491 15.7617C12.8688 15.7617 12.7012 15.6589 12.6119 15.4935L12.2448 14.8138C11.9961 14.3534 11.5304 14.0673 11.0292 14.0673C10.8773 14.0673 10.7268 14.0936 10.5819 14.1452L8.49632 14.8897C8.27617 14.9682 8.05739 15.0602 7.84609 15.1632L6.02207 16.0515C5.79122 16.1639 5.54535 16.2209 5.2912 16.2209C5.06075 16.2209 4.83593 16.1736 4.62301 16.0804C4.41427 15.989 4.25392 15.8064 4.18306 15.5795C4.11225 15.3525 4.13823 15.1048 4.25449 14.8998L4.30826 14.8049C4.43536 14.5809 4.45408 14.3034 4.35834 14.0624L3.1346 10.9839C2.77758 10.0857 3.1538 9.06446 3.99114 8.65891L6.27044 7.55482L8.33448 4.83463C8.52415 4.58461 8.80688 4.44124 9.11013 4.44124C9.2688 4.44124 9.42729 4.48229 9.56839 4.55991C9.66523 4.61322 9.77405 4.64136 9.88309 4.64136C10.0419 4.64136 10.1967 4.58228 10.3189 4.47502L11.6575 3.29979C11.8064 3.16904 11.995 3.09701 12.1886 3.09701C12.2886 3.09701 12.3867 3.11588 12.4804 3.15306L13.2254 3.44865C13.4411 3.53425 13.6151 3.71261 13.7026 3.93807C13.7902 4.16354 13.785 4.41971 13.6885 4.64103C13.5898 4.8672 13.6595 5.13288 13.8543 5.27285L14.8237 5.96952C14.9331 6.04812 15.0599 6.08973 15.1903 6.08973C15.4725 6.08973 15.7227 5.90009 15.8128 5.61773L16.6079 3.12674C16.6334 3.04664 16.7078 2.99506 16.7864 3.00037C16.8661 3.00601 16.9323 3.06766 16.9477 3.15059L17.2702 4.89497C17.2923 5.01462 17.4038 5.09723 17.5188 5.07547C17.5515 5.06937 17.5848 5.0663 17.6179 5.0663C17.8825 5.0663 18.1155 5.26506 18.172 5.53885L18.613 7.67713Z",
    stroke: "currentColor",
    "stroke-opacity": "0.9",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /* @__PURE__ */ createElementVNode("path", {
    d: "M15.6715 20.0019L16.5721 20.0703C16.7498 20.0837 16.9011 20.1859 16.9668 20.337C17.0325 20.488 16.9993 20.6568 16.8799 20.7776L15.7373 21.9341C15.6952 21.9765 15.6358 22 15.5746 22C15.5578 22 15.5409 21.9983 15.5241 21.9946C15.4462 21.9778 15.3847 21.9235 15.3636 21.8532L15.0222 20.713C14.971 20.5418 15.0094 20.3628 15.1275 20.222C15.2562 20.0683 15.4559 19.9861 15.6715 20.0019Z",
    "vector-effect": "non-scaling-stroke",
    fill: "currentColor"
  })
], -1), _sfc_main$1V = /* @__PURE__ */ defineComponent({
  __name: "AustralianMapIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1s
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1r = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "vector-effect": "non-scaling-stroke",
    d: "M2.71654 18.6386L10.8054 3.26982C11.3115 2.30816 12.6885 2.30816 13.1946 3.26982L21.2835 18.6386C21.6529 19.3406 21.2835 20.2047 20.5207 20.4227L16.6226 21.5364C15.6655 21.8099 14.6439 21.4065 14.1318 20.5529L12.3001 17.5002C12.1642 17.2736 11.8358 17.2736 11.6999 17.5002L9.86824 20.5529C9.35608 21.4065 8.33454 21.8099 7.37737 21.5364L3.47929 20.4227C2.71652 20.2047 2.34707 19.3406 2.71654 18.6386Z",
    stroke: "currentColor",
    "stroke-opacity": "0.9"
  })
], -1), _sfc_main$1U = /* @__PURE__ */ defineComponent({
  __name: "AutopilotIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1r
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1q = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6939)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M3 21H21M3 10H21M5 6L12 3L19 6M4 10V21M20 10V21M8 14V17M12 14V17M16 14V17",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1T = /* @__PURE__ */ defineComponent({
  __name: "BuildingBankIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1q
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1p = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31223)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12.5008 12C13.0312 12 13.5399 11.7893 13.915 11.4142C14.29 11.0391 14.5008 10.5304 14.5008 10C14.5008 9.46957 14.29 8.96086 13.915 8.58579C13.5399 8.21072 13.0312 8 12.5008 8L9.50076 8L9.50076 16H12.5008C13.0312 16 13.5399 15.7893 13.915 15.4142C14.29 15.0391 14.5008 14.5304 14.5008 14C14.5008 13.4696 14.29 12.9609 13.915 12.5858C13.5399 12.2107 13.0312 12 12.5008 12ZM12.5008 12H9.50076M2.80837 14.1213L9.87943 21.1924C11.051 22.364 12.9505 22.364 14.1221 21.1924L21.1931 14.1213C22.3647 12.9497 22.3647 11.0502 21.1931 9.87867L14.1221 2.8076C12.9505 1.63603 11.051 1.63603 9.87943 2.8076L2.80837 9.87867C1.63679 11.0502 1.63679 12.9497 2.80837 14.1213Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "vector-effect": "non-scaling-stroke"
    })
  ])
], -1), _sfc_main$1S = /* @__PURE__ */ defineComponent({
  __name: "BuyIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1p
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1o = /* @__PURE__ */ createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_8106_3131)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M16 3V7M8 3V7M4 11H20M6 5H18C19.1046 5 20 5.89543 20 7V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V7C4 5.89543 4.89543 5 6 5ZM8 15H10V17H8V15Z",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1R = /* @__PURE__ */ defineComponent({
  __name: "CalendarIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1o
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1n = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31599)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M18 12H18.01M6 12H6.01M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12ZM5 6H19C20.1046 6 21 6.89543 21 8V16C21 17.1046 20.1046 18 19 18H5C3.89543 18 3 17.1046 3 16V8C3 6.89543 3.89543 6 5 6Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1Q = /* @__PURE__ */ defineComponent({
  __name: "CashBanknoteIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1n
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1m = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6885)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M6 15L12 9L18 15",
      "vector-effect": "non-scaling-stroke",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1P = /* @__PURE__ */ defineComponent({
  __name: "ChevronUpIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1m
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1l = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6945)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12 7V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
      "vector-effect": "non-scaling-stroke",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1O = /* @__PURE__ */ defineComponent({
  __name: "ClockIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1l
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1k = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6967)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M14.8 9C14.6188 8.68576 14.3557 8.4267 14.0386 8.25055C13.7215 8.0744 13.3625 7.9878 13 8H11C10.4696 8 9.96086 8.21071 9.58579 8.58579C9.21071 8.96086 9 9.46957 9 10C9 10.5304 9.21071 11.0391 9.58579 11.4142C9.96086 11.7893 10.4696 12 11 12H13C13.5304 12 14.0391 12.2107 14.4142 12.5858C14.7893 12.9609 15 13.4696 15 14C15 14.5304 14.7893 15.0391 14.4142 15.4142C14.0391 15.7893 13.5304 16 13 16H11C10.6375 16.0122 10.2785 15.9256 9.96142 15.7494C9.64435 15.5733 9.38115 15.3142 9.2 15M12 6V8M12 16V18M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1N = /* @__PURE__ */ defineComponent({
  __name: "CoinIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1k
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1j = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31233)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M3 21H21M9 8H10M9 12H10M9 16H10M14 8H15M14 12H15M14 16H15M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1M = /* @__PURE__ */ defineComponent({
  __name: "CompanyIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1j
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1i = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31594)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M11 6C11 6.79565 11.5268 7.55871 12.4645 8.12132C13.4021 8.68393 14.6739 9 16 9C17.3261 9 18.5979 8.68393 19.5355 8.12132C20.4732 7.55871 21 6.79565 21 6M11 6C11 5.20435 11.5268 4.44129 12.4645 3.87868C13.4021 3.31607 14.6739 3 16 3C17.3261 3 18.5979 3.31607 19.5355 3.87868C20.4732 4.44129 21 5.20435 21 6M11 6V10M21 6V10M11 10C11 11.657 13.239 13 16 13C18.761 13 21 11.657 21 10M11 10V14M21 10V14M11 14C11 15.657 13.239 17 16 17C18.761 17 21 15.657 21 14M11 14V18C11 19.657 13.239 21 16 21C18.761 21 21 19.657 21 18V14M7 9H4.5C4.10218 9 3.72064 9.15804 3.43934 9.43934C3.15804 9.72064 3 10.1022 3 10.5C3 10.8978 3.15804 11.2794 3.43934 11.5607C3.72064 11.842 4.10218 12 4.5 12H5.5C5.89782 12 6.27936 12.158 6.56066 12.4393C6.84196 12.7206 7 13.1022 7 13.5C7 13.8978 6.84196 14.2794 6.56066 14.5607C6.27936 14.842 5.89782 15 5.5 15H3M5 15V16M5 8V9",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1L = /* @__PURE__ */ defineComponent({
  __name: "DistributionsAndDividendsIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1i
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1h = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6780)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "vector-effect": "non-scaling-stroke"
    })
  ])
], -1), _sfc_main$1K = /* @__PURE__ */ defineComponent({
  __name: "ExploreIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1h
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1g = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_7601_37956)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M11 7H6C5.46957 7 4.96086 7.21071 4.58579 7.58579C4.21071 7.96086 4 8.46957 4 9V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V13M10 14L20 4M20 4H15M20 4V9",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "vector-effect": "non-scaling-stroke"
    })
  ])
], -1), _sfc_main$1J = /* @__PURE__ */ defineComponent({
  __name: "ExternalLinkIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1g
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1f = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31622)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M13 21H6C5.46957 21 4.96086 20.7893 4.58579 20.4142C4.21071 20.0391 4 19.5304 4 19V7C4 6.46957 4.21071 5.96086 4.58579 5.58579C4.96086 5.21071 5.46957 5 6 5H18C18.5304 5 19.0391 5.21071 19.4142 5.58579C19.7893 5.96086 20 6.46957 20 7V10M16 3V7M8 3V7M4 11H16.5M21 15H18.5C18.1022 15 17.7206 15.158 17.4393 15.4393C17.158 15.7206 17 16.1022 17 16.5C17 16.8978 17.158 17.2794 17.4393 17.5607C17.7206 17.842 18.1022 18 18.5 18H19.5C19.8978 18 20.2794 18.158 20.5607 18.4393C20.842 18.7206 21 19.1022 21 19.5C21 19.8978 20.842 20.2794 20.5607 20.5607C20.2794 20.842 19.8978 21 19.5 21H17M19 21V22M19 14V15",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1I = /* @__PURE__ */ defineComponent({
  __name: "FeeCalendarIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1f
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1e = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1442_5793)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19M14 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V8M14 3L19 8M9 9H10M9 13H15M9 17H15",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1H = /* @__PURE__ */ defineComponent({
  __name: "FileTextIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1e
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1d = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31589)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12 7.99999V21M12 7.99999C11.6383 6.5094 11.0154 5.23506 10.2127 4.34316C9.41003 3.45125 8.46469 2.98319 7.5 2.99999C6.83696 2.99999 6.20107 3.26339 5.73223 3.73223C5.26339 4.20107 5 4.83695 5 5.49999C5 6.16304 5.26339 6.79892 5.73223 7.26776C6.20107 7.7366 6.83696 7.99999 7.5 7.99999M12 7.99999C12.3617 6.5094 12.9846 5.23506 13.7873 4.34316C14.59 3.45125 15.5353 2.98319 16.5 2.99999C17.163 2.99999 17.7989 3.26339 18.2678 3.73223C18.7366 4.20107 19 4.83695 19 5.49999C19 6.16304 18.7366 6.79892 18.2678 7.26776C17.7989 7.7366 17.163 7.99999 16.5 7.99999M19 12V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V12M4 7.99999H20C20.5523 7.99999 21 8.44771 21 8.99999V11C21 11.5523 20.5523 12 20 12H4C3.44772 12 3 11.5523 3 11V8.99999C3 8.44771 3.44772 7.99999 4 7.99999Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1G = /* @__PURE__ */ defineComponent({
  __name: "GiftIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1d
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1c = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "vector-effect": "non-scaling-stroke",
    d: "M3 12H7L10 20L14 4L17 12H21",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), _sfc_main$1F = /* @__PURE__ */ defineComponent({
  __name: "HeartbeatIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1c
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1b = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6844)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M16 15C13.79 16.333 10.208 16.333 8 15M18.9993 8.71001L13.6663 4.56201C13.1983 4.19792 12.6223 4.00024 12.0293 4.00024C11.4363 4.00024 10.8603 4.19792 10.3923 4.56201L5.0583 8.71001C4.73774 8.9593 4.47839 9.27854 4.30005 9.64336C4.12171 10.0082 4.02911 10.4089 4.0293 10.815V18.015C4.0293 18.5454 4.24001 19.0542 4.61508 19.4292C4.99016 19.8043 5.49886 20.015 6.0293 20.015H18.0293C18.5597 20.015 19.0684 19.8043 19.4435 19.4292C19.8186 19.0542 20.0293 18.5454 20.0293 18.015V10.815C20.0293 9.99201 19.6493 9.21501 18.9993 8.71001Z",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1E = /* @__PURE__ */ defineComponent({
  __name: "HomeIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1b
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$1a = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6888)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M6 9L12 15L18 9",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1D = /* @__PURE__ */ defineComponent({
  __name: "IconShowIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$1a
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$19 = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_305_6081)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M15 8H17M15 12H17M7 16H17M6 4H18C19.6569 4 21 5.34315 21 7V17C21 18.6569 19.6569 20 18 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4ZM11 10C11 11.1046 10.1046 12 9 12C7.89543 12 7 11.1046 7 10C7 8.89543 7.89543 8 9 8C10.1046 8 11 8.89543 11 10Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1C = /* @__PURE__ */ defineComponent({
  __name: "IdentityIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$19
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$18 = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31584)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M3 7H4.948C6.861 7 8.653 7.933 9.75 9.5C10.2904 10.2721 11.0091 10.9025 11.8451 11.3377C12.681 11.7729 13.6096 12.0001 14.552 12H21M21 12L18 15M21 12L18 9M3 17H4.95C5.89187 17 6.81985 16.7728 7.65513 16.3375C8.49042 15.9023 9.20836 15.272 9.748 14.5C10.2876 13.728 11.0056 13.0977 11.8409 12.6625C12.6762 12.2272 13.6041 12 14.546 12H20",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1B = /* @__PURE__ */ defineComponent({
  __name: "JoinIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$18
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$17 = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_3254_2379)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M15 8H17M15 12H17M7 16H17M6 4H18C19.6569 4 21 5.34315 21 7V17C21 18.6569 19.6569 20 18 20H6C4.34315 20 3 18.6569 3 17V7C3 5.34315 4.34315 4 6 4ZM11 10C11 11.1046 10.1046 12 9 12C7.89543 12 7 11.1046 7 10C7 8.89543 7.89543 8 9 8C10.1046 8 11 8.89543 11 10Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1A = /* @__PURE__ */ defineComponent({
  __name: "LicenceIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$17
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$16 = /* @__PURE__ */ createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_8671_23877)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M9.00014 15L15.0001 9M11.0001 6L11.4631 5.464C12.4009 4.52633 13.6728 3.9996 14.999 3.99969C16.3252 3.99979 17.597 4.52669 18.5346 5.4645C19.4723 6.40231 19.999 7.67419 19.9989 9.00035C19.9989 10.3265 19.4719 11.5983 18.5341 12.536L18.0001 13M13.0001 18L12.6031 18.534C11.6544 19.4722 10.3739 19.9984 9.03964 19.9984C7.70535 19.9984 6.42489 19.4722 5.47614 18.534C5.0085 18.0716 4.63724 17.521 4.38385 16.9141C4.13047 16.3073 4 15.6562 4 14.9985C4 14.3409 4.13047 13.6897 4.38385 13.0829C4.63724 12.476 5.0085 11.9254 5.47614 11.463L6.00014 11",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "vector-effect": "non-scaling-stroke"
    })
  ])
], -1), _sfc_main$1z = /* @__PURE__ */ defineComponent({
  __name: "LinkIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$16
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$15 = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_3128_2462)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M15 8V6C15 5.46957 14.7893 4.96086 14.4142 4.58579C14.0391 4.21071 13.5304 4 13 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H13C13.5304 20 14.0391 19.7893 14.4142 19.4142C14.7893 19.0391 15 18.5304 15 18V16M9 12L22 12M22 12L19 15M22 12L19 9",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1y = /* @__PURE__ */ defineComponent({
  __name: "LogoutIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$15
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$14 = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6947)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M14 15V17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H6L3 21V11C3 10.7348 3.10536 10.4804 3.29289 10.2929C3.48043 10.1054 3.73478 10 4 10H6M21 14L18 11H11C10.7348 11 10.4804 10.8946 10.2929 10.7071C10.1054 10.5196 10 10.2652 10 10V4C10 3.73478 10.1054 3.48043 10.2929 3.29289C10.4804 3.10536 10.7348 3 11 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V14Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1x = /* @__PURE__ */ defineComponent({
  __name: "MessageIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$14
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$13 = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6940)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M10 6H7C6.46957 6 5.96086 6.21071 5.58579 6.58579C5.21071 6.96086 5 7.46957 5 8V17C5 17.5304 5.21071 18.0391 5.58579 18.4142C5.96086 18.7893 6.46957 19 7 19H16C16.5304 19 17.0391 18.7893 17.4142 18.4142C17.7893 18.0391 18 17.5304 18 17V14M20 7C20 8.65685 18.6569 10 17 10C15.3431 10 14 8.65685 14 7C14 5.34315 15.3431 4 17 4C18.6569 4 20 5.34315 20 7Z",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1w = /* @__PURE__ */ defineComponent({
  __name: "NotificationsIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$13
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$12 = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 36 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.4686 4.78357C11.4686 4.63901 11.6263 4.54702 11.7511 4.6193L31.2008 15.8489C31.3257 15.9212 31.3257 16.1051 31.2008 16.1774L11.7511 27.407C11.6263 27.4793 11.4686 27.3873 11.4686 27.2427V4.78357ZM15.0595 3.20329C14.9084 3.11458 14.9708 2.88131 15.145 2.88131H25.3692C25.5532 2.88131 25.724 2.97988 25.816 3.14086L30.8953 11.9786C30.984 12.1298 30.8131 12.3006 30.6587 12.2119L15.0563 3.20329H15.0595ZM8.58727 24.9725C8.58727 25.1499 8.354 25.2123 8.2653 25.0579L3.20575 16.2563C3.11376 16.0986 3.11376 15.9014 3.20575 15.7405L8.2653 6.93881C8.354 6.78768 8.58727 6.84682 8.58727 7.02423V24.9692V24.9725ZM30.8789 20.0575C30.9676 19.9064 30.7967 19.7355 30.6423 19.8242L15.0957 28.8C14.9446 28.8887 15.007 29.122 15.1811 29.122H25.3659C25.5499 29.122 25.7207 29.0234 25.8127 28.8624L30.8756 20.0608L30.8789 20.0575ZM36.0403 16.8575C36.3458 16.3253 36.3458 15.6747 36.0403 15.1425L27.83 0.864066C27.5244 0.331828 26.9528 0 26.3384 0H9.93101C9.31663 0 8.74497 0.328542 8.43943 0.864066L0.229158 15.1425C-0.076386 15.6747 -0.076386 16.3253 0.229158 16.8575L8.43943 31.1359C8.74497 31.6682 9.31663 32 9.93101 32H26.3384C26.9528 32 27.5244 31.6715 27.83 31.1359L36.0403 16.8575Z",
    fill: "currentColor",
    "vector-effect": "non-scaling-stroke",
    "fill-opacity": "0.9"
  })
], -1), _sfc_main$1v = /* @__PURE__ */ defineComponent({
  __name: "OctagonIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: e.size
    }, {
      default: withCtx(() => [
        _hoisted_1$12
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$11 = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1692_6893)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M13.5 6.50006L17.5 10.5001M4 20.0001H8L18.5 9.50006C19.0304 8.96963 19.3284 8.2502 19.3284 7.50006C19.3284 6.74991 19.0304 6.03049 18.5 5.50006C17.9696 4.96963 17.2501 4.67163 16.5 4.67163C15.7499 4.67163 15.0304 4.96963 14.5 5.50006L4 16.0001V20.0001Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1u = /* @__PURE__ */ defineComponent({
  __name: "PenIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$11
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$10 = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    d: "M10.5 3.50006L14.5 7.50006M1 17.0001H5L15.5 6.50006C16.0304 5.96963 16.3284 5.2502 16.3284 4.50006C16.3284 3.74991 16.0304 3.03049 15.5 2.50006C14.9696 1.96963 14.2501 1.67163 13.5 1.67163C12.7499 1.67163 12.0304 1.96963 11.5 2.50006L1 13.0001V17.0001Z",
    stroke: "currentcolor",
    "stroke-opacity": "0.9",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "vector-effect": "non-scaling-stroke"
  })
], -1), _sfc_main$1t = /* @__PURE__ */ defineComponent({
  __name: "PencilIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$10
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$$ = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    d: "M6 18L18 6M18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17ZM8 7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6C7.55228 6 8 6.44772 8 7Z",
    stroke: "currentColor",
    "stroke-opacity": "0.9",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "vector-effect": "non-scaling-stroke"
  })
], -1), _sfc_main$1s = /* @__PURE__ */ defineComponent({
  __name: "PercentIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$$
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$_ = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1339_6189)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "vector-effect": "non-scaling-stroke"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M17.657 16.6567L13.414 20.8997C13.039 21.2743 12.5306 21.4848 12.0005 21.4848C11.4704 21.4848 10.962 21.2743 10.587 20.8997L6.343 16.6567C5.22422 15.5379 4.46234 14.1124 4.15369 12.5606C3.84504 11.0087 4.00349 9.40022 4.60901 7.93844C5.21452 6.47665 6.2399 5.22725 7.55548 4.34821C8.87107 3.46918 10.4178 3 12 3C13.5822 3 15.1289 3.46918 16.4445 4.34821C17.7601 5.22725 18.7855 6.47665 19.391 7.93844C19.9965 9.40022 20.155 11.0087 19.8463 12.5606C19.5377 14.1124 18.7758 15.5379 17.657 16.6567Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "vector-effect": "non-scaling-stroke"
    })
  ])
], -1), _sfc_main$1r = /* @__PURE__ */ defineComponent({
  __name: "PinIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$_
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$Z = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6928)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12 5V19M5 12H19",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "vector-effect": "non-scaling-stroke"
    })
  ])
], -1), _sfc_main$1q = /* @__PURE__ */ defineComponent({
  __name: "PlusIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$Z
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$Y = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31604)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M14 8H11.5C11.1022 8 10.7206 8.15804 10.4393 8.43934C10.158 8.72064 10 9.10218 10 9.5C10 9.89782 10.158 10.2794 10.4393 10.5607C10.7206 10.842 11.1022 11 11.5 11H12.5C12.8978 11 13.2794 11.158 13.5607 11.4393C13.842 11.7206 14 12.1022 14 12.5C14 12.8978 13.842 13.2794 13.5607 13.5607C13.2794 13.842 12.8978 14 12.5 14H10M12 14V15.5M12 6.5V8M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21L16 19L14 21L12 19L10 21L8 19L5 21Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1p = /* @__PURE__ */ defineComponent({
  __name: "ReceiptIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$Y
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$X = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_3674_2527)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M4 12V9C4 8.20435 4.31607 7.44129 4.87868 6.87868C5.44129 6.31607 6.20435 6 7 6H20M20 6L17 3M20 6L17 9M20 12V15C20 15.7956 19.6839 16.5587 19.1213 17.1213C18.5587 17.6839 17.7956 18 17 18H4M4 18L7 21M4 18L7 15",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1o = /* @__PURE__ */ defineComponent({
  __name: "RecurringIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$X
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$W = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31627)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M7 20H17M6 6L12 5L18 6M6 6L9 12C9 12.7956 8.68393 13.5587 8.12132 14.1213C7.55871 14.6839 6.79565 15 6 15C5.20435 15 4.44129 14.6839 3.87868 14.1213C3.31607 13.5587 3 12.7956 3 12L6 6ZM18 6L21 12C21 12.7956 20.6839 13.5587 20.1213 14.1213C19.5587 14.6839 18.7956 15 18 15C17.2044 15 16.4413 14.6839 15.8787 14.1213C15.3161 13.5587 15 12.7956 15 12L18 6ZM12 3V20",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1n = /* @__PURE__ */ defineComponent({
  __name: "ScaleIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$W
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$V = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31228)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M14.5 9.5C14.5 9.5 14 8 12 8C10 8 9.5 9.33333 9.5 10C9.5 13 14.5 11 14.5 14C14.5 14.6667 14 16 12 16C10 16 9.5 14.5 9.5 14.5M6 20H18C19.6569 20 21 18.6569 21 17L21 7C21 5.34315 19.6569 4 18 4L6 4C4.34315 4 3 5.34315 3 7L3 17C3 18.6569 4.34315 20 6 20Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1m = /* @__PURE__ */ defineComponent({
  __name: "SellIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$V
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$U = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6930)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M10 14L21 3M10 14L13.5006 21C13.5444 21.0957 13.6149 21.1769 13.7035 21.2338C13.7921 21.2906 13.8952 21.3209 14.0006 21.3209C14.1059 21.3209 14.209 21.2906 14.2976 21.2338C14.3862 21.1769 14.4567 21.0957 14.5006 21L21 3M10 14L3.00056 10.5C2.90482 10.4561 2.82369 10.3857 2.7668 10.2971C2.70992 10.2084 2.67969 10.1053 2.67969 10C2.67969 9.89468 2.70992 9.79158 2.7668 9.70295C2.82369 9.61431 2.90482 9.54387 3.00056 9.5L21 3",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1l = /* @__PURE__ */ defineComponent({
  __name: "SendIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$U
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$T = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31243)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M21 17H15.603C14.7991 16.9999 14.007 16.806 13.294 16.4347C12.581 16.0634 11.968 15.5256 11.507 14.867L10.993 14.133C10.532 13.4744 9.91904 12.9366 9.20601 12.5653C8.49298 12.194 7.70092 12.0001 6.897 12H3H6.9C7.70427 11.9999 8.49664 11.8057 9.20987 11.4341C9.9231 11.0624 10.5362 10.5241 10.997 9.865L11.507 9.135C11.9679 8.47572 12.5812 7.93739 13.2946 7.56571C14.008 7.19402 14.8006 6.99996 15.605 7H21M21 17L18 20M21 17L18 14M21 7L18 10M21 7L18 4",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1k = /* @__PURE__ */ defineComponent({
  __name: "SplitIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$T
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$S = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6952)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12.0008 17.75L5.82881 20.995L7.00781 14.122L2.00781 9.25501L8.90781 8.25501L11.9938 2.00201L15.0798 8.25501L21.9798 9.25501L16.9798 14.122L18.1588 20.995L12.0008 17.75Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1j = /* @__PURE__ */ defineComponent({
  __name: "StarIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$S
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$R = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_6434_31584)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M3 17H5.397C6.20092 16.9999 6.99298 16.806 7.70601 16.4347C8.41904 16.0634 9.03203 15.5256 9.493 14.867L9.67 14.614M13.33 9.387L13.507 9.133C13.968 8.47437 14.581 7.9366 15.294 7.56528C16.007 7.19397 16.7991 7.00006 17.603 7H21M21 7L18 4M21 7L18 10M3 7H5.397C6.20092 7.00006 6.99298 7.19397 7.70601 7.56528C8.41904 7.9366 9.03203 8.47437 9.493 9.133L13.507 14.867C13.968 15.5256 14.581 16.0634 15.294 16.4347C16.007 16.806 16.7991 16.9999 17.603 17H21M21 17L18 20M21 17L18 14",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1i = /* @__PURE__ */ defineComponent({
  __name: "SwitchIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$R
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$Q = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: " 0 0 24 24",
  fill: " none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "vector-effect": "non-scaling-stroke",
    d: "M6.168 18.849C6.41551 18.0252 6.92197 17.3032 7.61225 16.79C8.30252 16.2768 9.13985 15.9997 10 16H14C14.8613 15.9997 15.6996 16.2774 16.3904 16.7918C17.0812 17.3062 17.5875 18.0298 17.834 18.855M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z",
    stroke: "currentColor",
    "stroke-opacity": "0.9",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), _sfc_main$1h = /* @__PURE__ */ defineComponent({
  __name: "UserCircleIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$Q
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$P = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6929)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M3 21V19C3 17.9391 3.42143 16.9217 4.17157 16.1716C4.92172 15.4214 5.93913 15 7 15H11C12.0609 15 13.0783 15.4214 13.8284 16.1716C14.5786 16.9217 15 17.9391 15 19V21M16 11H22M19 8V14M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1g = /* @__PURE__ */ defineComponent({
  __name: "UserPlusIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$P
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$O = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6465)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M17 8V5C17 4.73478 16.8946 4.48043 16.7071 4.29289C16.5196 4.10536 16.2652 4 16 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6M4 6C4 6.53043 4.21071 7.03914 4.58579 7.41421C4.96086 7.78929 5.46957 8 6 8H18C18.2652 8 18.5196 8.10536 18.7071 8.29289C18.8946 8.48043 19 8.73478 19 9V12M4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H18C18.2652 20 18.5196 19.8946 18.7071 19.7071C18.8946 19.5196 19 19.2652 19 19V16M20 12V16H16C15.4696 16 14.9609 15.7893 14.5858 15.4142C14.2107 15.0391 14 14.5304 14 14C14 13.4696 14.2107 12.9609 14.5858 12.5858C14.9609 12.2107 15.4696 12 16 12H20Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "vector-effect": "non-scaling-stroke",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1f = /* @__PURE__ */ defineComponent({
  __name: "WalletIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$O
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$N = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_4177_2718)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M3.6 9H20.4M3.6 15H20.4M11.5 3C9.81534 5.69961 8.9222 8.81787 8.9222 12C8.9222 15.1821 9.81534 18.3004 11.5 21M12.5 3C14.1847 5.69961 15.0778 8.81787 15.0778 12C15.0778 15.1821 14.1847 18.3004 12.5 21M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
      "vector-effect": "non-scaling-stroke",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1e = /* @__PURE__ */ defineComponent({
  __name: "WorldIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$N
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$M = /* @__PURE__ */ createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-circle-check-filled",
  viewBox: "0 0 24 24",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "vector-effect": "non-scaling-stroke",
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /* @__PURE__ */ createElementVNode("path", {
    "vector-effect": "non-scaling-stroke",
    d: "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
    fill: "currentColor"
  })
], -1), _sfc_main$1d = /* @__PURE__ */ defineComponent({
  __name: "CircleCheckFilledIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$M
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$L = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6843)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "vector-effect": "non-scaling-stroke",
      d: "M12.0293 3.00024C11.214 3.00024 10.4219 3.27203 9.77842 3.77261L4.44441 7.92062C4.00357 8.26344 3.64691 8.70247 3.40165 9.20419C3.15646 9.70576 3.02911 10.2569 3.0293 10.8152V18.015C3.0293 18.8107 3.34537 19.5737 3.90798 20.1363C4.47059 20.6989 5.23365 21.015 6.0293 21.015H18.0293C18.8249 21.015 19.588 20.6989 20.1506 20.1363C20.7132 19.5737 21.0293 18.8107 21.0293 18.015V10.815C21.0293 9.68362 20.5065 8.61491 19.6128 7.92033L14.2803 3.77273C13.6368 3.27207 12.8447 3.00024 12.0293 3.00024ZM16.5166 15.8563C16.9896 15.5711 17.1417 14.9565 16.8564 14.4835C16.5712 14.0106 15.9566 13.8585 15.4837 14.1437C14.5697 14.695 13.3111 14.9998 11.9994 14.9998C10.6877 14.9998 9.42976 14.695 8.51698 14.1439C8.04418 13.8585 7.4295 14.0104 7.14406 14.4832C6.85862 14.956 7.01051 15.5707 7.48332 15.8561C8.77854 16.6381 10.4156 16.9998 11.9994 16.9998C13.5832 16.9998 15.2206 16.638 16.5166 15.8563Z",
      fill: "currentColor",
      "fill-opacity": "0.9"
    })
  ])
], -1), _sfc_main$1c = /* @__PURE__ */ defineComponent({
  __name: "HomeFilledIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$L
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$K = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_3150_2382)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M11 2C10.4696 2 9.96086 2.21071 9.58579 2.58579C9.21071 2.96086 9 3.46957 9 4V10C9 10.5304 9.21071 11.0391 9.58579 11.4142C9.96086 11.7893 10.4696 12 11 12H17.5858L20.2929 14.7071C20.5789 14.9931 21.009 15.0787 21.3827 14.9239C21.7564 14.7691 22 14.4045 22 14V4C22 3.46957 21.7893 2.96086 21.4142 2.58579C21.0391 2.21071 20.5304 2 20 2H11Z",
      fill: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "fill-opacity": "0.9"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M6.5 9C7.05228 9 7.5 9.44772 7.5 10C7.5 10.9283 7.86875 11.8185 8.52513 12.4749C9.1815 13.1312 10.0717 13.5 11 13.5H14C14.5523 13.5 15 13.9477 15 14.5V17C15 17.5304 14.7893 18.0391 14.4142 18.4142C14.0391 18.7893 13.5304 19 13 19H6.41421L3.70711 21.7071C3.42111 21.9931 2.99099 22.0786 2.61732 21.9239C2.24364 21.7691 2 21.4044 2 21V11C2 10.4696 2.21071 9.96086 2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H6.5Z",
      fill: "currentColor",
      "fill-opacity": "0.9",
      "vector-effect": "non-scaling-stroke"
    })
  ])
], -1), _sfc_main$1b = /* @__PURE__ */ defineComponent({
  __name: "MessageFilledIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$K
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$J = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_2490_2163)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12.0008 17.75L5.82881 20.995L7.00781 14.122L2.00781 9.25501L8.90781 8.25501L11.9938 2.00201L15.0798 8.25501L21.9798 9.25501L16.9798 14.122L18.1588 20.995L12.0008 17.75Z",
      fill: "currentColor",
      "fill-opacity": "0.9",
      "vector-effect": "non-scaling-stroke"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M5.33601 20.9105C5.30383 21.0981 5.38094 21.2877 5.53492 21.3995C5.6889 21.5114 5.89303 21.5261 6.06149 21.4376L12.0005 18.315L17.9257 21.4374C18.0942 21.5261 18.2984 21.5115 18.4525 21.3997C18.6066 21.2878 18.6838 21.0981 18.6516 20.9105L17.5171 14.2968L22.3286 9.6133C22.465 9.48048 22.5142 9.28169 22.4554 9.10058C22.3966 8.91948 22.24 8.7875 22.0515 8.76018L15.4118 7.7979L12.4422 1.78073C12.358 1.61006 12.1841 1.50201 11.9938 1.50201C11.8035 1.50201 11.6297 1.61006 11.5454 1.78073L8.57583 7.7979L1.9361 8.76018C1.74765 8.7875 1.59107 8.91948 1.53226 9.10058C1.47345 9.28169 1.52261 9.48048 1.65906 9.6133L6.47053 14.2968L5.33601 20.9105Z",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$1a = /* @__PURE__ */ defineComponent({
  __name: "StarFilledIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$J
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$I = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_3145_2382)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12 3L8 10H16L12 3Z",
      fill: "currentColor",
      "fill-opacity": "0.9"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M17 20C18.6569 20 20 18.6569 20 17C20 15.3431 18.6569 14 17 14C15.3431 14 14 15.3431 14 17C14 18.6569 15.3431 20 17 20Z",
      fill: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "fill-opacity": "0.9"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M9 14H5C4.44772 14 4 14.4477 4 15V19C4 19.5523 4.44772 20 5 20H9C9.55228 20 10 19.5523 10 19V15C10 14.4477 9.55228 14 9 14Z",
      fill: "currentColor",
      "fill-opacity": "0.9",
      "vector-effect": "non-scaling-stroke"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M12 3L8 10H16L12 3Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M17 20C18.6569 20 20 18.6569 20 17C20 15.3431 18.6569 14 17 14C15.3431 14 14 15.3431 14 17C14 18.6569 15.3431 20 17 20Z",
      stroke: "currentColor",
      "vector-effect": "non-scaling-stroke",
      "stroke-opacity": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      d: "M9 14H5C4.44772 14 4 14.4477 4 15V19C4 19.5523 4.44772 20 5 20H9C9.55228 20 10 19.5523 10 19V15C10 14.4477 9.55228 14 9 14Z",
      stroke: "currentColor",
      "stroke-opacity": "0.9",
      "vector-effect": "non-scaling-stroke",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$19 = /* @__PURE__ */ defineComponent({
  __name: "TriangleSquareCircleFilledIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$I
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$H = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_3145_2386)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "vector-effect": "non-scaling-stroke",
      d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6.00723 17.849C6.26167 17.0252 6.78232 16.3032 7.49193 15.79C8.20154 15.2768 9.06232 14.9997 9.94657 15H14.0586C14.944 14.9997 15.8058 15.2774 16.516 15.7918C17.2261 16.3062 17.7466 17.0298 18 17.855C17.2002 18.57 14.881 20 12.0026 20C9.71197 20 7.61577 19.1903 6 17.849H6.00723ZM12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
      fill: "currentColor",
      "fill-opacity": "0.9"
    })
  ])
], -1), _sfc_main$18 = /* @__PURE__ */ defineComponent({
  __name: "UserCircleFilledIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$H
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$G = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1197_6464)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "vector-effect": "non-scaling-stroke",
      d: "M3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H16C16.5304 3 17.0391 3.21071 17.4142 3.58579C17.7893 3.96086 18 4.46957 18 5V7C18.5304 7 19.0391 7.21071 19.4142 7.58579C19.7893 7.96086 20 8.46957 20 9V11C20.5523 11 21 11.4477 21 12V16C21 16.5523 20.5523 17 20 17V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6C3 5.20435 3.31607 4.44129 3.87868 3.87868ZM14 14.0047C14.0014 14.4008 14.1768 14.7805 14.4882 15.0607C14.8007 15.342 15.2246 15.5 15.6667 15.5H19V12.5H15.6667C15.2246 12.5 14.8007 12.658 14.4882 12.9393C14.1756 13.2206 14 13.6022 14 14L14 14.0047ZM5 6C5 6.26522 5.10536 6.51957 5.29289 6.70711C5.48043 6.89464 5.73478 7 6 7H16L16 5L6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6Z",
      fill: "currentColor",
      "fill-opacity": "0.9"
    })
  ])
], -1), _sfc_main$17 = /* @__PURE__ */ defineComponent({
  __name: "WalletFilledIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$G
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$F = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "vector-effect": "non-scaling-stroke",
    d: "M18.613 7.67713L20.3541 10.3567C20.8021 11.0461 21.0303 11.8861 20.9968 12.7219C20.9703 13.3788 20.785 14.0225 20.4606 14.5834L19.3282 16.542C18.8856 17.3073 18.084 17.7828 17.2361 17.7828C17.2156 17.7828 17.1952 17.7825 17.1746 17.782L16.1321 17.7544C15.3525 17.7338 14.6617 17.2255 14.3721 16.4595L13.9556 15.358C13.9235 15.2729 13.851 15.2427 13.7938 15.2427C13.7452 15.2427 13.7001 15.2639 13.6668 15.3024L13.4201 15.5883C13.3251 15.6985 13.1898 15.7617 13.0491 15.7617C12.8688 15.7617 12.7012 15.6589 12.6119 15.4935L12.2448 14.8138C11.9961 14.3534 11.5304 14.0673 11.0292 14.0673C10.8773 14.0673 10.7268 14.0936 10.5819 14.1452L8.49632 14.8897C8.27617 14.9682 8.05739 15.0602 7.84609 15.1632L6.02207 16.0515C5.79122 16.1639 5.54535 16.2209 5.2912 16.2209C5.06075 16.2209 4.83593 16.1736 4.62301 16.0804C4.41427 15.989 4.25392 15.8064 4.18306 15.5795C4.11225 15.3525 4.13823 15.1048 4.25449 14.8998L4.30826 14.8049C4.43536 14.5809 4.45408 14.3034 4.35834 14.0624L3.1346 10.9839C2.77758 10.0857 3.1538 9.06446 3.99114 8.65891L6.27044 7.55482L8.33448 4.83463C8.52415 4.58461 8.80688 4.44124 9.11013 4.44124C9.2688 4.44124 9.42729 4.48229 9.56839 4.55991C9.66523 4.61322 9.77405 4.64136 9.88309 4.64136C10.0419 4.64136 10.1967 4.58228 10.3189 4.47502L11.6575 3.29979C11.8064 3.16904 11.995 3.09701 12.1886 3.09701C12.2886 3.09701 12.3867 3.11588 12.4804 3.15306L13.2254 3.44865C13.4411 3.53425 13.6151 3.71261 13.7026 3.93807C13.7902 4.16354 13.785 4.41971 13.6885 4.64103C13.5898 4.8672 13.6595 5.13288 13.8543 5.27285L14.8237 5.96952C14.9331 6.04812 15.0599 6.08973 15.1903 6.08973C15.4725 6.08973 15.7227 5.90009 15.8128 5.61773L16.6079 3.12674C16.6334 3.04664 16.7078 2.99506 16.7864 3.00037C16.8661 3.00601 16.9323 3.06766 16.9477 3.15059L17.2702 4.89497C17.2923 5.01462 17.4038 5.09723 17.5188 5.07547C17.5515 5.06937 17.5848 5.0663 17.6179 5.0663C17.8825 5.0663 18.1155 5.26506 18.172 5.53885L18.613 7.67713Z",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /* @__PURE__ */ createElementVNode("path", {
    "vector-effect": "non-scaling-stroke",
    d: "M15.6715 20.0019L16.5721 20.0703C16.7498 20.0837 16.9011 20.1859 16.9668 20.337C17.0325 20.488 16.9993 20.6568 16.8799 20.7776L15.7373 21.9341C15.6952 21.9765 15.6358 22 15.5746 22C15.5578 22 15.5409 21.9983 15.5241 21.9946C15.4462 21.9778 15.3847 21.9235 15.3636 21.8532L15.0222 20.713C14.971 20.5418 15.0094 20.3628 15.1275 20.222C15.2562 20.0683 15.4559 19.9861 15.6715 20.0019Z",
    fill: "currentColor"
  })
], -1), _sfc_main$16 = /* @__PURE__ */ defineComponent({
  __name: "AustralianEquitiesIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$F
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$E = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6448)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M17 9V7C17 6.46957 16.7893 5.96086 16.4142 5.58579C16.0391 5.21071 15.5304 5 15 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V13C3 13.5304 3.21071 14.0391 3.58579 14.4142C3.96086 14.7893 4.46957 15 5 15H7M9 9H19C20.1046 9 21 9.89543 21 11V17C21 18.1046 20.1046 19 19 19H9C7.89543 19 7 18.1046 7 17V11C7 9.89543 7.89543 9 9 9ZM16 14C16 15.1046 15.1046 16 14 16C12.8954 16 12 15.1046 12 14C12 12.8954 12.8954 12 14 12C15.1046 12 16 12.8954 16 14Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$15 = /* @__PURE__ */ defineComponent({
  __name: "CashIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$E
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$D = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6434)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M6.80005 11C6.27416 11.9122 5.99756 12.9467 5.99805 13.9996C5.99853 15.0525 6.27608 16.0867 6.80282 16.9984C7.32955 17.9101 8.08692 18.6671 8.99885 19.1934C9.91077 19.7197 10.9451 19.9968 11.998 19.9968C13.051 19.9968 14.0853 19.7197 14.9972 19.1934C15.9092 18.6671 16.6665 17.9101 17.1933 16.9984C17.72 16.0867 17.9976 15.0525 17.998 13.9996C17.9985 12.9467 17.7219 11.9122 17.196 11L11.999 3L6.79905 11H6.80005Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$14 = /* @__PURE__ */ defineComponent({
  __name: "CommoditiesIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$D
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$C = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6437)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M6 10L3 13L6 16L9 13M10 6L13 3L16 6L13 9M12 12L13.5 13.5M14.5 17C15.163 17 15.7989 16.7366 16.2678 16.2678C16.7366 15.7989 17 15.163 17 14.5M15 21C16.5913 21 18.1174 20.3679 19.2426 19.2426C20.3679 18.1174 21 16.5913 21 15M3.707 6.293L6.293 3.707C6.48053 3.51953 6.73484 3.41421 7 3.41421C7.26516 3.41421 7.51947 3.51953 7.707 3.707L13.293 9.293C13.4805 9.48053 13.5858 9.73484 13.5858 10C13.5858 10.2652 13.4805 10.5195 13.293 10.707L10.707 13.293C10.5195 13.4805 10.2652 13.5858 10 13.5858C9.73484 13.5858 9.48053 13.4805 9.293 13.293L3.707 7.707C3.51953 7.51947 3.41421 7.26516 3.41421 7C3.41421 6.73484 3.51953 6.48053 3.707 6.293Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$13 = /* @__PURE__ */ defineComponent({
  __name: "CommunicationServicesIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$C
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$B = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1359_6905)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M3 11H21M15 19V17C15 16.2044 14.6839 15.4413 14.1213 14.8787C13.5587 14.3161 12.7956 14 12 14C11.2044 14 10.4413 14.3161 9.87868 14.8787C9.31607 15.4413 9 16.2044 9 17V19C9 19.2652 8.89464 19.5196 8.70711 19.7071C8.51957 19.8946 8.26522 20 8 20H4C3.73478 20 3.48043 19.8946 3.29289 19.7071C3.10536 19.5196 3 19.2652 3 19V5H7V8H10V5H14V8H17V5H21V19C21 19.2652 20.8946 19.5196 20.7071 19.7071C20.5196 19.8946 20.2652 20 20 20H16C15.7348 20 15.4804 19.8946 15.2929 19.7071C15.1054 19.5196 15 19.2652 15 19Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$12 = /* @__PURE__ */ defineComponent({
  __name: "ConservativeIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$B
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$A = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6432)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M4 15V18C4 19.1046 4.89543 20 6 20H7C8.10457 20 9 19.1046 9 18V15C9 13.8954 8.10457 13 7 13H6C4.89543 13 4 13.8954 4 15ZM4 15V12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12V15M20 15C20 13.8954 19.1046 13 18 13H17C15.8954 13 15 13.8954 15 15V18C15 19.1046 15.8954 20 17 20H18C19.1046 20 20 19.1046 20 18V15Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$11 = /* @__PURE__ */ defineComponent({
  __name: "ConsumerDiscretionaryIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$A
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$z = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6445)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M6 17C4.89543 17 4 17.8954 4 19C4 20.1046 4.89543 21 6 21C7.10457 21 8 20.1046 8 19C8 17.8954 7.10457 17 6 17ZM6 17H17M6 17V3H4M17 17C15.8954 17 15 17.8954 15 19C15 20.1046 15.8954 21 17 21C18.1046 21 19 20.1046 19 19C19 17.8954 18.1046 17 17 17ZM6 5L20 6L19 13H6",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$10 = /* @__PURE__ */ defineComponent({
  __name: "ConsumerStaplesIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$z
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$y = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "vector-effect": "non-scaling-stroke",
    d: "M11.5251 10C11.0051 9.54495 10.401 9.23209 9.75759 9.08875C8.92866 8.90407 8.07144 9.00902 7.29343 9.39043C6.51542 9.77184 5.85124 10.4127 5.38418 11.2328C4.91712 12.0528 4.66797 13.0154 4.66797 14C4.66797 14.9846 4.91712 15.9472 5.38418 16.7672C5.85124 17.5873 6.51542 18.2282 7.29343 18.6096C8.07144 18.991 8.92866 19.0959 9.75759 18.9112C10.401 18.7679 11.0051 18.455 11.5251 18M14 14.5H20M3 15.5H9M14 11.5H20M3 12.5H9M16.9993 16.5V10M16.9993 10L13 5M16.9993 10L21 5",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), _sfc_main$$ = /* @__PURE__ */ defineComponent({
  __name: "CurrencyIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$y
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$x = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6433)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M13 3V10H19L11 21V14H5L13 3Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$_ = /* @__PURE__ */ defineComponent({
  __name: "EnergyIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$x
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$w = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6438)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M3 21H21M3 10H21M5 6L12 3L19 6M4 10V21M20 10V21M8 14V17M12 14V17M16 14V17",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$Z = /* @__PURE__ */ defineComponent({
  __name: "FinancialsIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$w
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$v = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6449)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M21 6C21 7.65685 18.7614 9 16 9C13.2386 9 11 7.65685 11 6M21 6C21 4.34315 18.7614 3 16 3C13.2386 3 11 4.34315 11 6M21 6V10M11 6V10M11 10C11 11.657 13.239 13 16 13C18.761 13 21 11.657 21 10M11 10V14M21 10V14M11 14C11 15.657 13.239 17 16 17C18.761 17 21 15.657 21 14M11 14V18C11 19.657 13.239 21 16 21C18.761 21 21 19.657 21 18V14M7 9H4.5C4.10218 9 3.72064 9.15804 3.43934 9.43934C3.15804 9.72064 3 10.1022 3 10.5C3 10.8978 3.15804 11.2794 3.43934 11.5607C3.72064 11.842 4.10218 12 4.5 12H5.5C5.89782 12 6.27936 12.158 6.56066 12.4393C6.84196 12.7206 7 13.1022 7 13.5C7 13.8978 6.84196 14.2794 6.56066 14.5607C6.27936 14.842 5.89782 15 5.5 15H3M5 15V16M5 8V9",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$Y = /* @__PURE__ */ defineComponent({
  __name: "FixedIncomeIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$v
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$u = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6442)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M19.4995 13.572L11.9995 21L9.10349 18.132M2.98649 10.028C2.97813 8.97338 3.30348 7.94311 3.916 7.08453C4.52853 6.22596 5.39687 5.58306 6.39683 5.24778C7.39679 4.9125 8.47717 4.90201 9.48345 5.2178C10.4897 5.5336 11.3704 6.15951 11.9995 7.00603C12.413 6.45605 12.9356 5.99735 13.5346 5.65863C14.1335 5.31992 14.796 5.10848 15.4804 5.03755C16.1649 4.96662 16.8566 5.03773 17.5123 5.24642C18.168 5.45511 18.7735 5.7969 19.291 6.25039C19.8086 6.70388 20.2269 7.25931 20.5199 7.88192C20.8129 8.50453 20.9742 9.18091 20.9938 9.86874C21.0134 10.5566 20.8907 11.241 20.6336 11.8793C20.3765 12.5175 19.9904 13.0958 19.4995 13.578M3 13H5L7 16L9 10L10 13H13",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$X = /* @__PURE__ */ defineComponent({
  __name: "HealthCareIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$u
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$t = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6447)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M4 21C5.147 16.98 5.983 12.973 6 8.99998H12C12.017 12.973 12.853 16.98 14 21M12.5 13H17C17.025 15.612 17.894 18.296 19 21M9 4.99998C9.22717 4.68348 9.52797 4.42705 9.87642 4.25283C10.2249 4.0786 10.6105 3.99182 11 3.99998C11.3895 3.99182 11.7751 4.0786 12.1236 4.25283C12.472 4.42705 12.7728 4.68348 13 4.99998C13.2272 5.31647 13.528 5.5729 13.8764 5.74713C14.2249 5.92136 14.6105 6.00814 15 5.99998C15.3895 6.00814 15.7751 5.92136 16.1236 5.74713C16.472 5.5729 16.7728 5.31647 17 4.99998C17.2272 4.68348 17.528 4.42705 17.8764 4.25283C18.2249 4.0786 18.6105 3.99182 19 3.99998C19.3895 3.99182 19.7751 4.0786 20.1236 4.25283C20.472 4.42705 20.7728 4.68348 21 4.99998M3 21H22",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$W = /* @__PURE__ */ defineComponent({
  __name: "IndustrialsIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$t
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$s = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6435)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M6.75 16C7.59393 16.733 8.58187 17.2814 9.65035 17.61C10.7188 17.9385 11.8442 18.0399 12.9542 17.9076C14.0642 17.7754 15.1342 17.4124 16.0956 16.842C17.057 16.2716 17.8884 15.5065 18.5365 14.5957C19.1845 13.6849 19.6349 12.6486 19.8587 11.5533C20.0825 10.4581 20.0747 9.32822 19.8358 8.2362C19.5969 7.14418 19.1323 6.1142 18.4717 5.21243C17.8111 4.31066 16.9692 3.55705 16 3M12 18V22M8 22H16M16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$V = /* @__PURE__ */ defineComponent({
  __name: "InternationalEquitiesIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$s
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$r = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6446)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M3 21H21M9 8H10M9 12H10M9 16H10M14 8H15M14 12H15M14 16H15M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "ListedPropertyIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$r
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$q = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6443)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M4 19C5.10457 19 6 18.1046 6 17C6 15.8954 5.10457 15 4 15M4 19C2.89543 19 2 18.1046 2 17C2 15.8954 2.89543 15 4 15M4 19H13M4 15H13M13 19C14.1046 19 15 18.1046 15 17C15 15.8954 14.1046 15 13 15M13 19C11.8954 19 11 18.1046 11 17C11 15.8954 11.8954 15 13 15M13 15V10M8 12V7H10C10.7956 7 11.5587 7.31607 12.1213 7.87868C12.6839 8.44129 13 9.20435 13 10M13 10L18 5L21.12 9.88M5 15V13C5 12.7348 5.10536 12.4804 5.29289 12.2929C5.48043 12.1054 5.73478 12 6 12H13M21.12 9.88C21.539 10.2995 21.8252 10.8339 21.9407 11.4155C22.0563 11.9971 21.9969 12.5998 21.77 13.1477C21.5432 13.6956 21.1591 14.1639 20.6662 14.4936C20.1733 14.8233 19.5938 14.9995 19.0009 15C18.2055 14.9993 17.4429 14.6828 16.8809 14.12L21.12 9.88Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$T = /* @__PURE__ */ defineComponent({
  __name: "MaterialsIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$q
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$p = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6444)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M8.848 14.667L5.5 17.5M12 3V8M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12M12 3C16.9706 3 21 7.02944 21 12M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12M12 8C14.2091 8 16 9.79086 16 12M16 12H21M14.2188 15.328L16.9998 19.5",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$S = /* @__PURE__ */ defineComponent({
  __name: "MutiAssetIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$p
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$o = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6431)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M13 21V14L8 9L3 14V21H8M13 21H8M13 21H21V4C21 3.73478 20.8946 3.48043 20.7071 3.29289C20.5196 3.10536 20.2652 3 20 3H10C9.73478 3 9.48043 3.10536 9.29289 3.29289C9.10536 3.48043 9 3.73478 9 4V10M8 21V17M13 7V7.01M17 7V7.01M17 11V11.01M17 15V15.01",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$R = /* @__PURE__ */ defineComponent({
  __name: "RealEstateIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$o
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$n = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    "vector-effect": "non-scaling-stroke",
    d: "M4 20H20M4 4L8.5 10L14 8L20 16",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), _sfc_main$Q = /* @__PURE__ */ defineComponent({
  __name: "ShortIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$n
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$m = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6441)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M3 10H5M3 14H5M10 3V5M14 3V5M21 10H19M21 14H19M14 21V19M10 21V19M6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6C5 5.44772 5.44772 5 6 5ZM9 9H15V15H9V9Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "TechnologyIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$m
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$l = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_1364_6436)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      "vector-effect": "non-scaling-stroke",
      d: "M9 3V7M15 3V7M12 16V18C12 18.5304 12.2107 19.0391 12.5858 19.4142C12.9609 19.7893 13.4696 20 14 20H17M7 7H17V13C17 13.7956 16.6839 14.5587 16.1213 15.1213C15.5587 15.6839 14.7956 16 14 16H10C9.20435 16 8.44129 15.6839 7.87868 15.1213C7.31607 14.5587 7 13.7956 7 13V7Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1), _sfc_main$O = /* @__PURE__ */ defineComponent({
  __name: "UtilitiesIcon",
  props: {
    tone: null,
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      tone: t.tone,
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$l
      ]),
      _: 1
    }, 8, ["tone", "size"]));
  }
}), _hoisted_1$k = /* @__PURE__ */ createElementVNode("svg", {
  viewBox: "0 0 184 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ createElementVNode("g", { "clip-path": "url(#clip0_8613_924)" }, [
    /* @__PURE__ */ createElementVNode("path", {
      d: "M18.5115 38.4428C28.681 38.4428 36.925 30.1876 36.925 20.0043C36.925 9.82092 28.681 1.5657 18.5115 1.5657C8.34196 1.5657 0.0979614 9.82092 0.0979614 20.0043C0.0979614 30.1876 8.34196 38.4428 18.5115 38.4428Z",
      fill: "#FC4D16"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.1958 12.7307C14.1958 12.6369 14.2979 12.5773 14.3787 12.6242L26.9706 19.9042C27.0514 19.951 27.0514 20.0703 26.9706 20.1171L14.3787 27.3971C14.3601 27.4077 14.339 27.4132 14.3176 27.4131C14.2962 27.413 14.2752 27.4072 14.2567 27.3965C14.2382 27.3857 14.2229 27.3703 14.2122 27.3517C14.2015 27.3331 14.1958 27.3121 14.1958 27.2907V12.7307ZM16.5206 11.7062C16.4228 11.6487 16.4632 11.4974 16.5759 11.4974H23.1952C23.3143 11.4974 23.4249 11.5613 23.4844 11.6657L26.7728 17.3951C26.8302 17.4931 26.7196 17.6039 26.6196 17.5464L16.5185 11.7062H16.5206ZM12.3304 25.8189C12.3304 25.9339 12.1794 25.9744 12.122 25.8743L8.84636 20.1683C8.78681 20.066 8.78681 19.9382 8.84636 19.8339L12.122 14.1279C12.1794 14.0299 12.3304 14.0682 12.3304 14.1832V25.8168V25.8189ZM26.7621 22.6326C26.8196 22.5346 26.709 22.4238 26.609 22.4813L16.544 28.3002C16.4462 28.3577 16.4866 28.509 16.5993 28.509H23.193C23.3121 28.509 23.4227 28.4451 23.4823 28.3407L26.76 22.6347L26.7621 22.6326ZM30.1037 20.558C30.3015 20.213 30.3015 19.7913 30.1037 19.4462L24.7883 10.1897C24.6905 10.0197 24.5498 9.87846 24.3803 9.78014C24.2108 9.68182 24.0185 9.62987 23.8226 9.62952H13.2003C12.8026 9.62952 12.4325 9.84251 12.2347 10.1897L6.91929 19.4462C6.72148 19.7913 6.72148 20.213 6.91929 20.558L12.2347 29.8146C12.3324 29.9846 12.4731 30.1258 12.6426 30.2241C12.8121 30.3224 13.0045 30.3744 13.2003 30.3747H23.8226C24.2204 30.3747 24.5905 30.1618 24.7883 29.8146L30.1037 20.558Z",
      fill: "white"
    }),
    /* @__PURE__ */ createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M46.9132 23.346C46.9132 20.9094 48.7105 18.9734 51.2693 18.9734C53.8281 18.9734 55.6254 20.9094 55.6254 23.346C55.6254 25.7827 53.7983 27.7486 51.2693 27.7486C48.7403 27.7486 46.9132 25.7827 46.9132 23.346ZM52.0308 30.7709C56.1742 30.7709 59.0074 27.4844 59.0074 23.346C59.0074 19.2077 56.1742 15.951 52.0308 15.951C50.0208 15.951 48.0405 16.8605 47.0047 18.475V9.87656H43.6227V30.4173H46.8218V27.8934C47.7959 29.7421 49.9293 30.7688 52.0308 30.7688V30.7709ZM63.4613 21.6719C63.9803 19.7934 65.3799 18.6198 67.4516 18.6198C69.5233 18.6198 70.9867 19.7934 71.4738 21.6719H63.4613ZM67.6962 30.8561C70.6825 30.8561 73.303 29.5952 74.6132 26.7773V26.7177C73.6986 26.7773 72.3288 26.1596 71.7801 25.427L71.7503 25.4568C71.2015 26.9243 69.7403 28.0105 67.76 28.0105C65.3842 28.0105 63.5868 26.5132 63.2805 24.0787H74.7047C75.2535 19.6485 72.3288 15.8616 67.4835 15.8616C63.187 15.8616 60.0794 19.2077 60.0794 23.3439C60.0794 27.4802 63.2486 30.8561 67.6962 30.8561ZM75.4236 19.2077H77.4039V30.4173H80.8177V19.2077H82.9809V16.2726H80.8177V11.7509H77.4039V16.2726H75.4236V19.2077ZM86.9818 23.346C86.9818 20.9094 88.7791 18.9734 91.3379 18.9734C93.8967 18.9734 95.7259 20.9393 95.7259 23.346C95.7259 25.7528 93.9286 27.7486 91.3379 27.7486C88.7472 27.7486 86.9818 25.7827 86.9818 23.346ZM90.6083 30.7411C92.5886 30.7411 94.7517 29.772 95.7259 27.953V30.4173H99.0164V16.2726H95.7259V18.7369C94.7517 16.918 92.5886 15.9489 90.6083 15.9489C86.4351 15.9489 83.5998 19.2353 83.5998 23.3439C83.5998 27.4525 86.433 30.7389 90.6083 30.7389V30.7411ZM106.761 30.8582C110.113 30.8582 112.397 28.805 112.397 26.1341C112.397 23.4632 110.264 22.2896 108.009 21.8487L106.637 21.5846C105.419 21.3205 104.504 20.9968 104.504 20.0596C104.504 19.2375 105.295 18.475 106.546 18.475C107.918 18.475 108.984 19.1501 109.317 20.5878H109.347C109.926 19.9126 111.298 19.3844 112.21 19.5016L112.24 19.4718C111.691 17.476 109.711 15.8339 106.633 15.8339C103.555 15.8339 101.209 17.8296 101.209 20.2364C101.209 22.4089 102.673 23.6996 105.627 24.3152L107.059 24.6091C108.186 24.8732 109.069 25.2246 109.069 26.2534C109.069 27.2821 108.277 28.1021 106.784 28.1021C104.957 28.1021 103.647 26.9285 103.402 25.461L103.372 25.4312C102.794 26.1064 101.422 26.6048 100.51 26.4877L100.48 26.5175C101.029 29.1585 103.466 30.8603 106.757 30.8603L106.761 30.8582ZM114.042 30.4173H117.424V22.3769C117.424 20.3237 118.887 18.9734 120.897 18.9734C122.907 18.9734 124.187 20.2641 124.187 22.2598V30.4173H127.569V21.0564C127.569 18.0639 125.193 15.9212 122.054 15.9212C120.195 15.9212 118.368 16.7434 117.424 18.4153V9.87656H114.042V30.4173ZM132.572 23.346C132.572 20.9094 134.369 18.9734 136.928 18.9734C139.487 18.9734 141.316 20.9393 141.316 23.346C141.316 25.7528 139.519 27.7486 136.928 27.7486C134.337 27.7486 132.572 25.7827 132.572 23.346ZM136.199 30.7411C138.179 30.7411 140.342 29.772 141.316 27.953V30.4173H144.607V16.2726H141.316V18.7369C140.342 16.918 138.179 15.9489 136.199 15.9489C132.025 15.9489 129.19 19.2353 129.19 23.3439C129.19 27.4525 132.023 30.7389 136.199 30.7389V30.7411ZM147.263 20.1469V30.4173H150.645V24.1384C150.645 21.6741 151.407 19.3844 153.874 19.3844C154.606 19.3844 155.246 19.5612 155.58 19.8253H155.61C155.639 18.9159 156.433 17.5953 157.224 17.0969V17.0373C156.675 16.4217 155.701 16.0405 154.391 16.0405C152.532 16.0405 151.222 17.1566 150.552 18.6816V16.2748H147.261V20.1491L147.263 20.1469ZM159.664 21.6719C160.181 19.7934 161.582 18.6198 163.654 18.6198C165.726 18.6198 167.189 19.7934 167.676 21.6719H159.664ZM163.899 30.8561C166.885 30.8561 169.505 29.5952 170.816 26.7773V26.7177C169.901 26.7773 168.531 26.1596 167.982 25.427L167.953 25.4568C167.404 26.9243 165.943 28.0105 163.962 28.0105C161.587 28.0105 159.789 26.5132 159.483 24.0787H170.907C171.456 19.6485 168.531 15.8616 163.686 15.8616C159.389 15.8616 156.282 19.2077 156.282 23.3439C156.282 27.4802 159.451 30.8561 163.899 30.8561ZM178.043 30.8582C181.395 30.8582 183.68 28.805 183.68 26.1341C183.68 23.4632 181.546 22.2896 179.292 21.8487L177.92 21.5846C176.701 21.3205 175.786 20.9968 175.786 20.0596C175.786 19.2375 176.578 18.475 177.828 18.475C179.2 18.475 180.266 19.1501 180.6 20.5878H180.63C181.208 19.9126 182.58 19.3844 183.493 19.5016L183.522 19.4718C182.974 17.476 180.993 15.8339 177.916 15.8339C174.838 15.8339 172.492 17.8296 172.492 20.2364C172.492 22.4089 173.955 23.6996 176.91 24.3152L178.341 24.6091C179.468 24.8732 180.351 25.2246 180.351 26.2534C180.351 27.2821 179.56 28.1021 178.067 28.1021C176.239 28.1021 174.929 26.9285 174.685 25.461L174.655 25.4312C174.076 26.1064 172.704 26.6048 171.792 26.4877L171.762 26.5175C172.311 29.1585 174.748 30.8603 178.039 30.8603L178.043 30.8582Z",
      fill: "black"
    })
  ])
], -1), _sfc_main$N = /* @__PURE__ */ defineComponent({
  __name: "LogoWordmarkIcon",
  props: {
    size: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createBlock(_sfc_main$2D, {
      size: t.size
    }, {
      default: withCtx(() => [
        _hoisted_1$k
      ]),
      _: 1
    }, 8, ["size"]));
  }
});
var commonjsGlobal$1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, parseExports = {}, parse$3 = {
  get exports() {
    return parseExports;
  },
  set exports(e) {
    parseExports = e;
  }
};
(function(e, t) {
  (function(n, s) {
    e.exports = s();
  })(commonjsGlobal$1, () => {
    return n = { 705: (i) => {
      i.exports = function(a, o) {
        const l = [];
        return o.length === 0 ? l.push({ text: a, highlight: !1 }) : o[0][0] > 0 && l.push({ text: a.slice(0, o[0][0]), highlight: !1 }), o.forEach((c, u) => {
          const d = c[0], p = c[1];
          l.push({ text: a.slice(d, p), highlight: !0 }), u === o.length - 1 ? p < a.length && l.push({ text: a.slice(p, a.length), highlight: !1 }) : p < o[u + 1][0] && l.push({ text: a.slice(p, o[u + 1][0]), highlight: !1 });
        }), l;
      };
    } }, s = {}, function i(a) {
      var o = s[a];
      if (o !== void 0)
        return o.exports;
      var l = s[a] = { exports: {} };
      return n[a](l, l.exports, i), l.exports;
    }(705);
    var n, s;
  });
})(parse$3);
const parse$2 = parseExports, _sfc_main$M = /* @__PURE__ */ defineComponent({
  __name: "Strong",
  props: {
    tone: { default: void 0 }
  },
  setup(e) {
    const t = e, n = () => classMerge({
      ...t.tone && mapToneToTextClasses(t.tone)
    });
    return (s, i) => (openBlock(), createElementBlock("span", {
      class: normalizeClass(["text-bold font-bold", n()])
    }, [
      renderSlot(s.$slots, "default")
    ], 2));
  }
}), HIGHLIGHT_KIND = {
  LABEL: "label",
  VALUE: "value"
}, DEFAULT_DEBOUNCE_TIMEOUT_MS = 250, DATA_TEST_ID$7 = {
  CONTAINER: "autoSuggest_container",
  INPUT: "autoSuggest_input",
  ICON_LEFT: "autoSuggest_iconLeft",
  LIST: "autoSuggest_list",
  OPTION: "autoSuggest_option",
  NO_SUGGESTIONS_MESSAGE: "autoSuggest_noSuggestionsMessage",
  LOADING_MESSAGE: "autoSuggest_loadingMessage"
}, _sfc_main$L = /* @__PURE__ */ defineComponent({
  __name: "TextWithHighlight",
  props: {
    label: null,
    match: { type: Boolean },
    highlights: null,
    isActive: { type: Boolean, default: !1 },
    maxLines: { default: "none" }
  },
  setup(e) {
    const t = e, n = computed(
      () => parse$2(
        t.label,
        t.highlights.filter((s) => s.kind === HIGHLIGHT_KIND.LABEL).map(({ start: s, end: i }) => [s, i])
      )
    );
    return (s, i) => (openBlock(), createBlock(_sfc_main$2J, {
      tone: e.isActive ? "high-emphasis" : "medium-emphasis",
      "max-lines": e.maxLines
    }, {
      default: withCtx(() => [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(n), (a, o) => (openBlock(), createElementBlock(Fragment, { key: o }, [
          a.highlight ? (openBlock(), createBlock(_sfc_main$M, { key: 0 }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(a.text), 1)
            ]),
            _: 2
          }, 1024)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(a.text), 1)
          ], 64))
        ], 64))), 128))
      ]),
      _: 1
    }, 8, ["tone", "max-lines"]));
  }
}), vForwardRef = {
  mounted(e, t) {
    t.value(e);
  },
  unmounted(e, t) {
    t.value(null);
  }
};
var matchExports = {}, match$3 = {
  get exports() {
    return matchExports;
  },
  set exports(e) {
    matchExports = e;
  }
};
(function(e, t) {
  (function(n, s) {
    e.exports = s();
  })(commonjsGlobal$1, () => {
    return n = { 772: (i, a, o) => {
      const l = o(826).remove, c = /[.*+?^${}()|[\]\\]/g, u = /[a-z0-9_]/i, d = /\s+/;
      i.exports = function(p, f, g) {
        var C, k;
        k = { insideWords: !1, findAllOccurrences: !1, requireMatchAll: !1 }, C = (C = g) || {}, Object.keys(C).forEach((S) => {
          k[S] = !!C[S];
        }), g = k;
        const M = Array.from(p).map((S) => l(S));
        let _ = M.join("");
        return (f = l(f)).trim().split(d).filter((S) => S.length > 0).reduce((S, E) => {
          const P = E.length, $ = !g.insideWords && u.test(E[0]) ? "\\b" : "", A = new RegExp($ + E.replace(c, "\\$&"), "i");
          let I, D;
          if (I = A.exec(_), g.requireMatchAll && I === null)
            return _ = "", [];
          for (; I; ) {
            D = I.index;
            const R = P - M.slice(D, D + P).join("").length, Y = D - M.slice(0, D).join("").length, q = [D + Y, D + P + Y + R];
            if (q[0] !== q[1] && S.push(q), _ = _.slice(0, D) + new Array(P + 1).join(" ") + _.slice(D + P), !g.findAllOccurrences)
              break;
            I = A.exec(_);
          }
          return S;
        }, []).sort((S, E) => S[0] - E[0]);
      };
    }, 826: (i) => {
      var a = { À: "A", Á: "A", Â: "A", Ã: "A", Ä: "A", Å: "A", Ấ: "A", Ắ: "A", Ẳ: "A", Ẵ: "A", Ặ: "A", Æ: "AE", Ầ: "A", Ằ: "A", Ȃ: "A", Ç: "C", Ḉ: "C", È: "E", É: "E", Ê: "E", Ë: "E", Ế: "E", Ḗ: "E", Ề: "E", Ḕ: "E", Ḝ: "E", Ȇ: "E", Ì: "I", Í: "I", Î: "I", Ï: "I", Ḯ: "I", Ȋ: "I", Ð: "D", Ñ: "N", Ò: "O", Ó: "O", Ô: "O", Õ: "O", Ö: "O", Ø: "O", Ố: "O", Ṍ: "O", Ṓ: "O", Ȏ: "O", Ù: "U", Ú: "U", Û: "U", Ü: "U", Ý: "Y", à: "a", á: "a", â: "a", ã: "a", ä: "a", å: "a", ấ: "a", ắ: "a", ẳ: "a", ẵ: "a", ặ: "a", æ: "ae", ầ: "a", ằ: "a", ȃ: "a", ç: "c", ḉ: "c", è: "e", é: "e", ê: "e", ë: "e", ế: "e", ḗ: "e", ề: "e", ḕ: "e", ḝ: "e", ȇ: "e", ì: "i", í: "i", î: "i", ï: "i", ḯ: "i", ȋ: "i", ð: "d", ñ: "n", ò: "o", ó: "o", ô: "o", õ: "o", ö: "o", ø: "o", ố: "o", ṍ: "o", ṓ: "o", ȏ: "o", ù: "u", ú: "u", û: "u", ü: "u", ý: "y", ÿ: "y", Ā: "A", ā: "a", Ă: "A", ă: "a", Ą: "A", ą: "a", Ć: "C", ć: "c", Ĉ: "C", ĉ: "c", Ċ: "C", ċ: "c", Č: "C", č: "c", C̆: "C", c̆: "c", Ď: "D", ď: "d", Đ: "D", đ: "d", Ē: "E", ē: "e", Ĕ: "E", ĕ: "e", Ė: "E", ė: "e", Ę: "E", ę: "e", Ě: "E", ě: "e", Ĝ: "G", Ǵ: "G", ĝ: "g", ǵ: "g", Ğ: "G", ğ: "g", Ġ: "G", ġ: "g", Ģ: "G", ģ: "g", Ĥ: "H", ĥ: "h", Ħ: "H", ħ: "h", Ḫ: "H", ḫ: "h", Ĩ: "I", ĩ: "i", Ī: "I", ī: "i", Ĭ: "I", ĭ: "i", Į: "I", į: "i", İ: "I", ı: "i", Ĳ: "IJ", ĳ: "ij", Ĵ: "J", ĵ: "j", Ķ: "K", ķ: "k", Ḱ: "K", ḱ: "k", K̆: "K", k̆: "k", Ĺ: "L", ĺ: "l", Ļ: "L", ļ: "l", Ľ: "L", ľ: "l", Ŀ: "L", ŀ: "l", Ł: "l", ł: "l", Ḿ: "M", ḿ: "m", M̆: "M", m̆: "m", Ń: "N", ń: "n", Ņ: "N", ņ: "n", Ň: "N", ň: "n", ŉ: "n", N̆: "N", n̆: "n", Ō: "O", ō: "o", Ŏ: "O", ŏ: "o", Ő: "O", ő: "o", Œ: "OE", œ: "oe", P̆: "P", p̆: "p", Ŕ: "R", ŕ: "r", Ŗ: "R", ŗ: "r", Ř: "R", ř: "r", R̆: "R", r̆: "r", Ȓ: "R", ȓ: "r", Ś: "S", ś: "s", Ŝ: "S", ŝ: "s", Ş: "S", Ș: "S", ș: "s", ş: "s", Š: "S", š: "s", Ţ: "T", ţ: "t", ț: "t", Ț: "T", Ť: "T", ť: "t", Ŧ: "T", ŧ: "t", T̆: "T", t̆: "t", Ũ: "U", ũ: "u", Ū: "U", ū: "u", Ŭ: "U", ŭ: "u", Ů: "U", ů: "u", Ű: "U", ű: "u", Ų: "U", ų: "u", Ȗ: "U", ȗ: "u", V̆: "V", v̆: "v", Ŵ: "W", ŵ: "w", Ẃ: "W", ẃ: "w", X̆: "X", x̆: "x", Ŷ: "Y", ŷ: "y", Ÿ: "Y", Y̆: "Y", y̆: "y", Ź: "Z", ź: "z", Ż: "Z", ż: "z", Ž: "Z", ž: "z", ſ: "s", ƒ: "f", Ơ: "O", ơ: "o", Ư: "U", ư: "u", Ǎ: "A", ǎ: "a", Ǐ: "I", ǐ: "i", Ǒ: "O", ǒ: "o", Ǔ: "U", ǔ: "u", Ǖ: "U", ǖ: "u", Ǘ: "U", ǘ: "u", Ǚ: "U", ǚ: "u", Ǜ: "U", ǜ: "u", Ứ: "U", ứ: "u", Ṹ: "U", ṹ: "u", Ǻ: "A", ǻ: "a", Ǽ: "AE", ǽ: "ae", Ǿ: "O", ǿ: "o", Þ: "TH", þ: "th", Ṕ: "P", ṕ: "p", Ṥ: "S", ṥ: "s", X́: "X", x́: "x", Ѓ: "Г", ѓ: "г", Ќ: "К", ќ: "к", A̋: "A", a̋: "a", E̋: "E", e̋: "e", I̋: "I", i̋: "i", Ǹ: "N", ǹ: "n", Ồ: "O", ồ: "o", Ṑ: "O", ṑ: "o", Ừ: "U", ừ: "u", Ẁ: "W", ẁ: "w", Ỳ: "Y", ỳ: "y", Ȁ: "A", ȁ: "a", Ȅ: "E", ȅ: "e", Ȉ: "I", ȉ: "i", Ȍ: "O", ȍ: "o", Ȑ: "R", ȑ: "r", Ȕ: "U", ȕ: "u", B̌: "B", b̌: "b", Č̣: "C", č̣: "c", Ê̌: "E", ê̌: "e", F̌: "F", f̌: "f", Ǧ: "G", ǧ: "g", Ȟ: "H", ȟ: "h", J̌: "J", ǰ: "j", Ǩ: "K", ǩ: "k", M̌: "M", m̌: "m", P̌: "P", p̌: "p", Q̌: "Q", q̌: "q", Ř̩: "R", ř̩: "r", Ṧ: "S", ṧ: "s", V̌: "V", v̌: "v", W̌: "W", w̌: "w", X̌: "X", x̌: "x", Y̌: "Y", y̌: "y", A̧: "A", a̧: "a", B̧: "B", b̧: "b", Ḑ: "D", ḑ: "d", Ȩ: "E", ȩ: "e", Ɛ̧: "E", ɛ̧: "e", Ḩ: "H", ḩ: "h", I̧: "I", i̧: "i", Ɨ̧: "I", ɨ̧: "i", M̧: "M", m̧: "m", O̧: "O", o̧: "o", Q̧: "Q", q̧: "q", U̧: "U", u̧: "u", X̧: "X", x̧: "x", Z̧: "Z", z̧: "z" }, o = Object.keys(a).join("|"), l = new RegExp(o, "g"), c = new RegExp(o, ""), u = function(d) {
        return d.replace(l, function(p) {
          return a[p];
        });
      };
      i.exports = u, i.exports.has = function(d) {
        return !!d.match(c);
      }, i.exports.remove = u;
    } }, s = {}, function i(a) {
      var o = s[a];
      if (o !== void 0)
        return o.exports;
      var l = s[a] = { exports: {} };
      return n[a](l, l.exports, i), l.exports;
    }(772);
    var n, s;
  });
})(match$3);
const match$2 = matchExports, DEFAULT_OPTIONS$1 = {
  insideWords: !0
}, mapMatchesToHighlights = (e, t) => e.map(([n, s]) => ({ start: n, end: s, kind: t })), createSuggestionsMatcher = (e = {}) => {
  const t = {
    ...DEFAULT_OPTIONS$1,
    ...e
  };
  return (n, s) => {
    const i = s.trim();
    if (i === "")
      return n.map((o) => ({
        ...o,
        match: !1,
        highlights: []
      }));
    const a = [];
    for (const o of n) {
      const l = mapMatchesToHighlights(
        match$2(o.label, i, t),
        HIGHLIGHT_KIND.LABEL
      ), c = mapMatchesToHighlights(
        t.matchLabelsAndValues && o.value ? match$2(o.value.toString(), i, t) : [],
        HIGHLIGHT_KIND.VALUE
      ), u = l.concat(c);
      a.push({
        ...o,
        match: Boolean(u.length),
        highlights: u
      });
    }
    return a;
  };
}, _hoisted_1$j = ["data-testid", "for"], _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "AutoSuggest",
  props: {
    id: null,
    label: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    tone: { default: "primary" },
    modelValue: { default: void 0 },
    borderRadius: { default: "lg" },
    dropdownBorderRadius: { default: "lg" },
    border: { default: "solid" },
    placeholder: { default: void 0 },
    description: { default: void 0 },
    message: { default: void 0 },
    suggestions: { default: void 0 },
    suggestionsLimit: { default: void 0 },
    noSuggestionsMessage: { default: void 0 },
    autoFocus: { type: Boolean, default: !1 },
    hideChevron: { type: Boolean, default: !1 },
    showOverlay: { type: Boolean, default: !1 },
    truncateText: { type: Boolean, default: !1 },
    debounceTimeoutMs: { default: DEFAULT_DEBOUNCE_TIMEOUT_MS },
    matchOptions: { default: void 0 },
    variant: { default: void 0 },
    onFetchSuggestions: { type: Function, default: void 0 },
    joined: { default: void 0 }
  },
  emits: [
    "onEscape",
    "onChange",
    "onInputChange",
    "onFetchSuggestions",
    "onOpenDropdown",
    "onCloseDropdown",
    "onSuggestionsBottomClick",
    "update:modelValue"
  ],
  setup(e, { emit: t }) {
    const n = e, s = ref(), i = ref(), a = computed(() => n.modelValue || ""), o = ref(n.suggestions || []), l = ref(!1), c = ref(!1), u = ref(!1), d = ref(a.value), p = createSuggestionsMatcher(n.matchOptions), f = computed(() => {
      const z = p(o.value, d.value);
      return d.value.length > 0 ? z.filter(({ match: K }) => K) : z;
    }), g = useSlots(), C = computed(
      () => l.value && (f.value.length || d.value || g["suggestions-footer"])
    ), k = computed(
      () => (n.noSuggestionsMessage || g["no-suggestions-message"]) && !f.value.length && !u.value
    ), M = refDebounced(d, n.debounceTimeoutMs), _ = (z) => {
      const K = o.value.find(
        (Z) => Z.label === z.label
      ) || null;
      K && (t("onChange", K), t("update:modelValue", K.label)), l.value = !1, c.value = !1;
    }, S = (z) => {
      const K = z.target.value || "";
      t("onInputChange", K), d.value = K, K.length > 0 && (l.value = !0);
    };
    watch(M, async (z) => {
      n.onFetchSuggestions && l.value && (z.length > 0 ? (u.value = !0, o.value = await n.onFetchSuggestions(z), u.value = !1) : o.value = [...n.suggestions || []]);
    }), watch(l, () => {
      t(l.value ? "onOpenDropdown" : "onCloseDropdown"), !l.value && !a.value && (o.value = n.suggestions || []);
    });
    const E = () => {
      d.value = "", i.value.value = "", o.value = [...n.suggestions || []], t("onChange", ""), t("onInputChange", ""), t("update:modelValue", "");
    }, P = () => {
      a.value && t("onFetchSuggestions", a.value), c.value = !0;
    }, $ = () => {
      t("onSuggestionsBottomClick"), l.value = !1, c.value = !1;
    }, A = () => {
      l.value || (l.value = !0);
    }, I = () => {
      d.value = a.value, i.value.value = a.value, l.value = !1, c.value = !1;
    };
    onClickOutside(s, () => {
      I();
    });
    const D = (z) => z.target === i.value && z.composedPath().includes(i.value);
    onKeyDown("Enter", (z) => {
      z.preventDefault(), D(z) && (l.value = !l.value);
    }), onKeyDown("Escape", (z) => {
      D(z) && (l.value = !1, t("onEscape"));
    }), onKeyDown("Tab", (z) => {
      D(z) && (l.value && (I(), l.value = !1), c.value = !1);
    }), onKeyUp("Tab", (z) => {
      D(z) && !l.value && c.value && (l.value = !0);
    });
    const R = (z) => a.value === z.label, Y = () => classMerge("transition-all", {
      ...mapToneToFormFieldFocusRingClasses$1({
        tone: n.tone,
        focused: c.value,
        disabled: n.disabled
      }),
      ...n.borderRadius && mapBorderRadiusToClassName(n.borderRadius),
      ...n.border && mapBorderToBorderClassName(n.border),
      ...n.joined && mapJoinedToClasses(n.joined)
    }), q = () => classMerge({
      ["h-screen fixed left-0 right-0 mt-[1.1rem]"]: n.variant === "full-screen",
      ["absolute mt-1.5"]: !n.variant
    }), j = () => classMerge("w-full z-10", q(), {
      ...n.dropdownBorderRadius && mapBorderRadiusToClassName(n.dropdownBorderRadius)
    }), X = () => classMerge({
      ["max-h-[60rem]"]: n.variant === "full-screen",
      ["max-h-64"]: !n.variant
    }), ee = () => n.disabled ? "disabled" : n.tone === "error" ? "error" : "medium-emphasis", G = () => classMerge({
      "text-black-20": n.disabled,
      ...mapDisabledToCursorClasses(n.disabled)
    }), H = () => classMerge("transition-transform", {
      "rotate-180": l.value
    }), F = (z) => classMerge("cursor-pointer transition-colors ease-out select-none", {
      "bg-white hover:bg-grey-40": !z,
      "bg-grey-80 hover:bg-grey-80": z
    }), B = () => classMerge("relative", {
      "z-50": c.value || l.value,
      "z-auto": !c.value && !l.value
    });
    return onMounted(() => {
      n.autoFocus && i.value.focus();
    }), (z, K) => (openBlock(), createBlock(_sfc_main$2K, null, {
      default: withCtx(() => [
        withDirectives((openBlock(), createBlock(_sfc_main$2H, {
          class: normalizeClass(B()),
          space: "2xs",
          "data-testid": unref(DATA_TEST_ID$7).CONTAINER,
          onFocusin: P,
          onClick: A
        }, {
          default: withCtx(() => [
            e.label ? (openBlock(), createBlock(_sfc_main$2q, {
              key: 0,
              forId: e.id,
              tone: e.tone,
              disabled: e.disabled
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(e.label), 1)
              ]),
              _: 1
            }, 8, ["forId", "tone", "disabled"])) : createCommentVNode("", !0),
            createVNode(_sfc_main$2K, { class: "relative" }, {
              default: withCtx(() => [
                createVNode(_sfc_main$2K, {
                  tone: "base",
                  class: normalizeClass(Y()),
                  "padding-x": "md"
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2F, {
                      space: "xs",
                      "vertical-align": "center"
                    }, {
                      default: withCtx(() => [
                        z.$slots["icon-left"] ? (openBlock(), createBlock(_sfc_main$2E, {
                          key: 0,
                          width: "content"
                        }, {
                          default: withCtx(() => [
                            createElementVNode("label", {
                              class: "select-none",
                              "data-testid": unref(DATA_TEST_ID$7).ICON_LEFT,
                              for: e.id
                            }, [
                              renderSlot(z.$slots, "icon-left", {
                                tone: e.disabled ? "disabled" : "medium-emphasis"
                              })
                            ], 8, _hoisted_1$j)
                          ]),
                          _: 3
                        })) : createCommentVNode("", !0),
                        createVNode(_sfc_main$2E, null, {
                          default: withCtx(() => [
                            withDirectives(createVNode(_sfc_main$2K, {
                              component: "input",
                              id: e.id,
                              placeholder: e.placeholder,
                              disabled: e.disabled,
                              class: normalizeClass([G(), "w-full py-3 border-none bg-transparent !outline-none"]),
                              value: unref(a),
                              "data-testid": unref(DATA_TEST_ID$7).INPUT,
                              onInput: S,
                              autocomplete: "off"
                            }, null, 8, ["id", "placeholder", "disabled", "class", "value", "data-testid"]), [
                              [unref(vForwardRef), (Z) => i.value = Z]
                            ])
                          ]),
                          _: 1
                        }),
                        u.value ? (openBlock(), createBlock(_sfc_main$2E, {
                          key: 1,
                          width: "content"
                        }, {
                          default: withCtx(() => [
                            createVNode(unref(_sfc_main$2i), {
                              size: "sm",
                              tone: "low-emphasis"
                            })
                          ]),
                          _: 1
                        })) : createCommentVNode("", !0),
                        unref(a).length > 0 || d.value.length > 0 ? (openBlock(), createBlock(_sfc_main$2E, {
                          key: 2,
                          width: "content"
                        }, {
                          default: withCtx(() => [
                            createVNode(_sfc_main$2K, {
                              onClick: withModifiers(E, ["stop"]),
                              role: "button"
                            }, {
                              default: withCtx(() => [
                                createVNode(unref(_sfc_main$2p), {
                                  size: "sm",
                                  tone: "low-emphasis"
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })) : createCommentVNode("", !0),
                        e.hideChevron ? createCommentVNode("", !0) : (openBlock(), createBlock(_sfc_main$2E, {
                          key: 3,
                          width: "content"
                        }, {
                          default: withCtx(() => [
                            createVNode(unref(_sfc_main$2C), {
                              class: normalizeClass(H()),
                              tone: e.disabled ? "disabled" : "medium-emphasis"
                            }, null, 8, ["class", "tone"])
                          ]),
                          _: 1
                        }))
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["class"]),
                withDirectives(createVNode(_sfc_main$2K, {
                  class: normalizeClass(j()),
                  "box-shadow": "lg",
                  padding: "xs",
                  tone: "base"
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2H, { space: "2xs" }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$2K, {
                          class: normalizeClass(["overflow-y-auto scroll-smooth overscroll-contain", X()])
                        }, {
                          default: withCtx(() => [
                            createVNode(_sfc_main$2H, null, {
                              default: withCtx(() => [
                                unref(k) ? (openBlock(), createBlock(_sfc_main$2K, {
                                  key: 0,
                                  "padding-x": "md",
                                  "padding-y": "xs",
                                  "data-testid": unref(DATA_TEST_ID$7).NO_SUGGESTIONS_MESSAGE
                                }, {
                                  default: withCtx(() => [
                                    Boolean(e.noSuggestionsMessage) ? (openBlock(), createBlock(_sfc_main$2J, {
                                      key: 0,
                                      tone: "medium-emphasis"
                                    }, {
                                      default: withCtx(() => [
                                        createTextVNode(toDisplayString(e.noSuggestionsMessage), 1)
                                      ]),
                                      _: 1
                                    })) : renderSlot(z.$slots, "no-suggestions-message", { key: 1 })
                                  ]),
                                  _: 3
                                }, 8, ["data-testid"])) : createCommentVNode("", !0),
                                u.value ? (openBlock(), createBlock(_sfc_main$2K, {
                                  key: 1,
                                  "padding-x": "md",
                                  "padding-y": "xs",
                                  "data-testid": unref(DATA_TEST_ID$7).LOADING_MESSAGE
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_sfc_main$2J, { tone: "medium-emphasis" }, {
                                      default: withCtx(() => [
                                        createTextVNode("Searching... ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data-testid"])) : createCommentVNode("", !0),
                                createVNode(_sfc_main$2H, { space: "2xs" }, {
                                  default: withCtx(() => [
                                    (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(f).slice(
                                      0,
                                      e.suggestionsLimit || unref(f).length
                                    ), (Z, re) => (openBlock(), createBlock(_sfc_main$2K, {
                                      component: "ul",
                                      key: re,
                                      "data-testid": unref(DATA_TEST_ID$7).LIST
                                    }, {
                                      default: withCtx(() => [
                                        createVNode(_sfc_main$2K, {
                                          component: "li",
                                          "padding-x": "xs",
                                          "padding-y": "xs",
                                          "border-radius": "lg",
                                          "data-testid": unref(DATA_TEST_ID$7).OPTION,
                                          class: normalizeClass(F(R(Z))),
                                          onClick: withModifiers(() => _(Z), ["stop"])
                                        }, {
                                          default: withCtx(() => [
                                            renderSlot(z.$slots, "suggestion", {
                                              suggestion: {
                                                ...Z,
                                                isActive: R(Z),
                                                maxLines: e.truncateText ? "1" : "none"
                                              },
                                              renderText: _sfc_main$L
                                            }, () => [
                                              createVNode(_sfc_main$L, mergeProps(Z, {
                                                "is-active": R(Z)
                                              }), null, 16, ["is-active"])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["data-testid", "class", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["data-testid"]))), 128))
                                  ]),
                                  _: 3
                                })
                              ]),
                              _: 3
                            })
                          ]),
                          _: 3
                        }, 8, ["class"]),
                        z.$slots["suggestions-footer"] ? (openBlock(), createBlock(_sfc_main$2K, {
                          key: 0,
                          onClick: withModifiers($, ["stop"])
                        }, {
                          default: withCtx(() => [
                            renderSlot(z.$slots, "suggestions-footer")
                          ]),
                          _: 3
                        }, 8, ["onClick"])) : createCommentVNode("", !0)
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["class"]), [
                  [vShow, unref(C)]
                ])
              ]),
              _: 3
            }),
            e.description ? (openBlock(), createBlock(_sfc_main$2J, {
              key: 1,
              size: "sm",
              tone: ee()
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(e.description), 1)
              ]),
              _: 1
            }, 8, ["tone"])) : createCommentVNode("", !0),
            e.message ? (openBlock(), createBlock(_sfc_main$2J, {
              key: 2,
              size: "sm",
              tone: ee()
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(e.message), 1)
              ]),
              _: 1
            }, 8, ["tone"])) : createCommentVNode("", !0)
          ]),
          _: 3
        }, 8, ["class", "data-testid"])), [
          [unref(vForwardRef), (Z) => s.value = Z]
        ]),
        createVNode(_sfc_main$2t, {
          "is-visible": !!(e.showOverlay && l.value)
        }, null, 8, ["is-visible"])
      ]),
      _: 3
    }));
  }
}), mapVariantToFieldClasses = (e) => ({
  "px-4": e === "primary",
  "px-3 bg-brand-background": e === "secondary"
}), mapVariantToInputClasses = (e) => ({
  "py-3": e === "primary",
  "py-1.5 text-base": e === "secondary"
}), mapToneToFormFieldFocusRingClasses = ({
  tone: e,
  variant: t,
  focused: n,
  disabled: s
}) => ({
  "border-red-300": e === "error" && !n && s,
  "border-red-300 hover:ring-1 ring-red-300": e === "error" && !n && !s,
  "ring-2 ring-red-300 border-transparent": e === "error" && n,
  ...t === "primary" && e === "primary" && {
    "border-grey-200": e === "primary" && !n && s,
    "border-grey-200 hover:ring-1 ring-grey-300": e === "primary" && !n && !s,
    "ring-2 ring-grey-900 border-transparent": n
  },
  ...t === "secondary" && e === "primary" && {
    "border-transparent": !n && s,
    "border-transparent hover:ring-1 ring-grey-300": !n && !s,
    "ring-2 ring-grey-900 border-transparent": n
  }
}), DATA_TEST_ID$6 = {
  CONTAINER: "dropdown_container",
  LABEL: "dropdown_label",
  INPUT: "dropdown_input",
  LIST_CONTAINER: "dropdown_list-container",
  LIST: "dropdown_list",
  OPTION: "dropdown_option",
  STYLED_FIELD: "dropdown_styled-field",
  DESCRIPTION: "dropdown_description",
  MESSAGE: "dropdown_message",
  ICON_LEFT: "dropdown_icon-left",
  ICON_RIGHT: "dropdown_icon-right",
  OPTIONS_FOOTER: "dropdown_options-footer"
}, _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "Dropdown",
  props: {
    id: null,
    variant: { default: "primary" },
    label: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    tone: { default: "primary" },
    modelValue: { default: void 0 },
    borderRadius: { default: "lg" },
    dropdownBorderRadius: { default: "lg" },
    border: { default: "solid" },
    placeholder: { default: void 0 },
    description: { default: void 0 },
    message: { default: void 0 },
    options: { default: void 0 },
    autoFocus: { type: Boolean, default: !1 },
    hideChevron: { type: Boolean, default: !1 },
    joined: { default: void 0 },
    outerContainerRef: { default: void 0 }
  },
  emits: ["onChange", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, s = ref(), i = ref(), a = computed(() => {
      var A;
      return ((A = n.modelValue) == null ? void 0 : A.label) || "";
    }), o = ref(!1), l = ref(!1), c = (A) => {
      const I = (n.options || []).find(
        (D) => D.label === A.label
      ) || null;
      I && (t("onChange", I), t("update:modelValue", I)), o.value = !1;
    }, u = () => {
      n.disabled || (l.value = !0);
    }, d = () => {
      o.value = !1, l.value = !1;
    }, p = () => {
      !n.disabled && !o.value && (o.value = !0, l.value = !0);
    };
    onClickOutside(s, () => {
      (o.value || l.value) && d();
    });
    const f = (A) => A.target === i.value && A.composedPath().includes(i.value);
    onKeyDown("Enter", (A) => {
      A.preventDefault(), f(A) && (o.value = !o.value);
    }), onKeyDown("Escape", (A) => {
      f(A) && (o.value = !1);
    }), onKeyDown("Tab", (A) => {
      f(A) && (o.value && (d(), o.value = !1), l.value = !1);
    });
    const g = (A) => a.value === A.label, C = () => classMerge("transition-all", {
      ...mapToneToFormFieldFocusRingClasses({
        tone: n.tone,
        variant: n.variant,
        focused: l.value,
        disabled: n.disabled
      }),
      ...n.borderRadius && mapBorderRadiusToClassName(n.borderRadius),
      ...n.border && mapBorderToBorderClassName(n.border),
      ...n.joined && mapJoinedToClasses(n.joined),
      ...n.variant && mapVariantToFieldClasses(n.variant)
    }), k = () => classMerge({
      ...n.dropdownBorderRadius && mapBorderRadiusToClassName(n.dropdownBorderRadius),
      "w-full": !n.outerContainerRef
    }), M = () => n.disabled ? "disabled" : n.tone === "error" ? "error" : "medium-emphasis", _ = () => classMerge({
      "text-black-20": n.disabled,
      ...mapDisabledToCursorClasses(n.disabled),
      ...n.variant && mapVariantToInputClasses(n.variant)
    }), S = () => classMerge("select-none", {
      ...mapDisabledToCursorClasses(n.disabled)
    }), E = () => classMerge("transition-transform", {
      "rotate-180": o.value
    }), P = (A) => classMerge({
      "bg-white hover:bg-grey-40": !A,
      "bg-grey-80 hover:bg-grey-80": A
    }), $ = () => classMerge("relative", {
      "z-50": l.value,
      "z-auto": !l.value,
      "cursor-pointer": !n.disabled
    });
    return onMounted(() => {
      n.autoFocus && i.value.focus();
    }), (A, I) => (openBlock(), createBlock(_sfc_main$2K, { onClick: p }, {
      default: withCtx(() => [
        withDirectives((openBlock(), createBlock(_sfc_main$2H, {
          class: normalizeClass($()),
          space: "2xs",
          "data-testid": unref(DATA_TEST_ID$6).CONTAINER
        }, {
          default: withCtx(() => [
            e.label ? (openBlock(), createBlock(_sfc_main$2J, {
              key: 0,
              for: e.id,
              tone: M(),
              class: normalizeClass([S(), "select-none"]),
              component: "label",
              size: "sm",
              "data-testid": unref(DATA_TEST_ID$6).LABEL
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(e.label), 1)
              ]),
              _: 1
            }, 8, ["for", "tone", "class", "data-testid"])) : createCommentVNode("", !0),
            createVNode(_sfc_main$2K, { class: "relative" }, {
              default: withCtx(() => [
                createVNode(_sfc_main$2K, {
                  tone: "base",
                  class: normalizeClass(C()),
                  "data-testid": unref(DATA_TEST_ID$6).STYLED_FIELD
                }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2F, {
                      space: "xs",
                      "vertical-align": "center"
                    }, {
                      default: withCtx(() => [
                        A.$slots["icon-left"] ? (openBlock(), createBlock(_sfc_main$2E, {
                          key: 0,
                          width: "content"
                        }, {
                          default: withCtx(() => [
                            createVNode(_sfc_main$2K, {
                              class: "select-none",
                              "data-testid": unref(DATA_TEST_ID$6).ICON_LEFT
                            }, {
                              default: withCtx(() => [
                                renderSlot(A.$slots, "icon-left", {
                                  tone: e.disabled ? "disabled" : "medium-emphasis"
                                })
                              ]),
                              _: 3
                            }, 8, ["data-testid"])
                          ]),
                          _: 3
                        })) : createCommentVNode("", !0),
                        createVNode(_sfc_main$2E, null, {
                          default: withCtx(() => [
                            withDirectives(createVNode(_sfc_main$2K, {
                              component: "input",
                              id: e.id,
                              placeholder: e.placeholder,
                              disabled: e.disabled,
                              class: normalizeClass([_(), "w-full border-none bg-transparent !outline-none cursor-pointer"]),
                              value: unref(a),
                              "data-testid": unref(DATA_TEST_ID$6).INPUT,
                              onFocus: u,
                              readonly: "readonly"
                            }, null, 8, ["id", "placeholder", "disabled", "class", "value", "data-testid"]), [
                              [unref(vForwardRef), (D) => i.value = D]
                            ])
                          ]),
                          _: 1
                        }),
                        e.hideChevron ? createCommentVNode("", !0) : (openBlock(), createBlock(_sfc_main$2E, {
                          key: 1,
                          width: "content"
                        }, {
                          default: withCtx(() => [
                            createVNode(_sfc_main$2C, {
                              class: normalizeClass(E()),
                              tone: e.disabled ? "disabled" : "medium-emphasis"
                            }, null, 8, ["class", "tone"])
                          ]),
                          _: 1
                        }))
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                }, 8, ["class", "data-testid"]),
                o.value ? (openBlock(), createBlock(_sfc_main$2K, mergeProps({
                  key: 0,
                  class: ["absolute z-10 mt-1.5", k()],
                  "data-testid": unref(DATA_TEST_ID$6).LIST_CONTAINER
                }, {
                  ...e.outerContainerRef && {
                    style: {
                      width: `${e.outerContainerRef.getBoundingClientRect().width}px`
                    }
                  }
                }, {
                  "box-shadow": "lg",
                  padding: "xs",
                  tone: "base"
                }), {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2K, { class: "overflow-y-auto scroll-smooth overscroll-contain max-h-64" }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$2H, {
                          space: "2xs",
                          "data-testid": unref(DATA_TEST_ID$6).LIST
                        }, {
                          default: withCtx(() => [
                            (openBlock(!0), createElementBlock(Fragment, null, renderList(e.options || [], (D, R) => (openBlock(), createBlock(_sfc_main$2K, {
                              component: "ul",
                              key: R
                            }, {
                              default: withCtx(() => [
                                createVNode(_sfc_main$2K, {
                                  class: normalizeClass(["transition-colors ease-out cursor-pointer select-none", P(g(D))]),
                                  component: "li",
                                  "padding-x": "sm",
                                  "padding-y": "xs",
                                  "border-radius": "md",
                                  "data-testid": unref(DATA_TEST_ID$6).OPTION,
                                  onClick: withModifiers(() => c(D), ["stop"])
                                }, {
                                  default: withCtx(() => [
                                    renderSlot(A.$slots, "suggestion", {
                                      suggestion: {
                                        ...D,
                                        isActive: g(D)
                                      }
                                    }, () => [
                                      createVNode(_sfc_main$2J, {
                                        tone: g(D) ? "high-emphasis" : "medium-emphasis",
                                        size: n.variant === "primary" ? "lg" : "md"
                                      }, {
                                        default: withCtx(() => [
                                          createTextVNode(toDisplayString(D.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["tone", "size"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["data-testid", "class", "onClick"])
                              ]),
                              _: 2
                            }, 1024))), 128))
                          ]),
                          _: 3
                        }, 8, ["data-testid"])
                      ]),
                      _: 3
                    }),
                    A.$slots["options-footer"] ? (openBlock(), createBlock(_sfc_main$2K, {
                      key: 0,
                      padding: "sm",
                      "data-testid": unref(DATA_TEST_ID$6).OPTIONS_FOOTER,
                      onClick: I[0] || (I[0] = withModifiers(() => {
                      }, ["stop"]))
                    }, {
                      default: withCtx(() => [
                        renderSlot(A.$slots, "options-footer", normalizeProps(guardReactiveProps({ onClose: d })))
                      ]),
                      _: 3
                    }, 8, ["data-testid"])) : createCommentVNode("", !0)
                  ]),
                  _: 3
                }, 16, ["class", "data-testid"])) : createCommentVNode("", !0)
              ]),
              _: 3
            }),
            e.description ? (openBlock(), createBlock(_sfc_main$2J, {
              key: 1,
              size: "sm",
              tone: M(),
              "data-testid": unref(DATA_TEST_ID$6).DESCRIPTION
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(e.description), 1)
              ]),
              _: 1
            }, 8, ["tone", "data-testid"])) : createCommentVNode("", !0),
            e.message ? (openBlock(), createBlock(_sfc_main$2J, {
              key: 2,
              size: "sm",
              tone: M(),
              "data-testid": unref(DATA_TEST_ID$6).MESSAGE
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(e.message), 1)
              ]),
              _: 1
            }, 8, ["tone", "data-testid"])) : createCommentVNode("", !0)
          ]),
          _: 3
        }, 8, ["class", "data-testid"])), [
          [unref(vForwardRef), (D) => s.value = D]
        ])
      ]),
      _: 3
    }));
  }
}), _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "Heading",
  props: {
    component: { default: "h1" },
    variant: { default: "title" },
    size: { default: "xl" },
    tone: { default: "high-emphasis" },
    align: { default: "left" },
    maxLines: { default: void 0 }
  },
  setup(e) {
    const t = e, n = useMediaMatch(), s = useResponsiveProp(t.align, n), i = useResponsiveProp(
      t.maxLines,
      n
    ), a = (l, c) => l === "display" ? mapSizeToDisplayHeadingClasses(c) : mapSizeToTitleHeadingClasses(c), o = () => classMerge({
      ...t.size && t.variant && a(t.variant, t.size),
      ...t.tone && mapToneToTextClasses(t.tone),
      ...i.value && mapMaxLinesToLineClampClasses(i.value),
      ...s.value && mapAlignToTextClasses(s.value)
    });
    return (l, c) => (openBlock(), createBlock(resolveDynamicComponent(e.component), {
      class: normalizeClass(o())
    }, {
      default: withCtx(() => [
        renderSlot(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "Link",
  props: {
    href: { default: "javascript:void(0);" },
    tone: { default: "primary" },
    underline: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = () => classMerge({
      ...t.tone && mapToneToTextClasses(t.tone),
      underline: t.underline,
      "no-underline": !t.underline
    });
    return (s, i) => (openBlock(), createBlock(_sfc_main$2K, {
      component: "a",
      href: e.href,
      class: normalizeClass(n())
    }, {
      default: withCtx(() => [
        renderSlot(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["href", "class"]));
  }
});
function strictlyInject(e, t) {
  const n = inject(e, t);
  if (typeof n > "u")
    throw new Error(`Could not resolve ${e.description}`);
  return n;
}
const TabsKey = Symbol("tabs"), _sfc_main$G = /* @__PURE__ */ defineComponent({
  __name: "TabsProvider",
  props: {
    id: null,
    activeTab: { default: void 0 },
    textSize: { default: "md" },
    tone: { default: "base" },
    variant: null
  },
  emits: ["onChange"],
  setup(e, { emit: t }) {
    var o;
    const n = e, s = useSlots(), i = computed(() => n.activeTab), a = (((o = s.default) == null ? void 0 : o.call(s)) || []).filter(({ type: l }) => l.name === "TabPanel").map(({ props: l }) => l == null ? void 0 : l.name);
    return provide(TabsKey, {
      panels: a,
      tone: n.tone || "base",
      textSize: n.textSize || "md",
      selectedTab: i,
      onTabSelected: (l) => {
        t("onChange", l);
      },
      variant: n.variant
    }), (l, c) => (openBlock(), createBlock(_sfc_main$2K, null, {
      default: withCtx(() => [
        renderSlot(l.$slots, "default")
      ]),
      _: 3
    }));
  }
}), DATA_TEST_ID$5 = {
  TABS: "tabs",
  TAB: "tab"
}, _sfc_main$F = /* @__PURE__ */ defineComponent({
  __name: "Tabs",
  setup(e) {
    const t = strictlyInject(TabsKey), n = () => classMerge({
      "overflow-x-scroll": t.variant === "outline"
    });
    return (s, i) => (openBlock(), createBlock(_sfc_main$2x, {
      class: normalizeClass(n()),
      "data-testid": unref(DATA_TEST_ID$5).TABS
    }, {
      default: withCtx(() => [
        renderSlot(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "data-testid"]));
  }
}), __default__$4 = {
  name: "TabPanel"
}, _sfc_main$E = /* @__PURE__ */ defineComponent({
  ...__default__$4,
  props: {
    name: null
  },
  setup(e) {
    const t = e, n = strictlyInject(TabsKey), s = computed(() => n.selectedTab.value === t.name), i = n.panels.findIndex((a) => a === t.name) === 0;
    return (a, o) => unref(s) ? (openBlock(), createBlock(_sfc_main$2K, {
      key: 0,
      "border-radius": "lg",
      tone: unref(n).tone,
      class: normalizeClass({ "!rounded-tl-none": i })
    }, {
      default: withCtx(() => [
        renderSlot(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["tone", "class"])) : createCommentVNode("", !0);
  }
}), __default__$3 = {
  name: "Tab"
}, _sfc_main$D = /* @__PURE__ */ defineComponent({
  ...__default__$3,
  props: {
    name: null
  },
  setup(e) {
    const t = e, n = strictlyInject(TabsKey), s = computed(() => n.selectedTab.value === t.name), i = () => {
      n.onTabSelected(t.name);
    }, a = () => classMerge({
      "pb-4 border-b-2": n.variant === "outline",
      "border-b-transparent": n.variant === "outline" && !s.value,
      "border-b-black": n.variant === "outline" && s.value
    });
    return (o, l) => (openBlock(), createBlock(_sfc_main$2K, {
      "data-testid": `${unref(DATA_TEST_ID$5).TAB}-${t.name}`,
      component: "button",
      "padding-y": "sm",
      "padding-x": "md",
      class: normalizeClass(["rounded-t-lg", a()]),
      tone: unref(s) ? unref(n).tone : void 0,
      onClick: i
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$2J, {
          size: unref(n).textSize,
          variant: "interactive",
          "interactive-text-weight": unref(s) ? "strong" : "regular",
          tone: unref(s) ? "high-emphasis" : "medium-emphasis"
        }, {
          default: withCtx(() => [
            renderSlot(o.$slots, "default")
          ]),
          _: 3
        }, 8, ["size", "interactive-text-weight", "tone"])
      ]),
      _: 3
    }, 8, ["data-testid", "class", "tone"]));
  }
}), min$1 = Math.min, max$1 = Math.max, round$2 = Math.round, floor = Math.floor, createCoords = (e) => ({
  x: e,
  y: e
}), oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp$1(e, t, n) {
  return max$1(e, min$1(t, n));
}
function evaluate(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function getSide(e) {
  return e.split("-")[0];
}
function getAlignment(e) {
  return e.split("-")[1];
}
function getOppositeAxis(e) {
  return e === "x" ? "y" : "x";
}
function getAxisLength(e) {
  return e === "y" ? "height" : "width";
}
function getSideAxis(e) {
  return ["top", "bottom"].includes(getSide(e)) ? "y" : "x";
}
function getAlignmentAxis(e) {
  return getOppositeAxis(getSideAxis(e));
}
function getAlignmentSides(e, t, n) {
  n === void 0 && (n = !1);
  const s = getAlignment(e), i = getAlignmentAxis(e), a = getAxisLength(i);
  let o = i === "x" ? s === (n ? "end" : "start") ? "right" : "left" : s === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = getOppositePlacement$1(o)), [o, getOppositePlacement$1(o)];
}
function getExpandedPlacements(e) {
  const t = getOppositePlacement$1(e);
  return [getOppositeAlignmentPlacement(e), t, getOppositeAlignmentPlacement(t)];
}
function getOppositeAlignmentPlacement(e) {
  return e.replace(/start|end/g, (t) => oppositeAlignmentMap[t]);
}
function getSideList(e, t, n) {
  const s = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : s : t ? s : i;
    case "left":
    case "right":
      return t ? a : o;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(e, t, n, s) {
  const i = getAlignment(e);
  let a = getSideList(getSide(e), n === "start", s);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(getOppositeAlignmentPlacement)))), a;
}
function getOppositePlacement$1(e) {
  return e.replace(/left|right|bottom|top/g, (t) => oppositeSideMap[t]);
}
function expandPaddingObject(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function getPaddingObject(e) {
  return typeof e != "number" ? expandPaddingObject(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function rectToClientRect$1(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function computeCoordsFromPlacement(e, t, n) {
  let {
    reference: s,
    floating: i
  } = e;
  const a = getSideAxis(t), o = getAlignmentAxis(t), l = getAxisLength(o), c = getSide(t), u = a === "y", d = s.x + s.width / 2 - i.width / 2, p = s.y + s.height / 2 - i.height / 2, f = s[l] / 2 - i[l] / 2;
  let g;
  switch (c) {
    case "top":
      g = {
        x: d,
        y: s.y - i.height
      };
      break;
    case "bottom":
      g = {
        x: d,
        y: s.y + s.height
      };
      break;
    case "right":
      g = {
        x: s.x + s.width,
        y: p
      };
      break;
    case "left":
      g = {
        x: s.x - i.width,
        y: p
      };
      break;
    default:
      g = {
        x: s.x,
        y: s.y
      };
  }
  switch (getAlignment(t)) {
    case "start":
      g[o] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      g[o] += f * (n && u ? -1 : 1);
      break;
  }
  return g;
}
const computePosition$1 = async (e, t, n) => {
  const {
    placement: s = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = n, l = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: d,
    y: p
  } = computeCoordsFromPlacement(u, s, c), f = s, g = {}, C = 0;
  for (let k = 0; k < l.length; k++) {
    const {
      name: M,
      fn: _
    } = l[k], {
      x: S,
      y: E,
      data: P,
      reset: $
    } = await _({
      x: d,
      y: p,
      initialPlacement: s,
      placement: f,
      strategy: i,
      middlewareData: g,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = S ?? d, p = E ?? p, g = {
      ...g,
      [M]: {
        ...g[M],
        ...P
      }
    }, $ && C <= 50) {
      C++, typeof $ == "object" && ($.placement && (f = $.placement), $.rects && (u = $.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: i
      }) : $.rects), {
        x: d,
        y: p
      } = computeCoordsFromPlacement(u, f, c)), k = -1;
      continue;
    }
  }
  return {
    x: d,
    y: p,
    placement: f,
    strategy: i,
    middlewareData: g
  };
};
async function detectOverflow$1(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: s,
    y: i,
    platform: a,
    rects: o,
    elements: l,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: p = "floating",
    altBoundary: f = !1,
    padding: g = 0
  } = evaluate(t, e), C = getPaddingObject(g), M = l[f ? p === "floating" ? "reference" : "floating" : p], _ = rectToClientRect$1(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(M))) == null || n ? M : M.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: c
  })), S = p === "floating" ? {
    ...o.floating,
    x: s,
    y: i
  } : o.reference, E = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), P = await (a.isElement == null ? void 0 : a.isElement(E)) ? await (a.getScale == null ? void 0 : a.getScale(E)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = rectToClientRect$1(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: S,
    offsetParent: E,
    strategy: c
  }) : S);
  return {
    top: (_.top - $.top + C.top) / P.y,
    bottom: ($.bottom - _.bottom + C.bottom) / P.y,
    left: (_.left - $.left + C.left) / P.x,
    right: ($.right - _.right + C.right) / P.x
  };
}
const arrow$2 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: s,
      placement: i,
      rects: a,
      platform: o,
      elements: l
    } = t, {
      element: c,
      padding: u = 0
    } = evaluate(e, t) || {};
    if (c == null)
      return {};
    const d = getPaddingObject(u), p = {
      x: n,
      y: s
    }, f = getAlignmentAxis(i), g = getAxisLength(f), C = await o.getDimensions(c), k = f === "y", M = k ? "top" : "left", _ = k ? "bottom" : "right", S = k ? "clientHeight" : "clientWidth", E = a.reference[g] + a.reference[f] - p[f] - a.floating[g], P = p[f] - a.reference[f], $ = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let A = $ ? $[S] : 0;
    (!A || !await (o.isElement == null ? void 0 : o.isElement($))) && (A = l.floating[S] || a.floating[g]);
    const I = E / 2 - P / 2, D = A / 2 - C[g] / 2 - 1, R = min$1(d[M], D), Y = min$1(d[_], D), q = R, j = A - C[g] - Y, X = A / 2 - C[g] / 2 + I, ee = clamp$1(q, X, j), H = getAlignment(i) != null && X != ee && a.reference[g] / 2 - (X < q ? R : Y) - C[g] / 2 < 0 ? X < q ? q - X : j - X : 0;
    return {
      [f]: p[f] - H,
      data: {
        [f]: ee,
        centerOffset: X - ee + H
      }
    };
  }
}), flip$2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: s,
        middlewareData: i,
        rects: a,
        initialPlacement: o,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: C = !0,
        ...k
      } = evaluate(e, t), M = getSide(s), _ = getSide(o) === o, S = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), E = p || (_ || !C ? [getOppositePlacement$1(o)] : getExpandedPlacements(o));
      !p && g !== "none" && E.push(...getOppositeAxisPlacements(o, C, g, S));
      const P = [o, ...E], $ = await detectOverflow$1(t, k), A = [];
      let I = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (u && A.push($[M]), d) {
        const q = getAlignmentSides(s, a, S);
        A.push($[q[0]], $[q[1]]);
      }
      if (I = [...I, {
        placement: s,
        overflows: A
      }], !A.every((q) => q <= 0)) {
        var D, R;
        const q = (((D = i.flip) == null ? void 0 : D.index) || 0) + 1, j = P[q];
        if (j)
          return {
            data: {
              index: q,
              overflows: I
            },
            reset: {
              placement: j
            }
          };
        let X = (R = I.filter((ee) => ee.overflows[0] <= 0).sort((ee, G) => ee.overflows[1] - G.overflows[1])[0]) == null ? void 0 : R.placement;
        if (!X)
          switch (f) {
            case "bestFit": {
              var Y;
              const ee = (Y = I.map((G) => [G.placement, G.overflows.filter((H) => H > 0).reduce((H, F) => H + F, 0)]).sort((G, H) => G[1] - H[1])[0]) == null ? void 0 : Y[0];
              ee && (X = ee);
              break;
            }
            case "initialPlacement":
              X = o;
              break;
          }
        if (s !== X)
          return {
            reset: {
              placement: X
            }
          };
      }
      return {};
    }
  };
};
async function convertValueToCoords(e, t) {
  const {
    placement: n,
    platform: s,
    elements: i
  } = e, a = await (s.isRTL == null ? void 0 : s.isRTL(i.floating)), o = getSide(n), l = getAlignment(n), c = getSideAxis(n) === "y", u = ["left", "top"].includes(o) ? -1 : 1, d = a && c ? -1 : 1, p = evaluate(t, e);
  let {
    mainAxis: f,
    crossAxis: g,
    alignmentAxis: C
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...p
  };
  return l && typeof C == "number" && (g = l === "end" ? C * -1 : C), c ? {
    x: g * d,
    y: f * u
  } : {
    x: f * u,
    y: g * d
  };
}
const offset$2 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: s
      } = t, i = await convertValueToCoords(t, e);
      return {
        x: n + i.x,
        y: s + i.y,
        data: i
      };
    }
  };
}, shift = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: s,
        placement: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: l = {
          fn: (M) => {
            let {
              x: _,
              y: S
            } = M;
            return {
              x: _,
              y: S
            };
          }
        },
        ...c
      } = evaluate(e, t), u = {
        x: n,
        y: s
      }, d = await detectOverflow$1(t, c), p = getSideAxis(getSide(i)), f = getOppositeAxis(p);
      let g = u[f], C = u[p];
      if (a) {
        const M = f === "y" ? "top" : "left", _ = f === "y" ? "bottom" : "right", S = g + d[M], E = g - d[_];
        g = clamp$1(S, g, E);
      }
      if (o) {
        const M = p === "y" ? "top" : "left", _ = p === "y" ? "bottom" : "right", S = C + d[M], E = C - d[_];
        C = clamp$1(S, C, E);
      }
      const k = l.fn({
        ...t,
        [f]: g,
        [p]: C
      });
      return {
        ...k,
        data: {
          x: k.x - n,
          y: k.y - s
        }
      };
    }
  };
};
function getNodeName$1(e) {
  return isNode(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function getWindow$1(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function getDocumentElement$1(e) {
  var t;
  return (t = (isNode(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function isNode(e) {
  return e instanceof Node || e instanceof getWindow$1(e).Node;
}
function isElement$1(e) {
  return e instanceof Element || e instanceof getWindow$1(e).Element;
}
function isHTMLElement$1(e) {
  return e instanceof HTMLElement || e instanceof getWindow$1(e).HTMLElement;
}
function isShadowRoot$1(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof getWindow$1(e).ShadowRoot;
}
function isOverflowElement(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: s,
    display: i
  } = getComputedStyle$3(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + s + n) && !["inline", "contents"].includes(i);
}
function isTableElement$1(e) {
  return ["table", "td", "th"].includes(getNodeName$1(e));
}
function isContainingBlock(e) {
  const t = isWebKit(), n = getComputedStyle$3(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((s) => (n.willChange || "").includes(s)) || ["paint", "layout", "strict", "content"].some((s) => (n.contain || "").includes(s));
}
function getContainingBlock$1(e) {
  let t = getParentNode$1(e);
  for (; isHTMLElement$1(t) && !isLastTraversableNode(t); ) {
    if (isContainingBlock(t))
      return t;
    t = getParentNode$1(t);
  }
  return null;
}
function isWebKit() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(e) {
  return ["html", "body", "#document"].includes(getNodeName$1(e));
}
function getComputedStyle$3(e) {
  return getWindow$1(e).getComputedStyle(e);
}
function getNodeScroll$1(e) {
  return isElement$1(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function getParentNode$1(e) {
  if (getNodeName$1(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    isShadowRoot$1(e) && e.host || // Fallback.
    getDocumentElement$1(e)
  );
  return isShadowRoot$1(t) ? t.host : t;
}
function getNearestOverflowAncestor(e) {
  const t = getParentNode$1(e);
  return isLastTraversableNode(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : isHTMLElement$1(t) && isOverflowElement(t) ? t : getNearestOverflowAncestor(t);
}
function getOverflowAncestors(e, t) {
  var n;
  t === void 0 && (t = []);
  const s = getNearestOverflowAncestor(e), i = s === ((n = e.ownerDocument) == null ? void 0 : n.body), a = getWindow$1(s);
  return i ? t.concat(a, a.visualViewport || [], isOverflowElement(s) ? s : []) : t.concat(s, getOverflowAncestors(s));
}
function getCssDimensions(e) {
  const t = getComputedStyle$3(e);
  let n = parseFloat(t.width) || 0, s = parseFloat(t.height) || 0;
  const i = isHTMLElement$1(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : s, l = round$2(n) !== a || round$2(s) !== o;
  return l && (n = a, s = o), {
    width: n,
    height: s,
    $: l
  };
}
function unwrapElement(e) {
  return isElement$1(e) ? e : e.contextElement;
}
function getScale(e) {
  const t = unwrapElement(e);
  if (!isHTMLElement$1(t))
    return createCoords(1);
  const n = t.getBoundingClientRect(), {
    width: s,
    height: i,
    $: a
  } = getCssDimensions(t);
  let o = (a ? round$2(n.width) : n.width) / s, l = (a ? round$2(n.height) : n.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: o,
    y: l
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(e) {
  const t = getWindow$1(e);
  return !isWebKit() || !t.visualViewport ? noOffsets : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== getWindow$1(e) ? !1 : t;
}
function getBoundingClientRect$1(e, t, n, s) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = unwrapElement(e);
  let o = createCoords(1);
  t && (s ? isElement$1(s) && (o = getScale(s)) : o = getScale(e));
  const l = shouldAddVisualOffsets(a, n, s) ? getVisualOffsets(a) : createCoords(0);
  let c = (i.left + l.x) / o.x, u = (i.top + l.y) / o.y, d = i.width / o.x, p = i.height / o.y;
  if (a) {
    const f = getWindow$1(a), g = s && isElement$1(s) ? getWindow$1(s) : s;
    let C = f.frameElement;
    for (; C && s && g !== f; ) {
      const k = getScale(C), M = C.getBoundingClientRect(), _ = getComputedStyle$3(C), S = M.left + (C.clientLeft + parseFloat(_.paddingLeft)) * k.x, E = M.top + (C.clientTop + parseFloat(_.paddingTop)) * k.y;
      c *= k.x, u *= k.y, d *= k.x, p *= k.y, c += S, u += E, C = getWindow$1(C).frameElement;
    }
  }
  return rectToClientRect$1({
    width: d,
    height: p,
    x: c,
    y: u
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: s
  } = e;
  const i = isHTMLElement$1(n), a = getDocumentElement$1(n);
  if (n === a)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = createCoords(1);
  const c = createCoords(0);
  if ((i || !i && s !== "fixed") && ((getNodeName$1(n) !== "body" || isOverflowElement(a)) && (o = getNodeScroll$1(n)), isHTMLElement$1(n))) {
    const u = getBoundingClientRect$1(n);
    l = getScale(n), c.x = u.x + n.clientLeft, c.y = u.y + n.clientTop;
  }
  return {
    width: t.width * l.x,
    height: t.height * l.y,
    x: t.x * l.x - o.scrollLeft * l.x + c.x,
    y: t.y * l.y - o.scrollTop * l.y + c.y
  };
}
function getClientRects(e) {
  return Array.from(e.getClientRects());
}
function getWindowScrollBarX$1(e) {
  return getBoundingClientRect$1(getDocumentElement$1(e)).left + getNodeScroll$1(e).scrollLeft;
}
function getDocumentRect$1(e) {
  const t = getDocumentElement$1(e), n = getNodeScroll$1(e), s = e.ownerDocument.body, i = max$1(t.scrollWidth, t.clientWidth, s.scrollWidth, s.clientWidth), a = max$1(t.scrollHeight, t.clientHeight, s.scrollHeight, s.clientHeight);
  let o = -n.scrollLeft + getWindowScrollBarX$1(e);
  const l = -n.scrollTop;
  return getComputedStyle$3(s).direction === "rtl" && (o += max$1(t.clientWidth, s.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: l
  };
}
function getViewportRect$1(e, t) {
  const n = getWindow$1(e), s = getDocumentElement$1(e), i = n.visualViewport;
  let a = s.clientWidth, o = s.clientHeight, l = 0, c = 0;
  if (i) {
    a = i.width, o = i.height;
    const u = isWebKit();
    (!u || u && t === "fixed") && (l = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: l,
    y: c
  };
}
function getInnerBoundingClientRect$1(e, t) {
  const n = getBoundingClientRect$1(e, !0, t === "fixed"), s = n.top + e.clientTop, i = n.left + e.clientLeft, a = isHTMLElement$1(e) ? getScale(e) : createCoords(1), o = e.clientWidth * a.x, l = e.clientHeight * a.y, c = i * a.x, u = s * a.y;
  return {
    width: o,
    height: l,
    x: c,
    y: u
  };
}
function getClientRectFromClippingAncestor(e, t, n) {
  let s;
  if (t === "viewport")
    s = getViewportRect$1(e, n);
  else if (t === "document")
    s = getDocumentRect$1(getDocumentElement$1(e));
  else if (isElement$1(t))
    s = getInnerBoundingClientRect$1(t, n);
  else {
    const i = getVisualOffsets(e);
    s = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return rectToClientRect$1(s);
}
function hasFixedPositionAncestor(e, t) {
  const n = getParentNode$1(e);
  return n === t || !isElement$1(n) || isLastTraversableNode(n) ? !1 : getComputedStyle$3(n).position === "fixed" || hasFixedPositionAncestor(n, t);
}
function getClippingElementAncestors(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let s = getOverflowAncestors(e).filter((l) => isElement$1(l) && getNodeName$1(l) !== "body"), i = null;
  const a = getComputedStyle$3(e).position === "fixed";
  let o = a ? getParentNode$1(e) : e;
  for (; isElement$1(o) && !isLastTraversableNode(o); ) {
    const l = getComputedStyle$3(o), c = isContainingBlock(o);
    !c && l.position === "fixed" && (i = null), (a ? !c && !i : !c && l.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || isOverflowElement(o) && !c && hasFixedPositionAncestor(e, o)) ? s = s.filter((d) => d !== o) : i = l, o = getParentNode$1(o);
  }
  return t.set(e, s), s;
}
function getClippingRect$1(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: s,
    strategy: i
  } = e;
  const o = [...n === "clippingAncestors" ? getClippingElementAncestors(t, this._c) : [].concat(n), s], l = o[0], c = o.reduce((u, d) => {
    const p = getClientRectFromClippingAncestor(t, d, i);
    return u.top = max$1(p.top, u.top), u.right = min$1(p.right, u.right), u.bottom = min$1(p.bottom, u.bottom), u.left = max$1(p.left, u.left), u;
  }, getClientRectFromClippingAncestor(t, l, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function getDimensions(e) {
  return getCssDimensions(e);
}
function getRectRelativeToOffsetParent(e, t, n) {
  const s = isHTMLElement$1(t), i = getDocumentElement$1(t), a = n === "fixed", o = getBoundingClientRect$1(e, !0, a, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = createCoords(0);
  if (s || !s && !a)
    if ((getNodeName$1(t) !== "body" || isOverflowElement(i)) && (l = getNodeScroll$1(t)), s) {
      const u = getBoundingClientRect$1(t, !0, a, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else
      i && (c.x = getWindowScrollBarX$1(i));
  return {
    x: o.left + l.scrollLeft - c.x,
    y: o.top + l.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function getTrueOffsetParent$1(e, t) {
  return !isHTMLElement$1(e) || getComputedStyle$3(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function getOffsetParent$1(e, t) {
  const n = getWindow$1(e);
  if (!isHTMLElement$1(e))
    return n;
  let s = getTrueOffsetParent$1(e, t);
  for (; s && isTableElement$1(s) && getComputedStyle$3(s).position === "static"; )
    s = getTrueOffsetParent$1(s, t);
  return s && (getNodeName$1(s) === "html" || getNodeName$1(s) === "body" && getComputedStyle$3(s).position === "static" && !isContainingBlock(s)) ? n : s || getContainingBlock$1(e) || n;
}
const getElementRects = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: s
  } = e;
  const i = this.getOffsetParent || getOffsetParent$1, a = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(t, await i(n), s),
    floating: {
      x: 0,
      y: 0,
      ...await a(n)
    }
  };
};
function isRTL(e) {
  return getComputedStyle$3(e).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement$1,
  getClippingRect: getClippingRect$1,
  getOffsetParent: getOffsetParent$1,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL
};
function observeMove(e, t) {
  let n = null, s;
  const i = getDocumentElement$1(e);
  function a() {
    clearTimeout(s), n && n.disconnect(), n = null;
  }
  function o(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), a();
    const {
      left: u,
      top: d,
      width: p,
      height: f
    } = e.getBoundingClientRect();
    if (l || t(), !p || !f)
      return;
    const g = floor(d), C = floor(i.clientWidth - (u + p)), k = floor(i.clientHeight - (d + f)), M = floor(u), S = {
      rootMargin: -g + "px " + -C + "px " + -k + "px " + -M + "px",
      threshold: max$1(0, min$1(1, c)) || 1
    };
    let E = !0;
    function P($) {
      const A = $[0].intersectionRatio;
      if (A !== c) {
        if (!E)
          return o();
        A ? o(!1, A) : s = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      E = !1;
    }
    try {
      n = new IntersectionObserver(P, {
        ...S,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(P, S);
    }
    n.observe(e);
  }
  return o(!0), a;
}
function autoUpdate(e, t, n, s) {
  s === void 0 && (s = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = s, u = unwrapElement(e), d = i || a ? [...u ? getOverflowAncestors(u) : [], ...getOverflowAncestors(t)] : [];
  d.forEach((_) => {
    i && _.addEventListener("scroll", n, {
      passive: !0
    }), a && _.addEventListener("resize", n);
  });
  const p = u && l ? observeMove(u, n) : null;
  let f = -1, g = null;
  o && (g = new ResizeObserver((_) => {
    let [S] = _;
    S && S.target === u && g && (g.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      g && g.observe(t);
    })), n();
  }), u && !c && g.observe(u), g.observe(t));
  let C, k = c ? getBoundingClientRect$1(e) : null;
  c && M();
  function M() {
    const _ = getBoundingClientRect$1(e);
    k && (_.x !== k.x || _.y !== k.y || _.width !== k.width || _.height !== k.height) && n(), k = _, C = requestAnimationFrame(M);
  }
  return n(), () => {
    d.forEach((_) => {
      i && _.removeEventListener("scroll", n), a && _.removeEventListener("resize", n);
    }), p && p(), g && g.disconnect(), g = null, c && cancelAnimationFrame(C);
  };
}
const computePosition = (e, t, n) => {
  const s = /* @__PURE__ */ new Map(), i = {
    platform,
    ...n
  }, a = {
    ...i.platform,
    _c: s
  };
  return computePosition$1(e, t, {
    ...i,
    platform: a
  });
}, SQUARE_WIDTH = 8, SQUARE_OFFSET = SQUARE_WIDTH / 2, computeTriangleHeight = () => Math.sqrt(Math.pow(SQUARE_WIDTH, 2) * 2) / 2, getArrowClasses = (e) => {
  let t = "";
  return t = "border-t-8 border-r-8 w-[8px] h-[8px]", computed(() => ({
    [`${t} border-t-transparent border-r-black-90`]: e.value === "top",
    [`${t} border-t-black-90 border-r-transparent`]: e.value === "bottom"
  }));
}, computePadding = (e) => {
  const t = {
    desktop: "xl",
    tablet: "sm"
  }, n = useMediaMatch();
  return useResponsiveProp(
    e || t,
    n
  );
}, mapSpaceToPadding = (e) => {
  switch (e) {
    case "2xs":
      return 4;
    case "xs":
      return 8;
    case "sm":
      return 12;
    case "md":
      return 16;
    case "lg":
      return 24;
    case "xl":
      return 32;
    default:
      return 0;
  }
}, useFloating = (e, t, n, s) => {
  const i = reactive({
    isVisible: !1,
    currentPosition: s.position ?? "top"
  }), a = (d, p, f) => {
    const g = d.$refs.boxRef, C = p.$refs.boxRef, k = f == null ? void 0 : f.$refs.boxRef;
    return { togglerNode: g, tooltipNode: C, arrowNode: k };
  }, o = async () => {
    if (e.value && t.value && n.value) {
      const { togglerNode: d, tooltipNode: p, arrowNode: f } = a(
        e.value,
        t.value,
        n.value
      ), g = computeTriangleHeight(), C = computePadding(s.tooltipPadding), { x: k, y: M, middlewareData: _, placement: S } = await computePosition(
        d,
        p,
        {
          placement: i.currentPosition,
          middleware: [
            offset$2(s.offset ? s.offset + g : g),
            shift({
              padding: C.value ? mapSpaceToPadding(C.value) : 0
            }),
            flip$2(),
            arrow$2({ element: f })
          ]
        }
      );
      if ((S === "top" || S === "bottom") && (i.currentPosition = S), Object.assign(p.style, {
        left: `${k}px`,
        top: `${M}px`
      }), _.arrow) {
        const E = {
          top: "bottom",
          bottom: "top"
        }[S.split("-")[0]], { x: P, y: $ } = _.arrow;
        E && Object.assign(f.style, {
          left: P ? `${P}px` : "",
          top: $ ? `${$}px` : "",
          [E]: `-${SQUARE_OFFSET}px`
        });
      }
    }
  }, l = () => {
    i.timeout = setTimeout(() => {
      i.isVisible = !0;
    }, s.delay ?? 0);
  }, c = () => {
    i.timeout && clearTimeout(i.timeout), i.isVisible = !1;
  }, u = () => {
    i.isVisible = !i.isVisible;
  };
  return watch(
    () => i.isVisible,
    async () => {
      if (i.isVisible && await o(), e.value && t.value) {
        const { togglerNode: d, tooltipNode: p } = a(
          e.value,
          t.value
        );
        autoUpdate(d, p, o);
      }
    }
  ), onMounted(() => {
    window.addEventListener("scroll", c);
  }), {
    state: i,
    showTooltip: l,
    hideTooltip: c,
    toggleTooltip: u
  };
}, _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "Tooltip",
  props: {
    text: null,
    position: { default: "top" },
    offset: { default: 0 },
    delay: { default: 0 },
    tooltipPadding: { default: void 0 }
  },
  setup(e) {
    const t = e, n = ref(null), s = ref(null), i = ref(null), { showTooltip: a, hideTooltip: o, toggleTooltip: l, state: c } = useFloating(
      n,
      s,
      i,
      t
    ), { currentPosition: u } = toRefs(c), d = getArrowClasses(u);
    return (p, f) => (openBlock(), createBlock(_sfc_main$2K, null, {
      default: withCtx(() => [
        createVNode(_sfc_main$2K, {
          ref_key: "toggler",
          ref: n,
          class: "relative",
          tabindex: "0",
          onMouseenter: unref(a),
          onMouseleave: unref(o),
          onTouchstart: unref(l),
          onFocus: unref(a),
          onBlur: unref(o),
          "aria-describedby": "tooltip"
        }, {
          default: withCtx(() => [
            renderSlot(p.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["onMouseenter", "onMouseleave", "onTouchstart", "onFocus", "onBlur"]),
        withDirectives(createVNode(_sfc_main$2K, {
          id: "tooltip",
          role: "tooltip",
          ref_key: "tooltip",
          ref: s,
          component: "span",
          tone: "high-emphasis",
          padding: "xs",
          "border-radius": "lg",
          class: "absolute min-w-[50px] top-0 left-0 z-50 w-auto max-w-xs pointer-events-none animation"
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$2K, {
              component: "span",
              ref_key: "arrow",
              ref: i,
              class: normalizeClass([unref(d), "absolute rotate-45 border-solid"]),
              "data-testid": "tooltip_arrow"
            }, null, 8, ["class"]),
            createVNode(_sfc_main$2J, {
              tone: "base",
              size: "md",
              "preserve-newlines": ""
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(e.text), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [vShow, unref(c).isVisible]
        ])
      ]),
      _: 3
    }));
  }
}), Tooltip_vue_vue_type_style_index_0_scoped_94e5229e_lang = "", Tooltip$1 = /* @__PURE__ */ _export_sfc$1(_sfc_main$C, [["__scopeId", "data-v-94e5229e"]]), DATA_TEST_ID$4 = {
  CONTAINER: "radioGroup_container",
  LABEL: "radioGroup_label"
}, _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "RadioGroup",
  props: {
    id: null,
    label: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    tone: { default: "primary" },
    description: { default: void 0 },
    message: { default: void 0 },
    modelValue: { default: void 0 },
    value: { default: void 0 }
  },
  emits: ["onChange", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, s = ref(n.disabled), i = ref(n.modelValue || n.value || null), a = ref(n.tone);
    watch(
      () => n.disabled,
      (l) => {
        s.value = l;
      }
    ), watch(
      () => [n.modelValue, n.value],
      ([l, c]) => {
        i.value = l || c || null;
      }
    ), watch(
      () => n.tone,
      (l) => {
        a.value = l;
      }
    );
    const o = () => s.value ? "disabled" : n.tone === "error" ? "error" : "medium-emphasis";
    return provide("radioGroupProps", {
      id: n.id,
      tone: a,
      disabled: s,
      selected: i,
      onChange: (l) => {
        l !== i.value && (t("onChange", l), t("update:modelValue", l), i.value = l);
      }
    }), (l, c) => (openBlock(), createBlock(_sfc_main$2H, {
      class: "relative",
      space: "xs",
      "data-testid": unref(DATA_TEST_ID$4).CONTAINER
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$2H, { space: "2xs" }, {
          default: withCtx(() => [
            e.label ? (openBlock(), createBlock(_sfc_main$2q, {
              key: 0,
              forId: e.id,
              tone: a.value,
              disabled: s.value
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(e.label), 1)
              ]),
              _: 1
            }, 8, ["forId", "tone", "disabled"])) : createCommentVNode("", !0),
            createVNode(_sfc_main$2K, null, {
              default: withCtx(() => [
                renderSlot(l.$slots, "default", { tone: a.value })
              ]),
              _: 3
            })
          ]),
          _: 3
        }),
        e.description ? (openBlock(), createBlock(_sfc_main$2J, {
          key: 0,
          size: "sm",
          tone: o()
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(e.description), 1)
          ]),
          _: 1
        }, 8, ["tone"])) : createCommentVNode("", !0),
        e.message ? (openBlock(), createBlock(_sfc_main$2J, {
          key: 1,
          size: "sm",
          tone: o()
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(e.message), 1)
          ]),
          _: 1
        }, 8, ["tone"])) : createCommentVNode("", !0)
      ]),
      _: 3
    }, 8, ["data-testid"]));
  }
}), _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "RadioItem",
  props: {
    label: null,
    value: null
  },
  setup(e) {
    const t = e, n = ref(!1), { disabled: s, selected: i, id: a, tone: o, onChange: l } = inject(
      "radioGroupProps"
    ), c = () => {
      s.value || l(t.value);
    }, u = () => {
      n.value = !0;
    }, d = () => {
      n.value = !1;
    }, p = () => `${a}_${t.label || t.value}`, f = () => s.value ? "disabled" : o.value === "error" ? "error" : "medium-emphasis", g = () => classMerge(mapDisabledToCursorClasses(s.value)), C = () => classMerge(mapDisabledToCursorClasses(s.value)), k = () => classMerge("w-6 h-6 transition-all", {
      ...mapToneToFormFieldFocusRingClasses$1({
        tone: o.value,
        focused: n.value,
        disabled: s.value
      }),
      ...mapDisabledToCursorClasses(s.value)
    }), M = () => classMerge({
      ...mapDisabledToCursorClasses(s.value),
      "accent-grey-800": o.value !== "error",
      "accent-red-300": o.value === "error"
    }), _ = computed(() => ({
      for: p(),
      tone: f(),
      class: C(),
      disabled: s.value
    }));
    return (S, E) => (openBlock(), createBlock(_sfc_main$2K, {
      class: normalizeClass(g()),
      onClick: c
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$2x, {
          space: "2xs",
          "vertical-align": "center"
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$2K, {
              class: normalizeClass(k()),
              "border-radius": "full"
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$2K, {
                  id: p(),
                  checked: unref(i) === e.value,
                  disabled: unref(s),
                  class: normalizeClass([M(), "w-6 h-6 checkbox focus:outline-none transition-colors ease-in"]),
                  component: "input",
                  type: "radio",
                  onFocus: u,
                  onBlur: d
                }, null, 8, ["id", "checked", "disabled", "class"])
              ]),
              _: 1
            }, 8, ["class"]),
            createVNode(_sfc_main$2K, {
              "data-testid": unref(DATA_TEST_ID$4).LABEL,
              class: "select-none cursor-pointer"
            }, {
              default: withCtx(() => [
                renderSlot(S.$slots, "label", normalizeProps(guardReactiveProps(unref(_))), () => [
                  createVNode(_sfc_main$2J, mergeProps(unref(_), {
                    component: "label",
                    size: "lg",
                    class: "select-none cursor-pointer"
                  }), {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(e.label), 1)
                    ]),
                    _: 1
                  }, 16)
                ])
              ]),
              _: 3
            }, 8, ["data-testid"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), _sfc_main$z = /* @__PURE__ */ defineComponent({
  __name: "ButtonGroup",
  props: {
    id: null,
    disabled: { type: Boolean, default: !1 },
    modelValue: { default: void 0 }
  },
  emits: ["onChange", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, s = reactive({
      selectedItem: n.modelValue || null,
      disabled: n.disabled || !1
    });
    return watch(
      () => n.modelValue,
      (i) => {
        s.selectedItem = i || null;
      }
    ), watch(
      () => n.disabled,
      (i) => {
        s.disabled = i || !1;
      }
    ), provide("buttonGroupProps", {
      id: n.id,
      state: s,
      onChange: (i) => {
        i !== s.selectedItem && (t("onChange", i), t("update:modelValue", i), s.selectedItem = i);
      }
    }), (i, a) => (openBlock(), createBlock(_sfc_main$2K, { class: "rounded-md border border-grey-400 overflow-hidden flex" }, {
      default: withCtx(() => [
        renderSlot(i.$slots, "default")
      ]),
      _: 3
    }));
  }
}), _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "ButtonItem",
  props: {
    label: null,
    value: null,
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = inject("buttonGroupProps", {
      id: "",
      state: { selectedItem: null, disabled: !1 },
      onChange: () => {
      }
    }), s = computed(
      () => n.state.selectedItem === t.value
    ), i = computed(
      () => n.state.disabled || t.disabled
    ), a = () => {
      i.value || n.onChange(t.value);
    }, o = () => i.value && s.value ? "disabled" : s.value ? "high-emphasis" : "base", l = () => i.value ? "disabled" : s.value ? "base" : "medium-emphasis", c = () => classMerge(
      "flex-auto transition-colors border-l border-grey-400 first-of-type:border-l-0",
      mapDisabledToCursorClasses(i.value)
    );
    return (u, d) => (openBlock(), createBlock(_sfc_main$2K, {
      component: "button",
      "padding-x": "sm",
      "padding-y": "xs",
      "content-align": "center",
      tone: o(),
      onClick: a,
      class: normalizeClass(c())
    }, {
      default: withCtx(() => [
        createVNode(_sfc_main$2J, {
          tone: l(),
          variant: "interactive",
          "interactive-text-weight": "strong",
          size: "md"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(e.label), 1)
          ]),
          _: 1
        }, 8, ["tone"])
      ]),
      _: 1
    }, 8, ["tone", "class"]));
  }
}), _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "Overlay",
  props: {
    isVisible: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = () => classMerge(
      "fixed top-0 left-0 bottom-0 right-0 bg-grey-600 transition-opacity z-40",
      {
        animated: t.isVisible
      }
    );
    return (s, i) => e.isVisible ? (openBlock(), createBlock(_sfc_main$2K, {
      key: 0,
      class: normalizeClass(n())
    }, null, 8, ["class"])) : createCommentVNode("", !0);
  }
}), Overlay_vue_vue_type_style_index_0_lang = "", DATA_TEST_ID$3 = {
  CONTAINER: "dialog_container",
  BACK_ICON: "dialog_backIcon",
  CROSS_ICON: "dialog_crossIcon",
  OVERLAY: "dialog_overlay"
}, __default__$2 = {
  inheritAttrs: !1
}, _sfc_main$w = /* @__PURE__ */ defineComponent({
  ...__default__$2,
  __name: "Dialog",
  props: {
    id: null,
    open: { type: Boolean, default: !1 },
    title: { default: void 0 },
    description: { default: void 0 },
    width: { default: void 0 },
    hasPreviousStep: { type: Boolean, default: !1 }
  },
  emits: ["onBackClick", "onClose"],
  setup(e, { emit: t }) {
    const n = e, s = useMediaMatch(), i = computed(() => s.value === MEDIA_MATCH.MOBILE), a = useResponsiveProp(
      n.width,
      s
    ), o = () => classMerge({
      ...a.value && mapContentBlockWidthToWidthClassName(a.value)
    });
    onKeyStroke(
      ["Escape"],
      () => {
        n.open && t("onClose");
      },
      { eventName: "keyup" }
    );
    const l = () => ({
      container: classMerge({
        ["inset-0 h-screen w-screen sticky"]: i.value,
        ["fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"]: !i.value
      }),
      contentContainer: classMerge({
        ["overflow-y-auto h-full"]: i.value
      })
    });
    return (c, u) => (openBlock(), createBlock(Teleport, { to: "body" }, [
      e.open ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createVNode(_sfc_main$2K, {
          "data-testid": unref(DATA_TEST_ID$3).CONTAINER,
          class: normalizeClass(["z-50", [o(), l().container]]),
          "box-shadow": "lg",
          "border-radius": unref(i) ? "none" : "lg",
          tone: "base"
        }, {
          default: withCtx(() => [
            e.title || e.description ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createVNode(_sfc_main$2K, {
                "padding-x": "lg",
                "padding-y": "md"
              }, {
                default: withCtx(() => [
                  createVNode(_sfc_main$2H, { space: "xs" }, {
                    default: withCtx(() => [
                      createVNode(_sfc_main$2F, {
                        space: "md",
                        "vertical-align": "center"
                      }, {
                        default: withCtx(() => [
                          e.hasPreviousStep ? (openBlock(), createBlock(_sfc_main$2E, { key: 0 }, {
                            default: withCtx(() => [
                              createVNode(_sfc_main$2K, {
                                "data-testid": unref(DATA_TEST_ID$3).BACK_ICON,
                                class: "cursor-pointer",
                                onClick: u[0] || (u[0] = (d) => c.$emit("onBackClick"))
                              }, {
                                default: withCtx(() => [
                                  createVNode(_sfc_main$2g, { size: "sm" })
                                ]),
                                _: 1
                              }, 8, ["data-testid"])
                            ]),
                            _: 1
                          })) : createCommentVNode("", !0),
                          createVNode(_sfc_main$2E, null, {
                            default: withCtx(() => [
                              e.title ? (openBlock(), createBlock(_sfc_main$I, { key: 0 }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString(e.title), 1)
                                ]),
                                _: 1
                              })) : createCommentVNode("", !0)
                            ]),
                            _: 1
                          }),
                          createVNode(_sfc_main$2E, { width: "content" }, {
                            default: withCtx(() => [
                              createVNode(_sfc_main$2K, {
                                "data-testid": unref(DATA_TEST_ID$3).CROSS_ICON,
                                class: "cursor-pointer",
                                onClick: u[1] || (u[1] = (d) => c.$emit("onClose"))
                              }, {
                                default: withCtx(() => [
                                  createVNode(_sfc_main$2p, { size: "sm" })
                                ]),
                                _: 1
                              }, 8, ["data-testid"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      e.description ? (openBlock(), createBlock(_sfc_main$2J, { key: 0 }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(e.description), 1)
                        ]),
                        _: 1
                      })) : createCommentVNode("", !0)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              createVNode(_sfc_main$2B, { tone: "secondary" })
            ], 64)) : createCommentVNode("", !0),
            createVNode(_sfc_main$2K, {
              "padding-x": "lg",
              "padding-y": "md",
              class: normalizeClass(["flex flex-col justify-between md:justify-start", l().contentContainer])
            }, {
              default: withCtx(() => [
                renderSlot(c.$slots, "default"),
                createVNode(_sfc_main$2K, { "padding-bottom": { desktop: "none", mobile: "3xl" } }, {
                  default: withCtx(() => [
                    createVNode(_sfc_main$2x, { align: { desktop: "right", mobile: "center" } }, {
                      default: withCtx(() => [
                        renderSlot(c.$slots, "actions")
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          _: 3
        }, 8, ["data-testid", "border-radius", "class"]),
        createVNode(_sfc_main$x, {
          "is-visible": e.open,
          "data-testid": unref(DATA_TEST_ID$3).OVERLAY,
          onClick: u[2] || (u[2] = (d) => c.$emit("onClose"))
        }, null, 8, ["is-visible", "data-testid"])
      ], 64)) : createCommentVNode("", !0)
    ]));
  }
}), _sfc_main$v = {}, _hoisted_1$i = { class: "w-16 h-16 bg-brand-orange rounded-circle flex" }, _hoisted_2$e = /* @__PURE__ */ createElementVNode("div", { class: "w-10 h-9 m-auto" }, [
  /* @__PURE__ */ createElementVNode("svg", {
    width: "42",
    height: "36",
    viewBox: "0 0 42 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.4997 5.38152C13.4997 5.21889 13.6771 5.1154 13.8175 5.19671L35.6984 17.83C35.8389 17.9113 35.8389 18.1183 35.6984 18.1996L13.8175 30.8329C13.6771 30.9142 13.4997 30.8107 13.4997 30.6481V5.38152ZM17.5395 3.6037C17.3695 3.5039 17.4397 3.24148 17.6356 3.24148H29.1379C29.3448 3.24148 29.537 3.35236 29.6405 3.53347L35.3547 13.476C35.4545 13.646 35.2623 13.8382 35.0886 13.7384L17.5358 3.6037H17.5395ZM10.2582 28.094C10.2582 28.2936 9.99576 28.3639 9.89596 28.1901L4.20397 18.2883C4.10048 18.1109 4.10048 17.8891 4.20397 17.708L9.89596 7.80616C9.99576 7.63614 10.2582 7.70267 10.2582 7.90226V28.0904V28.094ZM35.3362 22.5647C35.436 22.3947 35.2438 22.2025 35.0701 22.3023L17.5802 32.4C17.4101 32.4998 17.4804 32.7622 17.6763 32.7622H29.1342C29.3411 32.7622 29.5333 32.6513 29.6368 32.4702L35.3325 22.5684L35.3362 22.5647ZM41.1428 18.9647C41.4865 18.3659 41.4865 17.6341 41.1428 17.0353L31.9062 0.972074C31.5625 0.373306 30.9194 0 30.2282 0H11.7699C11.0787 0 10.4356 0.36961 10.0919 0.972074L0.855307 17.0353C0.511569 17.6341 0.511569 18.3659 0.855307 18.9647L10.0919 35.0279C10.4356 35.6267 11.0787 36 11.7699 36H30.2282C30.9194 36 31.5625 35.6304 31.9062 35.0279L41.1428 18.9647Z",
      fill: "white"
    })
  ])
], -1), _hoisted_3$c = [
  _hoisted_2$e
];
function _sfc_render$9(e, t) {
  return openBlock(), createElementBlock("div", _hoisted_1$i, _hoisted_3$c);
}
const Logo = /* @__PURE__ */ _export_sfc$1(_sfc_main$v, [["render", _sfc_render$9]]);
var lottieExports = {}, lottie = {
  get exports() {
    return lottieExports;
  },
  set exports(e) {
    lottieExports = e;
  }
};
(function(module, exports) {
  typeof navigator < "u" && function(e, t) {
    module.exports = t();
  }(commonjsGlobal$1, function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
      _useWebWorker = !!t;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(t) {
      locationHref = t;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(e) {
      return document.createElement(e);
    }
    function extendPrototype(e, t) {
      var n, s = e.length, i;
      for (n = 0; n < s; n += 1) {
        i = e[n].prototype;
        for (var a in i)
          Object.prototype.hasOwnProperty.call(i, a) && (t.prototype[a] = i[a]);
      }
    }
    function getDescriptor(e, t) {
      return Object.getOwnPropertyDescriptor(e, t);
    }
    function createProxyFunction(e) {
      function t() {
      }
      return t.prototype = e, t;
    }
    var audioControllerFactory = function() {
      function e(t) {
        this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
      }
      return e.prototype = {
        addAudio: function(n) {
          this.audios.push(n);
        },
        pause: function() {
          var n, s = this.audios.length;
          for (n = 0; n < s; n += 1)
            this.audios[n].pause();
        },
        resume: function() {
          var n, s = this.audios.length;
          for (n = 0; n < s; n += 1)
            this.audios[n].resume();
        },
        setRate: function(n) {
          var s, i = this.audios.length;
          for (s = 0; s < i; s += 1)
            this.audios[s].setRate(n);
        },
        createAudio: function(n) {
          return this.audioFactory ? this.audioFactory(n) : window.Howl ? new window.Howl({
            src: [n]
          }) : {
            isPlaying: !1,
            play: function() {
              this.isPlaying = !0;
            },
            seek: function() {
              this.isPlaying = !1;
            },
            playing: function() {
            },
            rate: function() {
            },
            setVolume: function() {
            }
          };
        },
        setAudioFactory: function(n) {
          this.audioFactory = n;
        },
        setVolume: function(n) {
          this._volume = n, this._updateVolume();
        },
        mute: function() {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function() {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function() {
          return this._volume;
        },
        _updateVolume: function() {
          var n, s = this.audios.length;
          for (n = 0; n < s; n += 1)
            this.audios[n].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function() {
        return new e();
      };
    }(), createTypedArray = function() {
      function e(n, s) {
        var i = 0, a = [], o;
        switch (n) {
          case "int16":
          case "uint8c":
            o = 1;
            break;
          default:
            o = 1.1;
            break;
        }
        for (i = 0; i < s; i += 1)
          a.push(o);
        return a;
      }
      function t(n, s) {
        return n === "float32" ? new Float32Array(s) : n === "int16" ? new Int16Array(s) : n === "uint8c" ? new Uint8ClampedArray(s) : e(n, s);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? t : e;
    }();
    function createSizedArray(e) {
      return Array.apply(null, {
        length: e
      });
    }
    function _typeof$6(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(n) {
        return typeof n;
      } : _typeof$6 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$6(e);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var e = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], t, n = e.length;
      for (t = 0; t < n; t += 1)
        BMMath[e[t]] = Math[e[t]];
    })(), BMMath.random = Math.random, BMMath.abs = function(e) {
      var t = _typeof$6(e);
      if (t === "object" && e.length) {
        var n = createSizedArray(e.length), s, i = e.length;
        for (s = 0; s < i; s += 1)
          n[s] = Math.abs(e[s]);
        return n;
      }
      return Math.abs(e);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(e) {
      e.style.position = "absolute", e.style.top = 0, e.style.left = 0, e.style.display = "block", e.style.transformOrigin = "0 0", e.style.webkitTransformOrigin = "0 0", e.style.backfaceVisibility = "visible", e.style.webkitBackfaceVisibility = "visible", e.style.transformStyle = "preserve-3d", e.style.webkitTransformStyle = "preserve-3d", e.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(e, t, n, s) {
      this.type = e, this.currentTime = t, this.totalTime = n, this.direction = s < 0 ? -1 : 1;
    }
    function BMCompleteEvent(e, t) {
      this.type = e, this.direction = t < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(e, t, n, s) {
      this.type = e, this.currentLoop = n, this.totalLoops = t, this.direction = s < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(e, t, n) {
      this.type = e, this.firstFrame = t, this.totalFrames = n;
    }
    function BMDestroyEvent(e, t) {
      this.type = e, this.target = t;
    }
    function BMRenderFrameErrorEvent(e, t) {
      this.type = "renderFrameError", this.nativeError = e, this.currentTime = t;
    }
    function BMConfigErrorEvent(e) {
      this.type = "configError", this.nativeError = e;
    }
    var createElementID = function() {
      var e = 0;
      return function() {
        return e += 1, idPrefix$1 + "__lottie_element_" + e;
      };
    }();
    function HSVtoRGB(e, t, n) {
      var s, i, a, o, l, c, u, d;
      switch (o = Math.floor(e * 6), l = e * 6 - o, c = n * (1 - t), u = n * (1 - l * t), d = n * (1 - (1 - l) * t), o % 6) {
        case 0:
          s = n, i = d, a = c;
          break;
        case 1:
          s = u, i = n, a = c;
          break;
        case 2:
          s = c, i = n, a = d;
          break;
        case 3:
          s = c, i = u, a = n;
          break;
        case 4:
          s = d, i = c, a = n;
          break;
        case 5:
          s = n, i = c, a = u;
          break;
      }
      return [s, i, a];
    }
    function RGBtoHSV(e, t, n) {
      var s = Math.max(e, t, n), i = Math.min(e, t, n), a = s - i, o, l = s === 0 ? 0 : a / s, c = s / 255;
      switch (s) {
        case i:
          o = 0;
          break;
        case e:
          o = t - n + a * (t < n ? 6 : 0), o /= 6 * a;
          break;
        case t:
          o = n - e + a * 2, o /= 6 * a;
          break;
        case n:
          o = e - t + a * 4, o /= 6 * a;
          break;
      }
      return [o, l, c];
    }
    function addSaturationToRGB(e, t) {
      var n = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return n[1] += t, n[1] > 1 ? n[1] = 1 : n[1] <= 0 && (n[1] = 0), HSVtoRGB(n[0], n[1], n[2]);
    }
    function addBrightnessToRGB(e, t) {
      var n = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return n[2] += t, n[2] > 1 ? n[2] = 1 : n[2] < 0 && (n[2] = 0), HSVtoRGB(n[0], n[1], n[2]);
    }
    function addHueToRGB(e, t) {
      var n = RGBtoHSV(e[0] * 255, e[1] * 255, e[2] * 255);
      return n[0] += t / 360, n[0] > 1 ? n[0] -= 1 : n[0] < 0 && (n[0] += 1), HSVtoRGB(n[0], n[1], n[2]);
    }
    var rgbToHex = function() {
      var e = [], t, n;
      for (t = 0; t < 256; t += 1)
        n = t.toString(16), e[t] = n.length === 1 ? "0" + n : n;
      return function(s, i, a) {
        return s < 0 && (s = 0), i < 0 && (i = 0), a < 0 && (a = 0), "#" + e[s] + e[i] + e[a];
      };
    }(), setSubframeEnabled = function(t) {
      subframeEnabled = !!t;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(t) {
      expressionsPlugin = t;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(t) {
      expressionsInterfaces = t;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(t) {
      defaultCurveSegments = t;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(t) {
      idPrefix$1 = t;
    };
    function createNS(e) {
      return document.createElementNS(svgNS, e);
    }
    function _typeof$5(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$5 = function(n) {
        return typeof n;
      } : _typeof$5 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$5(e);
    }
    var dataManager = function() {
      var e = 1, t = [], n, s, i = {
        onmessage: function() {
        },
        postMessage: function(g) {
          n({
            data: g
          });
        }
      }, a = {
        postMessage: function(g) {
          i.onmessage({
            data: g
          });
        }
      };
      function o(f) {
        if (window.Worker && window.Blob && getWebWorker()) {
          var g = new Blob(["var _workerSelf = self; self.onmessage = ", f.toString()], {
            type: "text/javascript"
          }), C = URL.createObjectURL(g);
          return new Worker(C);
        }
        return n = f, i;
      }
      function l() {
        s || (s = o(function(g) {
          function C() {
            function M(G, H) {
              var F, B, z = G.length, K, Z, re, ae;
              for (B = 0; B < z; B += 1)
                if (F = G[B], "ks" in F && !F.completed) {
                  if (F.completed = !0, F.hasMask) {
                    var te = F.masksProperties;
                    for (Z = te.length, K = 0; K < Z; K += 1)
                      if (te[K].pt.k.i)
                        $(te[K].pt.k);
                      else
                        for (ae = te[K].pt.k.length, re = 0; re < ae; re += 1)
                          te[K].pt.k[re].s && $(te[K].pt.k[re].s[0]), te[K].pt.k[re].e && $(te[K].pt.k[re].e[0]);
                  }
                  F.ty === 0 ? (F.layers = E(F.refId, H), M(F.layers, H)) : F.ty === 4 ? P(F.shapes) : F.ty === 5 && X(F);
                }
            }
            function _(G, H) {
              if (G) {
                var F = 0, B = G.length;
                for (F = 0; F < B; F += 1)
                  G[F].t === 1 && (G[F].data.layers = E(G[F].data.refId, H), M(G[F].data.layers, H));
              }
            }
            function S(G, H) {
              for (var F = 0, B = H.length; F < B; ) {
                if (H[F].id === G)
                  return H[F];
                F += 1;
              }
              return null;
            }
            function E(G, H) {
              var F = S(G, H);
              return F ? F.layers.__used ? JSON.parse(JSON.stringify(F.layers)) : (F.layers.__used = !0, F.layers) : null;
            }
            function P(G) {
              var H, F = G.length, B, z;
              for (H = F - 1; H >= 0; H -= 1)
                if (G[H].ty === "sh")
                  if (G[H].ks.k.i)
                    $(G[H].ks.k);
                  else
                    for (z = G[H].ks.k.length, B = 0; B < z; B += 1)
                      G[H].ks.k[B].s && $(G[H].ks.k[B].s[0]), G[H].ks.k[B].e && $(G[H].ks.k[B].e[0]);
                else
                  G[H].ty === "gr" && P(G[H].it);
            }
            function $(G) {
              var H, F = G.i.length;
              for (H = 0; H < F; H += 1)
                G.i[H][0] += G.v[H][0], G.i[H][1] += G.v[H][1], G.o[H][0] += G.v[H][0], G.o[H][1] += G.v[H][1];
            }
            function A(G, H) {
              var F = H ? H.split(".") : [100, 100, 100];
              return G[0] > F[0] ? !0 : F[0] > G[0] ? !1 : G[1] > F[1] ? !0 : F[1] > G[1] ? !1 : G[2] > F[2] ? !0 : F[2] > G[2] ? !1 : null;
            }
            var I = function() {
              var G = [4, 4, 14];
              function H(B) {
                var z = B.t.d;
                B.t.d = {
                  k: [{
                    s: z,
                    t: 0
                  }]
                };
              }
              function F(B) {
                var z, K = B.length;
                for (z = 0; z < K; z += 1)
                  B[z].ty === 5 && H(B[z]);
              }
              return function(B) {
                if (A(G, B.v) && (F(B.layers), B.assets)) {
                  var z, K = B.assets.length;
                  for (z = 0; z < K; z += 1)
                    B.assets[z].layers && F(B.assets[z].layers);
                }
              };
            }(), D = function() {
              var G = [4, 7, 99];
              return function(H) {
                if (H.chars && !A(G, H.v)) {
                  var F, B = H.chars.length;
                  for (F = 0; F < B; F += 1) {
                    var z = H.chars[F];
                    z.data && z.data.shapes && (P(z.data.shapes), z.data.ip = 0, z.data.op = 99999, z.data.st = 0, z.data.sr = 1, z.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, H.chars[F].t || (z.data.shapes.push({
                      ty: "no"
                    }), z.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              };
            }(), R = function() {
              var G = [5, 7, 15];
              function H(B) {
                var z = B.t.p;
                typeof z.a == "number" && (z.a = {
                  a: 0,
                  k: z.a
                }), typeof z.p == "number" && (z.p = {
                  a: 0,
                  k: z.p
                }), typeof z.r == "number" && (z.r = {
                  a: 0,
                  k: z.r
                });
              }
              function F(B) {
                var z, K = B.length;
                for (z = 0; z < K; z += 1)
                  B[z].ty === 5 && H(B[z]);
              }
              return function(B) {
                if (A(G, B.v) && (F(B.layers), B.assets)) {
                  var z, K = B.assets.length;
                  for (z = 0; z < K; z += 1)
                    B.assets[z].layers && F(B.assets[z].layers);
                }
              };
            }(), Y = function() {
              var G = [4, 1, 9];
              function H(B) {
                var z, K = B.length, Z, re;
                for (z = 0; z < K; z += 1)
                  if (B[z].ty === "gr")
                    H(B[z].it);
                  else if (B[z].ty === "fl" || B[z].ty === "st")
                    if (B[z].c.k && B[z].c.k[0].i)
                      for (re = B[z].c.k.length, Z = 0; Z < re; Z += 1)
                        B[z].c.k[Z].s && (B[z].c.k[Z].s[0] /= 255, B[z].c.k[Z].s[1] /= 255, B[z].c.k[Z].s[2] /= 255, B[z].c.k[Z].s[3] /= 255), B[z].c.k[Z].e && (B[z].c.k[Z].e[0] /= 255, B[z].c.k[Z].e[1] /= 255, B[z].c.k[Z].e[2] /= 255, B[z].c.k[Z].e[3] /= 255);
                    else
                      B[z].c.k[0] /= 255, B[z].c.k[1] /= 255, B[z].c.k[2] /= 255, B[z].c.k[3] /= 255;
              }
              function F(B) {
                var z, K = B.length;
                for (z = 0; z < K; z += 1)
                  B[z].ty === 4 && H(B[z].shapes);
              }
              return function(B) {
                if (A(G, B.v) && (F(B.layers), B.assets)) {
                  var z, K = B.assets.length;
                  for (z = 0; z < K; z += 1)
                    B.assets[z].layers && F(B.assets[z].layers);
                }
              };
            }(), q = function() {
              var G = [4, 4, 18];
              function H(B) {
                var z, K = B.length, Z, re;
                for (z = K - 1; z >= 0; z -= 1)
                  if (B[z].ty === "sh")
                    if (B[z].ks.k.i)
                      B[z].ks.k.c = B[z].closed;
                    else
                      for (re = B[z].ks.k.length, Z = 0; Z < re; Z += 1)
                        B[z].ks.k[Z].s && (B[z].ks.k[Z].s[0].c = B[z].closed), B[z].ks.k[Z].e && (B[z].ks.k[Z].e[0].c = B[z].closed);
                  else
                    B[z].ty === "gr" && H(B[z].it);
              }
              function F(B) {
                var z, K, Z = B.length, re, ae, te, ue;
                for (K = 0; K < Z; K += 1) {
                  if (z = B[K], z.hasMask) {
                    var ce = z.masksProperties;
                    for (ae = ce.length, re = 0; re < ae; re += 1)
                      if (ce[re].pt.k.i)
                        ce[re].pt.k.c = ce[re].cl;
                      else
                        for (ue = ce[re].pt.k.length, te = 0; te < ue; te += 1)
                          ce[re].pt.k[te].s && (ce[re].pt.k[te].s[0].c = ce[re].cl), ce[re].pt.k[te].e && (ce[re].pt.k[te].e[0].c = ce[re].cl);
                  }
                  z.ty === 4 && H(z.shapes);
                }
              }
              return function(B) {
                if (A(G, B.v) && (F(B.layers), B.assets)) {
                  var z, K = B.assets.length;
                  for (z = 0; z < K; z += 1)
                    B.assets[z].layers && F(B.assets[z].layers);
                }
              };
            }();
            function j(G) {
              G.__complete || (Y(G), I(G), D(G), R(G), q(G), M(G.layers, G.assets), _(G.chars, G.assets), G.__complete = !0);
            }
            function X(G) {
              G.t.a.length === 0 && "m" in G.t.p;
            }
            var ee = {};
            return ee.completeData = j, ee.checkColors = Y, ee.checkChars = D, ee.checkPathProperties = R, ee.checkShapes = q, ee.completeLayers = M, ee;
          }
          if (a.dataManager || (a.dataManager = C()), a.assetLoader || (a.assetLoader = function() {
            function M(S) {
              var E = S.getResponseHeader("content-type");
              return E && S.responseType === "json" && E.indexOf("json") !== -1 || S.response && _typeof$5(S.response) === "object" ? S.response : S.response && typeof S.response == "string" ? JSON.parse(S.response) : S.responseText ? JSON.parse(S.responseText) : null;
            }
            function _(S, E, P, $) {
              var A, I = new XMLHttpRequest();
              try {
                I.responseType = "json";
              } catch {
              }
              I.onreadystatechange = function() {
                if (I.readyState === 4)
                  if (I.status === 200)
                    A = M(I), P(A);
                  else
                    try {
                      A = M(I), P(A);
                    } catch (D) {
                      $ && $(D);
                    }
              };
              try {
                I.open(["G", "E", "T"].join(""), S, !0);
              } catch {
                I.open(["G", "E", "T"].join(""), E + "/" + S, !0);
              }
              I.send();
            }
            return {
              load: _
            };
          }()), g.data.type === "loadAnimation")
            a.assetLoader.load(g.data.path, g.data.fullPath, function(M) {
              a.dataManager.completeData(M), a.postMessage({
                id: g.data.id,
                payload: M,
                status: "success"
              });
            }, function() {
              a.postMessage({
                id: g.data.id,
                status: "error"
              });
            });
          else if (g.data.type === "complete") {
            var k = g.data.animation;
            a.dataManager.completeData(k), a.postMessage({
              id: g.data.id,
              payload: k,
              status: "success"
            });
          } else
            g.data.type === "loadData" && a.assetLoader.load(g.data.path, g.data.fullPath, function(M) {
              a.postMessage({
                id: g.data.id,
                payload: M,
                status: "success"
              });
            }, function() {
              a.postMessage({
                id: g.data.id,
                status: "error"
              });
            });
        }), s.onmessage = function(f) {
          var g = f.data, C = g.id, k = t[C];
          t[C] = null, g.status === "success" ? k.onComplete(g.payload) : k.onError && k.onError();
        });
      }
      function c(f, g) {
        e += 1;
        var C = "processId_" + e;
        return t[C] = {
          onComplete: f,
          onError: g
        }, C;
      }
      function u(f, g, C) {
        l();
        var k = c(g, C);
        s.postMessage({
          type: "loadAnimation",
          path: f,
          fullPath: window.location.origin + window.location.pathname,
          id: k
        });
      }
      function d(f, g, C) {
        l();
        var k = c(g, C);
        s.postMessage({
          type: "loadData",
          path: f,
          fullPath: window.location.origin + window.location.pathname,
          id: k
        });
      }
      function p(f, g, C) {
        l();
        var k = c(g, C);
        s.postMessage({
          type: "complete",
          animation: f,
          id: k
        });
      }
      return {
        loadAnimation: u,
        loadData: d,
        completeAnimation: p
      };
    }(), ImagePreloader = function() {
      var e = function() {
        var _ = createTag("canvas");
        _.width = 1, _.height = 1;
        var S = _.getContext("2d");
        return S.fillStyle = "rgba(0,0,0,0)", S.fillRect(0, 0, 1, 1), _;
      }();
      function t() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function n() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function s(_, S, E) {
        var P = "";
        if (_.e)
          P = _.p;
        else if (S) {
          var $ = _.p;
          $.indexOf("images/") !== -1 && ($ = $.split("/")[1]), P = S + $;
        } else
          P = E, P += _.u ? _.u : "", P += _.p;
        return P;
      }
      function i(_) {
        var S = 0, E = setInterval(function() {
          var P = _.getBBox();
          (P.width || S > 500) && (this._imageLoaded(), clearInterval(E)), S += 1;
        }.bind(this), 50);
      }
      function a(_) {
        var S = s(_, this.assetsPath, this.path), E = createNS("image");
        isSafari ? this.testImageLoaded(E) : E.addEventListener("load", this._imageLoaded, !1), E.addEventListener("error", function() {
          P.img = e, this._imageLoaded();
        }.bind(this), !1), E.setAttributeNS("http://www.w3.org/1999/xlink", "href", S), this._elementHelper.append ? this._elementHelper.append(E) : this._elementHelper.appendChild(E);
        var P = {
          img: E,
          assetData: _
        };
        return P;
      }
      function o(_) {
        var S = s(_, this.assetsPath, this.path), E = createTag("img");
        E.crossOrigin = "anonymous", E.addEventListener("load", this._imageLoaded, !1), E.addEventListener("error", function() {
          P.img = e, this._imageLoaded();
        }.bind(this), !1), E.src = S;
        var P = {
          img: E,
          assetData: _
        };
        return P;
      }
      function l(_) {
        var S = {
          assetData: _
        }, E = s(_, this.assetsPath, this.path);
        return dataManager.loadData(E, function(P) {
          S.img = P, this._footageLoaded();
        }.bind(this), function() {
          S.img = {}, this._footageLoaded();
        }.bind(this)), S;
      }
      function c(_, S) {
        this.imagesLoadedCb = S;
        var E, P = _.length;
        for (E = 0; E < P; E += 1)
          _[E].layers || (!_[E].t || _[E].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(_[E]))) : _[E].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(_[E]))));
      }
      function u(_) {
        this.path = _ || "";
      }
      function d(_) {
        this.assetsPath = _ || "";
      }
      function p(_) {
        for (var S = 0, E = this.images.length; S < E; ) {
          if (this.images[S].assetData === _)
            return this.images[S].img;
          S += 1;
        }
        return null;
      }
      function f() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function g() {
        return this.totalImages === this.loadedAssets;
      }
      function C() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function k(_, S) {
        _ === "svg" ? (this._elementHelper = S, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function M() {
        this._imageLoaded = t.bind(this), this._footageLoaded = n.bind(this), this.testImageLoaded = i.bind(this), this.createFootageData = l.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return M.prototype = {
        loadAssets: c,
        setAssetsPath: d,
        setPath: u,
        loadedImages: g,
        loadedFootages: C,
        destroy: f,
        getAsset: p,
        createImgData: o,
        createImageData: a,
        imageLoaded: t,
        footageLoaded: n,
        setCacheType: k
      }, M;
    }();
    function BaseEvent() {
    }
    BaseEvent.prototype = {
      triggerEvent: function(t, n) {
        if (this._cbs[t])
          for (var s = this._cbs[t], i = 0; i < s.length; i += 1)
            s[i](n);
      },
      addEventListener: function(t, n) {
        return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(n), function() {
          this.removeEventListener(t, n);
        }.bind(this);
      },
      removeEventListener: function(t, n) {
        if (!n)
          this._cbs[t] = null;
        else if (this._cbs[t]) {
          for (var s = 0, i = this._cbs[t].length; s < i; )
            this._cbs[t][s] === n && (this._cbs[t].splice(s, 1), s -= 1, i -= 1), s += 1;
          this._cbs[t].length || (this._cbs[t] = null);
        }
      }
    };
    var markerParser = function() {
      function e(t) {
        for (var n = t.split(`\r
`), s = {}, i, a = 0, o = 0; o < n.length; o += 1)
          i = n[o].split(":"), i.length === 2 && (s[i[0]] = i[1].trim(), a += 1);
        if (a === 0)
          throw new Error();
        return s;
      }
      return function(t) {
        for (var n = [], s = 0; s < t.length; s += 1) {
          var i = t[s], a = {
            time: i.tm,
            duration: i.dr
          };
          try {
            a.payload = JSON.parse(t[s].cm);
          } catch {
            try {
              a.payload = e(t[s].cm);
            } catch {
              a.payload = {
                name: t[s].cm
              };
            }
          }
          n.push(a);
        }
        return n;
      };
    }(), ProjectInterface = function() {
      function e(t) {
        this.compositions.push(t);
      }
      return function() {
        function t(n) {
          for (var s = 0, i = this.compositions.length; s < i; ) {
            if (this.compositions[s].data && this.compositions[s].data.nm === n)
              return this.compositions[s].prepareFrame && this.compositions[s].data.xt && this.compositions[s].prepareFrame(this.currentFrame), this.compositions[s].compInterface;
            s += 1;
          }
          return null;
        }
        return t.compositions = [], t.currentFrame = 0, t.registerComposition = e, t;
      };
    }(), renderers = {}, registerRenderer = function(t, n) {
      renderers[t] = n;
    };
    function getRenderer(e) {
      return renderers[e];
    }
    function _typeof$4(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$4 = function(n) {
        return typeof n;
      } : _typeof$4 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$4(e);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(e) {
      (e.wrapper || e.container) && (this.wrapper = e.wrapper || e.container);
      var t = "svg";
      e.animType ? t = e.animType : e.renderer && (t = e.renderer);
      var n = getRenderer(t);
      this.renderer = new n(this, e.rendererSettings), this.imagePreloader.setCacheType(t, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = t, e.loop === "" || e.loop === null || e.loop === void 0 || e.loop === !0 ? this.loop = !0 : e.loop === !1 ? this.loop = !1 : this.loop = parseInt(e.loop, 10), this.autoplay = "autoplay" in e ? e.autoplay : !0, this.name = e.name ? e.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(e, "autoloadSegments") ? e.autoloadSegments : !0, this.assetsPath = e.assetsPath, this.initialSegment = e.initialSegment, e.audioFactory && this.audioController.setAudioFactory(e.audioFactory), e.animationData ? this.setupAnimation(e.animationData) : e.path && (e.path.lastIndexOf("\\") !== -1 ? this.path = e.path.substr(0, e.path.lastIndexOf("\\") + 1) : this.path = e.path.substr(0, e.path.lastIndexOf("/") + 1), this.fileName = e.path.substr(e.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(e.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(e) {
      dataManager.completeAnimation(e, this.configAnimation);
    }, AnimationItem.prototype.setData = function(e, t) {
      t && _typeof$4(t) !== "object" && (t = JSON.parse(t));
      var n = {
        wrapper: e,
        animationData: t
      }, s = e.attributes;
      n.path = s.getNamedItem("data-animation-path") ? s.getNamedItem("data-animation-path").value : s.getNamedItem("data-bm-path") ? s.getNamedItem("data-bm-path").value : s.getNamedItem("bm-path") ? s.getNamedItem("bm-path").value : "", n.animType = s.getNamedItem("data-anim-type") ? s.getNamedItem("data-anim-type").value : s.getNamedItem("data-bm-type") ? s.getNamedItem("data-bm-type").value : s.getNamedItem("bm-type") ? s.getNamedItem("bm-type").value : s.getNamedItem("data-bm-renderer") ? s.getNamedItem("data-bm-renderer").value : s.getNamedItem("bm-renderer") ? s.getNamedItem("bm-renderer").value : "canvas";
      var i = s.getNamedItem("data-anim-loop") ? s.getNamedItem("data-anim-loop").value : s.getNamedItem("data-bm-loop") ? s.getNamedItem("data-bm-loop").value : s.getNamedItem("bm-loop") ? s.getNamedItem("bm-loop").value : "";
      i === "false" ? n.loop = !1 : i === "true" ? n.loop = !0 : i !== "" && (n.loop = parseInt(i, 10));
      var a = s.getNamedItem("data-anim-autoplay") ? s.getNamedItem("data-anim-autoplay").value : s.getNamedItem("data-bm-autoplay") ? s.getNamedItem("data-bm-autoplay").value : s.getNamedItem("bm-autoplay") ? s.getNamedItem("bm-autoplay").value : !0;
      n.autoplay = a !== "false", n.name = s.getNamedItem("data-name") ? s.getNamedItem("data-name").value : s.getNamedItem("data-bm-name") ? s.getNamedItem("data-bm-name").value : s.getNamedItem("bm-name") ? s.getNamedItem("bm-name").value : "";
      var o = s.getNamedItem("data-anim-prerender") ? s.getNamedItem("data-anim-prerender").value : s.getNamedItem("data-bm-prerender") ? s.getNamedItem("data-bm-prerender").value : s.getNamedItem("bm-prerender") ? s.getNamedItem("bm-prerender").value : "";
      o === "false" && (n.prerender = !1), this.setParams(n);
    }, AnimationItem.prototype.includeLayers = function(e) {
      e.op > this.animationData.op && (this.animationData.op = e.op, this.totalFrames = Math.floor(e.op - this.animationData.ip));
      var t = this.animationData.layers, n, s = t.length, i = e.layers, a, o = i.length;
      for (a = 0; a < o; a += 1)
        for (n = 0; n < s; ) {
          if (t[n].id === i[a].id) {
            t[n] = i[a];
            break;
          }
          n += 1;
        }
      if ((e.chars || e.fonts) && (this.renderer.globalData.fontManager.addChars(e.chars), this.renderer.globalData.fontManager.addFonts(e.fonts, this.renderer.globalData.defs)), e.assets)
        for (s = e.assets.length, n = 0; n < s; n += 1)
          this.animationData.assets.push(e.assets[n]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(e) {
      this.animationData = e;
      var t = getExpressionsPlugin();
      t && t.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var e = this.animationData.segments;
      if (!e || e.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var t = e.shift();
      this.timeCompleted = t.time * this.frameRate;
      var n = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(n, this.includeLayers.bind(this), function() {
        this.trigger("data_failed");
      }.bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      var e = this.animationData.segments;
      e || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(e) {
      if (this.renderer)
        try {
          this.animationData = e, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(e), e.assets || (e.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(e.assets), this.markers = markerParser(e.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (t) {
          this.triggerConfigError(t);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var e = getExpressionsPlugin();
        e && e.initExpressions(this), this.renderer.initItems(), setTimeout(function() {
          this.trigger("DOMLoaded");
        }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(e, t) {
      var n = typeof e == "number" ? e : void 0, s = typeof t == "number" ? t : void 0;
      this.renderer.updateContainerSize(n, s);
    }, AnimationItem.prototype.setSubframe = function(e) {
      this.isSubframeEnabled = !!e;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (e) {
          this.triggerRenderFrameError(e);
        }
    }, AnimationItem.prototype.play = function(e) {
      e && this.name !== e || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_pause"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(e) {
      e && this.name !== e || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_play"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(e) {
      e && this.name !== e || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(e) {
      e && this.name !== e || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(e) {
      for (var t, n = 0; n < this.markers.length; n += 1)
        if (t = this.markers[n], t.payload && t.payload.name === e)
          return t;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(e, t, n) {
      if (!(n && this.name !== n)) {
        var s = Number(e);
        if (isNaN(s)) {
          var i = this.getMarkerData(e);
          i && this.goToAndStop(i.time, !0);
        } else
          t ? this.setCurrentRawFrameValue(e) : this.setCurrentRawFrameValue(e * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(e, t, n) {
      if (!(n && this.name !== n)) {
        var s = Number(e);
        if (isNaN(s)) {
          var i = this.getMarkerData(e);
          i && (i.duration ? this.playSegments([i.time, i.time + i.duration], !0) : this.goToAndStop(i.time, !0));
        } else
          this.goToAndStop(s, t, n);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(e) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var t = this.currentRawFrame + e * this.frameModifier, n = !1;
        t >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(t > this.totalFrames ? t % this.totalFrames : 0) || (n = !0, t = this.totalFrames - 1) : t >= this.totalFrames ? (this.playCount += 1, this.checkSegments(t % this.totalFrames) || (this.setCurrentRawFrameValue(t % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(t) : t < 0 ? this.checkSegments(t % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + t % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (n = !0, t = 0)) : this.setCurrentRawFrameValue(t), n && (this.setCurrentRawFrameValue(t), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(e, t) {
      this.playCount = 0, e[1] < e[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = e[0] - e[1], this.timeCompleted = this.totalFrames, this.firstFrame = e[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - t)) : e[1] > e[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = e[1] - e[0], this.timeCompleted = this.totalFrames, this.firstFrame = e[0], this.setCurrentRawFrameValue(1e-3 + t)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(e, t) {
      var n = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < e ? n = e : this.currentRawFrame + this.firstFrame > t && (n = t - e)), this.firstFrame = e, this.totalFrames = t - e, this.timeCompleted = this.totalFrames, n !== -1 && this.goToAndStop(n, !0);
    }, AnimationItem.prototype.playSegments = function(e, t) {
      if (t && (this.segments.length = 0), _typeof$4(e[0]) === "object") {
        var n, s = e.length;
        for (n = 0; n < s; n += 1)
          this.segments.push(e[n]);
      } else
        this.segments.push(e);
      this.segments.length && t && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(e) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), e && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(e) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), e), !0) : !1;
    }, AnimationItem.prototype.destroy = function(e) {
      e && this.name !== e || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.renderer = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(e) {
      this.currentRawFrame = e, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(e) {
      this.playSpeed = e, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(e) {
      this.playDirection = e < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(e) {
      this.loop = e;
    }, AnimationItem.prototype.setVolume = function(e, t) {
      t && this.name !== t || this.audioController.setVolume(e);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(e) {
      e && this.name !== e || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(e) {
      e && this.name !== e || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(e) {
      var t = "";
      if (e.e)
        t = e.p;
      else if (this.assetsPath) {
        var n = e.p;
        n.indexOf("images/") !== -1 && (n = n.split("/")[1]), t = this.assetsPath + n;
      } else
        t = this.path, t += e.u ? e.u : "", t += e.p;
      return t;
    }, AnimationItem.prototype.getAssetData = function(e) {
      for (var t = 0, n = this.assets.length; t < n; ) {
        if (e === this.assets[t].id)
          return this.assets[t];
        t += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(e) {
      return e ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(e, t, n) {
      try {
        var s = this.renderer.getElementByPath(e);
        s.updateDocumentData(t, n);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(e) {
      if (this._cbs && this._cbs[e])
        switch (e) {
          case "enterFrame":
            this.triggerEvent(e, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(e, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(e, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(e, new BMCompleteEvent(e, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(e, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(e, new BMDestroyEvent(e, this));
            break;
          default:
            this.triggerEvent(e);
        }
      e === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameMult)), e === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult)), e === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(e, this.frameMult)), e === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames)), e === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(e, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(e) {
      var t = new BMRenderFrameErrorEvent(e, this.currentFrame);
      this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
    }, AnimationItem.prototype.triggerConfigError = function(e) {
      var t = new BMConfigErrorEvent(e, this.currentFrame);
      this.triggerEvent("error", t), this.onError && this.onError.call(this, t);
    };
    var animationManager = function() {
      var e = {}, t = [], n = 0, s = 0, i = 0, a = !0, o = !1;
      function l(H) {
        for (var F = 0, B = H.target; F < s; )
          t[F].animation === B && (t.splice(F, 1), F -= 1, s -= 1, B.isPaused || p()), F += 1;
      }
      function c(H, F) {
        if (!H)
          return null;
        for (var B = 0; B < s; ) {
          if (t[B].elem === H && t[B].elem !== null)
            return t[B].animation;
          B += 1;
        }
        var z = new AnimationItem();
        return f(z, H), z.setData(H, F), z;
      }
      function u() {
        var H, F = t.length, B = [];
        for (H = 0; H < F; H += 1)
          B.push(t[H].animation);
        return B;
      }
      function d() {
        i += 1, Y();
      }
      function p() {
        i -= 1;
      }
      function f(H, F) {
        H.addEventListener("destroy", l), H.addEventListener("_active", d), H.addEventListener("_idle", p), t.push({
          elem: F,
          animation: H
        }), s += 1;
      }
      function g(H) {
        var F = new AnimationItem();
        return f(F, null), F.setParams(H), F;
      }
      function C(H, F) {
        var B;
        for (B = 0; B < s; B += 1)
          t[B].animation.setSpeed(H, F);
      }
      function k(H, F) {
        var B;
        for (B = 0; B < s; B += 1)
          t[B].animation.setDirection(H, F);
      }
      function M(H) {
        var F;
        for (F = 0; F < s; F += 1)
          t[F].animation.play(H);
      }
      function _(H) {
        var F = H - n, B;
        for (B = 0; B < s; B += 1)
          t[B].animation.advanceTime(F);
        n = H, i && !o ? window.requestAnimationFrame(_) : a = !0;
      }
      function S(H) {
        n = H, window.requestAnimationFrame(_);
      }
      function E(H) {
        var F;
        for (F = 0; F < s; F += 1)
          t[F].animation.pause(H);
      }
      function P(H, F, B) {
        var z;
        for (z = 0; z < s; z += 1)
          t[z].animation.goToAndStop(H, F, B);
      }
      function $(H) {
        var F;
        for (F = 0; F < s; F += 1)
          t[F].animation.stop(H);
      }
      function A(H) {
        var F;
        for (F = 0; F < s; F += 1)
          t[F].animation.togglePause(H);
      }
      function I(H) {
        var F;
        for (F = s - 1; F >= 0; F -= 1)
          t[F].animation.destroy(H);
      }
      function D(H, F, B) {
        var z = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), K, Z = z.length;
        for (K = 0; K < Z; K += 1)
          B && z[K].setAttribute("data-bm-type", B), c(z[K], H);
        if (F && Z === 0) {
          B || (B = "svg");
          var re = document.getElementsByTagName("body")[0];
          re.innerText = "";
          var ae = createTag("div");
          ae.style.width = "100%", ae.style.height = "100%", ae.setAttribute("data-bm-type", B), re.appendChild(ae), c(ae, H);
        }
      }
      function R() {
        var H;
        for (H = 0; H < s; H += 1)
          t[H].animation.resize();
      }
      function Y() {
        !o && i && a && (window.requestAnimationFrame(S), a = !1);
      }
      function q() {
        o = !0;
      }
      function j() {
        o = !1, Y();
      }
      function X(H, F) {
        var B;
        for (B = 0; B < s; B += 1)
          t[B].animation.setVolume(H, F);
      }
      function ee(H) {
        var F;
        for (F = 0; F < s; F += 1)
          t[F].animation.mute(H);
      }
      function G(H) {
        var F;
        for (F = 0; F < s; F += 1)
          t[F].animation.unmute(H);
      }
      return e.registerAnimation = c, e.loadAnimation = g, e.setSpeed = C, e.setDirection = k, e.play = M, e.pause = E, e.stop = $, e.togglePause = A, e.searchAnimations = D, e.resize = R, e.goToAndStop = P, e.destroy = I, e.freeze = q, e.unfreeze = j, e.setVolume = X, e.mute = ee, e.unmute = G, e.getRegisteredAnimations = u, e;
    }(), BezierFactory = function() {
      var e = {};
      e.getBezierEasing = n;
      var t = {};
      function n(S, E, P, $, A) {
        var I = A || ("bez_" + S + "_" + E + "_" + P + "_" + $).replace(/\./g, "p");
        if (t[I])
          return t[I];
        var D = new _([S, E, P, $]);
        return t[I] = D, D;
      }
      var s = 4, i = 1e-3, a = 1e-7, o = 10, l = 11, c = 1 / (l - 1), u = typeof Float32Array == "function";
      function d(S, E) {
        return 1 - 3 * E + 3 * S;
      }
      function p(S, E) {
        return 3 * E - 6 * S;
      }
      function f(S) {
        return 3 * S;
      }
      function g(S, E, P) {
        return ((d(E, P) * S + p(E, P)) * S + f(E)) * S;
      }
      function C(S, E, P) {
        return 3 * d(E, P) * S * S + 2 * p(E, P) * S + f(E);
      }
      function k(S, E, P, $, A) {
        var I, D, R = 0;
        do
          D = E + (P - E) / 2, I = g(D, $, A) - S, I > 0 ? P = D : E = D;
        while (Math.abs(I) > a && ++R < o);
        return D;
      }
      function M(S, E, P, $) {
        for (var A = 0; A < s; ++A) {
          var I = C(E, P, $);
          if (I === 0)
            return E;
          var D = g(E, P, $) - S;
          E -= D / I;
        }
        return E;
      }
      function _(S) {
        this._p = S, this._mSampleValues = u ? new Float32Array(l) : new Array(l), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return _.prototype = {
        get: function(E) {
          var P = this._p[0], $ = this._p[1], A = this._p[2], I = this._p[3];
          return this._precomputed || this._precompute(), P === $ && A === I ? E : E === 0 ? 0 : E === 1 ? 1 : g(this._getTForX(E), $, I);
        },
        // Private part
        _precompute: function() {
          var E = this._p[0], P = this._p[1], $ = this._p[2], A = this._p[3];
          this._precomputed = !0, (E !== P || $ !== A) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var E = this._p[0], P = this._p[2], $ = 0; $ < l; ++$)
            this._mSampleValues[$] = g($ * c, E, P);
        },
        /**
             * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
             */
        _getTForX: function(E) {
          for (var P = this._p[0], $ = this._p[2], A = this._mSampleValues, I = 0, D = 1, R = l - 1; D !== R && A[D] <= E; ++D)
            I += c;
          --D;
          var Y = (E - A[D]) / (A[D + 1] - A[D]), q = I + Y * c, j = C(q, P, $);
          return j >= i ? M(E, q, P, $) : j === 0 ? q : k(E, I, I + c, P, $);
        }
      }, e;
    }(), pooling = function() {
      function e(t) {
        return t.concat(createSizedArray(t.length));
      }
      return {
        double: e
      };
    }(), poolFactory = function() {
      return function(e, t, n) {
        var s = 0, i = e, a = createSizedArray(i), o = {
          newElement: l,
          release: c
        };
        function l() {
          var u;
          return s ? (s -= 1, u = a[s]) : u = t(), u;
        }
        function c(u) {
          s === i && (a = pooling.double(a), i *= 2), n && n(u), a[s] = u, s += 1;
        }
        return o;
      };
    }(), bezierLengthPool = function() {
      function e() {
        return {
          addedLength: 0,
          percents: createTypedArray("float32", getDefaultCurveSegments()),
          lengths: createTypedArray("float32", getDefaultCurveSegments())
        };
      }
      return poolFactory(8, e);
    }(), segmentsLengthPool = function() {
      function e() {
        return {
          lengths: [],
          totalLength: 0
        };
      }
      function t(n) {
        var s, i = n.lengths.length;
        for (s = 0; s < i; s += 1)
          bezierLengthPool.release(n.lengths[s]);
        n.lengths.length = 0;
      }
      return poolFactory(8, e, t);
    }();
    function bezFunction() {
      var e = Math;
      function t(f, g, C, k, M, _) {
        var S = f * k + g * M + C * _ - M * k - _ * f - C * g;
        return S > -1e-3 && S < 1e-3;
      }
      function n(f, g, C, k, M, _, S, E, P) {
        if (C === 0 && _ === 0 && P === 0)
          return t(f, g, k, M, S, E);
        var $ = e.sqrt(e.pow(k - f, 2) + e.pow(M - g, 2) + e.pow(_ - C, 2)), A = e.sqrt(e.pow(S - f, 2) + e.pow(E - g, 2) + e.pow(P - C, 2)), I = e.sqrt(e.pow(S - k, 2) + e.pow(E - M, 2) + e.pow(P - _, 2)), D;
        return $ > A ? $ > I ? D = $ - A - I : D = I - A - $ : I > A ? D = I - A - $ : D = A - $ - I, D > -1e-4 && D < 1e-4;
      }
      var s = function() {
        return function(f, g, C, k) {
          var M = getDefaultCurveSegments(), _, S, E, P, $, A = 0, I, D = [], R = [], Y = bezierLengthPool.newElement();
          for (E = C.length, _ = 0; _ < M; _ += 1) {
            for ($ = _ / (M - 1), I = 0, S = 0; S < E; S += 1)
              P = bmPow(1 - $, 3) * f[S] + 3 * bmPow(1 - $, 2) * $ * C[S] + 3 * (1 - $) * bmPow($, 2) * k[S] + bmPow($, 3) * g[S], D[S] = P, R[S] !== null && (I += bmPow(D[S] - R[S], 2)), R[S] = D[S];
            I && (I = bmSqrt(I), A += I), Y.percents[_] = $, Y.lengths[_] = A;
          }
          return Y.addedLength = A, Y;
        };
      }();
      function i(f) {
        var g = segmentsLengthPool.newElement(), C = f.c, k = f.v, M = f.o, _ = f.i, S, E = f._length, P = g.lengths, $ = 0;
        for (S = 0; S < E - 1; S += 1)
          P[S] = s(k[S], k[S + 1], M[S], _[S + 1]), $ += P[S].addedLength;
        return C && E && (P[S] = s(k[S], k[0], M[S], _[0]), $ += P[S].addedLength), g.totalLength = $, g;
      }
      function a(f) {
        this.segmentLength = 0, this.points = new Array(f);
      }
      function o(f, g) {
        this.partialLength = f, this.point = g;
      }
      var l = function() {
        var f = {};
        return function(g, C, k, M) {
          var _ = (g[0] + "_" + g[1] + "_" + C[0] + "_" + C[1] + "_" + k[0] + "_" + k[1] + "_" + M[0] + "_" + M[1]).replace(/\./g, "p");
          if (!f[_]) {
            var S = getDefaultCurveSegments(), E, P, $, A, I, D = 0, R, Y, q = null;
            g.length === 2 && (g[0] !== C[0] || g[1] !== C[1]) && t(g[0], g[1], C[0], C[1], g[0] + k[0], g[1] + k[1]) && t(g[0], g[1], C[0], C[1], C[0] + M[0], C[1] + M[1]) && (S = 2);
            var j = new a(S);
            for ($ = k.length, E = 0; E < S; E += 1) {
              for (Y = createSizedArray($), I = E / (S - 1), R = 0, P = 0; P < $; P += 1)
                A = bmPow(1 - I, 3) * g[P] + 3 * bmPow(1 - I, 2) * I * (g[P] + k[P]) + 3 * (1 - I) * bmPow(I, 2) * (C[P] + M[P]) + bmPow(I, 3) * C[P], Y[P] = A, q !== null && (R += bmPow(Y[P] - q[P], 2));
              R = bmSqrt(R), D += R, j.points[E] = new o(R, Y), q = Y;
            }
            j.segmentLength = D, f[_] = j;
          }
          return f[_];
        };
      }();
      function c(f, g) {
        var C = g.percents, k = g.lengths, M = C.length, _ = bmFloor((M - 1) * f), S = f * g.addedLength, E = 0;
        if (_ === M - 1 || _ === 0 || S === k[_])
          return C[_];
        for (var P = k[_] > S ? -1 : 1, $ = !0; $; )
          if (k[_] <= S && k[_ + 1] > S ? (E = (S - k[_]) / (k[_ + 1] - k[_]), $ = !1) : _ += P, _ < 0 || _ >= M - 1) {
            if (_ === M - 1)
              return C[_];
            $ = !1;
          }
        return C[_] + (C[_ + 1] - C[_]) * E;
      }
      function u(f, g, C, k, M, _) {
        var S = c(M, _), E = 1 - S, P = e.round((E * E * E * f[0] + (S * E * E + E * S * E + E * E * S) * C[0] + (S * S * E + E * S * S + S * E * S) * k[0] + S * S * S * g[0]) * 1e3) / 1e3, $ = e.round((E * E * E * f[1] + (S * E * E + E * S * E + E * E * S) * C[1] + (S * S * E + E * S * S + S * E * S) * k[1] + S * S * S * g[1]) * 1e3) / 1e3;
        return [P, $];
      }
      var d = createTypedArray("float32", 8);
      function p(f, g, C, k, M, _, S) {
        M < 0 ? M = 0 : M > 1 && (M = 1);
        var E = c(M, S);
        _ = _ > 1 ? 1 : _;
        var P = c(_, S), $, A = f.length, I = 1 - E, D = 1 - P, R = I * I * I, Y = E * I * I * 3, q = E * E * I * 3, j = E * E * E, X = I * I * D, ee = E * I * D + I * E * D + I * I * P, G = E * E * D + I * E * P + E * I * P, H = E * E * P, F = I * D * D, B = E * D * D + I * P * D + I * D * P, z = E * P * D + I * P * P + E * D * P, K = E * P * P, Z = D * D * D, re = P * D * D + D * P * D + D * D * P, ae = P * P * D + D * P * P + P * D * P, te = P * P * P;
        for ($ = 0; $ < A; $ += 1)
          d[$ * 4] = e.round((R * f[$] + Y * C[$] + q * k[$] + j * g[$]) * 1e3) / 1e3, d[$ * 4 + 1] = e.round((X * f[$] + ee * C[$] + G * k[$] + H * g[$]) * 1e3) / 1e3, d[$ * 4 + 2] = e.round((F * f[$] + B * C[$] + z * k[$] + K * g[$]) * 1e3) / 1e3, d[$ * 4 + 3] = e.round((Z * f[$] + re * C[$] + ae * k[$] + te * g[$]) * 1e3) / 1e3;
        return d;
      }
      return {
        getSegmentsLength: i,
        getNewSegment: p,
        getPointInSegment: u,
        buildBezierData: l,
        pointOnLine2D: t,
        pointOnLine3D: n
      };
    }
    var bez = bezFunction(), PropertyFactory = function() {
      var e = initialDefaultFrame, t = Math.abs;
      function n(M, _) {
        var S = this.offsetTime, E;
        this.propType === "multidimensional" && (E = createTypedArray("float32", this.pv.length));
        for (var P = _.lastIndex, $ = P, A = this.keyframes.length - 1, I = !0, D, R, Y; I; ) {
          if (D = this.keyframes[$], R = this.keyframes[$ + 1], $ === A - 1 && M >= R.t - S) {
            D.h && (D = R), P = 0;
            break;
          }
          if (R.t - S > M) {
            P = $;
            break;
          }
          $ < A - 1 ? $ += 1 : (P = 0, I = !1);
        }
        Y = this.keyframesMetadata[$] || {};
        var q, j, X, ee, G, H, F = R.t - S, B = D.t - S, z;
        if (D.to) {
          Y.bezierData || (Y.bezierData = bez.buildBezierData(D.s, R.s || D.e, D.to, D.ti));
          var K = Y.bezierData;
          if (M >= F || M < B) {
            var Z = M >= F ? K.points.length - 1 : 0;
            for (j = K.points[Z].point.length, q = 0; q < j; q += 1)
              E[q] = K.points[Z].point[q];
          } else {
            Y.__fnct ? H = Y.__fnct : (H = BezierFactory.getBezierEasing(D.o.x, D.o.y, D.i.x, D.i.y, D.n).get, Y.__fnct = H), X = H((M - B) / (F - B));
            var re = K.segmentLength * X, ae, te = _.lastFrame < M && _._lastKeyframeIndex === $ ? _._lastAddedLength : 0;
            for (G = _.lastFrame < M && _._lastKeyframeIndex === $ ? _._lastPoint : 0, I = !0, ee = K.points.length; I; ) {
              if (te += K.points[G].partialLength, re === 0 || X === 0 || G === K.points.length - 1) {
                for (j = K.points[G].point.length, q = 0; q < j; q += 1)
                  E[q] = K.points[G].point[q];
                break;
              } else if (re >= te && re < te + K.points[G + 1].partialLength) {
                for (ae = (re - te) / K.points[G + 1].partialLength, j = K.points[G].point.length, q = 0; q < j; q += 1)
                  E[q] = K.points[G].point[q] + (K.points[G + 1].point[q] - K.points[G].point[q]) * ae;
                break;
              }
              G < ee - 1 ? G += 1 : I = !1;
            }
            _._lastPoint = G, _._lastAddedLength = te - K.points[G].partialLength, _._lastKeyframeIndex = $;
          }
        } else {
          var ue, ce, ge, de, le;
          if (A = D.s.length, z = R.s || D.e, this.sh && D.h !== 1)
            if (M >= F)
              E[0] = z[0], E[1] = z[1], E[2] = z[2];
            else if (M <= B)
              E[0] = D.s[0], E[1] = D.s[1], E[2] = D.s[2];
            else {
              var me = a(D.s), ve = a(z), be = (M - B) / (F - B);
              i(E, s(me, ve, be));
            }
          else
            for ($ = 0; $ < A; $ += 1)
              D.h !== 1 && (M >= F ? X = 1 : M < B ? X = 0 : (D.o.x.constructor === Array ? (Y.__fnct || (Y.__fnct = []), Y.__fnct[$] ? H = Y.__fnct[$] : (ue = D.o.x[$] === void 0 ? D.o.x[0] : D.o.x[$], ce = D.o.y[$] === void 0 ? D.o.y[0] : D.o.y[$], ge = D.i.x[$] === void 0 ? D.i.x[0] : D.i.x[$], de = D.i.y[$] === void 0 ? D.i.y[0] : D.i.y[$], H = BezierFactory.getBezierEasing(ue, ce, ge, de).get, Y.__fnct[$] = H)) : Y.__fnct ? H = Y.__fnct : (ue = D.o.x, ce = D.o.y, ge = D.i.x, de = D.i.y, H = BezierFactory.getBezierEasing(ue, ce, ge, de).get, D.keyframeMetadata = H), X = H((M - B) / (F - B)))), z = R.s || D.e, le = D.h === 1 ? D.s[$] : D.s[$] + (z[$] - D.s[$]) * X, this.propType === "multidimensional" ? E[$] = le : E = le;
        }
        return _.lastIndex = P, E;
      }
      function s(M, _, S) {
        var E = [], P = M[0], $ = M[1], A = M[2], I = M[3], D = _[0], R = _[1], Y = _[2], q = _[3], j, X, ee, G, H;
        return X = P * D + $ * R + A * Y + I * q, X < 0 && (X = -X, D = -D, R = -R, Y = -Y, q = -q), 1 - X > 1e-6 ? (j = Math.acos(X), ee = Math.sin(j), G = Math.sin((1 - S) * j) / ee, H = Math.sin(S * j) / ee) : (G = 1 - S, H = S), E[0] = G * P + H * D, E[1] = G * $ + H * R, E[2] = G * A + H * Y, E[3] = G * I + H * q, E;
      }
      function i(M, _) {
        var S = _[0], E = _[1], P = _[2], $ = _[3], A = Math.atan2(2 * E * $ - 2 * S * P, 1 - 2 * E * E - 2 * P * P), I = Math.asin(2 * S * E + 2 * P * $), D = Math.atan2(2 * S * $ - 2 * E * P, 1 - 2 * S * S - 2 * P * P);
        M[0] = A / degToRads, M[1] = I / degToRads, M[2] = D / degToRads;
      }
      function a(M) {
        var _ = M[0] * degToRads, S = M[1] * degToRads, E = M[2] * degToRads, P = Math.cos(_ / 2), $ = Math.cos(S / 2), A = Math.cos(E / 2), I = Math.sin(_ / 2), D = Math.sin(S / 2), R = Math.sin(E / 2), Y = P * $ * A - I * D * R, q = I * D * A + P * $ * R, j = I * $ * A + P * D * R, X = P * D * A - I * $ * R;
        return [q, j, X, Y];
      }
      function o() {
        var M = this.comp.renderedFrame - this.offsetTime, _ = this.keyframes[0].t - this.offsetTime, S = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(M === this._caching.lastFrame || this._caching.lastFrame !== e && (this._caching.lastFrame >= S && M >= S || this._caching.lastFrame < _ && M < _))) {
          this._caching.lastFrame >= M && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
          var E = this.interpolateValue(M, this._caching);
          this.pv = E;
        }
        return this._caching.lastFrame = M, this.pv;
      }
      function l(M) {
        var _;
        if (this.propType === "unidimensional")
          _ = M * this.mult, t(this.v - _) > 1e-5 && (this.v = _, this._mdf = !0);
        else
          for (var S = 0, E = this.v.length; S < E; )
            _ = M[S] * this.mult, t(this.v[S] - _) > 1e-5 && (this.v[S] = _, this._mdf = !0), S += 1;
      }
      function c() {
        if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = this._isFirstFrame;
          var M, _ = this.effectsSequence.length, S = this.kf ? this.pv : this.data.k;
          for (M = 0; M < _; M += 1)
            S = this.effectsSequence[M](S);
          this.setVValue(S), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function u(M) {
        this.effectsSequence.push(M), this.container.addDynamicProperty(this);
      }
      function d(M, _, S, E) {
        this.propType = "unidimensional", this.mult = S || 1, this.data = _, this.v = S ? _.k * S : _.k, this.pv = _.k, this._mdf = !1, this.elem = M, this.container = E, this.comp = M.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = c, this.setVValue = l, this.addEffect = u;
      }
      function p(M, _, S, E) {
        this.propType = "multidimensional", this.mult = S || 1, this.data = _, this._mdf = !1, this.elem = M, this.container = E, this.comp = M.comp, this.k = !1, this.kf = !1, this.frameId = -1;
        var P, $ = _.k.length;
        for (this.v = createTypedArray("float32", $), this.pv = createTypedArray("float32", $), this.vel = createTypedArray("float32", $), P = 0; P < $; P += 1)
          this.v[P] = _.k[P] * this.mult, this.pv[P] = _.k[P];
        this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = c, this.setVValue = l, this.addEffect = u;
      }
      function f(M, _, S, E) {
        this.propType = "unidimensional", this.keyframes = _.k, this.keyframesMetadata = [], this.offsetTime = M.data.st, this.frameId = -1, this._caching = {
          lastFrame: e,
          lastIndex: 0,
          value: 0,
          _lastKeyframeIndex: -1
        }, this.k = !0, this.kf = !0, this.data = _, this.mult = S || 1, this.elem = M, this.container = E, this.comp = M.comp, this.v = e, this.pv = e, this._isFirstFrame = !0, this.getValue = c, this.setVValue = l, this.interpolateValue = n, this.effectsSequence = [o.bind(this)], this.addEffect = u;
      }
      function g(M, _, S, E) {
        this.propType = "multidimensional";
        var P, $ = _.k.length, A, I, D, R;
        for (P = 0; P < $ - 1; P += 1)
          _.k[P].to && _.k[P].s && _.k[P + 1] && _.k[P + 1].s && (A = _.k[P].s, I = _.k[P + 1].s, D = _.k[P].to, R = _.k[P].ti, (A.length === 2 && !(A[0] === I[0] && A[1] === I[1]) && bez.pointOnLine2D(A[0], A[1], I[0], I[1], A[0] + D[0], A[1] + D[1]) && bez.pointOnLine2D(A[0], A[1], I[0], I[1], I[0] + R[0], I[1] + R[1]) || A.length === 3 && !(A[0] === I[0] && A[1] === I[1] && A[2] === I[2]) && bez.pointOnLine3D(A[0], A[1], A[2], I[0], I[1], I[2], A[0] + D[0], A[1] + D[1], A[2] + D[2]) && bez.pointOnLine3D(A[0], A[1], A[2], I[0], I[1], I[2], I[0] + R[0], I[1] + R[1], I[2] + R[2])) && (_.k[P].to = null, _.k[P].ti = null), A[0] === I[0] && A[1] === I[1] && D[0] === 0 && D[1] === 0 && R[0] === 0 && R[1] === 0 && (A.length === 2 || A[2] === I[2] && D[2] === 0 && R[2] === 0) && (_.k[P].to = null, _.k[P].ti = null));
        this.effectsSequence = [o.bind(this)], this.data = _, this.keyframes = _.k, this.keyframesMetadata = [], this.offsetTime = M.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = S || 1, this.elem = M, this.container = E, this.comp = M.comp, this.getValue = c, this.setVValue = l, this.interpolateValue = n, this.frameId = -1;
        var Y = _.k[0].s.length;
        for (this.v = createTypedArray("float32", Y), this.pv = createTypedArray("float32", Y), P = 0; P < Y; P += 1)
          this.v[P] = e, this.pv[P] = e;
        this._caching = {
          lastFrame: e,
          lastIndex: 0,
          value: createTypedArray("float32", Y)
        }, this.addEffect = u;
      }
      function C(M, _, S, E, P) {
        var $;
        if (!_.k.length)
          $ = new d(M, _, E, P);
        else if (typeof _.k[0] == "number")
          $ = new p(M, _, E, P);
        else
          switch (S) {
            case 0:
              $ = new f(M, _, E, P);
              break;
            case 1:
              $ = new g(M, _, E, P);
              break;
          }
        return $.effectsSequence.length && P.addDynamicProperty($), $;
      }
      var k = {
        getProp: C
      };
      return k;
    }();
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = {
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
      },
      iterateDynamicProperties: function() {
        this._mdf = !1;
        var t, n = this.dynamicProperties.length;
        for (t = 0; t < n; t += 1)
          this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function(t) {
        this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
      }
    };
    var pointPool = function() {
      function e() {
        return createTypedArray("float32", 2);
      }
      return poolFactory(8, e);
    }();
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(e, t) {
      this.c = e, this.setLength(t);
      for (var n = 0; n < t; )
        this.v[n] = pointPool.newElement(), this.o[n] = pointPool.newElement(), this.i[n] = pointPool.newElement(), n += 1;
    }, ShapePath.prototype.setLength = function(e) {
      for (; this._maxLength < e; )
        this.doubleArrayLength();
      this._length = e;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(e, t, n, s, i) {
      var a;
      switch (this._length = Math.max(this._length, s + 1), this._length >= this._maxLength && this.doubleArrayLength(), n) {
        case "v":
          a = this.v;
          break;
        case "i":
          a = this.i;
          break;
        case "o":
          a = this.o;
          break;
        default:
          a = [];
          break;
      }
      (!a[s] || a[s] && !i) && (a[s] = pointPool.newElement()), a[s][0] = e, a[s][1] = t;
    }, ShapePath.prototype.setTripleAt = function(e, t, n, s, i, a, o, l) {
      this.setXYAt(e, t, "v", o, l), this.setXYAt(n, s, "o", o, l), this.setXYAt(i, a, "i", o, l);
    }, ShapePath.prototype.reverse = function() {
      var e = new ShapePath();
      e.setPathData(this.c, this._length);
      var t = this.v, n = this.o, s = this.i, i = 0;
      this.c && (e.setTripleAt(t[0][0], t[0][1], s[0][0], s[0][1], n[0][0], n[0][1], 0, !1), i = 1);
      var a = this._length - 1, o = this._length, l;
      for (l = i; l < o; l += 1)
        e.setTripleAt(t[a][0], t[a][1], s[a][0], s[a][1], n[a][0], n[a][1], l, !1), a -= 1;
      return e;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = function() {
      function e() {
        return new ShapePath();
      }
      function t(i) {
        var a = i._length, o;
        for (o = 0; o < a; o += 1)
          pointPool.release(i.v[o]), pointPool.release(i.i[o]), pointPool.release(i.o[o]), i.v[o] = null, i.i[o] = null, i.o[o] = null;
        i._length = 0, i.c = !1;
      }
      function n(i) {
        var a = s.newElement(), o, l = i._length === void 0 ? i.v.length : i._length;
        for (a.setLength(l), a.c = i.c, o = 0; o < l; o += 1)
          a.setTripleAt(i.v[o][0], i.v[o][1], i.o[o][0], i.o[o][1], i.i[o][0], i.i[o][1], o);
        return a;
      }
      var s = poolFactory(4, e, t);
      return s.clone = n, s;
    }();
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(e) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = e, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var e;
      for (e = 0; e < this._length; e += 1)
        shapePool.release(this.shapes[e]);
      this._length = 0;
    };
    var shapeCollectionPool = function() {
      var e = {
        newShapeCollection: i,
        release: a
      }, t = 0, n = 4, s = createSizedArray(n);
      function i() {
        var o;
        return t ? (t -= 1, o = s[t]) : o = new ShapeCollection(), o;
      }
      function a(o) {
        var l, c = o._length;
        for (l = 0; l < c; l += 1)
          shapePool.release(o.shapes[l]);
        o._length = 0, t === n && (s = pooling.double(s), n *= 2), s[t] = o, t += 1;
      }
      return e;
    }(), ShapePropertyFactory = function() {
      var e = -999999;
      function t(_, S, E) {
        var P = E.lastIndex, $, A, I, D, R, Y, q, j, X, ee = this.keyframes;
        if (_ < ee[0].t - this.offsetTime)
          $ = ee[0].s[0], I = !0, P = 0;
        else if (_ >= ee[ee.length - 1].t - this.offsetTime)
          $ = ee[ee.length - 1].s ? ee[ee.length - 1].s[0] : ee[ee.length - 2].e[0], I = !0;
        else {
          for (var G = P, H = ee.length - 1, F = !0, B, z, K; F && (B = ee[G], z = ee[G + 1], !(z.t - this.offsetTime > _)); )
            G < H - 1 ? G += 1 : F = !1;
          if (K = this.keyframesMetadata[G] || {}, I = B.h === 1, P = G, !I) {
            if (_ >= z.t - this.offsetTime)
              j = 1;
            else if (_ < B.t - this.offsetTime)
              j = 0;
            else {
              var Z;
              K.__fnct ? Z = K.__fnct : (Z = BezierFactory.getBezierEasing(B.o.x, B.o.y, B.i.x, B.i.y).get, K.__fnct = Z), j = Z((_ - (B.t - this.offsetTime)) / (z.t - this.offsetTime - (B.t - this.offsetTime)));
            }
            A = z.s ? z.s[0] : B.e[0];
          }
          $ = B.s[0];
        }
        for (Y = S._length, q = $.i[0].length, E.lastIndex = P, D = 0; D < Y; D += 1)
          for (R = 0; R < q; R += 1)
            X = I ? $.i[D][R] : $.i[D][R] + (A.i[D][R] - $.i[D][R]) * j, S.i[D][R] = X, X = I ? $.o[D][R] : $.o[D][R] + (A.o[D][R] - $.o[D][R]) * j, S.o[D][R] = X, X = I ? $.v[D][R] : $.v[D][R] + (A.v[D][R] - $.v[D][R]) * j, S.v[D][R] = X;
      }
      function n() {
        var _ = this.comp.renderedFrame - this.offsetTime, S = this.keyframes[0].t - this.offsetTime, E = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, P = this._caching.lastFrame;
        return P !== e && (P < S && _ < S || P > E && _ > E) || (this._caching.lastIndex = P < _ ? this._caching.lastIndex : 0, this.interpolateShape(_, this.pv, this._caching)), this._caching.lastFrame = _, this.pv;
      }
      function s() {
        this.paths = this.localShapeCollection;
      }
      function i(_, S) {
        if (_._length !== S._length || _.c !== S.c)
          return !1;
        var E, P = _._length;
        for (E = 0; E < P; E += 1)
          if (_.v[E][0] !== S.v[E][0] || _.v[E][1] !== S.v[E][1] || _.o[E][0] !== S.o[E][0] || _.o[E][1] !== S.o[E][1] || _.i[E][0] !== S.i[E][0] || _.i[E][1] !== S.i[E][1])
            return !1;
        return !0;
      }
      function a(_) {
        i(this.v, _) || (this.v = shapePool.clone(_), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function o() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var _;
          this.kf ? _ = this.pv : this.data.ks ? _ = this.data.ks.k : _ = this.data.pt.k;
          var S, E = this.effectsSequence.length;
          for (S = 0; S < E; S += 1)
            _ = this.effectsSequence[S](_);
          this.setVValue(_), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function l(_, S, E) {
        this.propType = "shape", this.comp = _.comp, this.container = _, this.elem = _, this.data = S, this.k = !1, this.kf = !1, this._mdf = !1;
        var P = E === 3 ? S.pt.k : S.ks.k;
        this.v = shapePool.clone(P), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = s, this.effectsSequence = [];
      }
      function c(_) {
        this.effectsSequence.push(_), this.container.addDynamicProperty(this);
      }
      l.prototype.interpolateShape = t, l.prototype.getValue = o, l.prototype.setVValue = a, l.prototype.addEffect = c;
      function u(_, S, E) {
        this.propType = "shape", this.comp = _.comp, this.elem = _, this.container = _, this.offsetTime = _.data.st, this.keyframes = E === 3 ? S.pt.k : S.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var P = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, P), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = e, this.reset = s, this._caching = {
          lastFrame: e,
          lastIndex: 0
        }, this.effectsSequence = [n.bind(this)];
      }
      u.prototype.getValue = o, u.prototype.interpolateShape = t, u.prototype.setVValue = a, u.prototype.addEffect = c;
      var d = function() {
        var _ = roundCorner;
        function S(E, P) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = P.d, this.elem = E, this.comp = E.comp, this.frameId = -1, this.initDynamicPropertyContainer(E), this.p = PropertyFactory.getProp(E, P.p, 1, 0, this), this.s = PropertyFactory.getProp(E, P.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return S.prototype = {
          reset: s,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function() {
            var P = this.p.v[0], $ = this.p.v[1], A = this.s.v[0] / 2, I = this.s.v[1] / 2, D = this.d !== 3, R = this.v;
            R.v[0][0] = P, R.v[0][1] = $ - I, R.v[1][0] = D ? P + A : P - A, R.v[1][1] = $, R.v[2][0] = P, R.v[2][1] = $ + I, R.v[3][0] = D ? P - A : P + A, R.v[3][1] = $, R.i[0][0] = D ? P - A * _ : P + A * _, R.i[0][1] = $ - I, R.i[1][0] = D ? P + A : P - A, R.i[1][1] = $ - I * _, R.i[2][0] = D ? P + A * _ : P - A * _, R.i[2][1] = $ + I, R.i[3][0] = D ? P - A : P + A, R.i[3][1] = $ + I * _, R.o[0][0] = D ? P + A * _ : P - A * _, R.o[0][1] = $ - I, R.o[1][0] = D ? P + A : P - A, R.o[1][1] = $ + I * _, R.o[2][0] = D ? P - A * _ : P + A * _, R.o[2][1] = $ + I, R.o[3][0] = D ? P - A : P + A, R.o[3][1] = $ - I * _;
          }
        }, extendPrototype([DynamicPropertyContainer], S), S;
      }(), p = function() {
        function _(S, E) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = S, this.comp = S.comp, this.data = E, this.frameId = -1, this.d = E.d, this.initDynamicPropertyContainer(S), E.sy === 1 ? (this.ir = PropertyFactory.getProp(S, E.ir, 0, 0, this), this.is = PropertyFactory.getProp(S, E.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(S, E.pt, 0, 0, this), this.p = PropertyFactory.getProp(S, E.p, 1, 0, this), this.r = PropertyFactory.getProp(S, E.r, 0, degToRads, this), this.or = PropertyFactory.getProp(S, E.or, 0, 0, this), this.os = PropertyFactory.getProp(S, E.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return _.prototype = {
          reset: s,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function() {
            var E = Math.floor(this.pt.v) * 2, P = Math.PI * 2 / E, $ = !0, A = this.or.v, I = this.ir.v, D = this.os.v, R = this.is.v, Y = 2 * Math.PI * A / (E * 2), q = 2 * Math.PI * I / (E * 2), j, X, ee, G, H = -Math.PI / 2;
            H += this.r.v;
            var F = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, j = 0; j < E; j += 1) {
              X = $ ? A : I, ee = $ ? D : R, G = $ ? Y : q;
              var B = X * Math.cos(H), z = X * Math.sin(H), K = B === 0 && z === 0 ? 0 : z / Math.sqrt(B * B + z * z), Z = B === 0 && z === 0 ? 0 : -B / Math.sqrt(B * B + z * z);
              B += +this.p.v[0], z += +this.p.v[1], this.v.setTripleAt(B, z, B - K * G * ee * F, z - Z * G * ee * F, B + K * G * ee * F, z + Z * G * ee * F, j, !0), $ = !$, H += P * F;
            }
          },
          convertPolygonToPath: function() {
            var E = Math.floor(this.pt.v), P = Math.PI * 2 / E, $ = this.or.v, A = this.os.v, I = 2 * Math.PI * $ / (E * 4), D, R = -Math.PI * 0.5, Y = this.data.d === 3 ? -1 : 1;
            for (R += this.r.v, this.v._length = 0, D = 0; D < E; D += 1) {
              var q = $ * Math.cos(R), j = $ * Math.sin(R), X = q === 0 && j === 0 ? 0 : j / Math.sqrt(q * q + j * j), ee = q === 0 && j === 0 ? 0 : -q / Math.sqrt(q * q + j * j);
              q += +this.p.v[0], j += +this.p.v[1], this.v.setTripleAt(q, j, q - X * I * A * Y, j - ee * I * A * Y, q + X * I * A * Y, j + ee * I * A * Y, D, !0), R += P * Y;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, extendPrototype([DynamicPropertyContainer], _), _;
      }(), f = function() {
        function _(S, E) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = S, this.comp = S.comp, this.frameId = -1, this.d = E.d, this.initDynamicPropertyContainer(S), this.p = PropertyFactory.getProp(S, E.p, 1, 0, this), this.s = PropertyFactory.getProp(S, E.s, 1, 0, this), this.r = PropertyFactory.getProp(S, E.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return _.prototype = {
          convertRectToPath: function() {
            var E = this.p.v[0], P = this.p.v[1], $ = this.s.v[0] / 2, A = this.s.v[1] / 2, I = bmMin($, A, this.r.v), D = I * (1 - roundCorner);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(E + $, P - A + I, E + $, P - A + I, E + $, P - A + D, 0, !0), this.v.setTripleAt(E + $, P + A - I, E + $, P + A - D, E + $, P + A - I, 1, !0), I !== 0 ? (this.v.setTripleAt(E + $ - I, P + A, E + $ - I, P + A, E + $ - D, P + A, 2, !0), this.v.setTripleAt(E - $ + I, P + A, E - $ + D, P + A, E - $ + I, P + A, 3, !0), this.v.setTripleAt(E - $, P + A - I, E - $, P + A - I, E - $, P + A - D, 4, !0), this.v.setTripleAt(E - $, P - A + I, E - $, P - A + D, E - $, P - A + I, 5, !0), this.v.setTripleAt(E - $ + I, P - A, E - $ + I, P - A, E - $ + D, P - A, 6, !0), this.v.setTripleAt(E + $ - I, P - A, E + $ - D, P - A, E + $ - I, P - A, 7, !0)) : (this.v.setTripleAt(E - $, P + A, E - $ + D, P + A, E - $, P + A, 2), this.v.setTripleAt(E - $, P - A, E - $, P - A + D, E - $, P - A, 3))) : (this.v.setTripleAt(E + $, P - A + I, E + $, P - A + D, E + $, P - A + I, 0, !0), I !== 0 ? (this.v.setTripleAt(E + $ - I, P - A, E + $ - I, P - A, E + $ - D, P - A, 1, !0), this.v.setTripleAt(E - $ + I, P - A, E - $ + D, P - A, E - $ + I, P - A, 2, !0), this.v.setTripleAt(E - $, P - A + I, E - $, P - A + I, E - $, P - A + D, 3, !0), this.v.setTripleAt(E - $, P + A - I, E - $, P + A - D, E - $, P + A - I, 4, !0), this.v.setTripleAt(E - $ + I, P + A, E - $ + I, P + A, E - $ + D, P + A, 5, !0), this.v.setTripleAt(E + $ - I, P + A, E + $ - D, P + A, E + $ - I, P + A, 6, !0), this.v.setTripleAt(E + $, P + A - I, E + $, P + A - I, E + $, P + A - D, 7, !0)) : (this.v.setTripleAt(E - $, P - A, E - $ + D, P - A, E - $, P - A, 1, !0), this.v.setTripleAt(E - $, P + A, E - $, P + A - D, E - $, P + A, 2, !0), this.v.setTripleAt(E + $, P + A, E + $ - D, P + A, E + $, P + A, 3, !0)));
          },
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: s
        }, extendPrototype([DynamicPropertyContainer], _), _;
      }();
      function g(_, S, E) {
        var P;
        if (E === 3 || E === 4) {
          var $ = E === 3 ? S.pt : S.ks, A = $.k;
          A.length ? P = new u(_, S, E) : P = new l(_, S, E);
        } else
          E === 5 ? P = new f(_, S) : E === 6 ? P = new d(_, S) : E === 7 && (P = new p(_, S));
        return P.k && _.addDynamicProperty(P), P;
      }
      function C() {
        return l;
      }
      function k() {
        return u;
      }
      var M = {};
      return M.getShapeProp = g, M.getConstructorFunction = C, M.getKeyframedConstructorFunction = k, M;
    }();
    /*!
     Transformation Matrix v2.0
     (c) Epistemex 2014-2015
     www.epistemex.com
     By Ken Fyrstenberg
     Contributions by leeoniya.
     License: MIT, header required.
     */
    var Matrix = function() {
      var e = Math.cos, t = Math.sin, n = Math.tan, s = Math.round;
      function i() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function a(F) {
        if (F === 0)
          return this;
        var B = e(F), z = t(F);
        return this._t(B, -z, 0, 0, z, B, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function o(F) {
        if (F === 0)
          return this;
        var B = e(F), z = t(F);
        return this._t(1, 0, 0, 0, 0, B, -z, 0, 0, z, B, 0, 0, 0, 0, 1);
      }
      function l(F) {
        if (F === 0)
          return this;
        var B = e(F), z = t(F);
        return this._t(B, 0, z, 0, 0, 1, 0, 0, -z, 0, B, 0, 0, 0, 0, 1);
      }
      function c(F) {
        if (F === 0)
          return this;
        var B = e(F), z = t(F);
        return this._t(B, -z, 0, 0, z, B, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function u(F, B) {
        return this._t(1, B, F, 1, 0, 0);
      }
      function d(F, B) {
        return this.shear(n(F), n(B));
      }
      function p(F, B) {
        var z = e(B), K = t(B);
        return this._t(z, K, 0, 0, -K, z, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, n(F), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(z, -K, 0, 0, K, z, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function f(F, B, z) {
        return !z && z !== 0 && (z = 1), F === 1 && B === 1 && z === 1 ? this : this._t(F, 0, 0, 0, 0, B, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
      }
      function g(F, B, z, K, Z, re, ae, te, ue, ce, ge, de, le, me, ve, be) {
        return this.props[0] = F, this.props[1] = B, this.props[2] = z, this.props[3] = K, this.props[4] = Z, this.props[5] = re, this.props[6] = ae, this.props[7] = te, this.props[8] = ue, this.props[9] = ce, this.props[10] = ge, this.props[11] = de, this.props[12] = le, this.props[13] = me, this.props[14] = ve, this.props[15] = be, this;
      }
      function C(F, B, z) {
        return z = z || 0, F !== 0 || B !== 0 || z !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, F, B, z, 1) : this;
      }
      function k(F, B, z, K, Z, re, ae, te, ue, ce, ge, de, le, me, ve, be) {
        var oe = this.props;
        if (F === 1 && B === 0 && z === 0 && K === 0 && Z === 0 && re === 1 && ae === 0 && te === 0 && ue === 0 && ce === 0 && ge === 1 && de === 0)
          return oe[12] = oe[12] * F + oe[15] * le, oe[13] = oe[13] * re + oe[15] * me, oe[14] = oe[14] * ge + oe[15] * ve, oe[15] *= be, this._identityCalculated = !1, this;
        var ye = oe[0], we = oe[1], Ae = oe[2], Se = oe[3], Ee = oe[4], Ie = oe[5], xe = oe[6], Ce = oe[7], $e = oe[8], De = oe[9], ke = oe[10], Me = oe[11], Pe = oe[12], Oe = oe[13], Be = oe[14], Fe = oe[15];
        return oe[0] = ye * F + we * Z + Ae * ue + Se * le, oe[1] = ye * B + we * re + Ae * ce + Se * me, oe[2] = ye * z + we * ae + Ae * ge + Se * ve, oe[3] = ye * K + we * te + Ae * de + Se * be, oe[4] = Ee * F + Ie * Z + xe * ue + Ce * le, oe[5] = Ee * B + Ie * re + xe * ce + Ce * me, oe[6] = Ee * z + Ie * ae + xe * ge + Ce * ve, oe[7] = Ee * K + Ie * te + xe * de + Ce * be, oe[8] = $e * F + De * Z + ke * ue + Me * le, oe[9] = $e * B + De * re + ke * ce + Me * me, oe[10] = $e * z + De * ae + ke * ge + Me * ve, oe[11] = $e * K + De * te + ke * de + Me * be, oe[12] = Pe * F + Oe * Z + Be * ue + Fe * le, oe[13] = Pe * B + Oe * re + Be * ce + Fe * me, oe[14] = Pe * z + Oe * ae + Be * ge + Fe * ve, oe[15] = Pe * K + Oe * te + Be * de + Fe * be, this._identityCalculated = !1, this;
      }
      function M() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function _(F) {
        for (var B = 0; B < 16; ) {
          if (F.props[B] !== this.props[B])
            return !1;
          B += 1;
        }
        return !0;
      }
      function S(F) {
        var B;
        for (B = 0; B < 16; B += 1)
          F.props[B] = this.props[B];
        return F;
      }
      function E(F) {
        var B;
        for (B = 0; B < 16; B += 1)
          this.props[B] = F[B];
      }
      function P(F, B, z) {
        return {
          x: F * this.props[0] + B * this.props[4] + z * this.props[8] + this.props[12],
          y: F * this.props[1] + B * this.props[5] + z * this.props[9] + this.props[13],
          z: F * this.props[2] + B * this.props[6] + z * this.props[10] + this.props[14]
        };
      }
      function $(F, B, z) {
        return F * this.props[0] + B * this.props[4] + z * this.props[8] + this.props[12];
      }
      function A(F, B, z) {
        return F * this.props[1] + B * this.props[5] + z * this.props[9] + this.props[13];
      }
      function I(F, B, z) {
        return F * this.props[2] + B * this.props[6] + z * this.props[10] + this.props[14];
      }
      function D() {
        var F = this.props[0] * this.props[5] - this.props[1] * this.props[4], B = this.props[5] / F, z = -this.props[1] / F, K = -this.props[4] / F, Z = this.props[0] / F, re = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / F, ae = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / F, te = new Matrix();
        return te.props[0] = B, te.props[1] = z, te.props[4] = K, te.props[5] = Z, te.props[12] = re, te.props[13] = ae, te;
      }
      function R(F) {
        var B = this.getInverseMatrix();
        return B.applyToPointArray(F[0], F[1], F[2] || 0);
      }
      function Y(F) {
        var B, z = F.length, K = [];
        for (B = 0; B < z; B += 1)
          K[B] = R(F[B]);
        return K;
      }
      function q(F, B, z) {
        var K = createTypedArray("float32", 6);
        if (this.isIdentity())
          K[0] = F[0], K[1] = F[1], K[2] = B[0], K[3] = B[1], K[4] = z[0], K[5] = z[1];
        else {
          var Z = this.props[0], re = this.props[1], ae = this.props[4], te = this.props[5], ue = this.props[12], ce = this.props[13];
          K[0] = F[0] * Z + F[1] * ae + ue, K[1] = F[0] * re + F[1] * te + ce, K[2] = B[0] * Z + B[1] * ae + ue, K[3] = B[0] * re + B[1] * te + ce, K[4] = z[0] * Z + z[1] * ae + ue, K[5] = z[0] * re + z[1] * te + ce;
        }
        return K;
      }
      function j(F, B, z) {
        var K;
        return this.isIdentity() ? K = [F, B, z] : K = [F * this.props[0] + B * this.props[4] + z * this.props[8] + this.props[12], F * this.props[1] + B * this.props[5] + z * this.props[9] + this.props[13], F * this.props[2] + B * this.props[6] + z * this.props[10] + this.props[14]], K;
      }
      function X(F, B) {
        if (this.isIdentity())
          return F + "," + B;
        var z = this.props;
        return Math.round((F * z[0] + B * z[4] + z[12]) * 100) / 100 + "," + Math.round((F * z[1] + B * z[5] + z[13]) * 100) / 100;
      }
      function ee() {
        for (var F = 0, B = this.props, z = "matrix3d(", K = 1e4; F < 16; )
          z += s(B[F] * K) / K, z += F === 15 ? ")" : ",", F += 1;
        return z;
      }
      function G(F) {
        var B = 1e4;
        return F < 1e-6 && F > 0 || F > -1e-6 && F < 0 ? s(F * B) / B : F;
      }
      function H() {
        var F = this.props, B = G(F[0]), z = G(F[1]), K = G(F[4]), Z = G(F[5]), re = G(F[12]), ae = G(F[13]);
        return "matrix(" + B + "," + z + "," + K + "," + Z + "," + re + "," + ae + ")";
      }
      return function() {
        this.reset = i, this.rotate = a, this.rotateX = o, this.rotateY = l, this.rotateZ = c, this.skew = d, this.skewFromAxis = p, this.shear = u, this.scale = f, this.setTransform = g, this.translate = C, this.transform = k, this.applyToPoint = P, this.applyToX = $, this.applyToY = A, this.applyToZ = I, this.applyToPointArray = j, this.applyToTriplePoints = q, this.applyToPointStringified = X, this.toCSS = ee, this.to2dCSS = H, this.clone = S, this.cloneFromProps = E, this.equals = _, this.inversePoints = Y, this.inversePoint = R, this.getInverseMatrix = D, this._t = this.transform, this.isIdentity = M, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    }();
    function _typeof$3(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$3 = function(n) {
        return typeof n;
      } : _typeof$3 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$3(e);
    }
    var lottie = {};
    function setLocation(e) {
      setLocationHref(e);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(e) {
      setSubframeEnabled(e);
    }
    function setPrefix(e) {
      setIdPrefix(e);
    }
    function loadAnimation(e) {
      return animationManager.loadAnimation(e);
    }
    function setQuality(e) {
      if (typeof e == "string")
        switch (e) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
            break;
        }
      else
        !isNaN(e) && e > 1 && setDefaultCurveSegments(e);
    }
    function inBrowser() {
      return typeof navigator < "u";
    }
    function installPlugin(e, t) {
      e === "expressions" && setExpressionsPlugin(t);
    }
    function getFactory(e) {
      switch (e) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.10.2";
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(e) {
      for (var t = queryString.split("&"), n = 0; n < t.length; n += 1) {
        var s = t[n].split("=");
        if (decodeURIComponent(s[0]) == e)
          return decodeURIComponent(s[1]);
      }
      return null;
    }
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
        src: ""
      };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (e) {
    }
    var ShapeModifiers = function() {
      var e = {}, t = {};
      e.registerModifier = n, e.getModifier = s;
      function n(i, a) {
        t[i] || (t[i] = a);
      }
      function s(i, a, o) {
        return new t[i](a, o);
      }
      return e;
    }();
    function ShapeModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(e) {
      if (!this.closed) {
        e.sh.container.addDynamicProperty(e.sh);
        var t = {
          shape: e.sh,
          data: e,
          localShapeCollection: shapeCollectionPool.newShapeCollection()
        };
        this.shapes.push(t), this.addShapeToModifier(t), this._isAnimated && e.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(e, t) {
      this.shapes = [], this.elem = e, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier);
    function TrimModifier() {
    }
    extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(e, t) {
      this.s = PropertyFactory.getProp(e, t.s, 0, 0.01, this), this.e = PropertyFactory.getProp(e, t.e, 0, 0.01, this), this.o = PropertyFactory.getProp(e, t.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = t.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(e) {
      e.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(e, t, n, s, i) {
      var a = [];
      t <= 1 ? a.push({
        s: e,
        e: t
      }) : e >= 1 ? a.push({
        s: e - 1,
        e: t - 1
      }) : (a.push({
        s: e,
        e: 1
      }), a.push({
        s: 0,
        e: t - 1
      }));
      var o = [], l, c = a.length, u;
      for (l = 0; l < c; l += 1)
        if (u = a[l], !(u.e * i < s || u.s * i > s + n)) {
          var d, p;
          u.s * i <= s ? d = 0 : d = (u.s * i - s) / n, u.e * i >= s + n ? p = 1 : p = (u.e * i - s) / n, o.push([d, p]);
        }
      return o.length || o.push([0, 0]), o;
    }, TrimModifier.prototype.releasePathsData = function(e) {
      var t, n = e.length;
      for (t = 0; t < n; t += 1)
        segmentsLengthPool.release(e[t]);
      return e.length = 0, e;
    }, TrimModifier.prototype.processShapes = function(e) {
      var t, n;
      if (this._mdf || e) {
        var s = this.o.v % 360 / 360;
        if (s < 0 && (s += 1), this.s.v > 1 ? t = 1 + s : this.s.v < 0 ? t = 0 + s : t = this.s.v + s, this.e.v > 1 ? n = 1 + s : this.e.v < 0 ? n = 0 + s : n = this.e.v + s, t > n) {
          var i = t;
          t = n, n = i;
        }
        t = Math.round(t * 1e4) * 1e-4, n = Math.round(n * 1e4) * 1e-4, this.sValue = t, this.eValue = n;
      } else
        t = this.sValue, n = this.eValue;
      var a, o, l = this.shapes.length, c, u, d, p, f, g = 0;
      if (n === t)
        for (o = 0; o < l; o += 1)
          this.shapes[o].localShapeCollection.releaseShapes(), this.shapes[o].shape._mdf = !0, this.shapes[o].shape.paths = this.shapes[o].localShapeCollection, this._mdf && (this.shapes[o].pathsData.length = 0);
      else if (n === 1 && t === 0 || n === 0 && t === 1) {
        if (this._mdf)
          for (o = 0; o < l; o += 1)
            this.shapes[o].pathsData.length = 0, this.shapes[o].shape._mdf = !0;
      } else {
        var C = [], k, M;
        for (o = 0; o < l; o += 1)
          if (k = this.shapes[o], !k.shape._mdf && !this._mdf && !e && this.m !== 2)
            k.shape.paths = k.localShapeCollection;
          else {
            if (a = k.shape.paths, u = a._length, f = 0, !k.shape._mdf && k.pathsData.length)
              f = k.totalShapeLength;
            else {
              for (d = this.releasePathsData(k.pathsData), c = 0; c < u; c += 1)
                p = bez.getSegmentsLength(a.shapes[c]), d.push(p), f += p.totalLength;
              k.totalShapeLength = f, k.pathsData = d;
            }
            g += f, k.shape._mdf = !0;
          }
        var _ = t, S = n, E = 0, P;
        for (o = l - 1; o >= 0; o -= 1)
          if (k = this.shapes[o], k.shape._mdf) {
            for (M = k.localShapeCollection, M.releaseShapes(), this.m === 2 && l > 1 ? (P = this.calculateShapeEdges(t, n, k.totalShapeLength, E, g), E += k.totalShapeLength) : P = [[_, S]], u = P.length, c = 0; c < u; c += 1) {
              _ = P[c][0], S = P[c][1], C.length = 0, S <= 1 ? C.push({
                s: k.totalShapeLength * _,
                e: k.totalShapeLength * S
              }) : _ >= 1 ? C.push({
                s: k.totalShapeLength * (_ - 1),
                e: k.totalShapeLength * (S - 1)
              }) : (C.push({
                s: k.totalShapeLength * _,
                e: k.totalShapeLength
              }), C.push({
                s: 0,
                e: k.totalShapeLength * (S - 1)
              }));
              var $ = this.addShapes(k, C[0]);
              if (C[0].s !== C[0].e) {
                if (C.length > 1) {
                  var A = k.shape.paths.shapes[k.shape.paths._length - 1];
                  if (A.c) {
                    var I = $.pop();
                    this.addPaths($, M), $ = this.addShapes(k, C[1], I);
                  } else
                    this.addPaths($, M), $ = this.addShapes(k, C[1]);
                }
                this.addPaths($, M);
              }
            }
            k.shape.paths = M;
          }
      }
    }, TrimModifier.prototype.addPaths = function(e, t) {
      var n, s = e.length;
      for (n = 0; n < s; n += 1)
        t.addShape(e[n]);
    }, TrimModifier.prototype.addSegment = function(e, t, n, s, i, a, o) {
      i.setXYAt(t[0], t[1], "o", a), i.setXYAt(n[0], n[1], "i", a + 1), o && i.setXYAt(e[0], e[1], "v", a), i.setXYAt(s[0], s[1], "v", a + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(e, t, n, s) {
      t.setXYAt(e[1], e[5], "o", n), t.setXYAt(e[2], e[6], "i", n + 1), s && t.setXYAt(e[0], e[4], "v", n), t.setXYAt(e[3], e[7], "v", n + 1);
    }, TrimModifier.prototype.addShapes = function(e, t, n) {
      var s = e.pathsData, i = e.shape.paths.shapes, a, o = e.shape.paths._length, l, c, u = 0, d, p, f, g, C = [], k, M = !0;
      for (n ? (p = n._length, k = n._length) : (n = shapePool.newElement(), p = 0, k = 0), C.push(n), a = 0; a < o; a += 1) {
        for (f = s[a].lengths, n.c = i[a].c, c = i[a].c ? f.length : f.length + 1, l = 1; l < c; l += 1)
          if (d = f[l - 1], u + d.addedLength < t.s)
            u += d.addedLength, n.c = !1;
          else if (u > t.e) {
            n.c = !1;
            break;
          } else
            t.s <= u && t.e >= u + d.addedLength ? (this.addSegment(i[a].v[l - 1], i[a].o[l - 1], i[a].i[l], i[a].v[l], n, p, M), M = !1) : (g = bez.getNewSegment(i[a].v[l - 1], i[a].v[l], i[a].o[l - 1], i[a].i[l], (t.s - u) / d.addedLength, (t.e - u) / d.addedLength, f[l - 1]), this.addSegmentFromArray(g, n, p, M), M = !1, n.c = !1), u += d.addedLength, p += 1;
        if (i[a].c && f.length) {
          if (d = f[l - 1], u <= t.e) {
            var _ = f[l - 1].addedLength;
            t.s <= u && t.e >= u + _ ? (this.addSegment(i[a].v[l - 1], i[a].o[l - 1], i[a].i[0], i[a].v[0], n, p, M), M = !1) : (g = bez.getNewSegment(i[a].v[l - 1], i[a].v[0], i[a].o[l - 1], i[a].i[0], (t.s - u) / _, (t.e - u) / _, f[l - 1]), this.addSegmentFromArray(g, n, p, M), M = !1, n.c = !1);
          } else
            n.c = !1;
          u += d.addedLength, p += 1;
        }
        if (n._length && (n.setXYAt(n.v[k][0], n.v[k][1], "i", k), n.setXYAt(n.v[n._length - 1][0], n.v[n._length - 1][1], "o", n._length - 1)), u > t.e)
          break;
        a < o - 1 && (n = shapePool.newElement(), M = !0, C.push(n), p = 0);
      }
      return C;
    };
    function PuckerAndBloatModifier() {
    }
    extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(e, t) {
      var n = t / 100, s = [0, 0], i = e._length, a = 0;
      for (a = 0; a < i; a += 1)
        s[0] += e.v[a][0], s[1] += e.v[a][1];
      s[0] /= i, s[1] /= i;
      var o = shapePool.newElement();
      o.c = e.c;
      var l, c, u, d, p, f;
      for (a = 0; a < i; a += 1)
        l = e.v[a][0] + (s[0] - e.v[a][0]) * n, c = e.v[a][1] + (s[1] - e.v[a][1]) * n, u = e.o[a][0] + (s[0] - e.o[a][0]) * -n, d = e.o[a][1] + (s[1] - e.o[a][1]) * -n, p = e.i[a][0] + (s[0] - e.i[a][0]) * -n, f = e.i[a][1] + (s[1] - e.i[a][1]) * -n, o.setTripleAt(l, c, u, d, p, f, a);
      return o;
    }, PuckerAndBloatModifier.prototype.processShapes = function(e) {
      var t, n, s = this.shapes.length, i, a, o = this.amount.v;
      if (o !== 0) {
        var l, c;
        for (n = 0; n < s; n += 1) {
          if (l = this.shapes[n], c = l.localShapeCollection, !(!l.shape._mdf && !this._mdf && !e))
            for (c.releaseShapes(), l.shape._mdf = !0, t = l.shape.paths.shapes, a = l.shape.paths._length, i = 0; i < a; i += 1)
              c.addShape(this.processPath(t[i], o));
          l.shape.paths = l.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = function() {
      var e = [0, 0];
      function t(c) {
        var u = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || u, this.a && c.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && c.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && c.skewFromAxis(-this.sk.v, this.sa.v), this.r ? c.rotate(-this.r.v) : c.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? c.translate(this.px.v, this.py.v, -this.pz.v) : c.translate(this.px.v, this.py.v, 0) : c.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function n(c) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || c) {
            var u;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var d, p;
              if (u = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (d = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / u, 0), p = this.p.getValueAtTime(this.p.keyframes[0].t / u, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (d = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / u, 0), p = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / u, 0)) : (d = this.p.pv, p = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / u, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                d = [], p = [];
                var f = this.px, g = this.py;
                f._caching.lastFrame + f.offsetTime <= f.keyframes[0].t ? (d[0] = f.getValueAtTime((f.keyframes[0].t + 0.01) / u, 0), d[1] = g.getValueAtTime((g.keyframes[0].t + 0.01) / u, 0), p[0] = f.getValueAtTime(f.keyframes[0].t / u, 0), p[1] = g.getValueAtTime(g.keyframes[0].t / u, 0)) : f._caching.lastFrame + f.offsetTime >= f.keyframes[f.keyframes.length - 1].t ? (d[0] = f.getValueAtTime(f.keyframes[f.keyframes.length - 1].t / u, 0), d[1] = g.getValueAtTime(g.keyframes[g.keyframes.length - 1].t / u, 0), p[0] = f.getValueAtTime((f.keyframes[f.keyframes.length - 1].t - 0.01) / u, 0), p[1] = g.getValueAtTime((g.keyframes[g.keyframes.length - 1].t - 0.01) / u, 0)) : (d = [f.pv, g.pv], p[0] = f.getValueAtTime((f._caching.lastFrame + f.offsetTime - 0.01) / u, f.offsetTime), p[1] = g.getValueAtTime((g._caching.lastFrame + g.offsetTime - 0.01) / u, g.offsetTime));
              } else
                p = e, d = p;
              this.v.rotate(-Math.atan2(d[1] - p[1], d[0] - p[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function s() {
        if (!this.a.k)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function i() {
      }
      function a(c) {
        this._addDynamicProperty(c), this.elem.addDynamicProperty(c), this._isDirty = !0;
      }
      function o(c, u, d) {
        if (this.elem = c, this.frameId = -1, this.propType = "transform", this.data = u, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(d || c), u.p && u.p.s ? (this.px = PropertyFactory.getProp(c, u.p.x, 0, 0, this), this.py = PropertyFactory.getProp(c, u.p.y, 0, 0, this), u.p.z && (this.pz = PropertyFactory.getProp(c, u.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(c, u.p || {
          k: [0, 0, 0]
        }, 1, 0, this), u.rx) {
          if (this.rx = PropertyFactory.getProp(c, u.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(c, u.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(c, u.rz, 0, degToRads, this), u.or.k[0].ti) {
            var p, f = u.or.k.length;
            for (p = 0; p < f; p += 1)
              u.or.k[p].to = null, u.or.k[p].ti = null;
          }
          this.or = PropertyFactory.getProp(c, u.or, 1, degToRads, this), this.or.sh = !0;
        } else
          this.r = PropertyFactory.getProp(c, u.r || {
            k: 0
          }, 0, degToRads, this);
        u.sk && (this.sk = PropertyFactory.getProp(c, u.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(c, u.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(c, u.a || {
          k: [0, 0, 0]
        }, 1, 0, this), this.s = PropertyFactory.getProp(c, u.s || {
          k: [100, 100, 100]
        }, 1, 0.01, this), u.o ? this.o = PropertyFactory.getProp(c, u.o, 0, 0.01, c) : this.o = {
          _mdf: !1,
          v: 1
        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      o.prototype = {
        applyToMatrix: t,
        getValue: n,
        precalculateMatrix: s,
        autoOrient: i
      }, extendPrototype([DynamicPropertyContainer], o), o.prototype.addDynamicProperty = a, o.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
      function l(c, u, d) {
        return new o(c, u, d);
      }
      return {
        getTransformProperty: l
      };
    }();
    function RepeaterModifier() {
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(e, t.c, 0, null, this), this.o = PropertyFactory.getProp(e, t.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(e, t.tr, this), this.so = PropertyFactory.getProp(e, t.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(e, t.tr.eo, 0, 0.01, this), this.data = t, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(e, t, n, s, i, a) {
      var o = a ? -1 : 1, l = s.s.v[0] + (1 - s.s.v[0]) * (1 - i), c = s.s.v[1] + (1 - s.s.v[1]) * (1 - i);
      e.translate(s.p.v[0] * o * i, s.p.v[1] * o * i, s.p.v[2]), t.translate(-s.a.v[0], -s.a.v[1], s.a.v[2]), t.rotate(-s.r.v * o * i), t.translate(s.a.v[0], s.a.v[1], s.a.v[2]), n.translate(-s.a.v[0], -s.a.v[1], s.a.v[2]), n.scale(a ? 1 / l : l, a ? 1 / c : c), n.translate(s.a.v[0], s.a.v[1], s.a.v[2]);
    }, RepeaterModifier.prototype.init = function(e, t, n, s) {
      for (this.elem = e, this.arr = t, this.pos = n, this.elemsData = s, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(e), this.initModifierProperties(e, t[n]); n > 0; )
        n -= 1, this._elements.unshift(t[n]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(e) {
      var t, n = e.length;
      for (t = 0; t < n; t += 1)
        e[t]._processed = !1, e[t].ty === "gr" && this.resetElements(e[t].it);
    }, RepeaterModifier.prototype.cloneElements = function(e) {
      var t = JSON.parse(JSON.stringify(e));
      return this.resetElements(t), t;
    }, RepeaterModifier.prototype.changeGroupRender = function(e, t) {
      var n, s = e.length;
      for (n = 0; n < s; n += 1)
        e[n]._render = t, e[n].ty === "gr" && this.changeGroupRender(e[n].it, t);
    }, RepeaterModifier.prototype.processShapes = function(e) {
      var t, n, s, i, a, o = !1;
      if (this._mdf || e) {
        var l = Math.ceil(this.c.v);
        if (this._groups.length < l) {
          for (; this._groups.length < l; ) {
            var c = {
              it: this.cloneElements(this._elements),
              ty: "gr"
            };
            c.it.push({
              a: {
                a: 0,
                ix: 1,
                k: [0, 0]
              },
              nm: "Transform",
              o: {
                a: 0,
                ix: 7,
                k: 100
              },
              p: {
                a: 0,
                ix: 2,
                k: [0, 0]
              },
              r: {
                a: 1,
                ix: 6,
                k: [{
                  s: 0,
                  e: 0,
                  t: 0
                }, {
                  s: 0,
                  e: 0,
                  t: 1
                }]
              },
              s: {
                a: 0,
                ix: 3,
                k: [100, 100]
              },
              sa: {
                a: 0,
                ix: 5,
                k: 0
              },
              sk: {
                a: 0,
                ix: 4,
                k: 0
              },
              ty: "tr"
            }), this.arr.splice(0, 0, c), this._groups.splice(0, 0, c), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), o = !0;
        }
        a = 0;
        var u;
        for (s = 0; s <= this._groups.length - 1; s += 1) {
          if (u = a < l, this._groups[s]._render = u, this.changeGroupRender(this._groups[s].it, u), !u) {
            var d = this.elemsData[s].it, p = d[d.length - 1];
            p.transform.op.v !== 0 ? (p.transform.op._mdf = !0, p.transform.op.v = 0) : p.transform.op._mdf = !1;
          }
          a += 1;
        }
        this._currentCopies = l;
        var f = this.o.v, g = f % 1, C = f > 0 ? Math.floor(f) : Math.ceil(f), k = this.pMatrix.props, M = this.rMatrix.props, _ = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var S = 0;
        if (f > 0) {
          for (; S < C; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), S += 1;
          g && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, g, !1), S += g);
        } else if (f < 0) {
          for (; S > C; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), S -= 1;
          g && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -g, !0), S -= g);
        }
        s = this.data.m === 1 ? 0 : this._currentCopies - 1, i = this.data.m === 1 ? 1 : -1, a = this._currentCopies;
        for (var E, P; a; ) {
          if (t = this.elemsData[s].it, n = t[t.length - 1].transform.mProps.v.props, P = n.length, t[t.length - 1].transform.mProps._mdf = !0, t[t.length - 1].transform.op._mdf = !0, t[t.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (s / (this._currentCopies - 1)), S !== 0) {
            for ((s !== 0 && i === 1 || s !== this._currentCopies - 1 && i === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(M[0], M[1], M[2], M[3], M[4], M[5], M[6], M[7], M[8], M[9], M[10], M[11], M[12], M[13], M[14], M[15]), this.matrix.transform(_[0], _[1], _[2], _[3], _[4], _[5], _[6], _[7], _[8], _[9], _[10], _[11], _[12], _[13], _[14], _[15]), this.matrix.transform(k[0], k[1], k[2], k[3], k[4], k[5], k[6], k[7], k[8], k[9], k[10], k[11], k[12], k[13], k[14], k[15]), E = 0; E < P; E += 1)
              n[E] = this.matrix.props[E];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), E = 0; E < P; E += 1)
              n[E] = this.matrix.props[E];
          S += 1, a -= 1, s += i;
        }
      } else
        for (a = this._currentCopies, s = 0, i = 1; a; )
          t = this.elemsData[s].it, n = t[t.length - 1].transform.mProps.v.props, t[t.length - 1].transform.mProps._mdf = !1, t[t.length - 1].transform.op._mdf = !1, a -= 1, s += i;
      return o;
    }, RepeaterModifier.prototype.addShape = function() {
    };
    function RoundCornersModifier() {
    }
    extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(e, t.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(e, t) {
      var n = shapePool.newElement();
      n.c = e.c;
      var s, i = e._length, a, o, l, c, u, d, p = 0, f, g, C, k, M, _;
      for (s = 0; s < i; s += 1)
        a = e.v[s], l = e.o[s], o = e.i[s], a[0] === l[0] && a[1] === l[1] && a[0] === o[0] && a[1] === o[1] ? (s === 0 || s === i - 1) && !e.c ? (n.setTripleAt(a[0], a[1], l[0], l[1], o[0], o[1], p), p += 1) : (s === 0 ? c = e.v[i - 1] : c = e.v[s - 1], u = Math.sqrt(Math.pow(a[0] - c[0], 2) + Math.pow(a[1] - c[1], 2)), d = u ? Math.min(u / 2, t) / u : 0, M = a[0] + (c[0] - a[0]) * d, f = M, _ = a[1] - (a[1] - c[1]) * d, g = _, C = f - (f - a[0]) * roundCorner, k = g - (g - a[1]) * roundCorner, n.setTripleAt(f, g, C, k, M, _, p), p += 1, s === i - 1 ? c = e.v[0] : c = e.v[s + 1], u = Math.sqrt(Math.pow(a[0] - c[0], 2) + Math.pow(a[1] - c[1], 2)), d = u ? Math.min(u / 2, t) / u : 0, C = a[0] + (c[0] - a[0]) * d, f = C, k = a[1] + (c[1] - a[1]) * d, g = k, M = f - (f - a[0]) * roundCorner, _ = g - (g - a[1]) * roundCorner, n.setTripleAt(f, g, C, k, M, _, p), p += 1) : (n.setTripleAt(e.v[s][0], e.v[s][1], e.o[s][0], e.o[s][1], e.i[s][0], e.i[s][1], p), p += 1);
      return n;
    }, RoundCornersModifier.prototype.processShapes = function(e) {
      var t, n, s = this.shapes.length, i, a, o = this.rd.v;
      if (o !== 0) {
        var l, c;
        for (n = 0; n < s; n += 1) {
          if (l = this.shapes[n], c = l.localShapeCollection, !(!l.shape._mdf && !this._mdf && !e))
            for (c.releaseShapes(), l.shape._mdf = !0, t = l.shape.paths.shapes, a = l.shape.paths._length, i = 0; i < a; i += 1)
              c.addShape(this.processPath(t[i], o));
          l.shape.paths = l.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function floatEqual(e, t) {
      return Math.abs(e - t) * 1e5 <= Math.min(Math.abs(e), Math.abs(t));
    }
    function floatZero(e) {
      return Math.abs(e) <= 1e-5;
    }
    function lerp(e, t, n) {
      return e * (1 - n) + t * n;
    }
    function lerpPoint(e, t, n) {
      return [lerp(e[0], t[0], n), lerp(e[1], t[1], n)];
    }
    function quadRoots(e, t, n) {
      if (e === 0)
        return [];
      var s = t * t - 4 * e * n;
      if (s < 0)
        return [];
      var i = -t / (2 * e);
      if (s === 0)
        return [i];
      var a = Math.sqrt(s) / (2 * e);
      return [i - a, i + a];
    }
    function polynomialCoefficients(e, t, n, s) {
      return [-e + 3 * t - 3 * n + s, 3 * e - 6 * t + 3 * n, -3 * e + 3 * t, e];
    }
    function singlePoint(e) {
      return new PolynomialBezier(e, e, e, e, !1);
    }
    function PolynomialBezier(e, t, n, s, i) {
      i && pointEqual(e, t) && (t = lerpPoint(e, s, 1 / 3)), i && pointEqual(n, s) && (n = lerpPoint(e, s, 2 / 3));
      var a = polynomialCoefficients(e[0], t[0], n[0], s[0]), o = polynomialCoefficients(e[1], t[1], n[1], s[1]);
      this.a = [a[0], o[0]], this.b = [a[1], o[1]], this.c = [a[2], o[2]], this.d = [a[3], o[3]], this.points = [e, t, n, s];
    }
    PolynomialBezier.prototype.point = function(e) {
      return [((this.a[0] * e + this.b[0]) * e + this.c[0]) * e + this.d[0], ((this.a[1] * e + this.b[1]) * e + this.c[1]) * e + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(e) {
      return [(3 * e * this.a[0] + 2 * this.b[0]) * e + this.c[0], (3 * e * this.a[1] + 2 * this.b[1]) * e + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(e) {
      var t = this.derivative(e);
      return Math.atan2(t[1], t[0]);
    }, PolynomialBezier.prototype.normalAngle = function(e) {
      var t = this.derivative(e);
      return Math.atan2(t[0], t[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var e = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(e))
        return [];
      var t = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / e, n = t * t - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / e;
      if (n < 0)
        return [];
      var s = Math.sqrt(n);
      return floatZero(s) ? s > 0 && s < 1 ? [t] : [] : [t - s, t + s].filter(function(i) {
        return i > 0 && i < 1;
      });
    }, PolynomialBezier.prototype.split = function(e) {
      if (e <= 0)
        return [singlePoint(this.points[0]), this];
      if (e >= 1)
        return [this, singlePoint(this.points[this.points.length - 1])];
      var t = lerpPoint(this.points[0], this.points[1], e), n = lerpPoint(this.points[1], this.points[2], e), s = lerpPoint(this.points[2], this.points[3], e), i = lerpPoint(t, n, e), a = lerpPoint(n, s, e), o = lerpPoint(i, a, e);
      return [new PolynomialBezier(this.points[0], t, i, o, !0), new PolynomialBezier(o, a, s, this.points[3], !0)];
    };
    function extrema(e, t) {
      var n = e.points[0][t], s = e.points[e.points.length - 1][t];
      if (n > s) {
        var i = s;
        s = n, n = i;
      }
      for (var a = quadRoots(3 * e.a[t], 2 * e.b[t], e.c[t]), o = 0; o < a.length; o += 1)
        if (a[o] > 0 && a[o] < 1) {
          var l = e.point(a[o])[t];
          l < n ? n = l : l > s && (s = l);
        }
      return {
        min: n,
        max: s
      };
    }
    PolynomialBezier.prototype.bounds = function() {
      return {
        x: extrema(this, 0),
        y: extrema(this, 1)
      };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var e = this.bounds();
      return {
        left: e.x.min,
        right: e.x.max,
        top: e.y.min,
        bottom: e.y.max,
        width: e.x.max - e.x.min,
        height: e.y.max - e.y.min,
        cx: (e.x.max + e.x.min) / 2,
        cy: (e.y.max + e.y.min) / 2
      };
    };
    function intersectData(e, t, n) {
      var s = e.boundingBox();
      return {
        cx: s.cx,
        cy: s.cy,
        width: s.width,
        height: s.height,
        bez: e,
        t: (t + n) / 2,
        t1: t,
        t2: n
      };
    }
    function splitData(e) {
      var t = e.bez.split(0.5);
      return [intersectData(t[0], e.t1, e.t), intersectData(t[1], e.t, e.t2)];
    }
    function boxIntersect(e, t) {
      return Math.abs(e.cx - t.cx) * 2 < e.width + t.width && Math.abs(e.cy - t.cy) * 2 < e.height + t.height;
    }
    function intersectsImpl(e, t, n, s, i, a) {
      if (boxIntersect(e, t)) {
        if (n >= a || e.width <= s && e.height <= s && t.width <= s && t.height <= s) {
          i.push([e.t, t.t]);
          return;
        }
        var o = splitData(e), l = splitData(t);
        intersectsImpl(o[0], l[0], n + 1, s, i, a), intersectsImpl(o[0], l[1], n + 1, s, i, a), intersectsImpl(o[1], l[0], n + 1, s, i, a), intersectsImpl(o[1], l[1], n + 1, s, i, a);
      }
    }
    PolynomialBezier.prototype.intersections = function(e, t, n) {
      t === void 0 && (t = 2), n === void 0 && (n = 7);
      var s = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(e, 0, 1), 0, t, s, n), s;
    }, PolynomialBezier.shapeSegment = function(e, t) {
      var n = (t + 1) % e.length();
      return new PolynomialBezier(e.v[t], e.o[t], e.i[n], e.v[n], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(e, t) {
      var n = (t + 1) % e.length();
      return new PolynomialBezier(e.v[n], e.i[n], e.o[t], e.v[t], !0);
    };
    function crossProduct(e, t) {
      return [e[1] * t[2] - e[2] * t[1], e[2] * t[0] - e[0] * t[2], e[0] * t[1] - e[1] * t[0]];
    }
    function lineIntersection(e, t, n, s) {
      var i = [e[0], e[1], 1], a = [t[0], t[1], 1], o = [n[0], n[1], 1], l = [s[0], s[1], 1], c = crossProduct(crossProduct(i, a), crossProduct(o, l));
      return floatZero(c[2]) ? null : [c[0] / c[2], c[1] / c[2]];
    }
    function polarOffset(e, t, n) {
      return [e[0] + Math.cos(t) * n, e[1] - Math.sin(t) * n];
    }
    function pointDistance(e, t) {
      return Math.hypot(e[0] - t[0], e[1] - t[1]);
    }
    function pointEqual(e, t) {
      return floatEqual(e[0], t[0]) && floatEqual(e[1], t[1]);
    }
    function ZigZagModifier() {
    }
    extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(e, t.s, 0, null, this), this.frequency = PropertyFactory.getProp(e, t.r, 0, null, this), this.pointsType = PropertyFactory.getProp(e, t.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(e, t, n, s, i, a, o) {
      var l = n - Math.PI / 2, c = n + Math.PI / 2, u = t[0] + Math.cos(n) * s * i, d = t[1] - Math.sin(n) * s * i;
      e.setTripleAt(u, d, u + Math.cos(l) * a, d - Math.sin(l) * a, u + Math.cos(c) * o, d - Math.sin(c) * o, e.length());
    }
    function getPerpendicularVector(e, t) {
      var n = [t[0] - e[0], t[1] - e[1]], s = -Math.PI * 0.5, i = [Math.cos(s) * n[0] - Math.sin(s) * n[1], Math.sin(s) * n[0] + Math.cos(s) * n[1]];
      return i;
    }
    function getProjectingAngle(e, t) {
      var n = t === 0 ? e.length() - 1 : t - 1, s = (t + 1) % e.length(), i = e.v[n], a = e.v[s], o = getPerpendicularVector(i, a);
      return Math.atan2(0, 1) - Math.atan2(o[1], o[0]);
    }
    function zigZagCorner(e, t, n, s, i, a, o) {
      var l = getProjectingAngle(t, n), c = t.v[n % t._length], u = t.v[n === 0 ? t._length - 1 : n - 1], d = t.v[(n + 1) % t._length], p = a === 2 ? Math.sqrt(Math.pow(c[0] - u[0], 2) + Math.pow(c[1] - u[1], 2)) : 0, f = a === 2 ? Math.sqrt(Math.pow(c[0] - d[0], 2) + Math.pow(c[1] - d[1], 2)) : 0;
      setPoint(e, t.v[n % t._length], l, o, s, f / ((i + 1) * 2), p / ((i + 1) * 2));
    }
    function zigZagSegment(e, t, n, s, i, a) {
      for (var o = 0; o < s; o += 1) {
        var l = (o + 1) / (s + 1), c = i === 2 ? Math.sqrt(Math.pow(t.points[3][0] - t.points[0][0], 2) + Math.pow(t.points[3][1] - t.points[0][1], 2)) : 0, u = t.normalAngle(l), d = t.point(l);
        setPoint(e, d, u, a, n, c / ((s + 1) * 2), c / ((s + 1) * 2)), a = -a;
      }
      return a;
    }
    ZigZagModifier.prototype.processPath = function(e, t, n, s) {
      var i = e._length, a = shapePool.newElement();
      if (a.c = e.c, e.c || (i -= 1), i === 0)
        return a;
      var o = -1, l = PolynomialBezier.shapeSegment(e, 0);
      zigZagCorner(a, e, 0, t, n, s, o);
      for (var c = 0; c < i; c += 1)
        o = zigZagSegment(a, l, t, n, s, -o), c === i - 1 && !e.c ? l = null : l = PolynomialBezier.shapeSegment(e, (c + 1) % i), zigZagCorner(a, e, c + 1, t, n, s, o);
      return a;
    }, ZigZagModifier.prototype.processShapes = function(e) {
      var t, n, s = this.shapes.length, i, a, o = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), c = this.pointsType.v;
      if (o !== 0) {
        var u, d;
        for (n = 0; n < s; n += 1) {
          if (u = this.shapes[n], d = u.localShapeCollection, !(!u.shape._mdf && !this._mdf && !e))
            for (d.releaseShapes(), u.shape._mdf = !0, t = u.shape.paths.shapes, a = u.shape.paths._length, i = 0; i < a; i += 1)
              d.addShape(this.processPath(t[i], o, l, c));
          u.shape.paths = u.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function linearOffset(e, t, n) {
      var s = Math.atan2(t[0] - e[0], t[1] - e[1]);
      return [polarOffset(e, s, n), polarOffset(t, s, n)];
    }
    function offsetSegment(e, t) {
      var n, s, i, a, o, l, c;
      c = linearOffset(e.points[0], e.points[1], t), n = c[0], s = c[1], c = linearOffset(e.points[1], e.points[2], t), i = c[0], a = c[1], c = linearOffset(e.points[2], e.points[3], t), o = c[0], l = c[1];
      var u = lineIntersection(n, s, i, a);
      u === null && (u = s);
      var d = lineIntersection(o, l, i, a);
      return d === null && (d = o), new PolynomialBezier(n, u, d, l);
    }
    function joinLines(e, t, n, s, i) {
      var a = t.points[3], o = n.points[0];
      if (s === 3 || pointEqual(a, o))
        return a;
      if (s === 2) {
        var l = -t.tangentAngle(1), c = -n.tangentAngle(0) + Math.PI, u = lineIntersection(a, polarOffset(a, l + Math.PI / 2, 100), o, polarOffset(o, l + Math.PI / 2, 100)), d = u ? pointDistance(u, a) : pointDistance(a, o) / 2, p = polarOffset(a, l, 2 * d * roundCorner);
        return e.setXYAt(p[0], p[1], "o", e.length() - 1), p = polarOffset(o, c, 2 * d * roundCorner), e.setTripleAt(o[0], o[1], o[0], o[1], p[0], p[1], e.length()), o;
      }
      var f = pointEqual(a, t.points[2]) ? t.points[0] : t.points[2], g = pointEqual(o, n.points[1]) ? n.points[3] : n.points[1], C = lineIntersection(f, a, o, g);
      return C && pointDistance(C, a) < i ? (e.setTripleAt(C[0], C[1], C[0], C[1], C[0], C[1], e.length()), C) : a;
    }
    function getIntersection(e, t) {
      var n = e.intersections(t);
      return n.length && floatEqual(n[0][0], 1) && n.shift(), n.length ? n[0] : null;
    }
    function pruneSegmentIntersection(e, t) {
      var n = e.slice(), s = t.slice(), i = getIntersection(e[e.length - 1], t[0]);
      return i && (n[e.length - 1] = e[e.length - 1].split(i[0])[0], s[0] = t[0].split(i[1])[1]), e.length > 1 && t.length > 1 && (i = getIntersection(e[0], t[t.length - 1]), i) ? [[e[0].split(i[0])[0]], [t[t.length - 1].split(i[1])[1]]] : [n, s];
    }
    function pruneIntersections(e) {
      for (var t, n = 1; n < e.length; n += 1)
        t = pruneSegmentIntersection(e[n - 1], e[n]), e[n - 1] = t[0], e[n] = t[1];
      return e.length > 1 && (t = pruneSegmentIntersection(e[e.length - 1], e[0]), e[e.length - 1] = t[0], e[0] = t[1]), e;
    }
    function offsetSegmentSplit(e, t) {
      var n = e.inflectionPoints(), s, i, a, o;
      if (n.length === 0)
        return [offsetSegment(e, t)];
      if (n.length === 1 || floatEqual(n[1], 1))
        return a = e.split(n[0]), s = a[0], i = a[1], [offsetSegment(s, t), offsetSegment(i, t)];
      a = e.split(n[0]), s = a[0];
      var l = (n[1] - n[0]) / (1 - n[0]);
      return a = a[1].split(l), o = a[0], i = a[1], [offsetSegment(s, t), offsetSegment(o, t), offsetSegment(i, t)];
    }
    function OffsetPathModifier() {
    }
    extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(e, t) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(e, t.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(e, t.ml, 0, null, this), this.lineJoin = t.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(e, t, n, s) {
      var i = shapePool.newElement();
      i.c = e.c;
      var a = e.length();
      e.c || (a -= 1);
      var o, l, c, u = [];
      for (o = 0; o < a; o += 1)
        c = PolynomialBezier.shapeSegment(e, o), u.push(offsetSegmentSplit(c, t));
      if (!e.c)
        for (o = a - 1; o >= 0; o -= 1)
          c = PolynomialBezier.shapeSegmentInverted(e, o), u.push(offsetSegmentSplit(c, t));
      u = pruneIntersections(u);
      var d = null, p = null;
      for (o = 0; o < u.length; o += 1) {
        var f = u[o];
        for (p && (d = joinLines(i, p, f[0], n, s)), p = f[f.length - 1], l = 0; l < f.length; l += 1)
          c = f[l], d && pointEqual(c.points[0], d) ? i.setXYAt(c.points[1][0], c.points[1][1], "o", i.length() - 1) : i.setTripleAt(c.points[0][0], c.points[0][1], c.points[1][0], c.points[1][1], c.points[0][0], c.points[0][1], i.length()), i.setTripleAt(c.points[3][0], c.points[3][1], c.points[3][0], c.points[3][1], c.points[2][0], c.points[2][1], i.length()), d = c.points[3];
      }
      return u.length && joinLines(i, p, u[0][0], n, s), i;
    }, OffsetPathModifier.prototype.processShapes = function(e) {
      var t, n, s = this.shapes.length, i, a, o = this.amount.v, l = this.miterLimit.v, c = this.lineJoin;
      if (o !== 0) {
        var u, d;
        for (n = 0; n < s; n += 1) {
          if (u = this.shapes[n], d = u.localShapeCollection, !(!u.shape._mdf && !this._mdf && !e))
            for (d.releaseShapes(), u.shape._mdf = !0, t = u.shape.paths.shapes, a = u.shape.paths._length, i = 0; i < a; i += 1)
              d.addShape(this.processPath(t[i], o, c, l));
          u.shape.paths = u.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function getFontProperties(e) {
      for (var t = e.fStyle ? e.fStyle.split(" ") : [], n = "normal", s = "normal", i = t.length, a, o = 0; o < i; o += 1)
        switch (a = t[o].toLowerCase(), a) {
          case "italic":
            s = "italic";
            break;
          case "bold":
            n = "700";
            break;
          case "black":
            n = "900";
            break;
          case "medium":
            n = "500";
            break;
          case "regular":
          case "normal":
            n = "400";
            break;
          case "light":
          case "thin":
            n = "200";
            break;
        }
      return {
        style: s,
        weight: e.fWeight || n
      };
    }
    var FontManager = function() {
      var e = 5e3, t = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
          shapes: []
        }
      }, n = [];
      n = n.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var s = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"], i = [65039, 8205];
      function a(P) {
        var $ = P.split(","), A, I = $.length, D = [];
        for (A = 0; A < I; A += 1)
          $[A] !== "sans-serif" && $[A] !== "monospace" && D.push($[A]);
        return D.join(",");
      }
      function o(P, $) {
        var A = createTag("span");
        A.setAttribute("aria-hidden", !0), A.style.fontFamily = $;
        var I = createTag("span");
        I.innerText = "giItT1WQy@!-/#", A.style.position = "absolute", A.style.left = "-10000px", A.style.top = "-10000px", A.style.fontSize = "300px", A.style.fontVariant = "normal", A.style.fontStyle = "normal", A.style.fontWeight = "normal", A.style.letterSpacing = "0", A.appendChild(I), document.body.appendChild(A);
        var D = I.offsetWidth;
        return I.style.fontFamily = a(P) + ", " + $, {
          node: I,
          w: D,
          parent: A
        };
      }
      function l() {
        var P, $ = this.fonts.length, A, I, D = $;
        for (P = 0; P < $; P += 1)
          this.fonts[P].loaded ? D -= 1 : this.fonts[P].fOrigin === "n" || this.fonts[P].origin === 0 ? this.fonts[P].loaded = !0 : (A = this.fonts[P].monoCase.node, I = this.fonts[P].monoCase.w, A.offsetWidth !== I ? (D -= 1, this.fonts[P].loaded = !0) : (A = this.fonts[P].sansCase.node, I = this.fonts[P].sansCase.w, A.offsetWidth !== I && (D -= 1, this.fonts[P].loaded = !0)), this.fonts[P].loaded && (this.fonts[P].sansCase.parent.parentNode.removeChild(this.fonts[P].sansCase.parent), this.fonts[P].monoCase.parent.parentNode.removeChild(this.fonts[P].monoCase.parent)));
        D !== 0 && Date.now() - this.initTime < e ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function c(P, $) {
        var A = document.body && $ ? "svg" : "canvas", I, D = getFontProperties(P);
        if (A === "svg") {
          var R = createNS("text");
          R.style.fontSize = "100px", R.setAttribute("font-family", P.fFamily), R.setAttribute("font-style", D.style), R.setAttribute("font-weight", D.weight), R.textContent = "1", P.fClass ? (R.style.fontFamily = "inherit", R.setAttribute("class", P.fClass)) : R.style.fontFamily = P.fFamily, $.appendChild(R), I = R;
        } else {
          var Y = new OffscreenCanvas(500, 500).getContext("2d");
          Y.font = D.style + " " + D.weight + " 100px " + P.fFamily, I = Y;
        }
        function q(j) {
          return A === "svg" ? (I.textContent = j, I.getComputedTextLength()) : I.measureText(j).width;
        }
        return {
          measureText: q
        };
      }
      function u(P, $) {
        if (!P) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = P.list;
          return;
        }
        if (!document.body) {
          this.isLoaded = !0, P.list.forEach(function(H) {
            H.helper = c(H), H.cache = {};
          }), this.fonts = P.list;
          return;
        }
        var A = P.list, I, D = A.length, R = D;
        for (I = 0; I < D; I += 1) {
          var Y = !0, q, j;
          if (A[I].loaded = !1, A[I].monoCase = o(A[I].fFamily, "monospace"), A[I].sansCase = o(A[I].fFamily, "sans-serif"), !A[I].fPath)
            A[I].loaded = !0, R -= 1;
          else if (A[I].fOrigin === "p" || A[I].origin === 3) {
            if (q = document.querySelectorAll('style[f-forigin="p"][f-family="' + A[I].fFamily + '"], style[f-origin="3"][f-family="' + A[I].fFamily + '"]'), q.length > 0 && (Y = !1), Y) {
              var X = createTag("style");
              X.setAttribute("f-forigin", A[I].fOrigin), X.setAttribute("f-origin", A[I].origin), X.setAttribute("f-family", A[I].fFamily), X.type = "text/css", X.innerText = "@font-face {font-family: " + A[I].fFamily + "; font-style: normal; src: url('" + A[I].fPath + "');}", $.appendChild(X);
            }
          } else if (A[I].fOrigin === "g" || A[I].origin === 1) {
            for (q = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), j = 0; j < q.length; j += 1)
              q[j].href.indexOf(A[I].fPath) !== -1 && (Y = !1);
            if (Y) {
              var ee = createTag("link");
              ee.setAttribute("f-forigin", A[I].fOrigin), ee.setAttribute("f-origin", A[I].origin), ee.type = "text/css", ee.rel = "stylesheet", ee.href = A[I].fPath, document.body.appendChild(ee);
            }
          } else if (A[I].fOrigin === "t" || A[I].origin === 2) {
            for (q = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), j = 0; j < q.length; j += 1)
              A[I].fPath === q[j].src && (Y = !1);
            if (Y) {
              var G = createTag("link");
              G.setAttribute("f-forigin", A[I].fOrigin), G.setAttribute("f-origin", A[I].origin), G.setAttribute("rel", "stylesheet"), G.setAttribute("href", A[I].fPath), $.appendChild(G);
            }
          }
          A[I].helper = c(A[I], $), A[I].cache = {}, this.fonts.push(A[I]);
        }
        R === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function d(P) {
        if (P) {
          this.chars || (this.chars = []);
          var $, A = P.length, I, D = this.chars.length, R;
          for ($ = 0; $ < A; $ += 1) {
            for (I = 0, R = !1; I < D; )
              this.chars[I].style === P[$].style && this.chars[I].fFamily === P[$].fFamily && this.chars[I].ch === P[$].ch && (R = !0), I += 1;
            R || (this.chars.push(P[$]), D += 1);
          }
        }
      }
      function p(P, $, A) {
        for (var I = 0, D = this.chars.length; I < D; ) {
          if (this.chars[I].ch === P && this.chars[I].style === $ && this.chars[I].fFamily === A)
            return this.chars[I];
          I += 1;
        }
        return (typeof P == "string" && P.charCodeAt(0) !== 13 || !P) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", P, $, A)), t;
      }
      function f(P, $, A) {
        var I = this.getFontByName($), D = P.charCodeAt(0);
        if (!I.cache[D + 1]) {
          var R = I.helper;
          if (P === " ") {
            var Y = R.measureText("|" + P + "|"), q = R.measureText("||");
            I.cache[D + 1] = (Y - q) / 100;
          } else
            I.cache[D + 1] = R.measureText(P) / 100;
        }
        return I.cache[D + 1] * A;
      }
      function g(P) {
        for (var $ = 0, A = this.fonts.length; $ < A; ) {
          if (this.fonts[$].fName === P)
            return this.fonts[$];
          $ += 1;
        }
        return this.fonts[0];
      }
      function C(P, $) {
        var A = P.toString(16) + $.toString(16);
        return s.indexOf(A) !== -1;
      }
      function k(P, $) {
        return $ ? P === i[0] && $ === i[1] : P === i[1];
      }
      function M(P) {
        return n.indexOf(P) !== -1;
      }
      function _() {
        this.isLoaded = !0;
      }
      var S = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      S.isModifier = C, S.isZeroWidthJoiner = k, S.isCombinedCharacter = M;
      var E = {
        addChars: d,
        addFonts: u,
        getCharData: p,
        getFontByName: g,
        measureText: f,
        checkLoadedFonts: l,
        setIsLoaded: _
      };
      return S.prototype = E, S;
    }();
    function RenderableElement() {
    }
    RenderableElement.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) === -1 && this.renderableComponents.push(t);
      },
      removeRenderableComponent: function(t) {
        this.renderableComponents.indexOf(t) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
      },
      prepareRenderableFrame: function(t) {
        this.checkLayerLimits(t);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      /**
         * @function
         * Initializes frame related properties.
         *
         * @param {number} num
         * current frame number in Layer's time
         *
         */
      checkLayerLimits: function(t) {
        this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var t, n = this.renderableComponents.length;
        for (t = 0; t < n; t += 1)
          this.renderableComponents[t].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? {
          w: this.data.textData.width,
          h: this.data.textData.height
        } : {
          w: this.data.width,
          h: this.data.height
        };
      }
    };
    var getBlendMode = function() {
      var e = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
      };
      return function(t) {
        return e[t] || "";
      };
    }();
    function SliderEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
    }
    function AngleEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
    }
    function ColorEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 1, 0, n);
    }
    function PointEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 1, 0, n);
    }
    function LayerIndexEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
    }
    function MaskIndexEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
    }
    function CheckboxEffect(e, t, n) {
      this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(e, t) {
      var n = e.ef || [];
      this.effectElements = [];
      var s, i = n.length, a;
      for (s = 0; s < i; s += 1)
        a = new GroupEffect(n[s], t), this.effectElements.push(a);
    }
    function GroupEffect(e, t) {
      this.init(e, t);
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(e, t) {
      this.data = e, this.effectElements = [], this.initDynamicPropertyContainer(t);
      var n, s = this.data.ef.length, i, a = this.data.ef;
      for (n = 0; n < s; n += 1) {
        switch (i = null, a[n].ty) {
          case 0:
            i = new SliderEffect(a[n], t, this);
            break;
          case 1:
            i = new AngleEffect(a[n], t, this);
            break;
          case 2:
            i = new ColorEffect(a[n], t, this);
            break;
          case 3:
            i = new PointEffect(a[n], t, this);
            break;
          case 4:
          case 7:
            i = new CheckboxEffect(a[n], t, this);
            break;
          case 10:
            i = new LayerIndexEffect(a[n], t, this);
            break;
          case 11:
            i = new MaskIndexEffect(a[n], t, this);
            break;
          case 5:
            i = new EffectsManager(a[n], t);
            break;
          default:
            i = new NoValueEffect(a[n]);
            break;
        }
        i && this.effectElements.push(i);
      }
    };
    function BaseElement() {
    }
    BaseElement.prototype = {
      checkMasks: function() {
        if (!this.data.hasMask)
          return !1;
        for (var t = 0, n = this.data.masksProperties.length; t < n; ) {
          if (this.data.masksProperties[t].mode !== "n" && this.data.masksProperties[t].cl !== !1)
            return !0;
          t += 1;
        }
        return !1;
      },
      initExpressions: function() {
        var t = getExpressionInterfaces();
        if (t) {
          var n = t("layer"), s = t("effects"), i = t("shape"), a = t("text"), o = t("comp");
          this.layerInterface = n(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
          var l = s.createEffectsInterface(this, this.layerInterface);
          this.layerInterface.registerEffectsInterface(l), this.data.ty === 0 || this.data.xt ? this.compInterface = o(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = i(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = a(this), this.layerInterface.text = this.layerInterface.textInterface);
        }
      },
      setBlendMode: function() {
        var t = getBlendMode(this.data.bm), n = this.baseElement || this.layerElement;
        n.style["mix-blend-mode"] = t;
      },
      initBaseData: function(t, n, s) {
        this.globalData = n, this.comp = s, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
      },
      getType: function() {
        return this.type;
      },
      sourceRectAtTime: function() {
      }
    };
    function FrameElement() {
    }
    FrameElement.prototype = {
      /**
         * @function
         * Initializes frame related properties.
         *
         */
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      /**
         * @function
         * Calculates all dynamic values
         *
         * @param {number} num
         * current frame number in Layer's time
         * @param {boolean} isVisible
         * if layers is currently in range
         *
         */
      prepareProperties: function(t, n) {
        var s, i = this.dynamicProperties.length;
        for (s = 0; s < i; s += 1)
          (n || this._isParent && this.dynamicProperties[s].propType === "transform") && (this.dynamicProperties[s].getValue(), this.dynamicProperties[s]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(t) {
        this.dynamicProperties.indexOf(t) === -1 && this.dynamicProperties.push(t);
      }
    };
    function FootageElement(e, t, n) {
      this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.footageData = t.imageLoader.getAsset(this.assetData), this.initBaseData(e, t, n);
    }
    FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var e = getExpressionInterfaces();
      if (e) {
        var t = e("footage");
        this.layerInterface = t(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    };
    function AudioElement(e, t, n) {
      this.initFrame(), this.initRenderable(), this.assetData = t.getAssetData(e.refId), this.initBaseData(e, t, n), this._isPlaying = !1, this._canPlay = !1;
      var s = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(s), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      }, this.lv = PropertyFactory.getProp(this, e.au && e.au.lv ? e.au.lv : {
        k: [100]
      }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(e) {
      if (this.prepareRenderableFrame(e, !0), this.prepareProperties(e, !0), this.tm._placeholder)
        this._currentTime = e / this.data.sr;
      else {
        var t = this.tm.v;
        this._currentTime = t;
      }
      this._volume = this.lv.v[0];
      var n = this._volume * this._volumeMultiplier;
      this._previousVolume !== n && (this._previousVolume = n, this.audio.volume(n));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(e) {
      this.audio.rate(e);
    }, AudioElement.prototype.volume = function(e) {
      this._volumeMultiplier = e, this._previousVolume = e * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    };
    function BaseRenderer() {
    }
    BaseRenderer.prototype.checkLayers = function(e) {
      var t, n = this.layers.length, s;
      for (this.completeLayers = !0, t = n - 1; t >= 0; t -= 1)
        this.elements[t] || (s = this.layers[t], s.ip - s.st <= e - this.layers[t].st && s.op - s.st > e - this.layers[t].st && this.buildItem(t)), this.completeLayers = this.elements[t] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(e) {
      switch (e.ty) {
        case 2:
          return this.createImage(e);
        case 0:
          return this.createComp(e);
        case 1:
          return this.createSolid(e);
        case 3:
          return this.createNull(e);
        case 4:
          return this.createShape(e);
        case 5:
          return this.createText(e);
        case 6:
          return this.createAudio(e);
        case 13:
          return this.createCamera(e);
        case 15:
          return this.createFootage(e);
        default:
          return this.createNull(e);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(e) {
      return new AudioElement(e, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(e) {
      return new FootageElement(e, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        this.buildItem(e);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(e) {
      this.completeLayers = !1;
      var t, n = e.length, s, i = this.layers.length;
      for (t = 0; t < n; t += 1)
        for (s = 0; s < i; ) {
          if (this.layers[s].id === e[t].id) {
            this.layers[s] = e[t];
            break;
          }
          s += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(e) {
      this.globalData.projectInterface = e;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(e, t, n) {
      for (var s = this.elements, i = this.layers, a = 0, o = i.length; a < o; )
        i[a].ind == t && (!s[a] || s[a] === !0 ? (this.buildItem(a), this.addPendingElement(e)) : (n.push(s[a]), s[a].setAsParent(), i[a].parent !== void 0 ? this.buildElementParenting(e, i[a].parent, n) : e.setHierarchy(n))), a += 1;
    }, BaseRenderer.prototype.addPendingElement = function(e) {
      this.pendingElements.push(e);
    }, BaseRenderer.prototype.searchExtraCompositions = function(e) {
      var t, n = e.length;
      for (t = 0; t < n; t += 1)
        if (e[t].xt) {
          var s = this.createComp(e[t]);
          s.initExpressions(), this.globalData.projectInterface.registerComposition(s);
        }
    }, BaseRenderer.prototype.getElementById = function(e) {
      var t, n = this.elements.length;
      for (t = 0; t < n; t += 1)
        if (this.elements[t].data.ind === e)
          return this.elements[t];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(e) {
      var t = e.shift(), n;
      if (typeof t == "number")
        n = this.elements[t];
      else {
        var s, i = this.elements.length;
        for (s = 0; s < i; s += 1)
          if (this.elements[s].data.nm === t) {
            n = this.elements[s];
            break;
          }
      }
      return e.length === 0 ? n : n.getElementByPath(e);
    }, BaseRenderer.prototype.setupGlobalData = function(e, t) {
      this.globalData.fontManager = new FontManager(), this.globalData.fontManager.addChars(e.chars), this.globalData.fontManager.addFonts(e.fonts, t), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = e.fr, this.globalData.nm = e.nm, this.globalData.compSize = {
        w: e.w,
        h: e.h
      };
    };
    function TransformElement() {
    }
    TransformElement.prototype = {
      initTransform: function() {
        this.finalTransform = {
          mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
            o: 0
          },
          _matMdf: !1,
          _opMdf: !1,
          mat: new Matrix()
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
      },
      renderTransform: function() {
        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
          var t, n = this.finalTransform.mat, s = 0, i = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; s < i; ) {
              if (this.hierarchy[s].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              s += 1;
            }
          if (this.finalTransform._matMdf)
            for (t = this.finalTransform.mProp.v.props, n.cloneFromProps(t), s = 0; s < i; s += 1)
              t = this.hierarchy[s].finalTransform.mProp.v.props, n.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
        }
      },
      globalToLocal: function(t) {
        var n = [];
        n.push(this.finalTransform);
        for (var s = !0, i = this.comp; s; )
          i.finalTransform ? (i.data.hasMask && n.splice(0, 0, i.finalTransform), i = i.comp) : s = !1;
        var a, o = n.length, l;
        for (a = 0; a < o; a += 1)
          l = n[a].mat.applyToPointArray(0, 0, 0), t = [t[0] - l[0], t[1] - l[1], 0];
        return t;
      },
      mHelper: new Matrix()
    };
    function MaskElement(e, t, n) {
      this.data = e, this.element = t, this.globalData = n, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var s = this.globalData.defs, i, a = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(a), this.solidPath = "";
      var o, l = this.masksProperties, c = 0, u = [], d, p, f = createElementID(), g, C, k, M, _ = "clipPath", S = "clip-path";
      for (i = 0; i < a; i += 1)
        if ((l[i].mode !== "a" && l[i].mode !== "n" || l[i].inv || l[i].o.k !== 100 || l[i].o.x) && (_ = "mask", S = "mask"), (l[i].mode === "s" || l[i].mode === "i") && c === 0 ? (g = createNS("rect"), g.setAttribute("fill", "#ffffff"), g.setAttribute("width", this.element.comp.data.w || 0), g.setAttribute("height", this.element.comp.data.h || 0), u.push(g)) : g = null, o = createNS("path"), l[i].mode === "n")
          this.viewData[i] = {
            op: PropertyFactory.getProp(this.element, l[i].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, l[i], 3),
            elem: o,
            lastPath: ""
          }, s.appendChild(o);
        else {
          c += 1, o.setAttribute("fill", l[i].mode === "s" ? "#000000" : "#ffffff"), o.setAttribute("clip-rule", "nonzero");
          var E;
          if (l[i].x.k !== 0 ? (_ = "mask", S = "mask", M = PropertyFactory.getProp(this.element, l[i].x, 0, null, this.element), E = createElementID(), C = createNS("filter"), C.setAttribute("id", E), k = createNS("feMorphology"), k.setAttribute("operator", "erode"), k.setAttribute("in", "SourceGraphic"), k.setAttribute("radius", "0"), C.appendChild(k), s.appendChild(C), o.setAttribute("stroke", l[i].mode === "s" ? "#000000" : "#ffffff")) : (k = null, M = null), this.storedData[i] = {
            elem: o,
            x: M,
            expan: k,
            lastPath: "",
            lastOperator: "",
            filterId: E,
            lastRadius: 0
          }, l[i].mode === "i") {
            p = u.length;
            var P = createNS("g");
            for (d = 0; d < p; d += 1)
              P.appendChild(u[d]);
            var $ = createNS("mask");
            $.setAttribute("mask-type", "alpha"), $.setAttribute("id", f + "_" + c), $.appendChild(o), s.appendChild($), P.setAttribute("mask", "url(" + getLocationHref() + "#" + f + "_" + c + ")"), u.length = 0, u.push(P);
          } else
            u.push(o);
          l[i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i] = {
            elem: o,
            lastPath: "",
            op: PropertyFactory.getProp(this.element, l[i].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, l[i], 3),
            invRect: g
          }, this.viewData[i].prop.k || this.drawPath(l[i], this.viewData[i].prop.v, this.viewData[i]);
        }
      for (this.maskElement = createNS(_), a = u.length, i = 0; i < a; i += 1)
        this.maskElement.appendChild(u[i]);
      c > 0 && (this.maskElement.setAttribute("id", f), this.element.maskedElement.setAttribute(S, "url(" + getLocationHref() + "#" + f + ")"), s.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(e) {
      return this.viewData[e].prop;
    }, MaskElement.prototype.renderFrame = function(e) {
      var t = this.element.finalTransform.mat, n, s = this.masksProperties.length;
      for (n = 0; n < s; n += 1)
        if ((this.viewData[n].prop._mdf || e) && this.drawPath(this.masksProperties[n], this.viewData[n].prop.v, this.viewData[n]), (this.viewData[n].op._mdf || e) && this.viewData[n].elem.setAttribute("fill-opacity", this.viewData[n].op.v), this.masksProperties[n].mode !== "n" && (this.viewData[n].invRect && (this.element.finalTransform.mProp._mdf || e) && this.viewData[n].invRect.setAttribute("transform", t.getInverseMatrix().to2dCSS()), this.storedData[n].x && (this.storedData[n].x._mdf || e))) {
          var i = this.storedData[n].expan;
          this.storedData[n].x.v < 0 ? (this.storedData[n].lastOperator !== "erode" && (this.storedData[n].lastOperator = "erode", this.storedData[n].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[n].filterId + ")")), i.setAttribute("radius", -this.storedData[n].x.v)) : (this.storedData[n].lastOperator !== "dilate" && (this.storedData[n].lastOperator = "dilate", this.storedData[n].elem.setAttribute("filter", null)), this.storedData[n].elem.setAttribute("stroke-width", this.storedData[n].x.v * 2));
        }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var e = "M0,0 ";
      return e += " h" + this.globalData.compSize.w, e += " v" + this.globalData.compSize.h, e += " h-" + this.globalData.compSize.w, e += " v-" + this.globalData.compSize.h + " ", e;
    }, MaskElement.prototype.drawPath = function(e, t, n) {
      var s = " M" + t.v[0][0] + "," + t.v[0][1], i, a;
      for (a = t._length, i = 1; i < a; i += 1)
        s += " C" + t.o[i - 1][0] + "," + t.o[i - 1][1] + " " + t.i[i][0] + "," + t.i[i][1] + " " + t.v[i][0] + "," + t.v[i][1];
      if (t.c && a > 1 && (s += " C" + t.o[i - 1][0] + "," + t.o[i - 1][1] + " " + t.i[0][0] + "," + t.i[0][1] + " " + t.v[0][0] + "," + t.v[0][1]), n.lastPath !== s) {
        var o = "";
        n.elem && (t.c && (o = e.inv ? this.solidPath + s : s), n.elem.setAttribute("d", o)), n.lastPath = s;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = function() {
      var e = {};
      e.createFilter = t, e.createAlphaToLuminanceFilter = n;
      function t(s, i) {
        var a = createNS("filter");
        return a.setAttribute("id", s), i !== !0 && (a.setAttribute("filterUnits", "objectBoundingBox"), a.setAttribute("x", "0%"), a.setAttribute("y", "0%"), a.setAttribute("width", "100%"), a.setAttribute("height", "100%")), a;
      }
      function n() {
        var s = createNS("feColorMatrix");
        return s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), s;
      }
      return e;
    }(), featureSupport = function() {
      var e = {
        maskType: !0,
        svgLumaHidden: !0,
        offscreenCanvas: typeof OffscreenCanvas < "u"
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (e.maskType = !1), /firefox/i.test(navigator.userAgent) && (e.svgLumaHidden = !1), e;
    }(), registeredEffects = {}, idPrefix = "filter_result_";
    function SVGEffects(e) {
      var t, n = "SourceGraphic", s = e.data.ef ? e.data.ef.length : 0, i = createElementID(), a = filtersFactory.createFilter(i, !0), o = 0;
      this.filters = [];
      var l;
      for (t = 0; t < s; t += 1) {
        l = null;
        var c = e.data.ef[t].ty;
        if (registeredEffects[c]) {
          var u = registeredEffects[c].effect;
          l = new u(a, e.effectsManager.effectElements[t], e, idPrefix + o, n), n = idPrefix + o, registeredEffects[c].countsAsEffect && (o += 1);
        }
        l && this.filters.push(l);
      }
      o && (e.globalData.defs.appendChild(a), e.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + i + ")")), this.filters.length && e.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(e) {
      var t, n = this.filters.length;
      for (t = 0; t < n; t += 1)
        this.filters[t].renderFrame(e);
    };
    function registerEffect(e, t, n) {
      registeredEffects[e] = {
        effect: t,
        countsAsEffect: n
      };
    }
    function SVGBaseElement() {
    }
    SVGBaseElement.prototype = {
      initRendererElement: function() {
        this.layerElement = createNS("g");
      },
      createContainerElements: function() {
        this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
        var t = null;
        if (this.data.td) {
          this.matteMasks = {};
          var n = createNS("g");
          n.setAttribute("id", this.layerId), n.appendChild(this.layerElement), t = n, this.globalData.defs.appendChild(n);
        } else
          this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
          var s = createNS("clipPath"), i = createNS("path");
          i.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var a = createElementID();
          if (s.setAttribute("id", a), s.appendChild(i), this.globalData.defs.appendChild(s), this.checkMasks()) {
            var o = createNS("g");
            o.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")"), o.appendChild(this.layerElement), this.transformedElement = o, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else
            this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + a + ")");
        }
        this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        this.finalTransform._matMdf && this.transformedElement.setAttribute("transform", this.finalTransform.mat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.mProp.o.v);
      },
      destroyBaseElement: function() {
        this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
      },
      getBaseElement: function() {
        return this.data.hd ? null : this.baseElement;
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this);
      },
      getMatte: function(t) {
        if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
          var n = this.layerId + "_" + t, s, i, a, o;
          if (t === 1 || t === 3) {
            var l = createNS("mask");
            l.setAttribute("id", n), l.setAttribute("mask-type", t === 3 ? "luminance" : "alpha"), a = createNS("use"), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), l.appendChild(a), this.globalData.defs.appendChild(l), !featureSupport.maskType && t === 1 && (l.setAttribute("mask-type", "luminance"), s = createElementID(), i = filtersFactory.createFilter(s), this.globalData.defs.appendChild(i), i.appendChild(filtersFactory.createAlphaToLuminanceFilter()), o = createNS("g"), o.appendChild(a), l.appendChild(o), o.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")"));
          } else if (t === 2) {
            var c = createNS("mask");
            c.setAttribute("id", n), c.setAttribute("mask-type", "alpha");
            var u = createNS("g");
            c.appendChild(u), s = createElementID(), i = filtersFactory.createFilter(s);
            var d = createNS("feComponentTransfer");
            d.setAttribute("in", "SourceGraphic"), i.appendChild(d);
            var p = createNS("feFuncA");
            p.setAttribute("type", "table"), p.setAttribute("tableValues", "1.0 0.0"), d.appendChild(p), this.globalData.defs.appendChild(i);
            var f = createNS("rect");
            f.setAttribute("width", this.comp.data.w), f.setAttribute("height", this.comp.data.h), f.setAttribute("x", "0"), f.setAttribute("y", "0"), f.setAttribute("fill", "#ffffff"), f.setAttribute("opacity", "0"), u.setAttribute("filter", "url(" + getLocationHref() + "#" + s + ")"), u.appendChild(f), a = createNS("use"), a.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), u.appendChild(a), featureSupport.maskType || (c.setAttribute("mask-type", "luminance"), i.appendChild(filtersFactory.createAlphaToLuminanceFilter()), o = createNS("g"), u.appendChild(f), o.appendChild(this.layerElement), u.appendChild(o)), this.globalData.defs.appendChild(c);
          }
          this.matteMasks[t] = n;
        }
        return this.matteMasks[t];
      },
      setMatte: function(t) {
        this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
      }
    };
    function HierarchyElement() {
    }
    HierarchyElement.prototype = {
      /**
         * @function
         * Initializes hierarchy properties
         *
         */
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      /**
         * @function
         * Sets layer's hierarchy.
         * @param {array} hierarch
         * layer's parent list
         *
         */
      setHierarchy: function(t) {
        this.hierarchy = t;
      },
      /**
         * @function
         * Sets layer as parent.
         *
         */
      setAsParent: function() {
        this._isParent = !0;
      },
      /**
         * @function
         * Searches layer's parenting chain
         *
         */
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function RenderableDOMElement() {
    }
    (function() {
      var e = {
        initElement: function(n, s, i) {
          this.initFrame(), this.initBaseData(n, s, i), this.initTransform(n, s, i), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
        },
        hide: function() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            var n = this.baseElement || this.layerElement;
            n.style.display = "none", this.hidden = !0;
          }
        },
        show: function() {
          if (this.isInRange && !this.isTransparent) {
            if (!this.data.hd) {
              var n = this.baseElement || this.layerElement;
              n.style.display = "block";
            }
            this.hidden = !1, this._isFirstFrame = !0;
          }
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        renderInnerContent: function() {
        },
        prepareFrame: function(n) {
          this._mdf = !1, this.prepareRenderableFrame(n), this.prepareProperties(n, this.isInRange), this.checkTransparency();
        },
        destroy: function() {
          this.innerElem = null, this.destroyBaseElement();
        }
      };
      extendPrototype([RenderableElement, createProxyFunction(e)], RenderableDOMElement);
    })();
    function IImageElement(e, t, n) {
      this.assetData = t.getAssetData(e.refId), this.initElement(e, t, n), this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
      };
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var e = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function ProcessedElement(e, t) {
      this.elem = e, this.pos = t;
    }
    function IShapeElement() {
    }
    IShapeElement.prototype = {
      addShapeToModifiers: function(t) {
        var n, s = this.shapeModifiers.length;
        for (n = 0; n < s; n += 1)
          this.shapeModifiers[n].addShape(t);
      },
      isShapeInAnimatedModifiers: function(t) {
        for (var n = 0, s = this.shapeModifiers.length; n < s; )
          if (this.shapeModifiers[n].isAnimatedWithShape(t))
            return !0;
        return !1;
      },
      renderModifiers: function() {
        if (this.shapeModifiers.length) {
          var t, n = this.shapes.length;
          for (t = 0; t < n; t += 1)
            this.shapes[t].sh.reset();
          n = this.shapeModifiers.length;
          var s;
          for (t = n - 1; t >= 0 && (s = this.shapeModifiers[t].processShapes(this._isFirstFrame), !s); t -= 1)
            ;
        }
      },
      searchProcessedElement: function(t) {
        for (var n = this.processedElements, s = 0, i = n.length; s < i; ) {
          if (n[s].elem === t)
            return n[s].pos;
          s += 1;
        }
        return 0;
      },
      addProcessedElement: function(t, n) {
        for (var s = this.processedElements, i = s.length; i; )
          if (i -= 1, s[i].elem === t) {
            s[i].pos = n;
            return;
          }
        s.push(new ProcessedElement(t, n));
      },
      prepareFrame: function(t) {
        this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
      }
    };
    var lineCapEnum = {
      1: "butt",
      2: "round",
      3: "square"
    }, lineJoinEnum = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
    function SVGShapeData(e, t, n) {
      this.caches = [], this.styles = [], this.transformers = e, this.lStr = "", this.sh = n, this.lvl = t, this._isAnimated = !!n.k;
      for (var s = 0, i = e.length; s < i; ) {
        if (e[s].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        s += 1;
      }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function SVGStyleData(e, t) {
      this.data = e, this.type = e.ty, this.d = "", this.lvl = t, this._mdf = !1, this.closed = e.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function DashProperty(e, t, n, s) {
      this.elem = e, this.frameId = -1, this.dataProps = createSizedArray(t.length), this.renderer = n, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", t.length ? t.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(s);
      var i, a = t.length || 0, o;
      for (i = 0; i < a; i += 1)
        o = PropertyFactory.getProp(e, t[i].v, 0, 0, this), this.k = o.k || this.k, this.dataProps[i] = {
          n: t[i].n,
          p: o
        };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(e) {
      if (!(this.elem.globalData.frameId === this.frameId && !e) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || e, this._mdf)) {
        var t = 0, n = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), t = 0; t < n; t += 1)
          this.dataProps[t].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[t].p.v : this.dashArray[t] = this.dataProps[t].p.v : this.dashoffset[0] = this.dataProps[t].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty);
    function SVGStrokeStyleData(e, t, n) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = n, this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
    function SVGFillStyleData(e, t, n) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.c = PropertyFactory.getProp(e, t.c, 1, 255, this), this.style = n;
    }
    extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
    function SVGNoStyleData(e, t, n) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.style = n;
    }
    extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
    function GradientProperty(e, t, n) {
      this.data = t, this.c = createTypedArray("uint8c", t.p * 4);
      var s = t.k.k[0].s ? t.k.k[0].s.length - t.p * 4 : t.k.k.length - t.p * 4;
      this.o = createTypedArray("float32", s), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = s, this.initDynamicPropertyContainer(n), this.prop = PropertyFactory.getProp(e, t.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    GradientProperty.prototype.comparePoints = function(e, t) {
      for (var n = 0, s = this.o.length / 2, i; n < s; ) {
        if (i = Math.abs(e[n * 4] - e[t * 4 + n * 2]), i > 0.01)
          return !1;
        n += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var e = 0, t = this.data.k.k.length; e < t; ) {
          if (!this.comparePoints(this.data.k.k[e].s, this.data.p))
            return !1;
          e += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(e) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || e) {
        var t, n = this.data.p * 4, s, i;
        for (t = 0; t < n; t += 1)
          s = t % 4 === 0 ? 100 : 255, i = Math.round(this.prop.v[t] * s), this.c[t] !== i && (this.c[t] = i, this._cmdf = !e);
        if (this.o.length)
          for (n = this.prop.v.length, t = this.data.p * 4; t < n; t += 1)
            s = t % 2 === 0 ? 100 : 1, i = t % 2 === 0 ? Math.round(this.prop.v[t] * 100) : this.prop.v[t], this.o[t - this.data.p * 4] !== i && (this.o[t - this.data.p * 4] = i, this._omdf = !e);
        this._mdf = !e;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty);
    function SVGGradientFillStyleData(e, t, n) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.initGradientData(e, t, n);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(e, t, n) {
      this.o = PropertyFactory.getProp(e, t.o, 0, 0.01, this), this.s = PropertyFactory.getProp(e, t.s, 1, null, this), this.e = PropertyFactory.getProp(e, t.e, 1, null, this), this.h = PropertyFactory.getProp(e, t.h || {
        k: 0
      }, 0, 0.01, this), this.a = PropertyFactory.getProp(e, t.a || {
        k: 0
      }, 0, degToRads, this), this.g = new GradientProperty(e, t.g, this), this.style = n, this.stops = [], this.setGradientData(n.pElem, t), this.setGradientOpacity(t, n), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(e, t) {
      var n = createElementID(), s = createNS(t.t === 1 ? "linearGradient" : "radialGradient");
      s.setAttribute("id", n), s.setAttribute("spreadMethod", "pad"), s.setAttribute("gradientUnits", "userSpaceOnUse");
      var i = [], a, o, l;
      for (l = t.g.p * 4, o = 0; o < l; o += 4)
        a = createNS("stop"), s.appendChild(a), i.push(a);
      e.setAttribute(t.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + n + ")"), this.gf = s, this.cst = i;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(e, t) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var n, s, i, a = createNS("mask"), o = createNS("path");
        a.appendChild(o);
        var l = createElementID(), c = createElementID();
        a.setAttribute("id", c);
        var u = createNS(e.t === 1 ? "linearGradient" : "radialGradient");
        u.setAttribute("id", l), u.setAttribute("spreadMethod", "pad"), u.setAttribute("gradientUnits", "userSpaceOnUse"), i = e.g.k.k[0].s ? e.g.k.k[0].s.length : e.g.k.k.length;
        var d = this.stops;
        for (s = e.g.p * 4; s < i; s += 2)
          n = createNS("stop"), n.setAttribute("stop-color", "rgb(255,255,255)"), u.appendChild(n), d.push(n);
        o.setAttribute(e.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + l + ")"), e.ty === "gs" && (o.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), o.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), e.lj === 1 && o.setAttribute("stroke-miterlimit", e.ml)), this.of = u, this.ms = a, this.ost = d, this.maskId = c, t.msElem = o;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(e, t, n) {
      this.initDynamicPropertyContainer(e), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(e, t.w, 0, null, this), this.d = new DashProperty(e, t.d || {}, "svg", this), this.initGradientData(e, t, n), this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(e, t, n) {
      this.transform = {
        mProps: e,
        op: t,
        container: n
      }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function(t, n, s, i) {
      if (n === 0)
        return "";
      var a = t.o, o = t.i, l = t.v, c, u = " M" + i.applyToPointStringified(l[0][0], l[0][1]);
      for (c = 1; c < n; c += 1)
        u += " C" + i.applyToPointStringified(a[c - 1][0], a[c - 1][1]) + " " + i.applyToPointStringified(o[c][0], o[c][1]) + " " + i.applyToPointStringified(l[c][0], l[c][1]);
      return s && n && (u += " C" + i.applyToPointStringified(a[c - 1][0], a[c - 1][1]) + " " + i.applyToPointStringified(o[0][0], o[0][1]) + " " + i.applyToPointStringified(l[0][0], l[0][1]), u += "z"), u;
    }, SVGElementsRenderer = function() {
      var e = new Matrix(), t = new Matrix(), n = {
        createRenderFunction: s
      };
      function s(p) {
        switch (p.ty) {
          case "fl":
            return l;
          case "gf":
            return u;
          case "gs":
            return c;
          case "st":
            return d;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return o;
          case "tr":
            return i;
          case "no":
            return a;
          default:
            return null;
        }
      }
      function i(p, f, g) {
        (g || f.transform.op._mdf) && f.transform.container.setAttribute("opacity", f.transform.op.v), (g || f.transform.mProps._mdf) && f.transform.container.setAttribute("transform", f.transform.mProps.v.to2dCSS());
      }
      function a() {
      }
      function o(p, f, g) {
        var C, k, M, _, S, E, P = f.styles.length, $ = f.lvl, A, I, D, R, Y;
        for (E = 0; E < P; E += 1) {
          if (_ = f.sh._mdf || g, f.styles[E].lvl < $) {
            for (I = t.reset(), R = $ - f.styles[E].lvl, Y = f.transformers.length - 1; !_ && R > 0; )
              _ = f.transformers[Y].mProps._mdf || _, R -= 1, Y -= 1;
            if (_)
              for (R = $ - f.styles[E].lvl, Y = f.transformers.length - 1; R > 0; )
                D = f.transformers[Y].mProps.v.props, I.transform(D[0], D[1], D[2], D[3], D[4], D[5], D[6], D[7], D[8], D[9], D[10], D[11], D[12], D[13], D[14], D[15]), R -= 1, Y -= 1;
          } else
            I = e;
          if (A = f.sh.paths, k = A._length, _) {
            for (M = "", C = 0; C < k; C += 1)
              S = A.shapes[C], S && S._length && (M += buildShapeString(S, S._length, S.c, I));
            f.caches[E] = M;
          } else
            M = f.caches[E];
          f.styles[E].d += p.hd === !0 ? "" : M, f.styles[E]._mdf = _ || f.styles[E]._mdf;
        }
      }
      function l(p, f, g) {
        var C = f.style;
        (f.c._mdf || g) && C.pElem.setAttribute("fill", "rgb(" + bmFloor(f.c.v[0]) + "," + bmFloor(f.c.v[1]) + "," + bmFloor(f.c.v[2]) + ")"), (f.o._mdf || g) && C.pElem.setAttribute("fill-opacity", f.o.v);
      }
      function c(p, f, g) {
        u(p, f, g), d(p, f, g);
      }
      function u(p, f, g) {
        var C = f.gf, k = f.g._hasOpacity, M = f.s.v, _ = f.e.v;
        if (f.o._mdf || g) {
          var S = p.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          f.style.pElem.setAttribute(S, f.o.v);
        }
        if (f.s._mdf || g) {
          var E = p.t === 1 ? "x1" : "cx", P = E === "x1" ? "y1" : "cy";
          C.setAttribute(E, M[0]), C.setAttribute(P, M[1]), k && !f.g._collapsable && (f.of.setAttribute(E, M[0]), f.of.setAttribute(P, M[1]));
        }
        var $, A, I, D;
        if (f.g._cmdf || g) {
          $ = f.cst;
          var R = f.g.c;
          for (I = $.length, A = 0; A < I; A += 1)
            D = $[A], D.setAttribute("offset", R[A * 4] + "%"), D.setAttribute("stop-color", "rgb(" + R[A * 4 + 1] + "," + R[A * 4 + 2] + "," + R[A * 4 + 3] + ")");
        }
        if (k && (f.g._omdf || g)) {
          var Y = f.g.o;
          for (f.g._collapsable ? $ = f.cst : $ = f.ost, I = $.length, A = 0; A < I; A += 1)
            D = $[A], f.g._collapsable || D.setAttribute("offset", Y[A * 2] + "%"), D.setAttribute("stop-opacity", Y[A * 2 + 1]);
        }
        if (p.t === 1)
          (f.e._mdf || g) && (C.setAttribute("x2", _[0]), C.setAttribute("y2", _[1]), k && !f.g._collapsable && (f.of.setAttribute("x2", _[0]), f.of.setAttribute("y2", _[1])));
        else {
          var q;
          if ((f.s._mdf || f.e._mdf || g) && (q = Math.sqrt(Math.pow(M[0] - _[0], 2) + Math.pow(M[1] - _[1], 2)), C.setAttribute("r", q), k && !f.g._collapsable && f.of.setAttribute("r", q)), f.e._mdf || f.h._mdf || f.a._mdf || g) {
            q || (q = Math.sqrt(Math.pow(M[0] - _[0], 2) + Math.pow(M[1] - _[1], 2)));
            var j = Math.atan2(_[1] - M[1], _[0] - M[0]), X = f.h.v;
            X >= 1 ? X = 0.99 : X <= -1 && (X = -0.99);
            var ee = q * X, G = Math.cos(j + f.a.v) * ee + M[0], H = Math.sin(j + f.a.v) * ee + M[1];
            C.setAttribute("fx", G), C.setAttribute("fy", H), k && !f.g._collapsable && (f.of.setAttribute("fx", G), f.of.setAttribute("fy", H));
          }
        }
      }
      function d(p, f, g) {
        var C = f.style, k = f.d;
        k && (k._mdf || g) && k.dashStr && (C.pElem.setAttribute("stroke-dasharray", k.dashStr), C.pElem.setAttribute("stroke-dashoffset", k.dashoffset[0])), f.c && (f.c._mdf || g) && C.pElem.setAttribute("stroke", "rgb(" + bmFloor(f.c.v[0]) + "," + bmFloor(f.c.v[1]) + "," + bmFloor(f.c.v[2]) + ")"), (f.o._mdf || g) && C.pElem.setAttribute("stroke-opacity", f.o.v), (f.w._mdf || g) && (C.pElem.setAttribute("stroke-width", f.w.v), C.msElem && C.msElem.setAttribute("stroke-width", f.w.v));
      }
      return n;
    }();
    function SVGShapeElement(e, t, n) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(e, t, n), this.prevViewData = [];
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var e, t = this.shapes.length, n, s, i = this.stylesList.length, a, o = [], l = !1;
      for (s = 0; s < i; s += 1) {
        for (a = this.stylesList[s], l = !1, o.length = 0, e = 0; e < t; e += 1)
          n = this.shapes[e], n.styles.indexOf(a) !== -1 && (o.push(n), l = n._isAnimated || l);
        o.length > 1 && l && this.setShapesAsAnimated(o);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(e) {
      var t, n = e.length;
      for (t = 0; t < n; t += 1)
        e[t].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(e, t) {
      var n, s = new SVGStyleData(e, t), i = s.pElem;
      if (e.ty === "st")
        n = new SVGStrokeStyleData(this, e, s);
      else if (e.ty === "fl")
        n = new SVGFillStyleData(this, e, s);
      else if (e.ty === "gf" || e.ty === "gs") {
        var a = e.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
        n = new a(this, e, s), this.globalData.defs.appendChild(n.gf), n.maskId && (this.globalData.defs.appendChild(n.ms), this.globalData.defs.appendChild(n.of), i.setAttribute("mask", "url(" + getLocationHref() + "#" + n.maskId + ")"));
      } else
        e.ty === "no" && (n = new SVGNoStyleData(this, e, s));
      return (e.ty === "st" || e.ty === "gs") && (i.setAttribute("stroke-linecap", lineCapEnum[e.lc || 2]), i.setAttribute("stroke-linejoin", lineJoinEnum[e.lj || 2]), i.setAttribute("fill-opacity", "0"), e.lj === 1 && i.setAttribute("stroke-miterlimit", e.ml)), e.r === 2 && i.setAttribute("fill-rule", "evenodd"), e.ln && i.setAttribute("id", e.ln), e.cl && i.setAttribute("class", e.cl), e.bm && (i.style["mix-blend-mode"] = getBlendMode(e.bm)), this.stylesList.push(s), this.addToAnimatedContents(e, n), n;
    }, SVGShapeElement.prototype.createGroupElement = function(e) {
      var t = new ShapeGroupData();
      return e.ln && t.gr.setAttribute("id", e.ln), e.cl && t.gr.setAttribute("class", e.cl), e.bm && (t.gr.style["mix-blend-mode"] = getBlendMode(e.bm)), t;
    }, SVGShapeElement.prototype.createTransformElement = function(e, t) {
      var n = TransformPropertyFactory.getTransformProperty(this, e, this), s = new SVGTransformData(n, n.o, t);
      return this.addToAnimatedContents(e, s), s;
    }, SVGShapeElement.prototype.createShapeElement = function(e, t, n) {
      var s = 4;
      e.ty === "rc" ? s = 5 : e.ty === "el" ? s = 6 : e.ty === "sr" && (s = 7);
      var i = ShapePropertyFactory.getShapeProp(this, e, s, this), a = new SVGShapeData(t, n, i);
      return this.shapes.push(a), this.addShapeToModifiers(a), this.addToAnimatedContents(e, a), a;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(e, t) {
      for (var n = 0, s = this.animatedContents.length; n < s; ) {
        if (this.animatedContents[n].element === t)
          return;
        n += 1;
      }
      this.animatedContents.push({
        fn: SVGElementsRenderer.createRenderFunction(e),
        element: t,
        data: e
      });
    }, SVGShapeElement.prototype.setElementStyles = function(e) {
      var t = e.styles, n, s = this.stylesList.length;
      for (n = 0; n < s; n += 1)
        this.stylesList[n].closed || t.push(this.stylesList[n]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var e, t = this.itemsData.length;
      for (e = 0; e < t; e += 1)
        this.prevViewData[e] = this.itemsData[e];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), t = this.dynamicProperties.length, e = 0; e < t; e += 1)
        this.dynamicProperties[e].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(e, t, n, s, i, a, o) {
      var l = [].concat(a), c, u = e.length - 1, d, p, f = [], g = [], C, k, M;
      for (c = u; c >= 0; c -= 1) {
        if (M = this.searchProcessedElement(e[c]), M ? t[c] = n[M - 1] : e[c]._render = o, e[c].ty === "fl" || e[c].ty === "st" || e[c].ty === "gf" || e[c].ty === "gs" || e[c].ty === "no")
          M ? t[c].style.closed = !1 : t[c] = this.createStyleElement(e[c], i), e[c]._render && t[c].style.pElem.parentNode !== s && s.appendChild(t[c].style.pElem), f.push(t[c].style);
        else if (e[c].ty === "gr") {
          if (!M)
            t[c] = this.createGroupElement(e[c]);
          else
            for (p = t[c].it.length, d = 0; d < p; d += 1)
              t[c].prevViewData[d] = t[c].it[d];
          this.searchShapes(e[c].it, t[c].it, t[c].prevViewData, t[c].gr, i + 1, l, o), e[c]._render && t[c].gr.parentNode !== s && s.appendChild(t[c].gr);
        } else
          e[c].ty === "tr" ? (M || (t[c] = this.createTransformElement(e[c], s)), C = t[c].transform, l.push(C)) : e[c].ty === "sh" || e[c].ty === "rc" || e[c].ty === "el" || e[c].ty === "sr" ? (M || (t[c] = this.createShapeElement(e[c], l, i)), this.setElementStyles(t[c])) : e[c].ty === "tm" || e[c].ty === "rd" || e[c].ty === "ms" || e[c].ty === "pb" || e[c].ty === "zz" || e[c].ty === "op" ? (M ? (k = t[c], k.closed = !1) : (k = ShapeModifiers.getModifier(e[c].ty), k.init(this, e[c]), t[c] = k, this.shapeModifiers.push(k)), g.push(k)) : e[c].ty === "rp" && (M ? (k = t[c], k.closed = !0) : (k = ShapeModifiers.getModifier(e[c].ty), t[c] = k, k.init(this, e, c, t), this.shapeModifiers.push(k), o = !1), g.push(k));
        this.addProcessedElement(e[c], c + 1);
      }
      for (u = f.length, c = 0; c < u; c += 1)
        f[c].closed = !0;
      for (u = g.length, c = 0; c < u; c += 1)
        g[c].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var e, t = this.stylesList.length;
      for (e = 0; e < t; e += 1)
        this.stylesList[e].reset();
      for (this.renderShape(), e = 0; e < t; e += 1)
        (this.stylesList[e]._mdf || this._isFirstFrame) && (this.stylesList[e].msElem && (this.stylesList[e].msElem.setAttribute("d", this.stylesList[e].d), this.stylesList[e].d = "M0 0" + this.stylesList[e].d), this.stylesList[e].pElem.setAttribute("d", this.stylesList[e].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var e, t = this.animatedContents.length, n;
      for (e = 0; e < t; e += 1)
        n = this.animatedContents[e], (this._isFirstFrame || n.element._isAnimated) && n.data !== !0 && n.fn(n.data, n.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function LetterProps(e, t, n, s, i, a) {
      this.o = e, this.sw = t, this.sc = n, this.fc = s, this.m = i, this.p = a, this._mdf = {
        o: !0,
        sw: !!t,
        sc: !!n,
        fc: !!s,
        m: !0,
        p: !0
      };
    }
    LetterProps.prototype.update = function(e, t, n, s, i, a) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var o = !1;
      return this.o !== e && (this.o = e, this._mdf.o = !0, o = !0), this.sw !== t && (this.sw = t, this._mdf.sw = !0, o = !0), this.sc !== n && (this.sc = n, this._mdf.sc = !0, o = !0), this.fc !== s && (this.fc = s, this._mdf.fc = !0, o = !0), this.m !== i && (this.m = i, this._mdf.m = !0, o = !0), a.length && (this.p[0] !== a[0] || this.p[1] !== a[1] || this.p[4] !== a[4] || this.p[5] !== a[5] || this.p[12] !== a[12] || this.p[13] !== a[13]) && (this.p = a, this._mdf.p = !0, o = !0), o;
    };
    function TextProperty(e, t) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, this.data = t, this.elem = e, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: "",
        fStyle: "",
        fWeight: "",
        fc: "",
        j: "",
        justifyOffset: "",
        l: [],
        lh: 0,
        lineWidths: [],
        ls: "",
        of: "",
        s: "",
        sc: "",
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: !1,
        strokeColorAnim: !1,
        strokeWidthAnim: !1,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: !1
      }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(e, t) {
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      return e;
    }, TextProperty.prototype.setCurrentData = function(e) {
      e.__complete || this.completeTextData(e), this.currentData = e, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(e) {
      this.effectsSequence.push(e), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(e) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !e)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var t = this.currentData, n = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var s, i = this.effectsSequence.length, a = e || this.data.d.k[this.keysIndex].s;
        for (s = 0; s < i; s += 1)
          n !== this.keysIndex ? a = this.effectsSequence[s](a, a.t) : a = this.effectsSequence[s](this.currentData, a.t);
        t !== a && this.setCurrentData(a), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var e = this.data.d.k, t = this.elem.comp.renderedFrame, n = 0, s = e.length; n <= s - 1 && !(n === s - 1 || e[n + 1].t > t); )
        n += 1;
      return this.keysIndex !== n && (this.keysIndex = n), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(e) {
      for (var t = [], n = 0, s = e.length, i, a, o = !1; n < s; )
        i = e.charCodeAt(n), FontManager.isCombinedCharacter(i) ? t[t.length - 1] += e.charAt(n) : i >= 55296 && i <= 56319 ? (a = e.charCodeAt(n + 1), a >= 56320 && a <= 57343 ? (o || FontManager.isModifier(i, a) ? (t[t.length - 1] += e.substr(n, 2), o = !1) : t.push(e.substr(n, 2)), n += 1) : t.push(e.charAt(n))) : i > 56319 ? (a = e.charCodeAt(n + 1), FontManager.isZeroWidthJoiner(i, a) ? (o = !0, t[t.length - 1] += e.substr(n, 2), n += 1) : t.push(e.charAt(n))) : FontManager.isZeroWidthJoiner(i) ? (t[t.length - 1] += e.charAt(n), o = !0) : t.push(e.charAt(n)), n += 1;
      return t;
    }, TextProperty.prototype.completeTextData = function(e) {
      e.__complete = !0;
      var t = this.elem.globalData.fontManager, n = this.data, s = [], i, a, o, l = 0, c, u = n.m.g, d = 0, p = 0, f = 0, g = [], C = 0, k = 0, M, _, S = t.getFontByName(e.f), E, P = 0, $ = getFontProperties(S);
      e.fWeight = $.weight, e.fStyle = $.style, e.finalSize = e.s, e.finalText = this.buildFinalText(e.t), a = e.finalText.length, e.finalLineHeight = e.lh;
      var A = e.tr / 1e3 * e.finalSize, I;
      if (e.sz)
        for (var D = !0, R = e.sz[0], Y = e.sz[1], q, j; D; ) {
          j = this.buildFinalText(e.t), q = 0, C = 0, a = j.length, A = e.tr / 1e3 * e.finalSize;
          var X = -1;
          for (i = 0; i < a; i += 1)
            I = j[i].charCodeAt(0), o = !1, j[i] === " " ? X = i : (I === 13 || I === 3) && (C = 0, o = !0, q += e.finalLineHeight || e.finalSize * 1.2), t.chars ? (E = t.getCharData(j[i], S.fStyle, S.fFamily), P = o ? 0 : E.w * e.finalSize / 100) : P = t.measureText(j[i], e.f, e.finalSize), C + P > R && j[i] !== " " ? (X === -1 ? a += 1 : i = X, q += e.finalLineHeight || e.finalSize * 1.2, j.splice(i, X === i ? 1 : 0, "\r"), X = -1, C = 0) : (C += P, C += A);
          q += S.ascent * e.finalSize / 100, this.canResize && e.finalSize > this.minimumFontSize && Y < q ? (e.finalSize -= 1, e.finalLineHeight = e.finalSize * e.lh / e.s) : (e.finalText = j, a = e.finalText.length, D = !1);
        }
      C = -A, P = 0;
      var ee = 0, G;
      for (i = 0; i < a; i += 1)
        if (o = !1, G = e.finalText[i], I = G.charCodeAt(0), I === 13 || I === 3 ? (ee = 0, g.push(C), k = C > k ? C : k, C = -2 * A, c = "", o = !0, f += 1) : c = G, t.chars ? (E = t.getCharData(G, S.fStyle, t.getFontByName(e.f).fFamily), P = o ? 0 : E.w * e.finalSize / 100) : P = t.measureText(c, e.f, e.finalSize), G === " " ? ee += P + A : (C += P + A + ee, ee = 0), s.push({
          l: P,
          an: P,
          add: d,
          n: o,
          anIndexes: [],
          val: c,
          line: f,
          animatorJustifyOffset: 0
        }), u == 2) {
          if (d += P, c === "" || c === " " || i === a - 1) {
            for ((c === "" || c === " ") && (d -= P); p <= i; )
              s[p].an = d, s[p].ind = l, s[p].extra = P, p += 1;
            l += 1, d = 0;
          }
        } else if (u == 3) {
          if (d += P, c === "" || i === a - 1) {
            for (c === "" && (d -= P); p <= i; )
              s[p].an = d, s[p].ind = l, s[p].extra = P, p += 1;
            d = 0, l += 1;
          }
        } else
          s[l].ind = l, s[l].extra = 0, l += 1;
      if (e.l = s, k = C > k ? C : k, g.push(C), e.sz)
        e.boxWidth = e.sz[0], e.justifyOffset = 0;
      else
        switch (e.boxWidth = k, e.j) {
          case 1:
            e.justifyOffset = -e.boxWidth;
            break;
          case 2:
            e.justifyOffset = -e.boxWidth / 2;
            break;
          default:
            e.justifyOffset = 0;
        }
      e.lineWidths = g;
      var H = n.a, F, B;
      _ = H.length;
      var z, K, Z = [];
      for (M = 0; M < _; M += 1) {
        for (F = H[M], F.a.sc && (e.strokeColorAnim = !0), F.a.sw && (e.strokeWidthAnim = !0), (F.a.fc || F.a.fh || F.a.fs || F.a.fb) && (e.fillColorAnim = !0), K = 0, z = F.s.b, i = 0; i < a; i += 1)
          B = s[i], B.anIndexes[M] = K, (z == 1 && B.val !== "" || z == 2 && B.val !== "" && B.val !== " " || z == 3 && (B.n || B.val == " " || i == a - 1) || z == 4 && (B.n || i == a - 1)) && (F.s.rn === 1 && Z.push(K), K += 1);
        n.a[M].s.totalChars = K;
        var re = -1, ae;
        if (F.s.rn === 1)
          for (i = 0; i < a; i += 1)
            B = s[i], re != B.anIndexes[M] && (re = B.anIndexes[M], ae = Z.splice(Math.floor(Math.random() * Z.length), 1)[0]), B.anIndexes[M] = ae;
      }
      e.yOffset = e.finalLineHeight || e.finalSize * 1.2, e.ls = e.ls || 0, e.ascent = S.ascent * e.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(e, t) {
      t = t === void 0 ? this.keysIndex : t;
      var n = this.copyData({}, this.data.d.k[t].s);
      n = this.copyData(n, e), this.data.d.k[t].s = n, this.recalculate(t), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(e) {
      var t = this.data.d.k[e].s;
      t.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(t);
    }, TextProperty.prototype.canResizeFont = function(e) {
      this.canResize = e, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(e) {
      this.minimumFontSize = Math.floor(e) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
      var e = Math.max, t = Math.min, n = Math.floor;
      function s(a, o) {
        this._currentTextLength = -1, this.k = !1, this.data = o, this.elem = a, this.comp = a.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(a), this.s = PropertyFactory.getProp(a, o.s || {
          k: 0
        }, 0, 0, this), "e" in o ? this.e = PropertyFactory.getProp(a, o.e, 0, 0, this) : this.e = {
          v: 100
        }, this.o = PropertyFactory.getProp(a, o.o || {
          k: 0
        }, 0, 0, this), this.xe = PropertyFactory.getProp(a, o.xe || {
          k: 0
        }, 0, 0, this), this.ne = PropertyFactory.getProp(a, o.ne || {
          k: 0
        }, 0, 0, this), this.sm = PropertyFactory.getProp(a, o.sm || {
          k: 100
        }, 0, 0, this), this.a = PropertyFactory.getProp(a, o.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      s.prototype = {
        getMult: function(o) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var l = 0, c = 0, u = 1, d = 1;
          this.ne.v > 0 ? l = this.ne.v / 100 : c = -this.ne.v / 100, this.xe.v > 0 ? u = 1 - this.xe.v / 100 : d = 1 + this.xe.v / 100;
          var p = BezierFactory.getBezierEasing(l, c, u, d).get, f = 0, g = this.finalS, C = this.finalE, k = this.data.sh;
          if (k === 2)
            C === g ? f = o >= C ? 1 : 0 : f = e(0, t(0.5 / (C - g) + (o - g) / (C - g), 1)), f = p(f);
          else if (k === 3)
            C === g ? f = o >= C ? 0 : 1 : f = 1 - e(0, t(0.5 / (C - g) + (o - g) / (C - g), 1)), f = p(f);
          else if (k === 4)
            C === g ? f = 0 : (f = e(0, t(0.5 / (C - g) + (o - g) / (C - g), 1)), f < 0.5 ? f *= 2 : f = 1 - 2 * (f - 0.5)), f = p(f);
          else if (k === 5) {
            if (C === g)
              f = 0;
            else {
              var M = C - g;
              o = t(e(0, o + 0.5 - g), C - g);
              var _ = -M / 2 + o, S = M / 2;
              f = Math.sqrt(1 - _ * _ / (S * S));
            }
            f = p(f);
          } else
            k === 6 ? (C === g ? f = 0 : (o = t(e(0, o + 0.5 - g), C - g), f = (1 + Math.cos(Math.PI + Math.PI * 2 * o / (C - g))) / 2), f = p(f)) : (o >= n(g) && (o - g < 0 ? f = e(0, t(t(C, 1) - (g - o), 1)) : f = e(0, t(C - o, 1))), f = p(f));
          if (this.sm.v !== 100) {
            var E = this.sm.v * 0.01;
            E === 0 && (E = 1e-8);
            var P = 0.5 - E * 0.5;
            f < P ? f = 0 : (f = (f - P) / E, f > 1 && (f = 1));
          }
          return f * this.a.v;
        },
        getValue: function(o) {
          this.iterateDynamicProperties(), this._mdf = o || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, o && this.data.r === 2 && (this.e.v = this._currentTextLength);
          var l = this.data.r === 2 ? 1 : 100 / this.data.totalChars, c = this.o.v / l, u = this.s.v / l + c, d = this.e.v / l + c;
          if (u > d) {
            var p = u;
            u = d, d = p;
          }
          this.finalS = u, this.finalE = d;
        }
      }, extendPrototype([DynamicPropertyContainer], s);
      function i(a, o, l) {
        return new s(a, o);
      }
      return {
        getTextSelectorProp: i
      };
    }();
    function TextAnimatorDataProperty(e, t, n) {
      var s = {
        propType: !1
      }, i = PropertyFactory.getProp, a = t.a;
      this.a = {
        r: a.r ? i(e, a.r, 0, degToRads, n) : s,
        rx: a.rx ? i(e, a.rx, 0, degToRads, n) : s,
        ry: a.ry ? i(e, a.ry, 0, degToRads, n) : s,
        sk: a.sk ? i(e, a.sk, 0, degToRads, n) : s,
        sa: a.sa ? i(e, a.sa, 0, degToRads, n) : s,
        s: a.s ? i(e, a.s, 1, 0.01, n) : s,
        a: a.a ? i(e, a.a, 1, 0, n) : s,
        o: a.o ? i(e, a.o, 0, 0.01, n) : s,
        p: a.p ? i(e, a.p, 1, 0, n) : s,
        sw: a.sw ? i(e, a.sw, 0, 0, n) : s,
        sc: a.sc ? i(e, a.sc, 1, 0, n) : s,
        fc: a.fc ? i(e, a.fc, 1, 0, n) : s,
        fh: a.fh ? i(e, a.fh, 0, 0, n) : s,
        fs: a.fs ? i(e, a.fs, 0, 0.01, n) : s,
        fb: a.fb ? i(e, a.fb, 0, 0.01, n) : s,
        t: a.t ? i(e, a.t, 0, 0, n) : s
      }, this.s = TextSelectorProp.getTextSelectorProp(e, t.s, n), this.s.t = t.s.t;
    }
    function TextAnimatorProperty(e, t, n) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = e, this._renderType = t, this._elem = n, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
        alignment: {}
      }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(n);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var e, t = this._textData.a.length, n, s = PropertyFactory.getProp;
      for (e = 0; e < t; e += 1)
        n = this._textData.a[e], this._animatorsData[e] = new TextAnimatorDataProperty(this._elem, n, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = {
        a: s(this._elem, this._textData.p.a, 0, 0, this),
        f: s(this._elem, this._textData.p.f, 0, 0, this),
        l: s(this._elem, this._textData.p.l, 0, 0, this),
        r: s(this._elem, this._textData.p.r, 0, 0, this),
        p: s(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = s(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(e, t) {
      if (this.lettersChangedFlag = t, !(!this._mdf && !this._isFirstFrame && !t && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var n = this._moreOptions.alignment.v, s = this._animatorsData, i = this._textData, a = this.mHelper, o = this._renderType, l = this.renderedLetters.length, c, u, d, p, f = e.l, g, C, k, M, _, S, E, P, $, A, I, D, R, Y, q;
        if (this._hasMaskedPath) {
          if (q = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var j = q.v;
            this._pathData.r.v && (j = j.reverse()), g = {
              tLength: 0,
              segments: []
            }, p = j._length - 1;
            var X;
            for (D = 0, d = 0; d < p; d += 1)
              X = bez.buildBezierData(j.v[d], j.v[d + 1], [j.o[d][0] - j.v[d][0], j.o[d][1] - j.v[d][1]], [j.i[d + 1][0] - j.v[d + 1][0], j.i[d + 1][1] - j.v[d + 1][1]]), g.tLength += X.segmentLength, g.segments.push(X), D += X.segmentLength;
            d = p, q.v.c && (X = bez.buildBezierData(j.v[d], j.v[0], [j.o[d][0] - j.v[d][0], j.o[d][1] - j.v[d][1]], [j.i[0][0] - j.v[0][0], j.i[0][1] - j.v[0][1]]), g.tLength += X.segmentLength, g.segments.push(X), D += X.segmentLength), this._pathData.pi = g;
          }
          if (g = this._pathData.pi, C = this._pathData.f.v, E = 0, S = 1, M = 0, _ = !0, A = g.segments, C < 0 && q.v.c)
            for (g.tLength < Math.abs(C) && (C = -Math.abs(C) % g.tLength), E = A.length - 1, $ = A[E].points, S = $.length - 1; C < 0; )
              C += $[S].partialLength, S -= 1, S < 0 && (E -= 1, $ = A[E].points, S = $.length - 1);
          $ = A[E].points, P = $[S - 1], k = $[S], I = k.partialLength;
        }
        p = f.length, c = 0, u = 0;
        var ee = e.finalSize * 1.2 * 0.714, G = !0, H, F, B, z, K;
        z = s.length;
        var Z, re = -1, ae, te, ue, ce = C, ge = E, de = S, le = -1, me, ve, be, oe, ye, we, Ae, Se, Ee = "", Ie = this.defaultPropsArray, xe;
        if (e.j === 2 || e.j === 1) {
          var Ce = 0, $e = 0, De = e.j === 2 ? -0.5 : -1, ke = 0, Me = !0;
          for (d = 0; d < p; d += 1)
            if (f[d].n) {
              for (Ce && (Ce += $e); ke < d; )
                f[ke].animatorJustifyOffset = Ce, ke += 1;
              Ce = 0, Me = !0;
            } else {
              for (B = 0; B < z; B += 1)
                H = s[B].a, H.t.propType && (Me && e.j === 2 && ($e += H.t.v * De), F = s[B].s, Z = F.getMult(f[d].anIndexes[B], i.a[B].s.totalChars), Z.length ? Ce += H.t.v * Z[0] * De : Ce += H.t.v * Z * De);
              Me = !1;
            }
          for (Ce && (Ce += $e); ke < d; )
            f[ke].animatorJustifyOffset = Ce, ke += 1;
        }
        for (d = 0; d < p; d += 1) {
          if (a.reset(), me = 1, f[d].n)
            c = 0, u += e.yOffset, u += G ? 1 : 0, C = ce, G = !1, this._hasMaskedPath && (E = ge, S = de, $ = A[E].points, P = $[S - 1], k = $[S], I = k.partialLength, M = 0), Ee = "", Se = "", we = "", xe = "", Ie = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (le !== f[d].line) {
                switch (e.j) {
                  case 1:
                    C += D - e.lineWidths[f[d].line];
                    break;
                  case 2:
                    C += (D - e.lineWidths[f[d].line]) / 2;
                    break;
                }
                le = f[d].line;
              }
              re !== f[d].ind && (f[re] && (C += f[re].extra), C += f[d].an / 2, re = f[d].ind), C += n[0] * f[d].an * 5e-3;
              var Pe = 0;
              for (B = 0; B < z; B += 1)
                H = s[B].a, H.p.propType && (F = s[B].s, Z = F.getMult(f[d].anIndexes[B], i.a[B].s.totalChars), Z.length ? Pe += H.p.v[0] * Z[0] : Pe += H.p.v[0] * Z), H.a.propType && (F = s[B].s, Z = F.getMult(f[d].anIndexes[B], i.a[B].s.totalChars), Z.length ? Pe += H.a.v[0] * Z[0] : Pe += H.a.v[0] * Z);
              for (_ = !0, this._pathData.a.v && (C = f[0].an * 0.5 + (D - this._pathData.f.v - f[0].an * 0.5 - f[f.length - 1].an * 0.5) * re / (p - 1), C += this._pathData.f.v); _; )
                M + I >= C + Pe || !$ ? (R = (C + Pe - M) / k.partialLength, te = P.point[0] + (k.point[0] - P.point[0]) * R, ue = P.point[1] + (k.point[1] - P.point[1]) * R, a.translate(-n[0] * f[d].an * 5e-3, -(n[1] * ee) * 0.01), _ = !1) : $ && (M += k.partialLength, S += 1, S >= $.length && (S = 0, E += 1, A[E] ? $ = A[E].points : q.v.c ? (S = 0, E = 0, $ = A[E].points) : (M -= k.partialLength, $ = null)), $ && (P = k, k = $[S], I = k.partialLength));
              ae = f[d].an / 2 - f[d].add, a.translate(-ae, 0, 0);
            } else
              ae = f[d].an / 2 - f[d].add, a.translate(-ae, 0, 0), a.translate(-n[0] * f[d].an * 5e-3, -n[1] * ee * 0.01, 0);
            for (B = 0; B < z; B += 1)
              H = s[B].a, H.t.propType && (F = s[B].s, Z = F.getMult(f[d].anIndexes[B], i.a[B].s.totalChars), (c !== 0 || e.j !== 0) && (this._hasMaskedPath ? Z.length ? C += H.t.v * Z[0] : C += H.t.v * Z : Z.length ? c += H.t.v * Z[0] : c += H.t.v * Z));
            for (e.strokeWidthAnim && (be = e.sw || 0), e.strokeColorAnim && (e.sc ? ve = [e.sc[0], e.sc[1], e.sc[2]] : ve = [0, 0, 0]), e.fillColorAnim && e.fc && (oe = [e.fc[0], e.fc[1], e.fc[2]]), B = 0; B < z; B += 1)
              H = s[B].a, H.a.propType && (F = s[B].s, Z = F.getMult(f[d].anIndexes[B], i.a[B].s.totalChars), Z.length ? a.translate(-H.a.v[0] * Z[0], -H.a.v[1] * Z[1], H.a.v[2] * Z[2]) : a.translate(-H.a.v[0] * Z, -H.a.v[1] * Z, H.a.v[2] * Z));
            for (B = 0; B < z; B += 1)
              H = s[B].a, H.s.propType && (F = s[B].s, Z = F.getMult(f[d].anIndexes[B], i.a[B].s.totalChars), Z.length ? a.scale(1 + (H.s.v[0] - 1) * Z[0], 1 + (H.s.v[1] - 1) * Z[1], 1) : a.scale(1 + (H.s.v[0] - 1) * Z, 1 + (H.s.v[1] - 1) * Z, 1));
            for (B = 0; B < z; B += 1) {
              if (H = s[B].a, F = s[B].s, Z = F.getMult(f[d].anIndexes[B], i.a[B].s.totalChars), H.sk.propType && (Z.length ? a.skewFromAxis(-H.sk.v * Z[0], H.sa.v * Z[1]) : a.skewFromAxis(-H.sk.v * Z, H.sa.v * Z)), H.r.propType && (Z.length ? a.rotateZ(-H.r.v * Z[2]) : a.rotateZ(-H.r.v * Z)), H.ry.propType && (Z.length ? a.rotateY(H.ry.v * Z[1]) : a.rotateY(H.ry.v * Z)), H.rx.propType && (Z.length ? a.rotateX(H.rx.v * Z[0]) : a.rotateX(H.rx.v * Z)), H.o.propType && (Z.length ? me += (H.o.v * Z[0] - me) * Z[0] : me += (H.o.v * Z - me) * Z), e.strokeWidthAnim && H.sw.propType && (Z.length ? be += H.sw.v * Z[0] : be += H.sw.v * Z), e.strokeColorAnim && H.sc.propType)
                for (ye = 0; ye < 3; ye += 1)
                  Z.length ? ve[ye] += (H.sc.v[ye] - ve[ye]) * Z[0] : ve[ye] += (H.sc.v[ye] - ve[ye]) * Z;
              if (e.fillColorAnim && e.fc) {
                if (H.fc.propType)
                  for (ye = 0; ye < 3; ye += 1)
                    Z.length ? oe[ye] += (H.fc.v[ye] - oe[ye]) * Z[0] : oe[ye] += (H.fc.v[ye] - oe[ye]) * Z;
                H.fh.propType && (Z.length ? oe = addHueToRGB(oe, H.fh.v * Z[0]) : oe = addHueToRGB(oe, H.fh.v * Z)), H.fs.propType && (Z.length ? oe = addSaturationToRGB(oe, H.fs.v * Z[0]) : oe = addSaturationToRGB(oe, H.fs.v * Z)), H.fb.propType && (Z.length ? oe = addBrightnessToRGB(oe, H.fb.v * Z[0]) : oe = addBrightnessToRGB(oe, H.fb.v * Z));
              }
            }
            for (B = 0; B < z; B += 1)
              H = s[B].a, H.p.propType && (F = s[B].s, Z = F.getMult(f[d].anIndexes[B], i.a[B].s.totalChars), this._hasMaskedPath ? Z.length ? a.translate(0, H.p.v[1] * Z[0], -H.p.v[2] * Z[1]) : a.translate(0, H.p.v[1] * Z, -H.p.v[2] * Z) : Z.length ? a.translate(H.p.v[0] * Z[0], H.p.v[1] * Z[1], -H.p.v[2] * Z[2]) : a.translate(H.p.v[0] * Z, H.p.v[1] * Z, -H.p.v[2] * Z));
            if (e.strokeWidthAnim && (we = be < 0 ? 0 : be), e.strokeColorAnim && (Ae = "rgb(" + Math.round(ve[0] * 255) + "," + Math.round(ve[1] * 255) + "," + Math.round(ve[2] * 255) + ")"), e.fillColorAnim && e.fc && (Se = "rgb(" + Math.round(oe[0] * 255) + "," + Math.round(oe[1] * 255) + "," + Math.round(oe[2] * 255) + ")"), this._hasMaskedPath) {
              if (a.translate(0, -e.ls), a.translate(0, n[1] * ee * 0.01 + u, 0), this._pathData.p.v) {
                Y = (k.point[1] - P.point[1]) / (k.point[0] - P.point[0]);
                var Oe = Math.atan(Y) * 180 / Math.PI;
                k.point[0] < P.point[0] && (Oe += 180), a.rotate(-Oe * Math.PI / 180);
              }
              a.translate(te, ue, 0), C -= n[0] * f[d].an * 5e-3, f[d + 1] && re !== f[d + 1].ind && (C += f[d].an / 2, C += e.tr * 1e-3 * e.finalSize);
            } else {
              switch (a.translate(c, u, 0), e.ps && a.translate(e.ps[0], e.ps[1] + e.ascent, 0), e.j) {
                case 1:
                  a.translate(f[d].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[f[d].line]), 0, 0);
                  break;
                case 2:
                  a.translate(f[d].animatorJustifyOffset + e.justifyOffset + (e.boxWidth - e.lineWidths[f[d].line]) / 2, 0, 0);
                  break;
              }
              a.translate(0, -e.ls), a.translate(ae, 0, 0), a.translate(n[0] * f[d].an * 5e-3, n[1] * ee * 0.01, 0), c += f[d].l + e.tr * 1e-3 * e.finalSize;
            }
            o === "html" ? Ee = a.toCSS() : o === "svg" ? Ee = a.to2dCSS() : Ie = [a.props[0], a.props[1], a.props[2], a.props[3], a.props[4], a.props[5], a.props[6], a.props[7], a.props[8], a.props[9], a.props[10], a.props[11], a.props[12], a.props[13], a.props[14], a.props[15]], xe = me;
          }
          l <= d ? (K = new LetterProps(xe, we, Ae, Se, Ee, Ie), this.renderedLetters.push(K), l += 1, this.lettersChangedFlag = !0) : (K = this.renderedLetters[d], this.lettersChangedFlag = K.update(xe, we, Ae, Se, Ee, Ie) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
    function ITextElement() {
    }
    ITextElement.prototype.initElement = function(e, t, n) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(e, t, n), this.textProperty = new TextProperty(this, e.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(e.t, this.renderType, this), this.initTransform(e, t, n), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(e) {
      this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    }, ITextElement.prototype.createPathShape = function(e, t) {
      var n, s = t.length, i, a = "";
      for (n = 0; n < s; n += 1)
        t[n].ty === "sh" && (i = t[n].ks.k, a += buildShapeString(i, i.i.length, !0, e));
      return a;
    }, ITextElement.prototype.updateDocumentData = function(e, t) {
      this.textProperty.updateDocumentData(e, t);
    }, ITextElement.prototype.canResizeFont = function(e) {
      this.textProperty.canResizeFont(e);
    }, ITextElement.prototype.setMinimumFontSize = function(e) {
      this.textProperty.setMinimumFontSize(e);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(e, t, n, s, i) {
      switch (e.ps && t.translate(e.ps[0], e.ps[1] + e.ascent, 0), t.translate(0, -e.ls, 0), e.j) {
        case 1:
          t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[n]), 0, 0);
          break;
        case 2:
          t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[n]) / 2, 0, 0);
          break;
      }
      t.translate(s, i, 0);
    }, ITextElement.prototype.buildColor = function(e) {
      return "rgb(" + Math.round(e[0] * 255) + "," + Math.round(e[1] * 255) + "," + Math.round(e[2] * 255) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    };
    var emptyShapeData = {
      shapes: []
    };
    function SVGTextLottieElement(e, t, n) {
      this.textSpans = [], this.renderType = "svg", this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(e) {
      for (var t = 0, n = e.length, s = [], i = ""; t < n; )
        e[t] === String.fromCharCode(13) || e[t] === String.fromCharCode(3) ? (s.push(i), i = "") : i += e[t], t += 1;
      return s.push(i), s;
    }, SVGTextLottieElement.prototype.buildShapeData = function(e, t) {
      if (e.shapes && e.shapes.length) {
        var n = e.shapes[0];
        if (n.it) {
          var s = n.it[n.it.length - 1];
          s.s && (s.s.k[0] = t, s.s.k[1] = t);
        }
      }
      return e;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      this.addDynamicProperty(this);
      var e, t, n = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(n ? n.l.length : 0), n.fc ? this.layerElement.setAttribute("fill", this.buildColor(n.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), n.sc && (this.layerElement.setAttribute("stroke", this.buildColor(n.sc)), this.layerElement.setAttribute("stroke-width", n.sw)), this.layerElement.setAttribute("font-size", n.finalSize);
      var s = this.globalData.fontManager.getFontByName(n.f);
      if (s.fClass)
        this.layerElement.setAttribute("class", s.fClass);
      else {
        this.layerElement.setAttribute("font-family", s.fFamily);
        var i = n.fWeight, a = n.fStyle;
        this.layerElement.setAttribute("font-style", a), this.layerElement.setAttribute("font-weight", i);
      }
      this.layerElement.setAttribute("aria-label", n.t);
      var o = n.l || [], l = !!this.globalData.fontManager.chars;
      t = o.length;
      var c, u = this.mHelper, d = "", p = this.data.singleShape, f = 0, g = 0, C = !0, k = n.tr * 1e-3 * n.finalSize;
      if (p && !l && !n.sz) {
        var M = this.textContainer, _ = "start";
        switch (n.j) {
          case 1:
            _ = "end";
            break;
          case 2:
            _ = "middle";
            break;
          default:
            _ = "start";
            break;
        }
        M.setAttribute("text-anchor", _), M.setAttribute("letter-spacing", k);
        var S = this.buildTextContents(n.finalText);
        for (t = S.length, g = n.ps ? n.ps[1] + n.ascent : 0, e = 0; e < t; e += 1)
          c = this.textSpans[e].span || createNS("tspan"), c.textContent = S[e], c.setAttribute("x", 0), c.setAttribute("y", g), c.style.display = "inherit", M.appendChild(c), this.textSpans[e] || (this.textSpans[e] = {
            span: null,
            glyph: null
          }), this.textSpans[e].span = c, g += n.finalLineHeight;
        this.layerElement.appendChild(M);
      } else {
        var E = this.textSpans.length, P;
        for (e = 0; e < t; e += 1) {
          if (this.textSpans[e] || (this.textSpans[e] = {
            span: null,
            childSpan: null,
            glyph: null
          }), !l || !p || e === 0) {
            if (c = E > e ? this.textSpans[e].span : createNS(l ? "g" : "text"), E <= e) {
              if (c.setAttribute("stroke-linecap", "butt"), c.setAttribute("stroke-linejoin", "round"), c.setAttribute("stroke-miterlimit", "4"), this.textSpans[e].span = c, l) {
                var $ = createNS("g");
                c.appendChild($), this.textSpans[e].childSpan = $;
              }
              this.textSpans[e].span = c, this.layerElement.appendChild(c);
            }
            c.style.display = "inherit";
          }
          if (u.reset(), p && (o[e].n && (f = -k, g += n.yOffset, g += C ? 1 : 0, C = !1), this.applyTextPropertiesToMatrix(n, u, o[e].line, f, g), f += o[e].l || 0, f += k), l) {
            P = this.globalData.fontManager.getCharData(n.finalText[e], s.fStyle, this.globalData.fontManager.getFontByName(n.f).fFamily);
            var A;
            if (P.t === 1)
              A = new SVGCompElement(P.data, this.globalData, this);
            else {
              var I = emptyShapeData;
              P.data && P.data.shapes && (I = this.buildShapeData(P.data, n.finalSize)), A = new SVGShapeElement(I, this.globalData, this);
            }
            if (this.textSpans[e].glyph) {
              var D = this.textSpans[e].glyph;
              this.textSpans[e].childSpan.removeChild(D.layerElement), D.destroy();
            }
            this.textSpans[e].glyph = A, A._debug = !0, A.prepareFrame(0), A.renderFrame(), this.textSpans[e].childSpan.appendChild(A.layerElement), P.t === 1 && this.textSpans[e].childSpan.setAttribute("transform", "scale(" + n.finalSize / 100 + "," + n.finalSize / 100 + ")");
          } else
            p && c.setAttribute("transform", "translate(" + u.props[12] + "," + u.props[13] + ")"), c.textContent = o[e].val, c.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        p && c && c.setAttribute("d", d);
      }
      for (; e < this.textSpans.length; )
        this.textSpans[e].span.style.display = "none", e += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var e = this.layerElement.getBBox();
        this.bbox = {
          top: e.y,
          left: e.x,
          width: e.width,
          height: e.height
        };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var e, t = this.textSpans.length, n;
      for (this.renderedFrame = this.comp.renderedFrame, e = 0; e < t; e += 1)
        n = this.textSpans[e].glyph, n && (n.prepareFrame(this.comp.renderedFrame - this.data.st), n._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if ((!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var e, t, n = this.textAnimator.renderedLetters, s = this.textProperty.currentData.l;
        t = s.length;
        var i, a, o;
        for (e = 0; e < t; e += 1)
          s[e].n || (i = n[e], a = this.textSpans[e].span, o = this.textSpans[e].glyph, o && o.renderFrame(), i._mdf.m && a.setAttribute("transform", i.m), i._mdf.o && a.setAttribute("opacity", i.o), i._mdf.sw && a.setAttribute("stroke-width", i.sw), i._mdf.sc && a.setAttribute("stroke", i.sc), i._mdf.fc && a.setAttribute("fill", i.fc));
      }
    };
    function ISolidElement(e, t, n) {
      this.initElement(e, t, n);
    }
    extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var e = createNS("rect");
      e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.layerElement.appendChild(e);
    };
    function NullElement(e, t, n) {
      this.initFrame(), this.initBaseData(e, t, n), this.initFrame(), this.initTransform(e, t, n), this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(e) {
      this.prepareProperties(e, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
    function SVGRendererBase() {
    }
    extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(e) {
      return new NullElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(e) {
      return new SVGShapeElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(e) {
      return new SVGTextLottieElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(e) {
      return new IImageElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(e) {
      return new ISolidElement(e, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(e) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + e.w + " " + e.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", e.w), this.svgElement.setAttribute("height", e.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var t = this.globalData.defs;
      this.setupGlobalData(e, t), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = e;
      var n = createNS("clipPath"), s = createNS("rect");
      s.setAttribute("width", e.w), s.setAttribute("height", e.h), s.setAttribute("x", 0), s.setAttribute("y", 0);
      var i = createElementID();
      n.setAttribute("id", i), n.appendChild(s), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + i + ")"), t.appendChild(n), this.layers = e.layers, this.elements = createSizedArray(e.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var e, t = this.layers ? this.layers.length : 0;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(e) {
      var t = 0, n = this.layers.length;
      for (t = 0; t < n; t += 1)
        if (this.layers[t].ind === e)
          return t;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(e) {
      var t = this.elements;
      if (!(t[e] || this.layers[e].ty === 99)) {
        t[e] = !0;
        var n = this.createItem(this.layers[e]);
        if (t[e] = n, getExpressionsPlugin() && (this.layers[e].ty === 0 && this.globalData.projectInterface.registerComposition(n), n.initExpressions()), this.appendElementInPos(n, e), this.layers[e].tt) {
          var s = "tp" in this.layers[e] ? this.findIndexByInd(this.layers[e].tp) : e - 1;
          if (s === -1)
            return;
          if (!this.elements[s] || this.elements[s] === !0)
            this.buildItem(s), this.addPendingElement(n);
          else {
            var i = t[s], a = i.getMatte(this.layers[e].tt);
            n.setMatte(a);
          }
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        if (e.checkParenting(), e.data.tt)
          for (var t = 0, n = this.elements.length; t < n; ) {
            if (this.elements[t] === e) {
              var s = "tp" in e.data ? this.findIndexByInd(e.data.tp) : t - 1, i = this.elements[s], a = i.getMatte(this.layers[t].tt);
              e.setMatte(a);
              break;
            }
            t += 1;
          }
      }
    }, SVGRendererBase.prototype.renderFrame = function(e) {
      if (!(this.renderedFrame === e || this.destroyed)) {
        e === null ? e = this.renderedFrame : this.renderedFrame = e, this.globalData.frameNum = e, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = e, this.globalData._mdf = !1;
        var t, n = this.layers.length;
        for (this.completeLayers || this.checkLayers(e), t = n - 1; t >= 0; t -= 1)
          (this.completeLayers || this.elements[t]) && this.elements[t].prepareFrame(e - this.layers[t].st);
        if (this.globalData._mdf)
          for (t = 0; t < n; t += 1)
            (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(e, t) {
      var n = e.getBaseElement();
      if (n) {
        for (var s = 0, i; s < t; )
          this.elements[s] && this.elements[s] !== !0 && this.elements[s].getBaseElement() && (i = this.elements[s].getBaseElement()), s += 1;
        i ? this.layerElement.insertBefore(n, i) : this.layerElement.appendChild(n);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function ICompElement() {
    }
    extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(e, t, n) {
      this.initFrame(), this.initBaseData(e, t, n), this.initTransform(e, t, n), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !t.progressiveLoad) && this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(e) {
      if (this._mdf = !1, this.prepareRenderableFrame(e), this.prepareProperties(e, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = e / this.data.sr;
        else {
          var t = this.tm.v;
          t === this.data.op && (t = this.data.op - 1), this.renderedFrame = t;
        }
        var n, s = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), n = s - 1; n >= 0; n -= 1)
          (this.completeLayers || this.elements[n]) && (this.elements[n].prepareFrame(this.renderedFrame - this.layers[n].st), this.elements[n]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        (this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
    }, ICompElement.prototype.setElements = function(e) {
      this.elements = e;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var e, t = this.layers.length;
      for (e = 0; e < t; e += 1)
        this.elements[e] && this.elements[e].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function SVGCompElement(e, t, n) {
      this.layers = e.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, n), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(e) {
      return new SVGCompElement(e, this.globalData, this);
    };
    function SVGRenderer(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var n = "";
      if (t && t.title) {
        var s = createNS("title"), i = createElementID();
        s.setAttribute("id", i), s.textContent = t.title, this.svgElement.appendChild(s), n += i;
      }
      if (t && t.description) {
        var a = createNS("desc"), o = createElementID();
        a.setAttribute("id", o), a.textContent = t.description, this.svgElement.appendChild(a), n += " " + o;
      }
      n && this.svgElement.setAttribute("aria-labelledby", n);
      var l = createNS("defs");
      this.svgElement.appendChild(l);
      var c = createNS("g");
      this.svgElement.appendChild(c), this.layerElement = c, this.renderConfig = {
        preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: t && t.contentVisibility || "visible",
        progressiveLoad: t && t.progressiveLoad || !1,
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        viewBoxOnly: t && t.viewBoxOnly || !1,
        viewBoxSize: t && t.viewBoxSize || !1,
        className: t && t.className || "",
        id: t && t.id || "",
        focusable: t && t.focusable,
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "100%",
          height: t && t.filterSize && t.filterSize.height || "100%",
          x: t && t.filterSize && t.filterSize.x || "0%",
          y: t && t.filterSize && t.filterSize.y || "0%"
        },
        width: t && t.width,
        height: t && t.height,
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        defs: l,
        renderConfig: this.renderConfig
      }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(e) {
      return new SVGCompElement(e, this.globalData, this);
    };
    function CVContextData() {
      this.saved = [], this.cArrPos = 0, this.cTr = new Matrix(), this.cO = 1;
      var e, t = 15;
      for (this.savedOp = createTypedArray("float32", t), e = 0; e < t; e += 1)
        this.saved[e] = createTypedArray("float32", 16);
      this._length = t;
    }
    CVContextData.prototype.duplicate = function() {
      var e = this._length * 2, t = this.savedOp;
      this.savedOp = createTypedArray("float32", e), this.savedOp.set(t);
      var n = 0;
      for (n = this._length; n < e; n += 1)
        this.saved[n] = createTypedArray("float32", 16);
      this._length = e;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.cO = 1;
    }, CVContextData.prototype.popTransform = function() {
      var e = this.saved[this.cArrPos], t, n = this.cTr.props;
      for (t = 0; t < 16; t += 1)
        n[t] = e[t];
      return e;
    }, CVContextData.prototype.popOpacity = function() {
      var e = this.savedOp[this.cArrPos];
      return this.cO = e, e;
    }, CVContextData.prototype.pop = function() {
      this.cArrPos -= 1;
      var e = this.popTransform(), t = this.popOpacity();
      return {
        transform: e,
        opacity: t
      };
    }, CVContextData.prototype.push = function() {
      var e = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var t, n = this.saved[this.cArrPos];
      for (t = 0; t < 16; t += 1)
        n[t] = e[t];
      this.savedOp[this.cArrPos] = this.cO, this.cArrPos += 1;
    }, CVContextData.prototype.getTransform = function() {
      return this.cTr;
    }, CVContextData.prototype.getOpacity = function() {
      return this.cO;
    }, CVContextData.prototype.setOpacity = function(e) {
      this.cO = e;
    };
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
      addTransformSequence: function(t) {
        var n, s = t.length, i = "_";
        for (n = 0; n < s; n += 1)
          i += t[n].transform.key + "_";
        var a = this.sequences[i];
        return a || (a = {
          transforms: [].concat(t),
          finalTransform: new Matrix(),
          _mdf: !1
        }, this.sequences[i] = a, this.sequenceList.push(a)), a;
      },
      processSequence: function(t, n) {
        for (var s = 0, i = t.transforms.length, a = n; s < i && !n; ) {
          if (t.transforms[s].transform.mProps._mdf) {
            a = !0;
            break;
          }
          s += 1;
        }
        if (a) {
          var o;
          for (t.finalTransform.reset(), s = i - 1; s >= 0; s -= 1)
            o = t.transforms[s].transform.mProps.v.props, t.finalTransform.transform(o[0], o[1], o[2], o[3], o[4], o[5], o[6], o[7], o[8], o[9], o[10], o[11], o[12], o[13], o[14], o[15]);
        }
        t._mdf = a;
      },
      processSequences: function(t) {
        var n, s = this.sequenceList.length;
        for (n = 0; n < s; n += 1)
          this.processSequence(this.sequenceList[n], t);
      },
      getNewKey: function() {
        return this.transform_key_count += 1, "_" + this.transform_key_count;
      }
    };
    var lumaLoader = function() {
      var t = "__lottie_element_luma_buffer", n = null, s = null, i = null;
      function a() {
        var c = createNS("svg"), u = createNS("filter"), d = createNS("feColorMatrix");
        return u.setAttribute("id", t), d.setAttribute("type", "matrix"), d.setAttribute("color-interpolation-filters", "sRGB"), d.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), u.appendChild(d), c.appendChild(u), c.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (c.style.display = "none"), c;
      }
      function o() {
        n || (i = a(), document.body.appendChild(i), n = createTag("canvas"), s = n.getContext("2d"), s.filter = "url(#" + t + ")", s.fillStyle = "rgba(0,0,0,0)", s.fillRect(0, 0, 1, 1));
      }
      function l(c) {
        return n || o(), n.width = c.width, n.height = c.height, s.filter = "url(#" + t + ")", n;
      }
      return {
        load: o,
        get: l
      };
    };
    function createCanvas(e, t) {
      if (featureSupport.offscreenCanvas)
        return new OffscreenCanvas(e, t);
      var n = createTag("canvas");
      return n.width = e, n.height = t, n;
    }
    var assetLoader = function() {
      return {
        loadLumaCanvas: lumaLoader.load,
        getLumaCanvas: lumaLoader.get,
        createCanvas
      };
    }();
    function CVEffects() {
    }
    CVEffects.prototype.renderFrame = function() {
    };
    function CVMaskElement(e, t) {
      this.data = e, this.element = t, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var n, s = this.masksProperties.length, i = !1;
      for (n = 0; n < s; n += 1)
        this.masksProperties[n].mode !== "n" && (i = !0), this.viewData[n] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[n], 3);
      this.hasMasks = i, i && this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var e = this.element.finalTransform.mat, t = this.element.canvasContext, n, s = this.masksProperties.length, i, a, o;
        for (t.beginPath(), n = 0; n < s; n += 1)
          if (this.masksProperties[n].mode !== "n") {
            this.masksProperties[n].inv && (t.moveTo(0, 0), t.lineTo(this.element.globalData.compSize.w, 0), t.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), t.lineTo(0, this.element.globalData.compSize.h), t.lineTo(0, 0)), o = this.viewData[n].v, i = e.applyToPointArray(o.v[0][0], o.v[0][1], 0), t.moveTo(i[0], i[1]);
            var l, c = o._length;
            for (l = 1; l < c; l += 1)
              a = e.applyToTriplePoints(o.o[l - 1], o.i[l], o.v[l]), t.bezierCurveTo(a[0], a[1], a[2], a[3], a[4], a[5]);
            a = e.applyToTriplePoints(o.o[l - 1], o.i[0], o.v[0]), t.bezierCurveTo(a[0], a[1], a[2], a[3], a[4], a[5]);
          }
        this.element.globalData.renderer.save(!0), t.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    function CVBaseElement() {
    }
    var operationsMap = {
      1: "source-in",
      2: "source-out",
      3: "source-in",
      4: "source-out"
    };
    CVBaseElement.prototype = {
      createElements: function() {
      },
      initRendererElement: function() {
      },
      createContainerElements: function() {
        if (this.data.tt >= 1) {
          this.buffers = [];
          var t = this.globalData.canvasContext, n = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
          this.buffers.push(n);
          var s = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
          this.buffers.push(s), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
        }
        this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects();
      },
      createContent: function() {
      },
      setBlendMode: function() {
        var t = this.globalData;
        if (t.blendMode !== this.data.bm) {
          t.blendMode = this.data.bm;
          var n = getBlendMode(this.data.bm);
          t.canvasContext.globalCompositeOperation = n;
        }
      },
      createRenderableComponents: function() {
        this.maskManager = new CVMaskElement(this.data, this);
      },
      hideElement: function() {
        !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
      },
      showElement: function() {
        this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
      },
      clearCanvas: function(t) {
        t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
      },
      prepareLayer: function() {
        if (this.data.tt >= 1) {
          var t = this.buffers[0], n = t.getContext("2d");
          this.clearCanvas(n), n.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
        }
      },
      exitLayer: function() {
        if (this.data.tt >= 1) {
          var t = this.buffers[1], n = t.getContext("2d");
          this.clearCanvas(n), n.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
          var s = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
          if (s.renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
            var i = assetLoader.getLumaCanvas(this.canvasContext.canvas), a = i.getContext("2d");
            a.drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(i, 0, 0);
          }
          this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
        }
      },
      renderFrame: function(t) {
        if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !t)) {
          this.renderTransform(), this.renderRenderable(), this.setBlendMode();
          var n = this.data.ty === 0;
          this.prepareLayer(), this.globalData.renderer.save(n), this.globalData.renderer.ctxTransform(this.finalTransform.mat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.mProp.o.v), this.renderInnerContent(), this.globalData.renderer.restore(n), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
        }
      },
      destroy: function() {
        this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
      },
      mHelper: new Matrix()
    }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(e, t, n, s) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var i = 4;
      t.ty === "rc" ? i = 5 : t.ty === "el" ? i = 6 : t.ty === "sr" && (i = 7), this.sh = ShapePropertyFactory.getShapeProp(e, t, i, e);
      var a, o = n.length, l;
      for (a = 0; a < o; a += 1)
        n[a].closed || (l = {
          transforms: s.addTransformSequence(n[a].transforms),
          trNodes: []
        }, this.styledShapes.push(l), n[a].elements.push(l));
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(e, t, n) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
      opacity: 1,
      _opMdf: !1
    }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(e, t) {
      var n = {
        data: e,
        type: e.ty,
        preTransforms: this.transformsManager.addTransformSequence(t),
        transforms: [],
        elements: [],
        closed: e.hd === !0
      }, s = {};
      if (e.ty === "fl" || e.ty === "st" ? (s.c = PropertyFactory.getProp(this, e.c, 1, 255, this), s.c.k || (n.co = "rgb(" + bmFloor(s.c.v[0]) + "," + bmFloor(s.c.v[1]) + "," + bmFloor(s.c.v[2]) + ")")) : (e.ty === "gf" || e.ty === "gs") && (s.s = PropertyFactory.getProp(this, e.s, 1, null, this), s.e = PropertyFactory.getProp(this, e.e, 1, null, this), s.h = PropertyFactory.getProp(this, e.h || {
        k: 0
      }, 0, 0.01, this), s.a = PropertyFactory.getProp(this, e.a || {
        k: 0
      }, 0, degToRads, this), s.g = new GradientProperty(this, e.g, this)), s.o = PropertyFactory.getProp(this, e.o, 0, 0.01, this), e.ty === "st" || e.ty === "gs") {
        if (n.lc = lineCapEnum[e.lc || 2], n.lj = lineJoinEnum[e.lj || 2], e.lj == 1 && (n.ml = e.ml), s.w = PropertyFactory.getProp(this, e.w, 0, null, this), s.w.k || (n.wi = s.w.v), e.d) {
          var i = new DashProperty(this, e.d, "canvas", this);
          s.d = i, s.d.k || (n.da = s.d.dashArray, n.do = s.d.dashoffset[0]);
        }
      } else
        n.r = e.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(n), s.style = n, s;
    }, CVShapeElement.prototype.createGroupElement = function() {
      var e = {
        it: [],
        prevViewData: []
      };
      return e;
    }, CVShapeElement.prototype.createTransformElement = function(e) {
      var t = {
        transform: {
          opacity: 1,
          _opMdf: !1,
          key: this.transformsManager.getNewKey(),
          op: PropertyFactory.getProp(this, e.o, 0, 0.01, this),
          mProps: TransformPropertyFactory.getTransformProperty(this, e, this)
        }
      };
      return t;
    }, CVShapeElement.prototype.createShapeElement = function(e) {
      var t = new CVShapeData(this, e, this.stylesList, this.transformsManager);
      return this.shapes.push(t), this.addShapeToModifiers(t), t;
    }, CVShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var e, t = this.itemsData.length;
      for (e = 0; e < t; e += 1)
        this.prevViewData[e] = this.itemsData[e];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), t = this.dynamicProperties.length, e = 0; e < t; e += 1)
        this.dynamicProperties[e].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(e) {
      var t, n = this.stylesList.length;
      for (t = 0; t < n; t += 1)
        this.stylesList[t].closed || this.stylesList[t].transforms.push(e);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var e, t = this.stylesList.length;
      for (e = 0; e < t; e += 1)
        this.stylesList[e].closed || this.stylesList[e].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(e) {
      var t, n = e.length;
      for (t = 0; t < n; t += 1)
        e[t].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(e, t, n, s, i) {
      var a, o = e.length - 1, l, c, u = [], d = [], p, f, g, C = [].concat(i);
      for (a = o; a >= 0; a -= 1) {
        if (p = this.searchProcessedElement(e[a]), p ? t[a] = n[p - 1] : e[a]._shouldRender = s, e[a].ty === "fl" || e[a].ty === "st" || e[a].ty === "gf" || e[a].ty === "gs")
          p ? t[a].style.closed = !1 : t[a] = this.createStyleElement(e[a], C), u.push(t[a].style);
        else if (e[a].ty === "gr") {
          if (!p)
            t[a] = this.createGroupElement(e[a]);
          else
            for (c = t[a].it.length, l = 0; l < c; l += 1)
              t[a].prevViewData[l] = t[a].it[l];
          this.searchShapes(e[a].it, t[a].it, t[a].prevViewData, s, C);
        } else
          e[a].ty === "tr" ? (p || (g = this.createTransformElement(e[a]), t[a] = g), C.push(t[a]), this.addTransformToStyleList(t[a])) : e[a].ty === "sh" || e[a].ty === "rc" || e[a].ty === "el" || e[a].ty === "sr" ? p || (t[a] = this.createShapeElement(e[a])) : e[a].ty === "tm" || e[a].ty === "rd" || e[a].ty === "pb" || e[a].ty === "zz" || e[a].ty === "op" ? (p ? (f = t[a], f.closed = !1) : (f = ShapeModifiers.getModifier(e[a].ty), f.init(this, e[a]), t[a] = f, this.shapeModifiers.push(f)), d.push(f)) : e[a].ty === "rp" && (p ? (f = t[a], f.closed = !0) : (f = ShapeModifiers.getModifier(e[a].ty), t[a] = f, f.init(this, e, a, t), this.shapeModifiers.push(f), s = !1), d.push(f));
        this.addProcessedElement(e[a], a + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(u), o = d.length, a = 0; a < o; a += 1)
        d[a].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(e, t) {
      (e._opMdf || t.op._mdf || this._isFirstFrame) && (t.opacity = e.opacity, t.opacity *= t.op.v, t._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var e, t = this.stylesList.length, n, s, i, a, o, l, c = this.globalData.renderer, u = this.globalData.canvasContext, d, p;
      for (e = 0; e < t; e += 1)
        if (p = this.stylesList[e], d = p.type, !((d === "st" || d === "gs") && p.wi === 0 || !p.data._shouldRender || p.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
          for (c.save(), o = p.elements, d === "st" || d === "gs" ? (u.strokeStyle = d === "st" ? p.co : p.grd, u.lineWidth = p.wi, u.lineCap = p.lc, u.lineJoin = p.lj, u.miterLimit = p.ml || 0) : u.fillStyle = d === "fl" ? p.co : p.grd, c.ctxOpacity(p.coOp), d !== "st" && d !== "gs" && u.beginPath(), c.ctxTransform(p.preTransforms.finalTransform.props), s = o.length, n = 0; n < s; n += 1) {
            for ((d === "st" || d === "gs") && (u.beginPath(), p.da && (u.setLineDash(p.da), u.lineDashOffset = p.do)), l = o[n].trNodes, a = l.length, i = 0; i < a; i += 1)
              l[i].t === "m" ? u.moveTo(l[i].p[0], l[i].p[1]) : l[i].t === "c" ? u.bezierCurveTo(l[i].pts[0], l[i].pts[1], l[i].pts[2], l[i].pts[3], l[i].pts[4], l[i].pts[5]) : u.closePath();
            (d === "st" || d === "gs") && (u.stroke(), p.da && u.setLineDash(this.dashResetter));
          }
          d !== "st" && d !== "gs" && u.fill(p.r), c.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(e, t, n, s) {
      var i, a = t.length - 1, o;
      for (o = e, i = a; i >= 0; i -= 1)
        t[i].ty === "tr" ? (o = n[i].transform, this.renderShapeTransform(e, o)) : t[i].ty === "sh" || t[i].ty === "el" || t[i].ty === "rc" || t[i].ty === "sr" ? this.renderPath(t[i], n[i]) : t[i].ty === "fl" ? this.renderFill(t[i], n[i], o) : t[i].ty === "st" ? this.renderStroke(t[i], n[i], o) : t[i].ty === "gf" || t[i].ty === "gs" ? this.renderGradientFill(t[i], n[i], o) : t[i].ty === "gr" ? this.renderShape(o, t[i].it, n[i].it) : t[i].ty;
      s && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(e, t) {
      if (this._isFirstFrame || t._mdf || e.transforms._mdf) {
        var n = e.trNodes, s = t.paths, i, a, o, l = s._length;
        n.length = 0;
        var c = e.transforms.finalTransform;
        for (o = 0; o < l; o += 1) {
          var u = s.shapes[o];
          if (u && u.v) {
            for (a = u._length, i = 1; i < a; i += 1)
              i === 1 && n.push({
                t: "m",
                p: c.applyToPointArray(u.v[0][0], u.v[0][1], 0)
              }), n.push({
                t: "c",
                pts: c.applyToTriplePoints(u.o[i - 1], u.i[i], u.v[i])
              });
            a === 1 && n.push({
              t: "m",
              p: c.applyToPointArray(u.v[0][0], u.v[0][1], 0)
            }), u.c && a && (n.push({
              t: "c",
              pts: c.applyToTriplePoints(u.o[i - 1], u.i[0], u.v[0])
            }), n.push({
              t: "z"
            }));
          }
        }
        e.trNodes = n;
      }
    }, CVShapeElement.prototype.renderPath = function(e, t) {
      if (e.hd !== !0 && e._shouldRender) {
        var n, s = t.styledShapes.length;
        for (n = 0; n < s; n += 1)
          this.renderStyledShape(t.styledShapes[n], t.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(e, t, n) {
      var s = t.style;
      (t.c._mdf || this._isFirstFrame) && (s.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || n._opMdf || this._isFirstFrame) && (s.coOp = t.o.v * n.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(e, t, n) {
      var s = t.style, i;
      if (!s.grd || t.g._mdf || t.s._mdf || t.e._mdf || e.t !== 1 && (t.h._mdf || t.a._mdf)) {
        var a = this.globalData.canvasContext, o = t.s.v, l = t.e.v;
        if (e.t === 1)
          i = a.createLinearGradient(o[0], o[1], l[0], l[1]);
        else {
          var c = Math.sqrt(Math.pow(o[0] - l[0], 2) + Math.pow(o[1] - l[1], 2)), u = Math.atan2(l[1] - o[1], l[0] - o[0]), d = t.h.v;
          d >= 1 ? d = 0.99 : d <= -1 && (d = -0.99);
          var p = c * d, f = Math.cos(u + t.a.v) * p + o[0], g = Math.sin(u + t.a.v) * p + o[1];
          i = a.createRadialGradient(f, g, 0, o[0], o[1], c);
        }
        var C, k = e.g.p, M = t.g.c, _ = 1;
        for (C = 0; C < k; C += 1)
          t.g._hasOpacity && t.g._collapsable && (_ = t.g.o[C * 2 + 1]), i.addColorStop(M[C * 4] / 100, "rgba(" + M[C * 4 + 1] + "," + M[C * 4 + 2] + "," + M[C * 4 + 3] + "," + _ + ")");
        s.grd = i;
      }
      s.coOp = t.o.v * n.opacity;
    }, CVShapeElement.prototype.renderStroke = function(e, t, n) {
      var s = t.style, i = t.d;
      i && (i._mdf || this._isFirstFrame) && (s.da = i.dashArray, s.do = i.dashoffset[0]), (t.c._mdf || this._isFirstFrame) && (s.co = "rgb(" + bmFloor(t.c.v[0]) + "," + bmFloor(t.c.v[1]) + "," + bmFloor(t.c.v[2]) + ")"), (t.o._mdf || n._opMdf || this._isFirstFrame) && (s.coOp = t.o.v * n.opacity), (t.w._mdf || this._isFirstFrame) && (s.wi = t.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    };
    function CVTextElement(e, t, n) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
        fill: "rgba(0,0,0,0)",
        stroke: "rgba(0,0,0,0)",
        sWidth: 0,
        fValue: ""
      }, this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var e = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
      var t = !1;
      e.fc ? (t = !0, this.values.fill = this.buildColor(e.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = t;
      var n = !1;
      e.sc && (n = !0, this.values.stroke = this.buildColor(e.sc), this.values.sWidth = e.sw);
      var s = this.globalData.fontManager.getFontByName(e.f), i, a, o = e.l, l = this.mHelper;
      this.stroke = n, this.values.fValue = e.finalSize + "px " + this.globalData.fontManager.getFontByName(e.f).fFamily, a = e.finalText.length;
      var c, u, d, p, f, g, C, k, M, _, S = this.data.singleShape, E = e.tr * 1e-3 * e.finalSize, P = 0, $ = 0, A = !0, I = 0;
      for (i = 0; i < a; i += 1) {
        c = this.globalData.fontManager.getCharData(e.finalText[i], s.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), u = c && c.data || {}, l.reset(), S && o[i].n && (P = -E, $ += e.yOffset, $ += A ? 1 : 0, A = !1), f = u.shapes ? u.shapes[0].it : [], C = f.length, l.scale(e.finalSize / 100, e.finalSize / 100), S && this.applyTextPropertiesToMatrix(e, l, o[i].line, P, $), M = createSizedArray(C - 1);
        var D = 0;
        for (g = 0; g < C; g += 1)
          if (f[g].ty === "sh") {
            for (p = f[g].ks.k.i.length, k = f[g].ks.k, _ = [], d = 1; d < p; d += 1)
              d === 1 && _.push(l.applyToX(k.v[0][0], k.v[0][1], 0), l.applyToY(k.v[0][0], k.v[0][1], 0)), _.push(l.applyToX(k.o[d - 1][0], k.o[d - 1][1], 0), l.applyToY(k.o[d - 1][0], k.o[d - 1][1], 0), l.applyToX(k.i[d][0], k.i[d][1], 0), l.applyToY(k.i[d][0], k.i[d][1], 0), l.applyToX(k.v[d][0], k.v[d][1], 0), l.applyToY(k.v[d][0], k.v[d][1], 0));
            _.push(l.applyToX(k.o[d - 1][0], k.o[d - 1][1], 0), l.applyToY(k.o[d - 1][0], k.o[d - 1][1], 0), l.applyToX(k.i[0][0], k.i[0][1], 0), l.applyToY(k.i[0][0], k.i[0][1], 0), l.applyToX(k.v[0][0], k.v[0][1], 0), l.applyToY(k.v[0][0], k.v[0][1], 0)), M[D] = _, D += 1;
          }
        S && (P += o[i].l, P += E), this.textSpans[I] ? this.textSpans[I].elem = M : this.textSpans[I] = {
          elem: M
        }, I += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      var e = this.canvasContext;
      e.font = this.values.fValue, e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4, this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var t, n, s, i, a, o, l = this.textAnimator.renderedLetters, c = this.textProperty.currentData.l;
      n = c.length;
      var u, d = null, p = null, f = null, g, C;
      for (t = 0; t < n; t += 1)
        if (!c[t].n) {
          if (u = l[t], u && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(u.p), this.globalData.renderer.ctxOpacity(u.o)), this.fill) {
            for (u && u.fc ? d !== u.fc && (d = u.fc, e.fillStyle = u.fc) : d !== this.values.fill && (d = this.values.fill, e.fillStyle = this.values.fill), g = this.textSpans[t].elem, i = g.length, this.globalData.canvasContext.beginPath(), s = 0; s < i; s += 1)
              for (C = g[s], o = C.length, this.globalData.canvasContext.moveTo(C[0], C[1]), a = 2; a < o; a += 6)
                this.globalData.canvasContext.bezierCurveTo(C[a], C[a + 1], C[a + 2], C[a + 3], C[a + 4], C[a + 5]);
            this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
          }
          if (this.stroke) {
            for (u && u.sw ? f !== u.sw && (f = u.sw, e.lineWidth = u.sw) : f !== this.values.sWidth && (f = this.values.sWidth, e.lineWidth = this.values.sWidth), u && u.sc ? p !== u.sc && (p = u.sc, e.strokeStyle = u.sc) : p !== this.values.stroke && (p = this.values.stroke, e.strokeStyle = this.values.stroke), g = this.textSpans[t].elem, i = g.length, this.globalData.canvasContext.beginPath(), s = 0; s < i; s += 1)
              for (C = g[s], o = C.length, this.globalData.canvasContext.moveTo(C[0], C[1]), a = 2; a < o; a += 6)
                this.globalData.canvasContext.bezierCurveTo(C[a], C[a + 1], C[a + 2], C[a + 3], C[a + 4], C[a + 5]);
            this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
          }
          u && this.globalData.renderer.restore();
        }
    };
    function CVImageElement(e, t, n) {
      this.assetData = t.getAssetData(e.refId), this.img = t.imageLoader.getAsset(this.assetData), this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var e = createTag("canvas");
        e.width = this.assetData.w, e.height = this.assetData.h;
        var t = e.getContext("2d"), n = this.img.width, s = this.img.height, i = n / s, a = this.assetData.w / this.assetData.h, o, l, c = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        i > a && c === "xMidYMid slice" || i < a && c !== "xMidYMid slice" ? (l = s, o = l * a) : (o = n, l = o / a), t.drawImage(this.img, (n - o) / 2, (s - l) / 2, o, l, 0, 0, this.assetData.w, this.assetData.h), this.img = e;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    };
    function CVSolidElement(e, t, n) {
      this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      var e = this.canvasContext;
      e.fillStyle = this.data.sc, e.fillRect(0, 0, this.data.sw, this.data.sh);
    };
    function CanvasRendererBase(e, t) {
      this.animationItem = e, this.renderConfig = {
        clearCanvas: t && t.clearCanvas !== void 0 ? t.clearCanvas : !0,
        context: t && t.context || null,
        progressiveLoad: t && t.progressiveLoad || !1,
        preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: t && t.contentVisibility || "visible",
        className: t && t.className || "",
        id: t && t.id || ""
      }, this.renderConfig.dpr = t && t.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = t && t.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
        frameNum: -1,
        _mdf: !1,
        renderConfig: this.renderConfig,
        currentGlobalAlpha: -1
      }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas";
    }
    extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(e) {
      return new CVShapeElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(e) {
      return new CVTextElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(e) {
      return new CVImageElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(e) {
      return new CVSolidElement(e, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(e) {
      if (!(e[0] === 1 && e[1] === 0 && e[4] === 0 && e[5] === 1 && e[12] === 0 && e[13] === 0)) {
        if (!this.renderConfig.clearCanvas) {
          this.canvasContext.transform(e[0], e[1], e[4], e[5], e[12], e[13]);
          return;
        }
        this.transformMat.cloneFromProps(e);
        var t = this.contextData.getTransform(), n = t.props;
        this.transformMat.transform(n[0], n[1], n[2], n[3], n[4], n[5], n[6], n[7], n[8], n[9], n[10], n[11], n[12], n[13], n[14], n[15]), t.cloneFromProps(this.transformMat.props);
        var s = t.props;
        this.canvasContext.setTransform(s[0], s[1], s[4], s[5], s[12], s[13]);
      }
    }, CanvasRendererBase.prototype.ctxOpacity = function(e) {
      var t = this.contextData.getOpacity();
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.globalAlpha *= e < 0 ? 0 : e, this.globalData.currentGlobalAlpha = t;
        return;
      }
      t *= e < 0 ? 0 : e, this.contextData.setOpacity(t), this.globalData.currentGlobalAlpha !== t && (this.canvasContext.globalAlpha = t, this.globalData.currentGlobalAlpha = t);
    }, CanvasRendererBase.prototype.reset = function() {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      this.contextData.reset();
    }, CanvasRendererBase.prototype.save = function(e) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.save();
        return;
      }
      e && this.canvasContext.save(), this.contextData.push();
    }, CanvasRendererBase.prototype.restore = function(e) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      e && (this.canvasContext.restore(), this.globalData.blendMode = "source-over");
      var t = this.contextData.pop(), n = t.transform, s = t.opacity;
      this.canvasContext.setTransform(n[0], n[1], n[4], n[5], n[12], n[13]), this.globalData.currentGlobalAlpha !== s && (this.canvasContext.globalAlpha = s, this.globalData.currentGlobalAlpha = s);
    }, CanvasRendererBase.prototype.configAnimation = function(e) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var t = this.animationItem.container.style;
        t.width = "100%", t.height = "100%";
        var n = "0px 0px 0px";
        t.transformOrigin = n, t.mozTransformOrigin = n, t.webkitTransformOrigin = n, t["-webkit-transform"] = n, t.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else
        this.canvasContext = this.renderConfig.context;
      this.data = e, this.layers = e.layers, this.transformCanvas = {
        w: e.w,
        h: e.h,
        sx: 0,
        sy: 0,
        tx: 0,
        ty: 0
      }, this.setupGlobalData(e, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(e.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(e, t) {
      this.reset();
      var n, s;
      e ? (n = e, s = t, this.canvasContext.canvas.width = n, this.canvasContext.canvas.height = s) : (this.animationItem.wrapper && this.animationItem.container ? (n = this.animationItem.wrapper.offsetWidth, s = this.animationItem.wrapper.offsetHeight) : (n = this.canvasContext.canvas.width, s = this.canvasContext.canvas.height), this.canvasContext.canvas.width = n * this.renderConfig.dpr, this.canvasContext.canvas.height = s * this.renderConfig.dpr);
      var i, a;
      if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var o = this.renderConfig.preserveAspectRatio.split(" "), l = o[1] || "meet", c = o[0] || "xMidYMid", u = c.substr(0, 4), d = c.substr(4);
        i = n / s, a = this.transformCanvas.w / this.transformCanvas.h, a > i && l === "meet" || a < i && l === "slice" ? (this.transformCanvas.sx = n / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = n / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = s / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = s / (this.transformCanvas.h / this.renderConfig.dpr)), u === "xMid" && (a < i && l === "meet" || a > i && l === "slice") ? this.transformCanvas.tx = (n - this.transformCanvas.w * (s / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : u === "xMax" && (a < i && l === "meet" || a > i && l === "slice") ? this.transformCanvas.tx = (n - this.transformCanvas.w * (s / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, d === "YMid" && (a > i && l === "meet" || a < i && l === "slice") ? this.transformCanvas.ty = (s - this.transformCanvas.h * (n / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : d === "YMax" && (a > i && l === "meet" || a < i && l === "slice") ? this.transformCanvas.ty = (s - this.transformCanvas.h * (n / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
      } else
        this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = n / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = s / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
      var e, t = this.layers ? this.layers.length : 0;
      for (e = t - 1; e >= 0; e -= 1)
        this.elements[e] && this.elements[e].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(e, t) {
      if (!(this.renderedFrame === e && this.renderConfig.clearCanvas === !0 && !t || this.destroyed || e === -1)) {
        this.renderedFrame = e, this.globalData.frameNum = e - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || t, this.globalData.projectInterface.currentFrame = e;
        var n, s = this.layers.length;
        for (this.completeLayers || this.checkLayers(e), n = 0; n < s; n += 1)
          (this.completeLayers || this.elements[n]) && this.elements[n].prepareFrame(e - this.layers[n].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), n = s - 1; n >= 0; n -= 1)
            (this.completeLayers || this.elements[n]) && this.elements[n].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(e) {
      var t = this.elements;
      if (!(t[e] || this.layers[e].ty === 99)) {
        var n = this.createItem(this.layers[e], this, this.globalData);
        t[e] = n, n.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        e.checkParenting();
      }
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    };
    function CVCompElement(e, t, n) {
      this.completeLayers = !1, this.layers = e.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(e, t, n), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var e = this.canvasContext;
      e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip();
      var t, n = this.layers.length;
      for (t = n - 1; t >= 0; t -= 1)
        (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var e, t = this.layers.length;
      for (e = t - 1; e >= 0; e -= 1)
        this.elements[e] && this.elements[e].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(e) {
      return new CVCompElement(e, this.globalData, this);
    };
    function CanvasRenderer(e, t) {
      this.animationItem = e, this.renderConfig = {
        clearCanvas: t && t.clearCanvas !== void 0 ? t.clearCanvas : !0,
        context: t && t.context || null,
        progressiveLoad: t && t.progressiveLoad || !1,
        preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: t && t.contentVisibility || "visible",
        className: t && t.className || "",
        id: t && t.id || "",
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.renderConfig.dpr = t && t.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = t && t.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
        frameNum: -1,
        _mdf: !1,
        renderConfig: this.renderConfig,
        currentGlobalAlpha: -1
      }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas";
    }
    extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(e) {
      return new CVCompElement(e, this.globalData, this);
    };
    function HBaseElement() {
    }
    HBaseElement.prototype = {
      checkBlendMode: function() {
      },
      initRendererElement: function() {
        this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
      },
      createContainerElements: function() {
        this.renderableEffectsManager = new CVEffects(), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        var t = this.transformedElement ? this.transformedElement.style : {};
        if (this.finalTransform._matMdf) {
          var n = this.finalTransform.mat.toCSS();
          t.transform = n, t.webkitTransform = n;
        }
        this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
      },
      renderFrame: function() {
        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
      },
      destroy: function() {
        this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData);
      },
      addEffects: function() {
      },
      setMatte: function() {
      }
    }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(e, t, n) {
      this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var e;
      this.data.hasMask ? (e = createNS("rect"), e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : (e = createTag("div"), e.style.width = this.data.sw + "px", e.style.height = this.data.sh + "px", e.style.backgroundColor = this.data.sc), this.layerElement.appendChild(e);
    };
    function HShapeElement(e, t, n) {
      this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(e, t, n), this.prevViewData = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      };
    }
    extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var e;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask)
        this.layerElement.appendChild(this.shapesContainer), e = this.svgElement;
      else {
        e = createNS("svg");
        var t = this.comp.data ? this.comp.data : this.globalData.compSize;
        e.setAttribute("width", t.w), e.setAttribute("height", t.h), e.appendChild(this.shapesContainer), this.layerElement.appendChild(e);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = e;
    }, HShapeElement.prototype.getTransformedPoint = function(e, t) {
      var n, s = e.length;
      for (n = 0; n < s; n += 1)
        t = e[n].mProps.v.applyToPointArray(t[0], t[1], 0);
      return t;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(e, t) {
      var n = e.sh.v, s = e.transformers, i, a = n._length, o, l, c, u;
      if (!(a <= 1)) {
        for (i = 0; i < a - 1; i += 1)
          o = this.getTransformedPoint(s, n.v[i]), l = this.getTransformedPoint(s, n.o[i]), c = this.getTransformedPoint(s, n.i[i + 1]), u = this.getTransformedPoint(s, n.v[i + 1]), this.checkBounds(o, l, c, u, t);
        n.c && (o = this.getTransformedPoint(s, n.v[i]), l = this.getTransformedPoint(s, n.o[i]), c = this.getTransformedPoint(s, n.i[0]), u = this.getTransformedPoint(s, n.v[0]), this.checkBounds(o, l, c, u, t));
      }
    }, HShapeElement.prototype.checkBounds = function(e, t, n, s, i) {
      this.getBoundsOfCurve(e, t, n, s);
      var a = this.shapeBoundingBox;
      i.x = bmMin(a.left, i.x), i.xMax = bmMax(a.right, i.xMax), i.y = bmMin(a.top, i.y), i.yMax = bmMax(a.bottom, i.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, HShapeElement.prototype.tempBoundingBox = {
      x: 0,
      xMax: 0,
      y: 0,
      yMax: 0,
      width: 0,
      height: 0
    }, HShapeElement.prototype.getBoundsOfCurve = function(e, t, n, s) {
      for (var i = [[e[0], s[0]], [e[1], s[1]]], a, o, l, c, u, d, p, f = 0; f < 2; ++f)
        o = 6 * e[f] - 12 * t[f] + 6 * n[f], a = -3 * e[f] + 9 * t[f] - 9 * n[f] + 3 * s[f], l = 3 * t[f] - 3 * e[f], o |= 0, a |= 0, l |= 0, a === 0 && o === 0 || (a === 0 ? (c = -l / o, c > 0 && c < 1 && i[f].push(this.calculateF(c, e, t, n, s, f))) : (u = o * o - 4 * l * a, u >= 0 && (d = (-o + bmSqrt(u)) / (2 * a), d > 0 && d < 1 && i[f].push(this.calculateF(d, e, t, n, s, f)), p = (-o - bmSqrt(u)) / (2 * a), p > 0 && p < 1 && i[f].push(this.calculateF(p, e, t, n, s, f)))));
      this.shapeBoundingBox.left = bmMin.apply(null, i[0]), this.shapeBoundingBox.top = bmMin.apply(null, i[1]), this.shapeBoundingBox.right = bmMax.apply(null, i[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, i[1]);
    }, HShapeElement.prototype.calculateF = function(e, t, n, s, i, a) {
      return bmPow(1 - e, 3) * t[a] + 3 * bmPow(1 - e, 2) * e * n[a] + 3 * (1 - e) * bmPow(e, 2) * s[a] + bmPow(e, 3) * i[a];
    }, HShapeElement.prototype.calculateBoundingBox = function(e, t) {
      var n, s = e.length;
      for (n = 0; n < s; n += 1)
        e[n] && e[n].sh ? this.calculateShapeBoundingBox(e[n], t) : e[n] && e[n].it ? this.calculateBoundingBox(e[n].it, t) : e[n] && e[n].style && e[n].w && this.expandStrokeBoundingBox(e[n].w, t);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(e, t) {
      var n = 0;
      if (e.keyframes) {
        for (var s = 0; s < e.keyframes.length; s += 1) {
          var i = e.keyframes[s].s;
          i > n && (n = i);
        }
        n *= e.mult;
      } else
        n = e.v * e.mult;
      t.x -= n, t.xMax += n, t.y -= n, t.yMax += n;
    }, HShapeElement.prototype.currentBoxContains = function(e) {
      return this.currentBBox.x <= e.x && this.currentBBox.y <= e.y && this.currentBBox.width + this.currentBBox.x >= e.x + e.width && this.currentBBox.height + this.currentBBox.y >= e.y + e.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var e = this.tempBoundingBox, t = 999999;
        if (e.x = t, e.xMax = -t, e.y = t, e.yMax = -t, this.calculateBoundingBox(this.itemsData, e), e.width = e.xMax < e.x ? 0 : e.xMax - e.x, e.height = e.yMax < e.y ? 0 : e.yMax - e.y, this.currentBoxContains(e))
          return;
        var n = !1;
        if (this.currentBBox.w !== e.width && (this.currentBBox.w = e.width, this.shapeCont.setAttribute("width", e.width), n = !0), this.currentBBox.h !== e.height && (this.currentBBox.h = e.height, this.shapeCont.setAttribute("height", e.height), n = !0), n || this.currentBBox.x !== e.x || this.currentBBox.y !== e.y) {
          this.currentBBox.w = e.width, this.currentBBox.h = e.height, this.currentBBox.x = e.x, this.currentBBox.y = e.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var s = this.shapeCont.style, i = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          s.transform = i, s.webkitTransform = i;
        }
      }
    };
    function HTextElement(e, t, n) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      }, this.renderType = "svg", this.isMasked = !1, this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var e = createNS("g");
        this.maskedElement.appendChild(e), this.innerElem = e;
      } else
        this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var e = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(e.l ? e.l.length : 0);
      var t = this.innerElem.style, n = e.fc ? this.buildColor(e.fc) : "rgba(0,0,0,0)";
      t.fill = n, t.color = n, e.sc && (t.stroke = this.buildColor(e.sc), t.strokeWidth = e.sw + "px");
      var s = this.globalData.fontManager.getFontByName(e.f);
      if (!this.globalData.fontManager.chars)
        if (t.fontSize = e.finalSize + "px", t.lineHeight = e.finalSize + "px", s.fClass)
          this.innerElem.className = s.fClass;
        else {
          t.fontFamily = s.fFamily;
          var i = e.fWeight, a = e.fStyle;
          t.fontStyle = a, t.fontWeight = i;
        }
      var o, l, c = e.l;
      l = c.length;
      var u, d, p, f = this.mHelper, g, C = "", k = 0;
      for (o = 0; o < l; o += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[k] ? u = this.textPaths[k] : (u = createNS("path"), u.setAttribute("stroke-linecap", lineCapEnum[1]), u.setAttribute("stroke-linejoin", lineJoinEnum[2]), u.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[k] ? (d = this.textSpans[k], p = d.children[0]) : (d = createTag("div"), d.style.lineHeight = 0, p = createNS("svg"), p.appendChild(u), styleDiv(d)))) : this.isMasked ? u = this.textPaths[k] ? this.textPaths[k] : createNS("text") : this.textSpans[k] ? (d = this.textSpans[k], u = this.textPaths[k]) : (d = createTag("span"), styleDiv(d), u = createTag("span"), styleDiv(u), d.appendChild(u)), this.globalData.fontManager.chars) {
          var M = this.globalData.fontManager.getCharData(e.finalText[o], s.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily), _;
          if (M ? _ = M.data : _ = null, f.reset(), _ && _.shapes && _.shapes.length && (g = _.shapes[0].it, f.scale(e.finalSize / 100, e.finalSize / 100), C = this.createPathShape(f, g), u.setAttribute("d", C)), this.isMasked)
            this.innerElem.appendChild(u);
          else {
            if (this.innerElem.appendChild(d), _ && _.shapes) {
              document.body.appendChild(p);
              var S = p.getBBox();
              p.setAttribute("width", S.width + 2), p.setAttribute("height", S.height + 2), p.setAttribute("viewBox", S.x - 1 + " " + (S.y - 1) + " " + (S.width + 2) + " " + (S.height + 2));
              var E = p.style, P = "translate(" + (S.x - 1) + "px," + (S.y - 1) + "px)";
              E.transform = P, E.webkitTransform = P, c[o].yOffset = S.y - 1;
            } else
              p.setAttribute("width", 1), p.setAttribute("height", 1);
            d.appendChild(p);
          }
        } else if (u.textContent = c[o].val, u.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
          this.innerElem.appendChild(u);
        else {
          this.innerElem.appendChild(d);
          var $ = u.style, A = "translate3d(0," + -e.finalSize / 1.2 + "px,0)";
          $.transform = A, $.webkitTransform = A;
        }
        this.isMasked ? this.textSpans[k] = u : this.textSpans[k] = d, this.textSpans[k].style.display = "block", this.textPaths[k] = u, k += 1;
      }
      for (; k < this.textSpans.length; )
        this.textSpans[k].style.display = "none", k += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      var e;
      if (this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag)
          return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), e = this.svgElement.style;
          var t = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          e.transform = t, e.webkitTransform = t;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
        var n, s, i = 0, a = this.textAnimator.renderedLetters, o = this.textProperty.currentData.l;
        s = o.length;
        var l, c, u;
        for (n = 0; n < s; n += 1)
          o[n].n ? i += 1 : (c = this.textSpans[n], u = this.textPaths[n], l = a[i], i += 1, l._mdf.m && (this.isMasked ? c.setAttribute("transform", l.m) : (c.style.webkitTransform = l.m, c.style.transform = l.m)), c.style.opacity = l.o, l.sw && l._mdf.sw && u.setAttribute("stroke-width", l.sw), l.sc && l._mdf.sc && u.setAttribute("stroke", l.sc), l.fc && l._mdf.fc && (u.setAttribute("fill", l.fc), u.style.color = l.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var d = this.innerElem.getBBox();
          this.currentBBox.w !== d.width && (this.currentBBox.w = d.width, this.svgElement.setAttribute("width", d.width)), this.currentBBox.h !== d.height && (this.currentBBox.h = d.height, this.svgElement.setAttribute("height", d.height));
          var p = 1;
          if (this.currentBBox.w !== d.width + p * 2 || this.currentBBox.h !== d.height + p * 2 || this.currentBBox.x !== d.x - p || this.currentBBox.y !== d.y - p) {
            this.currentBBox.w = d.width + p * 2, this.currentBBox.h = d.height + p * 2, this.currentBBox.x = d.x - p, this.currentBBox.y = d.y - p, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), e = this.svgElement.style;
            var f = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            e.transform = f, e.webkitTransform = f;
          }
        }
      }
    };
    function HCameraElement(e, t, n) {
      this.initFrame(), this.initBaseData(e, t, n), this.initHierarchy();
      var s = PropertyFactory.getProp;
      if (this.pe = s(this, e.pe, 0, 0, this), e.ks.p.s ? (this.px = s(this, e.ks.p.x, 1, 0, this), this.py = s(this, e.ks.p.y, 1, 0, this), this.pz = s(this, e.ks.p.z, 1, 0, this)) : this.p = s(this, e.ks.p, 1, 0, this), e.ks.a && (this.a = s(this, e.ks.a, 1, 0, this)), e.ks.or.k.length && e.ks.or.k[0].to) {
        var i, a = e.ks.or.k.length;
        for (i = 0; i < a; i += 1)
          e.ks.or.k[i].to = null, e.ks.or.k[i].ti = null;
      }
      this.or = s(this, e.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = s(this, e.ks.rx, 0, degToRads, this), this.ry = s(this, e.ks.ry, 0, degToRads, this), this.rz = s(this, e.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = {
        mProp: this
      };
    }
    extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var e, t = this.comp.threeDElements.length, n, s, i;
      for (e = 0; e < t; e += 1)
        if (n = this.comp.threeDElements[e], n.type === "3d") {
          s = n.perspectiveElem.style, i = n.container.style;
          var a = this.pe.v + "px", o = "0px 0px 0px", l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          s.perspective = a, s.webkitPerspective = a, i.transformOrigin = o, i.mozTransformOrigin = o, i.webkitTransformOrigin = o, s.transform = l, s.webkitTransform = l;
        }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var e = this._isFirstFrame, t, n;
      if (this.hierarchy)
        for (n = this.hierarchy.length, t = 0; t < n; t += 1)
          e = this.hierarchy[t].finalTransform.mProp._mdf || e;
      if (e || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy)
          for (n = this.hierarchy.length - 1, t = n; t >= 0; t -= 1) {
            var s = this.hierarchy[t].finalTransform.mProp;
            this.mat.translate(-s.p.v[0], -s.p.v[1], s.p.v[2]), this.mat.rotateX(-s.or.v[0]).rotateY(-s.or.v[1]).rotateZ(s.or.v[2]), this.mat.rotateX(-s.rx.v).rotateY(-s.ry.v).rotateZ(s.rz.v), this.mat.scale(1 / s.s.v[0], 1 / s.s.v[1], 1 / s.s.v[2]), this.mat.translate(s.a.v[0], s.a.v[1], s.a.v[2]);
          }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var i;
          this.p ? i = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : i = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var a = Math.sqrt(Math.pow(i[0], 2) + Math.pow(i[1], 2) + Math.pow(i[2], 2)), o = [i[0] / a, i[1] / a, i[2] / a], l = Math.sqrt(o[2] * o[2] + o[0] * o[0]), c = Math.atan2(o[1], l), u = Math.atan2(o[0], -o[2]);
          this.mat.rotateY(u).rotateX(-c);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var d = !this._prevMat.equals(this.mat);
        if ((d || this.pe._mdf) && this.comp.threeDElements) {
          n = this.comp.threeDElements.length;
          var p, f, g;
          for (t = 0; t < n; t += 1)
            if (p = this.comp.threeDElements[t], p.type === "3d") {
              if (d) {
                var C = this.mat.toCSS();
                g = p.container.style, g.transform = C, g.webkitTransform = C;
              }
              this.pe._mdf && (f = p.perspectiveElem.style, f.perspective = this.pe.v + "px", f.webkitPerspective = this.pe.v + "px");
            }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(e) {
      this.prepareProperties(e, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    };
    function HImageElement(e, t, n) {
      this.assetData = t.getAssetData(e.refId), this.initElement(e, t, n);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var e = this.globalData.getAssetsPath(this.assetData), t = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(t), t.crossOrigin = "anonymous", t.src = e, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: t && t.className || "",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "400%",
          height: t && t.filterSize && t.filterSize.height || "400%",
          x: t && t.filterSize && t.filterSize.x || "-100%",
          y: t && t.filterSize && t.filterSize.y || "-100%"
        }
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var e = this.pendingElements.pop();
        e.checkParenting();
      }
    }, HybridRendererBase.prototype.appendElementInPos = function(e, t) {
      var n = e.getBaseElement();
      if (n) {
        var s = this.layers[t];
        if (!s.ddd || !this.supports3d)
          if (this.threeDElements)
            this.addTo3dContainer(n, t);
          else {
            for (var i = 0, a, o, l; i < t; )
              this.elements[i] && this.elements[i] !== !0 && this.elements[i].getBaseElement && (o = this.elements[i], l = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : o.getBaseElement(), a = l || a), i += 1;
            a ? (!s.ddd || !this.supports3d) && this.layerElement.insertBefore(n, a) : (!s.ddd || !this.supports3d) && this.layerElement.appendChild(n);
          }
        else
          this.addTo3dContainer(n, t);
      }
    }, HybridRendererBase.prototype.createShape = function(e) {
      return this.supports3d ? new HShapeElement(e, this.globalData, this) : new SVGShapeElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(e) {
      return this.supports3d ? new HTextElement(e, this.globalData, this) : new SVGTextLottieElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(e) {
      return this.camera = new HCameraElement(e, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(e) {
      return this.supports3d ? new HImageElement(e, this.globalData, this) : new IImageElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(e) {
      return this.supports3d ? new HSolidElement(e, this.globalData, this) : new ISolidElement(e, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(e) {
      for (var t = 0, n = this.threeDElements.length; t < n; ) {
        if (this.threeDElements[t].startPos <= e && this.threeDElements[t].endPos >= e)
          return this.threeDElements[t].perspectiveElem;
        t += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(e, t) {
      var n = createTag("div"), s, i;
      styleDiv(n);
      var a = createTag("div");
      if (styleDiv(a), t === "3d") {
        s = n.style, s.width = this.globalData.compSize.w + "px", s.height = this.globalData.compSize.h + "px";
        var o = "50% 50%";
        s.webkitTransformOrigin = o, s.mozTransformOrigin = o, s.transformOrigin = o, i = a.style;
        var l = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        i.transform = l, i.webkitTransform = l;
      }
      n.appendChild(a);
      var c = {
        container: a,
        perspectiveElem: n,
        startPos: e,
        endPos: e,
        type: t
      };
      return this.threeDElements.push(c), c;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var e, t = this.layers.length, n, s = "";
      for (e = 0; e < t; e += 1)
        this.layers[e].ddd && this.layers[e].ty !== 3 ? (s !== "3d" && (s = "3d", n = this.createThreeDContainer(e, "3d")), n.endPos = Math.max(n.endPos, e)) : (s !== "2d" && (s = "2d", n = this.createThreeDContainer(e, "2d")), n.endPos = Math.max(n.endPos, e));
      for (t = this.threeDElements.length, e = t - 1; e >= 0; e -= 1)
        this.resizerElem.appendChild(this.threeDElements[e].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(e, t) {
      for (var n = 0, s = this.threeDElements.length; n < s; ) {
        if (t <= this.threeDElements[n].endPos) {
          for (var i = this.threeDElements[n].startPos, a; i < t; )
            this.elements[i] && this.elements[i].getBaseElement && (a = this.elements[i].getBaseElement()), i += 1;
          a ? this.threeDElements[n].container.insertBefore(e, a) : this.threeDElements[n].container.appendChild(e);
          break;
        }
        n += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(e) {
      var t = createTag("div"), n = this.animationItem.wrapper, s = t.style;
      s.width = e.w + "px", s.height = e.h + "px", this.resizerElem = t, styleDiv(t), s.transformStyle = "flat", s.mozTransformStyle = "flat", s.webkitTransformStyle = "flat", this.renderConfig.className && t.setAttribute("class", this.renderConfig.className), n.appendChild(t), s.overflow = "hidden";
      var i = createNS("svg");
      i.setAttribute("width", "1"), i.setAttribute("height", "1"), styleDiv(i), this.resizerElem.appendChild(i);
      var a = createNS("defs");
      i.appendChild(a), this.data = e, this.setupGlobalData(e, i), this.globalData.defs = a, this.layers = e.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var e, t = this.layers ? this.layers.length : 0;
      for (e = 0; e < t; e += 1)
        this.elements[e].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var e = this.animationItem.wrapper.offsetWidth, t = this.animationItem.wrapper.offsetHeight, n = e / t, s = this.globalData.compSize.w / this.globalData.compSize.h, i, a, o, l;
      s > n ? (i = e / this.globalData.compSize.w, a = e / this.globalData.compSize.w, o = 0, l = (t - this.globalData.compSize.h * (e / this.globalData.compSize.w)) / 2) : (i = t / this.globalData.compSize.h, a = t / this.globalData.compSize.h, o = (e - this.globalData.compSize.w * (t / this.globalData.compSize.h)) / 2, l = 0);
      var c = this.resizerElem.style;
      c.webkitTransform = "matrix3d(" + i + ",0,0,0,0," + a + ",0,0,0,0,1,0," + o + "," + l + ",0,1)", c.transform = c.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera)
        this.camera.setup();
      else {
        var e = this.globalData.compSize.w, t = this.globalData.compSize.h, n, s = this.threeDElements.length;
        for (n = 0; n < s; n += 1) {
          var i = this.threeDElements[n].perspectiveElem.style;
          i.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2)) + "px", i.perspective = i.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(e) {
      var t, n = e.length, s = createTag("div");
      for (t = 0; t < n; t += 1)
        if (e[t].xt) {
          var i = this.createComp(e[t], s, this.globalData.comp, null);
          i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
        }
    };
    function HCompElement(e, t, n) {
      this.layers = e.layers, this.supports3d = !e.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(e, t, n), this.tm = e.tm ? PropertyFactory.getProp(this, e.tm, 0, t.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(e, t) {
      for (var n = 0, s; n < t; )
        this.elements[n] && this.elements[n].getBaseElement && (s = this.elements[n].getBaseElement()), n += 1;
      s ? this.layerElement.insertBefore(e, s) : this.layerElement.appendChild(e);
    }, HCompElement.prototype.createComp = function(e) {
      return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
    };
    function HybridRenderer(e, t) {
      this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: t && t.className || "",
        imagePreserveAspectRatio: t && t.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(t && t.hideOnTransparent === !1),
        filterSize: {
          width: t && t.filterSize && t.filterSize.width || "400%",
          height: t && t.filterSize && t.filterSize.height || "400%",
          x: t && t.filterSize && t.filterSize.x || "-100%",
          y: t && t.filterSize && t.filterSize.y || "-100%"
        },
        runExpressions: !t || t.runExpressions === void 0 || t.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(e) {
      return this.supports3d ? new HCompElement(e, this.globalData, this) : new SVGCompElement(e, this.globalData, this);
    };
    var CompExpressionInterface = function() {
      return function(e) {
        function t(n) {
          for (var s = 0, i = e.layers.length; s < i; ) {
            if (e.layers[s].nm === n || e.layers[s].ind === n)
              return e.elements[s].layerInterface;
            s += 1;
          }
          return null;
        }
        return Object.defineProperty(t, "_name", {
          value: e.data.nm
        }), t.layer = t, t.pixelAspect = 1, t.height = e.data.h || e.globalData.compSize.h, t.width = e.data.w || e.globalData.compSize.w, t.pixelAspect = 1, t.frameDuration = 1 / e.globalData.frameRate, t.displayStartTime = 0, t.numLayers = e.layers.length, t;
      };
    }(), Expressions = function() {
      var e = {};
      e.initExpressions = t;
      function t(n) {
        var s = 0, i = [];
        function a() {
          s += 1;
        }
        function o() {
          s -= 1, s === 0 && c();
        }
        function l(u) {
          i.indexOf(u) === -1 && i.push(u);
        }
        function c() {
          var u, d = i.length;
          for (u = 0; u < d; u += 1)
            i[u].release();
          i.length = 0;
        }
        n.renderer.compInterface = CompExpressionInterface(n.renderer), n.renderer.globalData.projectInterface.registerComposition(n.renderer), n.renderer.globalData.pushExpression = a, n.renderer.globalData.popExpression = o, n.renderer.globalData.registerExpressionProperty = l;
      }
      return e;
    }(), MaskManagerInterface = function() {
      function e(n, s) {
        this._mask = n, this._data = s;
      }
      Object.defineProperty(e.prototype, "maskPath", {
        get: function() {
          return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
        }
      }), Object.defineProperty(e.prototype, "maskOpacity", {
        get: function() {
          return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
        }
      });
      var t = function(s) {
        var i = createSizedArray(s.viewData.length), a, o = s.viewData.length;
        for (a = 0; a < o; a += 1)
          i[a] = new e(s.viewData[a], s.masksProperties[a]);
        var l = function(u) {
          for (a = 0; a < o; ) {
            if (s.masksProperties[a].nm === u)
              return i[a];
            a += 1;
          }
          return null;
        };
        return l;
      };
      return t;
    }(), ExpressionPropertyInterface = function() {
      var e = {
        pv: 0,
        v: 0,
        mult: 1
      }, t = {
        pv: [0, 0, 0],
        v: [0, 0, 0],
        mult: 1
      };
      function n(o, l, c) {
        Object.defineProperty(o, "velocity", {
          get: function() {
            return l.getVelocityAtTime(l.comp.currentFrame);
          }
        }), o.numKeys = l.keyframes ? l.keyframes.length : 0, o.key = function(u) {
          if (!o.numKeys)
            return 0;
          var d = "";
          "s" in l.keyframes[u - 1] ? d = l.keyframes[u - 1].s : "e" in l.keyframes[u - 2] ? d = l.keyframes[u - 2].e : d = l.keyframes[u - 2].s;
          var p = c === "unidimensional" ? new Number(d) : Object.assign({}, d);
          return p.time = l.keyframes[u - 1].t / l.elem.comp.globalData.frameRate, p.value = c === "unidimensional" ? d[0] : d, p;
        }, o.valueAtTime = l.getValueAtTime, o.speedAtTime = l.getSpeedAtTime, o.velocityAtTime = l.getVelocityAtTime, o.propertyGroup = l.propertyGroup;
      }
      function s(o) {
        (!o || !("pv" in o)) && (o = e);
        var l = 1 / o.mult, c = o.pv * l, u = new Number(c);
        return u.value = c, n(u, o, "unidimensional"), function() {
          return o.k && o.getValue(), c = o.v * l, u.value !== c && (u = new Number(c), u.value = c, n(u, o, "unidimensional")), u;
        };
      }
      function i(o) {
        (!o || !("pv" in o)) && (o = t);
        var l = 1 / o.mult, c = o.data && o.data.l || o.pv.length, u = createTypedArray("float32", c), d = createTypedArray("float32", c);
        return u.value = d, n(u, o, "multidimensional"), function() {
          o.k && o.getValue();
          for (var p = 0; p < c; p += 1)
            d[p] = o.v[p] * l, u[p] = d[p];
          return u;
        };
      }
      function a() {
        return e;
      }
      return function(o) {
        return o ? o.propType === "unidimensional" ? s(o) : i(o) : a;
      };
    }(), TransformExpressionInterface = function() {
      return function(e) {
        function t(o) {
          switch (o) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return t.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return t.rotation;
            case "ADBE Rotate X":
              return t.xRotation;
            case "ADBE Rotate Y":
              return t.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return t.position;
            case "ADBE Position_0":
              return t.xPosition;
            case "ADBE Position_1":
              return t.yPosition;
            case "ADBE Position_2":
              return t.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return t.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return t.opacity;
            default:
              return null;
          }
        }
        Object.defineProperty(t, "rotation", {
          get: ExpressionPropertyInterface(e.r || e.rz)
        }), Object.defineProperty(t, "zRotation", {
          get: ExpressionPropertyInterface(e.rz || e.r)
        }), Object.defineProperty(t, "xRotation", {
          get: ExpressionPropertyInterface(e.rx)
        }), Object.defineProperty(t, "yRotation", {
          get: ExpressionPropertyInterface(e.ry)
        }), Object.defineProperty(t, "scale", {
          get: ExpressionPropertyInterface(e.s)
        });
        var n, s, i, a;
        return e.p ? a = ExpressionPropertyInterface(e.p) : (n = ExpressionPropertyInterface(e.px), s = ExpressionPropertyInterface(e.py), e.pz && (i = ExpressionPropertyInterface(e.pz))), Object.defineProperty(t, "position", {
          get: function() {
            return e.p ? a() : [n(), s(), i ? i() : 0];
          }
        }), Object.defineProperty(t, "xPosition", {
          get: ExpressionPropertyInterface(e.px)
        }), Object.defineProperty(t, "yPosition", {
          get: ExpressionPropertyInterface(e.py)
        }), Object.defineProperty(t, "zPosition", {
          get: ExpressionPropertyInterface(e.pz)
        }), Object.defineProperty(t, "anchorPoint", {
          get: ExpressionPropertyInterface(e.a)
        }), Object.defineProperty(t, "opacity", {
          get: ExpressionPropertyInterface(e.o)
        }), Object.defineProperty(t, "skew", {
          get: ExpressionPropertyInterface(e.sk)
        }), Object.defineProperty(t, "skewAxis", {
          get: ExpressionPropertyInterface(e.sa)
        }), Object.defineProperty(t, "orientation", {
          get: ExpressionPropertyInterface(e.or)
        }), t;
      };
    }(), LayerExpressionInterface = function() {
      function e(u) {
        var d = new Matrix();
        if (u !== void 0) {
          var p = this._elem.finalTransform.mProp.getValueAtTime(u);
          p.clone(d);
        } else {
          var f = this._elem.finalTransform.mProp;
          f.applyToMatrix(d);
        }
        return d;
      }
      function t(u, d) {
        var p = this.getMatrix(d);
        return p.props[12] = 0, p.props[13] = 0, p.props[14] = 0, this.applyPoint(p, u);
      }
      function n(u, d) {
        var p = this.getMatrix(d);
        return this.applyPoint(p, u);
      }
      function s(u, d) {
        var p = this.getMatrix(d);
        return p.props[12] = 0, p.props[13] = 0, p.props[14] = 0, this.invertPoint(p, u);
      }
      function i(u, d) {
        var p = this.getMatrix(d);
        return this.invertPoint(p, u);
      }
      function a(u, d) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var p, f = this._elem.hierarchy.length;
          for (p = 0; p < f; p += 1)
            this._elem.hierarchy[p].finalTransform.mProp.applyToMatrix(u);
        }
        return u.applyToPointArray(d[0], d[1], d[2] || 0);
      }
      function o(u, d) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var p, f = this._elem.hierarchy.length;
          for (p = 0; p < f; p += 1)
            this._elem.hierarchy[p].finalTransform.mProp.applyToMatrix(u);
        }
        return u.inversePoint(d);
      }
      function l(u) {
        var d = new Matrix();
        if (d.reset(), this._elem.finalTransform.mProp.applyToMatrix(d), this._elem.hierarchy && this._elem.hierarchy.length) {
          var p, f = this._elem.hierarchy.length;
          for (p = 0; p < f; p += 1)
            this._elem.hierarchy[p].finalTransform.mProp.applyToMatrix(d);
          return d.inversePoint(u);
        }
        return d.inversePoint(u);
      }
      function c() {
        return [1, 1, 1, 1];
      }
      return function(u) {
        var d;
        function p(k) {
          g.mask = new MaskManagerInterface(k, u);
        }
        function f(k) {
          g.effect = k;
        }
        function g(k) {
          switch (k) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return g.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return d;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return g.effect;
            case "ADBE Text Properties":
              return g.textInterface;
            default:
              return null;
          }
        }
        g.getMatrix = e, g.invertPoint = o, g.applyPoint = a, g.toWorld = n, g.toWorldVec = t, g.fromWorld = i, g.fromWorldVec = s, g.toComp = n, g.fromComp = l, g.sampleImage = c, g.sourceRectAtTime = u.sourceRectAtTime.bind(u), g._elem = u, d = TransformExpressionInterface(u.finalTransform.mProp);
        var C = getDescriptor(d, "anchorPoint");
        return Object.defineProperties(g, {
          hasParent: {
            get: function() {
              return u.hierarchy.length;
            }
          },
          parent: {
            get: function() {
              return u.hierarchy[0].layerInterface;
            }
          },
          rotation: getDescriptor(d, "rotation"),
          scale: getDescriptor(d, "scale"),
          position: getDescriptor(d, "position"),
          opacity: getDescriptor(d, "opacity"),
          anchorPoint: C,
          anchor_point: C,
          transform: {
            get: function() {
              return d;
            }
          },
          active: {
            get: function() {
              return u.isInRange;
            }
          }
        }), g.startTime = u.data.st, g.index = u.data.ind, g.source = u.data.refId, g.height = u.data.ty === 0 ? u.data.h : 100, g.width = u.data.ty === 0 ? u.data.w : 100, g.inPoint = u.data.ip / u.comp.globalData.frameRate, g.outPoint = u.data.op / u.comp.globalData.frameRate, g._name = u.data.nm, g.registerMaskInterface = p, g.registerEffectsInterface = f, g;
      };
    }(), propertyGroupFactory = function() {
      return function(e, t) {
        return function(n) {
          return n = n === void 0 ? 1 : n, n <= 0 ? e : t(n - 1);
        };
      };
    }(), PropertyInterface = function() {
      return function(e, t) {
        var n = {
          _name: e
        };
        function s(i) {
          return i = i === void 0 ? 1 : i, i <= 0 ? n : t(i - 1);
        }
        return s;
      };
    }(), EffectsExpressionInterface = function() {
      var e = {
        createEffectsInterface: t
      };
      function t(i, a) {
        if (i.effectsManager) {
          var o = [], l = i.data.ef, c, u = i.effectsManager.effectElements.length;
          for (c = 0; c < u; c += 1)
            o.push(n(l[c], i.effectsManager.effectElements[c], a, i));
          var d = i.data.ef || [], p = function(g) {
            for (c = 0, u = d.length; c < u; ) {
              if (g === d[c].nm || g === d[c].mn || g === d[c].ix)
                return o[c];
              c += 1;
            }
            return null;
          };
          return Object.defineProperty(p, "numProperties", {
            get: function() {
              return d.length;
            }
          }), p;
        }
        return null;
      }
      function n(i, a, o, l) {
        function c(g) {
          for (var C = i.ef, k = 0, M = C.length; k < M; ) {
            if (g === C[k].nm || g === C[k].mn || g === C[k].ix)
              return C[k].ty === 5 ? d[k] : d[k]();
            k += 1;
          }
          throw new Error();
        }
        var u = propertyGroupFactory(c, o), d = [], p, f = i.ef.length;
        for (p = 0; p < f; p += 1)
          i.ef[p].ty === 5 ? d.push(n(i.ef[p], a.effectElements[p], a.effectElements[p].propertyGroup, l)) : d.push(s(a.effectElements[p], i.ef[p].ty, l, u));
        return i.mn === "ADBE Color Control" && Object.defineProperty(c, "color", {
          get: function() {
            return d[0]();
          }
        }), Object.defineProperties(c, {
          numProperties: {
            get: function() {
              return i.np;
            }
          },
          _name: {
            value: i.nm
          },
          propertyGroup: {
            value: u
          }
        }), c.enabled = i.en !== 0, c.active = c.enabled, c;
      }
      function s(i, a, o, l) {
        var c = ExpressionPropertyInterface(i.p);
        function u() {
          return a === 10 ? o.comp.compInterface(i.p.v) : c();
        }
        return i.p.setGroupProperty && i.p.setGroupProperty(PropertyInterface("", l)), u;
      }
      return e;
    }(), ShapePathInterface = function() {
      return function(t, n, s) {
        var i = n.sh;
        function a(l) {
          return l === "Shape" || l === "shape" || l === "Path" || l === "path" || l === "ADBE Vector Shape" || l === 2 ? a.path : null;
        }
        var o = propertyGroupFactory(a, s);
        return i.setGroupProperty(PropertyInterface("Path", o)), Object.defineProperties(a, {
          path: {
            get: function() {
              return i.k && i.getValue(), i;
            }
          },
          shape: {
            get: function() {
              return i.k && i.getValue(), i;
            }
          },
          _name: {
            value: t.nm
          },
          ix: {
            value: t.ix
          },
          propertyIndex: {
            value: t.ix
          },
          mn: {
            value: t.mn
          },
          propertyGroup: {
            value: s
          }
        }), a;
      };
    }(), ShapeExpressionInterface = function() {
      function e(C, k, M) {
        var _ = [], S, E = C ? C.length : 0;
        for (S = 0; S < E; S += 1)
          C[S].ty === "gr" ? _.push(n(C[S], k[S], M)) : C[S].ty === "fl" ? _.push(s(C[S], k[S], M)) : C[S].ty === "st" ? _.push(o(C[S], k[S], M)) : C[S].ty === "tm" ? _.push(l(C[S], k[S], M)) : C[S].ty === "tr" || (C[S].ty === "el" ? _.push(u(C[S], k[S], M)) : C[S].ty === "sr" ? _.push(d(C[S], k[S], M)) : C[S].ty === "sh" ? _.push(ShapePathInterface(C[S], k[S], M)) : C[S].ty === "rc" ? _.push(p(C[S], k[S], M)) : C[S].ty === "rd" ? _.push(f(C[S], k[S], M)) : C[S].ty === "rp" ? _.push(g(C[S], k[S], M)) : C[S].ty === "gf" ? _.push(i(C[S], k[S], M)) : _.push(a(C[S], k[S])));
        return _;
      }
      function t(C, k, M) {
        var _, S = function($) {
          for (var A = 0, I = _.length; A < I; ) {
            if (_[A]._name === $ || _[A].mn === $ || _[A].propertyIndex === $ || _[A].ix === $ || _[A].ind === $)
              return _[A];
            A += 1;
          }
          return typeof $ == "number" ? _[$ - 1] : null;
        };
        S.propertyGroup = propertyGroupFactory(S, M), _ = e(C.it, k.it, S.propertyGroup), S.numProperties = _.length;
        var E = c(C.it[C.it.length - 1], k.it[k.it.length - 1], S.propertyGroup);
        return S.transform = E, S.propertyIndex = C.cix, S._name = C.nm, S;
      }
      function n(C, k, M) {
        var _ = function($) {
          switch ($) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return _.content;
            default:
              return _.transform;
          }
        };
        _.propertyGroup = propertyGroupFactory(_, M);
        var S = t(C, k, _.propertyGroup), E = c(C.it[C.it.length - 1], k.it[k.it.length - 1], _.propertyGroup);
        return _.content = S, _.transform = E, Object.defineProperty(_, "_name", {
          get: function() {
            return C.nm;
          }
        }), _.numProperties = C.np, _.propertyIndex = C.ix, _.nm = C.nm, _.mn = C.mn, _;
      }
      function s(C, k, M) {
        function _(S) {
          return S === "Color" || S === "color" ? _.color : S === "Opacity" || S === "opacity" ? _.opacity : null;
        }
        return Object.defineProperties(_, {
          color: {
            get: ExpressionPropertyInterface(k.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(k.o)
          },
          _name: {
            value: C.nm
          },
          mn: {
            value: C.mn
          }
        }), k.c.setGroupProperty(PropertyInterface("Color", M)), k.o.setGroupProperty(PropertyInterface("Opacity", M)), _;
      }
      function i(C, k, M) {
        function _(S) {
          return S === "Start Point" || S === "start point" ? _.startPoint : S === "End Point" || S === "end point" ? _.endPoint : S === "Opacity" || S === "opacity" ? _.opacity : null;
        }
        return Object.defineProperties(_, {
          startPoint: {
            get: ExpressionPropertyInterface(k.s)
          },
          endPoint: {
            get: ExpressionPropertyInterface(k.e)
          },
          opacity: {
            get: ExpressionPropertyInterface(k.o)
          },
          type: {
            get: function() {
              return "a";
            }
          },
          _name: {
            value: C.nm
          },
          mn: {
            value: C.mn
          }
        }), k.s.setGroupProperty(PropertyInterface("Start Point", M)), k.e.setGroupProperty(PropertyInterface("End Point", M)), k.o.setGroupProperty(PropertyInterface("Opacity", M)), _;
      }
      function a() {
        function C() {
          return null;
        }
        return C;
      }
      function o(C, k, M) {
        var _ = propertyGroupFactory(I, M), S = propertyGroupFactory(A, _);
        function E(D) {
          Object.defineProperty(A, C.d[D].nm, {
            get: ExpressionPropertyInterface(k.d.dataProps[D].p)
          });
        }
        var P, $ = C.d ? C.d.length : 0, A = {};
        for (P = 0; P < $; P += 1)
          E(P), k.d.dataProps[P].p.setGroupProperty(S);
        function I(D) {
          return D === "Color" || D === "color" ? I.color : D === "Opacity" || D === "opacity" ? I.opacity : D === "Stroke Width" || D === "stroke width" ? I.strokeWidth : null;
        }
        return Object.defineProperties(I, {
          color: {
            get: ExpressionPropertyInterface(k.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(k.o)
          },
          strokeWidth: {
            get: ExpressionPropertyInterface(k.w)
          },
          dash: {
            get: function() {
              return A;
            }
          },
          _name: {
            value: C.nm
          },
          mn: {
            value: C.mn
          }
        }), k.c.setGroupProperty(PropertyInterface("Color", _)), k.o.setGroupProperty(PropertyInterface("Opacity", _)), k.w.setGroupProperty(PropertyInterface("Stroke Width", _)), I;
      }
      function l(C, k, M) {
        function _(E) {
          return E === C.e.ix || E === "End" || E === "end" ? _.end : E === C.s.ix ? _.start : E === C.o.ix ? _.offset : null;
        }
        var S = propertyGroupFactory(_, M);
        return _.propertyIndex = C.ix, k.s.setGroupProperty(PropertyInterface("Start", S)), k.e.setGroupProperty(PropertyInterface("End", S)), k.o.setGroupProperty(PropertyInterface("Offset", S)), _.propertyIndex = C.ix, _.propertyGroup = M, Object.defineProperties(_, {
          start: {
            get: ExpressionPropertyInterface(k.s)
          },
          end: {
            get: ExpressionPropertyInterface(k.e)
          },
          offset: {
            get: ExpressionPropertyInterface(k.o)
          },
          _name: {
            value: C.nm
          }
        }), _.mn = C.mn, _;
      }
      function c(C, k, M) {
        function _(E) {
          return C.a.ix === E || E === "Anchor Point" ? _.anchorPoint : C.o.ix === E || E === "Opacity" ? _.opacity : C.p.ix === E || E === "Position" ? _.position : C.r.ix === E || E === "Rotation" || E === "ADBE Vector Rotation" ? _.rotation : C.s.ix === E || E === "Scale" ? _.scale : C.sk && C.sk.ix === E || E === "Skew" ? _.skew : C.sa && C.sa.ix === E || E === "Skew Axis" ? _.skewAxis : null;
        }
        var S = propertyGroupFactory(_, M);
        return k.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", S)), k.transform.mProps.p.setGroupProperty(PropertyInterface("Position", S)), k.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", S)), k.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", S)), k.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", S)), k.transform.mProps.sk && (k.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", S)), k.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", S))), k.transform.op.setGroupProperty(PropertyInterface("Opacity", S)), Object.defineProperties(_, {
          opacity: {
            get: ExpressionPropertyInterface(k.transform.mProps.o)
          },
          position: {
            get: ExpressionPropertyInterface(k.transform.mProps.p)
          },
          anchorPoint: {
            get: ExpressionPropertyInterface(k.transform.mProps.a)
          },
          scale: {
            get: ExpressionPropertyInterface(k.transform.mProps.s)
          },
          rotation: {
            get: ExpressionPropertyInterface(k.transform.mProps.r)
          },
          skew: {
            get: ExpressionPropertyInterface(k.transform.mProps.sk)
          },
          skewAxis: {
            get: ExpressionPropertyInterface(k.transform.mProps.sa)
          },
          _name: {
            value: C.nm
          }
        }), _.ty = "tr", _.mn = C.mn, _.propertyGroup = M, _;
      }
      function u(C, k, M) {
        function _(P) {
          return C.p.ix === P ? _.position : C.s.ix === P ? _.size : null;
        }
        var S = propertyGroupFactory(_, M);
        _.propertyIndex = C.ix;
        var E = k.sh.ty === "tm" ? k.sh.prop : k.sh;
        return E.s.setGroupProperty(PropertyInterface("Size", S)), E.p.setGroupProperty(PropertyInterface("Position", S)), Object.defineProperties(_, {
          size: {
            get: ExpressionPropertyInterface(E.s)
          },
          position: {
            get: ExpressionPropertyInterface(E.p)
          },
          _name: {
            value: C.nm
          }
        }), _.mn = C.mn, _;
      }
      function d(C, k, M) {
        function _(P) {
          return C.p.ix === P ? _.position : C.r.ix === P ? _.rotation : C.pt.ix === P ? _.points : C.or.ix === P || P === "ADBE Vector Star Outer Radius" ? _.outerRadius : C.os.ix === P ? _.outerRoundness : C.ir && (C.ir.ix === P || P === "ADBE Vector Star Inner Radius") ? _.innerRadius : C.is && C.is.ix === P ? _.innerRoundness : null;
        }
        var S = propertyGroupFactory(_, M), E = k.sh.ty === "tm" ? k.sh.prop : k.sh;
        return _.propertyIndex = C.ix, E.or.setGroupProperty(PropertyInterface("Outer Radius", S)), E.os.setGroupProperty(PropertyInterface("Outer Roundness", S)), E.pt.setGroupProperty(PropertyInterface("Points", S)), E.p.setGroupProperty(PropertyInterface("Position", S)), E.r.setGroupProperty(PropertyInterface("Rotation", S)), C.ir && (E.ir.setGroupProperty(PropertyInterface("Inner Radius", S)), E.is.setGroupProperty(PropertyInterface("Inner Roundness", S))), Object.defineProperties(_, {
          position: {
            get: ExpressionPropertyInterface(E.p)
          },
          rotation: {
            get: ExpressionPropertyInterface(E.r)
          },
          points: {
            get: ExpressionPropertyInterface(E.pt)
          },
          outerRadius: {
            get: ExpressionPropertyInterface(E.or)
          },
          outerRoundness: {
            get: ExpressionPropertyInterface(E.os)
          },
          innerRadius: {
            get: ExpressionPropertyInterface(E.ir)
          },
          innerRoundness: {
            get: ExpressionPropertyInterface(E.is)
          },
          _name: {
            value: C.nm
          }
        }), _.mn = C.mn, _;
      }
      function p(C, k, M) {
        function _(P) {
          return C.p.ix === P ? _.position : C.r.ix === P ? _.roundness : C.s.ix === P || P === "Size" || P === "ADBE Vector Rect Size" ? _.size : null;
        }
        var S = propertyGroupFactory(_, M), E = k.sh.ty === "tm" ? k.sh.prop : k.sh;
        return _.propertyIndex = C.ix, E.p.setGroupProperty(PropertyInterface("Position", S)), E.s.setGroupProperty(PropertyInterface("Size", S)), E.r.setGroupProperty(PropertyInterface("Rotation", S)), Object.defineProperties(_, {
          position: {
            get: ExpressionPropertyInterface(E.p)
          },
          roundness: {
            get: ExpressionPropertyInterface(E.r)
          },
          size: {
            get: ExpressionPropertyInterface(E.s)
          },
          _name: {
            value: C.nm
          }
        }), _.mn = C.mn, _;
      }
      function f(C, k, M) {
        function _(P) {
          return C.r.ix === P || P === "Round Corners 1" ? _.radius : null;
        }
        var S = propertyGroupFactory(_, M), E = k;
        return _.propertyIndex = C.ix, E.rd.setGroupProperty(PropertyInterface("Radius", S)), Object.defineProperties(_, {
          radius: {
            get: ExpressionPropertyInterface(E.rd)
          },
          _name: {
            value: C.nm
          }
        }), _.mn = C.mn, _;
      }
      function g(C, k, M) {
        function _(P) {
          return C.c.ix === P || P === "Copies" ? _.copies : C.o.ix === P || P === "Offset" ? _.offset : null;
        }
        var S = propertyGroupFactory(_, M), E = k;
        return _.propertyIndex = C.ix, E.c.setGroupProperty(PropertyInterface("Copies", S)), E.o.setGroupProperty(PropertyInterface("Offset", S)), Object.defineProperties(_, {
          copies: {
            get: ExpressionPropertyInterface(E.c)
          },
          offset: {
            get: ExpressionPropertyInterface(E.o)
          },
          _name: {
            value: C.nm
          }
        }), _.mn = C.mn, _;
      }
      return function(C, k, M) {
        var _;
        function S(P) {
          if (typeof P == "number")
            return P = P === void 0 ? 1 : P, P === 0 ? M : _[P - 1];
          for (var $ = 0, A = _.length; $ < A; ) {
            if (_[$]._name === P)
              return _[$];
            $ += 1;
          }
          return null;
        }
        function E() {
          return M;
        }
        return S.propertyGroup = propertyGroupFactory(S, E), _ = e(C, k, S.propertyGroup), S.numProperties = _.length, S._name = "Contents", S;
      };
    }(), TextExpressionInterface = function() {
      return function(e) {
        var t, n;
        function s(i) {
          switch (i) {
            case "ADBE Text Document":
              return s.sourceText;
            default:
              return null;
          }
        }
        return Object.defineProperty(s, "sourceText", {
          get: function() {
            e.textProperty.getValue();
            var a = e.textProperty.currentData.t;
            return a !== t && (t = e.textProperty.currentData.t, n = new String(a), n.value = a || new String(a), Object.defineProperty(n, "style", {
              get: function() {
                return {
                  fillColor: e.textProperty.currentData.fc
                };
              }
            })), n;
          }
        }), s;
      };
    }();
    function _typeof$2(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$2 = function(n) {
        return typeof n;
      } : _typeof$2 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$2(e);
    }
    var FootageInterface = function() {
      var e = function(s) {
        var i = "", a = s.getFootageData();
        function o() {
          return i = "", a = s.getFootageData(), l;
        }
        function l(c) {
          if (a[c])
            return i = c, a = a[c], _typeof$2(a) === "object" ? l : a;
          var u = c.indexOf(i);
          if (u !== -1) {
            var d = parseInt(c.substr(u + i.length), 10);
            return a = a[d], _typeof$2(a) === "object" ? l : a;
          }
          return "";
        }
        return o;
      }, t = function(s) {
        function i(a) {
          return a === "Outline" ? i.outlineInterface() : null;
        }
        return i._name = "Outline", i.outlineInterface = e(s), i;
      };
      return function(n) {
        function s(i) {
          return i === "Data" ? s.dataInterface : null;
        }
        return s._name = "Data", s.dataInterface = t(n), s;
      };
    }(), interfaces = {
      layer: LayerExpressionInterface,
      effects: EffectsExpressionInterface,
      comp: CompExpressionInterface,
      shape: ShapeExpressionInterface,
      text: TextExpressionInterface,
      footage: FootageInterface
    };
    function getInterface(e) {
      return interfaces[e] || null;
    }
    function _typeof$1(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$1 = function(n) {
        return typeof n;
      } : _typeof$1 = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof$1(e);
    }
    function seedRandom(e, t) {
      var n = this, s = 256, i = 6, a = 52, o = "random", l = t.pow(s, i), c = t.pow(2, a), u = c * 2, d = s - 1, p;
      function f(E, P, $) {
        var A = [];
        P = P === !0 ? {
          entropy: !0
        } : P || {};
        var I = M(k(P.entropy ? [E, S(e)] : E === null ? _() : E, 3), A), D = new g(A), R = function() {
          for (var q = D.g(i), j = l, X = 0; q < c; )
            q = (q + X) * s, j *= s, X = D.g(1);
          for (; q >= u; )
            q /= 2, j /= 2, X >>>= 1;
          return (q + X) / j;
        };
        return R.int32 = function() {
          return D.g(4) | 0;
        }, R.quick = function() {
          return D.g(4) / 4294967296;
        }, R.double = R, M(S(D.S), e), (P.pass || $ || function(Y, q, j, X) {
          return X && (X.S && C(X, D), Y.state = function() {
            return C(D, {});
          }), j ? (t[o] = Y, q) : Y;
        })(R, I, "global" in P ? P.global : this == t, P.state);
      }
      t["seed" + o] = f;
      function g(E) {
        var P, $ = E.length, A = this, I = 0, D = A.i = A.j = 0, R = A.S = [];
        for ($ || (E = [$++]); I < s; )
          R[I] = I++;
        for (I = 0; I < s; I++)
          R[I] = R[D = d & D + E[I % $] + (P = R[I])], R[D] = P;
        A.g = function(Y) {
          for (var q, j = 0, X = A.i, ee = A.j, G = A.S; Y--; )
            q = G[X = d & X + 1], j = j * s + G[d & (G[X] = G[ee = d & ee + q]) + (G[ee] = q)];
          return A.i = X, A.j = ee, j;
        };
      }
      function C(E, P) {
        return P.i = E.i, P.j = E.j, P.S = E.S.slice(), P;
      }
      function k(E, P) {
        var $ = [], A = _typeof$1(E), I;
        if (P && A == "object")
          for (I in E)
            try {
              $.push(k(E[I], P - 1));
            } catch {
            }
        return $.length ? $ : A == "string" ? E : E + "\0";
      }
      function M(E, P) {
        for (var $ = E + "", A, I = 0; I < $.length; )
          P[d & I] = d & (A ^= P[d & I] * 19) + $.charCodeAt(I++);
        return S(P);
      }
      function _() {
        try {
          var E = new Uint8Array(s);
          return (n.crypto || n.msCrypto).getRandomValues(E), S(E);
        } catch {
          var P = n.navigator, $ = P && P.plugins;
          return [+new Date(), n, $, n.screen, S(e)];
        }
      }
      function S(E) {
        return String.fromCharCode.apply(0, E);
      }
      M(t.random(), e);
    }
    function initialize$2(e) {
      seedRandom([], e);
    }
    var propTypes = {
      SHAPE: "shape"
    };
    function _typeof(e) {
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(n) {
        return typeof n;
      } : _typeof = function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, _typeof(e);
    }
    var ExpressionManager = function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null;
      initialize$2(BMMath);
      function $bm_isInstanceOfArray(e) {
        return e.constructor === Array || e.constructor === Float32Array;
      }
      function isNumerable(e, t) {
        return e === "number" || e === "boolean" || e === "string" || t instanceof Number;
      }
      function $bm_neg(e) {
        var t = _typeof(e);
        if (t === "number" || t === "boolean" || e instanceof Number)
          return -e;
        if ($bm_isInstanceOfArray(e)) {
          var n, s = e.length, i = [];
          for (n = 0; n < s; n += 1)
            i[n] = -e[n];
          return i;
        }
        return e.propType ? e.v : -e;
      }
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(e, t) {
        var n = _typeof(e), s = _typeof(t);
        if (n === "string" || s === "string" || isNumerable(n, e) && isNumerable(s, t))
          return e + t;
        if ($bm_isInstanceOfArray(e) && isNumerable(s, t))
          return e = e.slice(0), e[0] += t, e;
        if (isNumerable(n, e) && $bm_isInstanceOfArray(t))
          return t = t.slice(0), t[0] = e + t[0], t;
        if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
          for (var i = 0, a = e.length, o = t.length, l = []; i < a || i < o; )
            (typeof e[i] == "number" || e[i] instanceof Number) && (typeof t[i] == "number" || t[i] instanceof Number) ? l[i] = e[i] + t[i] : l[i] = t[i] === void 0 ? e[i] : e[i] || t[i], i += 1;
          return l;
        }
        return 0;
      }
      var add = sum;
      function sub(e, t) {
        var n = _typeof(e), s = _typeof(t);
        if (isNumerable(n, e) && isNumerable(s, t))
          return n === "string" && (e = parseInt(e, 10)), s === "string" && (t = parseInt(t, 10)), e - t;
        if ($bm_isInstanceOfArray(e) && isNumerable(s, t))
          return e = e.slice(0), e[0] -= t, e;
        if (isNumerable(n, e) && $bm_isInstanceOfArray(t))
          return t = t.slice(0), t[0] = e - t[0], t;
        if ($bm_isInstanceOfArray(e) && $bm_isInstanceOfArray(t)) {
          for (var i = 0, a = e.length, o = t.length, l = []; i < a || i < o; )
            (typeof e[i] == "number" || e[i] instanceof Number) && (typeof t[i] == "number" || t[i] instanceof Number) ? l[i] = e[i] - t[i] : l[i] = t[i] === void 0 ? e[i] : e[i] || t[i], i += 1;
          return l;
        }
        return 0;
      }
      function mul(e, t) {
        var n = _typeof(e), s = _typeof(t), i;
        if (isNumerable(n, e) && isNumerable(s, t))
          return e * t;
        var a, o;
        if ($bm_isInstanceOfArray(e) && isNumerable(s, t)) {
          for (o = e.length, i = createTypedArray("float32", o), a = 0; a < o; a += 1)
            i[a] = e[a] * t;
          return i;
        }
        if (isNumerable(n, e) && $bm_isInstanceOfArray(t)) {
          for (o = t.length, i = createTypedArray("float32", o), a = 0; a < o; a += 1)
            i[a] = e * t[a];
          return i;
        }
        return 0;
      }
      function div(e, t) {
        var n = _typeof(e), s = _typeof(t), i;
        if (isNumerable(n, e) && isNumerable(s, t))
          return e / t;
        var a, o;
        if ($bm_isInstanceOfArray(e) && isNumerable(s, t)) {
          for (o = e.length, i = createTypedArray("float32", o), a = 0; a < o; a += 1)
            i[a] = e[a] / t;
          return i;
        }
        if (isNumerable(n, e) && $bm_isInstanceOfArray(t)) {
          for (o = t.length, i = createTypedArray("float32", o), a = 0; a < o; a += 1)
            i[a] = e / t[a];
          return i;
        }
        return 0;
      }
      function mod(e, t) {
        return typeof e == "string" && (e = parseInt(e, 10)), typeof t == "string" && (t = parseInt(t, 10)), e % t;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(e, t, n) {
        if (t > n) {
          var s = n;
          n = t, t = s;
        }
        return Math.min(Math.max(e, t), n);
      }
      function radiansToDegrees(e) {
        return e / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(e) {
        return e * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(e, t) {
        if (typeof e == "number" || e instanceof Number)
          return t = t || 0, Math.abs(e - t);
        t || (t = helperLengthArray);
        var n, s = Math.min(e.length, t.length), i = 0;
        for (n = 0; n < s; n += 1)
          i += Math.pow(t[n] - e[n], 2);
        return Math.sqrt(i);
      }
      function normalize(e) {
        return div(e, length(e));
      }
      function rgbToHsl(e) {
        var t = e[0], n = e[1], s = e[2], i = Math.max(t, n, s), a = Math.min(t, n, s), o, l, c = (i + a) / 2;
        if (i === a)
          o = 0, l = 0;
        else {
          var u = i - a;
          switch (l = c > 0.5 ? u / (2 - i - a) : u / (i + a), i) {
            case t:
              o = (n - s) / u + (n < s ? 6 : 0);
              break;
            case n:
              o = (s - t) / u + 2;
              break;
            case s:
              o = (t - n) / u + 4;
              break;
          }
          o /= 6;
        }
        return [o, l, c, e[3]];
      }
      function hue2rgb(e, t, n) {
        return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
      }
      function hslToRgb(e) {
        var t = e[0], n = e[1], s = e[2], i, a, o;
        if (n === 0)
          i = s, o = s, a = s;
        else {
          var l = s < 0.5 ? s * (1 + n) : s + n - s * n, c = 2 * s - l;
          i = hue2rgb(c, l, t + 1 / 3), a = hue2rgb(c, l, t), o = hue2rgb(c, l, t - 1 / 3);
        }
        return [i, a, o, e[3]];
      }
      function linear(e, t, n, s, i) {
        if ((s === void 0 || i === void 0) && (s = t, i = n, t = 0, n = 1), n < t) {
          var a = n;
          n = t, t = a;
        }
        if (e <= t)
          return s;
        if (e >= n)
          return i;
        var o = n === t ? 0 : (e - t) / (n - t);
        if (!s.length)
          return s + (i - s) * o;
        var l, c = s.length, u = createTypedArray("float32", c);
        for (l = 0; l < c; l += 1)
          u[l] = s[l] + (i[l] - s[l]) * o;
        return u;
      }
      function random(e, t) {
        if (t === void 0 && (e === void 0 ? (e = 0, t = 1) : (t = e, e = void 0)), t.length) {
          var n, s = t.length;
          e || (e = createTypedArray("float32", s));
          var i = createTypedArray("float32", s), a = BMMath.random();
          for (n = 0; n < s; n += 1)
            i[n] = e[n] + a * (t[n] - e[n]);
          return i;
        }
        e === void 0 && (e = 0);
        var o = BMMath.random();
        return e + o * (t - e);
      }
      function createPath(e, t, n, s) {
        var i, a = e.length, o = shapePool.newElement();
        o.setPathData(!!s, a);
        var l = [0, 0], c, u;
        for (i = 0; i < a; i += 1)
          c = t && t[i] ? t[i] : l, u = n && n[i] ? n[i] : l, o.setTripleAt(e[i][0], e[i][1], u[0] + e[i][0], u[1] + e[i][1], c[0] + e[i][0], c[1] + e[i][1], i, !0);
        return o;
      }
      function initiateExpression(elem, data, property) {
        function noOp(e) {
          return e;
        }
        if (!elem.globalData.renderConfig.runExpressions)
          return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
          get: function() {
            return thisProperty.v;
          }
        }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = function e(t, n) {
          var s, i, a = this.pv.length ? this.pv.length : 1, o = createTypedArray("float32", a);
          t = 5;
          var l = Math.floor(time * t);
          for (s = 0, i = 0; s < l; ) {
            for (i = 0; i < a; i += 1)
              o[i] += -n + n * 2 * BMMath.random();
            s += 1;
          }
          var c = time * t, u = c - Math.floor(c), d = createTypedArray("float32", a);
          if (a > 1) {
            for (i = 0; i < a; i += 1)
              d[i] = this.pv[i] + o[i] + (-n + n * 2 * BMMath.random()) * u;
            return d;
          }
          return this.pv + o[0] + (-n + n * 2 * BMMath.random()) * u;
        }.bind(this);
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
        function loopInDuration(e, t) {
          return loopIn(e, t, !0);
        }
        function loopOutDuration(e, t) {
          return loopOut(e, t, !0);
        }
        this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
        function lookAt(e, t) {
          var n = [t[0] - e[0], t[1] - e[1], t[2] - e[2]], s = Math.atan2(n[0], Math.sqrt(n[1] * n[1] + n[2] * n[2])) / degToRads, i = -Math.atan2(n[1], n[2]) / degToRads;
          return [i, s, 0];
        }
        function easeOut(e, t, n, s, i) {
          return applyEase(easeOutBez, e, t, n, s, i);
        }
        function easeIn(e, t, n, s, i) {
          return applyEase(easeInBez, e, t, n, s, i);
        }
        function ease(e, t, n, s, i) {
          return applyEase(easeInOutBez, e, t, n, s, i);
        }
        function applyEase(e, t, n, s, i, a) {
          i === void 0 ? (i = n, a = s) : t = (t - n) / (s - n), t > 1 ? t = 1 : t < 0 && (t = 0);
          var o = e(t);
          if ($bm_isInstanceOfArray(i)) {
            var l, c = i.length, u = createTypedArray("float32", c);
            for (l = 0; l < c; l += 1)
              u[l] = (a[l] - i[l]) * o + i[l];
            return u;
          }
          return (a - i) * o + i;
        }
        function nearestKey(e) {
          var t, n = data.k.length, s, i;
          if (!data.k.length || typeof data.k[0] == "number")
            s = 0, i = 0;
          else if (s = -1, e *= elem.comp.globalData.frameRate, e < data.k[0].t)
            s = 1, i = data.k[0].t;
          else {
            for (t = 0; t < n - 1; t += 1)
              if (e === data.k[t].t) {
                s = t + 1, i = data.k[t].t;
                break;
              } else if (e > data.k[t].t && e < data.k[t + 1].t) {
                e - data.k[t].t > data.k[t + 1].t - e ? (s = t + 2, i = data.k[t + 1].t) : (s = t + 1, i = data.k[t].t);
                break;
              }
            s === -1 && (s = t + 1, i = data.k[t].t);
          }
          var a = {};
          return a.index = s, a.time = i / elem.comp.globalData.frameRate, a;
        }
        function key(e) {
          var t, n, s;
          if (!data.k.length || typeof data.k[0] == "number")
            throw new Error("The property has no keyframe at index " + e);
          e -= 1, t = {
            time: data.k[e].t / elem.comp.globalData.frameRate,
            value: []
          };
          var i = Object.prototype.hasOwnProperty.call(data.k[e], "s") ? data.k[e].s : data.k[e - 1].e;
          for (s = i.length, n = 0; n < s; n += 1)
            t[n] = i[n], t.value[n] = i[n];
          return t;
        }
        function framesToTime(e, t) {
          return t || (t = elem.comp.globalData.frameRate), e / t;
        }
        function timeToFrames(e, t) {
          return !e && e !== 0 && (e = time), t || (t = elem.comp.globalData.frameRate), e * t;
        }
        function seedRandom(e) {
          BMMath.seedrandom(randSeed + e);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(e, t) {
          return typeof value == "string" ? t === void 0 ? value.substring(e) : value.substring(e, t) : "";
        }
        function substr(e, t) {
          return typeof value == "string" ? t === void 0 ? value.substr(e) : value.substr(e, t) : "";
        }
        function posterizeTime(e) {
          time = e === 0 ? 0 : Math.floor(time * e) / e, value = valueAtTime(time);
        }
        var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, hasParent = !!(elem.hierarchy && elem.hierarchy.length), parent, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
        function executeExpression(e) {
          return value = e, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), hasParent = !!(elem.hierarchy && elem.hierarchy.length), hasParent && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath], ob;
    }(), expressionHelpers = function() {
      function e(o, l, c) {
        l.x && (c.k = !0, c.x = !0, c.initiateExpression = ExpressionManager.initiateExpression, c.effectsSequence.push(c.initiateExpression(o, l, c).bind(c)));
      }
      function t(o) {
        return o *= this.elem.globalData.frameRate, o -= this.offsetTime, o !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < o ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(o, this._cachingAtTime), this._cachingAtTime.lastFrame = o), this._cachingAtTime.value;
      }
      function n(o) {
        var l = -0.01, c = this.getValueAtTime(o), u = this.getValueAtTime(o + l), d = 0;
        if (c.length) {
          var p;
          for (p = 0; p < c.length; p += 1)
            d += Math.pow(u[p] - c[p], 2);
          d = Math.sqrt(d) * 100;
        } else
          d = 0;
        return d;
      }
      function s(o) {
        if (this.vel !== void 0)
          return this.vel;
        var l = -1e-3, c = this.getValueAtTime(o), u = this.getValueAtTime(o + l), d;
        if (c.length) {
          d = createTypedArray("float32", c.length);
          var p;
          for (p = 0; p < c.length; p += 1)
            d[p] = (u[p] - c[p]) / l;
        } else
          d = (u - c) / l;
        return d;
      }
      function i() {
        return this.pv;
      }
      function a(o) {
        this.propertyGroup = o;
      }
      return {
        searchExpressions: e,
        getSpeedAtTime: n,
        getVelocityAtTime: s,
        getValueAtTime: t,
        getStaticValueAtTime: i,
        setGroupProperty: a
      };
    }();
    function addPropertyDecorator() {
      function e(f, g, C) {
        if (!this.k || !this.keyframes)
          return this.pv;
        f = f ? f.toLowerCase() : "";
        var k = this.comp.renderedFrame, M = this.keyframes, _ = M[M.length - 1].t;
        if (k <= _)
          return this.pv;
        var S, E;
        C ? (g ? S = Math.abs(_ - this.elem.comp.globalData.frameRate * g) : S = Math.max(0, _ - this.elem.data.ip), E = _ - S) : ((!g || g > M.length - 1) && (g = M.length - 1), E = M[M.length - 1 - g].t, S = _ - E);
        var P, $, A;
        if (f === "pingpong") {
          var I = Math.floor((k - E) / S);
          if (I % 2 !== 0)
            return this.getValueAtTime((S - (k - E) % S + E) / this.comp.globalData.frameRate, 0);
        } else if (f === "offset") {
          var D = this.getValueAtTime(E / this.comp.globalData.frameRate, 0), R = this.getValueAtTime(_ / this.comp.globalData.frameRate, 0), Y = this.getValueAtTime(((k - E) % S + E) / this.comp.globalData.frameRate, 0), q = Math.floor((k - E) / S);
          if (this.pv.length) {
            for (A = new Array(D.length), $ = A.length, P = 0; P < $; P += 1)
              A[P] = (R[P] - D[P]) * q + Y[P];
            return A;
          }
          return (R - D) * q + Y;
        } else if (f === "continue") {
          var j = this.getValueAtTime(_ / this.comp.globalData.frameRate, 0), X = this.getValueAtTime((_ - 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (A = new Array(j.length), $ = A.length, P = 0; P < $; P += 1)
              A[P] = j[P] + (j[P] - X[P]) * ((k - _) / this.comp.globalData.frameRate) / 5e-4;
            return A;
          }
          return j + (j - X) * ((k - _) / 1e-3);
        }
        return this.getValueAtTime(((k - E) % S + E) / this.comp.globalData.frameRate, 0);
      }
      function t(f, g, C) {
        if (!this.k)
          return this.pv;
        f = f ? f.toLowerCase() : "";
        var k = this.comp.renderedFrame, M = this.keyframes, _ = M[0].t;
        if (k >= _)
          return this.pv;
        var S, E;
        C ? (g ? S = Math.abs(this.elem.comp.globalData.frameRate * g) : S = Math.max(0, this.elem.data.op - _), E = _ + S) : ((!g || g > M.length - 1) && (g = M.length - 1), E = M[g].t, S = E - _);
        var P, $, A;
        if (f === "pingpong") {
          var I = Math.floor((_ - k) / S);
          if (I % 2 === 0)
            return this.getValueAtTime(((_ - k) % S + _) / this.comp.globalData.frameRate, 0);
        } else if (f === "offset") {
          var D = this.getValueAtTime(_ / this.comp.globalData.frameRate, 0), R = this.getValueAtTime(E / this.comp.globalData.frameRate, 0), Y = this.getValueAtTime((S - (_ - k) % S + _) / this.comp.globalData.frameRate, 0), q = Math.floor((_ - k) / S) + 1;
          if (this.pv.length) {
            for (A = new Array(D.length), $ = A.length, P = 0; P < $; P += 1)
              A[P] = Y[P] - (R[P] - D[P]) * q;
            return A;
          }
          return Y - (R - D) * q;
        } else if (f === "continue") {
          var j = this.getValueAtTime(_ / this.comp.globalData.frameRate, 0), X = this.getValueAtTime((_ + 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (A = new Array(j.length), $ = A.length, P = 0; P < $; P += 1)
              A[P] = j[P] + (j[P] - X[P]) * (_ - k) / 1e-3;
            return A;
          }
          return j + (j - X) * (_ - k) / 1e-3;
        }
        return this.getValueAtTime((S - ((_ - k) % S + _)) / this.comp.globalData.frameRate, 0);
      }
      function n(f, g) {
        if (!this.k)
          return this.pv;
        if (f = (f || 0.4) * 0.5, g = Math.floor(g || 5), g <= 1)
          return this.pv;
        var C = this.comp.renderedFrame / this.comp.globalData.frameRate, k = C - f, M = C + f, _ = g > 1 ? (M - k) / (g - 1) : 1, S = 0, E = 0, P;
        this.pv.length ? P = createTypedArray("float32", this.pv.length) : P = 0;
        for (var $; S < g; ) {
          if ($ = this.getValueAtTime(k + S * _), this.pv.length)
            for (E = 0; E < this.pv.length; E += 1)
              P[E] += $[E];
          else
            P += $;
          S += 1;
        }
        if (this.pv.length)
          for (E = 0; E < this.pv.length; E += 1)
            P[E] /= g;
        else
          P /= g;
        return P;
      }
      function s(f) {
        this._transformCachingAtTime || (this._transformCachingAtTime = {
          v: new Matrix()
        });
        var g = this._transformCachingAtTime.v;
        if (g.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var C = this.a.getValueAtTime(f);
          g.translate(-C[0] * this.a.mult, -C[1] * this.a.mult, C[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var k = this.s.getValueAtTime(f);
          g.scale(k[0] * this.s.mult, k[1] * this.s.mult, k[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var M = this.sk.getValueAtTime(f), _ = this.sa.getValueAtTime(f);
          g.skewFromAxis(-M * this.sk.mult, _ * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var S = this.r.getValueAtTime(f);
          g.rotate(-S * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var E = this.rz.getValueAtTime(f), P = this.ry.getValueAtTime(f), $ = this.rx.getValueAtTime(f), A = this.or.getValueAtTime(f);
          g.rotateZ(-E * this.rz.mult).rotateY(P * this.ry.mult).rotateX($ * this.rx.mult).rotateZ(-A[2] * this.or.mult).rotateY(A[1] * this.or.mult).rotateX(A[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var I = this.px.getValueAtTime(f), D = this.py.getValueAtTime(f);
          if (this.data.p.z) {
            var R = this.pz.getValueAtTime(f);
            g.translate(I * this.px.mult, D * this.py.mult, -R * this.pz.mult);
          } else
            g.translate(I * this.px.mult, D * this.py.mult, 0);
        } else {
          var Y = this.p.getValueAtTime(f);
          g.translate(Y[0] * this.p.mult, Y[1] * this.p.mult, -Y[2] * this.p.mult);
        }
        return g;
      }
      function i() {
        return this.v.clone(new Matrix());
      }
      var a = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(f, g, C) {
        var k = a(f, g, C);
        return k.dynamicProperties.length ? k.getValueAtTime = s.bind(k) : k.getValueAtTime = i.bind(k), k.setGroupProperty = expressionHelpers.setGroupProperty, k;
      };
      var o = PropertyFactory.getProp;
      PropertyFactory.getProp = function(f, g, C, k, M) {
        var _ = o(f, g, C, k, M);
        _.kf ? _.getValueAtTime = expressionHelpers.getValueAtTime.bind(_) : _.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(_), _.setGroupProperty = expressionHelpers.setGroupProperty, _.loopOut = e, _.loopIn = t, _.smooth = n, _.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(_), _.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(_), _.numKeys = g.a === 1 ? g.k.length : 0, _.propertyIndex = g.ix;
        var S = 0;
        return C !== 0 && (S = createTypedArray("float32", g.a === 1 ? g.k[0].s.length : g.k.length)), _._cachingAtTime = {
          lastFrame: initialDefaultFrame,
          lastIndex: 0,
          value: S
        }, expressionHelpers.searchExpressions(f, g, _), _.k && M.addDynamicProperty(_), _;
      };
      function l(f) {
        return this._cachingAtTime || (this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        }), f *= this.elem.globalData.frameRate, f -= this.offsetTime, f !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < f ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = f, this.interpolateShape(f, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }
      var c = ShapePropertyFactory.getConstructorFunction(), u = ShapePropertyFactory.getKeyframedConstructorFunction();
      function d() {
      }
      d.prototype = {
        vertices: function(g, C) {
          this.k && this.getValue();
          var k = this.v;
          C !== void 0 && (k = this.getValueAtTime(C, 0));
          var M, _ = k._length, S = k[g], E = k.v, P = createSizedArray(_);
          for (M = 0; M < _; M += 1)
            g === "i" || g === "o" ? P[M] = [S[M][0] - E[M][0], S[M][1] - E[M][1]] : P[M] = [S[M][0], S[M][1]];
          return P;
        },
        points: function(g) {
          return this.vertices("v", g);
        },
        inTangents: function(g) {
          return this.vertices("i", g);
        },
        outTangents: function(g) {
          return this.vertices("o", g);
        },
        isClosed: function() {
          return this.v.c;
        },
        pointOnPath: function(g, C) {
          var k = this.v;
          C !== void 0 && (k = this.getValueAtTime(C, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(k));
          for (var M = this._segmentsLength, _ = M.lengths, S = M.totalLength * g, E = 0, P = _.length, $ = 0, A; E < P; ) {
            if ($ + _[E].addedLength > S) {
              var I = E, D = k.c && E === P - 1 ? 0 : E + 1, R = (S - $) / _[E].addedLength;
              A = bez.getPointInSegment(k.v[I], k.v[D], k.o[I], k.i[D], R, _[E]);
              break;
            } else
              $ += _[E].addedLength;
            E += 1;
          }
          return A || (A = k.c ? [k.v[0][0], k.v[0][1]] : [k.v[k._length - 1][0], k.v[k._length - 1][1]]), A;
        },
        vectorOnPath: function(g, C, k) {
          g == 1 ? g = this.v.c : g == 0 && (g = 0.999);
          var M = this.pointOnPath(g, C), _ = this.pointOnPath(g + 1e-3, C), S = _[0] - M[0], E = _[1] - M[1], P = Math.sqrt(Math.pow(S, 2) + Math.pow(E, 2));
          if (P === 0)
            return [0, 0];
          var $ = k === "tangent" ? [S / P, E / P] : [-E / P, S / P];
          return $;
        },
        tangentOnPath: function(g, C) {
          return this.vectorOnPath(g, C, "tangent");
        },
        normalOnPath: function(g, C) {
          return this.vectorOnPath(g, C, "normal");
        },
        setGroupProperty: expressionHelpers.setGroupProperty,
        getValueAtTime: expressionHelpers.getStaticValueAtTime
      }, extendPrototype([d], c), extendPrototype([d], u), u.prototype.getValueAtTime = l, u.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var p = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(f, g, C, k, M) {
        var _ = p(f, g, C, k, M);
        return _.propertyIndex = g.ix, _.lock = !1, C === 3 ? expressionHelpers.searchExpressions(f, g.pt, _) : C === 4 && expressionHelpers.searchExpressions(f, g.ks, _), _.k && f.addDynamicProperty(_), _;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      function e() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      }
      TextProperty.prototype.getExpressionValue = function(t, n) {
        var s = this.calculateExpression(n);
        if (t.t !== s) {
          var i = {};
          return this.copyData(i, t), i.t = s.toString(), i.__complete = !1, i;
        }
        return t;
      }, TextProperty.prototype.searchProperty = function() {
        var t = this.searchKeyframes(), n = this.searchExpressions();
        return this.kf = t || n, this.kf;
      }, TextProperty.prototype.searchExpressions = e;
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = {
      createMergeNode: function e(t, n) {
        var s = createNS("feMerge");
        s.setAttribute("result", t);
        var i, a;
        for (a = 0; a < n.length; a += 1)
          i = createNS("feMergeNode"), i.setAttribute("in", n[a]), s.appendChild(i), s.appendChild(i);
        return s;
      }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(e, t, n, s, i) {
      this.filterManager = t;
      var a = createNS("feColorMatrix");
      a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "linearRGB"), a.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = a, a.setAttribute("result", s + "_tint_1"), e.appendChild(a), a = createNS("feColorMatrix"), a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a.setAttribute("result", s + "_tint_2"), e.appendChild(a), this.matrixFilter = a;
      var o = this.createMergeNode(s, [i, s + "_tint_1", s + "_tint_2"]);
      e.appendChild(o);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, s = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + s + " 0"), this.matrixFilter.setAttribute("values", n[0] - t[0] + " 0 0 0 " + t[0] + " " + (n[1] - t[1]) + " 0 0 0 " + t[1] + " " + (n[2] - t[2]) + " 0 0 0 " + t[2] + " 0 0 0 1 0");
      }
    };
    function SVGFillFilter(e, t, n, s) {
      this.filterManager = t;
      var i = createNS("feColorMatrix");
      i.setAttribute("type", "matrix"), i.setAttribute("color-interpolation-filters", "sRGB"), i.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), i.setAttribute("result", s), e.appendChild(i), this.matrixFilter = i;
    }
    SVGFillFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[2].p.v, n = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + t[0] + " 0 0 0 0 " + t[1] + " 0 0 0 0 " + t[2] + " 0 0 0 " + n + " 0");
      }
    };
    function SVGStrokeEffect(e, t, n) {
      this.initialized = !1, this.filterManager = t, this.elem = n, this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
      var e = this.elem.layerElement.children || this.elem.layerElement.childNodes, t, n, s, i;
      for (this.filterManager.effectElements[1].p.v === 1 ? (i = this.elem.maskManager.masksProperties.length, s = 0) : (s = this.filterManager.effectElements[0].p.v - 1, i = s + 1), n = createNS("g"), n.setAttribute("fill", "none"), n.setAttribute("stroke-linecap", "round"), n.setAttribute("stroke-dashoffset", 1), s; s < i; s += 1)
        t = createNS("path"), n.appendChild(t), this.paths.push({
          p: t,
          m: s
        });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var a = createNS("mask"), o = createElementID();
        a.setAttribute("id", o), a.setAttribute("mask-type", "alpha"), a.appendChild(n), this.elem.globalData.defs.appendChild(a);
        var l = createNS("g");
        for (l.setAttribute("mask", "url(" + getLocationHref() + "#" + o + ")"); e[0]; )
          l.appendChild(e[0]);
        this.elem.layerElement.appendChild(l), this.masker = a, n.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2)
          for (e = this.elem.layerElement.children || this.elem.layerElement.childNodes; e.length; )
            this.elem.layerElement.removeChild(e[0]);
        this.elem.layerElement.appendChild(n), this.elem.layerElement.removeAttribute("mask"), n.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = n;
    }, SVGStrokeEffect.prototype.renderFrame = function(e) {
      this.initialized || this.initialize();
      var t, n = this.paths.length, s, i;
      for (t = 0; t < n; t += 1)
        if (this.paths[t].m !== -1 && (s = this.elem.maskManager.viewData[this.paths[t].m], i = this.paths[t].p, (e || this.filterManager._mdf || s.prop._mdf) && i.setAttribute("d", s.lastPath), e || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || s.prop._mdf)) {
          var a;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var o = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, l = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, c = i.getTotalLength();
            a = "0 0 0 " + c * o + " ";
            var u = c * (l - o), d = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01, p = Math.floor(u / d), f;
            for (f = 0; f < p; f += 1)
              a += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
            a += "0 " + c * 10 + " 0 0";
          } else
            a = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          i.setAttribute("stroke-dasharray", a);
        }
      if ((e || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2), (e || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (e || this.filterManager.effectElements[3].p._mdf)) {
        var g = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(g[0] * 255) + "," + bmFloor(g[1] * 255) + "," + bmFloor(g[2] * 255) + ")");
      }
    };
    function SVGTritoneFilter(e, t, n, s) {
      this.filterManager = t;
      var i = createNS("feColorMatrix");
      i.setAttribute("type", "matrix"), i.setAttribute("color-interpolation-filters", "linearRGB"), i.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), e.appendChild(i);
      var a = createNS("feComponentTransfer");
      a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", s), this.matrixFilter = a;
      var o = createNS("feFuncR");
      o.setAttribute("type", "table"), a.appendChild(o), this.feFuncR = o;
      var l = createNS("feFuncG");
      l.setAttribute("type", "table"), a.appendChild(l), this.feFuncG = l;
      var c = createNS("feFuncB");
      c.setAttribute("type", "table"), a.appendChild(c), this.feFuncB = c, e.appendChild(a);
    }
    SVGTritoneFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = this.filterManager.effectElements[0].p.v, n = this.filterManager.effectElements[1].p.v, s = this.filterManager.effectElements[2].p.v, i = s[0] + " " + n[0] + " " + t[0], a = s[1] + " " + n[1] + " " + t[1], o = s[2] + " " + n[2] + " " + t[2];
        this.feFuncR.setAttribute("tableValues", i), this.feFuncG.setAttribute("tableValues", a), this.feFuncB.setAttribute("tableValues", o);
      }
    };
    function SVGProLevelsFilter(e, t, n, s) {
      this.filterManager = t;
      var i = this.filterManager.effectElements, a = createNS("feComponentTransfer");
      (i[10].p.k || i[10].p.v !== 0 || i[11].p.k || i[11].p.v !== 1 || i[12].p.k || i[12].p.v !== 1 || i[13].p.k || i[13].p.v !== 0 || i[14].p.k || i[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", a)), (i[17].p.k || i[17].p.v !== 0 || i[18].p.k || i[18].p.v !== 1 || i[19].p.k || i[19].p.v !== 1 || i[20].p.k || i[20].p.v !== 0 || i[21].p.k || i[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", a)), (i[24].p.k || i[24].p.v !== 0 || i[25].p.k || i[25].p.v !== 1 || i[26].p.k || i[26].p.v !== 1 || i[27].p.k || i[27].p.v !== 0 || i[28].p.k || i[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", a)), (i[31].p.k || i[31].p.v !== 0 || i[32].p.k || i[32].p.v !== 1 || i[33].p.k || i[33].p.v !== 1 || i[34].p.k || i[34].p.v !== 0 || i[35].p.k || i[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", a)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (a.setAttribute("color-interpolation-filters", "sRGB"), e.appendChild(a)), (i[3].p.k || i[3].p.v !== 0 || i[4].p.k || i[4].p.v !== 1 || i[5].p.k || i[5].p.v !== 1 || i[6].p.k || i[6].p.v !== 0 || i[7].p.k || i[7].p.v !== 1) && (a = createNS("feComponentTransfer"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", s), e.appendChild(a), this.feFuncRComposed = this.createFeFunc("feFuncR", a), this.feFuncGComposed = this.createFeFunc("feFuncG", a), this.feFuncBComposed = this.createFeFunc("feFuncB", a));
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(e, t) {
      var n = createNS(e);
      return n.setAttribute("type", "table"), t.appendChild(n), n;
    }, SVGProLevelsFilter.prototype.getTableValue = function(e, t, n, s, i) {
      for (var a = 0, o = 256, l, c = Math.min(e, t), u = Math.max(e, t), d = Array.call(null, {
        length: o
      }), p, f = 0, g = i - s, C = t - e; a <= 256; )
        l = a / 256, l <= c ? p = C < 0 ? i : s : l >= u ? p = C < 0 ? s : i : p = s + g * Math.pow((l - e) / C, 1 / n), d[f] = p, f += 1, a += 256 / (o - 1);
      return d.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t, n = this.filterManager.effectElements;
        this.feFuncRComposed && (e || n[3].p._mdf || n[4].p._mdf || n[5].p._mdf || n[6].p._mdf || n[7].p._mdf) && (t = this.getTableValue(n[3].p.v, n[4].p.v, n[5].p.v, n[6].p.v, n[7].p.v), this.feFuncRComposed.setAttribute("tableValues", t), this.feFuncGComposed.setAttribute("tableValues", t), this.feFuncBComposed.setAttribute("tableValues", t)), this.feFuncR && (e || n[10].p._mdf || n[11].p._mdf || n[12].p._mdf || n[13].p._mdf || n[14].p._mdf) && (t = this.getTableValue(n[10].p.v, n[11].p.v, n[12].p.v, n[13].p.v, n[14].p.v), this.feFuncR.setAttribute("tableValues", t)), this.feFuncG && (e || n[17].p._mdf || n[18].p._mdf || n[19].p._mdf || n[20].p._mdf || n[21].p._mdf) && (t = this.getTableValue(n[17].p.v, n[18].p.v, n[19].p.v, n[20].p.v, n[21].p.v), this.feFuncG.setAttribute("tableValues", t)), this.feFuncB && (e || n[24].p._mdf || n[25].p._mdf || n[26].p._mdf || n[27].p._mdf || n[28].p._mdf) && (t = this.getTableValue(n[24].p.v, n[25].p.v, n[26].p.v, n[27].p.v, n[28].p.v), this.feFuncB.setAttribute("tableValues", t)), this.feFuncA && (e || n[31].p._mdf || n[32].p._mdf || n[33].p._mdf || n[34].p._mdf || n[35].p._mdf) && (t = this.getTableValue(n[31].p.v, n[32].p.v, n[33].p.v, n[34].p.v, n[35].p.v), this.feFuncA.setAttribute("tableValues", t));
      }
    };
    function SVGDropShadowEffect(e, t, n, s, i) {
      var a = t.container.globalData.renderConfig.filterSize, o = t.data.fs || a;
      e.setAttribute("x", o.x || a.x), e.setAttribute("y", o.y || a.y), e.setAttribute("width", o.width || a.width), e.setAttribute("height", o.height || a.height), this.filterManager = t;
      var l = createNS("feGaussianBlur");
      l.setAttribute("in", "SourceAlpha"), l.setAttribute("result", s + "_drop_shadow_1"), l.setAttribute("stdDeviation", "0"), this.feGaussianBlur = l, e.appendChild(l);
      var c = createNS("feOffset");
      c.setAttribute("dx", "25"), c.setAttribute("dy", "0"), c.setAttribute("in", s + "_drop_shadow_1"), c.setAttribute("result", s + "_drop_shadow_2"), this.feOffset = c, e.appendChild(c);
      var u = createNS("feFlood");
      u.setAttribute("flood-color", "#00ff00"), u.setAttribute("flood-opacity", "1"), u.setAttribute("result", s + "_drop_shadow_3"), this.feFlood = u, e.appendChild(u);
      var d = createNS("feComposite");
      d.setAttribute("in", s + "_drop_shadow_3"), d.setAttribute("in2", s + "_drop_shadow_2"), d.setAttribute("operator", "in"), d.setAttribute("result", s + "_drop_shadow_4"), e.appendChild(d);
      var p = this.createMergeNode(s, [s + "_drop_shadow_4", i]);
      e.appendChild(p);
    }
    extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        if ((e || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), e || this.filterManager.effectElements[0].p._mdf) {
          var t = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(t[0] * 255), Math.round(t[1] * 255), Math.round(t[2] * 255)));
        }
        if ((e || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), e || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var n = this.filterManager.effectElements[3].p.v, s = (this.filterManager.effectElements[2].p.v - 90) * degToRads, i = n * Math.cos(s), a = n * Math.sin(s);
          this.feOffset.setAttribute("dx", i), this.feOffset.setAttribute("dy", a);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(e, t, n) {
      this.initialized = !1, this.filterManager = t, this.filterElem = e, this.elem = n, n.matteElement = createNS("g"), n.matteElement.appendChild(n.layerElement), n.matteElement.appendChild(n.transformedElement), n.baseElement = n.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(e) {
      for (var t = 0, n = _svgMatteSymbols.length; t < n; ) {
        if (_svgMatteSymbols[t] === e)
          return _svgMatteSymbols[t];
        t += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(e, t) {
      var n = e.layerElement.parentNode;
      if (n) {
        for (var s = n.children, i = 0, a = s.length; i < a && s[i] !== e.layerElement; )
          i += 1;
        var o;
        i <= a - 2 && (o = s[i + 1]);
        var l = createNS("use");
        l.setAttribute("href", "#" + t), o ? n.insertBefore(l, o) : n.appendChild(l);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(e, t) {
      if (!this.findSymbol(t)) {
        var n = createElementID(), s = createNS("mask");
        s.setAttribute("id", t.layerId), s.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(t);
        var i = e.globalData.defs;
        i.appendChild(s);
        var a = createNS("symbol");
        a.setAttribute("id", n), this.replaceInParent(t, n), a.appendChild(t.layerElement), i.appendChild(a);
        var o = createNS("use");
        o.setAttribute("href", "#" + n), s.appendChild(o), t.data.hd = !1, t.show();
      }
      e.setMatte(t.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var e = this.filterManager.effectElements[0].p.v, t = this.elem.comp.elements, n = 0, s = t.length; n < s; )
        t[n] && t[n].data.ind === e && this.setElementAsMask(this.elem, t[n]), n += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    };
    function SVGGaussianBlurEffect(e, t, n, s) {
      e.setAttribute("x", "-100%"), e.setAttribute("y", "-100%"), e.setAttribute("width", "300%"), e.setAttribute("height", "300%"), this.filterManager = t;
      var i = createNS("feGaussianBlur");
      i.setAttribute("result", s), e.appendChild(i), this.feGaussianBlur = i;
    }
    return SVGGaussianBlurEffect.prototype.renderFrame = function(e) {
      if (e || this.filterManager._mdf) {
        var t = 0.3, n = this.filterManager.effectElements[0].p.v * t, s = this.filterManager.effectElements[1].p.v, i = s == 3 ? 0 : n, a = s == 2 ? 0 : n;
        this.feGaussianBlur.setAttribute("stdDeviation", i + " " + a);
        var o = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", o);
      }
    }, registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect(20, SVGTintFilter, !0), registerEffect(21, SVGFillFilter, !0), registerEffect(22, SVGStrokeEffect, !1), registerEffect(23, SVGTritoneFilter, !0), registerEffect(24, SVGProLevelsFilter, !0), registerEffect(25, SVGDropShadowEffect, !0), registerEffect(28, SVGMatte3Effect, !1), registerEffect(29, SVGGaussianBlurEffect, !0), lottie;
  });
})(lottie, lottieExports);
const Lottie = lottieExports, _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "LottieIcon",
  props: {
    lottieJson: null,
    loop: { type: Boolean, default: !0 },
    autoPlay: { type: Boolean, default: !0 },
    speed: { default: 1 }
  },
  emits: ["onComplete", "onLoopComplete"],
  setup(e, { expose: t, emit: n }) {
    const s = e, i = ref(), a = ref(), o = (g) => {
      a.value = Lottie.loadAnimation({
        container: g,
        renderer: "svg",
        loop: s.loop,
        animationData: s.lottieJson,
        autoplay: s.autoPlay
      }), a.value.addEventListener("complete", () => {
        n("onComplete");
      }), a.value.addEventListener("loopComplete", () => {
        n("onLoopComplete");
      });
    };
    onMounted(() => {
      i.value && o(i.value);
    });
    const l = () => {
      a.value && a.value.play();
    }, c = () => {
      a.value && a.value.stop();
    }, u = () => {
      a.value && a.value.pause();
    }, d = (g) => {
      a.value && a.value.setSpeed(g);
    }, p = (g) => {
      a.value && a.value.setDirection(g);
    }, f = () => {
      a.value && a.value.destroy();
    };
    return onBeforeUnmount(() => {
      f();
    }), t({
      play: l,
      stop: c,
      pause: u,
      setSpeed: d,
      reverseAnimation: p
    }), (g, C) => (openBlock(), createElementBlock("div", {
      "data-testid": "lottie-icon",
      ref_key: "lottieContainer",
      ref: i,
      class: "w-full h-auto"
    }, null, 512));
  }
});
var script$1 = defineComponent({
  name: "SingleOtpInput",
  props: {
    inputType: {
      type: String,
      validator: (e) => ["number", "tel", "letter-numeric", "password"].includes(e),
      default: "tel"
    },
    inputmode: {
      type: String,
      default: "numeric"
    },
    value: {
      type: [String, Number]
    },
    separator: {
      type: String
    },
    focus: {
      type: Boolean
    },
    inputClasses: {
      type: [String, Array]
    },
    conditionalClass: {
      type: String
    },
    shouldAutoFocus: {
      type: Boolean
    },
    isLastChild: {
      type: Boolean
    },
    placeholder: {
      type: String
    },
    isDisabled: {
      type: Boolean
    }
  },
  emits: ["on-change", "on-keydown", "on-paste", "on-focus", "on-blur"],
  setup(e, t) {
    let {
      emit: n
    } = t;
    const s = ref(e.value || ""), i = ref(null), a = () => (s.value = s.value.toString(), s.value.length > 1 && (s.value = s.value.slice(0, 1)), n("on-change", s.value)), o = (f) => f >= 65 && f <= 90, l = (f) => f >= 48 && f <= 57 || f >= 96 && f <= 105, c = (f) => {
      e.isDisabled && f.preventDefault();
      const g = f || window.event, C = g.which ? g.which : g.keyCode;
      l(C) || e.inputType === "letter-numeric" && o(C) || [8, 9, 13, 37, 39, 46, 86].includes(C) ? n("on-keydown", f) : g.preventDefault();
    }, u = (f) => n("on-paste", f), d = () => (i.value.select(), n("on-focus")), p = () => n("on-blur");
    return watch(() => e.value, (f, g) => {
      f !== g && (s.value = f);
    }), watch(() => e.focus, (f, g) => {
      g !== f && i.value && e.focus && (i.value.focus(), i.value.select());
    }), onMounted(() => {
      i.value && e.focus && e.shouldAutoFocus && (i.value.focus(), i.value.select());
    }), {
      handleOnChange: a,
      handleOnKeyDown: c,
      handleOnPaste: u,
      handleOnFocus: d,
      handleOnBlur: p,
      input: i,
      model: s,
      inputTypeValue: e.inputType === "letter-numeric" ? "text" : e.inputType
    };
  }
});
const _hoisted_1$1$1 = {
  style: {
    display: "flex",
    "align-items": "center"
  }
}, _hoisted_2$1$1 = ["type", "inputmode", "placeholder", "disabled"], _hoisted_3$b = {
  key: 0
}, _hoisted_4$3 = ["innerHTML"];
function render$1(e, t, n, s, i, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$1$1, [withDirectives(createElementVNode("input", {
    type: e.inputTypeValue,
    inputmode: e.inputmode,
    placeholder: e.placeholder,
    disabled: e.isDisabled,
    ref: "input",
    min: "0",
    max: "9",
    maxlength: "1",
    pattern: "[0-9]",
    "onUpdate:modelValue": t[0] || (t[0] = (o) => e.model = o),
    class: normalizeClass([e.inputClasses, e.conditionalClass, {
      "is-complete": e.model
    }]),
    onInput: t[1] || (t[1] = function() {
      return e.handleOnChange && e.handleOnChange(...arguments);
    }),
    onKeydown: t[2] || (t[2] = function() {
      return e.handleOnKeyDown && e.handleOnKeyDown(...arguments);
    }),
    onPaste: t[3] || (t[3] = function() {
      return e.handleOnPaste && e.handleOnPaste(...arguments);
    }),
    onFocus: t[4] || (t[4] = function() {
      return e.handleOnFocus && e.handleOnFocus(...arguments);
    }),
    onBlur: t[5] || (t[5] = function() {
      return e.handleOnBlur && e.handleOnBlur(...arguments);
    })
  }, null, 42, _hoisted_2$1$1), [[vModelDynamic, e.model]]), !e.isLastChild && e.separator ? (openBlock(), createElementBlock("span", _hoisted_3$b, [createElementVNode("span", {
    innerHTML: e.separator
  }, null, 8, _hoisted_4$3)])) : createCommentVNode("", !0)]);
}
script$1.render = render$1;
const BACKSPACE = 8, LEFT_ARROW = 37, RIGHT_ARROW = 39, DELETE = 46;
var script = /* @__PURE__ */ defineComponent({
  name: "Vue3OtpInput",
  components: {
    SingleOtpInput: script$1
  },
  props: {
    numInputs: {
      default: 4
    },
    separator: {
      type: String,
      default: "**"
    },
    inputClasses: {
      type: [String, Array]
    },
    conditionalClass: {
      type: Array,
      default: []
    },
    inputType: {
      type: String,
      validator: (e) => ["number", "tel", "letter-numeric", "password"].includes(e)
    },
    inputmode: {
      type: String,
      validator: (e) => ["numeric", "text", "tel", "none"].includes(e),
      default: "numeric"
    },
    shouldAutoFocus: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: Array,
      default: []
    },
    isDisabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, t) {
    let {
      emit: n
    } = t;
    const s = ref(0), i = ref([]), a = ref([]), o = (_) => {
      s.value = _;
    }, l = () => {
      s.value = -1;
    }, c = () => i.value.join("").length === e.numInputs ? n("on-complete", i.value.join("")) : "Wait until the user enters the required number of characters", u = (_) => {
      s.value = Math.max(Math.min(e.numInputs - 1, _), 0);
    }, d = () => {
      u(s.value + 1);
    }, p = () => {
      u(s.value - 1);
    }, f = (_) => {
      a.value = Object.assign([], i.value), i.value[s.value] = _, a.value.join("") !== i.value.join("") && (n("on-change", i.value.join("")), c());
    };
    return {
      activeInput: s,
      otp: i,
      oldOtp: a,
      clearInput: () => {
        i.value.length > 0 && n("on-change", ""), i.value = [], s.value = 0;
      },
      handleOnPaste: (_) => {
        _.preventDefault();
        const S = _.clipboardData.getData("text/plain").slice(0, e.numInputs - s.value).split("");
        if (e.inputType === "number" && !S.join("").match(/^\d+$/) || e.inputType === "letter-numeric" && !S.join("").match(/^\w+$/))
          return "Invalid pasted data";
        const P = i.value.slice(0, s.value).concat(S);
        return P.slice(0, e.numInputs).forEach(function($, A) {
          i.value[A] = $;
        }), u(P.slice(0, e.numInputs).length), c();
      },
      handleOnKeyDown: (_) => {
        switch (_.keyCode) {
          case BACKSPACE:
            _.preventDefault(), f(""), p();
            break;
          case DELETE:
            _.preventDefault(), f("");
            break;
          case LEFT_ARROW:
            _.preventDefault(), p();
            break;
          case RIGHT_ARROW:
            _.preventDefault(), d();
            break;
        }
      },
      handleOnBlur: l,
      changeCodeAtFocus: f,
      focusInput: u,
      focusNextInput: d,
      focusPrevInput: p,
      handleOnFocus: o,
      checkFilledAllInputs: c,
      handleOnChange: (_) => {
        f(_), d();
      }
    };
  }
});
const _hoisted_1$h = {
  style: {
    display: "flex"
  }
}, _hoisted_2$d = {
  key: 0,
  autocomplete: "off",
  name: "hidden",
  type: "text",
  style: {
    display: "none"
  }
};
function render$2(e, t, n, s, i, a) {
  const o = resolveComponent("SingleOtpInput");
  return openBlock(), createElementBlock("div", _hoisted_1$h, [e.inputType === "password" ? (openBlock(), createElementBlock("input", _hoisted_2$d)) : createCommentVNode("", !0), (openBlock(!0), createElementBlock(Fragment, null, renderList(e.numInputs, (l, c) => (openBlock(), createBlock(o, {
    key: c,
    focus: e.activeInput === c,
    value: e.otp[c],
    separator: e.separator,
    "input-type": e.inputType,
    inputmode: e.inputmode,
    "input-classes": e.inputClasses,
    conditionalClass: e.conditionalClass[c],
    "is-last-child": c === e.numInputs - 1,
    "should-auto-focus": e.shouldAutoFocus,
    placeholder: e.placeholder[c],
    "is-disabled": e.isDisabled,
    onOnChange: e.handleOnChange,
    onOnKeydown: e.handleOnKeyDown,
    onOnPaste: e.handleOnPaste,
    onOnFocus: (u) => e.handleOnFocus(c),
    onOnBlur: e.handleOnBlur
  }, null, 8, ["focus", "value", "separator", "input-type", "inputmode", "input-classes", "conditionalClass", "is-last-child", "should-auto-focus", "placeholder", "is-disabled", "onOnChange", "onOnKeydown", "onOnPaste", "onOnFocus", "onOnBlur"]))), 128))]);
}
script.render = render$2;
var entry_esm = /* @__PURE__ */ (() => {
  const e = script;
  return e.install = (t) => {
    t.component("Vue3OtpInput", e);
  }, e;
})();
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "PincodeField",
  props: {
    numberOfInputs: { default: 6 },
    isInvalid: { type: Boolean, default: !1 }
  },
  emits: ["onChange", "onComplete"],
  setup(e, { expose: t, emit: n }) {
    const s = e, i = ref(null);
    t({
      otpInputRef: i
    });
    const a = computed(
      () => s.isInvalid ? "border-red-300 focus:border-red-300 focus:border" : ""
    ), o = (c) => {
      n("onChange", c);
    }, l = (c) => {
      n("onComplete", c);
    };
    return (c, u) => (openBlock(), createBlock(unref(entry_esm), {
      ref_key: "otpInputRef",
      ref: i,
      "input-classes": `w-full py-3 px-2 indent-2 border rounded-8 h-14 border-grey-200 placeholder-black-40 caret-brand-orange text-black-90 text-xl focus:ring-0 focus:border-grey-900 focus:border-2 focus:outline-none ${unref(a)}`,
      separator: "",
      "num-inputs": e.numberOfInputs,
      "should-auto-focus": !0,
      "is-input-num": !0,
      placeholder: ["–", "–", "–", "–", "–", "–"],
      onOnChange: o,
      onOnComplete: l
    }, null, 8, ["input-classes", "num-inputs"]));
  }
}), _sfc_main$s = defineComponent({
  props: {
    width: {
      type: [Object, String],
      default: "full"
    },
    height: {
      type: [Object, String],
      default: "lg"
    },
    borderRadius: {
      type: String,
      default: "full"
    }
  },
  setup(e, { slots: t }) {
    var c;
    const n = useMediaMatch(), s = useResponsiveProp(
      e.width,
      n
    ), i = useResponsiveProp(
      e.height,
      n
    ), a = (c = t.default) == null ? void 0 : c.call(t), o = () => classMerge(
      "skeleton bg-black-7 after:bg-gradient-to-r after:from-transparent after:via-black-10 after:to-transparent",
      {
        ...e.borderRadius && mapBorderRadiusToClassName(e.borderRadius),
        ...s.value && mapSkeletonWidthToWidth(
          a ? "content" : s.value
        ),
        ...i.value && mapSkeletonHeightToHeight(
          a ? "content" : i.value
        )
      }
    ), l = () => classMerge("invisible");
    return () => h(_sfc_main$2K, { role: "status", class: o() }, () => (a || []).map((u) => {
      const d = l();
      return Array.isArray(u.children) ? u.children.map(
        (p) => h(p, { class: d })
      ) : h(u, { class: d });
    }));
  }
}), Skeleton_vue_vue_type_style_index_0_scoped_1782d4ae_lang = "", Skeleton = /* @__PURE__ */ _export_sfc$1(_sfc_main$s, [["__scopeId", "data-v-1782d4ae"]]), _hoisted_1$g = { key: 0 }, _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "Superscript",
  props: {
    text: null
  },
  setup(e) {
    return (t, n) => e.text ? (openBlock(), createElementBlock("sup", _hoisted_1$g, toDisplayString(e.text), 1)) : createCommentVNode("", !0);
  }
}), _sfc_main$q = /* @__PURE__ */ defineComponent({
  __name: "UnderlinedButton",
  props: {
    text: { default: "" }
  },
  setup(e) {
    return (t, n) => (openBlock(), createElementBlock("button", {
      class: "h-12 text-lg underline",
      onClick: n[0] || (n[0] = (s) => t.$emit("onClick")),
      type: "button"
    }, toDisplayString(e.text), 1));
  }
}), _hoisted_1$f = ["href"], _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "UnderlinedLink",
  props: {
    href: null
  },
  setup(e) {
    const t = e;
    return (n, s) => (openBlock(), createElementBlock("a", {
      href: t.href,
      class: "underline"
    }, [
      renderSlot(n.$slots, "default")
    ], 8, _hoisted_1$f));
  }
}), DATA_TEST_ID$2 = {
  INPUT: "toggle_input",
  INDICATOR: "toggle_indicator",
  BACKGROUND: "toggle_background",
  LABEL: "toggle_label"
}, _hoisted_1$e = ["id", "checked", "aria-checked", "aria-disabled", "aria-readonly", "disabled", "data-testid"], _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "Toggle",
  props: {
    id: null,
    showLabel: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    modelValue: { type: Boolean, default: !1 },
    value: { type: Boolean, default: void 0 }
  },
  emits: ["update:modelValue", "onChange"],
  setup(e, { emit: t }) {
    const n = e, s = ref(n.modelValue || n.value || !1);
    watch(
      () => n.modelValue,
      (c) => {
        s.value = c;
      }
    ), watch(
      () => n.value,
      (c) => {
        s.value = Boolean(c);
      }
    );
    const i = () => classMerge({
      "bg-black": s.value,
      "bg-gray-200": !s.value
    }), a = () => classMerge({
      "translate-x-[1.1rem]": s.value,
      "translate-x-0.5": !s.value
    }), o = () => classMerge("flex cursor-pointer items-center", {
      "opacity-50 cursor-not-allowed": n.disabled
    }), l = () => {
      s.value = !s.value, t("update:modelValue", s.value), t("onChange", s.value);
    };
    return (c, u) => (openBlock(), createBlock(_sfc_main$2x, {
      space: "md",
      "vertical-align": "center"
    }, {
      default: withCtx(() => [
        n.showLabel ? (openBlock(), createBlock(_sfc_main$2K, {
          key: 0,
          component: "label",
          for: n.id,
          class: "text-base",
          "data-testid": unref(DATA_TEST_ID$2).LABEL
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(s.value ? "On" : "Off"), 1)
          ]),
          _: 1
        }, 8, ["for", "data-testid"])) : createCommentVNode("", !0),
        createElementVNode("input", {
          id: n.id,
          class: "sr-only",
          type: "checkbox",
          checked: s.value,
          "aria-checked": s.value,
          "aria-disabled": n.disabled,
          "aria-readonly": n.disabled,
          onClick: l,
          disabled: n.disabled,
          "data-testid": unref(DATA_TEST_ID$2).INPUT
        }, null, 8, _hoisted_1$e),
        createVNode(_sfc_main$2K, {
          component: "label",
          for: n.id,
          "aria-disabled": e.disabled,
          class: normalizeClass(o())
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$2K, {
              class: normalizeClass([i(), "relative h-6 w-10 rounded-full"]),
              "data-testid": unref(DATA_TEST_ID$2).BACKGROUND
            }, {
              default: withCtx(() => [
                createVNode(_sfc_main$2K, {
                  class: normalizeClass([a(), "absolute top-1/2 transform -translate-y-1/2 h-5 w-5 bg-white rounded-full transition duration-200 ease-linear"]),
                  "data-testid": unref(DATA_TEST_ID$2).INDICATOR
                }, null, 8, ["class", "data-testid"])
              ]),
              _: 1
            }, 8, ["class", "data-testid"])
          ]),
          _: 1
        }, 8, ["for", "aria-disabled", "class"])
      ]),
      _: 1
    }));
  }
});
var __defProp$1 = Object.defineProperty, __getOwnPropSymbols = Object.getOwnPropertySymbols, __hasOwnProp = Object.prototype.hasOwnProperty, __propIsEnum = Object.prototype.propertyIsEnumerable, __defNormalProp$1 = (e, t, n) => t in e ? __defProp$1(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, __spreadValues = (e, t) => {
  for (var n in t || (t = {}))
    __hasOwnProp.call(t, n) && __defNormalProp$1(e, n, t[n]);
  if (__getOwnPropSymbols)
    for (var n of __getOwnPropSymbols(t))
      __propIsEnum.call(t, n) && __defNormalProp$1(e, n, t[n]);
  return e;
}, isFunction$5 = (e) => typeof e == "function", isString$1 = (e) => typeof e == "string", isNonEmptyString = (e) => isString$1(e) && e.trim().length > 0, isNumber$2 = (e) => typeof e == "number", isUndefined = (e) => typeof e > "u", isObject$c = (e) => typeof e == "object" && e !== null, isJSX = (e) => hasProp(e, "tag") && isNonEmptyString(e.tag), isTouchEvent = (e) => window.TouchEvent && e instanceof TouchEvent, isToastComponent = (e) => hasProp(e, "component") && isToastContent(e.component), isVueComponent = (e) => isFunction$5(e) || isObject$c(e), isToastContent = (e) => !isUndefined(e) && (isString$1(e) || isVueComponent(e) || isToastComponent(e)), isDOMRect = (e) => isObject$c(e) && ["height", "width", "right", "left", "top", "bottom"].every((t) => isNumber$2(e[t])), hasProp = (e, t) => (isObject$c(e) || isFunction$5(e)) && t in e, getId = ((e) => () => e++)(0);
function getX(e) {
  return isTouchEvent(e) ? e.targetTouches[0].clientX : e.clientX;
}
function getY(e) {
  return isTouchEvent(e) ? e.targetTouches[0].clientY : e.clientY;
}
var removeElement = (e) => {
  isUndefined(e.remove) ? e.parentNode && e.parentNode.removeChild(e) : e.remove();
}, getVueComponentFromObj = (e) => isToastComponent(e) ? getVueComponentFromObj(e.component) : isJSX(e) ? defineComponent({
  render() {
    return e;
  }
}) : typeof e == "string" ? e : toRaw(unref(e)), normalizeToastComponent = (e) => {
  if (typeof e == "string")
    return e;
  const t = hasProp(e, "props") && isObject$c(e.props) ? e.props : {}, n = hasProp(e, "listeners") && isObject$c(e.listeners) ? e.listeners : {};
  return { component: getVueComponentFromObj(e), props: t, listeners: n };
}, isBrowser = () => typeof window < "u", EventBus = class {
  constructor() {
    this.allHandlers = {};
  }
  getHandlers(e) {
    return this.allHandlers[e] || [];
  }
  on(e, t) {
    const n = this.getHandlers(e);
    n.push(t), this.allHandlers[e] = n;
  }
  off(e, t) {
    const n = this.getHandlers(e);
    n.splice(n.indexOf(t) >>> 0, 1);
  }
  emit(e, t) {
    this.getHandlers(e).forEach((s) => s(t));
  }
}, isEventBusInterface = (e) => ["on", "off", "emit"].every((t) => hasProp(e, t) && isFunction$5(e[t])), TYPE;
(function(e) {
  e.SUCCESS = "success", e.ERROR = "error", e.WARNING = "warning", e.INFO = "info", e.DEFAULT = "default";
})(TYPE || (TYPE = {}));
var POSITION;
(function(e) {
  e.TOP_LEFT = "top-left", e.TOP_CENTER = "top-center", e.TOP_RIGHT = "top-right", e.BOTTOM_LEFT = "bottom-left", e.BOTTOM_CENTER = "bottom-center", e.BOTTOM_RIGHT = "bottom-right";
})(POSITION || (POSITION = {}));
var EVENTS;
(function(e) {
  e.ADD = "add", e.DISMISS = "dismiss", e.UPDATE = "update", e.CLEAR = "clear", e.UPDATE_DEFAULTS = "update_defaults";
})(EVENTS || (EVENTS = {}));
var VT_NAMESPACE = "Vue-Toastification", COMMON = {
  type: {
    type: String,
    default: TYPE.DEFAULT
  },
  classNames: {
    type: [String, Array],
    default: () => []
  },
  trueBoolean: {
    type: Boolean,
    default: !0
  }
}, ICON = {
  type: COMMON.type,
  customIcon: {
    type: [String, Boolean, Object, Function],
    default: !0
  }
}, CLOSE_BUTTON = {
  component: {
    type: [String, Object, Function, Boolean],
    default: "button"
  },
  classNames: COMMON.classNames,
  showOnHover: {
    type: Boolean,
    default: !1
  },
  ariaLabel: {
    type: String,
    default: "close"
  }
}, PROGRESS_BAR = {
  timeout: {
    type: [Number, Boolean],
    default: 5e3
  },
  hideProgressBar: {
    type: Boolean,
    default: !1
  },
  isRunning: {
    type: Boolean,
    default: !1
  }
}, TRANSITION = {
  transition: {
    type: [Object, String],
    default: `${VT_NAMESPACE}__bounce`
  }
}, CORE_TOAST = {
  position: {
    type: String,
    default: POSITION.TOP_RIGHT
  },
  draggable: COMMON.trueBoolean,
  draggablePercent: {
    type: Number,
    default: 0.6
  },
  pauseOnFocusLoss: COMMON.trueBoolean,
  pauseOnHover: COMMON.trueBoolean,
  closeOnClick: COMMON.trueBoolean,
  timeout: PROGRESS_BAR.timeout,
  hideProgressBar: PROGRESS_BAR.hideProgressBar,
  toastClassName: COMMON.classNames,
  bodyClassName: COMMON.classNames,
  icon: ICON.customIcon,
  closeButton: CLOSE_BUTTON.component,
  closeButtonClassName: CLOSE_BUTTON.classNames,
  showCloseButtonOnHover: CLOSE_BUTTON.showOnHover,
  accessibility: {
    type: Object,
    default: () => ({
      toastRole: "alert",
      closeButtonLabel: "close"
    })
  },
  rtl: {
    type: Boolean,
    default: !1
  },
  eventBus: {
    type: Object,
    required: !1,
    default: () => new EventBus()
  }
}, TOAST = {
  id: {
    type: [String, Number],
    required: !0,
    default: 0
  },
  type: COMMON.type,
  content: {
    type: [String, Object, Function],
    required: !0,
    default: ""
  },
  onClick: {
    type: Function,
    default: void 0
  },
  onClose: {
    type: Function,
    default: void 0
  }
}, CONTAINER = {
  container: {
    type: [
      Object,
      Function
    ],
    default: () => document.body
  },
  newestOnTop: COMMON.trueBoolean,
  maxToasts: {
    type: Number,
    default: 20
  },
  transition: TRANSITION.transition,
  toastDefaults: Object,
  filterBeforeCreate: {
    type: Function,
    default: (e) => e
  },
  filterToasts: {
    type: Function,
    default: (e) => e
  },
  containerClassName: COMMON.classNames,
  onMounted: Function,
  shareAppContext: [Boolean, Object]
}, propValidators_default = {
  CORE_TOAST,
  TOAST,
  CONTAINER,
  PROGRESS_BAR,
  ICON,
  TRANSITION,
  CLOSE_BUTTON
}, VtProgressBar_default = defineComponent({
  name: "VtProgressBar",
  props: propValidators_default.PROGRESS_BAR,
  data() {
    return {
      hasClass: !0
    };
  },
  computed: {
    style() {
      return {
        animationDuration: `${this.timeout}ms`,
        animationPlayState: this.isRunning ? "running" : "paused",
        opacity: this.hideProgressBar ? 0 : 1
      };
    },
    cpClass() {
      return this.hasClass ? `${VT_NAMESPACE}__progress-bar` : "";
    }
  },
  watch: {
    timeout() {
      this.hasClass = !1, this.$nextTick(() => this.hasClass = !0);
    }
  },
  mounted() {
    this.$el.addEventListener("animationend", this.animationEnded);
  },
  beforeUnmount() {
    this.$el.removeEventListener("animationend", this.animationEnded);
  },
  methods: {
    animationEnded() {
      this.$emit("close-toast");
    }
  }
});
function render(e, t) {
  return openBlock(), createElementBlock("div", {
    style: normalizeStyle(e.style),
    class: normalizeClass(e.cpClass)
  }, null, 6);
}
VtProgressBar_default.render = render;
var VtProgressBar_default2 = VtProgressBar_default, VtCloseButton_default = defineComponent({
  name: "VtCloseButton",
  props: propValidators_default.CLOSE_BUTTON,
  computed: {
    buttonComponent() {
      return this.component !== !1 ? getVueComponentFromObj(this.component) : "button";
    },
    classes() {
      const e = [`${VT_NAMESPACE}__close-button`];
      return this.showOnHover && e.push("show-on-hover"), e.concat(this.classNames);
    }
  }
}), _hoisted_1$d = /* @__PURE__ */ createTextVNode(" × ");
function render2(e, t) {
  return openBlock(), createBlock(resolveDynamicComponent(e.buttonComponent), mergeProps({
    "aria-label": e.ariaLabel,
    class: e.classes
  }, e.$attrs), {
    default: withCtx(() => [
      _hoisted_1$d
    ]),
    _: 1
  }, 16, ["aria-label", "class"]);
}
VtCloseButton_default.render = render2;
var VtCloseButton_default2 = VtCloseButton_default, VtSuccessIcon_default = {}, _hoisted_12 = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "check-circle",
  class: "svg-inline--fa fa-check-circle fa-w-16",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, _hoisted_2$c = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
}, null, -1), _hoisted_3$a = [
  _hoisted_2$c
];
function render3(e, t) {
  return openBlock(), createElementBlock("svg", _hoisted_12, _hoisted_3$a);
}
VtSuccessIcon_default.render = render3;
var VtSuccessIcon_default2 = VtSuccessIcon_default, VtInfoIcon_default = {}, _hoisted_13 = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "info-circle",
  class: "svg-inline--fa fa-info-circle fa-w-16",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, _hoisted_22 = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
}, null, -1), _hoisted_32 = [
  _hoisted_22
];
function render4(e, t) {
  return openBlock(), createElementBlock("svg", _hoisted_13, _hoisted_32);
}
VtInfoIcon_default.render = render4;
var VtInfoIcon_default2 = VtInfoIcon_default, VtWarningIcon_default = {}, _hoisted_14 = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "exclamation-circle",
  class: "svg-inline--fa fa-exclamation-circle fa-w-16",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, _hoisted_23 = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
}, null, -1), _hoisted_33 = [
  _hoisted_23
];
function render5(e, t) {
  return openBlock(), createElementBlock("svg", _hoisted_14, _hoisted_33);
}
VtWarningIcon_default.render = render5;
var VtWarningIcon_default2 = VtWarningIcon_default, VtErrorIcon_default = {}, _hoisted_15 = {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "exclamation-triangle",
  class: "svg-inline--fa fa-exclamation-triangle fa-w-18",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 576 512"
}, _hoisted_24 = /* @__PURE__ */ createElementVNode("path", {
  fill: "currentColor",
  d: "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
}, null, -1), _hoisted_34 = [
  _hoisted_24
];
function render6(e, t) {
  return openBlock(), createElementBlock("svg", _hoisted_15, _hoisted_34);
}
VtErrorIcon_default.render = render6;
var VtErrorIcon_default2 = VtErrorIcon_default, VtIcon_default = defineComponent({
  name: "VtIcon",
  props: propValidators_default.ICON,
  computed: {
    customIconChildren() {
      return hasProp(this.customIcon, "iconChildren") ? this.trimValue(this.customIcon.iconChildren) : "";
    },
    customIconClass() {
      return isString$1(this.customIcon) ? this.trimValue(this.customIcon) : hasProp(this.customIcon, "iconClass") ? this.trimValue(this.customIcon.iconClass) : "";
    },
    customIconTag() {
      return hasProp(this.customIcon, "iconTag") ? this.trimValue(this.customIcon.iconTag, "i") : "i";
    },
    hasCustomIcon() {
      return this.customIconClass.length > 0;
    },
    component() {
      return this.hasCustomIcon ? this.customIconTag : isToastContent(this.customIcon) ? getVueComponentFromObj(this.customIcon) : this.iconTypeComponent;
    },
    iconTypeComponent() {
      return {
        [TYPE.DEFAULT]: VtInfoIcon_default2,
        [TYPE.INFO]: VtInfoIcon_default2,
        [TYPE.SUCCESS]: VtSuccessIcon_default2,
        [TYPE.ERROR]: VtErrorIcon_default2,
        [TYPE.WARNING]: VtWarningIcon_default2
      }[this.type];
    },
    iconClasses() {
      const e = [`${VT_NAMESPACE}__icon`];
      return this.hasCustomIcon ? e.concat(this.customIconClass) : e;
    }
  },
  methods: {
    trimValue(e, t = "") {
      return isNonEmptyString(e) ? e.trim() : t;
    }
  }
});
function render7(e, t) {
  return openBlock(), createBlock(resolveDynamicComponent(e.component), {
    class: normalizeClass(e.iconClasses)
  }, {
    default: withCtx(() => [
      createTextVNode(toDisplayString(e.customIconChildren), 1)
    ]),
    _: 1
  }, 8, ["class"]);
}
VtIcon_default.render = render7;
var VtIcon_default2 = VtIcon_default, VtToast_default = defineComponent({
  name: "VtToast",
  components: { ProgressBar: VtProgressBar_default2, CloseButton: VtCloseButton_default2, Icon: VtIcon_default2 },
  inheritAttrs: !1,
  props: Object.assign({}, propValidators_default.CORE_TOAST, propValidators_default.TOAST),
  data() {
    return {
      isRunning: !0,
      disableTransitions: !1,
      beingDragged: !1,
      dragStart: 0,
      dragPos: { x: 0, y: 0 },
      dragRect: {}
    };
  },
  computed: {
    classes() {
      const e = [
        `${VT_NAMESPACE}__toast`,
        `${VT_NAMESPACE}__toast--${this.type}`,
        `${this.position}`
      ].concat(this.toastClassName);
      return this.disableTransitions && e.push("disable-transition"), this.rtl && e.push(`${VT_NAMESPACE}__toast--rtl`), e;
    },
    bodyClasses() {
      return [
        `${VT_NAMESPACE}__toast-${isString$1(this.content) ? "body" : "component-body"}`
      ].concat(this.bodyClassName);
    },
    draggableStyle() {
      return this.dragStart === this.dragPos.x ? {} : this.beingDragged ? {
        transform: `translateX(${this.dragDelta}px)`,
        opacity: 1 - Math.abs(this.dragDelta / this.removalDistance)
      } : {
        transition: "transform 0.2s, opacity 0.2s",
        transform: "translateX(0)",
        opacity: 1
      };
    },
    dragDelta() {
      return this.beingDragged ? this.dragPos.x - this.dragStart : 0;
    },
    removalDistance() {
      return isDOMRect(this.dragRect) ? (this.dragRect.right - this.dragRect.left) * this.draggablePercent : 0;
    }
  },
  mounted() {
    this.draggable && this.draggableSetup(), this.pauseOnFocusLoss && this.focusSetup();
  },
  beforeUnmount() {
    this.draggable && this.draggableCleanup(), this.pauseOnFocusLoss && this.focusCleanup();
  },
  methods: {
    hasProp,
    getVueComponentFromObj,
    closeToast() {
      this.eventBus.emit(EVENTS.DISMISS, this.id);
    },
    clickHandler() {
      this.onClick && this.onClick(this.closeToast), this.closeOnClick && (!this.beingDragged || this.dragStart === this.dragPos.x) && this.closeToast();
    },
    timeoutHandler() {
      this.closeToast();
    },
    hoverPause() {
      this.pauseOnHover && (this.isRunning = !1);
    },
    hoverPlay() {
      this.pauseOnHover && (this.isRunning = !0);
    },
    focusPause() {
      this.isRunning = !1;
    },
    focusPlay() {
      this.isRunning = !0;
    },
    focusSetup() {
      addEventListener("blur", this.focusPause), addEventListener("focus", this.focusPlay);
    },
    focusCleanup() {
      removeEventListener("blur", this.focusPause), removeEventListener("focus", this.focusPlay);
    },
    draggableSetup() {
      const e = this.$el;
      e.addEventListener("touchstart", this.onDragStart, {
        passive: !0
      }), e.addEventListener("mousedown", this.onDragStart), addEventListener("touchmove", this.onDragMove, { passive: !1 }), addEventListener("mousemove", this.onDragMove), addEventListener("touchend", this.onDragEnd), addEventListener("mouseup", this.onDragEnd);
    },
    draggableCleanup() {
      const e = this.$el;
      e.removeEventListener("touchstart", this.onDragStart), e.removeEventListener("mousedown", this.onDragStart), removeEventListener("touchmove", this.onDragMove), removeEventListener("mousemove", this.onDragMove), removeEventListener("touchend", this.onDragEnd), removeEventListener("mouseup", this.onDragEnd);
    },
    onDragStart(e) {
      this.beingDragged = !0, this.dragPos = { x: getX(e), y: getY(e) }, this.dragStart = getX(e), this.dragRect = this.$el.getBoundingClientRect();
    },
    onDragMove(e) {
      this.beingDragged && (e.preventDefault(), this.isRunning && (this.isRunning = !1), this.dragPos = { x: getX(e), y: getY(e) });
    },
    onDragEnd() {
      this.beingDragged && (Math.abs(this.dragDelta) >= this.removalDistance ? (this.disableTransitions = !0, this.$nextTick(() => this.closeToast())) : setTimeout(() => {
        this.beingDragged = !1, isDOMRect(this.dragRect) && this.pauseOnHover && this.dragRect.bottom >= this.dragPos.y && this.dragPos.y >= this.dragRect.top && this.dragRect.left <= this.dragPos.x && this.dragPos.x <= this.dragRect.right ? this.isRunning = !1 : this.isRunning = !0;
      }));
    }
  }
}), _hoisted_16 = ["role"];
function render8(e, t) {
  const n = resolveComponent("Icon"), s = resolveComponent("CloseButton"), i = resolveComponent("ProgressBar");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(e.classes),
    style: normalizeStyle(e.draggableStyle),
    onClick: t[0] || (t[0] = (...a) => e.clickHandler && e.clickHandler(...a)),
    onMouseenter: t[1] || (t[1] = (...a) => e.hoverPause && e.hoverPause(...a)),
    onMouseleave: t[2] || (t[2] = (...a) => e.hoverPlay && e.hoverPlay(...a))
  }, [
    e.icon ? (openBlock(), createBlock(n, {
      key: 0,
      "custom-icon": e.icon,
      type: e.type
    }, null, 8, ["custom-icon", "type"])) : createCommentVNode("v-if", !0),
    createElementVNode("div", {
      role: e.accessibility.toastRole || "alert",
      class: normalizeClass(e.bodyClasses)
    }, [
      typeof e.content == "string" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString(e.content), 1)
      ], 2112)) : (openBlock(), createBlock(resolveDynamicComponent(e.getVueComponentFromObj(e.content)), mergeProps({
        key: 1,
        "toast-id": e.id
      }, e.hasProp(e.content, "props") ? e.content.props : {}, toHandlers(e.hasProp(e.content, "listeners") ? e.content.listeners : {}), { onCloseToast: e.closeToast }), null, 16, ["toast-id", "onCloseToast"]))
    ], 10, _hoisted_16),
    e.closeButton ? (openBlock(), createBlock(s, {
      key: 1,
      component: e.closeButton,
      "class-names": e.closeButtonClassName,
      "show-on-hover": e.showCloseButtonOnHover,
      "aria-label": e.accessibility.closeButtonLabel,
      onClick: withModifiers(e.closeToast, ["stop"])
    }, null, 8, ["component", "class-names", "show-on-hover", "aria-label", "onClick"])) : createCommentVNode("v-if", !0),
    e.timeout ? (openBlock(), createBlock(i, {
      key: 2,
      "is-running": e.isRunning,
      "hide-progress-bar": e.hideProgressBar,
      timeout: e.timeout,
      onCloseToast: e.timeoutHandler
    }, null, 8, ["is-running", "hide-progress-bar", "timeout", "onCloseToast"])) : createCommentVNode("v-if", !0)
  ], 38);
}
VtToast_default.render = render8;
var VtToast_default2 = VtToast_default, VtTransition_default = defineComponent({
  name: "VtTransition",
  props: propValidators_default.TRANSITION,
  emits: ["leave"],
  methods: {
    hasProp,
    leave(e) {
      e instanceof HTMLElement && (e.style.left = e.offsetLeft + "px", e.style.top = e.offsetTop + "px", e.style.width = getComputedStyle(e).width, e.style.position = "absolute");
    }
  }
});
function render9(e, t) {
  return openBlock(), createBlock(TransitionGroup, {
    tag: "div",
    "enter-active-class": e.transition.enter ? e.transition.enter : `${e.transition}-enter-active`,
    "move-class": e.transition.move ? e.transition.move : `${e.transition}-move`,
    "leave-active-class": e.transition.leave ? e.transition.leave : `${e.transition}-leave-active`,
    onLeave: e.leave
  }, {
    default: withCtx(() => [
      renderSlot(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["enter-active-class", "move-class", "leave-active-class", "onLeave"]);
}
VtTransition_default.render = render9;
var VtTransition_default2 = VtTransition_default, VtToastContainer_default = defineComponent({
  name: "VueToastification",
  devtools: {
    hide: !0
  },
  components: { Toast: VtToast_default2, VtTransition: VtTransition_default2 },
  props: Object.assign({}, propValidators_default.CORE_TOAST, propValidators_default.CONTAINER, propValidators_default.TRANSITION),
  data() {
    return {
      count: 0,
      positions: Object.values(POSITION),
      toasts: {},
      defaults: {}
    };
  },
  computed: {
    toastArray() {
      return Object.values(this.toasts);
    },
    filteredToasts() {
      return this.defaults.filterToasts(this.toastArray);
    }
  },
  beforeMount() {
    const e = this.eventBus;
    e.on(EVENTS.ADD, this.addToast), e.on(EVENTS.CLEAR, this.clearToasts), e.on(EVENTS.DISMISS, this.dismissToast), e.on(EVENTS.UPDATE, this.updateToast), e.on(EVENTS.UPDATE_DEFAULTS, this.updateDefaults), this.defaults = this.$props;
  },
  mounted() {
    this.setup(this.container);
  },
  methods: {
    async setup(e) {
      isFunction$5(e) && (e = await e()), removeElement(this.$el), e.appendChild(this.$el);
    },
    setToast(e) {
      isUndefined(e.id) || (this.toasts[e.id] = e);
    },
    addToast(e) {
      e.content = normalizeToastComponent(e.content);
      const t = Object.assign({}, this.defaults, e.type && this.defaults.toastDefaults && this.defaults.toastDefaults[e.type], e), n = this.defaults.filterBeforeCreate(t, this.toastArray);
      n && this.setToast(n);
    },
    dismissToast(e) {
      const t = this.toasts[e];
      !isUndefined(t) && !isUndefined(t.onClose) && t.onClose(), delete this.toasts[e];
    },
    clearToasts() {
      Object.keys(this.toasts).forEach((e) => {
        this.dismissToast(e);
      });
    },
    getPositionToasts(e) {
      const t = this.filteredToasts.filter((n) => n.position === e).slice(0, this.defaults.maxToasts);
      return this.defaults.newestOnTop ? t.reverse() : t;
    },
    updateDefaults(e) {
      isUndefined(e.container) || this.setup(e.container), this.defaults = Object.assign({}, this.defaults, e);
    },
    updateToast({
      id: e,
      options: t,
      create: n
    }) {
      this.toasts[e] ? (t.timeout && t.timeout === this.toasts[e].timeout && t.timeout++, this.setToast(Object.assign({}, this.toasts[e], t))) : n && this.addToast(Object.assign({}, { id: e }, t));
    },
    getClasses(e) {
      return [`${VT_NAMESPACE}__container`, e].concat(this.defaults.containerClassName);
    }
  }
});
function render10(e, t) {
  const n = resolveComponent("Toast"), s = resolveComponent("VtTransition");
  return openBlock(), createElementBlock("div", null, [
    (openBlock(!0), createElementBlock(Fragment, null, renderList(e.positions, (i) => (openBlock(), createElementBlock("div", { key: i }, [
      createVNode(s, {
        transition: e.defaults.transition,
        class: normalizeClass(e.getClasses(i))
      }, {
        default: withCtx(() => [
          (openBlock(!0), createElementBlock(Fragment, null, renderList(e.getPositionToasts(i), (a) => (openBlock(), createBlock(n, mergeProps({
            key: a.id
          }, a), null, 16))), 128))
        ]),
        _: 2
      }, 1032, ["transition", "class"])
    ]))), 128))
  ]);
}
VtToastContainer_default.render = render10;
var VtToastContainer_default2 = VtToastContainer_default, buildInterface = (e = {}, t = !0) => {
  const n = e.eventBus = e.eventBus || new EventBus();
  t && nextTick(() => {
    const a = createApp(VtToastContainer_default2, __spreadValues({}, e)), o = a.mount(document.createElement("div")), l = e.onMounted;
    if (isUndefined(l) || l(o, a), e.shareAppContext) {
      const c = e.shareAppContext;
      c === !0 ? console.warn(`[${VT_NAMESPACE}] App to share context with was not provided.`) : (a._context.components = c._context.components, a._context.directives = c._context.directives, a._context.mixins = c._context.mixins, a._context.provides = c._context.provides, a.config.globalProperties = c.config.globalProperties);
    }
  });
  const s = (a, o) => {
    const l = Object.assign({}, { id: getId(), type: TYPE.DEFAULT }, o, {
      content: a
    });
    return n.emit(EVENTS.ADD, l), l.id;
  };
  s.clear = () => n.emit(EVENTS.CLEAR, void 0), s.updateDefaults = (a) => {
    n.emit(EVENTS.UPDATE_DEFAULTS, a);
  }, s.dismiss = (a) => {
    n.emit(EVENTS.DISMISS, a);
  };
  function i(a, { content: o, options: l }, c = !1) {
    const u = Object.assign({}, l, { content: o });
    n.emit(EVENTS.UPDATE, {
      id: a,
      options: u,
      create: c
    });
  }
  return s.update = i, s.success = (a, o) => s(a, Object.assign({}, o, { type: TYPE.SUCCESS })), s.info = (a, o) => s(a, Object.assign({}, o, { type: TYPE.INFO })), s.error = (a, o) => s(a, Object.assign({}, o, { type: TYPE.ERROR })), s.warning = (a, o) => s(a, Object.assign({}, o, { type: TYPE.WARNING })), s;
}, createMockToastInterface = () => {
  const e = () => console.warn(`[${VT_NAMESPACE}] This plugin does not support SSR!`);
  return new Proxy(e, {
    get() {
      return e;
    }
  });
};
function createToastInterface(e) {
  return isBrowser() ? isEventBusInterface(e) ? buildInterface({ eventBus: e }, !1) : buildInterface(e, !0) : createMockToastInterface();
}
var toastInjectionKey = Symbol("VueToastification"), globalEventBus = new EventBus(), VueToastificationPlugin = (e, t) => {
  (t == null ? void 0 : t.shareAppContext) === !0 && (t.shareAppContext = e);
  const n = createToastInterface(__spreadValues({
    eventBus: globalEventBus
  }, t));
  e.provide(toastInjectionKey, n);
}, useToast = (e) => {
  if (e)
    return createToastInterface(e);
  const t = getCurrentInstance() ? inject(toastInjectionKey, void 0) : void 0;
  return t || createToastInterface(globalEventBus);
}, src_default = VueToastificationPlugin;
const index$1 = "", isTabletAndUp = useMediaQuery("(min-width: 640px)"), toast = useToast(), snackBarMethodTypes = {
  default: toast.info,
  info: toast.info,
  error: toast.error,
  success: toast.success,
  warning: toast.warning
}, defaultOptions$2 = {
  containerClassName: "custom-snackbar-container text-base",
  closeButton: !1,
  hideProgressBar: !0,
  icon: !1,
  position: isTabletAndUp.value ? POSITION.BOTTOM_CENTER : POSITION.TOP_CENTER,
  transition: "Vue-Toastification__fade",
  timeout: 4e3
};
let customOptions = {};
const SnackBarPlugin = {
  install(e, t) {
    customOptions = { ...defaultOptions$2, ...t }, e.use(src_default, customOptions);
  }
};
function showSnack(e, t, n) {
  const s = t || TYPE.DEFAULT, i = defineComponent({
    render: () => h(_sfc_main$2J, { size: "md" }, () => e)
  });
  snackBarMethodTypes[s](i, { timeout: n });
}
const __variableDynamicImportRuntimeHelper = (e, t) => {
  const n = e[t];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((s, i) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(i.bind(null, new Error("Unknown variable dynamic import: " + t)));
  });
}, _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "Icon",
  props: {
    name: { default: "user-circle" },
    tone: { default: "high-emphasis" }
  },
  setup(e) {
    const t = e, n = shallowRef("");
    watchEffect(() => {
      __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "../../assets/images/accessible.vue": () => import("./accessible-959033e0.mjs"), "../../assets/images/address.vue": () => import("./address-bdfa34df.mjs"), "../../assets/images/alert-circle.vue": () => import("./alert-circle-c8c1148a.mjs"), "../../assets/images/alert-octagon.vue": () => import("./alert-octagon-bcdf3b2f.mjs"), "../../assets/images/building-bank.vue": () => import("./building-bank-0383b659.mjs"), "../../assets/images/chevron-down.vue": () => import("./chevron-down-78a13a63.mjs"), "../../assets/images/chevron-left.vue": () => import("./chevron-left-34aaccdf.mjs"), "../../assets/images/chevron-right.vue": () => import("./chevron-right-8667e56c.mjs"), "../../assets/images/chevron-up.vue": () => import("./chevron-up-ddae2a0c.mjs"), "../../assets/images/clock.vue": () => import("./clock-486b6ce9.mjs"), "../../assets/images/cross.vue": () => import("./cross-40d8d1d7.mjs"), "../../assets/images/explore.vue": () => import("./explore-3069332b.mjs"), "../../assets/images/file-text.vue": () => import("./file-text-fbbf3be6.mjs"), "../../assets/images/heartbeat.vue": () => import("./heartbeat-ec9f63ff.mjs"), "../../assets/images/home-filled.vue": () => import("./home-filled-4153cf6c.mjs"), "../../assets/images/home.vue": () => import("./home-3f9fd73d.mjs"), "../../assets/images/icon-show.vue": () => import("./icon-show-75abef83.mjs"), "../../assets/images/info.vue": () => import("./info-ab639da1.mjs"), "../../assets/images/licence.vue": () => import("./licence-7516c452.mjs"), "../../assets/images/logout.vue": () => import("./logout-90ec65f9.mjs"), "../../assets/images/message-filled.vue": () => import("./message-filled-3fa65eb4.mjs"), "../../assets/images/message.vue": () => import("./message-f8c118a4.mjs"), "../../assets/images/notifications.vue": () => import("./notifications-9938153a.mjs"), "../../assets/images/octagon.vue": () => import("./octagon-4c6f9592.mjs"), "../../assets/images/pen.vue": () => import("./pen-407fa280.mjs"), "../../assets/images/pin.vue": () => import("./pin-f8191240.mjs"), "../../assets/images/send.vue": () => import("./send-3790ae5a.mjs"), "../../assets/images/spinner.vue": () => import("./spinner-50f96fd3.mjs"), "../../assets/images/star-filled.vue": () => import("./star-filled-6537bf7c.mjs"), "../../assets/images/star.vue": () => import("./star-776c71b9.mjs"), "../../assets/images/tick.vue": () => import("./tick-36588ee8.mjs"), "../../assets/images/triangle-square-circle-filled.vue": () => import("./triangle-square-circle-filled-c360f2d9.mjs"), "../../assets/images/triangle-square-circle.vue": () => import("./triangle-square-circle-e831fe95.mjs"), "../../assets/images/user-circle-filled.vue": () => import("./user-circle-filled-751f5fd6.mjs"), "../../assets/images/user-circle.vue": () => import("./user-circle-eb9f2798.mjs"), "../../assets/images/user-plus.vue": () => import("./user-plus-c59eb965.mjs"), "../../assets/images/wallet-filled.vue": () => import("./wallet-filled-22bfe69f.mjs"), "../../assets/images/wallet.vue": () => import("./wallet-9a8ace21.mjs"), "../../assets/images/world.vue": () => import("./world-f9de378b.mjs") }), `../../assets/images/${t.name}.vue`).then((i) => {
        n.value = i.default;
      });
    });
    const s = () => classMerge({
      ...t.tone && mapToneToTextClasses(t.tone)
    });
    return (i, a) => unref(n) ? (openBlock(), createBlock(resolveDynamicComponent(unref(n)), {
      key: 0,
      class: normalizeClass(s())
    }, null, 8, ["class"])) : createCommentVNode("", !0);
  }
}), formatCurrency = (e, { currencyLocale: t, currency: n, notation: s, minimumFractionDigits: i }) => new Intl.NumberFormat(t, {
  style: "currency",
  ...t && { locale: t },
  ...n && { currency: n },
  notation: s,
  minimumFractionDigits: i
}).format(e), formatNumber$1 = (e, { locale: t, ...n }) => new Intl.NumberFormat(t, n).format(e), formatCurrencyAsDecimal = (e) => Number(e == null ? void 0 : e.replace(/[^0-9.-]+/g, "")), _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "NumberFormat",
  props: {
    value: null,
    decimals: { default: 3 },
    locale: { default: "en-AU" },
    isEstimate: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = (c) => c !== 0 ? !1 : c.toLocaleString()[0] === "-", s = computed(() => {
      const c = n(t.value) ? Math.abs(t.value) : t.value;
      return formatNumber$1(c, {
        locale: t.locale,
        minimumFractionDigits: t.decimals
      });
    }), i = computed(
      () => parseFloat(t.value.toFixed(t.decimals))
    ), a = computed(() => i.value > 0 ? "success" : i.value < 0 ? "error" : "high-emphasis"), o = computed(() => i.value > 0 ? "+" : ""), l = computed(() => t.isEstimate ? "~" : "");
    return (c, u) => (openBlock(), createBlock(_sfc_main$2K, { component: "span" }, {
      default: withCtx(() => [
        renderSlot(c.$slots, "render", normalizeProps(guardReactiveProps({
          estimatePrefix: unref(l),
          plusMinusPrefix: unref(o),
          formattedValue: unref(s),
          directionTone: unref(a)
        })), () => [
          createTextVNode(toDisplayString(unref(s)), 1)
        ])
      ]),
      _: 3
    }));
  }
}), _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "CurrencyFormat",
  props: {
    value: null,
    locale: { default: "en-AU" },
    currency: { default: "AUD" },
    notation: { default: "standard" },
    minimumFractionDigits: { default: void 0 },
    isEstimate: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = (c) => c !== 0 ? !1 : c.toLocaleString()[0] === "-", s = computed(() => {
      const c = parseFloat(t.value.toFixed(2));
      return n(c) ? Math.abs(c) : c;
    }), i = computed(
      () => formatCurrency(s.value, {
        currencyLocale: t.locale,
        currency: t.currency,
        notation: t.notation,
        minimumFractionDigits: t.minimumFractionDigits
      })
    ), a = computed(() => s.value > 0 ? "success" : s.value < 0 ? "error" : "high-emphasis"), o = computed(() => s.value > 0 ? "+" : ""), l = computed(() => t.isEstimate ? "~" : "");
    return (c, u) => (openBlock(), createBlock(_sfc_main$2K, { component: "span" }, {
      default: withCtx(() => [
        renderSlot(c.$slots, "render", normalizeProps(guardReactiveProps({
          estimatePrefix: unref(l),
          plusMinusPrefix: unref(o),
          formattedValue: unref(i),
          directionTone: unref(a)
        })), () => [
          createTextVNode(toDisplayString(unref(i)), 1)
        ])
      ]),
      _: 3
    }));
  }
}), _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "SymbolFormat",
  props: {
    value: null
  },
  setup(e) {
    const t = e, n = computed(() => {
      if (t.value.includes(":")) {
        const [s] = t.value.split(":");
        return s;
      }
      return t.value;
    });
    return (s, i) => (openBlock(), createBlock(_sfc_main$2K, { component: "span" }, {
      default: withCtx(() => [
        renderSlot(s.$slots, "render", normalizeProps(guardReactiveProps({ formattedValue: unref(n) })), () => [
          createTextVNode(toDisplayString(unref(n)), 1)
        ])
      ]),
      _: 3
    }));
  }
}), _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "UnitsFormat",
  props: {
    value: null,
    decimals: { default: 3 },
    isEstimate: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = (c) => c !== 0 ? !1 : c.toLocaleString()[0] === "-", s = computed(() => (n(t.value) ? Math.abs(t.value) : t.value).toFixed(t.decimals)), i = computed(
      () => parseFloat(t.value.toFixed(t.decimals))
    ), a = computed(() => i.value > 0 ? "success" : i.value < 0 ? "error" : "high-emphasis"), o = computed(() => i.value > 0 ? "+" : ""), l = computed(() => t.isEstimate ? "~" : "");
    return (c, u) => (openBlock(), createBlock(_sfc_main$2K, { component: "span" }, {
      default: withCtx(() => [
        renderSlot(c.$slots, "render", normalizeProps(guardReactiveProps({
          estimatePrefix: unref(l),
          plusMinusPrefix: unref(o),
          formattedValue: unref(s),
          directionTone: unref(a)
        })), () => [
          createTextVNode(toDisplayString(unref(s)), 1)
        ])
      ]),
      _: 3
    }));
  }
});
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(e, t) {
  return e.concat([t + "-" + start, t + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(e, t) {
  return e.concat([t, t + "-" + start, t + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function getWindow(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function isElement(e) {
  var t = getWindow(e).Element;
  return e instanceof t || e instanceof Element;
}
function isHTMLElement(e) {
  var t = getWindow(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function isShadowRoot(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = getWindow(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function applyStyles(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var s = t.styles[n] || {}, i = t.attributes[n] || {}, a = t.elements[n];
    !isHTMLElement(a) || !getNodeName(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(o) {
      var l = i[o];
      l === !1 ? a.removeAttribute(o) : a.setAttribute(o, l === !0 ? "" : l);
    }));
  });
}
function effect$2(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(s) {
      var i = t.elements[s], a = t.attributes[s] || {}, o = Object.keys(t.styles.hasOwnProperty(s) ? t.styles[s] : n[s]), l = o.reduce(function(c, u) {
        return c[u] = "", c;
      }, {});
      !isHTMLElement(i) || !getNodeName(i) || (Object.assign(i.style, l), Object.keys(a).forEach(function(c) {
        i.removeAttribute(c);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(e) {
  return e.split("-")[0];
}
var max = Math.max, min = Math.min, round$1 = Math.round;
function getUAString() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var s = e.getBoundingClientRect(), i = 1, a = 1;
  t && isHTMLElement(e) && (i = e.offsetWidth > 0 && round$1(s.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && round$1(s.height) / e.offsetHeight || 1);
  var o = isElement(e) ? getWindow(e) : window, l = o.visualViewport, c = !isLayoutViewport() && n, u = (s.left + (c && l ? l.offsetLeft : 0)) / i, d = (s.top + (c && l ? l.offsetTop : 0)) / a, p = s.width / i, f = s.height / a;
  return {
    width: p,
    height: f,
    top: d,
    right: u + p,
    bottom: d + f,
    left: u,
    x: u,
    y: d
  };
}
function getLayoutRect(e) {
  var t = getBoundingClientRect(e), n = e.offsetWidth, s = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - s) <= 1 && (s = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: s
  };
}
function contains(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && isShadowRoot(n)) {
    var s = t;
    do {
      if (s && e.isSameNode(s))
        return !0;
      s = s.parentNode || s.host;
    } while (s);
  }
  return !1;
}
function getComputedStyle$2(e) {
  return getWindow(e).getComputedStyle(e);
}
function isTableElement(e) {
  return ["table", "td", "th"].indexOf(getNodeName(e)) >= 0;
}
function getDocumentElement(e) {
  return ((isElement(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function getParentNode(e) {
  return getNodeName(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (isShadowRoot(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(e)
  );
}
function getTrueOffsetParent(e) {
  return !isHTMLElement(e) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$2(e).position === "fixed" ? null : e.offsetParent;
}
function getContainingBlock(e) {
  var t = /firefox/i.test(getUAString()), n = /Trident/i.test(getUAString());
  if (n && isHTMLElement(e)) {
    var s = getComputedStyle$2(e);
    if (s.position === "fixed")
      return null;
  }
  var i = getParentNode(e);
  for (isShadowRoot(i) && (i = i.host); isHTMLElement(i) && ["html", "body"].indexOf(getNodeName(i)) < 0; ) {
    var a = getComputedStyle$2(i);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function getOffsetParent(e) {
  for (var t = getWindow(e), n = getTrueOffsetParent(e); n && isTableElement(n) && getComputedStyle$2(n).position === "static"; )
    n = getTrueOffsetParent(n);
  return n && (getNodeName(n) === "html" || getNodeName(n) === "body" && getComputedStyle$2(n).position === "static") ? t : n || getContainingBlock(e) || t;
}
function getMainAxisFromPlacement(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function within(e, t, n) {
  return max(e, min(t, n));
}
function withinMaxClamp(e, t, n) {
  var s = within(e, t, n);
  return s > n ? n : s;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(e) {
  return Object.assign({}, getFreshSideObject(), e);
}
function expandToHashMap(e, t) {
  return t.reduce(function(n, s) {
    return n[s] = e, n;
  }, {});
}
var toPaddingObject = function e(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, mergePaddingObject(typeof t != "number" ? t : expandToHashMap(t, basePlacements));
};
function arrow(e) {
  var t, n = e.state, s = e.name, i = e.options, a = n.elements.arrow, o = n.modifiersData.popperOffsets, l = getBasePlacement(n.placement), c = getMainAxisFromPlacement(l), u = [left, right].indexOf(l) >= 0, d = u ? "height" : "width";
  if (!(!a || !o)) {
    var p = toPaddingObject(i.padding, n), f = getLayoutRect(a), g = c === "y" ? top : left, C = c === "y" ? bottom : right, k = n.rects.reference[d] + n.rects.reference[c] - o[c] - n.rects.popper[d], M = o[c] - n.rects.reference[c], _ = getOffsetParent(a), S = _ ? c === "y" ? _.clientHeight || 0 : _.clientWidth || 0 : 0, E = k / 2 - M / 2, P = p[g], $ = S - f[d] - p[C], A = S / 2 - f[d] / 2 + E, I = within(P, A, $), D = c;
    n.modifiersData[s] = (t = {}, t[D] = I, t.centerOffset = I - A, t);
  }
}
function effect$1(e) {
  var t = e.state, n = e.options, s = n.element, i = s === void 0 ? "[data-popper-arrow]" : s;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || contains(t.elements.popper, i) && (t.elements.arrow = i));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(e) {
  return e.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(e, t) {
  var n = e.x, s = e.y, i = t.devicePixelRatio || 1;
  return {
    x: round$1(n * i) / i || 0,
    y: round$1(s * i) / i || 0
  };
}
function mapToStyles(e) {
  var t, n = e.popper, s = e.popperRect, i = e.placement, a = e.variation, o = e.offsets, l = e.position, c = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, p = e.isFixed, f = o.x, g = f === void 0 ? 0 : f, C = o.y, k = C === void 0 ? 0 : C, M = typeof d == "function" ? d({
    x: g,
    y: k
  }) : {
    x: g,
    y: k
  };
  g = M.x, k = M.y;
  var _ = o.hasOwnProperty("x"), S = o.hasOwnProperty("y"), E = left, P = top, $ = window;
  if (u) {
    var A = getOffsetParent(n), I = "clientHeight", D = "clientWidth";
    if (A === getWindow(n) && (A = getDocumentElement(n), getComputedStyle$2(A).position !== "static" && l === "absolute" && (I = "scrollHeight", D = "scrollWidth")), A = A, i === top || (i === left || i === right) && a === end) {
      P = bottom;
      var R = p && A === $ && $.visualViewport ? $.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        A[I]
      );
      k -= R - s.height, k *= c ? 1 : -1;
    }
    if (i === left || (i === top || i === bottom) && a === end) {
      E = right;
      var Y = p && A === $ && $.visualViewport ? $.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        A[D]
      );
      g -= Y - s.width, g *= c ? 1 : -1;
    }
  }
  var q = Object.assign({
    position: l
  }, u && unsetSides), j = d === !0 ? roundOffsetsByDPR({
    x: g,
    y: k
  }, getWindow(n)) : {
    x: g,
    y: k
  };
  if (g = j.x, k = j.y, c) {
    var X;
    return Object.assign({}, q, (X = {}, X[P] = S ? "0" : "", X[E] = _ ? "0" : "", X.transform = ($.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + k + "px)" : "translate3d(" + g + "px, " + k + "px, 0)", X));
  }
  return Object.assign({}, q, (t = {}, t[P] = S ? k + "px" : "", t[E] = _ ? g + "px" : "", t.transform = "", t));
}
function computeStyles(e) {
  var t = e.state, n = e.options, s = n.gpuAcceleration, i = s === void 0 ? !0 : s, a = n.adaptive, o = a === void 0 ? !0 : a, l = n.roundOffsets, c = l === void 0 ? !0 : l, u = {
    placement: getBasePlacement(t.placement),
    variation: getVariation(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, mapToStyles(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, mapToStyles(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(e) {
  var t = e.state, n = e.instance, s = e.options, i = s.scroll, a = i === void 0 ? !0 : i, o = s.resize, l = o === void 0 ? !0 : o, c = getWindow(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && u.forEach(function(d) {
    d.addEventListener("scroll", n.update, passive);
  }), l && c.addEventListener("resize", n.update, passive), function() {
    a && u.forEach(function(d) {
      d.removeEventListener("scroll", n.update, passive);
    }), l && c.removeEventListener("resize", n.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function e() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return hash$1[t];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(e) {
  return e.replace(/start|end/g, function(t) {
    return hash[t];
  });
}
function getWindowScroll(e) {
  var t = getWindow(e), n = t.pageXOffset, s = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: s
  };
}
function getWindowScrollBarX(e) {
  return getBoundingClientRect(getDocumentElement(e)).left + getWindowScroll(e).scrollLeft;
}
function getViewportRect(e, t) {
  var n = getWindow(e), s = getDocumentElement(e), i = n.visualViewport, a = s.clientWidth, o = s.clientHeight, l = 0, c = 0;
  if (i) {
    a = i.width, o = i.height;
    var u = isLayoutViewport();
    (u || !u && t === "fixed") && (l = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: l + getWindowScrollBarX(e),
    y: c
  };
}
function getDocumentRect(e) {
  var t, n = getDocumentElement(e), s = getWindowScroll(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, a = max(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), o = max(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), l = -s.scrollLeft + getWindowScrollBarX(e), c = -s.scrollTop;
  return getComputedStyle$2(i || n).direction === "rtl" && (l += max(n.clientWidth, i ? i.clientWidth : 0) - a), {
    width: a,
    height: o,
    x: l,
    y: c
  };
}
function isScrollParent(e) {
  var t = getComputedStyle$2(e), n = t.overflow, s = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + s);
}
function getScrollParent(e) {
  return ["html", "body", "#document"].indexOf(getNodeName(e)) >= 0 ? e.ownerDocument.body : isHTMLElement(e) && isScrollParent(e) ? e : getScrollParent(getParentNode(e));
}
function listScrollParents(e, t) {
  var n;
  t === void 0 && (t = []);
  var s = getScrollParent(e), i = s === ((n = e.ownerDocument) == null ? void 0 : n.body), a = getWindow(s), o = i ? [a].concat(a.visualViewport || [], isScrollParent(s) ? s : []) : s, l = t.concat(o);
  return i ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(listScrollParents(getParentNode(o)))
  );
}
function rectToClientRect(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function getInnerBoundingClientRect(e, t) {
  var n = getBoundingClientRect(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function getClientRectFromMixedType(e, t, n) {
  return t === viewport ? rectToClientRect(getViewportRect(e, n)) : isElement(t) ? getInnerBoundingClientRect(t, n) : rectToClientRect(getDocumentRect(getDocumentElement(e)));
}
function getClippingParents(e) {
  var t = listScrollParents(getParentNode(e)), n = ["absolute", "fixed"].indexOf(getComputedStyle$2(e).position) >= 0, s = n && isHTMLElement(e) ? getOffsetParent(e) : e;
  return isElement(s) ? t.filter(function(i) {
    return isElement(i) && contains(i, s) && getNodeName(i) !== "body";
  }) : [];
}
function getClippingRect(e, t, n, s) {
  var i = t === "clippingParents" ? getClippingParents(e) : [].concat(t), a = [].concat(i, [n]), o = a[0], l = a.reduce(function(c, u) {
    var d = getClientRectFromMixedType(e, u, s);
    return c.top = max(d.top, c.top), c.right = min(d.right, c.right), c.bottom = min(d.bottom, c.bottom), c.left = max(d.left, c.left), c;
  }, getClientRectFromMixedType(e, o, s));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function computeOffsets(e) {
  var t = e.reference, n = e.element, s = e.placement, i = s ? getBasePlacement(s) : null, a = s ? getVariation(s) : null, o = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, c;
  switch (i) {
    case top:
      c = {
        x: o,
        y: t.y - n.height
      };
      break;
    case bottom:
      c = {
        x: o,
        y: t.y + t.height
      };
      break;
    case right:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case left:
      c = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var u = i ? getMainAxisFromPlacement(i) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (a) {
      case start:
        c[u] = c[u] - (t[d] / 2 - n[d] / 2);
        break;
      case end:
        c[u] = c[u] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return c;
}
function detectOverflow(e, t) {
  t === void 0 && (t = {});
  var n = t, s = n.placement, i = s === void 0 ? e.placement : s, a = n.strategy, o = a === void 0 ? e.strategy : a, l = n.boundary, c = l === void 0 ? clippingParents : l, u = n.rootBoundary, d = u === void 0 ? viewport : u, p = n.elementContext, f = p === void 0 ? popper : p, g = n.altBoundary, C = g === void 0 ? !1 : g, k = n.padding, M = k === void 0 ? 0 : k, _ = mergePaddingObject(typeof M != "number" ? M : expandToHashMap(M, basePlacements)), S = f === popper ? reference : popper, E = e.rects.popper, P = e.elements[C ? S : f], $ = getClippingRect(isElement(P) ? P : P.contextElement || getDocumentElement(e.elements.popper), c, d, o), A = getBoundingClientRect(e.elements.reference), I = computeOffsets({
    reference: A,
    element: E,
    strategy: "absolute",
    placement: i
  }), D = rectToClientRect(Object.assign({}, E, I)), R = f === popper ? D : A, Y = {
    top: $.top - R.top + _.top,
    bottom: R.bottom - $.bottom + _.bottom,
    left: $.left - R.left + _.left,
    right: R.right - $.right + _.right
  }, q = e.modifiersData.offset;
  if (f === popper && q) {
    var j = q[i];
    Object.keys(Y).forEach(function(X) {
      var ee = [right, bottom].indexOf(X) >= 0 ? 1 : -1, G = [top, bottom].indexOf(X) >= 0 ? "y" : "x";
      Y[X] += j[G] * ee;
    });
  }
  return Y;
}
function computeAutoPlacement(e, t) {
  t === void 0 && (t = {});
  var n = t, s = n.placement, i = n.boundary, a = n.rootBoundary, o = n.padding, l = n.flipVariations, c = n.allowedAutoPlacements, u = c === void 0 ? placements : c, d = getVariation(s), p = d ? l ? variationPlacements : variationPlacements.filter(function(C) {
    return getVariation(C) === d;
  }) : basePlacements, f = p.filter(function(C) {
    return u.indexOf(C) >= 0;
  });
  f.length === 0 && (f = p);
  var g = f.reduce(function(C, k) {
    return C[k] = detectOverflow(e, {
      placement: k,
      boundary: i,
      rootBoundary: a,
      padding: o
    })[getBasePlacement(k)], C;
  }, {});
  return Object.keys(g).sort(function(C, k) {
    return g[C] - g[k];
  });
}
function getExpandedFallbackPlacements(e) {
  if (getBasePlacement(e) === auto)
    return [];
  var t = getOppositePlacement(e);
  return [getOppositeVariationPlacement(e), t, getOppositeVariationPlacement(t)];
}
function flip(e) {
  var t = e.state, n = e.options, s = e.name;
  if (!t.modifiersData[s]._skip) {
    for (var i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, l = o === void 0 ? !0 : o, c = n.fallbackPlacements, u = n.padding, d = n.boundary, p = n.rootBoundary, f = n.altBoundary, g = n.flipVariations, C = g === void 0 ? !0 : g, k = n.allowedAutoPlacements, M = t.options.placement, _ = getBasePlacement(M), S = _ === M, E = c || (S || !C ? [getOppositePlacement(M)] : getExpandedFallbackPlacements(M)), P = [M].concat(E).reduce(function(te, ue) {
      return te.concat(getBasePlacement(ue) === auto ? computeAutoPlacement(t, {
        placement: ue,
        boundary: d,
        rootBoundary: p,
        padding: u,
        flipVariations: C,
        allowedAutoPlacements: k
      }) : ue);
    }, []), $ = t.rects.reference, A = t.rects.popper, I = /* @__PURE__ */ new Map(), D = !0, R = P[0], Y = 0; Y < P.length; Y++) {
      var q = P[Y], j = getBasePlacement(q), X = getVariation(q) === start, ee = [top, bottom].indexOf(j) >= 0, G = ee ? "width" : "height", H = detectOverflow(t, {
        placement: q,
        boundary: d,
        rootBoundary: p,
        altBoundary: f,
        padding: u
      }), F = ee ? X ? right : left : X ? bottom : top;
      $[G] > A[G] && (F = getOppositePlacement(F));
      var B = getOppositePlacement(F), z = [];
      if (a && z.push(H[j] <= 0), l && z.push(H[F] <= 0, H[B] <= 0), z.every(function(te) {
        return te;
      })) {
        R = q, D = !1;
        break;
      }
      I.set(q, z);
    }
    if (D)
      for (var K = C ? 3 : 1, Z = function(ue) {
        var ce = P.find(function(ge) {
          var de = I.get(ge);
          if (de)
            return de.slice(0, ue).every(function(le) {
              return le;
            });
        });
        if (ce)
          return R = ce, "break";
      }, re = K; re > 0; re--) {
        var ae = Z(re);
        if (ae === "break")
          break;
      }
    t.placement !== R && (t.modifiersData[s]._skip = !0, t.placement = R, t.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function isAnySideFullyClipped(e) {
  return [top, right, bottom, left].some(function(t) {
    return e[t] >= 0;
  });
}
function hide(e) {
  var t = e.state, n = e.name, s = t.rects.reference, i = t.rects.popper, a = t.modifiersData.preventOverflow, o = detectOverflow(t, {
    elementContext: "reference"
  }), l = detectOverflow(t, {
    altBoundary: !0
  }), c = getSideOffsets(o, s), u = getSideOffsets(l, i, a), d = isAnySideFullyClipped(c), p = isAnySideFullyClipped(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: u,
    isReferenceHidden: d,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": p
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(e, t, n) {
  var s = getBasePlacement(e), i = [left, top].indexOf(s) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, o = a[0], l = a[1];
  return o = o || 0, l = (l || 0) * i, [left, right].indexOf(s) >= 0 ? {
    x: l,
    y: o
  } : {
    x: o,
    y: l
  };
}
function offset(e) {
  var t = e.state, n = e.options, s = e.name, i = n.offset, a = i === void 0 ? [0, 0] : i, o = placements.reduce(function(d, p) {
    return d[p] = distanceAndSkiddingToXY(p, t.rects, a), d;
  }, {}), l = o[t.placement], c = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[s] = o;
}
const offset$1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = computeOffsets({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(e) {
  return e === "x" ? "y" : "x";
}
function preventOverflow(e) {
  var t = e.state, n = e.options, s = e.name, i = n.mainAxis, a = i === void 0 ? !0 : i, o = n.altAxis, l = o === void 0 ? !1 : o, c = n.boundary, u = n.rootBoundary, d = n.altBoundary, p = n.padding, f = n.tether, g = f === void 0 ? !0 : f, C = n.tetherOffset, k = C === void 0 ? 0 : C, M = detectOverflow(t, {
    boundary: c,
    rootBoundary: u,
    padding: p,
    altBoundary: d
  }), _ = getBasePlacement(t.placement), S = getVariation(t.placement), E = !S, P = getMainAxisFromPlacement(_), $ = getAltAxis(P), A = t.modifiersData.popperOffsets, I = t.rects.reference, D = t.rects.popper, R = typeof k == "function" ? k(Object.assign({}, t.rects, {
    placement: t.placement
  })) : k, Y = typeof R == "number" ? {
    mainAxis: R,
    altAxis: R
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, R), q = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, j = {
    x: 0,
    y: 0
  };
  if (A) {
    if (a) {
      var X, ee = P === "y" ? top : left, G = P === "y" ? bottom : right, H = P === "y" ? "height" : "width", F = A[P], B = F + M[ee], z = F - M[G], K = g ? -D[H] / 2 : 0, Z = S === start ? I[H] : D[H], re = S === start ? -D[H] : -I[H], ae = t.elements.arrow, te = g && ae ? getLayoutRect(ae) : {
        width: 0,
        height: 0
      }, ue = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : getFreshSideObject(), ce = ue[ee], ge = ue[G], de = within(0, I[H], te[H]), le = E ? I[H] / 2 - K - de - ce - Y.mainAxis : Z - de - ce - Y.mainAxis, me = E ? -I[H] / 2 + K + de + ge + Y.mainAxis : re + de + ge + Y.mainAxis, ve = t.elements.arrow && getOffsetParent(t.elements.arrow), be = ve ? P === "y" ? ve.clientTop || 0 : ve.clientLeft || 0 : 0, oe = (X = q == null ? void 0 : q[P]) != null ? X : 0, ye = F + le - oe - be, we = F + me - oe, Ae = within(g ? min(B, ye) : B, F, g ? max(z, we) : z);
      A[P] = Ae, j[P] = Ae - F;
    }
    if (l) {
      var Se, Ee = P === "x" ? top : left, Ie = P === "x" ? bottom : right, xe = A[$], Ce = $ === "y" ? "height" : "width", $e = xe + M[Ee], De = xe - M[Ie], ke = [top, left].indexOf(_) !== -1, Me = (Se = q == null ? void 0 : q[$]) != null ? Se : 0, Pe = ke ? $e : xe - I[Ce] - D[Ce] - Me + Y.altAxis, Oe = ke ? xe + I[Ce] + D[Ce] - Me - Y.altAxis : De, Be = g && ke ? withinMaxClamp(Pe, xe, Oe) : within(g ? Pe : $e, xe, g ? Oe : De);
      A[$] = Be, j[$] = Be - xe;
    }
    t.modifiersData[s] = j;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function getNodeScroll(e) {
  return e === getWindow(e) || !isHTMLElement(e) ? getWindowScroll(e) : getHTMLElementScroll(e);
}
function isElementScaled(e) {
  var t = e.getBoundingClientRect(), n = round$1(t.width) / e.offsetWidth || 1, s = round$1(t.height) / e.offsetHeight || 1;
  return n !== 1 || s !== 1;
}
function getCompositeRect(e, t, n) {
  n === void 0 && (n = !1);
  var s = isHTMLElement(t), i = isHTMLElement(t) && isElementScaled(t), a = getDocumentElement(t), o = getBoundingClientRect(e, i, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (s || !s && !n) && ((getNodeName(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(a)) && (l = getNodeScroll(t)), isHTMLElement(t) ? (c = getBoundingClientRect(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : a && (c.x = getWindowScrollBarX(a))), {
    x: o.left + l.scrollLeft - c.x,
    y: o.top + l.scrollTop - c.y,
    width: o.width,
    height: o.height
  };
}
function order(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), s = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function i(a) {
    n.add(a.name);
    var o = [].concat(a.requires || [], a.requiresIfExists || []);
    o.forEach(function(l) {
      if (!n.has(l)) {
        var c = t.get(l);
        c && i(c);
      }
    }), s.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || i(a);
  }), s;
}
function orderModifiers(e) {
  var t = order(e);
  return modifierPhases.reduce(function(n, s) {
    return n.concat(t.filter(function(i) {
      return i.phase === s;
    }));
  }, []);
}
function debounce$1(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function mergeByName(e) {
  var t = e.reduce(function(n, s) {
    var i = n[s.name];
    return n[s.name] = i ? Object.assign({}, i, s, {
      options: Object.assign({}, i.options, s.options),
      data: Object.assign({}, i.data, s.data)
    }) : s, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(s) {
    return !(s && typeof s.getBoundingClientRect == "function");
  });
}
function popperGenerator(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, s = n === void 0 ? [] : n, i = t.defaultOptions, a = i === void 0 ? DEFAULT_OPTIONS : i;
  return function(l, c, u) {
    u === void 0 && (u = a);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, a),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, p = [], f = !1, g = {
      state: d,
      setOptions: function(_) {
        var S = typeof _ == "function" ? _(d.options) : _;
        k(), d.options = Object.assign({}, a, d.options, S), d.scrollParents = {
          reference: isElement(l) ? listScrollParents(l) : l.contextElement ? listScrollParents(l.contextElement) : [],
          popper: listScrollParents(c)
        };
        var E = orderModifiers(mergeByName([].concat(s, d.options.modifiers)));
        return d.orderedModifiers = E.filter(function(P) {
          return P.enabled;
        }), C(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var _ = d.elements, S = _.reference, E = _.popper;
          if (areValidElements(S, E)) {
            d.rects = {
              reference: getCompositeRect(S, getOffsetParent(E), d.options.strategy === "fixed"),
              popper: getLayoutRect(E)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(Y) {
              return d.modifiersData[Y.name] = Object.assign({}, Y.data);
            });
            for (var P = 0; P < d.orderedModifiers.length; P++) {
              if (d.reset === !0) {
                d.reset = !1, P = -1;
                continue;
              }
              var $ = d.orderedModifiers[P], A = $.fn, I = $.options, D = I === void 0 ? {} : I, R = $.name;
              typeof A == "function" && (d = A({
                state: d,
                options: D,
                name: R,
                instance: g
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$1(function() {
        return new Promise(function(M) {
          g.forceUpdate(), M(d);
        });
      }),
      destroy: function() {
        k(), f = !0;
      }
    };
    if (!areValidElements(l, c))
      return g;
    g.setOptions(u).then(function(M) {
      !f && u.onFirstUpdate && u.onFirstUpdate(M);
    });
    function C() {
      d.orderedModifiers.forEach(function(M) {
        var _ = M.name, S = M.options, E = S === void 0 ? {} : S, P = M.effect;
        if (typeof P == "function") {
          var $ = P({
            state: d,
            name: _,
            instance: g,
            options: E
          }), A = function() {
          };
          p.push($ || A);
        }
      });
    }
    function k() {
      p.forEach(function(M) {
        return M();
      }), p = [];
    }
    return g;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
}), __defProp = Object.defineProperty, __defNormalProp = (e, t, n) => t in e ? __defProp(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, __publicField = (e, t, n) => (__defNormalProp(e, typeof t != "symbol" ? t + "" : t, n), n);
const _export_sfc = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, i] of t)
    n[s] = i;
  return n;
}, _sfc_main$h = {}, _hoisted_1$c = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, _hoisted_2$b = /* @__PURE__ */ createElementVNode("polyline", { points: "9 18 15 12 9 6" }, null, -1), _hoisted_3$9 = [
  _hoisted_2$b
];
function _sfc_render$8(e, t) {
  return openBlock(), createElementBlock("svg", _hoisted_1$c, _hoisted_3$9);
}
const IconChevronRight = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$8]]), _sfc_main$g = {}, _hoisted_1$b = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, _hoisted_2$a = /* @__PURE__ */ createElementVNode("polyline", { points: "15 18 9 12 15 6" }, null, -1), _hoisted_3$8 = [
  _hoisted_2$a
];
function _sfc_render$7(e, t) {
  return openBlock(), createElementBlock("svg", _hoisted_1$b, _hoisted_3$8);
}
const IconChevronLeft = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$7]]), _sfc_main$f = {}, _hoisted_1$a = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, _hoisted_2$9 = /* @__PURE__ */ createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1), _hoisted_3$7 = [
  _hoisted_2$9
];
function _sfc_render$6(e, t) {
  return openBlock(), createElementBlock("svg", _hoisted_1$a, _hoisted_3$7);
}
const IconChevronDown = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$6]]), _sfc_main$e = {}, _hoisted_1$9 = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, _hoisted_2$8 = /* @__PURE__ */ createElementVNode("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" }, null, -1), _hoisted_3$6 = [
  _hoisted_2$8
];
function _sfc_render$5(e, t) {
  return openBlock(), createElementBlock("svg", _hoisted_1$9, _hoisted_3$6);
}
const IconClock = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$5]]), icons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconClock
}, Symbol.toStringTag, { value: "Module" })), _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "BaseIcon",
  props: {
    name: { type: String, required: !0 },
    width: { type: String },
    height: { type: String },
    size: { type: String, default: "26" },
    viewBox: { type: String }
  },
  setup(e) {
    const t = e, n = computed(() => t.width || t.size), s = computed(() => t.height || t.size), i = computed(() => icons[`Icon${t.name}`]);
    return (a, o) => (openBlock(), createBlock(resolveDynamicComponent(unref(i)), {
      width: unref(n),
      height: unref(s),
      class: "vc-base-icon"
    }, null, 8, ["width", "height"]));
  }
});
function windowExists() {
  return typeof window < "u";
}
function windowHasFeature(e) {
  return windowExists() && e in window;
}
function useDarkMode(e) {
  const t = ref(!1), n = computed(() => t.value ? "dark" : "light");
  let s, i;
  function a(g) {
    t.value = g.matches;
  }
  function o() {
    windowHasFeature("matchMedia") && (s = window.matchMedia("(prefers-color-scheme: dark)"), s.addEventListener("change", a), t.value = s.matches);
  }
  function l() {
    const { selector: g = ":root", darkClass: C = "dark" } = e.value, k = document.querySelector(g);
    t.value = k.classList.contains(C);
  }
  function c(g) {
    const { selector: C = ":root", darkClass: k = "dark" } = g;
    if (windowExists() && C && k) {
      const M = document.querySelector(C);
      M && (i = new MutationObserver(l), i.observe(M, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t.value = M.classList.contains(k));
    }
  }
  function u() {
    p();
    const g = typeof e.value;
    g === "string" && e.value.toLowerCase() === "system" ? o() : g === "object" ? c(e.value) : t.value = !!e.value;
  }
  const d = watch(() => e.value, () => u(), {
    immediate: !0
  });
  function p() {
    s && (s.removeEventListener("change", a), s = void 0), i && (i.disconnect(), i = void 0);
  }
  function f() {
    p(), d();
  }
  return onUnmounted(() => f()), {
    isDark: t,
    displayMode: n,
    cleanup: f
  };
}
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$8 = freeGlobal || freeSelf || Function("return this")(), _root = root$8, root$7 = _root, Symbol$5 = root$7.Symbol, _Symbol = Symbol$5, Symbol$4 = _Symbol, objectProto$g = Object.prototype, hasOwnProperty$d = objectProto$g.hasOwnProperty, nativeObjectToString$1 = objectProto$g.toString, symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag$1(e) {
  var t = hasOwnProperty$d.call(e, symToStringTag$1), n = e[symToStringTag$1];
  try {
    e[symToStringTag$1] = void 0;
    var s = !0;
  } catch {
  }
  var i = nativeObjectToString$1.call(e);
  return s && (t ? e[symToStringTag$1] = n : delete e[symToStringTag$1]), i;
}
var _getRawTag = getRawTag$1, objectProto$f = Object.prototype, nativeObjectToString = objectProto$f.toString;
function objectToString$1(e) {
  return nativeObjectToString.call(e);
}
var _objectToString = objectToString$1, Symbol$3 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
function baseGetTag$a(e) {
  return e == null ? e === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(e) ? getRawTag(e) : objectToString(e);
}
var _baseGetTag = baseGetTag$a;
function isObject$a(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var isObject_1 = isObject$a, baseGetTag$9 = _baseGetTag, isObject$9 = isObject_1, asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$3(e) {
  if (!isObject$9(e))
    return !1;
  var t = baseGetTag$9(e);
  return t == funcTag$1 || t == genTag || t == asyncTag || t == proxyTag;
}
var isFunction_1 = isFunction$3, isArray$c = Array.isArray, isArray_1 = isArray$c;
function isObjectLike$b(e) {
  return e != null && typeof e == "object";
}
var isObjectLike_1 = isObjectLike$b, baseGetTag$8 = _baseGetTag, isArray$b = isArray_1, isObjectLike$a = isObjectLike_1, stringTag$2 = "[object String]";
function isString(e) {
  return typeof e == "string" || !isArray$b(e) && isObjectLike$a(e) && baseGetTag$8(e) == stringTag$2;
}
var isString_1 = isString, baseGetTag$7 = _baseGetTag, isObjectLike$9 = isObjectLike_1, boolTag$2 = "[object Boolean]";
function isBoolean(e) {
  return e === !0 || e === !1 || isObjectLike$9(e) && baseGetTag$7(e) == boolTag$2;
}
var isBoolean_1 = isBoolean, baseGetTag$6 = _baseGetTag, isObjectLike$8 = isObjectLike_1, numberTag$2 = "[object Number]";
function isNumber$1(e) {
  return typeof e == "number" || isObjectLike$8(e) && baseGetTag$6(e) == numberTag$2;
}
var isNumber_1 = isNumber$1, baseGetTag$5 = _baseGetTag, isObjectLike$7 = isObjectLike_1, dateTag$2 = "[object Date]";
function baseIsDate$1(e) {
  return isObjectLike$7(e) && baseGetTag$5(e) == dateTag$2;
}
var _baseIsDate = baseIsDate$1;
function baseUnary$2(e) {
  return function(t) {
    return e(t);
  };
}
var _baseUnary = baseUnary$2, _nodeUtilExports = {}, _nodeUtil = {
  get exports() {
    return _nodeUtilExports;
  },
  set exports(e) {
    _nodeUtilExports = e;
  }
};
(function(e, t) {
  var n = _freeGlobal, s = t && !t.nodeType && t, i = s && !0 && e && !e.nodeType && e, a = i && i.exports === s, o = a && n.process, l = function() {
    try {
      var c = i && i.require && i.require("util").types;
      return c || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = l;
})(_nodeUtil, _nodeUtilExports);
var baseIsDate = _baseIsDate, baseUnary$1 = _baseUnary, nodeUtil$1 = _nodeUtilExports, nodeIsDate = nodeUtil$1 && nodeUtil$1.isDate, isDate$1 = nodeIsDate ? baseUnary$1(nodeIsDate) : baseIsDate, isDate_1 = isDate$1, baseGetTag$4 = _baseGetTag, isObjectLike$6 = isObjectLike_1, symbolTag$1 = "[object Symbol]";
function isSymbol$3(e) {
  return typeof e == "symbol" || isObjectLike$6(e) && baseGetTag$4(e) == symbolTag$1;
}
var isSymbol_1 = isSymbol$3, isArray$a = isArray_1, isSymbol$2 = isSymbol_1, reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(e, t) {
  if (isArray$a(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || isSymbol$2(e) ? !0 : reIsPlainProp.test(e) || !reIsDeepProp.test(e) || t != null && e in Object(t);
}
var _isKey = isKey$3, root$6 = _root, coreJsData$1 = root$6["__core-js_shared__"], _coreJsData = coreJsData$1, coreJsData = _coreJsData, maskSrcKey = function() {
  var e = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function isMasked$1(e) {
  return !!maskSrcKey && maskSrcKey in e;
}
var _isMasked = isMasked$1, funcProto$2 = Function.prototype, funcToString$2 = funcProto$2.toString;
function toSource$2(e) {
  if (e != null) {
    try {
      return funcToString$2.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var _toSource = toSource$2, isFunction$2 = isFunction_1, isMasked = _isMasked, isObject$8 = isObject_1, toSource$1 = _toSource, reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto$1 = Function.prototype, objectProto$e = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$c = objectProto$e.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$c).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(e) {
  if (!isObject$8(e) || isMasked(e))
    return !1;
  var t = isFunction$2(e) ? reIsNative : reIsHostCtor;
  return t.test(toSource$1(e));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(e, t) {
  return e == null ? void 0 : e[t];
}
var _getValue = getValue$1, baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(e, t) {
  var n = getValue(e, t);
  return baseIsNative(n) ? n : void 0;
}
var _getNative = getNative$7, getNative$6 = _getNative, nativeCreate$4 = getNative$6(Object, "create"), _nativeCreate = nativeCreate$4, nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}, this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var _hashDelete = hashDelete$1, nativeCreate$2 = _nativeCreate, HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$d = Object.prototype, hasOwnProperty$b = objectProto$d.hasOwnProperty;
function hashGet$1(e) {
  var t = this.__data__;
  if (nativeCreate$2) {
    var n = t[e];
    return n === HASH_UNDEFINED$2 ? void 0 : n;
  }
  return hasOwnProperty$b.call(t, e) ? t[e] : void 0;
}
var _hashGet = hashGet$1, nativeCreate$1 = _nativeCreate, objectProto$c = Object.prototype, hasOwnProperty$a = objectProto$c.hasOwnProperty;
function hashHas$1(e) {
  var t = this.__data__;
  return nativeCreate$1 ? t[e] !== void 0 : hasOwnProperty$a.call(t, e);
}
var _hashHas = hashHas$1, nativeCreate = _nativeCreate, HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = nativeCreate && t === void 0 ? HASH_UNDEFINED$1 : t, this;
}
var _hashSet = hashSet$1, hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype.delete = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [], this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$6(e, t) {
  return e === t || e !== e && t !== t;
}
var eq_1 = eq$6, eq$5 = eq_1;
function assocIndexOf$4(e, t) {
  for (var n = e.length; n--; )
    if (eq$5(e[n][0], t))
      return n;
  return -1;
}
var _assocIndexOf = assocIndexOf$4, assocIndexOf$3 = _assocIndexOf, arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete$1(e) {
  var t = this.__data__, n = assocIndexOf$3(t, e);
  if (n < 0)
    return !1;
  var s = t.length - 1;
  return n == s ? t.pop() : splice.call(t, n, 1), --this.size, !0;
}
var _listCacheDelete = listCacheDelete$1, assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(e) {
  var t = this.__data__, n = assocIndexOf$2(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var _listCacheGet = listCacheGet$1, assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(e) {
  return assocIndexOf$1(this.__data__, e) > -1;
}
var _listCacheHas = listCacheHas$1, assocIndexOf = _assocIndexOf;
function listCacheSet$1(e, t) {
  var n = this.__data__, s = assocIndexOf(n, e);
  return s < 0 ? (++this.size, n.push([e, t])) : n[s][1] = t, this;
}
var _listCacheSet = listCacheSet$1, listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype.delete = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4, getNative$5 = _getNative, root$5 = _root, Map$3 = getNative$5(root$5, "Map"), _Map = Map$3, Hash = _Hash, ListCache$3 = _ListCache, Map$2 = _Map;
function mapCacheClear$1() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$2 || ListCache$3)(),
    string: new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var _isKeyable = isKeyable$1, isKeyable = _isKeyable;
function getMapData$4(e, t) {
  var n = e.__data__;
  return isKeyable(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var _getMapData = getMapData$4, getMapData$3 = _getMapData;
function mapCacheDelete$1(e) {
  var t = getMapData$3(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var _mapCacheDelete = mapCacheDelete$1, getMapData$2 = _getMapData;
function mapCacheGet$1(e) {
  return getMapData$2(this, e).get(e);
}
var _mapCacheGet = mapCacheGet$1, getMapData$1 = _getMapData;
function mapCacheHas$1(e) {
  return getMapData$1(this, e).has(e);
}
var _mapCacheHas = mapCacheHas$1, getMapData = _getMapData;
function mapCacheSet$1(e, t) {
  var n = getMapData(this, e), s = n.size;
  return n.set(e, t), this.size += n.size == s ? 0 : 1, this;
}
var _mapCacheSet = mapCacheSet$1, mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype.delete = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3, MapCache$2 = _MapCache, FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  var n = function() {
    var s = arguments, i = t ? t.apply(this, s) : s[0], a = n.cache;
    if (a.has(i))
      return a.get(i);
    var o = e.apply(this, s);
    return n.cache = a.set(i, o) || a, o;
  };
  return n.cache = new (memoize$1.Cache || MapCache$2)(), n;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1, memoize = memoize_1, MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(e) {
  var t = memoize(e, function(s) {
    return n.size === MAX_MEMOIZE_SIZE && n.clear(), s;
  }), n = t.cache;
  return t;
}
var _memoizeCapped = memoizeCapped$1, memoizeCapped = _memoizeCapped, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath$1 = memoizeCapped(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(rePropName, function(n, s, i, a) {
    t.push(i ? a.replace(reEscapeChar, "$1") : s || n);
  }), t;
}), _stringToPath = stringToPath$1;
function arrayMap$1(e, t) {
  for (var n = -1, s = e == null ? 0 : e.length, i = Array(s); ++n < s; )
    i[n] = t(e[n], n, e);
  return i;
}
var _arrayMap = arrayMap$1, Symbol$2 = _Symbol, arrayMap = _arrayMap, isArray$9 = isArray_1, isSymbol$1 = isSymbol_1, INFINITY$1 = 1 / 0, symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(e) {
  if (typeof e == "string")
    return e;
  if (isArray$9(e))
    return arrayMap(e, baseToString$1) + "";
  if (isSymbol$1(e))
    return symbolToString ? symbolToString.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -INFINITY$1 ? "-0" : t;
}
var _baseToString = baseToString$1, baseToString = _baseToString;
function toString$1(e) {
  return e == null ? "" : baseToString(e);
}
var toString_1 = toString$1, isArray$8 = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString = toString_1;
function castPath$2(e, t) {
  return isArray$8(e) ? e : isKey$2(e, t) ? [e] : stringToPath(toString(e));
}
var _castPath = castPath$2, isSymbol = isSymbol_1, INFINITY$2 = 1 / 0;
function toKey$4(e) {
  if (typeof e == "string" || isSymbol(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -INFINITY$2 ? "-0" : t;
}
var _toKey = toKey$4, castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$2(e, t) {
  t = castPath$1(t, e);
  for (var n = 0, s = t.length; e != null && n < s; )
    e = e[toKey$3(t[n++])];
  return n && n == s ? e : void 0;
}
var _baseGet = baseGet$2, baseGet$1 = _baseGet;
function get$1(e, t, n) {
  var s = e == null ? void 0 : baseGet$1(e, t);
  return s === void 0 ? n : s;
}
var get_1 = get$1, getNative$4 = _getNative, defineProperty$2 = function() {
  try {
    var e = getNative$4(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), _defineProperty$1 = defineProperty$2, defineProperty$1 = _defineProperty$1;
function baseAssignValue$4(e, t, n) {
  t == "__proto__" && defineProperty$1 ? defineProperty$1(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var _baseAssignValue = baseAssignValue$4, baseAssignValue$3 = _baseAssignValue, eq$4 = eq_1, objectProto$b = Object.prototype, hasOwnProperty$9 = objectProto$b.hasOwnProperty;
function assignValue$1(e, t, n) {
  var s = e[t];
  (!(hasOwnProperty$9.call(e, t) && eq$4(s, n)) || n === void 0 && !(t in e)) && baseAssignValue$3(e, t, n);
}
var _assignValue = assignValue$1, MAX_SAFE_INTEGER$1 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$3(e, t) {
  var n = typeof e;
  return t = t ?? MAX_SAFE_INTEGER$1, !!t && (n == "number" || n != "symbol" && reIsUint.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var _isIndex = isIndex$3;
function createBaseFor$1(e) {
  return function(t, n, s) {
    for (var i = -1, a = Object(t), o = s(t), l = o.length; l--; ) {
      var c = o[e ? l : ++i];
      if (n(a[c], c, a) === !1)
        break;
    }
    return t;
  };
}
var _createBaseFor = createBaseFor$1, createBaseFor = _createBaseFor, baseFor$2 = createBaseFor(), _baseFor = baseFor$2;
function baseTimes$1(e, t) {
  for (var n = -1, s = Array(e); ++n < e; )
    s[n] = t(n);
  return s;
}
var _baseTimes = baseTimes$1, baseGetTag$3 = _baseGetTag, isObjectLike$5 = isObjectLike_1, argsTag$2 = "[object Arguments]";
function baseIsArguments$1(e) {
  return isObjectLike$5(e) && baseGetTag$3(e) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1, baseIsArguments = _baseIsArguments, isObjectLike$4 = isObjectLike_1, objectProto$a = Object.prototype, hasOwnProperty$8 = objectProto$a.hasOwnProperty, propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable, isArguments$3 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(e) {
  return isObjectLike$4(e) && hasOwnProperty$8.call(e, "callee") && !propertyIsEnumerable$1.call(e, "callee");
}, isArguments_1 = isArguments$3, isBufferExports = {}, isBuffer$3 = {
  get exports() {
    return isBufferExports;
  },
  set exports(e) {
    isBufferExports = e;
  }
};
function stubFalse() {
  return !1;
}
var stubFalse_1 = stubFalse;
(function(e, t) {
  var n = _root, s = stubFalse_1, i = t && !t.nodeType && t, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, l = o ? n.Buffer : void 0, c = l ? l.isBuffer : void 0, u = c || s;
  e.exports = u;
})(isBuffer$3, isBufferExports);
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3, baseGetTag$2 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$3 = isObjectLike_1, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$3 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray$1(e) {
  return isObjectLike$3(e) && isLength$2(e.length) && !!typedArrayTags[baseGetTag$2(e)];
}
var _baseIsTypedArray = baseIsTypedArray$1, baseIsTypedArray = _baseIsTypedArray, baseUnary = _baseUnary, nodeUtil = _nodeUtilExports, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray$3 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray, isTypedArray_1 = isTypedArray$3, baseTimes = _baseTimes, isArguments$2 = isArguments_1, isArray$7 = isArray_1, isBuffer$2 = isBufferExports, isIndex$2 = _isIndex, isTypedArray$2 = isTypedArray_1, objectProto$9 = Object.prototype, hasOwnProperty$7 = objectProto$9.hasOwnProperty;
function arrayLikeKeys$2(e, t) {
  var n = isArray$7(e), s = !n && isArguments$2(e), i = !n && !s && isBuffer$2(e), a = !n && !s && !i && isTypedArray$2(e), o = n || s || i || a, l = o ? baseTimes(e.length, String) : [], c = l.length;
  for (var u in e)
    (t || hasOwnProperty$7.call(e, u)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    isIndex$2(u, c))) && l.push(u);
  return l;
}
var _arrayLikeKeys = arrayLikeKeys$2, objectProto$8 = Object.prototype;
function isPrototype$3(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || objectProto$8;
  return e === n;
}
var _isPrototype = isPrototype$3;
function overArg$2(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var _overArg = overArg$2, overArg$1 = _overArg, nativeKeys$1 = overArg$1(Object.keys, Object), _nativeKeys = nativeKeys$1, isPrototype$2 = _isPrototype, nativeKeys = _nativeKeys, objectProto$7 = Object.prototype, hasOwnProperty$6 = objectProto$7.hasOwnProperty;
function baseKeys$1(e) {
  if (!isPrototype$2(e))
    return nativeKeys(e);
  var t = [];
  for (var n in Object(e))
    hasOwnProperty$6.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var _baseKeys = baseKeys$1, isFunction$1 = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$5(e) {
  return e != null && isLength$1(e.length) && !isFunction$1(e);
}
var isArrayLike_1 = isArrayLike$5, arrayLikeKeys$1 = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$4 = isArrayLike_1;
function keys$3(e) {
  return isArrayLike$4(e) ? arrayLikeKeys$1(e) : baseKeys(e);
}
var keys_1 = keys$3, baseFor$1 = _baseFor, keys$2 = keys_1;
function baseForOwn$2(e, t) {
  return e && baseFor$1(e, t, keys$2);
}
var _baseForOwn = baseForOwn$2, ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2(), this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var _stackDelete = stackDelete$1;
function stackGet$1(e) {
  return this.__data__.get(e);
}
var _stackGet = stackGet$1;
function stackHas$1(e) {
  return this.__data__.has(e);
}
var _stackHas = stackHas$1, ListCache$1 = _ListCache, Map$1 = _Map, MapCache$1 = _MapCache, LARGE_ARRAY_SIZE = 200;
function stackSet$1(e, t) {
  var n = this.__data__;
  if (n instanceof ListCache$1) {
    var s = n.__data__;
    if (!Map$1 || s.length < LARGE_ARRAY_SIZE - 1)
      return s.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new MapCache$1(s);
  }
  return n.set(e, t), this.size = n.size, this;
}
var _stackSet = stackSet$1, ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$3(e) {
  var t = this.__data__ = new ListCache(e);
  this.size = t.size;
}
Stack$3.prototype.clear = stackClear;
Stack$3.prototype.delete = stackDelete;
Stack$3.prototype.get = stackGet;
Stack$3.prototype.has = stackHas;
Stack$3.prototype.set = stackSet;
var _Stack = Stack$3, HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(e) {
  return this.__data__.set(e, HASH_UNDEFINED), this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(e) {
  return this.__data__.has(e);
}
var _setCacheHas = setCacheHas$1, MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$1(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new MapCache(); ++t < n; )
    this.add(e[t]);
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$2(e, t) {
  for (var n = -1, s = e == null ? 0 : e.length; ++n < s; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var _arraySome = arraySome$2;
function cacheHas$1(e, t) {
  return e.has(t);
}
var _cacheHas = cacheHas$1, SetCache = _SetCache, arraySome$1 = _arraySome, cacheHas = _cacheHas, COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(e, t, n, s, i, a) {
  var o = n & COMPARE_PARTIAL_FLAG$5, l = e.length, c = t.length;
  if (l != c && !(o && c > l))
    return !1;
  var u = a.get(e), d = a.get(t);
  if (u && d)
    return u == t && d == e;
  var p = -1, f = !0, g = n & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (a.set(e, t), a.set(t, e); ++p < l; ) {
    var C = e[p], k = t[p];
    if (s)
      var M = o ? s(k, C, p, t, e, a) : s(C, k, p, e, t, a);
    if (M !== void 0) {
      if (M)
        continue;
      f = !1;
      break;
    }
    if (g) {
      if (!arraySome$1(t, function(_, S) {
        if (!cacheHas(g, S) && (C === _ || i(C, _, n, s, a)))
          return g.push(S);
      })) {
        f = !1;
        break;
      }
    } else if (!(C === k || i(C, k, n, s, a))) {
      f = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), f;
}
var _equalArrays = equalArrays$2, root$4 = _root, Uint8Array$2 = root$4.Uint8Array, _Uint8Array = Uint8Array$2;
function mapToArray$1(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(s, i) {
    n[++t] = [i, s];
  }), n;
}
var _mapToArray = mapToArray$1;
function setToArray$1(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(s) {
    n[++t] = s;
  }), n;
}
var _setToArray = setToArray$1, Symbol$1 = _Symbol, Uint8Array$1 = _Uint8Array, eq$3 = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray, COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(e, t, n, s, i, a, o) {
  switch (n) {
    case dataViewTag$1:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case arrayBufferTag:
      return !(e.byteLength != t.byteLength || !a(new Uint8Array$1(e), new Uint8Array$1(t)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq$3(+e, +t);
    case errorTag:
      return e.name == t.name && e.message == t.message;
    case regexpTag:
    case stringTag:
      return e == t + "";
    case mapTag$1:
      var l = mapToArray;
    case setTag$1:
      var c = s & COMPARE_PARTIAL_FLAG$4;
      if (l || (l = setToArray), e.size != t.size && !c)
        return !1;
      var u = o.get(e);
      if (u)
        return u == t;
      s |= COMPARE_UNORDERED_FLAG$2, o.set(e, t);
      var d = equalArrays$1(l(e), l(t), s, i, a, o);
      return o.delete(e), d;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(e) == symbolValueOf.call(t);
  }
  return !1;
}
var _equalByTag = equalByTag$1;
function arrayPush$1(e, t) {
  for (var n = -1, s = t.length, i = e.length; ++n < s; )
    e[i + n] = t[n];
  return e;
}
var _arrayPush = arrayPush$1, arrayPush = _arrayPush, isArray$6 = isArray_1;
function baseGetAllKeys$1(e, t, n) {
  var s = t(e);
  return isArray$6(e) ? s : arrayPush(s, n(e));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(e, t) {
  for (var n = -1, s = e == null ? 0 : e.length, i = 0, a = []; ++n < s; ) {
    var o = e[n];
    t(o, n, e) && (a[i++] = o);
  }
  return a;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1, arrayFilter = _arrayFilter, stubArray = stubArray_1, objectProto$6 = Object.prototype, propertyIsEnumerable = objectProto$6.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols$1 = nativeGetSymbols ? function(e) {
  return e == null ? [] : (e = Object(e), arrayFilter(nativeGetSymbols(e), function(t) {
    return propertyIsEnumerable.call(e, t);
  }));
} : stubArray, _getSymbols = getSymbols$1, baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$1 = keys_1;
function getAllKeys$1(e) {
  return baseGetAllKeys(e, keys$1, getSymbols);
}
var _getAllKeys = getAllKeys$1, getAllKeys = _getAllKeys, COMPARE_PARTIAL_FLAG$3 = 1, objectProto$5 = Object.prototype, hasOwnProperty$5 = objectProto$5.hasOwnProperty;
function equalObjects$1(e, t, n, s, i, a) {
  var o = n & COMPARE_PARTIAL_FLAG$3, l = getAllKeys(e), c = l.length, u = getAllKeys(t), d = u.length;
  if (c != d && !o)
    return !1;
  for (var p = c; p--; ) {
    var f = l[p];
    if (!(o ? f in t : hasOwnProperty$5.call(t, f)))
      return !1;
  }
  var g = a.get(e), C = a.get(t);
  if (g && C)
    return g == t && C == e;
  var k = !0;
  a.set(e, t), a.set(t, e);
  for (var M = o; ++p < c; ) {
    f = l[p];
    var _ = e[f], S = t[f];
    if (s)
      var E = o ? s(S, _, f, t, e, a) : s(_, S, f, e, t, a);
    if (!(E === void 0 ? _ === S || i(_, S, n, s, a) : E)) {
      k = !1;
      break;
    }
    M || (M = f == "constructor");
  }
  if (k && !M) {
    var P = e.constructor, $ = t.constructor;
    P != $ && "constructor" in e && "constructor" in t && !(typeof P == "function" && P instanceof P && typeof $ == "function" && $ instanceof $) && (k = !1);
  }
  return a.delete(e), a.delete(t), k;
}
var _equalObjects = equalObjects$1, getNative$3 = _getNative, root$3 = _root, DataView$1 = getNative$3(root$3, "DataView"), _DataView = DataView$1, getNative$2 = _getNative, root$2 = _root, Promise$2 = getNative$2(root$2, "Promise"), _Promise = Promise$2, getNative$1 = _getNative, root$1 = _root, Set$1 = getNative$1(root$1, "Set"), _Set = Set$1, getNative = _getNative, root = _root, WeakMap$1 = getNative(root, "WeakMap"), _WeakMap = WeakMap$1, DataView = _DataView, Map$4 = _Map, Promise$1 = _Promise, Set$2 = _Set, WeakMap$2 = _WeakMap, baseGetTag$1 = _baseGetTag, toSource = _toSource, mapTag = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$4), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$2), getTag$1 = baseGetTag$1;
(DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag || Map$4 && getTag$1(new Map$4()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$2 && getTag$1(new Set$2()) != setTag || WeakMap$2 && getTag$1(new WeakMap$2()) != weakMapTag) && (getTag$1 = function(e) {
  var t = baseGetTag$1(e), n = t == objectTag$2 ? e.constructor : void 0, s = n ? toSource(n) : "";
  if (s)
    switch (s) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return t;
});
var _getTag = getTag$1, Stack$2 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$5 = isArray_1, isBuffer$1 = isBufferExports, isTypedArray$1 = isTypedArray_1, COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag$1 = "[object Object]", objectProto$4 = Object.prototype, hasOwnProperty$4 = objectProto$4.hasOwnProperty;
function baseIsEqualDeep$1(e, t, n, s, i, a) {
  var o = isArray$5(e), l = isArray$5(t), c = o ? arrayTag : getTag(e), u = l ? arrayTag : getTag(t);
  c = c == argsTag ? objectTag$1 : c, u = u == argsTag ? objectTag$1 : u;
  var d = c == objectTag$1, p = u == objectTag$1, f = c == u;
  if (f && isBuffer$1(e)) {
    if (!isBuffer$1(t))
      return !1;
    o = !0, d = !1;
  }
  if (f && !d)
    return a || (a = new Stack$2()), o || isTypedArray$1(e) ? equalArrays(e, t, n, s, i, a) : equalByTag(e, t, c, n, s, i, a);
  if (!(n & COMPARE_PARTIAL_FLAG$2)) {
    var g = d && hasOwnProperty$4.call(e, "__wrapped__"), C = p && hasOwnProperty$4.call(t, "__wrapped__");
    if (g || C) {
      var k = g ? e.value() : e, M = C ? t.value() : t;
      return a || (a = new Stack$2()), i(k, M, n, s, a);
    }
  }
  return f ? (a || (a = new Stack$2()), equalObjects(e, t, n, s, i, a)) : !1;
}
var _baseIsEqualDeep = baseIsEqualDeep$1, baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$2 = isObjectLike_1;
function baseIsEqual$2(e, t, n, s, i) {
  return e === t ? !0 : e == null || t == null || !isObjectLike$2(e) && !isObjectLike$2(t) ? e !== e && t !== t : baseIsEqualDeep(e, t, n, s, baseIsEqual$2, i);
}
var _baseIsEqual = baseIsEqual$2, Stack$1 = _Stack, baseIsEqual$1 = _baseIsEqual, COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(e, t, n, s) {
  var i = n.length, a = i, o = !s;
  if (e == null)
    return !a;
  for (e = Object(e); i--; ) {
    var l = n[i];
    if (o && l[2] ? l[1] !== e[l[0]] : !(l[0] in e))
      return !1;
  }
  for (; ++i < a; ) {
    l = n[i];
    var c = l[0], u = e[c], d = l[1];
    if (o && l[2]) {
      if (u === void 0 && !(c in e))
        return !1;
    } else {
      var p = new Stack$1();
      if (s)
        var f = s(u, d, c, e, t, p);
      if (!(f === void 0 ? baseIsEqual$1(d, u, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, s, p) : f))
        return !1;
    }
  }
  return !0;
}
var _baseIsMatch = baseIsMatch$1, isObject$7 = isObject_1;
function isStrictComparable$2(e) {
  return e === e && !isObject$7(e);
}
var _isStrictComparable = isStrictComparable$2, isStrictComparable$1 = _isStrictComparable, keys = keys_1;
function getMatchData$1(e) {
  for (var t = keys(e), n = t.length; n--; ) {
    var s = t[n], i = e[s];
    t[n] = [s, i, isStrictComparable$1(i)];
  }
  return t;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2, baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(e) {
  var t = getMatchData(e);
  return t.length == 1 && t[0][2] ? matchesStrictComparable$1(t[0][0], t[0][1]) : function(n) {
    return n === e || baseIsMatch(n, e, t);
  };
}
var _baseMatches = baseMatches$1;
function baseHasIn$1(e, t) {
  return e != null && t in Object(e);
}
var _baseHasIn = baseHasIn$1, castPath = _castPath, isArguments$1 = isArguments_1, isArray$4 = isArray_1, isIndex$1 = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$2(e, t, n) {
  t = castPath(t, e);
  for (var s = -1, i = t.length, a = !1; ++s < i; ) {
    var o = toKey$2(t[s]);
    if (!(a = e != null && n(e, o)))
      break;
    e = e[o];
  }
  return a || ++s != i ? a : (i = e == null ? 0 : e.length, !!i && isLength(i) && isIndex$1(o, i) && (isArray$4(e) || isArguments$1(e)));
}
var _hasPath = hasPath$2, baseHasIn = _baseHasIn, hasPath$1 = _hasPath;
function hasIn$1(e, t) {
  return e != null && hasPath$1(e, t, baseHasIn);
}
var hasIn_1 = hasIn$1, baseIsEqual = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey, COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(e, t) {
  return isKey$1(e) && isStrictComparable(t) ? matchesStrictComparable(toKey$1(e), t) : function(n) {
    var s = get(n, e);
    return s === void 0 && s === t ? hasIn(n, e) : baseIsEqual(t, s, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$3(e) {
  return e;
}
var identity_1 = identity$3;
function baseProperty$1(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var _baseProperty = baseProperty$1, baseGet = _baseGet;
function basePropertyDeep$1(e) {
  return function(t) {
    return baseGet(t, e);
  };
}
var _basePropertyDeep = basePropertyDeep$1, baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(e) {
  return isKey(e) ? baseProperty(toKey(e)) : basePropertyDeep(e);
}
var property_1 = property$1, baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$2 = identity_1, isArray$3 = isArray_1, property = property_1;
function baseIteratee$2(e) {
  return typeof e == "function" ? e : e == null ? identity$2 : typeof e == "object" ? isArray$3(e) ? baseMatchesProperty(e[0], e[1]) : baseMatches(e) : property(e);
}
var _baseIteratee = baseIteratee$2, baseAssignValue$2 = _baseAssignValue, baseForOwn$1 = _baseForOwn, baseIteratee$1 = _baseIteratee;
function mapValues(e, t) {
  var n = {};
  return t = baseIteratee$1(t), baseForOwn$1(e, function(s, i, a) {
    baseAssignValue$2(n, i, t(s, i, a));
  }), n;
}
var mapValues_1 = mapValues;
function apply$2(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var _apply = apply$2, apply$1 = _apply, nativeMax = Math.max;
function overRest$1(e, t, n) {
  return t = nativeMax(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var s = arguments, i = -1, a = nativeMax(s.length - t, 0), o = Array(a); ++i < a; )
      o[i] = s[t + i];
    i = -1;
    for (var l = Array(t + 1); ++i < t; )
      l[i] = s[i];
    return l[t] = n(o), apply$1(e, this, l);
  };
}
var _overRest = overRest$1;
function constant$1(e) {
  return function() {
    return e;
  };
}
var constant_1 = constant$1, constant = constant_1, defineProperty = _defineProperty$1, identity$1 = identity_1, baseSetToString$1 = defineProperty ? function(e, t) {
  return defineProperty(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant(t),
    writable: !0
  });
} : identity$1, _baseSetToString = baseSetToString$1, HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut$1(e) {
  var t = 0, n = 0;
  return function() {
    var s = nativeNow(), i = HOT_SPAN - (s - n);
    if (n = s, i > 0) {
      if (++t >= HOT_COUNT)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1, baseSetToString = _baseSetToString, shortOut = _shortOut, setToString$1 = shortOut(baseSetToString), _setToString = setToString$1, identity = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$3(e, t) {
  return setToString(overRest(e, t, identity), e + "");
}
var _baseRest = baseRest$3, eq$2 = eq_1, isArrayLike$3 = isArrayLike_1, isIndex = _isIndex, isObject$6 = isObject_1;
function isIterateeCall$3(e, t, n) {
  if (!isObject$6(n))
    return !1;
  var s = typeof t;
  return (s == "number" ? isArrayLike$3(n) && isIndex(t, n.length) : s == "string" && t in n) ? eq$2(n[t], e) : !1;
}
var _isIterateeCall = isIterateeCall$3;
function nativeKeysIn$1(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var _nativeKeysIn = nativeKeysIn$1, isObject$5 = isObject_1, isPrototype$1 = _isPrototype, nativeKeysIn = _nativeKeysIn, objectProto$3 = Object.prototype, hasOwnProperty$3 = objectProto$3.hasOwnProperty;
function baseKeysIn$1(e) {
  if (!isObject$5(e))
    return nativeKeysIn(e);
  var t = isPrototype$1(e), n = [];
  for (var s in e)
    s == "constructor" && (t || !hasOwnProperty$3.call(e, s)) || n.push(s);
  return n;
}
var _baseKeysIn = baseKeysIn$1, arrayLikeKeys = _arrayLikeKeys, baseKeysIn = _baseKeysIn, isArrayLike$2 = isArrayLike_1;
function keysIn$3(e) {
  return isArrayLike$2(e) ? arrayLikeKeys(e, !0) : baseKeysIn(e);
}
var keysIn_1 = keysIn$3, baseRest$2 = _baseRest, eq$1 = eq_1, isIterateeCall$2 = _isIterateeCall, keysIn$2 = keysIn_1, objectProto$2 = Object.prototype, hasOwnProperty$2 = objectProto$2.hasOwnProperty, defaults$1 = baseRest$2(function(e, t) {
  e = Object(e);
  var n = -1, s = t.length, i = s > 2 ? t[2] : void 0;
  for (i && isIterateeCall$2(t[0], t[1], i) && (s = 1); ++n < s; )
    for (var a = t[n], o = keysIn$2(a), l = -1, c = o.length; ++l < c; ) {
      var u = o[l], d = e[u];
      (d === void 0 || eq$1(d, objectProto$2[u]) && !hasOwnProperty$2.call(e, u)) && (e[u] = a[u]);
    }
  return e;
}), defaults_1 = defaults$1, baseAssignValue$1 = _baseAssignValue, eq$7 = eq_1;
function assignMergeValue$2(e, t, n) {
  (n !== void 0 && !eq$7(e[t], n) || n === void 0 && !(t in e)) && baseAssignValue$1(e, t, n);
}
var _assignMergeValue = assignMergeValue$2, _cloneBufferExports = {}, _cloneBuffer = {
  get exports() {
    return _cloneBufferExports;
  },
  set exports(e) {
    _cloneBufferExports = e;
  }
};
(function(e, t) {
  var n = _root, s = t && !t.nodeType && t, i = s && !0 && e && !e.nodeType && e, a = i && i.exports === s, o = a ? n.Buffer : void 0, l = o ? o.allocUnsafe : void 0;
  function c(u, d) {
    if (d)
      return u.slice();
    var p = u.length, f = l ? l(p) : new u.constructor(p);
    return u.copy(f), f;
  }
  e.exports = c;
})(_cloneBuffer, _cloneBufferExports);
var Uint8Array2 = _Uint8Array;
function cloneArrayBuffer$1(e) {
  var t = new e.constructor(e.byteLength);
  return new Uint8Array2(t).set(new Uint8Array2(e)), t;
}
var _cloneArrayBuffer = cloneArrayBuffer$1, cloneArrayBuffer = _cloneArrayBuffer;
function cloneTypedArray$1(e, t) {
  var n = t ? cloneArrayBuffer(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var _cloneTypedArray = cloneTypedArray$1;
function copyArray$1(e, t) {
  var n = -1, s = e.length;
  for (t || (t = Array(s)); ++n < s; )
    t[n] = e[n];
  return t;
}
var _copyArray = copyArray$1, isObject$4 = isObject_1, objectCreate = Object.create, baseCreate$1 = function() {
  function e() {
  }
  return function(t) {
    if (!isObject$4(t))
      return {};
    if (objectCreate)
      return objectCreate(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), _baseCreate = baseCreate$1, overArg = _overArg, getPrototype$2 = overArg(Object.getPrototypeOf, Object), _getPrototype = getPrototype$2, baseCreate = _baseCreate, getPrototype$1 = _getPrototype, isPrototype = _isPrototype;
function initCloneObject$1(e) {
  return typeof e.constructor == "function" && !isPrototype(e) ? baseCreate(getPrototype$1(e)) : {};
}
var _initCloneObject = initCloneObject$1, isArrayLike$1 = isArrayLike_1, isObjectLike$1 = isObjectLike_1;
function isArrayLikeObject$1(e) {
  return isObjectLike$1(e) && isArrayLike$1(e);
}
var isArrayLikeObject_1 = isArrayLikeObject$1, baseGetTag = _baseGetTag, getPrototype = _getPrototype, isObjectLike = isObjectLike_1, objectTag = "[object Object]", funcProto = Function.prototype, objectProto$1 = Object.prototype, funcToString = funcProto.toString, hasOwnProperty$1 = objectProto$1.hasOwnProperty, objectCtorString = funcToString.call(Object);
function isPlainObject$1(e) {
  if (!isObjectLike(e) || baseGetTag(e) != objectTag)
    return !1;
  var t = getPrototype(e);
  if (t === null)
    return !0;
  var n = hasOwnProperty$1.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && funcToString.call(n) == objectCtorString;
}
var isPlainObject_1 = isPlainObject$1;
function safeGet$2(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var _safeGet = safeGet$2, assignValue = _assignValue, baseAssignValue = _baseAssignValue;
function copyObject$1(e, t, n, s) {
  var i = !n;
  n || (n = {});
  for (var a = -1, o = t.length; ++a < o; ) {
    var l = t[a], c = s ? s(n[l], e[l], l, n, e) : void 0;
    c === void 0 && (c = e[l]), i ? baseAssignValue(n, l, c) : assignValue(n, l, c);
  }
  return n;
}
var _copyObject = copyObject$1, copyObject = _copyObject, keysIn$1 = keysIn_1;
function toPlainObject$1(e) {
  return copyObject(e, keysIn$1(e));
}
var toPlainObject_1 = toPlainObject$1, assignMergeValue$1 = _assignMergeValue, cloneBuffer = _cloneBufferExports, cloneTypedArray = _cloneTypedArray, copyArray = _copyArray, initCloneObject = _initCloneObject, isArguments = isArguments_1, isArray$2 = isArray_1, isArrayLikeObject = isArrayLikeObject_1, isBuffer = isBufferExports, isFunction$4 = isFunction_1, isObject$3 = isObject_1, isPlainObject = isPlainObject_1, isTypedArray = isTypedArray_1, safeGet$1 = _safeGet, toPlainObject = toPlainObject_1;
function baseMergeDeep$1(e, t, n, s, i, a, o) {
  var l = safeGet$1(e, n), c = safeGet$1(t, n), u = o.get(c);
  if (u) {
    assignMergeValue$1(e, n, u);
    return;
  }
  var d = a ? a(l, c, n + "", e, t, o) : void 0, p = d === void 0;
  if (p) {
    var f = isArray$2(c), g = !f && isBuffer(c), C = !f && !g && isTypedArray(c);
    d = c, f || g || C ? isArray$2(l) ? d = l : isArrayLikeObject(l) ? d = copyArray(l) : g ? (p = !1, d = cloneBuffer(c, !0)) : C ? (p = !1, d = cloneTypedArray(c, !0)) : d = [] : isPlainObject(c) || isArguments(c) ? (d = l, isArguments(l) ? d = toPlainObject(l) : (!isObject$3(l) || isFunction$4(l)) && (d = initCloneObject(c))) : p = !1;
  }
  p && (o.set(c, d), i(d, c, s, a, o), o.delete(c)), assignMergeValue$1(e, n, d);
}
var _baseMergeDeep = baseMergeDeep$1, Stack = _Stack, assignMergeValue = _assignMergeValue, baseFor = _baseFor, baseMergeDeep = _baseMergeDeep, isObject$2 = isObject_1, keysIn = keysIn_1, safeGet = _safeGet;
function baseMerge$2(e, t, n, s, i) {
  e !== t && baseFor(t, function(a, o) {
    if (i || (i = new Stack()), isObject$2(a))
      baseMergeDeep(e, t, o, n, baseMerge$2, s, i);
    else {
      var l = s ? s(safeGet(e, o), a, o + "", e, t, i) : void 0;
      l === void 0 && (l = a), assignMergeValue(e, o, l);
    }
  }, keysIn);
}
var _baseMerge = baseMerge$2, baseMerge$1 = _baseMerge, isObject$1 = isObject_1;
function customDefaultsMerge$1(e, t, n, s, i, a) {
  return isObject$1(e) && isObject$1(t) && (a.set(t, e), baseMerge$1(e, t, void 0, customDefaultsMerge$1, a), a.delete(t)), e;
}
var _customDefaultsMerge = customDefaultsMerge$1, baseRest$1 = _baseRest, isIterateeCall$1 = _isIterateeCall;
function createAssigner$1(e) {
  return baseRest$1(function(t, n) {
    var s = -1, i = n.length, a = i > 1 ? n[i - 1] : void 0, o = i > 2 ? n[2] : void 0;
    for (a = e.length > 3 && typeof a == "function" ? (i--, a) : void 0, o && isIterateeCall$1(n[0], n[1], o) && (a = i < 3 ? void 0 : a, i = 1), t = Object(t); ++s < i; ) {
      var l = n[s];
      l && e(t, l, s, a);
    }
    return t;
  });
}
var _createAssigner = createAssigner$1, baseMerge = _baseMerge, createAssigner = _createAssigner, mergeWith$1 = createAssigner(function(e, t, n, s) {
  baseMerge(e, t, n, s);
}), mergeWith_1 = mergeWith$1, apply = _apply, baseRest = _baseRest, customDefaultsMerge = _customDefaultsMerge, mergeWith = mergeWith_1, defaultsDeep = baseRest(function(e) {
  return e.push(void 0, customDefaultsMerge), apply(mergeWith, void 0, e);
}), defaultsDeep_1 = defaultsDeep, objectProto = Object.prototype, hasOwnProperty = objectProto.hasOwnProperty;
function baseHas$1(e, t) {
  return e != null && hasOwnProperty.call(e, t);
}
var _baseHas = baseHas$1, baseHas = _baseHas, hasPath = _hasPath;
function has$1(e, t) {
  return e != null && hasPath(e, t, baseHas);
}
var has_1 = has$1, isArrayLike = isArrayLike_1;
function createBaseEach$1(e, t) {
  return function(n, s) {
    if (n == null)
      return n;
    if (!isArrayLike(n))
      return e(n, s);
    for (var i = n.length, a = t ? i : -1, o = Object(n); (t ? a-- : ++a < i) && s(o[a], a, o) !== !1; )
      ;
    return n;
  };
}
var _createBaseEach = createBaseEach$1, baseForOwn = _baseForOwn, createBaseEach = _createBaseEach, baseEach$1 = createBaseEach(baseForOwn), _baseEach = baseEach$1;
function head(e) {
  return e && e.length ? e[0] : void 0;
}
var head_1 = head;
function last(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var last_1 = last, baseEach = _baseEach;
function baseSome$1(e, t) {
  var n;
  return baseEach(e, function(s, i, a) {
    return n = t(s, i, a), !n;
  }), !!n;
}
var _baseSome = baseSome$1, arraySome = _arraySome, baseIteratee = _baseIteratee, baseSome = _baseSome, isArray$1 = isArray_1, isIterateeCall = _isIterateeCall;
function some(e, t, n) {
  var s = isArray$1(e) ? arraySome : baseSome;
  return n && isIterateeCall(e, t, n) && (t = void 0), s(e, baseIteratee(t));
}
var some_1 = some;
const getType = (e) => Object.prototype.toString.call(e).slice(8, -1), isDate$2 = (e) => isDate_1(e) && !isNaN(e.getTime()), isObject$b = (e) => getType(e) === "Object", has = has_1, hasAny = (e, t) => some_1(t, (n) => has_1(e, n)), pad = (e, t, n = "0") => {
  for (e = e != null ? String(e) : "", t = t || 2; e.length < t; )
    e = `${n}${e}`;
  return e;
}, isArray$d = (e) => Array.isArray(e), arrayHasItems = (e) => isArray$d(e) && e.length > 0, resolveEl = (e) => e == null ? e ?? null : document && isString_1(e) ? document.querySelector(e) : e.$el ?? e, off = (e, t, n, s = void 0) => {
  e.removeEventListener(t, n, s);
}, on = (e, t, n, s = void 0) => (e.addEventListener(t, n, s), () => off(e, t, n, s)), elementContains = (e, t) => !!e && !!t && (e === t || e.contains(t)), onSpaceOrEnter = (e, t) => {
  (e.key === " " || e.key === "Enter") && (t(e), e.preventDefault());
}, omit = (e, ...t) => {
  const n = {};
  let s;
  for (s in e)
    t.includes(s) || (n[s] = e[s]);
  return n;
}, pick = (e, t) => {
  const n = {};
  return t.forEach((s) => {
    s in e && (n[s] = e[s]);
  }), n;
};
function clamp(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
const createGuid = () => {
  function e() {
    return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
  }
  return `${e() + e()}-${e()}-${e()}-${e()}-${e()}${e()}${e()}`;
}, targetProps = ["base", "start", "end", "startEnd"], displayProps = [
  "class",
  "wrapperClass",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], _defaultProfile = { base: {}, start: {}, end: {} };
function normalizeConfig(e, t, n = _defaultProfile) {
  let s = e, i = {};
  t === !0 || isString_1(t) ? (s = isString_1(t) ? t : s, i = { ...n }) : isObject$b(t) && (hasAny(t, targetProps) ? i = { ...t } : i = {
    base: { ...t },
    start: { ...t },
    end: { ...t }
  });
  const a = defaultsDeep_1(
    i,
    { start: i.startEnd, end: i.startEnd },
    n
  );
  return Object.entries(a).forEach(([o, l]) => {
    let c = s;
    l === !0 || isString_1(l) ? (c = isString_1(l) ? l : c, a[o] = { color: c }) : isObject$b(l) && (hasAny(l, displayProps) ? a[o] = { ...l } : a[o] = {}), defaultsDeep_1(a[o], { color: c });
  }), a;
}
class HighlightRenderer {
  constructor() {
    __publicField(this, "type", "highlight");
  }
  normalizeConfig(t, n) {
    return normalizeConfig(t, n, {
      base: { fillMode: "light" },
      start: { fillMode: "solid" },
      end: { fillMode: "solid" }
    });
  }
  prepareRender(t) {
    t.highlights = [], t.content || (t.content = []);
  }
  render({ data: t, onStart: n, onEnd: s }, i) {
    const { key: a, highlight: o } = t;
    if (!o)
      return;
    const { highlights: l } = i, { base: c, start: u, end: d } = o;
    n && s ? l.push({
      ...u,
      key: a,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${u.color}`,
      class: [`vc-highlight vc-highlight-bg-${u.fillMode}`, u.class],
      contentClass: [
        `vc-attr vc-highlight-content-${u.fillMode} vc-${u.color}`,
        u.contentClass
      ]
    }) : n ? (l.push({
      ...c,
      key: `${a}-base`,
      wrapperClass: `vc-day-layer vc-day-box-right-center vc-attr vc-${c.color}`,
      class: [
        `vc-highlight vc-highlight-base-start vc-highlight-bg-${c.fillMode}`,
        c.class
      ]
    }), l.push({
      ...u,
      key: a,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${u.color}`,
      class: [`vc-highlight vc-highlight-bg-${u.fillMode}`, u.class],
      contentClass: [
        `vc-attr vc-highlight-content-${u.fillMode} vc-${u.color}`,
        u.contentClass
      ]
    })) : s ? (l.push({
      ...c,
      key: `${a}-base`,
      wrapperClass: `vc-day-layer vc-day-box-left-center vc-attr vc-${c.color}`,
      class: [
        `vc-highlight vc-highlight-base-end vc-highlight-bg-${c.fillMode}`,
        c.class
      ]
    }), l.push({
      ...d,
      key: a,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${d.color}`,
      class: [`vc-highlight vc-highlight-bg-${d.fillMode}`, d.class],
      contentClass: [
        `vc-attr vc-highlight-content-${d.fillMode} vc-${d.color}`,
        d.contentClass
      ]
    })) : l.push({
      ...c,
      key: `${a}-middle`,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [
        `vc-highlight vc-highlight-base-middle vc-highlight-bg-${c.fillMode}`,
        c.class
      ],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    });
  }
}
class BaseRenderer {
  constructor(t, n) {
    __publicField(this, "type", ""), __publicField(this, "collectionType", ""), this.type = t, this.collectionType = n;
  }
  normalizeConfig(t, n) {
    return normalizeConfig(t, n);
  }
  prepareRender(t) {
    t[this.collectionType] = [];
  }
  render({ data: t, onStart: n, onEnd: s }, i) {
    const { key: a } = t, o = t[this.type];
    if (!a || !o)
      return;
    const l = i[this.collectionType], { base: c, start: u, end: d } = o;
    n ? l.push({
      ...u,
      key: a,
      class: [
        `vc-${this.type} vc-${this.type}-start vc-${u.color} vc-attr`,
        u.class
      ]
    }) : s ? l.push({
      ...d,
      key: a,
      class: [
        `vc-${this.type} vc-${this.type}-end vc-${d.color} vc-attr`,
        d.class
      ]
    }) : l.push({
      ...c,
      key: a,
      class: [
        `vc-${this.type} vc-${this.type}-base vc-${c.color} vc-attr`,
        c.class
      ]
    });
  }
}
class ContentRenderer extends BaseRenderer {
  constructor() {
    super("content", "content");
  }
  normalizeConfig(t, n) {
    return normalizeConfig("base", n);
  }
}
class DotRenderer extends BaseRenderer {
  constructor() {
    super("dot", "dots");
  }
}
class BarRenderer extends BaseRenderer {
  constructor() {
    super("bar", "bars");
  }
}
class Theme {
  constructor(t) {
    __publicField(this, "color"), __publicField(this, "renderers", [
      new ContentRenderer(),
      new HighlightRenderer(),
      new DotRenderer(),
      new BarRenderer()
    ]), this.color = t;
  }
  normalizeGlyphs(t) {
    this.renderers.forEach((n) => {
      const s = n.type;
      t[s] != null && (t[s] = n.normalizeConfig(this.color, t[s]));
    });
  }
  prepareRender(t = {}) {
    return this.renderers.forEach((n) => {
      n.prepareRender(t);
    }), t;
  }
  render(t, n) {
    this.renderers.forEach((s) => {
      s.render(t, n);
    });
  }
}
const maxSwipeTime = 300, minHorizontalSwipeDistance = 60, maxVerticalSwipeDistance = 80, touch = {
  maxSwipeTime,
  minHorizontalSwipeDistance,
  maxVerticalSwipeDistance
}, title = "MMMM YYYY", weekdays = "W", navMonths = "MMM", hours = "h A", input = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], inputDateTime = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], inputDateTime24hr = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], inputTime = [
  "h:mm A"
], inputTime24hr = [
  "HH:mm"
], dayPopover = "WWW, MMM D, YYYY", data = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], model = "iso", iso = "YYYY-MM-DDTHH:mm:ss.SSSZ", masks = {
  title,
  weekdays,
  navMonths,
  hours,
  input,
  inputDateTime,
  inputDateTime24hr,
  inputTime,
  inputTime24hr,
  dayPopover,
  data,
  model,
  iso
}, locales = {
  // Arabic
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  // Bulgarian
  bg: { dow: 2, L: "D.MM.YYYY" },
  // Catalan
  ca: { dow: 2, L: "DD/MM/YYYY" },
  // Chinese (China)
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  // Chinese (Taiwan)
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  // Croatian
  hr: { dow: 2, L: "DD.MM.YYYY" },
  // Czech
  cs: { dow: 2, L: "DD.MM.YYYY" },
  // Danish
  da: { dow: 2, L: "DD.MM.YYYY" },
  // Dutch
  nl: { dow: 2, L: "DD-MM-YYYY" },
  // English (US)
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  // English (Australia)
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  // English (Canada)
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  // English (Great Britain)
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  // English (Ireland)
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  // English (New Zealand)
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  // English (South Africa)
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  // Esperanto
  eo: { dow: 2, L: "YYYY-MM-DD" },
  // Estonian
  et: { dow: 2, L: "DD.MM.YYYY" },
  // Finnish
  fi: { dow: 2, L: "DD.MM.YYYY" },
  // French
  fr: { dow: 2, L: "DD/MM/YYYY" },
  // French (Canada)
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  // French (Switzerland)
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  // German
  de: { dow: 2, L: "DD.MM.YYYY" },
  // Hebrew
  he: { dow: 1, L: "DD.MM.YYYY" },
  // Indonesian
  id: { dow: 2, L: "DD/MM/YYYY" },
  // Italian
  it: { dow: 2, L: "DD/MM/YYYY" },
  // Japanese
  ja: { dow: 1, L: "YYYY年M月D日" },
  // Korean
  ko: { dow: 1, L: "YYYY.MM.DD" },
  // Latvian
  lv: { dow: 2, L: "DD.MM.YYYY" },
  // Lithuanian
  lt: { dow: 2, L: "DD.MM.YYYY" },
  // Macedonian
  mk: { dow: 2, L: "D.MM.YYYY" },
  // Norwegian
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  // Polish
  pl: { dow: 2, L: "DD.MM.YYYY" },
  // Portuguese
  pt: { dow: 2, L: "DD/MM/YYYY" },
  // Romanian
  ro: { dow: 2, L: "DD.MM.YYYY" },
  // Russian
  ru: { dow: 2, L: "DD.MM.YYYY" },
  // Slovak
  sk: { dow: 2, L: "DD.MM.YYYY" },
  // Spanish (Spain)
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  // Spanish (Mexico)
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  // Swedish
  sv: { dow: 2, L: "YYYY-MM-DD" },
  // Thai
  th: { dow: 1, L: "DD/MM/YYYY" },
  // Turkish
  tr: { dow: 2, L: "DD.MM.YYYY" },
  // Ukrainian
  uk: { dow: 2, L: "DD.MM.YYYY" },
  // Vietnam
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
locales.en = locales["en-US"];
locales.es = locales["es-ES"];
locales.no = locales.nb;
locales.zh = locales["zh-CN"];
const localeSettings = Object.entries(locales).reduce(
  (e, [t, { dow: n, L: s }]) => (e[t] = {
    id: t,
    firstDayOfWeek: n,
    masks: { L: s }
  }, e),
  {}
), defaultConfig = {
  componentPrefix: "V",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch,
  masks,
  locales: localeSettings,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      isInteractive: !0
    }
  }
}, state = reactive(defaultConfig), defaultLocales = computed(() => mapValues_1(state.locales, (e) => (e.masks = defaultsDeep_1(e.masks, state.masks), e))), getDefault = (e) => typeof window < "u" && has(window.__vcalendar__, e) ? get_1(window.__vcalendar__, e) : get_1(state, e);
var toDateExports = {}, toDate$1 = {
  get exports() {
    return toDateExports;
  },
  set exports(e) {
    toDateExports = e;
  }
}, toIntegerExports = {}, toInteger$1 = {
  get exports() {
    return toIntegerExports;
  },
  set exports(e) {
    toIntegerExports = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(s) {
    if (s === null || s === !0 || s === !1)
      return NaN;
    var i = Number(s);
    return isNaN(i) ? i : i < 0 ? Math.ceil(i) : Math.floor(i);
  }
  e.exports = t.default;
})(toInteger$1, toIntegerExports);
var getTimezoneOffsetInMillisecondsExports = {}, getTimezoneOffsetInMilliseconds$1 = {
  get exports() {
    return getTimezoneOffsetInMillisecondsExports;
  },
  set exports(e) {
    getTimezoneOffsetInMillisecondsExports = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(s) {
    var i = new Date(Date.UTC(s.getFullYear(), s.getMonth(), s.getDate(), s.getHours(), s.getMinutes(), s.getSeconds(), s.getMilliseconds()));
    return i.setUTCFullYear(s.getFullYear()), s.getTime() - i.getTime();
  }
  e.exports = t.default;
})(getTimezoneOffsetInMilliseconds$1, getTimezoneOffsetInMillisecondsExports);
var tzParseTimezoneExports = {}, tzParseTimezone = {
  get exports() {
    return tzParseTimezoneExports;
  },
  set exports(e) {
    tzParseTimezoneExports = e;
  }
}, tzTokenizeDateExports = {}, tzTokenizeDate = {
  get exports() {
    return tzTokenizeDateExports;
  },
  set exports(e) {
    tzTokenizeDateExports = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(c, u) {
    var d = l(u);
    return d.formatToParts ? i(d, c) : a(d, c);
  }
  var s = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
  };
  function i(c, u) {
    try {
      for (var d = c.formatToParts(u), p = [], f = 0; f < d.length; f++) {
        var g = s[d[f].type];
        g >= 0 && (p[g] = parseInt(d[f].value, 10));
      }
      return p;
    } catch (C) {
      if (C instanceof RangeError)
        return [NaN];
      throw C;
    }
  }
  function a(c, u) {
    var d = c.format(u).replace(/\u200E/g, ""), p = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(d);
    return [p[3], p[1], p[2], p[4], p[5], p[6]];
  }
  var o = {};
  function l(c) {
    if (!o[c]) {
      var u = new Intl.DateTimeFormat("en-US", {
        hour12: !1,
        timeZone: "America/New_York",
        year: "numeric",
        month: "numeric",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), d = u === "06/25/2014, 00:00:00" || u === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
      o[c] = d ? new Intl.DateTimeFormat("en-US", {
        hour12: !1,
        timeZone: c,
        year: "numeric",
        month: "numeric",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      }) : new Intl.DateTimeFormat("en-US", {
        hourCycle: "h23",
        timeZone: c,
        year: "numeric",
        month: "numeric",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
    }
    return o[c];
  }
  e.exports = t.default;
})(tzTokenizeDate, tzTokenizeDateExports);
var newDateUTCExports = {}, newDateUTC = {
  get exports() {
    return newDateUTCExports;
  },
  set exports(e) {
    newDateUTCExports = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(s, i, a, o, l, c, u) {
    var d = /* @__PURE__ */ new Date(0);
    return d.setUTCFullYear(s, i, a), d.setUTCHours(o, l, c, u), d;
  }
  e.exports = t.default;
})(newDateUTC, newDateUTCExports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = c;
  var n = i(tzTokenizeDateExports), s = i(newDateUTCExports);
  function i(k) {
    return k && k.__esModule ? k : { default: k };
  }
  var a = 36e5, o = 6e4, l = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
  };
  function c(k, M, _) {
    var S, E;
    if (!k || (S = l.timezoneZ.exec(k), S))
      return 0;
    var P;
    if (S = l.timezoneHH.exec(k), S)
      return P = parseInt(S[1], 10), f(P) ? -(P * a) : NaN;
    if (S = l.timezoneHHMM.exec(k), S) {
      P = parseInt(S[1], 10);
      var $ = parseInt(S[2], 10);
      return f(P, $) ? (E = Math.abs(P) * a + $ * o, P > 0 ? -E : E) : NaN;
    }
    if (C(k)) {
      M = new Date(M || Date.now());
      var A = _ ? M : u(M), I = d(A, k), D = _ ? I : p(M, I, k);
      return -D;
    }
    return NaN;
  }
  function u(k) {
    return (0, s.default)(k.getFullYear(), k.getMonth(), k.getDate(), k.getHours(), k.getMinutes(), k.getSeconds(), k.getMilliseconds());
  }
  function d(k, M) {
    var _ = (0, n.default)(k, M), S = (0, s.default)(_[0], _[1] - 1, _[2], _[3] % 24, _[4], _[5], 0).getTime(), E = k.getTime(), P = E % 1e3;
    return E -= P >= 0 ? P : 1e3 + P, S - E;
  }
  function p(k, M, _) {
    var S = k.getTime(), E = S - M, P = d(new Date(E), _);
    if (M === P)
      return M;
    E -= P - M;
    var $ = d(new Date(E), _);
    return P === $ ? P : Math.max(P, $);
  }
  function f(k, M) {
    return -23 <= k && k <= 23 && (M == null || 0 <= M && M <= 59);
  }
  var g = {};
  function C(k) {
    if (g[k])
      return !0;
    try {
      return new Intl.DateTimeFormat(void 0, {
        timeZone: k
      }), g[k] = !0, !0;
    } catch {
      return !1;
    }
  }
  e.exports = t.default;
})(tzParseTimezone, tzParseTimezoneExports);
var tzPatternExports = {}, tzPattern = {
  get exports() {
    return tzPatternExports;
  },
  set exports(e) {
    tzPatternExports = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var n = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, s = n;
  t.default = s, e.exports = t.default;
})(tzPattern, tzPatternExports);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = p;
  var n = o(toIntegerExports), s = o(getTimezoneOffsetInMillisecondsExports), i = o(tzParseTimezoneExports), a = o(tzPatternExports);
  function o(D) {
    return D && D.__esModule ? D : { default: D };
  }
  var l = 36e5, c = 6e4, u = 2, d = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
      /^([+-]\d{2})$/,
      // 0 additional digits
      /^([+-]\d{3})$/,
      // 1 additional digit
      /^([+-]\d{4})$/
      // 2 additional digits
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
      /^([+-]\d{4})/,
      // 0 additional digits
      /^([+-]\d{5})/,
      // 1 additional digit
      /^([+-]\d{6})/
      // 2 additional digits
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: a.default
  };
  function p(D, R) {
    if (arguments.length < 1)
      throw new TypeError("1 argument required, but only " + arguments.length + " present");
    if (D === null)
      return /* @__PURE__ */ new Date(NaN);
    var Y = R || {}, q = Y.additionalDigits == null ? u : (0, n.default)(Y.additionalDigits);
    if (q !== 2 && q !== 1 && q !== 0)
      throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (D instanceof Date || typeof D == "object" && Object.prototype.toString.call(D) === "[object Date]")
      return new Date(D.getTime());
    if (typeof D == "number" || Object.prototype.toString.call(D) === "[object Number]")
      return new Date(D);
    if (!(typeof D == "string" || Object.prototype.toString.call(D) === "[object String]"))
      return /* @__PURE__ */ new Date(NaN);
    var j = f(D), X = g(j.date, q), ee = X.year, G = X.restDateString, H = C(G, ee);
    if (isNaN(H))
      return /* @__PURE__ */ new Date(NaN);
    if (H) {
      var F = H.getTime(), B = 0, z;
      if (j.time && (B = k(j.time), isNaN(B)))
        return /* @__PURE__ */ new Date(NaN);
      if (j.timeZone || Y.timeZone) {
        if (z = (0, i.default)(j.timeZone || Y.timeZone, new Date(F + B)), isNaN(z))
          return /* @__PURE__ */ new Date(NaN);
      } else
        z = (0, s.default)(new Date(F + B)), z = (0, s.default)(new Date(F + B + z));
      return new Date(F + B + z);
    } else
      return /* @__PURE__ */ new Date(NaN);
  }
  function f(D) {
    var R = {}, Y = d.dateTimePattern.exec(D), q;
    if (Y ? (R.date = Y[1], q = Y[3]) : (Y = d.datePattern.exec(D), Y ? (R.date = Y[1], q = Y[2]) : (R.date = null, q = D)), q) {
      var j = d.timeZone.exec(q);
      j ? (R.time = q.replace(j[1], ""), R.timeZone = j[1].trim()) : R.time = q;
    }
    return R;
  }
  function g(D, R) {
    var Y = d.YYY[R], q = d.YYYYY[R], j;
    if (j = d.YYYY.exec(D) || q.exec(D), j) {
      var X = j[1];
      return {
        year: parseInt(X, 10),
        restDateString: D.slice(X.length)
      };
    }
    if (j = d.YY.exec(D) || Y.exec(D), j) {
      var ee = j[1];
      return {
        year: parseInt(ee, 10) * 100,
        restDateString: D.slice(ee.length)
      };
    }
    return {
      year: null
    };
  }
  function C(D, R) {
    if (R === null)
      return null;
    var Y, q, j, X;
    if (D.length === 0)
      return q = /* @__PURE__ */ new Date(0), q.setUTCFullYear(R), q;
    if (Y = d.MM.exec(D), Y)
      return q = /* @__PURE__ */ new Date(0), j = parseInt(Y[1], 10) - 1, P(R, j) ? (q.setUTCFullYear(R, j), q) : /* @__PURE__ */ new Date(NaN);
    if (Y = d.DDD.exec(D), Y) {
      q = /* @__PURE__ */ new Date(0);
      var ee = parseInt(Y[1], 10);
      return $(R, ee) ? (q.setUTCFullYear(R, 0, ee), q) : /* @__PURE__ */ new Date(NaN);
    }
    if (Y = d.MMDD.exec(D), Y) {
      q = /* @__PURE__ */ new Date(0), j = parseInt(Y[1], 10) - 1;
      var G = parseInt(Y[2], 10);
      return P(R, j, G) ? (q.setUTCFullYear(R, j, G), q) : /* @__PURE__ */ new Date(NaN);
    }
    if (Y = d.Www.exec(D), Y)
      return X = parseInt(Y[1], 10) - 1, A(R, X) ? M(R, X) : /* @__PURE__ */ new Date(NaN);
    if (Y = d.WwwD.exec(D), Y) {
      X = parseInt(Y[1], 10) - 1;
      var H = parseInt(Y[2], 10) - 1;
      return A(R, X, H) ? M(R, X, H) : /* @__PURE__ */ new Date(NaN);
    }
    return null;
  }
  function k(D) {
    var R, Y, q;
    if (R = d.HH.exec(D), R)
      return Y = parseFloat(R[1].replace(",", ".")), I(Y) ? Y % 24 * l : NaN;
    if (R = d.HHMM.exec(D), R)
      return Y = parseInt(R[1], 10), q = parseFloat(R[2].replace(",", ".")), I(Y, q) ? Y % 24 * l + q * c : NaN;
    if (R = d.HHMMSS.exec(D), R) {
      Y = parseInt(R[1], 10), q = parseInt(R[2], 10);
      var j = parseFloat(R[3].replace(",", "."));
      return I(Y, q, j) ? Y % 24 * l + q * c + j * 1e3 : NaN;
    }
    return null;
  }
  function M(D, R, Y) {
    R = R || 0, Y = Y || 0;
    var q = /* @__PURE__ */ new Date(0);
    q.setUTCFullYear(D, 0, 4);
    var j = q.getUTCDay() || 7, X = R * 7 + Y + 1 - j;
    return q.setUTCDate(q.getUTCDate() + X), q;
  }
  var _ = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], S = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  function E(D) {
    return D % 400 === 0 || D % 4 === 0 && D % 100 !== 0;
  }
  function P(D, R, Y) {
    if (R < 0 || R > 11)
      return !1;
    if (Y != null) {
      if (Y < 1)
        return !1;
      var q = E(D);
      if (q && Y > S[R] || !q && Y > _[R])
        return !1;
    }
    return !0;
  }
  function $(D, R) {
    if (R < 1)
      return !1;
    var Y = E(D);
    return !(Y && R > 366 || !Y && R > 365);
  }
  function A(D, R, Y) {
    return !(R < 0 || R > 52 || Y != null && (Y < 0 || Y > 6));
  }
  function I(D, R, Y) {
    return !(D != null && (D < 0 || D >= 25) || R != null && (R < 0 || R >= 60) || Y != null && (Y < 0 || Y >= 60));
  }
  e.exports = t.default;
})(toDate$1, toDateExports);
const toFnsDate = /* @__PURE__ */ getDefaultExportFromCjs(toDateExports);
function requiredArgs$1(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function _typeof$1(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$1 = function(n) {
    return typeof n;
  } : _typeof$1 = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, _typeof$1(e);
}
function toDate$2(e) {
  requiredArgs$1(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || _typeof$1(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function toInteger$2(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
var defaultOptions$1 = {};
function getDefaultOptions$1() {
  return defaultOptions$1;
}
function startOfWeek$1(e, t) {
  var n, s, i, a, o, l, c, u;
  requiredArgs$1(1, arguments);
  var d = getDefaultOptions$1(), p = toInteger$2((n = (s = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && s !== void 0 ? s : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = toDate$2(e), g = f.getDay(), C = (g < p ? 7 : 0) + g - p;
  return f.setDate(f.getDate() - C), f.setHours(0, 0, 0, 0), f;
}
function getTimezoneOffsetInMilliseconds$2(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var MILLISECONDS_IN_WEEK$2 = 6048e5;
function differenceInCalendarWeeks(e, t, n) {
  requiredArgs$1(2, arguments);
  var s = startOfWeek$1(e, n), i = startOfWeek$1(t, n), a = s.getTime() - getTimezoneOffsetInMilliseconds$2(s), o = i.getTime() - getTimezoneOffsetInMilliseconds$2(i);
  return Math.round((a - o) / MILLISECONDS_IN_WEEK$2);
}
function lastDayOfMonth(e) {
  requiredArgs$1(1, arguments);
  var t = toDate$2(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function startOfMonth$1(e) {
  requiredArgs$1(1, arguments);
  var t = toDate$2(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function getWeeksInMonth(e, t) {
  return requiredArgs$1(1, arguments), differenceInCalendarWeeks(lastDayOfMonth(e), startOfMonth$1(e), t) + 1;
}
function getWeekYear(e, t) {
  var n, s, i, a, o, l, c, u;
  requiredArgs$1(1, arguments);
  var d = toDate$2(e), p = d.getFullYear(), f = getDefaultOptions$1(), g = toInteger$2((n = (s = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && i !== void 0 ? i : f.firstWeekContainsDate) !== null && s !== void 0 ? s : (c = f.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var C = /* @__PURE__ */ new Date(0);
  C.setFullYear(p + 1, 0, g), C.setHours(0, 0, 0, 0);
  var k = startOfWeek$1(C, t), M = /* @__PURE__ */ new Date(0);
  M.setFullYear(p, 0, g), M.setHours(0, 0, 0, 0);
  var _ = startOfWeek$1(M, t);
  return d.getTime() >= k.getTime() ? p + 1 : d.getTime() >= _.getTime() ? p : p - 1;
}
function startOfWeekYear(e, t) {
  var n, s, i, a, o, l, c, u;
  requiredArgs$1(1, arguments);
  var d = getDefaultOptions$1(), p = toInteger$2((n = (s = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && i !== void 0 ? i : d.firstWeekContainsDate) !== null && s !== void 0 ? s : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = getWeekYear(e, t), g = /* @__PURE__ */ new Date(0);
  g.setFullYear(f, 0, p), g.setHours(0, 0, 0, 0);
  var C = startOfWeek$1(g, t);
  return C;
}
var MILLISECONDS_IN_WEEK$1$1 = 6048e5;
function getWeek(e, t) {
  requiredArgs$1(1, arguments);
  var n = toDate$2(e), s = startOfWeek$1(n, t).getTime() - startOfWeekYear(n, t).getTime();
  return Math.round(s / MILLISECONDS_IN_WEEK$1$1) + 1;
}
function startOfISOWeek(e) {
  return requiredArgs$1(1, arguments), startOfWeek$1(e, {
    weekStartsOn: 1
  });
}
function getISOWeekYear(e) {
  requiredArgs$1(1, arguments);
  var t = toDate$2(e), n = t.getFullYear(), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(n + 1, 0, 4), s.setHours(0, 0, 0, 0);
  var i = startOfISOWeek(s), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  var o = startOfISOWeek(a);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function startOfISOWeekYear(e) {
  requiredArgs$1(1, arguments);
  var t = getISOWeekYear(e), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  var s = startOfISOWeek(n);
  return s;
}
var MILLISECONDS_IN_WEEK$3 = 6048e5;
function getISOWeek(e) {
  requiredArgs$1(1, arguments);
  var t = toDate$2(e), n = startOfISOWeek(t).getTime() - startOfISOWeekYear(t).getTime();
  return Math.round(n / MILLISECONDS_IN_WEEK$3) + 1;
}
function addDays$1(e, t) {
  requiredArgs$1(2, arguments);
  var n = toDate$2(e), s = toInteger$2(t);
  return isNaN(s) ? /* @__PURE__ */ new Date(NaN) : (s && n.setDate(n.getDate() + s), n);
}
function addMonths$1(e, t) {
  requiredArgs$1(2, arguments);
  var n = toDate$2(e), s = toInteger$2(t);
  if (isNaN(s))
    return /* @__PURE__ */ new Date(NaN);
  if (!s)
    return n;
  var i = n.getDate(), a = new Date(n.getTime());
  a.setMonth(n.getMonth() + s + 1, 0);
  var o = a.getDate();
  return i >= o ? a : (n.setFullYear(a.getFullYear(), a.getMonth(), i), n);
}
function addYears$1(e, t) {
  requiredArgs$1(2, arguments);
  var n = toInteger$2(t);
  return addMonths$1(e, n * 12);
}
var GroupRuleType = /* @__PURE__ */ ((e) => (e.Any = "any", e.All = "all", e))(GroupRuleType || {}), IntervalRuleType = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(IntervalRuleType || {}), ComponentRuleType = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weekdays = "weekdays", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(ComponentRuleType || {}), OrdinalComponentRuleType = /* @__PURE__ */ ((e) => (e.OrdinalWeekdays = "ordinalWeekdays", e))(OrdinalComponentRuleType || {});
class IntervalRule {
  constructor(t, n, s) {
    __publicField(this, "validated", !0), this.type = t, this.interval = n, this.from = s, this.from || (console.error(
      'A valid "from" date is required for date interval rule. This rule will be skipped.'
    ), this.validated = !1);
  }
  passes(t) {
    if (!this.validated)
      return !0;
    const { date: n } = t;
    switch (this.type) {
      case "days":
        return diffInDays(this.from.date, n) % this.interval === 0;
      case "weeks":
        return diffInWeeks(this.from.date, n) % this.interval === 0;
      case "months":
        return diffInMonths(this.from.date, n) % this.interval === 0;
      case "years":
        return diffInYears(this.from.date, n) % this.interval === 0;
      default:
        return !1;
    }
  }
}
class ComponentRule {
  constructor(t, n, s, i) {
    __publicField(this, "components", []), this.type = t, this.validator = s, this.getter = i, this.components = this.normalizeComponents(n);
  }
  static create(t, n) {
    switch (t) {
      case "days":
        return new DaysRule(n);
      case "weekdays":
        return new WeekdaysRule(n);
      case "weeks":
        return new WeeksRule(n);
      case "months":
        return new MonthsRule(n);
      case "years":
        return new YearsRule(n);
    }
  }
  normalizeComponents(t) {
    if (this.validator(t))
      return [t];
    if (!isArray$d(t))
      return [];
    const n = [];
    return t.forEach((s) => {
      if (!this.validator(s)) {
        console.error(
          `Component value ${s} in invalid for "${this.type}" rule. This rule will be skipped.`
        );
        return;
      }
      n.push(s);
    }), n;
  }
  passes(t) {
    return this.getter(t).some((i) => this.components.includes(i));
  }
}
class DaysRule extends ComponentRule {
  constructor(t) {
    super(
      "days",
      t,
      isDayInMonth,
      ({ day: n, dayFromEnd: s }) => [n, -s]
    );
  }
}
class WeekdaysRule extends ComponentRule {
  constructor(t) {
    super(
      "weekdays",
      t,
      isDayOfWeek,
      ({ weekday: n }) => [n]
    );
  }
}
class WeeksRule extends ComponentRule {
  constructor(t) {
    super(
      "weeks",
      t,
      isWeekInMonth,
      ({ week: n, weekFromEnd: s }) => [n, -s]
    );
  }
}
class MonthsRule extends ComponentRule {
  constructor(t) {
    super("months", t, isMonthInYear, ({ month: n }) => [
      n
    ]);
  }
}
class YearsRule extends ComponentRule {
  constructor(t) {
    super("years", t, isNumber_1, ({ year: n }) => [n]);
  }
}
class OrdinalComponentRule {
  constructor(t, n) {
    __publicField(this, "components"), this.type = t, this.components = this.normalizeComponents(n);
  }
  normalizeArrayConfig(t) {
    const n = [];
    return t.forEach((s, i) => {
      if (isNumber_1(s)) {
        if (i === 0)
          return;
        if (!isOrdinalWeekInMonth(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!isDayOfWeek(s)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        n.push([t[0], s]);
      } else
        isArray$d(s) && n.push(...this.normalizeArrayConfig(s));
    }), n;
  }
  normalizeComponents(t) {
    const n = [];
    return t.forEach((s, i) => {
      if (isNumber_1(s)) {
        if (i === 0)
          return;
        if (!isOrdinalWeekInMonth(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!isDayOfWeek(s)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        n.push([t[0], s]);
      } else
        isArray$d(s) && n.push(...this.normalizeArrayConfig(s));
    }), n;
  }
  passes(t) {
    const { weekday: n, weekdayOrdinal: s, weekdayOrdinalFromEnd: i } = t;
    return this.components.some(
      ([a, o]) => (a === s || a === -i) && n === o
    );
  }
}
class FunctionRule {
  constructor(t) {
    __publicField(this, "type", "function"), __publicField(this, "validated", !0), this.fn = t, isFunction_1(t) || (console.error(
      "The function rule requires a valid function. This rule will be skipped."
    ), this.validated = !1);
  }
  passes(t) {
    return this.validated ? this.fn(t) : !0;
  }
}
class DateRepeat {
  constructor(t, n = {}, s) {
    __publicField(this, "validated", !0), __publicField(this, "config"), __publicField(this, "type", GroupRuleType.Any), __publicField(this, "from"), __publicField(this, "until"), __publicField(this, "rules", []), __publicField(this, "locale", new Locale()), this.parent = s, n.locale && (this.locale = n.locale), this.config = t, isFunction_1(t) ? (this.type = GroupRuleType.All, this.rules = [new FunctionRule(t)]) : isArray$d(t) ? (this.type = GroupRuleType.Any, this.rules = t.map((i) => new DateRepeat(i, n, this))) : isObject$b(t) ? (this.type = GroupRuleType.All, this.from = t.from ? this.locale.getDateParts(t.from) : s == null ? void 0 : s.from, this.until = t.until ? this.locale.getDateParts(t.until) : s == null ? void 0 : s.until, this.rules = this.getObjectRules(t)) : (console.error("Rule group configuration must be an object or an array."), this.validated = !1);
  }
  getObjectRules(t) {
    const n = [];
    if (t.every && (isString_1(t.every) && (t.every = [1, `${t.every}s`]), isArray$d(t.every))) {
      const [s = 1, i = IntervalRuleType.Days] = t.every;
      n.push(new IntervalRule(i, s, this.from));
    }
    return Object.values(ComponentRuleType).forEach((s) => {
      s in t && n.push(ComponentRule.create(s, t[s]));
    }), Object.values(OrdinalComponentRuleType).forEach((s) => {
      s in t && n.push(new OrdinalComponentRule(s, t[s]));
    }), t.on != null && (isArray$d(t.on) || (t.on = [t.on]), n.push(
      new DateRepeat(t.on, { locale: this.locale }, this.parent)
    )), n;
  }
  passes(t) {
    return this.validated ? this.from && t.dayIndex <= this.from.dayIndex || this.until && t.dayIndex >= this.until.dayIndex ? !1 : this.type === GroupRuleType.Any ? this.rules.some((n) => n.passes(t)) : this.rules.every((n) => n.passes(t)) : !0;
  }
}
function isDayInMonth(e) {
  return isNumber_1(e) ? e >= 1 && e <= 31 : !1;
}
function isDayOfWeek(e) {
  return isNumber_1(e) ? e >= 1 && e <= 7 : !1;
}
function isWeekInMonth(e) {
  return isNumber_1(e) ? e >= -6 && e <= -1 || e >= 1 && e <= 6 : !1;
}
function isMonthInYear(e) {
  return isNumber_1(e) ? e >= 1 && e <= 12 : !1;
}
function isOrdinalWeekInMonth(e) {
  return !(!isNumber_1(e) || e < -5 || e > 5 || e === 0);
}
const DatePatchKeys = {
  dateTime: [
    "year",
    "month",
    "day",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ],
  date: ["year", "month", "day"],
  time: ["hours", "minutes", "seconds", "milliseconds"]
}, daysInWeek = 7, weeksInMonth = 6, MS_PER_SECOND = 1e3, MS_PER_MINUTE = MS_PER_SECOND * 60, MS_PER_HOUR = MS_PER_MINUTE * 60, MS_PER_DAY = MS_PER_HOUR * 24, daysInMonths$1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], maskMacros = ["L", "iso"], DATE_PART_RANGES = {
  milliseconds: [0, 999, 3],
  seconds: [0, 59, 2],
  minutes: [0, 59, 2],
  hours: [0, 23, 2]
}, token = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, literal = /\[([^]*?)\]/gm, formatFlags = {
  D(e) {
    return e.day;
  },
  DD(e) {
    return pad(e.day, 2);
  },
  // Do(d: DateParts, l: Locale) {
  //   return l.DoFn(d.day);
  // },
  d(e) {
    return e.weekday - 1;
  },
  dd(e) {
    return pad(e.weekday - 1, 2);
  },
  W(e, t) {
    return t.dayNamesNarrow[e.weekday - 1];
  },
  WW(e, t) {
    return t.dayNamesShorter[e.weekday - 1];
  },
  WWW(e, t) {
    return t.dayNamesShort[e.weekday - 1];
  },
  WWWW(e, t) {
    return t.dayNames[e.weekday - 1];
  },
  M(e) {
    return e.month;
  },
  MM(e) {
    return pad(e.month, 2);
  },
  MMM(e, t) {
    return t.monthNamesShort[e.month - 1];
  },
  MMMM(e, t) {
    return t.monthNames[e.month - 1];
  },
  YY(e) {
    return String(e.year).substr(2);
  },
  YYYY(e) {
    return pad(e.year, 4);
  },
  h(e) {
    return e.hours % 12 || 12;
  },
  hh(e) {
    return pad(e.hours % 12 || 12, 2);
  },
  H(e) {
    return e.hours;
  },
  HH(e) {
    return pad(e.hours, 2);
  },
  m(e) {
    return e.minutes;
  },
  mm(e) {
    return pad(e.minutes, 2);
  },
  s(e) {
    return e.seconds;
  },
  ss(e) {
    return pad(e.seconds, 2);
  },
  S(e) {
    return Math.round(e.milliseconds / 100);
  },
  SS(e) {
    return pad(Math.round(e.milliseconds / 10), 2);
  },
  SSS(e) {
    return pad(e.milliseconds, 3);
  },
  a(e, t) {
    return e.hours < 12 ? t.amPm[0] : t.amPm[1];
  },
  A(e, t) {
    return e.hours < 12 ? t.amPm[0].toUpperCase() : t.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${pad(Math.floor(Math.abs(t) / 60), 2)}`;
  },
  ZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${pad(
      Math.floor(Math.abs(t) / 60) * 100 + Math.abs(t) % 60,
      4
    )}`;
  },
  ZZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${pad(Math.floor(Math.abs(t) / 60), 2)}:${pad(
      Math.abs(t) % 60,
      2
    )}`;
  }
}, twoDigits = /\d\d?/, threeDigits = /\d{3}/, fourDigits = /\d{4}/, word = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, noop$1 = () => {
}, monthUpdate = (e) => (t, n, s) => {
  const i = s[e].indexOf(
    n.charAt(0).toUpperCase() + n.substr(1).toLowerCase()
  );
  ~i && (t.month = i);
}, parseFlags = {
  D: [
    twoDigits,
    (e, t) => {
      e.day = t;
    }
  ],
  Do: [
    new RegExp(twoDigits.source + word.source),
    (e, t) => {
      e.day = parseInt(t, 10);
    }
  ],
  d: [twoDigits, noop$1],
  W: [word, noop$1],
  M: [
    twoDigits,
    (e, t) => {
      e.month = t - 1;
    }
  ],
  MMM: [word, monthUpdate("monthNamesShort")],
  MMMM: [word, monthUpdate("monthNames")],
  YY: [
    twoDigits,
    (e, t) => {
      const s = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      e.year = +`${t > 68 ? s - 1 : s}${t}`;
    }
  ],
  YYYY: [
    fourDigits,
    (e, t) => {
      e.year = t;
    }
  ],
  S: [
    /\d/,
    (e, t) => {
      e.milliseconds = t * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (e, t) => {
      e.milliseconds = t * 10;
    }
  ],
  SSS: [
    threeDigits,
    (e, t) => {
      e.milliseconds = t;
    }
  ],
  h: [
    twoDigits,
    (e, t) => {
      e.hours = t;
    }
  ],
  m: [
    twoDigits,
    (e, t) => {
      e.minutes = t;
    }
  ],
  s: [
    twoDigits,
    (e, t) => {
      e.seconds = t;
    }
  ],
  a: [
    word,
    (e, t, n) => {
      const s = t.toLowerCase();
      s === n.amPm[0] ? e.isPm = !1 : s === n.amPm[1] && (e.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (e, t) => {
      t === "Z" && (t = "+00:00");
      const n = `${t}`.match(/([+-]|\d\d)/gi);
      if (n) {
        const s = +n[1] * 60 + parseInt(n[2], 10);
        e.timezoneOffset = n[0] === "+" ? s : -s;
      }
    }
  ]
};
parseFlags.DD = parseFlags.D;
parseFlags.dd = parseFlags.d;
parseFlags.WWWW = parseFlags.WWW = parseFlags.WW = parseFlags.W;
parseFlags.MM = parseFlags.M;
parseFlags.mm = parseFlags.m;
parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
parseFlags.ss = parseFlags.s;
parseFlags.A = parseFlags.a;
parseFlags.ZZZZ = parseFlags.ZZZ = parseFlags.ZZ = parseFlags.Z;
function normalizeMasks(e, t) {
  return (arrayHasItems(e) && e || [
    isString_1(e) && e || "YYYY-MM-DD"
  ]).map(
    (n) => maskMacros.reduce(
      (s, i) => s.replace(i, t.masks[i] || ""),
      n
    )
  );
}
function isDateParts(e) {
  return isObject$b(e) && "year" in e && "month" in e && "day" in e;
}
function startOfWeek$2(e, t = 1) {
  const n = e.getDay() + 1, s = n >= t ? t - n : -(7 - (t - n));
  return addDays$1(e, s);
}
function getDayIndex(e, t, n) {
  const s = Date.UTC(e, t - 1, n);
  return diffInDays(/* @__PURE__ */ new Date(0), new Date(s));
}
function diffInDays(e, t) {
  return Math.round((t.getTime() - e.getTime()) / MS_PER_DAY);
}
function diffInWeeks(e, t) {
  return Math.ceil(diffInDays(startOfWeek$2(e), startOfWeek$2(t)) / 7);
}
function diffInYears(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}
function diffInMonths(e, t) {
  return diffInYears(e, t) * 12 + (t.getMonth() - e.getMonth());
}
function getDateFromParts(e, t = "") {
  const n = /* @__PURE__ */ new Date(), {
    year: s = n.getFullYear(),
    month: i = n.getMonth() + 1,
    day: a = n.getDate(),
    hours: o = 0,
    minutes: l = 0,
    seconds: c = 0,
    milliseconds: u = 0
  } = e;
  if (t) {
    const d = `${pad(s, 4)}-${pad(i, 2)}-${pad(a, 2)}T${pad(
      o,
      2
    )}:${pad(l, 2)}:${pad(c, 2)}.${pad(u, 3)}`;
    return toFnsDate(d, { timeZone: t });
  }
  return new Date(s, i - 1, a, o, l, c, u);
}
function getDateParts(e, t) {
  let n = new Date(e.getTime());
  t.timezone && (n = new Date(
    e.toLocaleString("en-US", { timeZone: t.timezone })
  ), n.setMilliseconds(e.getMilliseconds()));
  const s = n.getMilliseconds(), i = n.getSeconds(), a = n.getMinutes(), o = n.getHours(), l = s + i * MS_PER_SECOND + a * MS_PER_MINUTE + o * MS_PER_HOUR, c = n.getMonth() + 1, u = n.getFullYear(), d = t.getMonthParts(c, u), p = n.getDate(), f = d.numDays - p + 1, g = n.getDay() + 1, C = Math.floor((p - 1) / 7 + 1), k = Math.floor((d.numDays - p) / 7 + 1), M = Math.ceil(
    (p + Math.abs(d.firstWeekday - d.firstDayOfWeek)) / 7
  ), _ = d.numWeeks - M + 1, S = d.weeknumbers[M], E = getDayIndex(u, c, p);
  return {
    milliseconds: s,
    seconds: i,
    minutes: a,
    hours: o,
    time: l,
    day: p,
    dayFromEnd: f,
    weekday: g,
    weekdayOrdinal: C,
    weekdayOrdinalFromEnd: k,
    week: M,
    weekFromEnd: _,
    weeknumber: S,
    month: c,
    year: u,
    date: n,
    dateTime: n.getTime(),
    dayIndex: E,
    timezoneOffset: 0,
    isValid: !0
  };
}
function getMonthPartsKey(e, t, n) {
  return `${t}-${e}-${n}`;
}
function getMonthParts(e, t, n) {
  const s = t % 4 === 0 && t % 100 !== 0 || t % 400 === 0, i = new Date(t, e - 1, 1), a = i.getDay() + 1, o = e === 2 && s ? 29 : daysInMonths$1[e - 1], l = n - 1, c = getWeeksInMonth(i, {
    weekStartsOn: l
  }), u = [], d = [];
  for (let p = 0; p < c; p++) {
    const f = addDays$1(i, p * 7);
    u.push(getWeek(f, { weekStartsOn: l })), d.push(getISOWeek(f));
  }
  return {
    firstDayOfWeek: n,
    firstDayOfMonth: i,
    inLeapYear: s,
    firstWeekday: a,
    numDays: o,
    numWeeks: c,
    month: e,
    year: t,
    weeknumbers: u,
    isoWeeknumbers: d
  };
}
function getWeekdayDates() {
  const e = [];
  for (let i = 0; i < daysInWeek; i++)
    e.push(
      getDateFromParts({
        year: 2020,
        month: 1,
        day: 5 + i,
        hours: 12
      })
    );
  return e;
}
function getDayNames(e, t = void 0) {
  const n = new Intl.DateTimeFormat(t, {
    weekday: e
  });
  return getWeekdayDates().map((s) => n.format(s));
}
function getHourDates() {
  const e = [];
  for (let t = 0; t <= 24; t++)
    e.push(new Date(2e3, 0, 1, t));
  return e;
}
function getRelativeTimeNames(e = void 0) {
  const t = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
  ], n = new Intl.RelativeTimeFormat(e);
  return t.reduce((s, i) => {
    const a = n.formatToParts(100, i);
    return s[i] = a[1].unit, s;
  }, {});
}
function getMonthDates() {
  const e = [];
  for (let t = 0; t < 12; t++)
    e.push(new Date(2e3, t, 15));
  return e;
}
function getMonthNames(e, t = void 0) {
  const n = new Intl.DateTimeFormat(t, {
    month: e,
    timeZone: "UTC"
  });
  return getMonthDates().map((s) => n.format(s));
}
function datePartIsValid(e, t, n) {
  return isNumber_1(t) ? t === e : isArray$d(t) ? t.includes(e) : isFunction_1(t) ? t(e, n) : !(t.min != null && t.min > e || t.max != null && t.max < e || t.interval != null && e % t.interval !== 0);
}
function getDatePartOptions(e, t, n) {
  const s = [], [i, a, o] = t;
  for (let l = i; l <= a; l++)
    (n == null || datePartIsValid(l, n, e)) && s.push({
      value: l,
      label: pad(l, o)
    });
  return s;
}
function getDatePartsOptions(e, t) {
  return {
    milliseconds: getDatePartOptions(
      e,
      DATE_PART_RANGES.milliseconds,
      t.milliseconds
    ),
    seconds: getDatePartOptions(e, DATE_PART_RANGES.seconds, t.seconds),
    minutes: getDatePartOptions(e, DATE_PART_RANGES.minutes, t.minutes),
    hours: getDatePartOptions(e, DATE_PART_RANGES.hours, t.hours)
  };
}
function getNearestDatePart(e, t, n, s) {
  const a = getDatePartOptions(e, t, s).reduce((o, l) => {
    if (l.disabled)
      return o;
    if (isNaN(o))
      return l.value;
    const c = Math.abs(o - n);
    return Math.abs(l.value - n) < c ? l.value : o;
  }, NaN);
  return isNaN(a) ? n : a;
}
function applyRulesForDateParts(e, t) {
  const n = { ...e };
  return Object.entries(t).forEach(([s, i]) => {
    const a = DATE_PART_RANGES[s], o = e[s];
    n[s] = getNearestDatePart(
      e,
      a,
      o,
      i
    );
  }), n;
}
function parseDate$1(e, t, n) {
  return normalizeMasks(t, n).map((i) => {
    if (typeof i != "string")
      throw new Error("Invalid mask");
    let a = e;
    if (a.length > 1e3)
      return !1;
    let o = !0;
    const l = {};
    if (i.replace(token, (d) => {
      if (parseFlags[d]) {
        const p = parseFlags[d], f = a.search(p[0]);
        ~f ? a.replace(p[0], (g) => (p[1](l, g, n), a = a.substr(f + g.length), g)) : o = !1;
      }
      return parseFlags[d] ? "" : d.slice(1, d.length - 1);
    }), !o)
      return !1;
    const c = /* @__PURE__ */ new Date();
    l.hours != null && (l.isPm === !0 && +l.hours != 12 ? l.hours = +l.hours + 12 : l.isPm === !1 && +l.hours == 12 && (l.hours = 0));
    let u;
    return l.timezoneOffset != null ? (l.minutes = +(l.minutes || 0) - +l.timezoneOffset, u = new Date(
      Date.UTC(
        l.year || c.getFullYear(),
        l.month || 0,
        l.day || 1,
        l.hours || 0,
        l.minutes || 0,
        l.seconds || 0,
        l.milliseconds || 0
      )
    )) : u = n.getDateFromParts({
      year: l.year || c.getFullYear(),
      month: (l.month || 0) + 1,
      day: l.day || 1,
      hours: l.hours || 0,
      minutes: l.minutes || 0,
      seconds: l.seconds || 0,
      milliseconds: l.milliseconds || 0
    }), u;
  }).find((i) => i) || new Date(e);
}
function formatDate(e, t, n) {
  if (e == null)
    return "";
  let s = normalizeMasks(t, n)[0];
  /Z$/.test(s) && (n.timezone = "utc");
  const i = [];
  s = s.replace(literal, (o, l) => (i.push(l), "??"));
  const a = n.getDateParts(e);
  return s = s.replace(
    token,
    (o) => o in formatFlags ? formatFlags[o](a, n) : o.slice(1, o.length - 1)
  ), s.replace(/\?\?/g, () => i.shift());
}
const viewAddressKeys = {
  daily: ["year", "month", "day"],
  weekly: ["year", "month", "week"],
  monthly: ["year", "month"]
};
function getDays({
  monthComps: e,
  prevMonthComps: t,
  nextMonthComps: n
}, s) {
  const i = [], {
    firstDayOfWeek: a,
    firstWeekday: o,
    isoWeeknumbers: l,
    weeknumbers: c,
    numDays: u,
    numWeeks: d
  } = e, p = o + (o < a ? daysInWeek : 0) - a;
  let f = !0, g = !1, C = !1, k = 0;
  const M = new Intl.DateTimeFormat(s.id, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  let _ = t.numDays - p + 1, S = t.numDays - _ + 1, E = Math.floor((_ - 1) / daysInWeek + 1), P = 1, $ = t.numWeeks, A = 1, I = t.month, D = t.year;
  const R = /* @__PURE__ */ new Date(), Y = R.getDate(), q = R.getMonth() + 1, j = R.getFullYear();
  for (let X = 1; X <= weeksInMonth; X++) {
    for (let ee = 1, G = a; ee <= daysInWeek; ee++, G += G === daysInWeek ? 1 - daysInWeek : 1) {
      f && G === o && (_ = 1, S = e.numDays, E = Math.floor((_ - 1) / daysInWeek + 1), P = Math.floor((u - _) / daysInWeek + 1), $ = 1, A = d, I = e.month, D = e.year, f = !1, g = !0);
      const H = s.getDateFromParams(D, I, _, 0, 0, 0, 0), F = s.getDateFromParams(D, I, _, 12, 0, 0, 0), B = s.getDateFromParams(
        D,
        I,
        _,
        23,
        59,
        59,
        999
      ), z = H, K = `${pad(D, 4)}-${pad(I, 2)}-${pad(_, 2)}`, Z = ee, re = daysInWeek - ee, ae = c[X - 1], te = l[X - 1], ue = _ === Y && I === q && D === j, ce = g && _ === 1, ge = g && _ === u, de = X === 1, le = X === d, me = ee === 1, ve = ee === daysInWeek, be = getDayIndex(D, I, _);
      i.push({
        locale: s,
        id: K,
        position: ++k,
        label: _.toString(),
        ariaLabel: M.format(new Date(D, I - 1, _)),
        day: _,
        dayFromEnd: S,
        weekday: G,
        weekdayPosition: Z,
        weekdayPositionFromEnd: re,
        weekdayOrdinal: E,
        weekdayOrdinalFromEnd: P,
        week: $,
        weekFromEnd: A,
        weekPosition: X,
        weeknumber: ae,
        isoWeeknumber: te,
        month: I,
        year: D,
        date: z,
        startDate: H,
        endDate: B,
        noonDate: F,
        dayIndex: be,
        isToday: ue,
        isFirstDay: ce,
        isLastDay: ge,
        isDisabled: !g,
        isFocusable: !g,
        isFocused: !1,
        inMonth: g,
        inPrevMonth: f,
        inNextMonth: C,
        onTop: de,
        onBottom: le,
        onLeft: me,
        onRight: ve,
        classes: [
          `id-${K}`,
          `day-${_}`,
          `day-from-end-${S}`,
          `weekday-${G}`,
          `weekday-position-${Z}`,
          `weekday-ordinal-${E}`,
          `weekday-ordinal-from-end-${P}`,
          `week-${$}`,
          `week-from-end-${A}`,
          {
            "is-today": ue,
            "is-first-day": ce,
            "is-last-day": ge,
            "in-month": g,
            "in-prev-month": f,
            "in-next-month": C,
            "on-top": de,
            "on-bottom": le,
            "on-left": me,
            "on-right": ve
          }
        ]
      }), g && ge ? (g = !1, C = !0, _ = 1, S = u, E = 1, P = Math.floor((u - _) / daysInWeek + 1), $ = 1, A = n.numWeeks, I = n.month, D = n.year) : (_++, S--, E = Math.floor((_ - 1) / daysInWeek + 1), P = Math.floor((u - _) / daysInWeek + 1));
    }
    $++, A--;
  }
  return i;
}
function getWeeks(e, t, n, s) {
  const i = e.reduce((a, o, l) => {
    const c = Math.floor(l / 7);
    let u = a[c];
    return u || (u = {
      id: `week-${c + 1}`,
      title: "",
      week: o.week,
      weekPosition: o.weekPosition,
      weeknumber: o.weeknumber,
      isoWeeknumber: o.isoWeeknumber,
      weeknumberDisplay: t ? o.weeknumber : n ? o.isoWeeknumber : void 0,
      days: []
    }, a[c] = u), u.days.push(o), a;
  }, Array(e.length / daysInWeek));
  return i.forEach((a) => {
    const o = a.days[0], l = a.days[a.days.length - 1];
    o.month === l.month ? a.title = `${s.formatDate(o.date, "MMMM YYYY")}` : o.year === l.year ? a.title = `${s.formatDate(
      o.date,
      "MMM"
    )} - ${s.formatDate(l.date, "MMM YYYY")}` : a.title = `${s.formatDate(
      o.date,
      "MMM YYYY"
    )} - ${s.formatDate(l.date, "MMM YYYY")}`;
  }), i;
}
function getWeekdays(e, t) {
  return e.days.map((n) => ({
    label: t.formatDate(n.date, t.masks.weekdays),
    weekday: n.weekday
  }));
}
function getPageAddressForDate(e, t, n) {
  return pick(
    n.getDateParts(n.toDate(e)),
    viewAddressKeys[t]
  );
}
function addPages({ day: e, week: t, month: n, year: s }, i, a, o) {
  if (a === "daily" && e) {
    const l = new Date(s, n - 1, e), c = addDays$1(l, i);
    return {
      day: c.getDate(),
      month: c.getMonth() + 1,
      year: c.getFullYear()
    };
  } else if (a === "weekly" && t) {
    const c = o.getMonthParts(n, s).firstDayOfMonth, u = addDays$1(c, (t - 1 + i) * 7), d = o.getDateParts(u);
    return {
      week: d.week,
      month: d.month,
      year: d.year
    };
  } else {
    const l = new Date(s, n - 1, 1), c = addMonths$1(l, i);
    return {
      month: c.getMonth() + 1,
      year: c.getFullYear()
    };
  }
}
function pageIsValid(e) {
  return e != null && e.month != null && e.year != null;
}
function pageIsBeforePage(e, t) {
  return !pageIsValid(e) || !pageIsValid(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year < t.year : e.month && t.month && e.month !== t.month ? e.month < t.month : e.week && t.week && e.week !== t.week ? e.week < t.week : e.day && t.day && e.day !== t.day ? e.day < t.day : !1);
}
function pageIsAfterPage(e, t) {
  return !pageIsValid(e) || !pageIsValid(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year > t.year : e.month && t.month && e.month !== t.month ? e.month > t.month : e.week && t.week && e.week !== t.week ? e.week > t.week : e.day && t.day && e.day !== t.day ? e.day > t.day : !1);
}
function pageIsBetweenPages(e, t, n) {
  return (e || !1) && !pageIsBeforePage(e, t) && !pageIsAfterPage(e, n);
}
function pageIsEqualToPage(e, t) {
  return !e && t || e && !t ? !1 : !e && !t ? !0 : (e = e, t = t, e.year === t.year && e.month === t.month && e.week === t.week && e.day === t.day);
}
function pageRangeToArray(e, t, n, s) {
  if (!pageIsValid(e) || !pageIsValid(t))
    return [];
  const i = [];
  for (; !pageIsAfterPage(e, t); )
    i.push(e), e = addPages(e, 1, n, s);
  return i;
}
function getPageKey(e) {
  const { day: t, week: n, month: s, year: i } = e;
  let a = `${i}-${pad(s, 2)}`;
  return n && (a = `${a}-w${n}`), t && (a = `${a}-${pad(t, 2)}`), a;
}
function getCachedPage(e, t) {
  const { month: n, year: s, showWeeknumbers: i, showIsoWeeknumbers: a } = e, o = new Date(s, n - 1, 15), l = t.getMonthParts(n, s), c = t.getPrevMonthParts(n, s), u = t.getNextMonthParts(n, s), d = getDays({ monthComps: l, prevMonthComps: c, nextMonthComps: u }, t), p = getWeeks(d, i, a, t), f = getWeekdays(p[0], t);
  return {
    id: getPageKey(e),
    month: n,
    year: s,
    monthTitle: t.formatDate(o, t.masks.title),
    shortMonthLabel: t.formatDate(o, "MMM"),
    monthLabel: t.formatDate(o, "MMMM"),
    shortYearLabel: s.toString().substring(2),
    yearLabel: s.toString(),
    monthComps: l,
    prevMonthComps: c,
    nextMonthComps: u,
    days: d,
    weeks: p,
    weekdays: f
  };
}
function getPage(e, t) {
  const { day: n, week: s, view: i, trimWeeks: a } = e, o = {
    ...t,
    ...e,
    title: "",
    viewDays: [],
    viewWeeks: []
  };
  switch (i) {
    case "daily": {
      let l = o.days.find((u) => u.inMonth);
      n ? l = o.days.find((u) => u.day === n && u.inMonth) || l : s && (l = o.days.find((u) => u.week === s && u.inMonth));
      const c = o.weeks[l.week - 1];
      o.viewWeeks = [c], o.viewDays = [l], o.week = l.week, o.weekTitle = c.title, o.day = l.day, o.dayTitle = l.ariaLabel, o.title = o.dayTitle;
      break;
    }
    case "weekly": {
      o.week = s || 1;
      const l = o.weeks[o.week - 1];
      o.viewWeeks = [l], o.viewDays = l.days, o.weekTitle = l.title, o.title = o.weekTitle;
      break;
    }
    default: {
      o.title = o.monthTitle, o.viewWeeks = o.weeks.slice(
        0,
        a ? o.monthComps.numWeeks : void 0
      ), o.viewDays = o.days;
      break;
    }
  }
  return o;
}
class Cache {
  constructor(t, n, s) {
    __publicField(this, "keys", []), __publicField(this, "store", {}), this.size = t, this.createKey = n, this.createItem = s;
  }
  get(...t) {
    const n = this.createKey(...t);
    return this.store[n];
  }
  getOrSet(...t) {
    const n = this.createKey(...t);
    if (this.store[n])
      return this.store[n];
    const s = this.createItem(...t);
    if (this.keys.length >= this.size) {
      const i = this.keys.shift();
      i != null && delete this.store[i];
    }
    return this.keys.push(n), this.store[n] = s, s;
  }
}
class DateRange {
  constructor(t, n = new Locale()) {
    __publicField(this, "order"), __publicField(this, "locale"), __publicField(this, "start", null), __publicField(this, "end", null), __publicField(this, "repeat", null);
    var s;
    this.locale = n;
    const { start: i, end: a, span: o, order: l, repeat: c } = t;
    isDate$2(i) && (this.start = n.getDateParts(i)), isDate$2(a) ? this.end = n.getDateParts(a) : this.start != null && o && (this.end = n.getDateParts(addDays$1(this.start.date, o - 1))), this.order = l ?? 0, c && (this.repeat = new DateRepeat(
      {
        from: (s = this.start) == null ? void 0 : s.date,
        ...c
      },
      {
        locale: this.locale
      }
    ));
  }
  static fromMany(t, n) {
    return (isArray$d(t) ? t : [t]).filter((s) => s).map((s) => DateRange.from(s, n));
  }
  static from(t, n) {
    if (t instanceof DateRange)
      return t;
    const s = {
      start: null,
      end: null
    };
    return t != null && (isArray$d(t) ? (s.start = t[0] ?? null, s.end = t[1] ?? null) : isObject$b(t) ? Object.assign(s, t) : (s.start = t, s.end = t)), s.start != null && (s.start = new Date(s.start)), s.end != null && (s.end = new Date(s.end)), new DateRange(s, n);
  }
  get opts() {
    const { order: t, locale: n } = this;
    return { order: t, locale: n };
  }
  get hasRepeat() {
    return !!this.repeat;
  }
  get isSingleDay() {
    const { start: t, end: n } = this;
    return t && n && t.year === n.year && t.month === n.month && t.day === n.day;
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get daySpan() {
    return this.start == null || this.end == null ? this.hasRepeat ? 1 : 1 / 0 : this.end.dayIndex - this.start.dayIndex;
  }
  startsOnDay(t) {
    var n, s;
    return ((n = this.start) == null ? void 0 : n.dayIndex) === t.dayIndex || !!((s = this.repeat) != null && s.passes(t));
  }
  intersectsDay(t) {
    return this.intersectsDayRange(t, t);
  }
  intersectsRange(t) {
    var n, s;
    return this.intersectsDayRange(
      ((n = t.start) == null ? void 0 : n.dayIndex) ?? -1 / 0,
      ((s = t.end) == null ? void 0 : s.dayIndex) ?? 1 / 0
    );
  }
  intersectsDayRange(t, n) {
    return !(this.start && this.start.dayIndex > n || this.end && this.end.dayIndex < t);
  }
}
class DateRangeContext {
  constructor() {
    __publicField(this, "records", {});
  }
  render(t, n, s) {
    var i, a, o, l;
    let c = null;
    const u = s[0].dayIndex, d = s[s.length - 1].dayIndex;
    return n.hasRepeat ? s.forEach((p) => {
      var f, g;
      if (n.startsOnDay(p)) {
        const C = n.daySpan < 1 / 0 ? n.daySpan : 1;
        c = {
          startDay: p.dayIndex,
          startTime: ((f = n.start) == null ? void 0 : f.time) ?? 0,
          endDay: p.dayIndex + C - 1,
          endTime: ((g = n.end) == null ? void 0 : g.time) ?? MS_PER_DAY
        }, this.getRangeRecords(t).push(c);
      }
    }) : n.intersectsDayRange(u, d) && (c = {
      startDay: ((i = n.start) == null ? void 0 : i.dayIndex) ?? -1 / 0,
      startTime: ((a = n.start) == null ? void 0 : a.time) ?? -1 / 0,
      endDay: ((o = n.end) == null ? void 0 : o.dayIndex) ?? 1 / 0,
      endTime: ((l = n.end) == null ? void 0 : l.time) ?? 1 / 0
    }, this.getRangeRecords(t).push(c)), c;
  }
  getRangeRecords(t) {
    let n = this.records[t.key];
    return n || (n = {
      ranges: [],
      data: t
    }, this.records[t.key] = n), n.ranges;
  }
  getCell(t, n) {
    return this.getCells(n).find((a) => a.data.key === t);
  }
  cellExists(t, n) {
    const s = this.records[t];
    return s == null ? !1 : s.ranges.some(
      (i) => i.startDay <= n && i.endDay >= n
    );
  }
  getCells(t) {
    const n = Object.values(this.records), s = [], { dayIndex: i } = t;
    return n.forEach(({ data: a, ranges: o }) => {
      o.filter((l) => l.startDay <= i && l.endDay >= i).forEach((l) => {
        const c = i === l.startDay, u = i === l.endDay, d = c ? l.startTime : 0, p = new Date(t.startDate.getTime() + d), f = u ? l.endTime : MS_PER_DAY, g = new Date(t.endDate.getTime() + f), C = d === 0 && f === MS_PER_DAY, k = a.order || 0;
        s.push({
          ...l,
          data: a,
          onStart: c,
          onEnd: u,
          startTime: d,
          startDate: p,
          endTime: f,
          endDate: g,
          allDay: C,
          order: k
        });
      });
    }), s.sort((a, o) => a.order - o.order), s;
  }
}
const DEFAULT_MONTH_CACHE_SIZE = 12, DEFAULT_PAGE_CACHE_SIZE = 5;
function resolveConfig(e, t) {
  const n = new Intl.DateTimeFormat().resolvedOptions().locale;
  let s;
  isString_1(e) ? s = e : has(e, "id") && (s = e.id), s = (s || n).toLowerCase();
  const i = Object.keys(t), a = (c) => i.find((u) => u.toLowerCase() === c);
  s = a(s) || a(s.substring(0, 2)) || n;
  const o = {
    ...t["en-IE"],
    ...t[s],
    id: s,
    monthCacheSize: DEFAULT_MONTH_CACHE_SIZE,
    pageCacheSize: DEFAULT_PAGE_CACHE_SIZE
  };
  return isObject$b(e) ? defaultsDeep_1(e, o) : o;
}
class Locale {
  constructor(t = void 0, n) {
    __publicField(this, "id"), __publicField(this, "daysInWeek"), __publicField(this, "firstDayOfWeek"), __publicField(this, "masks"), __publicField(this, "timezone"), __publicField(this, "hourLabels"), __publicField(this, "dayNames"), __publicField(this, "dayNamesShort"), __publicField(this, "dayNamesShorter"), __publicField(this, "dayNamesNarrow"), __publicField(this, "monthNames"), __publicField(this, "monthNamesShort"), __publicField(this, "relativeTimeNames"), __publicField(this, "amPm", ["am", "pm"]), __publicField(this, "monthCache"), __publicField(this, "pageCache");
    const { id: s, firstDayOfWeek: i, masks: a, monthCacheSize: o, pageCacheSize: l } = resolveConfig(t, defaultLocales.value);
    this.monthCache = new Cache(
      o,
      getMonthPartsKey,
      getMonthParts
    ), this.pageCache = new Cache(l, getPageKey, getCachedPage), this.id = s, this.daysInWeek = daysInWeek, this.firstDayOfWeek = clamp(i, 1, daysInWeek), this.masks = a, this.timezone = n || void 0, this.hourLabels = this.getHourLabels(), this.dayNames = getDayNames("long", this.id), this.dayNamesShort = getDayNames("short", this.id), this.dayNamesShorter = this.dayNamesShort.map((c) => c.substring(0, 2)), this.dayNamesNarrow = getDayNames("narrow", this.id), this.monthNames = getMonthNames("long", this.id), this.monthNamesShort = getMonthNames("short", this.id), this.relativeTimeNames = getRelativeTimeNames(this.id);
  }
  formatDate(t, n) {
    return formatDate(t, n, this);
  }
  parseDate(t, n) {
    return parseDate$1(t, n, this);
  }
  toDate(t, n = {}) {
    const s = /* @__PURE__ */ new Date(NaN);
    let i = s;
    const { fillDate: a, mask: o, patch: l, rules: c } = n;
    if (isNumber_1(t) ? (n.type = "number", i = /* @__PURE__ */ new Date(+t)) : isString_1(t) ? (n.type = "string", i = t ? parseDate$1(t, o || "iso", this) : s) : isDate$2(t) ? (n.type = "date", i = new Date(t.getTime())) : isDateParts(t) && (n.type = "object", i = this.getDateFromParts(t)), i && (l || c)) {
      let u = this.getDateParts(i);
      if (l && a != null) {
        const d = this.getDateParts(this.toDate(a));
        u = this.getDateParts(
          this.toDate({ ...d, ...pick(u, DatePatchKeys[l]) })
        );
      }
      c && (u = applyRulesForDateParts(u, c)), i = this.getDateFromParts(u);
    }
    return i || s;
  }
  toDateOrNull(t, n = {}) {
    const s = this.toDate(t, n);
    return isNaN(s.getTime()) ? null : s;
  }
  fromDate(t, { type: n, mask: s } = {}) {
    switch (n) {
      case "number":
        return t ? t.getTime() : NaN;
      case "string":
        return t ? this.formatDate(t, s || "iso") : "";
      case "object":
        return t ? this.getDateParts(t) : null;
      default:
        return t ? new Date(t) : null;
    }
  }
  range(t) {
    return DateRange.from(t, this);
  }
  ranges(t) {
    return DateRange.fromMany(t, this);
  }
  getDateParts(t) {
    return getDateParts(t, this);
  }
  getDateFromParts(t) {
    return getDateFromParts(t, this.timezone);
  }
  getDateFromParams(t, n, s, i, a, o, l) {
    return this.getDateFromParts({
      year: t,
      month: n,
      day: s,
      hours: i,
      minutes: a,
      seconds: o,
      milliseconds: l
    });
  }
  getPage(t) {
    const n = this.pageCache.getOrSet(t, this);
    return getPage(t, n);
  }
  getMonthParts(t, n) {
    const { firstDayOfWeek: s } = this;
    return this.monthCache.getOrSet(t, n, s);
  }
  getThisMonthParts() {
    const t = /* @__PURE__ */ new Date();
    return this.getMonthParts(
      t.getMonth() + 1,
      t.getFullYear()
    );
  }
  getPrevMonthParts(t, n) {
    return t === 1 ? this.getMonthParts(12, n - 1) : this.getMonthParts(t - 1, n);
  }
  getNextMonthParts(t, n) {
    return t === 12 ? this.getMonthParts(1, n + 1) : this.getMonthParts(t + 1, n);
  }
  getHourLabels() {
    return getHourDates().map((t) => this.formatDate(t, this.masks.hours));
  }
  getDayId(t) {
    return this.formatDate(t, "YYYY-MM-DD");
  }
}
class Attribute {
  constructor(t, n, s) {
    __publicField(this, "key", ""), __publicField(this, "hashcode", ""), __publicField(this, "highlight", null), __publicField(this, "content", null), __publicField(this, "dot", null), __publicField(this, "bar", null), __publicField(this, "event", null), __publicField(this, "popover", null), __publicField(this, "customData", null), __publicField(this, "ranges"), __publicField(this, "hasRanges", !1), __publicField(this, "order", 0), __publicField(this, "pinPage", !1), __publicField(this, "maxRepeatSpan", 0), __publicField(this, "locale");
    const { dates: i } = Object.assign(
      this,
      { hashcode: "", order: 0, pinPage: !1 },
      t
    );
    this.key || (this.key = createGuid()), this.locale = s, n.normalizeGlyphs(this), this.ranges = s.ranges(i ?? []), this.hasRanges = !!arrayHasItems(this.ranges), this.maxRepeatSpan = this.ranges.filter((a) => a.hasRepeat).map((a) => a.daySpan).reduce((a, o) => Math.max(a, o), 0);
  }
  intersectsRange({ start: t, end: n }) {
    if (t == null || n == null)
      return !1;
    const s = this.ranges.filter((o) => !o.hasRepeat);
    for (const o of s)
      if (o.intersectsDayRange(t.dayIndex, n.dayIndex))
        return !0;
    const i = this.ranges.filter((o) => o.hasRepeat);
    if (!i.length)
      return !1;
    let a = t;
    for (this.maxRepeatSpan > 1 && (a = this.locale.getDateParts(addDays$1(a.date, -this.maxRepeatSpan))); a.dayIndex <= n.dayIndex; ) {
      for (const o of i)
        if (o.startsOnDay(a))
          return !0;
      a = this.locale.getDateParts(addDays$1(a.date, 1));
    }
    return !1;
  }
}
const contextKey$3 = "__vc_base_context__", propsDef$3 = {
  color: {
    type: String,
    default: () => getDefault("color")
  },
  isDark: {
    type: [Boolean, String, Object],
    default: () => getDefault("isDark")
  },
  firstDayOfWeek: Number,
  masks: Object,
  locale: [String, Object],
  timezone: String,
  minDate: null,
  maxDate: null,
  disabledDates: null
};
function createBase(e) {
  const t = computed(() => e.color ?? ""), n = computed(() => e.isDark ?? !1), { displayMode: s } = useDarkMode(n), i = computed(() => new Theme(t.value)), a = computed(() => {
    if (e.locale instanceof Locale)
      return e.locale;
    const d = isObject$b(e.locale) ? e.locale : {
      id: e.locale,
      firstDayOfWeek: e.firstDayOfWeek,
      masks: e.masks
    };
    return new Locale(d, e.timezone);
  }), o = computed(() => a.value.masks), l = computed(() => {
    const d = e.disabledDates ?? [];
    return e.minDate != null && d.push({
      start: null,
      end: addDays$1(a.value.toDate(e.minDate), -1)
    }), e.maxDate != null && d.push({
      start: addDays$1(a.value.toDate(e.maxDate), 1),
      end: null
    }), a.value.ranges(d);
  }), c = computed(() => new Attribute(
    {
      key: "disabled",
      dates: l.value,
      order: 100
    },
    i.value,
    a.value
  )), u = {
    color: t,
    isDark: n,
    displayMode: s,
    theme: i,
    locale: a,
    masks: o,
    disabledDates: l,
    disabledAttribute: c
  };
  return provide(contextKey$3, u), u;
}
function useOrCreateBase(e) {
  return inject(contextKey$3, createBase(e));
}
const addHorizontalSwipeHandler = (e, t, {
  maxSwipeTime: n,
  minHorizontalSwipeDistance: s,
  maxVerticalSwipeDistance: i
}) => {
  if (!e || !e.addEventListener || !isFunction_1(t))
    return null;
  let a = 0, o = 0, l = null, c = !1;
  function u(p) {
    const f = p.changedTouches[0];
    a = f.screenX, o = f.screenY, l = (/* @__PURE__ */ new Date()).getTime(), c = !0;
  }
  function d(p) {
    if (!c || !l)
      return;
    c = !1;
    const f = p.changedTouches[0], g = f.screenX - a, C = f.screenY - o;
    if ((/* @__PURE__ */ new Date()).getTime() - l < n && Math.abs(g) >= s && Math.abs(C) <= i) {
      const M = { toLeft: !1, toRight: !1 };
      g < 0 ? M.toLeft = !0 : M.toRight = !0, t(M);
    }
  }
  return on(e, "touchstart", u, { passive: !0 }), on(e, "touchend", d, { passive: !0 }), () => {
    off(e, "touchstart", u), off(e, "touchend", d);
  };
}, watchSkippers = {}, skipWatcher = (e, t = 10) => {
  watchSkippers[e] = Date.now() + t;
}, handleWatcher = (e, t) => {
  if (e in watchSkippers) {
    const n = watchSkippers[e];
    if (Date.now() < n)
      return;
    delete watchSkippers[e];
  }
  t();
}, propsDef$2 = {
  ...propsDef$3,
  view: {
    type: String,
    default: "monthly",
    validator(e) {
      return ["daily", "weekly", "monthly"].includes(e);
    }
  },
  rows: {
    type: Number,
    default: 1
  },
  columns: {
    type: Number,
    default: 1
  },
  step: Number,
  titlePosition: {
    type: String,
    default: () => getDefault("titlePosition")
  },
  navVisibility: {
    type: String,
    default: () => getDefault("navVisibility")
  },
  showWeeknumbers: [Boolean, String],
  showIsoWeeknumbers: [Boolean, String],
  expanded: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  initialPage: Object,
  initialPagePosition: { type: Number, default: 1 },
  minPage: Object,
  maxPage: Object,
  transition: String,
  attributes: Array,
  trimWeeks: Boolean,
  disablePageSwipe: Boolean
}, emitsDef$1 = [
  "dayclick",
  "daymouseenter",
  "daymouseleave",
  "dayfocusin",
  "dayfocusout",
  "daykeydown",
  "weeknumberclick",
  "transition-start",
  "transition-end",
  "did-move",
  "update:view",
  "update:pages"
], contextKey$2 = "__vc_calendar_context__";
function createCalendar(e, { emit: t, slots: n }) {
  const s = ref(null), i = ref(null), a = ref(null), o = ref((/* @__PURE__ */ new Date()).getDate()), l = ref(!1), c = ref(createGuid()), u = ref(createGuid()), d = ref(e.view), p = ref([]), f = ref("");
  let g = null, C = null;
  const {
    theme: k,
    color: M,
    displayMode: _,
    locale: S,
    masks: E,
    disabledAttribute: P,
    disabledDates: $
  } = useOrCreateBase(e), A = computed(() => e.rows * e.columns), I = computed(() => e.step || A.value), D = computed(() => head_1(p.value) ?? null), R = computed(() => last_1(p.value) ?? null), Y = computed(
    () => e.minPage || (e.minDate ? Z(e.minDate) : null)
  ), q = computed(
    () => e.maxPage || (e.maxDate ? Z(e.maxDate) : null)
  ), j = computed(() => e.navVisibility), X = computed(() => !!e.showWeeknumbers), ee = computed(() => !!e.showIsoWeeknumbers), G = computed(() => d.value === "monthly"), H = computed(() => d.value === "weekly"), F = computed(() => d.value === "daily"), B = () => {
    l.value = !0, t("transition-start");
  }, z = () => {
    l.value = !1, t("transition-end"), g && (g.resolve(!0), g = null);
  }, K = (ne, ie, he = d.value) => addPages(ne, ie, he, S.value), Z = (ne) => getPageAddressForDate(ne, d.value, S.value), re = (ne) => {
    !P.value || !de.value || (ne.isDisabled = de.value.cellExists(
      P.value.key,
      ne.dayIndex
    ));
  }, ae = (ne) => {
    ne.isFocusable = ne.inMonth && ne.day === o.value;
  }, te = (ne, ie) => {
    for (const he of ne)
      for (const Q of he.days)
        if (ie(Q) === !1)
          return;
  }, ue = computed(
    () => p.value.reduce((ne, ie) => (ne.push(...ie.viewDays), ne), [])
  ), ce = computed(() => {
    const ne = [];
    return (e.attributes || []).forEach((ie, he) => {
      if (!ie || !ie.dates)
        return;
      const Q = has(ie, "key") ? ie.key : he, se = ie.order || 0;
      ne.push(
        new Attribute(
          {
            ...ie,
            key: Q,
            order: se
          },
          k.value,
          S.value
        )
      );
    }), P.value && ne.push(P.value), ne;
  }), ge = computed(() => arrayHasItems(ce.value)), de = computed(() => {
    const ne = new DateRangeContext();
    return ce.value.forEach((ie) => {
      ie.ranges.forEach((he) => {
        ne.render(ie, he, ue.value);
      });
    }), ne;
  }), le = computed(() => ue.value.reduce((ne, ie) => (ne[ie.dayIndex] = { day: ie, cells: [] }, ne[ie.dayIndex].cells.push(...de.value.getCells(ie)), ne), {})), me = (ne, ie) => {
    const he = e.showWeeknumbers || e.showIsoWeeknumbers;
    return he == null ? "" : isBoolean_1(he) ? he ? "left" : "" : he.startsWith("right") ? ie > 1 ? "right" : he : ne > 1 ? "left" : he;
  }, ve = () => {
    var ne, ie;
    if (!ge.value)
      return null;
    const he = ce.value.find((fe) => fe.pinPage) || ce.value[0];
    if (!he || !he.hasRanges)
      return null;
    const [Q] = he.ranges, se = ((ne = Q.start) == null ? void 0 : ne.date) || ((ie = Q.end) == null ? void 0 : ie.date);
    return se ? Z(se) : null;
  }, be = () => {
    if (pageIsValid(D.value))
      return D.value;
    const ne = ve();
    return pageIsValid(ne) ? ne : Z(/* @__PURE__ */ new Date());
  }, oe = (ne, ie = {}) => {
    const { view: he = d.value, position: Q = 1, force: se } = ie, fe = Q > 0 ? 1 - Q : -(A.value + Q);
    let _e = K(ne, fe, he), Te = K(_e, A.value - 1, he);
    return se || (pageIsBeforePage(_e, Y.value) ? _e = Y.value : pageIsAfterPage(Te, q.value) && (_e = K(q.value, 1 - A.value)), Te = K(_e, A.value - 1)), { fromPage: _e, toPage: Te };
  }, ye = (ne, ie, he = "") => {
    if (he === "none" || he === "fade")
      return he;
    if ((ne == null ? void 0 : ne.view) !== (ie == null ? void 0 : ie.view))
      return "fade";
    const Q = pageIsAfterPage(ie, ne), se = pageIsBeforePage(ie, ne);
    return !Q && !se ? "fade" : he === "slide-v" ? se ? "slide-down" : "slide-up" : se ? "slide-right" : "slide-left";
  }, we = (ne = {}) => new Promise((ie, he) => {
    const { position: Q = 1, force: se = !1, transition: fe } = ne, _e = pageIsValid(ne.page) ? ne.page : be(), { fromPage: Te } = oe(_e, {
      position: Q,
      force: se
    }), Ve = [];
    for (let Ne = 0; Ne < A.value; Ne++) {
      const ze = K(Te, Ne), We = Ne + 1, Ue = Math.ceil(We / e.columns), Le = e.rows - Ue + 1, qe = We % e.columns || e.columns, Ye = e.columns - qe + 1, Je = me(qe, Ye);
      Ve.push(
        S.value.getPage({
          ...ze,
          view: d.value,
          titlePosition: e.titlePosition,
          trimWeeks: e.trimWeeks,
          position: We,
          row: Ue,
          rowFromEnd: Le,
          column: qe,
          columnFromEnd: Ye,
          showWeeknumbers: X.value,
          showIsoWeeknumbers: ee.value,
          weeknumberPosition: Je
        })
      );
    }
    f.value = ye(
      p.value[0],
      Ve[0],
      fe
    ), p.value = Ve, f.value && f.value !== "none" ? g = {
      resolve: ie,
      reject: he
    } : ie(!0);
  }), Ae = (ne) => {
    const ie = D.value ?? Z(/* @__PURE__ */ new Date());
    return K(ie, ne);
  }, Se = (ne, ie = {}) => {
    const he = pageIsValid(ne) ? ne : Z(ne);
    return Object.assign(
      ie,
      oe(he, {
        ...ie,
        force: !0
      })
    ), pageRangeToArray(
      ie.fromPage,
      ie.toPage,
      d.value,
      S.value
    ).map((se) => pageIsBetweenPages(se, Y.value, q.value)).every((se) => se);
  }, Ee = (ne, ie = {}) => Se(Ae(ne), ie), Ie = computed(() => Ee(-I.value)), xe = computed(() => Ee(I.value)), Ce = async (ne, ie = {}) => !ie.force && !Se(ne, ie) ? !1 : (ie.fromPage && !pageIsEqualToPage(ie.fromPage, D.value) && (i.value && i.value.hide({ hideDelay: 0 }), ie.view && (skipWatcher("view", 10), d.value = ie.view), await we({
    ...ie,
    page: ie.fromPage,
    position: 1,
    force: !0
  }), t("did-move", p.value)), !0), $e = (ne, ie = {}) => Ce(Ae(ne), ie), De = () => $e(-I.value), ke = () => $e(I.value), Me = (ne) => {
    const ie = G.value ? ".in-month" : "", he = `.id-${S.value.getDayId(ne)}${ie}`, Q = `${he}.vc-focusable, ${he} .vc-focusable`, se = s.value;
    if (se) {
      const fe = se.querySelector(Q);
      if (fe)
        return fe.focus(), !0;
    }
    return !1;
  }, Pe = async (ne, ie = {}) => Me(ne) ? !0 : (await Ce(ne, ie), Me(ne)), Oe = (ne, ie) => {
    o.value = ne.day, t("dayclick", ne, ie);
  }, Be = (ne, ie) => {
    t("daymouseenter", ne, ie);
  }, Fe = (ne, ie) => {
    t("daymouseleave", ne, ie);
  }, He = (ne, ie) => {
    o.value = ne.day, a.value = ne, ne.isFocused = !0, t("dayfocusin", ne, ie);
  }, Ze = (ne, ie) => {
    a.value = null, ne.isFocused = !1, t("dayfocusout", ne, ie);
  }, je = (ne, ie) => {
    t("daykeydown", ne, ie);
    const he = ne.noonDate;
    let Q = null;
    switch (ie.key) {
      case "ArrowLeft": {
        Q = addDays$1(he, -1);
        break;
      }
      case "ArrowRight": {
        Q = addDays$1(he, 1);
        break;
      }
      case "ArrowUp": {
        Q = addDays$1(he, -7);
        break;
      }
      case "ArrowDown": {
        Q = addDays$1(he, 7);
        break;
      }
      case "Home": {
        Q = addDays$1(he, -ne.weekdayPosition + 1);
        break;
      }
      case "End": {
        Q = addDays$1(he, ne.weekdayPositionFromEnd);
        break;
      }
      case "PageUp": {
        ie.altKey ? Q = addYears$1(he, -1) : Q = addMonths$1(he, -1);
        break;
      }
      case "PageDown": {
        ie.altKey ? Q = addYears$1(he, 1) : Q = addMonths$1(he, 1);
        break;
      }
    }
    Q && (ie.preventDefault(), Pe(Q).catch());
  }, Xe = (ne) => {
    const ie = a.value;
    ie != null && je(ie, ne);
  }, Qe = (ne, ie) => {
    t("weeknumberclick", ne, ie);
  };
  we({
    page: e.initialPage,
    position: e.initialPagePosition
  }), onMounted(() => {
    !e.disablePageSwipe && s.value && (C = addHorizontalSwipeHandler(
      s.value,
      ({ toLeft: ne = !1, toRight: ie = !1 }) => {
        ne ? ke() : ie && De();
      },
      getDefault("touch")
    ));
  }), onUnmounted(() => {
    p.value = [], C && C();
  }), watch(
    () => S.value,
    () => {
      we();
    }
  ), watch(
    () => A.value,
    () => we()
  ), watch(
    () => e.view,
    () => d.value = e.view
  ), watch(
    () => d.value,
    () => {
      handleWatcher("view", () => {
        we();
      }), t("update:view", d.value);
    }
  ), watch(
    () => o.value,
    () => {
      te(p.value, (ne) => ae(ne));
    }
  ), watchEffect(() => {
    t("update:pages", p.value), te(p.value, (ne) => {
      re(ne), ae(ne);
    });
  });
  const Ge = {
    emit: t,
    slots: n,
    containerRef: s,
    navPopoverRef: i,
    focusedDay: a,
    inTransition: l,
    navPopoverId: c,
    dayPopoverId: u,
    view: d,
    pages: p,
    transitionName: f,
    theme: k,
    color: M,
    displayMode: _,
    locale: S,
    masks: E,
    attributes: ce,
    disabledAttribute: P,
    disabledDates: $,
    attributeContext: de,
    days: ue,
    dayCells: le,
    count: A,
    step: I,
    firstPage: D,
    lastPage: R,
    canMovePrev: Ie,
    canMoveNext: xe,
    minPage: Y,
    maxPage: q,
    isMonthly: G,
    isWeekly: H,
    isDaily: F,
    navVisibility: j,
    showWeeknumbers: X,
    showIsoWeeknumbers: ee,
    getDateAddress: Z,
    canMove: Se,
    canMoveBy: Ee,
    move: Ce,
    moveBy: $e,
    movePrev: De,
    moveNext: ke,
    onTransitionBeforeEnter: B,
    onTransitionAfterEnter: z,
    tryFocusDate: Me,
    focusDate: Pe,
    onKeydown: Xe,
    onDayKeydown: je,
    onDayClick: Oe,
    onDayMouseenter: Be,
    onDayMouseleave: Fe,
    onDayFocusin: He,
    onDayFocusout: Ze,
    onWeeknumberClick: Qe
  };
  return provide(contextKey$2, Ge), Ge;
}
function useCalendar() {
  const e = inject(contextKey$2);
  if (e)
    return e;
  throw new Error(
    "Calendar context missing. Please verify this component is nested within a valid context provider."
  );
}
const __default__$1 = {
  inheritAttrs: !1
}, _sfc_main$c = /* @__PURE__ */ defineComponent({
  ...__default__$1,
  __name: "CalendarSlot",
  props: {
    name: null
  },
  setup(e) {
    const { slots: t } = useCalendar();
    return (n, s) => unref(t)[e.name] ? (openBlock(), createBlock(resolveDynamicComponent(unref(t)[e.name]), normalizeProps(mergeProps({ key: 0 }, n.$attrs)), null, 16)) : renderSlot(n.$slots, "default", { key: 1 });
  }
});
function showPopover(e) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: e
    })
  );
}
function hidePopover(e) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: e
    })
  );
}
function togglePopover(e) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: e
    })
  );
}
function getPopoverEventHandlers(e) {
  const { visibility: t } = e, n = t === "click", s = t === "hover", i = t === "hover-focus", a = t === "focus";
  e.autoHide = !n;
  let o = !1, l = !1;
  const c = (C) => {
    n && (togglePopover({
      ...e,
      target: e.target || C.currentTarget
    }), C.stopPropagation());
  }, u = (C) => {
    o || (o = !0, (s || i) && showPopover({
      ...e,
      target: e.target || C.currentTarget
    }));
  }, d = () => {
    o && (o = !1, (s || i && !l) && hidePopover(e));
  }, p = (C) => {
    l || (l = !0, (a || i) && showPopover({
      ...e,
      target: e.target || C.currentTarget
    }));
  }, f = (C) => {
    l && !elementContains(C.currentTarget, C.relatedTarget) && (l = !1, (a || i && !o) && hidePopover(e));
  }, g = {};
  switch (e.visibility) {
    case "click":
      g.click = c;
      break;
    case "hover":
      g.mousemove = u, g.mouseleave = d;
      break;
    case "focus":
      g.focusin = p, g.focusout = f;
      break;
    case "hover-focus":
      g.mousemove = u, g.mouseleave = d, g.focusin = p, g.focusout = f;
      break;
  }
  return g;
}
const removeHandlers = (e) => {
  const t = resolveEl(e);
  if (t == null)
    return;
  const n = t.popoverHandlers;
  !n || !n.length || (n.forEach((s) => s()), delete t.popoverHandlers);
}, addHandlers = (e, t) => {
  const n = resolveEl(e);
  if (n == null)
    return;
  const s = [], i = getPopoverEventHandlers(t);
  Object.entries(i).forEach(([a, o]) => {
    s.push(on(n, a, o));
  }), n.popoverHandlers = s;
}, popoverDirective = {
  mounted(e, t) {
    const { value: n } = t;
    n && addHandlers(e, n);
  },
  updated(e, t) {
    const { oldValue: n, value: s } = t, i = n == null ? void 0 : n.visibility, a = s == null ? void 0 : s.visibility;
    i !== a && (i && (removeHandlers(e), a || hidePopover(n)), a && addHandlers(e, s));
  },
  unmounted(e) {
    removeHandlers(e);
  }
}, _hoisted_1$8 = ["disabled"], _hoisted_2$7 = {
  key: 1,
  type: "button",
  class: "vc-title"
}, _hoisted_3$5 = ["disabled"], _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "CalendarHeader",
  props: {
    page: { type: Object, required: !0 },
    layout: String,
    isLg: Boolean,
    isXl: Boolean,
    is2xl: Boolean,
    hideTitle: Boolean,
    hideArrows: Boolean
  },
  setup(e) {
    const t = e, {
      navPopoverId: n,
      navVisibility: s,
      canMovePrev: i,
      movePrev: a,
      canMoveNext: o,
      moveNext: l
    } = useCalendar(), c = computed(() => {
      switch (t.page.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    }), u = computed(() => {
      const { page: k } = t;
      return {
        id: n.value,
        visibility: s.value,
        placement: c.value,
        modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }],
        data: { page: k },
        isInteractive: !0
      };
    }), d = computed(() => t.page.titlePosition.includes("left")), p = computed(() => t.page.titlePosition.includes("right")), f = computed(() => t.layout ? t.layout : d.value ? "tu-pn" : p.value ? "pn-tu" : "p-tu-n;"), g = computed(() => ({
      prev: f.value.includes("p") && !t.hideArrows,
      title: f.value.includes("t") && !t.hideTitle,
      next: f.value.includes("n") && !t.hideArrows
    })), C = computed(() => ({ gridTemplateColumns: f.value.split("").map((M) => {
      switch (M) {
        case "p":
          return "[prev] auto";
        case "n":
          return "[next] auto";
        case "t":
          return "[title] auto";
        case "-":
          return "1fr";
        default:
          return "";
      }
    }).join(" ") }));
    return (k, M) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["vc-header", { "is-lg": e.isLg, "is-xl": e.isXl, "is-2xl": e.is2xl }]),
      style: normalizeStyle(unref(C))
    }, [
      unref(g).prev ? (openBlock(), createElementBlock("button", {
        key: 0,
        type: "button",
        class: "vc-arrow vc-prev vc-focus",
        disabled: !unref(i),
        onClick: M[0] || (M[0] = //@ts-ignore
        (..._) => unref(a) && unref(a)(..._)),
        onKeydown: M[1] || (M[1] = withKeys(
          //@ts-ignore
          (..._) => unref(a) && unref(a)(..._),
          ["space", "enter"]
        ))
      }, [
        createVNode(_sfc_main$c, {
          name: "header-prev-button",
          disabled: !unref(i)
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$d, {
              name: "ChevronLeft",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, _hoisted_1$8)) : createCommentVNode("", !0),
      unref(g).title ? withDirectives((openBlock(), createElementBlock("button", _hoisted_2$7, [
        createVNode(_sfc_main$c, {
          name: "header-title",
          title: e.page.title
        }, {
          default: withCtx(() => [
            createElementVNode("span", null, toDisplayString(e.page.title), 1)
          ]),
          _: 1
        }, 8, ["title"])
      ])), [
        [unref(popoverDirective), unref(u)]
      ]) : createCommentVNode("", !0),
      unref(g).next ? (openBlock(), createElementBlock("button", {
        key: 2,
        type: "button",
        class: "vc-arrow vc-next vc-focus",
        disabled: !unref(o),
        onClick: M[2] || (M[2] = //@ts-ignore
        (..._) => unref(l) && unref(l)(..._)),
        onKeydown: M[3] || (M[3] = withKeys(
          //@ts-ignore
          (..._) => unref(l) && unref(l)(..._),
          ["space", "enter"]
        ))
      }, [
        createVNode(_sfc_main$c, {
          name: "header-next-button",
          disabled: !unref(o)
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$d, {
              name: "ChevronRight",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, _hoisted_3$5)) : createCommentVNode("", !0)
    ], 6));
  }
}), _sfc_main$a = defineComponent({
  directives: { popover: popoverDirective },
  components: { CalendarSlot: _sfc_main$c },
  props: {
    day: { type: Object, required: !0 }
  },
  setup(e) {
    const {
      locale: t,
      theme: n,
      attributeContext: s,
      dayPopoverId: i,
      slots: a,
      onDayClick: o,
      onDayMouseenter: l,
      onDayMouseleave: c,
      onDayFocusin: u,
      onDayFocusout: d,
      onDayKeydown: p
    } = useCalendar(), f = computed(() => e.day), g = computed(() => s.value.getCells(f.value)), C = computed(
      () => g.value.map((G) => G.data)
    ), k = computed(() => ({
      ...f.value,
      attributes: C.value,
      attributeCells: g.value
    }));
    function M({ data: G }, { popovers: H }) {
      const { key: F, customData: B, popover: z } = G;
      if (!z)
        return;
      const K = defaults_1(
        {
          key: F,
          customData: B,
          attribute: G
        },
        { ...z },
        {
          visibility: z.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !z.label
        }
      );
      H.splice(0, 0, K);
    }
    const _ = computed(() => {
      const G = {
        ...n.value.prepareRender({}),
        popovers: []
      };
      return g.value.forEach((H) => {
        n.value.render(H, G), M(H, G);
      }), G;
    }), S = computed(() => _.value.highlights), E = computed(() => !!arrayHasItems(S.value)), P = computed(() => _.value.content), $ = computed(() => _.value.dots), A = computed(() => !!arrayHasItems($.value)), I = computed(() => _.value.bars), D = computed(() => !!arrayHasItems(I.value)), R = computed(() => _.value.popovers), Y = computed(
      () => R.value.map((G) => G.attribute)
    ), q = computed(() => [
      "vc-day",
      ...f.value.classes,
      { "vc-day-box-center-center": !a["day-content"] },
      { "is-not-in-month": !e.day.inMonth }
    ]), j = computed(() => {
      let G;
      f.value.isFocusable ? G = "0" : G = "-1";
      const H = [
        "vc-day-content vc-focusable vc-focus vc-attr",
        { "vc-disabled": f.value.isDisabled },
        get_1(last_1(S.value), "contentClass"),
        get_1(last_1(P.value), "class") || ""
      ], F = {
        ...get_1(last_1(S.value), "contentStyle"),
        ...get_1(last_1(P.value), "style")
      };
      return {
        class: H,
        style: F,
        tabindex: G,
        "aria-label": f.value.ariaLabel,
        "aria-disabled": !!f.value.isDisabled,
        role: "button"
      };
    }), X = computed(() => ({
      click(G) {
        o(k.value, G);
      },
      mouseenter(G) {
        l(k.value, G);
      },
      mouseleave(G) {
        c(k.value, G);
      },
      focusin(G) {
        u(k.value, G);
      },
      focusout(G) {
        d(k.value, G);
      },
      keydown(G) {
        p(k.value, G);
      }
    })), ee = computed(() => arrayHasItems(R.value) ? defaults_1(
      {
        id: i.value,
        data: { day: f, attributes: Y.value }
      },
      ...R.value
    ) : null);
    return {
      attributes: C,
      attributeCells: g,
      bars: I,
      dayClasses: q,
      dayContentProps: j,
      dayContentEvents: X,
      dayPopover: ee,
      glyphs: _,
      dots: $,
      hasDots: A,
      hasBars: D,
      highlights: S,
      hasHighlights: E,
      locale: t,
      popovers: R
    };
  }
}), _hoisted_1$7 = {
  key: 0,
  class: "vc-highlights vc-day-layer"
}, _hoisted_2$6 = {
  key: 1,
  class: "vc-day-layer vc-day-box-center-bottom"
}, _hoisted_3$4 = { class: "vc-dots" }, _hoisted_4$2 = {
  key: 2,
  class: "vc-day-layer vc-day-box-center-bottom"
}, _hoisted_5$2 = { class: "vc-bars" };
function _sfc_render$4(e, t, n, s, i, a) {
  const o = resolveComponent("CalendarSlot"), l = resolveDirective("popover");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(e.dayClasses)
  }, [
    e.hasHighlights ? (openBlock(), createElementBlock("div", _hoisted_1$7, [
      (openBlock(!0), createElementBlock(Fragment, null, renderList(e.highlights, ({ key: c, wrapperClass: u, class: d, style: p }) => (openBlock(), createElementBlock("div", {
        key: c,
        class: normalizeClass(u)
      }, [
        createElementVNode("div", {
          class: normalizeClass(d),
          style: normalizeStyle(p)
        }, null, 6)
      ], 2))), 128))
    ])) : createCommentVNode("", !0),
    createVNode(o, {
      name: "day-content",
      day: e.day,
      attributes: e.attributes,
      "attribute-cells": e.attributeCells,
      dayProps: e.dayContentProps,
      dayEvents: e.dayContentEvents,
      locale: e.locale
    }, {
      default: withCtx(() => [
        withDirectives((openBlock(), createElementBlock("div", mergeProps(e.dayContentProps, toHandlers(e.dayContentEvents, !0)), [
          createTextVNode(toDisplayString(e.day.label), 1)
        ], 16)), [
          [l, e.dayPopover]
        ])
      ]),
      _: 1
    }, 8, ["day", "attributes", "attribute-cells", "dayProps", "dayEvents", "locale"]),
    e.hasDots ? (openBlock(), createElementBlock("div", _hoisted_2$6, [
      createElementVNode("div", _hoisted_3$4, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(e.dots, ({ key: c, class: u, style: d }) => (openBlock(), createElementBlock("span", {
          key: c,
          class: normalizeClass(u),
          style: normalizeStyle(d)
        }, null, 6))), 128))
      ])
    ])) : createCommentVNode("", !0),
    e.hasBars ? (openBlock(), createElementBlock("div", _hoisted_4$2, [
      createElementVNode("div", _hoisted_5$2, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(e.bars, ({ key: c, class: u, style: d }) => (openBlock(), createElementBlock("span", {
          key: c,
          class: normalizeClass(u),
          style: normalizeStyle(d)
        }, null, 6))), 128))
      ])
    ])) : createCommentVNode("", !0)
  ], 2);
}
const CalendarDay = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$4]]), _sfc_main$9 = {
  name: "CalendarPane",
  inheritAttrs: !1,
  components: { CalendarHeader: _sfc_main$b, CalendarDay },
  props: {
    page: { type: Object, required: !0 }
  },
  setup() {
    const { onWeeknumberClick: e } = useCalendar();
    return {
      onWeeknumberClick: e
    };
  }
}, _hoisted_1$6 = { class: "vc-weekdays" }, _hoisted_2$5 = ["onClick"];
function _sfc_render$3(e, t, n, s, i, a) {
  const o = resolveComponent("CalendarHeader"), l = resolveComponent("CalendarDay");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass([
      "vc-pane",
      `row-${n.page.row}`,
      `row-from-end-${n.page.rowFromEnd}`,
      `column-${n.page.column}`,
      `column-from-end-${n.page.columnFromEnd}`
    ]),
    ref: "pane"
  }, [
    createVNode(o, {
      page: n.page,
      "is-lg": "",
      "hide-arrows": ""
    }, null, 8, ["page"]),
    createElementVNode("div", {
      class: normalizeClass(["vc-weeks", {
        [`vc-show-weeknumbers-${n.page.weeknumberPosition}`]: n.page.weeknumberPosition
      }])
    }, [
      createElementVNode("div", _hoisted_1$6, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(n.page.weekdays, ({ weekday: c, label: u }, d) => (openBlock(), createElementBlock("div", {
          key: d,
          class: normalizeClass(`vc-weekday vc-weekday-${c}`)
        }, toDisplayString(u), 3))), 128))
      ]),
      (openBlock(!0), createElementBlock(Fragment, null, renderList(n.page.viewWeeks, (c) => (openBlock(), createElementBlock("div", {
        key: `weeknumber-${c.weeknumber}`,
        class: "vc-week"
      }, [
        n.page.weeknumberPosition ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["vc-weeknumber", `is-${n.page.weeknumberPosition}`])
        }, [
          createElementVNode("span", {
            class: normalizeClass(["vc-weeknumber-content"]),
            onClick: (u) => s.onWeeknumberClick(c, u)
          }, toDisplayString(c.weeknumberDisplay), 9, _hoisted_2$5)
        ], 2)) : createCommentVNode("", !0),
        (openBlock(!0), createElementBlock(Fragment, null, renderList(c.days, (u) => (openBlock(), createBlock(l, {
          key: u.id,
          day: u
        }, null, 8, ["day"]))), 128))
      ]))), 128))
    ], 2)
  ], 2);
}
const CalendarPane = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$3]]), _sfc_main$8 = defineComponent({
  name: "Popover",
  inheritAttrs: !1,
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  props: {
    id: { type: String, required: !0 },
    showDelay: { type: Number, default: 0 },
    hideDelay: { type: Number, default: 110 },
    boundarySelector: { type: String }
  },
  setup(e, { emit: t }) {
    let n;
    const s = ref();
    let i = null, a = null;
    const o = reactive({
      isVisible: !1,
      target: null,
      data: null,
      transition: "slide-fade",
      placement: "bottom",
      direction: "",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !0,
      visibility: "click",
      isHovered: !1,
      isFocused: !1,
      autoHide: !1,
      force: !1
    });
    function l(K) {
      K && (o.direction = K.split("-")[0]);
    }
    function c({ placement: K, options: Z }) {
      l(K || (Z == null ? void 0 : Z.placement));
    }
    const u = computed(() => ({
      placement: o.placement,
      strategy: o.positionFixed ? "fixed" : "absolute",
      boundary: "",
      modifiers: [
        {
          name: "onUpdate",
          enabled: !0,
          phase: "afterWrite",
          fn: c
        },
        ...o.modifiers || []
      ],
      onFirstUpdate: c
    })), d = computed(() => {
      const K = o.direction === "left" || o.direction === "right";
      let Z = "";
      if (o.placement) {
        const re = o.placement.split("-");
        re.length > 1 && (Z = re[1]);
      }
      return ["start", "top", "left"].includes(Z) ? K ? "top" : "left" : ["end", "bottom", "right"].includes(Z) ? K ? "bottom" : "right" : K ? "middle" : "center";
    });
    function p() {
      a && (a.destroy(), a = null);
    }
    function f() {
      nextTick(() => {
        const K = resolveEl(o.target);
        !K || !s.value || (a && a.state.elements.reference !== K && p(), a ? a.update() : a = createPopper(
          K,
          s.value,
          u.value
        ));
      });
    }
    function g(K) {
      Object.assign(o, omit(K, "force"));
    }
    function C(K, Z) {
      clearTimeout(n), K > 0 ? n = setTimeout(Z, K) : Z();
    }
    function k(K) {
      return !K || !a ? !1 : resolveEl(K) === a.state.elements.reference;
    }
    async function M(K = {}) {
      o.force || (K.force && (o.force = !0), C(K.showDelay ?? e.showDelay, () => {
        o.isVisible && (o.force = !1, t("after-show")), g({
          ...K,
          isVisible: !0
        }), f();
      }));
    }
    function _(K = {}) {
      a && (K.target && !k(K.target) || o.force || (K.force && (o.force = !0), C(K.hideDelay ?? e.hideDelay, () => {
        o.isVisible || (o.force = !1), o.isVisible = !1;
      })));
    }
    function S(K = {}) {
      K.target != null && (o.isVisible && k(K.target) ? _(K) : M(K));
    }
    function E(K) {
      if (!a)
        return;
      const Z = a.state.elements.reference;
      if (!s.value || !Z)
        return;
      const re = K.target;
      elementContains(s.value, re) || elementContains(Z, re) || _({ force: !0 });
    }
    function P(K) {
      (K.key === "Esc" || K.key === "Escape") && _();
    }
    function $({ detail: K }) {
      !K.id || K.id !== e.id || M(K);
    }
    function A({ detail: K }) {
      !K.id || K.id !== e.id || _(K);
    }
    function I({ detail: K }) {
      !K.id || K.id !== e.id || S(K);
    }
    function D() {
      on(document, "keydown", P), on(document, "click", E), on(document, "show-popover", $), on(document, "hide-popover", A), on(document, "toggle-popover", I);
    }
    function R() {
      off(document, "keydown", P), off(document, "click", E), off(document, "show-popover", $), off(document, "hide-popover", A), off(document, "toggle-popover", I);
    }
    function Y(K) {
      t("before-show", K);
    }
    function q(K) {
      o.force = !1, t("after-show", K);
    }
    function j(K) {
      t("before-hide", K);
    }
    function X(K) {
      o.force = !1, p(), t("after-hide", K);
    }
    function ee(K) {
      K.stopPropagation();
    }
    function G() {
      o.isHovered = !0, o.isInteractive && ["hover", "hover-focus"].includes(o.visibility) && M();
    }
    function H() {
      if (o.isHovered = !1, !a)
        return;
      const K = a.state.elements.reference;
      o.autoHide && !o.isFocused && (!K || K !== document.activeElement) && ["hover", "hover-focus"].includes(o.visibility) && _();
    }
    function F() {
      o.isFocused = !0, o.isInteractive && ["focus", "hover-focus"].includes(o.visibility) && M();
    }
    function B(K) {
      ["focus", "hover-focus"].includes(o.visibility) && (!K.relatedTarget || !elementContains(s.value, K.relatedTarget)) && (o.isFocused = !1, !o.isHovered && o.autoHide && _());
    }
    function z() {
      i != null && (i.disconnect(), i = null);
    }
    return watch(
      () => s.value,
      (K) => {
        z(), K && (i = new ResizeObserver(() => {
          a && a.update();
        }), i.observe(K));
      }
    ), watch(() => o.placement, l, {
      immediate: !0
    }), onMounted(() => {
      D();
    }), onUnmounted(() => {
      p(), z(), R();
    }), {
      ...toRefs(o),
      popoverRef: s,
      alignment: d,
      hide: _,
      setupPopper: f,
      beforeEnter: Y,
      afterEnter: q,
      beforeLeave: j,
      afterLeave: X,
      onClick: ee,
      onMouseOver: G,
      onMouseLeave: H,
      onFocusIn: F,
      onFocusOut: B
    };
  }
});
function _sfc_render$2(e, t, n, s, i, a) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["vc-popover-content-wrapper", { "is-interactive": e.isInteractive }]),
    ref: "popoverRef",
    onClick: t[0] || (t[0] = (...o) => e.onClick && e.onClick(...o)),
    onMouseover: t[1] || (t[1] = (...o) => e.onMouseOver && e.onMouseOver(...o)),
    onMouseleave: t[2] || (t[2] = (...o) => e.onMouseLeave && e.onMouseLeave(...o)),
    onFocusin: t[3] || (t[3] = (...o) => e.onFocusIn && e.onFocusIn(...o)),
    onFocusout: t[4] || (t[4] = (...o) => e.onFocusOut && e.onFocusOut(...o))
  }, [
    createVNode(Transition, {
      name: `vc-${e.transition}`,
      appear: "",
      onBeforeEnter: e.beforeEnter,
      onAfterEnter: e.afterEnter,
      onBeforeLeave: e.beforeLeave,
      onAfterLeave: e.afterLeave
    }, {
      default: withCtx(() => [
        e.isVisible ? (openBlock(), createElementBlock("div", mergeProps({
          key: 0,
          tabindex: "-1",
          class: `vc-popover-content direction-${e.direction}`
        }, e.$attrs), [
          renderSlot(e.$slots, "default", {
            direction: e.direction,
            alignment: e.alignment,
            data: e.data,
            hide: e.hide
          }, () => [
            createTextVNode(toDisplayString(e.data), 1)
          ]),
          createElementVNode("span", {
            class: normalizeClass([
              "vc-popover-caret",
              `direction-${e.direction}`,
              `align-${e.alignment}`
            ])
          }, null, 2)
        ], 16)) : createCommentVNode("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
  ], 34);
}
const Popover = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$2]]), propsDef$1 = {
  value: { type: Object, required: !0 }
}, emitsDef = ["input"], contextKey$1 = "__vc_calendar_nav_context__";
function createCalendarNav(e, { emit: t }) {
  const n = ref(!0), s = ref(0), i = ref(0), a = 12, o = ref(null), { locale: l, masks: c, canMove: u, getDateAddress: d } = useCalendar();
  function p() {
    setTimeout(() => {
      if (o.value == null)
        return;
      const te = o.value.querySelector(
        ".vc-nav-item:not(:disabled)"
      );
      te && te.focus();
    }, 10);
  }
  function f(te, ue) {
    t("input", { month: te, year: ue }, { position: Y.value });
  }
  function g(te) {
    s.value = te, n.value = !0, p();
  }
  function C(te) {
    const { year: ue } = d(/* @__PURE__ */ new Date()), ce = te * a, ge = ce + a, de = [];
    for (let le = ce; le < ge; le += 1) {
      let me = !1;
      for (let ve = 1; ve < 12 && (me = u({ month: ve, year: le }, { position: Y.value }), !me); ve++)
        ;
      de.push({
        year: le,
        id: le.toString(),
        label: le.toString(),
        ariaLabel: le.toString(),
        isActive: le === R.value,
        isCurrent: le === ue,
        isDisabled: !me,
        click: () => g(le)
      });
    }
    return de;
  }
  function k(te) {
    const { month: ue, year: ce } = d(/* @__PURE__ */ new Date());
    return getMonthDates().map((ge, de) => {
      const le = de + 1;
      return {
        month: le,
        year: te,
        id: `${te}.${pad(le, 2)}`,
        label: l.value.formatDate(ge, c.value.navMonths),
        ariaLabel: l.value.formatDate(ge, "MMMM YYYY"),
        isActive: le === D.value && te === R.value,
        isCurrent: le === ue && te === ce,
        isDisabled: !u(
          { month: le, year: te },
          { position: Y.value }
        ),
        click: () => f(le, te)
      };
    });
  }
  function M(te) {
    return Math.floor(te / a);
  }
  function _() {
    n.value = !n.value;
  }
  function S() {
    B.value && (n.value && P(), A());
  }
  function E() {
    Z.value && (n.value && $(), I());
  }
  function P() {
    s.value--;
  }
  function $() {
    s.value++;
  }
  function A() {
    i.value--;
  }
  function I() {
    i.value++;
  }
  const D = computed(() => {
    var te;
    return ((te = e.value) == null ? void 0 : te.month) || 0;
  }), R = computed(() => {
    var te;
    return ((te = e.value) == null ? void 0 : te.year) || 0;
  }), Y = computed(() => {
    var te;
    return ((te = e.value) == null ? void 0 : te.position) || 1;
  }), q = computed(() => k(s.value)), j = computed(() => C(i.value)), X = computed(() => head_1(j.value.map((te) => te.year))), ee = computed(() => last_1(j.value.map((te) => te.year))), G = computed(() => n.value ? s.value : `${X.value} - ${ee.value}`), H = computed(
    () => k(s.value - 1).some((te) => !te.isDisabled)
  ), F = computed(
    () => C(i.value - 1).some((te) => !te.isDisabled)
  ), B = computed(
    () => n.value ? H.value : F.value
  ), z = computed(
    () => k(s.value + 1).some((te) => !te.isDisabled)
  ), K = computed(
    () => C(i.value + 1).some((te) => !te.isDisabled)
  ), Z = computed(
    () => n.value ? z.value : K.value
  ), re = computed(
    () => n.value ? q.value : j.value
  );
  watch(
    () => R.value,
    () => {
      s.value = R.value;
    }
  ), watch(
    () => s.value,
    (te) => {
      i.value = M(te);
    }
  ), s.value = R.value, onMounted(() => p());
  const ae = {
    navContainer: o,
    title: G,
    monthMode: n,
    currentMonth: D,
    currentYear: R,
    activeItems: re,
    prevItemsEnabled: B,
    nextItemsEnabled: Z,
    toggleMode: _,
    movePrev: S,
    moveNext: E,
    movePrevYear: P,
    moveNextYear: $,
    movePrevYearGroup: A,
    moveNextYearGroup: I
  };
  return provide(contextKey$1, ae), ae;
}
const _hoisted_1$5 = { class: "vc-nav-header" }, _hoisted_2$4 = ["disabled"], _hoisted_3$3 = ["disabled"], _hoisted_4$1 = { class: "vc-nav-items" }, _hoisted_5$1 = ["data-id", "aria-label", "disabled", "onClick", "onKeydown"], _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "CalendarNav",
  props: propsDef$1,
  emits: emitsDef,
  setup(e, { emit: t }) {
    const n = e, {
      navContainer: s,
      title: i,
      prevItemsEnabled: a,
      nextItemsEnabled: o,
      activeItems: l,
      toggleMode: c,
      movePrev: u,
      moveNext: d
    } = createCalendarNav(n, { emit: t });
    return (p, f) => (openBlock(), createElementBlock("div", {
      class: "vc-nav-container",
      ref_key: "navContainer",
      ref: s
    }, [
      createElementVNode("div", _hoisted_1$5, [
        createElementVNode("button", {
          type: "button",
          class: "vc-nav-arrow is-left vc-focus",
          disabled: !unref(a),
          onClick: f[0] || (f[0] = //@ts-ignore
          (...g) => unref(u) && unref(u)(...g)),
          onKeydown: f[1] || (f[1] = (g) => unref(onSpaceOrEnter)(g, unref(u)))
        }, [
          createVNode(_sfc_main$c, {
            name: "nav-prev-button",
            move: unref(u),
            disabled: !unref(a)
          }, {
            default: withCtx(() => [
              createVNode(_sfc_main$d, {
                name: "ChevronLeft",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["move", "disabled"])
        ], 40, _hoisted_2$4),
        createElementVNode("button", {
          type: "button",
          class: "vc-nav-title vc-focus",
          onClick: f[2] || (f[2] = //@ts-ignore
          (...g) => unref(c) && unref(c)(...g)),
          onKeydown: f[3] || (f[3] = (g) => unref(onSpaceOrEnter)(g, unref(c)))
        }, toDisplayString(unref(i)), 33),
        createElementVNode("button", {
          type: "button",
          class: "vc-nav-arrow is-right vc-focus",
          disabled: !unref(o),
          onClick: f[4] || (f[4] = //@ts-ignore
          (...g) => unref(d) && unref(d)(...g)),
          onKeydown: f[5] || (f[5] = (g) => unref(onSpaceOrEnter)(g, unref(d)))
        }, [
          createVNode(_sfc_main$c, {
            name: "nav-next-button",
            move: unref(d),
            disabled: !unref(o)
          }, {
            default: withCtx(() => [
              createVNode(_sfc_main$d, {
                name: "ChevronRight",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["move", "disabled"])
        ], 40, _hoisted_3$3)
      ]),
      createElementVNode("div", _hoisted_4$1, [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(unref(l), (g) => (openBlock(), createElementBlock("button", {
          key: g.label,
          type: "button",
          "data-id": g.id,
          "aria-label": g.ariaLabel,
          class: normalizeClass(["vc-nav-item vc-focus", [
            g.isActive ? "is-active" : g.isCurrent ? "is-current" : ""
          ]]),
          disabled: g.isDisabled,
          onClick: g.click,
          onKeydown: (C) => unref(onSpaceOrEnter)(C, g.click)
        }, toDisplayString(g.label), 43, _hoisted_5$1))), 128))
      ])
    ], 512));
  }
}), _sfc_main$6 = {
  __name: "CalendarNavPopover",
  setup(e) {
    const { navPopoverId: t, color: n, displayMode: s, navPopoverRef: i, move: a } = useCalendar();
    return (o, l) => (openBlock(), createBlock(Popover, {
      id: unref(t),
      class: normalizeClass(["vc-nav-popover-container", `vc-${unref(n)}`, `vc-${unref(s)}`]),
      ref_key: "navPopoverRef",
      ref: i
    }, {
      default: withCtx(({ data: c }) => [
        createVNode(_sfc_main$7, {
          value: c.page,
          onInput: unref(a)
        }, null, 8, ["value", "onInput"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}, _sfc_main$5 = defineComponent({
  name: "PopoverRow",
  props: {
    attribute: { type: Object, required: !0 }
  },
  setup(e) {
    return {
      indicator: computed(() => {
        const { content: n, highlight: s, dot: i, bar: a, popover: o } = e.attribute;
        return o && o.hideIndicator ? null : n ? {
          class: `vc-bar vc-day-popover-row-bar vc-attr vc-${n.base.color}`
        } : s ? {
          class: `vc-highlight-bg-solid vc-day-popover-row-highlight vc-attr vc-${s.base.color}`
        } : i ? {
          class: `vc-dot vc-attr vc-${i.base.color}`
        } : a ? {
          class: `vc-bar vc-day-popover-row-bar vc-attr vc-${a.base.color}`
        } : null;
      })
    };
  }
}), _hoisted_1$4 = { class: "vc-day-popover-row" }, _hoisted_2$3 = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, _hoisted_3$2 = { class: "vc-day-popover-row-label" };
function _sfc_render$1(e, t, n, s, i, a) {
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    e.indicator ? (openBlock(), createElementBlock("div", _hoisted_2$3, [
      createElementVNode("span", {
        class: normalizeClass(e.indicator.class)
      }, null, 2)
    ])) : createCommentVNode("", !0),
    createElementVNode("div", _hoisted_3$2, [
      renderSlot(e.$slots, "default", {}, () => [
        createTextVNode(toDisplayString(e.attribute.popover ? e.attribute.popover.label : "No content provided"), 1)
      ])
    ])
  ]);
}
const PopoverRow = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$1]]), _hoisted_1$3 = { class: "vc-day-popover-container" }, _hoisted_2$2 = {
  key: 0,
  class: "vc-day-popover-header"
}, _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "CalendarDayPopover",
  setup(e) {
    const { dayPopoverId: t, displayMode: n, color: s, masks: i, locale: a } = useCalendar();
    function o(c, u) {
      return a.value.formatDate(c, u);
    }
    function l(c) {
      return a.value.formatDate(c.date, i.value.dayPopover);
    }
    return (c, u) => (openBlock(), createBlock(Popover, {
      id: unref(t),
      class: normalizeClass([`vc-${unref(s)}`, `vc-${unref(n)}`])
    }, {
      default: withCtx(({ data: { day: d, attributes: p }, hide: f }) => [
        renderSlot(c.$slots, "default", {
          day: d,
          dayTitle: l(d),
          attributes: p,
          format: o,
          masks: unref(i),
          hide: f
        }, () => [
          createElementVNode("div", _hoisted_1$3, [
            unref(i).dayPopover ? (openBlock(), createElementBlock("div", _hoisted_2$2, toDisplayString(l(d)), 1)) : createCommentVNode("", !0),
            (openBlock(!0), createElementBlock(Fragment, null, renderList(p, (g) => (openBlock(), createBlock(PopoverRow, {
              key: g.key,
              attribute: g
            }, null, 8, ["attribute"]))), 128))
          ])
        ])
      ]),
      _: 3
    }, 8, ["id", "class"]));
  }
}), _sfc_main$3 = defineComponent({
  name: "Calendar",
  components: {
    CalendarHeader: _sfc_main$b,
    CalendarPane,
    CalendarNavPopover: _sfc_main$6,
    CalendarDayPopover: _sfc_main$4
  },
  emits: emitsDef$1,
  props: propsDef$2,
  setup(e, { emit: t, slots: n }) {
    return createCalendar(e, { emit: t, slots: n });
  }
}), _hoisted_1$2 = { class: "vc-pane-header-wrapper" };
function _sfc_render(e, t, n, s, i, a) {
  const o = resolveComponent("CalendarHeader"), l = resolveComponent("CalendarPane"), c = resolveComponent("CalendarDayPopover"), u = resolveComponent("CalendarNavPopover");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", mergeProps({ "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, e.$attrs, {
      class: [
        "vc-container",
        `vc-${e.view}`,
        `vc-${e.color}`,
        `vc-${e.displayMode}`,
        {
          "vc-expanded": e.expanded,
          "vc-bordered": !e.borderless,
          "vc-transparent": e.transparent
        }
      ],
      onMouseup: t[0] || (t[0] = withModifiers(() => {
      }, ["prevent"])),
      ref: "containerRef"
    }), [
      createElementVNode("div", {
        class: normalizeClass(["vc-pane-container", { "in-transition": e.inTransition }])
      }, [
        createElementVNode("div", _hoisted_1$2, [
          e.firstPage ? (openBlock(), createBlock(o, {
            key: 0,
            page: e.firstPage,
            "is-lg": "",
            "hide-title": ""
          }, null, 8, ["page"])) : createCommentVNode("", !0)
        ]),
        createVNode(Transition, {
          name: `vc-${e.transitionName}`,
          onBeforeEnter: e.onTransitionBeforeEnter,
          onAfterEnter: e.onTransitionAfterEnter
        }, {
          default: withCtx(() => [
            (openBlock(), createElementBlock("div", {
              key: e.pages[0].id,
              class: "vc-pane-layout",
              style: normalizeStyle({
                gridTemplateColumns: `repeat(${e.columns}, 1fr)`
              })
            }, [
              (openBlock(!0), createElementBlock(Fragment, null, renderList(e.pages, (d) => (openBlock(), createBlock(l, {
                key: d.id,
                page: d
              }, null, 8, ["page"]))), 128))
            ], 4))
          ]),
          _: 1
        }, 8, ["name", "onBeforeEnter", "onAfterEnter"]),
        renderSlot(e.$slots, "footer")
      ], 2)
    ], 16),
    createVNode(c, null, {
      default: withCtx((d) => [
        renderSlot(e.$slots, "day-popover", normalizeProps(guardReactiveProps(d)))
      ]),
      _: 3
    }),
    createVNode(u)
  ], 64);
}
const Calendar = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render]]), _hoisted_1$1 = { class: "vc-base-select" }, _hoisted_2$1 = ["value"], _hoisted_3$1 = ["value", "disabled"], __default__ = {
  inheritAttrs: !1
}, _sfc_main$2$1 = /* @__PURE__ */ Object.assign(__default__, {
  __name: "BaseSelect",
  props: {
    options: Array,
    modelValue: null,
    alignRight: Boolean,
    alignLeft: Boolean,
    showIcon: Boolean,
    small: Boolean
  },
  emits: ["update:modelValue"],
  setup(e) {
    return (t, n) => (openBlock(), createElementBlock("div", _hoisted_1$1, [
      e.showIcon ? (openBlock(), createBlock(_sfc_main$d, {
        key: 0,
        name: "ChevronDown",
        size: e.small ? "16" : "18"
      }, null, 8, ["size"])) : createCommentVNode("", !0),
      createElementVNode("select", mergeProps(t.$attrs, {
        value: e.modelValue,
        class: ["vc-focus", {
          "vc-has-icon": e.showIcon,
          "vc-align-right": e.alignRight,
          "vc-align-left": e.alignLeft,
          "vc-small": e.small
        }],
        onChange: n[0] || (n[0] = (s) => t.$emit("update:modelValue", s.target.value))
      }), [
        (openBlock(!0), createElementBlock(Fragment, null, renderList(e.options, (s) => (openBlock(), createElementBlock("option", {
          key: s.value,
          value: s.value,
          disabled: s.disabled
        }, toDisplayString(s.label), 9, _hoisted_3$1))), 128))
      ], 16, _hoisted_2$1)
    ]));
  }
}), contextKey = "__vc_date_picker_context__", propsDef = {
  ...propsDef$3,
  mode: { type: String, default: "date" },
  modelValue: {
    type: [Number, String, Date, Object]
  },
  modelModifiers: {
    type: Object,
    default: () => ({})
  },
  rules: [String, Object],
  is24hr: Boolean,
  hideTimeHeader: Boolean,
  timeAccuracy: { type: Number, default: 2 },
  isRequired: Boolean,
  isRange: Boolean,
  updateOnInput: {
    type: Boolean,
    default: () => getDefault("datePicker.updateOnInput")
  },
  inputDebounce: {
    type: Number,
    default: () => getDefault("datePicker.inputDebounce")
  },
  popover: {
    type: [Boolean, Object],
    default: !0
  },
  dragAttribute: Object,
  selectAttribute: Object,
  attributes: [Object, Array]
}, emits = [
  "update:modelValue",
  "drag",
  "dayclick",
  "daykeydown",
  "popover-will-show",
  "popover-did-show",
  "popover-will-hide",
  "popover-did-hide"
];
function createDatePicker(e, t) {
  const n = createBase(e), { locale: s, masks: i, disabledAttribute: a } = n, { emit: o } = t, l = ref(!1), c = ref(createGuid()), u = ref(null), d = ref(null), p = ref(["", ""]), f = ref(null), g = ref(null);
  let C, k, M = !0;
  const _ = computed(() => e.isRange || e.modelModifiers.range === !0), S = computed(
    () => _.value && u.value != null ? u.value.start : null
  ), E = computed(
    () => _.value && u.value != null ? u.value.end : null
  ), P = computed(() => e.mode.toLowerCase() === "date"), $ = computed(
    () => e.mode.toLowerCase() === "datetime"
  ), A = computed(() => e.mode.toLowerCase() === "time"), I = computed(() => !!d.value), D = computed(() => {
    let Q = "date";
    e.modelModifiers.number && (Q = "number"), e.modelModifiers.string && (Q = "string");
    const se = i.value.modelValue || "iso";
    return ae({ type: Q, mask: se });
  }), R = computed(
    () => Ie(d.value ?? u.value)
  ), Y = computed(() => A.value ? e.is24hr ? i.value.inputTime24hr : i.value.inputTime : $.value ? e.is24hr ? i.value.inputDateTime24hr : i.value.inputDateTime : i.value.input), q = computed(() => /[Hh]/g.test(Y.value)), j = computed(
    () => /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(Y.value)
  ), X = computed(() => {
    if (q.value && j.value)
      return "dateTime";
    if (j.value)
      return "date";
    if (q.value)
      return "time";
  }), ee = computed(() => {
    var Q;
    const se = ((Q = f.value) == null ? void 0 : Q.$el.previousElementSibling) ?? void 0;
    return defaultsDeep_1({}, e.popover, getDefault("datePicker.popover"), {
      target: se
    });
  }), G = computed(
    () => getPopoverEventHandlers({
      ...ee.value,
      id: c.value
    })
  ), H = computed(() => _.value ? {
    start: p.value[0],
    end: p.value[1]
  } : p.value[0]), F = computed(() => {
    const Q = ["start", "end"].map((se) => ({
      input: Ae(se),
      change: Se(se),
      keyup: Ee,
      ...e.popover && G.value
    }));
    return _.value ? {
      start: Q[0],
      end: Q[1]
    } : Q[0];
  }), B = computed(() => {
    if (!ce(u.value))
      return null;
    const Q = {
      key: "select-drag",
      ...e.selectAttribute,
      dates: u.value,
      pinPage: !0
    }, { dot: se, bar: fe, highlight: _e, content: Te } = Q;
    return !se && !fe && !_e && !Te && (Q.highlight = !0), Q;
  }), z = computed(() => {
    if (!_.value || !ce(d.value))
      return null;
    const Q = {
      key: "select-drag",
      ...e.dragAttribute,
      dates: d.value
    }, { dot: se, bar: fe, highlight: _e, content: Te } = Q;
    return !se && !fe && !_e && !Te && (Q.highlight = {
      startEnd: {
        fillMode: "outline"
      }
    }), Q;
  }), K = computed(() => {
    const Q = isArray$d(e.attributes) ? [...e.attributes] : [];
    return z.value ? Q.unshift(z.value) : B.value && Q.unshift(B.value), Q;
  }), Z = computed(() => ae(
    e.rules === "auto" ? re() : e.rules ?? {}
  ));
  function re() {
    const Q = {
      ms: [0, 999],
      sec: [0, 59],
      min: [0, 59],
      hr: [0, 23]
    }, se = P.value ? 0 : e.timeAccuracy;
    return [0, 1].map((fe) => {
      switch (se) {
        case 0:
          return {
            hours: Q.hr[fe],
            minutes: Q.min[fe],
            seconds: Q.sec[fe],
            milliseconds: Q.ms[fe]
          };
        case 1:
          return {
            minutes: Q.min[fe],
            seconds: Q.sec[fe],
            milliseconds: Q.ms[fe]
          };
        case 3:
          return { milliseconds: Q.ms[fe] };
        case 4:
          return {};
        default:
          return { seconds: Q.sec[fe], milliseconds: Q.ms[fe] };
      }
    });
  }
  function ae(Q) {
    return isArray$d(Q) ? Q.length === 1 ? [Q[0], Q[0]] : Q : [Q, Q];
  }
  function te(Q) {
    return ae(Q).map(
      (se, fe) => ({
        ...se,
        rules: Z.value[fe]
      })
    );
  }
  function ue(Q) {
    return isNumber_1(Q) ? !isNaN(Q) : isDate$2(Q) ? !isNaN(Q.getTime()) : isString_1(Q) ? Q !== "" : Q != null;
  }
  function ce(Q) {
    return _.value ? isObject$b(Q) && ue(Q.start) && ue(Q.end) : ue(Q);
  }
  function ge(Q, se) {
    const fe = isDate$2(Q), _e = isDate$2(se);
    return !fe && !_e ? !0 : fe !== _e ? !1 : Q.getTime() === se.getTime();
  }
  function de(Q, se) {
    if (_.value) {
      const fe = ce(Q), _e = ce(se);
      return !fe && !_e ? !0 : fe !== _e ? !1 : ge(Q.start, se.start) && ge(Q.end, se.end);
    }
    return ge(Q, se);
  }
  function le(Q) {
    return !ce(Q) || !a.value ? !1 : a.value.intersectsRange(s.value.range(Q));
  }
  function me(Q, se, fe, _e) {
    if (!ce(Q))
      return null;
    if (_.value) {
      const Te = s.value.toDate(Q.start, {
        ...se[0],
        fillDate: S.value ?? void 0,
        patch: fe
      }), Ve = s.value.toDate(Q.end, {
        ...se[1],
        fillDate: E.value ?? void 0,
        patch: fe
      });
      return je({ start: Te, end: Ve }, _e);
    }
    return s.value.toDateOrNull(Q, {
      ...se[0],
      fillDate: u.value,
      patch: fe
    });
  }
  function ve(Q, se) {
    return _.value ? ce(Q) ? {
      start: s.value.fromDate(Q.start, se[0]),
      end: s.value.fromDate(Q.end, se[1])
    } : null : s.value.fromDate(Q, se[0]);
  }
  function be(Q, se = {}) {
    return clearTimeout(C), new Promise((fe) => {
      const { debounce: _e = 0, ...Te } = se;
      _e > 0 ? C = window.setTimeout(() => {
        fe(oe(Q, Te));
      }, _e) : fe(oe(Q, Te));
    });
  }
  function oe(Q, {
    config: se = D.value,
    patch: fe = "dateTime",
    clearIfEqual: _e = !1,
    formatInput: Te = !0,
    hidePopover: Ve = !1,
    dragging: Ne = I.value,
    targetPriority: ze,
    moveToValue: We = !1
  } = {}) {
    const Ue = te(se);
    let Le = me(
      Q,
      Ue,
      fe,
      ze
    );
    if (le(Le)) {
      if (Ne)
        return null;
      Le = u.value, Ve = !1;
    } else
      Le == null && e.isRequired ? Le = u.value : (
        // Clear value if same value was passed
        Le != null && de(u.value, Le) && _e && (Le = null)
      );
    const Ye = Ne ? d : u, Je = !de(Ye.value, Le);
    Ye.value = Le, Ne || (d.value = null);
    const et = ve(
      Le,
      D.value
    );
    return Je && (M = !1, o(Ne ? "drag" : "update:modelValue", et), nextTick(() => M = !0)), Ve && !Ne && He(), Te && ye(), We && nextTick(() => ne(ze ?? "start")), et;
  }
  function ye() {
    nextTick(() => {
      const Q = te({
        type: "string",
        mask: Y.value
      }), se = ve(
        d.value || u.value,
        Q
      );
      _.value ? p.value = [se && se.start, se && se.end] : p.value = [se, ""];
    });
  }
  function we(Q, se, fe) {
    p.value.splice(se === "start" ? 0 : 1, 1, Q);
    const _e = _.value ? {
      start: p.value[0],
      end: p.value[1] || p.value[0]
    } : Q, Te = {
      type: "string",
      mask: Y.value
    };
    be(_e, {
      ...fe,
      config: Te,
      patch: X.value,
      targetPriority: se,
      moveToValue: !0
    });
  }
  function Ae(Q) {
    return (se) => {
      e.updateOnInput && we(se.currentTarget.value, Q, {
        formatInput: !1,
        hidePopover: !1,
        debounce: e.inputDebounce
      });
    };
  }
  function Se(Q) {
    return (se) => {
      we(se.currentTarget.value, Q, {
        formatInput: !0,
        hidePopover: !1
      });
    };
  }
  function Ee(Q) {
    Q.key === "Escape" && be(u.value, {
      formatInput: !0,
      hidePopover: !0
    });
  }
  function Ie(Q) {
    return _.value ? [
      Q && Q.start ? s.value.getDateParts(Q.start) : null,
      Q && Q.end ? s.value.getDateParts(Q.end) : null
    ] : [Q ? s.value.getDateParts(Q) : null];
  }
  function xe() {
    d.value = null, ye();
  }
  function Ce(Q) {
    o("popover-will-show", Q);
  }
  function $e(Q) {
    o("popover-did-show", Q);
  }
  function De(Q) {
    xe(), o("popover-will-hide", Q);
  }
  function ke(Q) {
    o("popover-did-hide", Q);
  }
  function Me(Q) {
    const se = {
      patch: "date",
      formatInput: !0,
      hidePopover: !0
    };
    if (_.value) {
      const fe = !I.value;
      fe ? k = { start: Q.startDate, end: Q.endDate } : k != null && (k.end = Q.date), be(k, {
        ...se,
        dragging: fe
      });
    } else
      be(Q.date, {
        ...se,
        clearIfEqual: !e.isRequired
      });
  }
  function Pe(Q, se) {
    Me(Q), o("dayclick", Q, se);
  }
  function Oe(Q, se) {
    switch (se.key) {
      case " ":
      case "Enter": {
        Me(Q), se.preventDefault();
        break;
      }
      case "Escape":
        He();
    }
    o("daykeydown", Q, se);
  }
  function Be(Q, se) {
    !I.value || k == null || (k.end = Q.date, be(je(k), {
      patch: "date",
      formatInput: !0
    }));
  }
  function Fe(Q = {}) {
    showPopover({
      ...ee.value,
      ...Q,
      isInteractive: !0,
      id: c.value
    });
  }
  function He(Q = {}) {
    hidePopover({
      hideDelay: 10,
      force: !0,
      ...ee.value,
      ...Q,
      id: c.value
    });
  }
  function Ze(Q) {
    togglePopover({
      ...ee.value,
      ...Q,
      isInteractive: !0,
      id: c.value
    });
  }
  function je(Q, se) {
    const { start: fe, end: _e } = Q;
    if (fe > _e)
      switch (se) {
        case "start":
          return { start: fe, end: fe };
        case "end":
          return { start: _e, end: _e };
        default:
          return { start: _e, end: fe };
      }
    return { start: fe, end: _e };
  }
  function Xe(Q) {
    if (ce(u.value)) {
      const se = _.value ? Q ? S.value : E.value : u.value;
      return getPageAddressForDate(se, "monthly", s.value);
    }
    return null;
  }
  async function Qe(Q, se = {}) {
    return g.value == null ? !1 : g.value.move(Q, se);
  }
  async function Ge(Q, se = {}) {
    return g.value == null ? !1 : g.value.moveBy(Q, se);
  }
  async function ne(Q, se = {}) {
    if (g.value == null)
      return !1;
    const { firstPage: fe, lastPage: _e, move: Te } = g.value, Ve = Q !== "end", Ne = Xe(Ve), ze = Ve ? 1 : -1;
    return !Ne || pageIsBetweenPages(Ne, fe, _e) ? !1 : Te(Ne, {
      position: ze,
      ...se
    });
  }
  watch(
    () => e.isRange,
    (Q) => {
      Q && console.warn(
        "The `is-range` prop will be deprecated in future releases. Please use the `range` modifier."
      );
    },
    { immediate: !0 }
  ), watch(
    () => Y.value,
    () => ye()
  ), watch(
    () => e.modelValue,
    (Q) => {
      M && oe(Q, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), watch(
    () => Z.value,
    () => {
      isObject$b(e.rules) && oe(e.modelValue, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), watch(
    () => e.timezone,
    () => {
      oe(u.value, { formatInput: !0 });
    }
  );
  const ie = ae(D.value);
  u.value = me(e.modelValue, ie, "dateTime"), onMounted(() => {
    oe(e.modelValue, {
      formatInput: !0,
      hidePopover: !1
    });
  }), nextTick(() => l.value = !0);
  const he = {
    ...n,
    showCalendar: l,
    datePickerPopoverId: c,
    popoverRef: f,
    popoverEvents: G,
    calendarRef: g,
    isRange: _,
    isTimeMode: A,
    isDateTimeMode: $,
    is24hr: toRef(e, "is24hr"),
    hideTimeHeader: toRef(e, "hideTimeHeader"),
    timeAccuracy: toRef(e, "timeAccuracy"),
    isDragging: I,
    inputValue: H,
    inputEvents: F,
    dateParts: R,
    attributes: K,
    rules: Z,
    move: Qe,
    moveBy: Ge,
    moveToValue: ne,
    updateValue: be,
    showPopover: Fe,
    hidePopover: He,
    togglePopover: Ze,
    onDayClick: Pe,
    onDayKeydown: Oe,
    onDayMouseEnter: Be,
    onPopoverBeforeShow: Ce,
    onPopoverAfterShow: $e,
    onPopoverBeforeHide: De,
    onPopoverAfterHide: ke
  };
  return provide(contextKey, he), he;
}
function useDatePicker() {
  const e = inject(contextKey);
  if (e)
    return e;
  throw new Error(
    "DatePicker context missing. Please verify this component is nested within a valid context provider."
  );
}
const _amOptions = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], _pmOptions = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
];
function createTimePicker(e) {
  const t = useDatePicker(), {
    locale: n,
    isRange: s,
    isTimeMode: i,
    dateParts: a,
    rules: o,
    is24hr: l,
    hideTimeHeader: c,
    timeAccuracy: u,
    updateValue: d
  } = t;
  function p(j) {
    j = Object.assign(g.value, j);
    let X = null;
    if (s.value) {
      const ee = f.value ? j : a.value[0], G = f.value ? a.value[1] : j;
      X = { start: ee, end: G };
    } else
      X = j;
    d(X, {
      patch: "time",
      targetPriority: f.value ? "start" : "end",
      moveToValue: !0
    });
  }
  const f = computed(() => e.position === 0), g = computed(
    () => a.value[e.position] || { isValid: !1 }
  ), C = computed(() => isDateParts(g.value)), k = computed(() => !!g.value.isValid), M = computed(() => !c.value && k.value), _ = computed(() => {
    if (!C.value)
      return null;
    let j = n.value.toDate(g.value);
    return g.value.hours === 24 && (j = new Date(j.getTime() - 1)), j;
  }), S = computed({
    get() {
      return g.value.hours;
    },
    set(j) {
      p({ hours: j });
    }
  }), E = computed({
    get() {
      return g.value.minutes;
    },
    set(j) {
      p({ minutes: j });
    }
  }), P = computed({
    get() {
      return g.value.seconds;
    },
    set(j) {
      p({ seconds: j });
    }
  }), $ = computed({
    get() {
      return g.value.milliseconds;
    },
    set(j) {
      p({ milliseconds: j });
    }
  }), A = computed({
    get() {
      return g.value.hours < 12;
    },
    set(j) {
      j = String(j).toLowerCase() == "true";
      let X = S.value;
      j && X >= 12 ? X -= 12 : !j && X < 12 && (X += 12), p({ hours: X });
    }
  }), I = computed(
    () => getDatePartsOptions(g.value, o.value[e.position])
  ), D = computed(() => _amOptions.filter(
    (j) => I.value.hours.some((X) => X.value === j.value)
  )), R = computed(() => _pmOptions.filter(
    (j) => I.value.hours.some((X) => X.value === j.value)
  )), Y = computed(() => l.value ? I.value.hours : A.value ? D.value : R.value), q = computed(() => {
    const j = [];
    return arrayHasItems(D.value) && j.push({ value: !0, label: "AM" }), arrayHasItems(R.value) && j.push({ value: !1, label: "PM" }), j;
  });
  return {
    ...t,
    showHeader: M,
    timeAccuracy: u,
    parts: g,
    isValid: k,
    date: _,
    hours: S,
    minutes: E,
    seconds: P,
    milliseconds: $,
    options: I,
    hourOptions: Y,
    isAM: A,
    isAMOptions: q,
    is24hr: l
  };
}
const _hoisted_1 = {
  key: 0,
  class: "vc-time-header"
}, _hoisted_2 = { class: "vc-time-weekday" }, _hoisted_3 = { class: "vc-time-month" }, _hoisted_4 = { class: "vc-time-day" }, _hoisted_5 = { class: "vc-time-year" }, _hoisted_6 = { class: "vc-time-select-group" }, _hoisted_7 = /* @__PURE__ */ createElementVNode("span", { class: "vc-time-colon" }, ":", -1), _hoisted_8 = /* @__PURE__ */ createElementVNode("span", { class: "vc-time-colon" }, ":", -1), _hoisted_9 = /* @__PURE__ */ createElementVNode("span", { class: "vc-time-decimal" }, ".", -1), _sfc_main$1$1 = /* @__PURE__ */ defineComponent({
  __name: "TimePicker",
  props: {
    position: null
  },
  setup(e, { expose: t }) {
    const s = createTimePicker(e);
    t(s);
    const {
      locale: i,
      isValid: a,
      date: o,
      hours: l,
      minutes: c,
      seconds: u,
      milliseconds: d,
      options: p,
      hourOptions: f,
      isTimeMode: g,
      isAM: C,
      isAMOptions: k,
      is24hr: M,
      showHeader: _,
      timeAccuracy: S
    } = s;
    return (E, P) => (openBlock(), createElementBlock("div", {
      class: normalizeClass(["vc-time-picker", [{ "vc-invalid": !unref(a), "vc-attached": !unref(g) }]])
    }, [
      renderSlot(E.$slots, "time-header", {}, () => [
        unref(_) && unref(o) ? (openBlock(), createElementBlock("div", _hoisted_1, [
          createElementVNode("span", _hoisted_2, toDisplayString(unref(i).formatDate(unref(o), "WWW")), 1),
          createElementVNode("span", _hoisted_3, toDisplayString(unref(i).formatDate(unref(o), "MMM")), 1),
          createElementVNode("span", _hoisted_4, toDisplayString(unref(i).formatDate(unref(o), "D")), 1),
          createElementVNode("span", _hoisted_5, toDisplayString(unref(i).formatDate(unref(o), "YYYY")), 1)
        ])) : createCommentVNode("", !0)
      ]),
      createElementVNode("div", _hoisted_6, [
        createVNode(_sfc_main$d, {
          name: "Clock",
          size: "17"
        }),
        createVNode(_sfc_main$2$1, {
          modelValue: unref(l),
          "onUpdate:modelValue": P[0] || (P[0] = ($) => isRef(l) ? l.value = $ : null),
          modelModifiers: { number: !0 },
          options: unref(f),
          "align-right": ""
        }, null, 8, ["modelValue", "options"]),
        unref(S) > 1 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          _hoisted_7,
          createVNode(_sfc_main$2$1, {
            modelValue: unref(c),
            "onUpdate:modelValue": P[1] || (P[1] = ($) => isRef(c) ? c.value = $ : null),
            modelModifiers: { number: !0 },
            options: unref(p).minutes,
            "align-left": unref(S) === 2
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : createCommentVNode("", !0),
        unref(S) > 2 ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          _hoisted_8,
          createVNode(_sfc_main$2$1, {
            modelValue: unref(u),
            "onUpdate:modelValue": P[2] || (P[2] = ($) => isRef(u) ? u.value = $ : null),
            modelModifiers: { number: !0 },
            options: unref(p).seconds,
            "align-left": unref(S) === 3
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : createCommentVNode("", !0),
        unref(S) > 3 ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
          _hoisted_9,
          createVNode(_sfc_main$2$1, {
            modelValue: unref(d),
            "onUpdate:modelValue": P[3] || (P[3] = ($) => isRef(d) ? d.value = $ : null),
            modelModifiers: { number: !0 },
            options: unref(p).milliseconds,
            "align-left": ""
          }, null, 8, ["modelValue", "options"])
        ], 64)) : createCommentVNode("", !0),
        unref(M) ? createCommentVNode("", !0) : (openBlock(), createBlock(_sfc_main$2$1, {
          key: 3,
          modelValue: unref(C),
          "onUpdate:modelValue": P[4] || (P[4] = ($) => isRef(C) ? C.value = $ : null),
          options: unref(k)
        }, null, 8, ["modelValue", "options"]))
      ])
    ], 2));
  }
}), _sfc_main$i = defineComponent({
  name: "DatePicker",
  inheritAttrs: !1,
  emits,
  props: propsDef,
  setup(e, t) {
    const n = createDatePicker(e, t), { slots: s, attrs: i } = t, {
      isTimeMode: a,
      isRange: o,
      isDateTimeMode: l,
      color: c,
      displayMode: u,
      dateParts: d,
      datePickerPopoverId: p,
      attributes: f,
      calendarRef: g,
      popoverRef: C,
      showCalendar: k,
      onDayClick: M,
      onDayMouseEnter: _,
      onDayKeydown: S,
      onPopoverBeforeShow: E,
      onPopoverAfterShow: P,
      onPopoverBeforeHide: $,
      onPopoverAfterHide: A
    } = n;
    t.expose(n);
    const I = reactive(omit(n, "calendarRef", "popoverRef")), D = () => (o.value ? [0, 1] : [0]).map((j) => h(_sfc_main$1$1, { position: j })), R = () => {
      if (!d.value)
        return null;
      const q = l.value ? { ...s, footer: D } : s;
      return h(
        Calendar,
        {
          ...i,
          attributes: f.value,
          ref: g,
          onDayclick: M,
          onDaymouseenter: _,
          onDaykeydown: S
        },
        q
      );
    }, Y = () => {
      if (a.value)
        return h(
          "div",
          {
            class: `vc-container vc-bordered vc-${c.value} vc-${u.value}`
          },
          [D()]
        );
      if (k.value)
        return R();
    };
    return s.default ? () => [
      // Popover trigger
      s.default(I),
      // Popover content
      h(
        Popover,
        {
          id: p.value,
          placement: "bottom-start",
          class: `vc-date-picker-content vc-${c.value} vc-${u.value}`,
          ref: C,
          "onBefore-show": E,
          "onAfter-show": P,
          "onBefore-hide": $,
          "onAfter-hide": A
        },
        {
          default: Y
        }
      )
    ] : Y;
  }
}), style = "", DATA_TEST_ID$1 = {
  CONTAINER: "date-picker_container",
  INPUT: "date-picker_input",
  CLEAR_BUTTON: "date-picker_clear-button",
  DESCRIPTION: "date-picker_description",
  MESSAGE: "date-picker_message",
  ICON_LEFT: "date-picker_icon-left",
  ICON_RIGHT: "date-picker_icon-right"
}, _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "DatePicker",
  props: {
    id: null,
    modelValue: { default: void 0 },
    value: { default: void 0 },
    label: { default: void 0 },
    tone: { default: "primary" },
    placeholder: { default: void 0 },
    borderRadius: { default: "lg" },
    border: { default: "solid" },
    description: { default: void 0 },
    align: { default: "left" },
    message: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    joined: { default: void 0 },
    mask: { default: void 0 },
    autoFocus: { type: Boolean, default: !1 },
    showClear: { type: Boolean, default: !0 },
    firstDayOfWeek: { default: 2 },
    highlightToday: { type: Boolean, default: !0 },
    isRequired: { type: Boolean, default: !1 },
    maxDate: { default: void 0 },
    minDate: { default: void 0 }
  },
  emits: ["update:modelValue", "onChange"],
  setup(e, { emit: t }) {
    const n = e, s = ref(null), i = ref(), a = ref(!1), o = ref(n.modelValue || n.value), l = ref([
      {
        key: "today",
        highlight: {
          fillMode: "outline"
        },
        dates: [new Date()]
      }
    ]);
    watch(
      () => n.modelValue,
      (S) => {
        o.value = S;
      }
    ), watch(
      () => n.value,
      (S) => {
        o.value = S;
      }
    );
    const c = () => {
      n.disabled || (t("update:modelValue", o.value), t("onChange", o.value));
    }, u = () => {
      n.disabled || (a.value = !0);
    }, d = () => {
      n.disabled || (a.value = !1);
    }, p = () => {
      o.value = void 0, t("update:modelValue", void 0), t("onChange", void 0);
    }, f = useMediaMatch(), g = useResponsiveProp(n.align, f), C = () => classMerge({
      ...mapToneToFormFieldFocusRingClasses$1({
        tone: n.tone,
        focused: a.value,
        disabled: n.disabled
      }),
      ...n.borderRadius && mapBorderRadiusToClassName(n.borderRadius),
      ...n.border && mapBorderToBorderClassName(n.border),
      ...n.joined && mapJoinedToClasses(n.joined)
    }), k = () => n.disabled ? "disabled" : n.tone === "error" ? "error" : "medium-emphasis", M = () => classMerge({
      "text-black-20": n.disabled,
      ...g.value && mapAlignToTextClasses(g.value),
      ...mapDisabledToCursorClasses(n.disabled)
    }), _ = () => classMerge({
      "opacity-1 w-[1.1rem]": a.value && o.value,
      "opacity-0 w-0 delay-100": !a.value || !o.value
    });
    return onMounted(() => {
      var E;
      const S = (E = s.value) == null ? void 0 : E.$refs.boxRef;
      n.autoFocus && S && i.value && (S.focus(), i.value.showPopover());
    }), (S, E) => (openBlock(), createBlock(_sfc_main$2H, {
      class: "relative",
      space: "2xs",
      "data-testid": unref(DATA_TEST_ID$1).CONTAINER
    }, {
      default: withCtx(() => [
        e.label ? (openBlock(), createBlock(_sfc_main$2q, {
          key: 0,
          forId: e.id,
          tone: e.tone,
          disabled: e.disabled
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(e.label), 1)
          ]),
          _: 1
        }, 8, ["forId", "tone", "disabled"])) : createCommentVNode("", !0),
        createVNode(_sfc_main$2K, {
          tone: "base",
          class: normalizeClass([C(), "transition-all"]),
          "padding-x": "sm"
        }, {
          default: withCtx(() => [
            createVNode(unref(_sfc_main$i), {
              ref_key: "datePickerRef",
              ref: i,
              modelValue: o.value,
              "onUpdate:modelValue": [
                E[0] || (E[0] = (P) => o.value = P),
                c
              ],
              mode: "date",
              attributes: l.value,
              color: "brand-orange",
              "first-day-of-week": e.firstDayOfWeek,
              "input-debounce": 500,
              "is-required": e.isRequired,
              masks: { weekdays: "WWW" },
              "max-date": e.maxDate,
              "min-date": e.minDate,
              popover: { visibility: "focus" },
              "trim-weeks": "",
              "update-on-input": ""
            }, {
              "header-title": withCtx(({ title: P }) => [
                createVNode(_sfc_main$I, { size: "xl" }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(P), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              default: withCtx(({ inputValue: P, inputEvents: $ }) => [
                createVNode(_sfc_main$2F, {
                  space: "xs",
                  "vertical-align": "center"
                }, {
                  default: withCtx(() => [
                    S.$slots["icon-left"] ? (openBlock(), createBlock(_sfc_main$2E, {
                      key: 0,
                      width: "content"
                    }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$2K, {
                          class: "select-none",
                          "data-testid": unref(DATA_TEST_ID$1).ICON_LEFT
                        }, {
                          default: withCtx(() => [
                            renderSlot(S.$slots, "icon-left", {
                              tone: e.disabled ? "disabled" : "medium-emphasis"
                            })
                          ]),
                          _: 3
                        }, 8, ["data-testid"])
                      ]),
                      _: 3
                    })) : createCommentVNode("", !0),
                    createVNode(_sfc_main$2E, null, {
                      default: withCtx(() => [
                        withDirectives(createVNode(_sfc_main$2K, mergeProps(
                          {
                            ref_key: "boxInputRef",
                            ref: s,
                            component: "input",
                            id: e.id,
                            value: P
                          },
                          toHandlers($),
                          {
                            onBlur: d,
                            onFocus: u,
                            placeholder: e.placeholder,
                            disabled: e.disabled
                          },
                          e.mask && {
                            "data-maska": e.mask
                          },
                          {
                            "padding-y": "sm",
                            class: [M(), "w-full border-none bg-transparent !outline-none cursor-pointer"],
                            "data-testid": unref(DATA_TEST_ID$1).INPUT
                          }
                        ), null, 16, ["id", "value", "placeholder", "disabled", "class", "data-testid"]), [
                          [unref(U)]
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    S.$slots["icon-right"] ? (openBlock(), createBlock(_sfc_main$2E, {
                      key: 1,
                      width: "content"
                    }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$2K, {
                          class: "select-none",
                          "data-testid": unref(DATA_TEST_ID$1).ICON_RIGHT
                        }, {
                          default: withCtx(() => [
                            renderSlot(S.$slots, "icon-right", {
                              tone: e.disabled ? "disabled" : "high-emphasis"
                            })
                          ]),
                          _: 3
                        }, 8, ["data-testid"])
                      ]),
                      _: 3
                    })) : createCommentVNode("", !0),
                    e.showClear ? (openBlock(), createBlock(_sfc_main$2E, {
                      key: 2,
                      width: "content"
                    }, {
                      default: withCtx(() => [
                        createVNode(_sfc_main$2K, {
                          class: normalizeClass(["transition-all", _()]),
                          role: "button",
                          "vertical-align": "center",
                          onClick: p,
                          "data-testid": unref(DATA_TEST_ID$1).CLEAR_BUTTON
                        }, {
                          default: withCtx(() => [
                            createVNode(_sfc_main$2p, {
                              size: "sm",
                              tone: "low-emphasis"
                            })
                          ]),
                          _: 1
                        }, 8, ["class", "data-testid"])
                      ]),
                      _: 1
                    })) : createCommentVNode("", !0)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 3
            }, 8, ["modelValue", "attributes", "first-day-of-week", "is-required", "max-date", "min-date"])
          ]),
          _: 3
        }, 8, ["class"]),
        e.description ? (openBlock(), createBlock(_sfc_main$2J, {
          key: 1,
          size: "sm",
          tone: k(),
          "data-testid": unref(DATA_TEST_ID$1).DESCRIPTION
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(e.description), 1)
          ]),
          _: 1
        }, 8, ["tone", "data-testid"])) : createCommentVNode("", !0),
        e.message ? (openBlock(), createBlock(_sfc_main$2J, {
          key: 2,
          size: "sm",
          tone: k(),
          "data-testid": unref(DATA_TEST_ID$1).MESSAGE
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(e.message), 1)
          ]),
          _: 1
        }, 8, ["tone", "data-testid"])) : createCommentVNode("", !0)
      ]),
      _: 3
    }, 8, ["data-testid"]));
  }
}), DatePicker_vue_vue_type_style_index_0_lang = "";
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function round(e) {
  return e + 0.5 | 0;
}
const lim = (e, t, n) => Math.max(Math.min(e, n), t);
function p2b(e) {
  return lim(round(e * 2.55), 0, 255);
}
function n2b(e) {
  return lim(round(e * 255), 0, 255);
}
function b2n(e) {
  return lim(round(e / 2.55) / 100, 0, 1);
}
function n2p(e) {
  return lim(round(e * 100), 0, 100);
}
const map$1 = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, hex = [..."0123456789ABCDEF"], h1 = (e) => hex[e & 15], h2 = (e) => hex[(e & 240) >> 4] + hex[e & 15], eq = (e) => (e & 240) >> 4 === (e & 15), isShort = (e) => eq(e.r) && eq(e.g) && eq(e.b) && eq(e.a);
function hexParse(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & map$1[e[1]] * 17,
    g: 255 & map$1[e[2]] * 17,
    b: 255 & map$1[e[3]] * 17,
    a: t === 5 ? map$1[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: map$1[e[1]] << 4 | map$1[e[2]],
    g: map$1[e[3]] << 4 | map$1[e[4]],
    b: map$1[e[5]] << 4 | map$1[e[6]],
    a: t === 9 ? map$1[e[7]] << 4 | map$1[e[8]] : 255
  })), n;
}
const alpha = (e, t) => e < 255 ? t(e) : "";
function hexString(e) {
  var t = isShort(e) ? h1 : h2;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + alpha(e.a, t) : void 0;
}
const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(e, t, n) {
  const s = t * Math.min(n, 1 - n), i = (a, o = (a + e / 30) % 12) => n - s * Math.max(Math.min(o - 3, 9 - o, 1), -1);
  return [i(0), i(8), i(4)];
}
function hsv2rgbn(e, t, n) {
  const s = (i, a = (i + e / 60) % 6) => n - n * t * Math.max(Math.min(a, 4 - a, 1), 0);
  return [s(5), s(3), s(1)];
}
function hwb2rgbn(e, t, n) {
  const s = hsl2rgbn(e, 1, 0.5);
  let i;
  for (t + n > 1 && (i = 1 / (t + n), t *= i, n *= i), i = 0; i < 3; i++)
    s[i] *= 1 - t - n, s[i] += t;
  return s;
}
function hueValue(e, t, n, s, i) {
  return e === i ? (t - n) / s + (t < n ? 6 : 0) : t === i ? (n - e) / s + 2 : (e - t) / s + 4;
}
function rgb2hsl(e) {
  const n = e.r / 255, s = e.g / 255, i = e.b / 255, a = Math.max(n, s, i), o = Math.min(n, s, i), l = (a + o) / 2;
  let c, u, d;
  return a !== o && (d = a - o, u = l > 0.5 ? d / (2 - a - o) : d / (a + o), c = hueValue(n, s, i, d, a), c = c * 60 + 0.5), [c | 0, u || 0, l];
}
function calln(e, t, n, s) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, s)).map(n2b);
}
function hsl2rgb(e, t, n) {
  return calln(hsl2rgbn, e, t, n);
}
function hwb2rgb(e, t, n) {
  return calln(hwb2rgbn, e, t, n);
}
function hsv2rgb(e, t, n) {
  return calln(hsv2rgbn, e, t, n);
}
function hue(e) {
  return (e % 360 + 360) % 360;
}
function hueParse(e) {
  const t = HUE_RE.exec(e);
  let n = 255, s;
  if (!t)
    return;
  t[5] !== s && (n = t[6] ? p2b(+t[5]) : n2b(+t[5]));
  const i = hue(+t[2]), a = +t[3] / 100, o = +t[4] / 100;
  return t[1] === "hwb" ? s = hwb2rgb(i, a, o) : t[1] === "hsv" ? s = hsv2rgb(i, a, o) : s = hsl2rgb(i, a, o), {
    r: s[0],
    g: s[1],
    b: s[2],
    a: n
  };
}
function rotate(e, t) {
  var n = rgb2hsl(e);
  n[0] = hue(n[0] + t), n = hsl2rgb(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function hslString(e) {
  if (!e)
    return;
  const t = rgb2hsl(e), n = t[0], s = n2p(t[1]), i = n2p(t[2]);
  return e.a < 255 ? `hsla(${n}, ${s}%, ${i}%, ${b2n(e.a)})` : `hsl(${n}, ${s}%, ${i}%)`;
}
const map = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, names$1 = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function unpack() {
  const e = {}, t = Object.keys(names$1), n = Object.keys(map);
  let s, i, a, o, l;
  for (s = 0; s < t.length; s++) {
    for (o = l = t[s], i = 0; i < n.length; i++)
      a = n[i], l = l.replace(a, map[a]);
    a = parseInt(names$1[o], 16), e[l] = [a >> 16 & 255, a >> 8 & 255, a & 255];
  }
  return e;
}
let names;
function nameParse(e) {
  names || (names = unpack(), names.transparent = [0, 0, 0, 0]);
  const t = names[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(e) {
  const t = RGB_RE.exec(e);
  let n = 255, s, i, a;
  if (t) {
    if (t[7] !== s) {
      const o = +t[7];
      n = t[8] ? p2b(o) : lim(o * 255, 0, 255);
    }
    return s = +t[1], i = +t[3], a = +t[5], s = 255 & (t[2] ? p2b(s) : lim(s, 0, 255)), i = 255 & (t[4] ? p2b(i) : lim(i, 0, 255)), a = 255 & (t[6] ? p2b(a) : lim(a, 0, 255)), {
      r: s,
      g: i,
      b: a,
      a: n
    };
  }
}
function rgbString(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${b2n(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const to = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, from = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function interpolate$1(e, t, n) {
  const s = from(b2n(e.r)), i = from(b2n(e.g)), a = from(b2n(e.b));
  return {
    r: n2b(to(s + n * (from(b2n(t.r)) - s))),
    g: n2b(to(i + n * (from(b2n(t.g)) - i))),
    b: n2b(to(a + n * (from(b2n(t.b)) - a))),
    a: e.a + n * (t.a - e.a)
  };
}
function modHSL(e, t, n) {
  if (e) {
    let s = rgb2hsl(e);
    s[t] = Math.max(0, Math.min(s[t] + s[t] * n, t === 0 ? 360 : 1)), s = hsl2rgb(s), e.r = s[0], e.g = s[1], e.b = s[2];
  }
}
function clone$1(e, t) {
  return e && Object.assign(t || {}, e);
}
function fromObject(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = n2b(e[3]))) : (t = clone$1(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = n2b(t.a)), t;
}
function functionParse(e) {
  return e.charAt(0) === "r" ? rgbParse(e) : hueParse(e);
}
class Color {
  constructor(t) {
    if (t instanceof Color)
      return t;
    const n = typeof t;
    let s;
    n === "object" ? s = fromObject(t) : n === "string" && (s = hexParse(t) || nameParse(t) || functionParse(t)), this._rgb = s, this._valid = !!s;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = clone$1(this._rgb);
    return t && (t.a = b2n(t.a)), t;
  }
  set rgb(t) {
    this._rgb = fromObject(t);
  }
  rgbString() {
    return this._valid ? rgbString(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? hexString(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? hslString(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const s = this.rgb, i = t.rgb;
      let a;
      const o = n === a ? 0.5 : n, l = 2 * o - 1, c = s.a - i.a, u = ((l * c === -1 ? l : (l + c) / (1 + l * c)) + 1) / 2;
      a = 1 - u, s.r = 255 & u * s.r + a * i.r + 0.5, s.g = 255 & u * s.g + a * i.g + 0.5, s.b = 255 & u * s.b + a * i.b + 0.5, s.a = o * s.a + (1 - o) * i.a, this.rgb = s;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = interpolate$1(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new Color(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = n2b(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = round(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return modHSL(this._rgb, 2, t), this;
  }
  darken(t) {
    return modHSL(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return modHSL(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return modHSL(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return rotate(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.3.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function noop() {
}
const uid = (() => {
  let e = 0;
  return () => e++;
})();
function isNullOrUndef(e) {
  return e === null || typeof e > "u";
}
function isArray(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function isObject(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function isNumberFinite(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function finiteOrDefault(e, t) {
  return isNumberFinite(e) ? e : t;
}
function valueOrDefault(e, t) {
  return typeof e > "u" ? t : e;
}
const toDimension = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function callback(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function each(e, t, n, s) {
  let i, a, o;
  if (isArray(e))
    if (a = e.length, s)
      for (i = a - 1; i >= 0; i--)
        t.call(n, e[i], i);
    else
      for (i = 0; i < a; i++)
        t.call(n, e[i], i);
  else if (isObject(e))
    for (o = Object.keys(e), a = o.length, i = 0; i < a; i++)
      t.call(n, e[o[i]], o[i]);
}
function _elementsEqual(e, t) {
  let n, s, i, a;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, s = e.length; n < s; ++n)
    if (i = e[n], a = t[n], i.datasetIndex !== a.datasetIndex || i.index !== a.index)
      return !1;
  return !0;
}
function clone(e) {
  if (isArray(e))
    return e.map(clone);
  if (isObject(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), s = n.length;
    let i = 0;
    for (; i < s; ++i)
      t[n[i]] = clone(e[n[i]]);
    return t;
  }
  return e;
}
function isValidKey(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function _merger(e, t, n, s) {
  if (!isValidKey(e))
    return;
  const i = t[e], a = n[e];
  isObject(i) && isObject(a) ? merge(i, a, s) : t[e] = clone(a);
}
function merge(e, t, n) {
  const s = isArray(t) ? t : [
    t
  ], i = s.length;
  if (!isObject(e))
    return e;
  n = n || {};
  const a = n.merger || _merger;
  let o;
  for (let l = 0; l < i; ++l) {
    if (o = s[l], !isObject(o))
      continue;
    const c = Object.keys(o);
    for (let u = 0, d = c.length; u < d; ++u)
      a(c[u], e, o, n);
  }
  return e;
}
function mergeIf(e, t) {
  return merge(e, t, {
    merger: _mergerIf
  });
}
function _mergerIf(e, t, n) {
  if (!isValidKey(e))
    return;
  const s = t[e], i = n[e];
  isObject(s) && isObject(i) ? mergeIf(s, i) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = clone(i));
}
const keyResolvers = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function _splitKey(e) {
  const t = e.split("."), n = [];
  let s = "";
  for (const i of t)
    s += i, s.endsWith("\\") ? s = s.slice(0, -1) + "." : (n.push(s), s = "");
  return n;
}
function _getKeyResolver(e) {
  const t = _splitKey(e);
  return (n) => {
    for (const s of t) {
      if (s === "")
        break;
      n = n && n[s];
    }
    return n;
  };
}
function resolveObjectKey(e, t) {
  return (keyResolvers[t] || (keyResolvers[t] = _getKeyResolver(t)))(e);
}
function _capitalize(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const defined = (e) => typeof e < "u", isFunction = (e) => typeof e == "function", setsEqual = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function _isClickEvent(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const PI = Math.PI, TAU = 2 * PI, PITAU = TAU + PI, INFINITY = Number.POSITIVE_INFINITY, RAD_PER_DEG = PI / 180, HALF_PI = PI / 2, QUARTER_PI = PI / 4, TWO_THIRDS_PI = PI * 2 / 3, log10 = Math.log10, sign = Math.sign;
function almostEquals(e, t, n) {
  return Math.abs(e - t) < n;
}
function niceNum(e) {
  const t = Math.round(e);
  e = almostEquals(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(log10(e))), s = e / n;
  return (s <= 1 ? 1 : s <= 2 ? 2 : s <= 5 ? 5 : 10) * n;
}
function _factorize(e) {
  const t = [], n = Math.sqrt(e);
  let s;
  for (s = 1; s < n; s++)
    e % s === 0 && (t.push(s), t.push(e / s));
  return n === (n | 0) && t.push(n), t.sort((i, a) => i - a).pop(), t;
}
function isNumber(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function almostWhole(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function _setMinAndMaxByKey(e, t, n) {
  let s, i, a;
  for (s = 0, i = e.length; s < i; s++)
    a = e[s][n], isNaN(a) || (t.min = Math.min(t.min, a), t.max = Math.max(t.max, a));
}
function toRadians(e) {
  return e * (PI / 180);
}
function toDegrees(e) {
  return e * (180 / PI);
}
function _decimalPlaces(e) {
  if (!isNumberFinite(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function getAngleFromPoint(e, t) {
  const n = t.x - e.x, s = t.y - e.y, i = Math.sqrt(n * n + s * s);
  let a = Math.atan2(s, n);
  return a < -0.5 * PI && (a += TAU), {
    angle: a,
    distance: i
  };
}
function distanceBetweenPoints(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function _angleDiff(e, t) {
  return (e - t + PITAU) % TAU - PI;
}
function _normalizeAngle(e) {
  return (e % TAU + TAU) % TAU;
}
function _angleBetween(e, t, n, s) {
  const i = _normalizeAngle(e), a = _normalizeAngle(t), o = _normalizeAngle(n), l = _normalizeAngle(a - i), c = _normalizeAngle(o - i), u = _normalizeAngle(i - a), d = _normalizeAngle(i - o);
  return i === a || i === o || s && a === o || l > c && u < d;
}
function _limitValue(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function _int16Range(e) {
  return _limitValue(e, -32768, 32767);
}
function _isBetween(e, t, n, s = 1e-6) {
  return e >= Math.min(t, n) - s && e <= Math.max(t, n) + s;
}
function _lookup(e, t, n) {
  n = n || ((o) => e[o] < t);
  let s = e.length - 1, i = 0, a;
  for (; s - i > 1; )
    a = i + s >> 1, n(a) ? i = a : s = a;
  return {
    lo: i,
    hi: s
  };
}
const _lookupByKey = (e, t, n, s) => _lookup(e, n, s ? (i) => {
  const a = e[i][t];
  return a < n || a === n && e[i + 1][t] === n;
} : (i) => e[i][t] < n), _rlookupByKey = (e, t, n) => _lookup(e, n, (s) => e[s][t] >= n);
function _filterBetween(e, t, n) {
  let s = 0, i = e.length;
  for (; s < i && e[s] < t; )
    s++;
  for (; i > s && e[i - 1] > n; )
    i--;
  return s > 0 || i < e.length ? e.slice(s, i) : e;
}
const arrayEvents = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function listenArrayEvents(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), arrayEvents.forEach((n) => {
    const s = "_onData" + _capitalize(n), i = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...a) {
        const o = i.apply(this, a);
        return e._chartjs.listeners.forEach((l) => {
          typeof l[s] == "function" && l[s](...a);
        }), o;
      }
    });
  });
}
function unlistenArrayEvents(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const s = n.listeners, i = s.indexOf(t);
  i !== -1 && s.splice(i, 1), !(s.length > 0) && (arrayEvents.forEach((a) => {
    delete e[a];
  }), delete e._chartjs);
}
function _arrayUnique(e) {
  const t = new Set(e);
  return t.size === e.length ? e : Array.from(t);
}
const requestAnimFrame = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function throttled(e, t) {
  let n = [], s = !1;
  return function(...i) {
    n = i, s || (s = !0, requestAnimFrame.call(window, () => {
      s = !1, e.apply(t, n);
    }));
  };
}
function debounce(e, t) {
  let n;
  return function(...s) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, s)) : e.apply(this, s), t;
  };
}
const _toLeftRightCenter = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", _alignStartEnd = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2;
function _getStartAndCountOfVisiblePoints(e, t, n) {
  const s = t.length;
  let i = 0, a = s;
  if (e._sorted) {
    const { iScale: o, _parsed: l } = e, c = o.axis, { min: u, max: d, minDefined: p, maxDefined: f } = o.getUserBounds();
    p && (i = _limitValue(Math.min(
      // @ts-expect-error Need to type _parsed
      _lookupByKey(l, o.axis, u).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? s : _lookupByKey(t, c, o.getPixelForValue(u)).lo
    ), 0, s - 1)), f ? a = _limitValue(Math.max(
      // @ts-expect-error Need to type _parsed
      _lookupByKey(l, o.axis, d, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : _lookupByKey(t, c, o.getPixelForValue(d), !0).hi + 1
    ), i, s) - i : a = s - i;
  }
  return {
    start: i,
    count: a
  };
}
function _scaleRangesChanged(e) {
  const { xScale: t, yScale: n, _scaleRanges: s } = e, i = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!s)
    return e._scaleRanges = i, !0;
  const a = s.xmin !== t.min || s.xmax !== t.max || s.ymin !== n.min || s.ymax !== n.max;
  return Object.assign(s, i), a;
}
const atEdge = (e) => e === 0 || e === 1, elasticIn = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * TAU / n)), elasticOut = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * TAU / n) + 1, effects = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * HALF_PI) + 1,
  easeOutSine: (e) => Math.sin(e * HALF_PI),
  easeInOutSine: (e) => -0.5 * (Math.cos(PI * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => atEdge(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => atEdge(e) ? e : elasticIn(e, 0.075, 0.3),
  easeOutElastic: (e) => atEdge(e) ? e : elasticOut(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return atEdge(e) ? e : e < 0.5 ? 0.5 * elasticIn(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * elasticOut(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - effects.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? effects.easeInBounce(e * 2) * 0.5 : effects.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function color(e) {
  return isPatternOrGradient(e) ? e : new Color(e);
}
function getHoverColor(e) {
  return isPatternOrGradient(e) ? e : new Color(e).saturate(0.5).darken(0.1).hexString();
}
const numbers = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], colors = [
  "color",
  "borderColor",
  "backgroundColor"
];
function applyAnimationsDefaults(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: colors
    },
    numbers: {
      type: "number",
      properties: numbers
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function applyLayoutsDefaults(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const intlCache = /* @__PURE__ */ new Map();
function getNumberFormat(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let s = intlCache.get(n);
  return s || (s = new Intl.NumberFormat(e, t), intlCache.set(n, s)), s;
}
function formatNumber(e, t, n) {
  return getNumberFormat(t, n).format(e);
}
const formatters$4 = {
  values(e) {
    return isArray(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const s = this.chart.options.locale;
    let i, a = e;
    if (n.length > 1) {
      const u = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (u < 1e-4 || u > 1e15) && (i = "scientific"), a = calculateDelta(e, n);
    }
    const o = log10(Math.abs(a)), l = isNaN(o) ? 1 : Math.max(Math.min(-1 * Math.floor(o), 20), 0), c = {
      notation: i,
      minimumFractionDigits: l,
      maximumFractionDigits: l
    };
    return Object.assign(c, this.options.ticks.format), formatNumber(e, s, c);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const s = n[t].significand || e / Math.pow(10, Math.floor(log10(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(s) || t > 0.8 * n.length ? formatters$4.numeric.call(this, e, t, n) : "";
  }
};
function calculateDelta(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var Ticks = {
  formatters: formatters$4
};
function applyScaleDefaults(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, n) => n.lineWidth,
      tickColor: (t, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Ticks.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const overrides = /* @__PURE__ */ Object.create(null), descriptors = /* @__PURE__ */ Object.create(null);
function getScope$1(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let s = 0, i = n.length; s < i; ++s) {
    const a = n[s];
    e = e[a] || (e[a] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function set(e, t, n) {
  return typeof t == "string" ? merge(getScope$1(e, t), n) : merge(getScope$1(e, ""), t);
}
class Defaults {
  constructor(t, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (s) => s.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (s, i) => getHoverColor(i.backgroundColor), this.hoverBorderColor = (s, i) => getHoverColor(i.borderColor), this.hoverColor = (s, i) => getHoverColor(i.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(n);
  }
  set(t, n) {
    return set(this, t, n);
  }
  get(t) {
    return getScope$1(this, t);
  }
  describe(t, n) {
    return set(descriptors, t, n);
  }
  override(t, n) {
    return set(overrides, t, n);
  }
  route(t, n, s, i) {
    const a = getScope$1(this, t), o = getScope$1(this, s), l = "_" + n;
    Object.defineProperties(a, {
      [l]: {
        value: a[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const c = this[l], u = o[i];
          return isObject(c) ? Object.assign({}, u, c) : valueOrDefault(c, u);
        },
        set(c) {
          this[l] = c;
        }
      }
    });
  }
  apply(t) {
    t.forEach((n) => n(this));
  }
}
var defaults = /* @__PURE__ */ new Defaults({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  applyAnimationsDefaults,
  applyLayoutsDefaults,
  applyScaleDefaults
]);
function toFontString(e) {
  return !e || isNullOrUndef(e.size) || isNullOrUndef(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function _measureText(e, t, n, s, i) {
  let a = t[i];
  return a || (a = t[i] = e.measureText(i).width, n.push(i)), a > s && (s = a), s;
}
function _longestText(e, t, n, s) {
  s = s || {};
  let i = s.data = s.data || {}, a = s.garbageCollect = s.garbageCollect || [];
  s.font !== t && (i = s.data = {}, a = s.garbageCollect = [], s.font = t), e.save(), e.font = t;
  let o = 0;
  const l = n.length;
  let c, u, d, p, f;
  for (c = 0; c < l; c++)
    if (p = n[c], p != null && !isArray(p))
      o = _measureText(e, i, a, o, p);
    else if (isArray(p))
      for (u = 0, d = p.length; u < d; u++)
        f = p[u], f != null && !isArray(f) && (o = _measureText(e, i, a, o, f));
  e.restore();
  const g = a.length / 2;
  if (g > n.length) {
    for (c = 0; c < g; c++)
      delete i[a[c]];
    a.splice(0, g);
  }
  return o;
}
function _alignPixel(e, t, n) {
  const s = e.currentDevicePixelRatio, i = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - i) * s) / s + i;
}
function clearCanvas(e, t) {
  t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore();
}
function drawPoint(e, t, n, s) {
  drawPointLegend(e, t, n, s, null);
}
function drawPointLegend(e, t, n, s, i) {
  let a, o, l, c, u, d, p, f;
  const g = t.pointStyle, C = t.rotation, k = t.radius;
  let M = (C || 0) * RAD_PER_DEG;
  if (g && typeof g == "object" && (a = g.toString(), a === "[object HTMLImageElement]" || a === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, s), e.rotate(M), e.drawImage(g, -g.width / 2, -g.height / 2, g.width, g.height), e.restore();
    return;
  }
  if (!(isNaN(k) || k <= 0)) {
    switch (e.beginPath(), g) {
      default:
        i ? e.ellipse(n, s, i / 2, k, 0, 0, TAU) : e.arc(n, s, k, 0, TAU), e.closePath();
        break;
      case "triangle":
        d = i ? i / 2 : k, e.moveTo(n + Math.sin(M) * d, s - Math.cos(M) * k), M += TWO_THIRDS_PI, e.lineTo(n + Math.sin(M) * d, s - Math.cos(M) * k), M += TWO_THIRDS_PI, e.lineTo(n + Math.sin(M) * d, s - Math.cos(M) * k), e.closePath();
        break;
      case "rectRounded":
        u = k * 0.516, c = k - u, o = Math.cos(M + QUARTER_PI) * c, p = Math.cos(M + QUARTER_PI) * (i ? i / 2 - u : c), l = Math.sin(M + QUARTER_PI) * c, f = Math.sin(M + QUARTER_PI) * (i ? i / 2 - u : c), e.arc(n - p, s - l, u, M - PI, M - HALF_PI), e.arc(n + f, s - o, u, M - HALF_PI, M), e.arc(n + p, s + l, u, M, M + HALF_PI), e.arc(n - f, s + o, u, M + HALF_PI, M + PI), e.closePath();
        break;
      case "rect":
        if (!C) {
          c = Math.SQRT1_2 * k, d = i ? i / 2 : c, e.rect(n - d, s - c, 2 * d, 2 * c);
          break;
        }
        M += QUARTER_PI;
      case "rectRot":
        p = Math.cos(M) * (i ? i / 2 : k), o = Math.cos(M) * k, l = Math.sin(M) * k, f = Math.sin(M) * (i ? i / 2 : k), e.moveTo(n - p, s - l), e.lineTo(n + f, s - o), e.lineTo(n + p, s + l), e.lineTo(n - f, s + o), e.closePath();
        break;
      case "crossRot":
        M += QUARTER_PI;
      case "cross":
        p = Math.cos(M) * (i ? i / 2 : k), o = Math.cos(M) * k, l = Math.sin(M) * k, f = Math.sin(M) * (i ? i / 2 : k), e.moveTo(n - p, s - l), e.lineTo(n + p, s + l), e.moveTo(n + f, s - o), e.lineTo(n - f, s + o);
        break;
      case "star":
        p = Math.cos(M) * (i ? i / 2 : k), o = Math.cos(M) * k, l = Math.sin(M) * k, f = Math.sin(M) * (i ? i / 2 : k), e.moveTo(n - p, s - l), e.lineTo(n + p, s + l), e.moveTo(n + f, s - o), e.lineTo(n - f, s + o), M += QUARTER_PI, p = Math.cos(M) * (i ? i / 2 : k), o = Math.cos(M) * k, l = Math.sin(M) * k, f = Math.sin(M) * (i ? i / 2 : k), e.moveTo(n - p, s - l), e.lineTo(n + p, s + l), e.moveTo(n + f, s - o), e.lineTo(n - f, s + o);
        break;
      case "line":
        o = i ? i / 2 : Math.cos(M) * k, l = Math.sin(M) * k, e.moveTo(n - o, s - l), e.lineTo(n + o, s + l);
        break;
      case "dash":
        e.moveTo(n, s), e.lineTo(n + Math.cos(M) * (i ? i / 2 : k), s + Math.sin(M) * k);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function _isPointInArea(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function clipArea(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function unclipArea(e) {
  e.restore();
}
function _steppedLineTo(e, t, n, s, i) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (i === "middle") {
    const a = (t.x + n.x) / 2;
    e.lineTo(a, t.y), e.lineTo(a, n.y);
  } else
    i === "after" != !!s ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function _bezierCurveTo(e, t, n, s) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(s ? t.cp1x : t.cp2x, s ? t.cp1y : t.cp2y, s ? n.cp2x : n.cp1x, s ? n.cp2y : n.cp1y, n.x, n.y);
}
function setRenderOpts(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), isNullOrUndef(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function decorateText(e, t, n, s, i) {
  if (i.strikethrough || i.underline) {
    const a = e.measureText(s), o = t - a.actualBoundingBoxLeft, l = t + a.actualBoundingBoxRight, c = n - a.actualBoundingBoxAscent, u = n + a.actualBoundingBoxDescent, d = i.strikethrough ? (c + u) / 2 : u;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = i.decorationWidth || 2, e.moveTo(o, d), e.lineTo(l, d), e.stroke();
  }
}
function drawBackdrop(e, t) {
  const n = e.fillStyle;
  e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function renderText(e, t, n, s, i, a = {}) {
  const o = isArray(t) ? t : [
    t
  ], l = a.strokeWidth > 0 && a.strokeColor !== "";
  let c, u;
  for (e.save(), e.font = i.string, setRenderOpts(e, a), c = 0; c < o.length; ++c)
    u = o[c], a.backdrop && drawBackdrop(e, a.backdrop), l && (a.strokeColor && (e.strokeStyle = a.strokeColor), isNullOrUndef(a.strokeWidth) || (e.lineWidth = a.strokeWidth), e.strokeText(u, n, s, a.maxWidth)), e.fillText(u, n, s, a.maxWidth), decorateText(e, n, s, u, a), s += Number(i.lineHeight);
  e.restore();
}
function addRoundedRectPath(e, t) {
  const { x: n, y: s, w: i, h: a, radius: o } = t;
  e.arc(n + o.topLeft, s + o.topLeft, o.topLeft, -HALF_PI, PI, !0), e.lineTo(n, s + a - o.bottomLeft), e.arc(n + o.bottomLeft, s + a - o.bottomLeft, o.bottomLeft, PI, HALF_PI, !0), e.lineTo(n + i - o.bottomRight, s + a), e.arc(n + i - o.bottomRight, s + a - o.bottomRight, o.bottomRight, HALF_PI, 0, !0), e.lineTo(n + i, s + o.topRight), e.arc(n + i - o.topRight, s + o.topRight, o.topRight, 0, -HALF_PI, !0), e.lineTo(n + o.topLeft, s);
}
const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function toLineHeight(e, t) {
  const n = ("" + e).match(LINE_HEIGHT);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const numberOrZero = (e) => +e || 0;
function _readValueToProps(e, t) {
  const n = {}, s = isObject(t), i = s ? Object.keys(t) : t, a = isObject(e) ? s ? (o) => valueOrDefault(e[o], e[t[o]]) : (o) => e[o] : () => e;
  for (const o of i)
    n[o] = numberOrZero(a(o));
  return n;
}
function toTRBL(e) {
  return _readValueToProps(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function toTRBLCorners(e) {
  return _readValueToProps(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function toPadding(e) {
  const t = toTRBL(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function toFont(e, t) {
  e = e || {}, t = t || defaults.font;
  let n = valueOrDefault(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let s = valueOrDefault(e.style, t.style);
  s && !("" + s).match(FONT_STYLE) && (console.warn('Invalid font style specified: "' + s + '"'), s = void 0);
  const i = {
    family: valueOrDefault(e.family, t.family),
    lineHeight: toLineHeight(valueOrDefault(e.lineHeight, t.lineHeight), n),
    size: n,
    style: s,
    weight: valueOrDefault(e.weight, t.weight),
    string: ""
  };
  return i.string = toFontString(i), i;
}
function resolve(e, t, n, s) {
  let i = !0, a, o, l;
  for (a = 0, o = e.length; a < o; ++a)
    if (l = e[a], l !== void 0 && (t !== void 0 && typeof l == "function" && (l = l(t), i = !1), n !== void 0 && isArray(l) && (l = l[n % l.length], i = !1), l !== void 0))
      return s && !i && (s.cacheable = !1), l;
}
function _addGrace(e, t, n) {
  const { min: s, max: i } = e, a = toDimension(t, (i - s) / 2), o = (l, c) => n && l === 0 ? 0 : l + c;
  return {
    min: o(s, -Math.abs(a)),
    max: o(i, a)
  };
}
function createContext(e, t) {
  return Object.assign(Object.create(e), t);
}
function _createResolver(e, t = [
  ""
], n, s, i = () => e[0]) {
  const a = n || e;
  typeof s > "u" && (s = _resolve("_fallback", e));
  const o = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: a,
    _fallback: s,
    _getTarget: i,
    override: (l) => _createResolver([
      l,
      ...e
    ], t, a, s)
  };
  return new Proxy(o, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(l, c) {
      return delete l[c], delete l._keys, delete e[0][c], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(l, c) {
      return _cached(l, c, () => _resolveWithPrefixes(c, t, e, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(l, c) {
      return Reflect.getOwnPropertyDescriptor(l._scopes[0], c);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(l, c) {
      return getKeysFromAllScopes(l).includes(c);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(l) {
      return getKeysFromAllScopes(l);
    },
    /**
    * A trap for setting property values.
    */
    set(l, c, u) {
      const d = l._storage || (l._storage = i());
      return l[c] = d[c] = u, delete l._keys, !0;
    }
  });
}
function _attachContext(e, t, n, s) {
  const i = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: _descriptors(e, s),
    setContext: (a) => _attachContext(e, a, n, s),
    override: (a) => _attachContext(e.override(a), t, n, s)
  };
  return new Proxy(i, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, o) {
      return delete a[o], delete e[o], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, o, l) {
      return _cached(a, o, () => _resolveWithContext(a, o, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, o) {
      return a._descriptors.allKeys ? Reflect.has(e, o) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, o);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(a, o) {
      return Reflect.has(e, o);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(a, o, l) {
      return e[o] = l, delete a[o], !0;
    }
  });
}
function _descriptors(e, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = t.scriptable, _indexable: s = t.indexable, _allKeys: i = t.allKeys } = e;
  return {
    allKeys: i,
    scriptable: n,
    indexable: s,
    isScriptable: isFunction(n) ? n : () => n,
    isIndexable: isFunction(s) ? s : () => s
  };
}
const readKey = (e, t) => e ? e + _capitalize(t) : t, needsSubResolver = (e, t) => isObject(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function _cached(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t))
    return e[t];
  const s = n();
  return e[t] = s, s;
}
function _resolveWithContext(e, t, n) {
  const { _proxy: s, _context: i, _subProxy: a, _descriptors: o } = e;
  let l = s[t];
  return isFunction(l) && o.isScriptable(t) && (l = _resolveScriptable(t, l, e, n)), isArray(l) && l.length && (l = _resolveArray(t, l, e, o.isIndexable)), needsSubResolver(t, l) && (l = _attachContext(l, i, a && a[t], o)), l;
}
function _resolveScriptable(e, t, n, s) {
  const { _proxy: i, _context: a, _subProxy: o, _stack: l } = n;
  if (l.has(e))
    throw new Error("Recursion detected: " + Array.from(l).join("->") + "->" + e);
  l.add(e);
  let c = t(a, o || s);
  return l.delete(e), needsSubResolver(e, c) && (c = createSubResolver(i._scopes, i, e, c)), c;
}
function _resolveArray(e, t, n, s) {
  const { _proxy: i, _context: a, _subProxy: o, _descriptors: l } = n;
  if (typeof a.index < "u" && s(e))
    return t[a.index % t.length];
  if (isObject(t[0])) {
    const c = t, u = i._scopes.filter((d) => d !== c);
    t = [];
    for (const d of c) {
      const p = createSubResolver(u, i, e, d);
      t.push(_attachContext(p, a, o && o[e], l));
    }
  }
  return t;
}
function resolveFallback(e, t, n) {
  return isFunction(e) ? e(t, n) : e;
}
const getScope = (e, t) => e === !0 ? t : typeof e == "string" ? resolveObjectKey(t, e) : void 0;
function addScopes(e, t, n, s, i) {
  for (const a of t) {
    const o = getScope(n, a);
    if (o) {
      e.add(o);
      const l = resolveFallback(o._fallback, n, i);
      if (typeof l < "u" && l !== n && l !== s)
        return l;
    } else if (o === !1 && typeof s < "u" && n !== s)
      return null;
  }
  return !1;
}
function createSubResolver(e, t, n, s) {
  const i = t._rootScopes, a = resolveFallback(t._fallback, n, s), o = [
    ...e,
    ...i
  ], l = /* @__PURE__ */ new Set();
  l.add(s);
  let c = addScopesFromKey(l, o, n, a || n, s);
  return c === null || typeof a < "u" && a !== n && (c = addScopesFromKey(l, o, a, c, s), c === null) ? !1 : _createResolver(Array.from(l), [
    ""
  ], i, a, () => subGetTarget(t, n, s));
}
function addScopesFromKey(e, t, n, s, i) {
  for (; n; )
    n = addScopes(e, t, n, s, i);
  return n;
}
function subGetTarget(e, t, n) {
  const s = e._getTarget();
  t in s || (s[t] = {});
  const i = s[t];
  return isArray(i) && isObject(n) ? n : i || {};
}
function _resolveWithPrefixes(e, t, n, s) {
  let i;
  for (const a of t)
    if (i = _resolve(readKey(a, e), n), typeof i < "u")
      return needsSubResolver(e, i) ? createSubResolver(n, s, e, i) : i;
}
function _resolve(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const s = n[e];
    if (typeof s < "u")
      return s;
  }
}
function getKeysFromAllScopes(e) {
  let t = e._keys;
  return t || (t = e._keys = resolveKeysFromAllScopes(e._scopes)), t;
}
function resolveKeysFromAllScopes(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const s of Object.keys(n).filter((i) => !i.startsWith("_")))
      t.add(s);
  return Array.from(t);
}
const EPSILON = Number.EPSILON || 1e-14, getPoint = (e, t) => t < e.length && !e[t].skip && e[t], getValueAxis = (e) => e === "x" ? "y" : "x";
function splineCurve(e, t, n, s) {
  const i = e.skip ? t : e, a = t, o = n.skip ? t : n, l = distanceBetweenPoints(a, i), c = distanceBetweenPoints(o, a);
  let u = l / (l + c), d = c / (l + c);
  u = isNaN(u) ? 0 : u, d = isNaN(d) ? 0 : d;
  const p = s * u, f = s * d;
  return {
    previous: {
      x: a.x - p * (o.x - i.x),
      y: a.y - p * (o.y - i.y)
    },
    next: {
      x: a.x + f * (o.x - i.x),
      y: a.y + f * (o.y - i.y)
    }
  };
}
function monotoneAdjust(e, t, n) {
  const s = e.length;
  let i, a, o, l, c, u = getPoint(e, 0);
  for (let d = 0; d < s - 1; ++d)
    if (c = u, u = getPoint(e, d + 1), !(!c || !u)) {
      if (almostEquals(t[d], 0, EPSILON)) {
        n[d] = n[d + 1] = 0;
        continue;
      }
      i = n[d] / t[d], a = n[d + 1] / t[d], l = Math.pow(i, 2) + Math.pow(a, 2), !(l <= 9) && (o = 3 / Math.sqrt(l), n[d] = i * o * t[d], n[d + 1] = a * o * t[d]);
    }
}
function monotoneCompute(e, t, n = "x") {
  const s = getValueAxis(n), i = e.length;
  let a, o, l, c = getPoint(e, 0);
  for (let u = 0; u < i; ++u) {
    if (o = l, l = c, c = getPoint(e, u + 1), !l)
      continue;
    const d = l[n], p = l[s];
    o && (a = (d - o[n]) / 3, l[`cp1${n}`] = d - a, l[`cp1${s}`] = p - a * t[u]), c && (a = (c[n] - d) / 3, l[`cp2${n}`] = d + a, l[`cp2${s}`] = p + a * t[u]);
  }
}
function splineCurveMonotone(e, t = "x") {
  const n = getValueAxis(t), s = e.length, i = Array(s).fill(0), a = Array(s);
  let o, l, c, u = getPoint(e, 0);
  for (o = 0; o < s; ++o)
    if (l = c, c = u, u = getPoint(e, o + 1), !!c) {
      if (u) {
        const d = u[t] - c[t];
        i[o] = d !== 0 ? (u[n] - c[n]) / d : 0;
      }
      a[o] = l ? u ? sign(i[o - 1]) !== sign(i[o]) ? 0 : (i[o - 1] + i[o]) / 2 : i[o - 1] : i[o];
    }
  monotoneAdjust(e, i, a), monotoneCompute(e, a, t);
}
function capControlPoint(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function capBezierPoints(e, t) {
  let n, s, i, a, o, l = _isPointInArea(e[0], t);
  for (n = 0, s = e.length; n < s; ++n)
    o = a, a = l, l = n < s - 1 && _isPointInArea(e[n + 1], t), a && (i = e[n], o && (i.cp1x = capControlPoint(i.cp1x, t.left, t.right), i.cp1y = capControlPoint(i.cp1y, t.top, t.bottom)), l && (i.cp2x = capControlPoint(i.cp2x, t.left, t.right), i.cp2y = capControlPoint(i.cp2y, t.top, t.bottom)));
}
function _updateBezierControlPoints(e, t, n, s, i) {
  let a, o, l, c;
  if (t.spanGaps && (e = e.filter((u) => !u.skip)), t.cubicInterpolationMode === "monotone")
    splineCurveMonotone(e, i);
  else {
    let u = s ? e[e.length - 1] : e[0];
    for (a = 0, o = e.length; a < o; ++a)
      l = e[a], c = splineCurve(u, l, e[Math.min(a + 1, o - (s ? 0 : 1)) % o], t.tension), l.cp1x = c.previous.x, l.cp1y = c.previous.y, l.cp2x = c.next.x, l.cp2y = c.next.y, u = l;
  }
  t.capBezierPoints && capBezierPoints(e, n);
}
function _isDomSupported() {
  return typeof window < "u" && typeof document < "u";
}
function _getParentNode(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function parseMaxStyle(e, t, n) {
  let s;
  return typeof e == "string" ? (s = parseInt(e, 10), e.indexOf("%") !== -1 && (s = s / 100 * t.parentNode[n])) : s = e, s;
}
const getComputedStyle$1 = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function getStyle(e, t) {
  return getComputedStyle$1(e).getPropertyValue(t);
}
const positions = [
  "top",
  "right",
  "bottom",
  "left"
];
function getPositionedStyle(e, t, n) {
  const s = {};
  n = n ? "-" + n : "";
  for (let i = 0; i < 4; i++) {
    const a = positions[i];
    s[a] = parseFloat(e[t + "-" + a + n]) || 0;
  }
  return s.width = s.left + s.right, s.height = s.top + s.bottom, s;
}
const useOffsetPos = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function getCanvasPosition(e, t) {
  const n = e.touches, s = n && n.length ? n[0] : e, { offsetX: i, offsetY: a } = s;
  let o = !1, l, c;
  if (useOffsetPos(i, a, e.target))
    l = i, c = a;
  else {
    const u = t.getBoundingClientRect();
    l = s.clientX - u.left, c = s.clientY - u.top, o = !0;
  }
  return {
    x: l,
    y: c,
    box: o
  };
}
function getRelativePosition(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: s } = t, i = getComputedStyle$1(n), a = i.boxSizing === "border-box", o = getPositionedStyle(i, "padding"), l = getPositionedStyle(i, "border", "width"), { x: c, y: u, box: d } = getCanvasPosition(e, n), p = o.left + (d && l.left), f = o.top + (d && l.top);
  let { width: g, height: C } = t;
  return a && (g -= o.width + l.width, C -= o.height + l.height), {
    x: Math.round((c - p) / g * n.width / s),
    y: Math.round((u - f) / C * n.height / s)
  };
}
function getContainerSize(e, t, n) {
  let s, i;
  if (t === void 0 || n === void 0) {
    const a = _getParentNode(e);
    if (!a)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const o = a.getBoundingClientRect(), l = getComputedStyle$1(a), c = getPositionedStyle(l, "border", "width"), u = getPositionedStyle(l, "padding");
      t = o.width - u.width - c.width, n = o.height - u.height - c.height, s = parseMaxStyle(l.maxWidth, a, "clientWidth"), i = parseMaxStyle(l.maxHeight, a, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: s || INFINITY,
    maxHeight: i || INFINITY
  };
}
const round1 = (e) => Math.round(e * 10) / 10;
function getMaximumSize(e, t, n, s) {
  const i = getComputedStyle$1(e), a = getPositionedStyle(i, "margin"), o = parseMaxStyle(i.maxWidth, e, "clientWidth") || INFINITY, l = parseMaxStyle(i.maxHeight, e, "clientHeight") || INFINITY, c = getContainerSize(e, t, n);
  let { width: u, height: d } = c;
  if (i.boxSizing === "content-box") {
    const f = getPositionedStyle(i, "border", "width"), g = getPositionedStyle(i, "padding");
    u -= g.width + f.width, d -= g.height + f.height;
  }
  return u = Math.max(0, u - a.width), d = Math.max(0, s ? u / s : d - a.height), u = round1(Math.min(u, o, c.maxWidth)), d = round1(Math.min(d, l, c.maxHeight)), u && !d && (d = round1(u / 2)), (t !== void 0 || n !== void 0) && s && c.height && d > c.height && (d = c.height, u = round1(Math.floor(d * s))), {
    width: u,
    height: d
  };
}
function retinaScale(e, t, n) {
  const s = t || 1, i = Math.floor(e.height * s), a = Math.floor(e.width * s);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const o = e.canvas;
  return o.style && (n || !o.style.height && !o.style.width) && (o.style.height = `${e.height}px`, o.style.width = `${e.width}px`), e.currentDevicePixelRatio !== s || o.height !== i || o.width !== a ? (e.currentDevicePixelRatio = s, o.height = i, o.width = a, e.ctx.setTransform(s, 0, 0, s, 0, 0), !0) : !1;
}
const supportsEventListenerOptions = function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch {
  }
  return e;
}();
function readUsedSize(e, t) {
  const n = getStyle(e, t), s = n && n.match(/^(\d+)(\.\d+)?px$/);
  return s ? +s[1] : void 0;
}
function _pointInLine(e, t, n, s) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function _steppedInterpolation(e, t, n, s) {
  return {
    x: e.x + n * (t.x - e.x),
    y: s === "middle" ? n < 0.5 ? e.y : t.y : s === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function _bezierInterpolation(e, t, n, s) {
  const i = {
    x: e.cp2x,
    y: e.cp2y
  }, a = {
    x: t.cp1x,
    y: t.cp1y
  }, o = _pointInLine(e, i, n), l = _pointInLine(i, a, n), c = _pointInLine(a, t, n), u = _pointInLine(o, l, n), d = _pointInLine(l, c, n);
  return _pointInLine(u, d, n);
}
const getRightToLeftAdapter = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, s) {
      return n - s;
    },
    leftForLtr(n, s) {
      return n - s;
    }
  };
}, getLeftToRightAdapter = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function getRtlAdapter(e, t, n) {
  return e ? getRightToLeftAdapter(t, n) : getLeftToRightAdapter();
}
function overrideTextDirection(e, t) {
  let n, s;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, s = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = s);
}
function restoreTextDirection(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function propertyFn(e) {
  return e === "angle" ? {
    between: _angleBetween,
    compare: _angleDiff,
    normalize: _normalizeAngle
  } : {
    between: _isBetween,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function normalizeSegment({ start: e, end: t, count: n, loop: s, style: i }) {
  return {
    start: e % n,
    end: t % n,
    loop: s && (t - e + 1) % n === 0,
    style: i
  };
}
function getSegment(e, t, n) {
  const { property: s, start: i, end: a } = n, { between: o, normalize: l } = propertyFn(s), c = t.length;
  let { start: u, end: d, loop: p } = e, f, g;
  if (p) {
    for (u += c, d += c, f = 0, g = c; f < g && o(l(t[u % c][s]), i, a); ++f)
      u--, d--;
    u %= c, d %= c;
  }
  return d < u && (d += c), {
    start: u,
    end: d,
    loop: p,
    style: e.style
  };
}
function _boundSegment(e, t, n) {
  if (!n)
    return [
      e
    ];
  const { property: s, start: i, end: a } = n, o = t.length, { compare: l, between: c, normalize: u } = propertyFn(s), { start: d, end: p, loop: f, style: g } = getSegment(e, t, n), C = [];
  let k = !1, M = null, _, S, E;
  const P = () => c(i, E, _) && l(i, E) !== 0, $ = () => l(a, _) === 0 || c(a, E, _), A = () => k || P(), I = () => !k || $();
  for (let D = d, R = d; D <= p; ++D)
    S = t[D % o], !S.skip && (_ = u(S[s]), _ !== E && (k = c(_, i, a), M === null && A() && (M = l(_, i) === 0 ? D : R), M !== null && I() && (C.push(normalizeSegment({
      start: M,
      end: D,
      loop: f,
      count: o,
      style: g
    })), M = null), R = D, E = _));
  return M !== null && C.push(normalizeSegment({
    start: M,
    end: p,
    loop: f,
    count: o,
    style: g
  })), C;
}
function _boundSegments(e, t) {
  const n = [], s = e.segments;
  for (let i = 0; i < s.length; i++) {
    const a = _boundSegment(s[i], e.points, t);
    a.length && n.push(...a);
  }
  return n;
}
function findStartAndEnd(e, t, n, s) {
  let i = 0, a = t - 1;
  if (n && !s)
    for (; i < t && !e[i].skip; )
      i++;
  for (; i < t && e[i].skip; )
    i++;
  for (i %= t, n && (a += i); a > i && e[a % t].skip; )
    a--;
  return a %= t, {
    start: i,
    end: a
  };
}
function solidSegments(e, t, n, s) {
  const i = e.length, a = [];
  let o = t, l = e[t], c;
  for (c = t + 1; c <= n; ++c) {
    const u = e[c % i];
    u.skip || u.stop ? l.skip || (s = !1, a.push({
      start: t % i,
      end: (c - 1) % i,
      loop: s
    }), t = o = u.stop ? c : null) : (o = c, l.skip && (t = c)), l = u;
  }
  return o !== null && a.push({
    start: t % i,
    end: o % i,
    loop: s
  }), a;
}
function _computeSegments(e, t) {
  const n = e.points, s = e.options.spanGaps, i = n.length;
  if (!i)
    return [];
  const a = !!e._loop, { start: o, end: l } = findStartAndEnd(n, i, a, s);
  if (s === !0)
    return splitByStyles(e, [
      {
        start: o,
        end: l,
        loop: a
      }
    ], n, t);
  const c = l < o ? l + i : l, u = !!e._fullLoop && o === 0 && l === i - 1;
  return splitByStyles(e, solidSegments(n, o, c, u), n, t);
}
function splitByStyles(e, t, n, s) {
  return !s || !s.setContext || !n ? t : doSplitByStyles(e, t, n, s);
}
function doSplitByStyles(e, t, n, s) {
  const i = e._chart.getContext(), a = readStyle(e.options), { _datasetIndex: o, options: { spanGaps: l } } = e, c = n.length, u = [];
  let d = a, p = t[0].start, f = p;
  function g(C, k, M, _) {
    const S = l ? -1 : 1;
    if (C !== k) {
      for (C += c; n[C % c].skip; )
        C -= S;
      for (; n[k % c].skip; )
        k += S;
      C % c !== k % c && (u.push({
        start: C % c,
        end: k % c,
        loop: M,
        style: _
      }), d = _, p = k % c);
    }
  }
  for (const C of t) {
    p = l ? p : C.start;
    let k = n[p % c], M;
    for (f = p + 1; f <= C.end; f++) {
      const _ = n[f % c];
      M = readStyle(s.setContext(createContext(i, {
        type: "segment",
        p0: k,
        p1: _,
        p0DataIndex: (f - 1) % c,
        p1DataIndex: f % c,
        datasetIndex: o
      }))), styleChanged(M, d) && g(p, f - 1, C.loop, d), k = _, d = M;
    }
    p < f - 1 && g(p, f - 1, C.loop, d);
  }
  return u;
}
function readStyle(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function styleChanged(e, t) {
  if (!t)
    return !1;
  const n = [], s = function(i, a) {
    return isPatternOrGradient(a) ? (n.includes(a) || n.push(a), n.indexOf(a)) : a;
  };
  return JSON.stringify(e, s) !== JSON.stringify(t, s);
}
/*!
 * Chart.js v4.3.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class Animator {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, s, i) {
    const a = n.listeners[i], o = n.duration;
    a.forEach((l) => l({
      chart: t,
      initial: n.initial,
      numSteps: o,
      currentStep: Math.min(s - n.start, o)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = requestAnimFrame.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((s, i) => {
      if (!s.running || !s.items.length)
        return;
      const a = s.items;
      let o = a.length - 1, l = !1, c;
      for (; o >= 0; --o)
        c = a[o], c._active ? (c._total > s.duration && (s.duration = c._total), c.tick(t), l = !0) : (a[o] = a[a.length - 1], a.pop());
      l && (i.draw(), this._notify(i, s, t, "progress")), a.length || (s.running = !1, this._notify(i, s, t, "complete"), s.initial = !1), n += a.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let s = n.get(t);
    return s || (s = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, s)), s;
  }
  listen(t, n, s) {
    this._getAnims(t).listeners[n].push(s);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((s, i) => Math.max(s, i._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const s = n.items;
    let i = s.length - 1;
    for (; i >= 0; --i)
      s[i].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var animator = /* @__PURE__ */ new Animator();
const transparent = "transparent", interpolators = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const s = color(e || transparent), i = s.valid && color(t || transparent);
    return i && i.valid ? i.mix(s, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
class Animation {
  constructor(t, n, s, i) {
    const a = n[s];
    i = resolve([
      t.to,
      i,
      a,
      t.from
    ]);
    const o = resolve([
      t.from,
      a,
      i
    ]);
    this._active = !0, this._fn = t.fn || interpolators[t.type || typeof o], this._easing = effects[t.easing] || effects.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = s, this._from = o, this._to = i, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, s) {
    if (this._active) {
      this._notify(!1);
      const i = this._target[this._prop], a = s - this._start, o = this._duration - a;
      this._start = s, this._duration = Math.floor(Math.max(o, t.duration)), this._total += a, this._loop = !!t.loop, this._to = resolve([
        t.to,
        n,
        i,
        t.from
      ]), this._from = resolve([
        t.from,
        i,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, s = this._duration, i = this._prop, a = this._from, o = this._loop, l = this._to;
    let c;
    if (this._active = a !== l && (o || n < s), !this._active) {
      this._target[i] = l, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[i] = a;
      return;
    }
    c = n / s % 2, c = o && c > 1 ? 2 - c : c, c = this._easing(Math.min(1, Math.max(0, c))), this._target[i] = this._fn(a, l, c);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, s) => {
      t.push({
        res: n,
        rej: s
      });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", s = this._promises || [];
    for (let i = 0; i < s.length; i++)
      s[i][n]();
  }
}
class Animations {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!isObject(t))
      return;
    const n = Object.keys(defaults.animation), s = this._properties;
    Object.getOwnPropertyNames(t).forEach((i) => {
      const a = t[i];
      if (!isObject(a))
        return;
      const o = {};
      for (const l of n)
        o[l] = a[l];
      (isArray(a.properties) && a.properties || [
        i
      ]).forEach((l) => {
        (l === i || !s.has(l)) && s.set(l, o);
      });
    });
  }
  _animateOptions(t, n) {
    const s = n.options, i = resolveTargetOptions(t, s);
    if (!i)
      return [];
    const a = this._createAnimations(i, s);
    return s.$shared && awaitAll(t.options.$animations, s).then(() => {
      t.options = s;
    }, () => {
    }), a;
  }
  _createAnimations(t, n) {
    const s = this._properties, i = [], a = t.$animations || (t.$animations = {}), o = Object.keys(n), l = Date.now();
    let c;
    for (c = o.length - 1; c >= 0; --c) {
      const u = o[c];
      if (u.charAt(0) === "$")
        continue;
      if (u === "options") {
        i.push(...this._animateOptions(t, n));
        continue;
      }
      const d = n[u];
      let p = a[u];
      const f = s.get(u);
      if (p)
        if (f && p.active()) {
          p.update(f, d, l);
          continue;
        } else
          p.cancel();
      if (!f || !f.duration) {
        t[u] = d;
        continue;
      }
      a[u] = p = new Animation(f, t, u, d), i.push(p);
    }
    return i;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const s = this._createAnimations(t, n);
    if (s.length)
      return animator.add(this._chart, s), !0;
  }
}
function awaitAll(e, t) {
  const n = [], s = Object.keys(t);
  for (let i = 0; i < s.length; i++) {
    const a = e[s[i]];
    a && a.active() && n.push(a.wait());
  }
  return Promise.all(n);
}
function resolveTargetOptions(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function scaleClip(e, t) {
  const n = e && e.options || {}, s = n.reverse, i = n.min === void 0 ? t : 0, a = n.max === void 0 ? t : 0;
  return {
    start: s ? a : i,
    end: s ? i : a
  };
}
function defaultClip(e, t, n) {
  if (n === !1)
    return !1;
  const s = scaleClip(e, n), i = scaleClip(t, n);
  return {
    top: i.end,
    right: s.end,
    bottom: i.start,
    left: s.start
  };
}
function toClip(e) {
  let t, n, s, i;
  return isObject(e) ? (t = e.top, n = e.right, s = e.bottom, i = e.left) : t = n = s = i = e, {
    top: t,
    right: n,
    bottom: s,
    left: i,
    disabled: e === !1
  };
}
function getSortedDatasetIndices(e, t) {
  const n = [], s = e._getSortedDatasetMetas(t);
  let i, a;
  for (i = 0, a = s.length; i < a; ++i)
    n.push(s[i].index);
  return n;
}
function applyStack(e, t, n, s = {}) {
  const i = e.keys, a = s.mode === "single";
  let o, l, c, u;
  if (t !== null) {
    for (o = 0, l = i.length; o < l; ++o) {
      if (c = +i[o], c === n) {
        if (s.all)
          continue;
        break;
      }
      u = e.values[c], isNumberFinite(u) && (a || t === 0 || sign(t) === sign(u)) && (t += u);
    }
    return t;
  }
}
function convertObjectDataToArray(e) {
  const t = Object.keys(e), n = new Array(t.length);
  let s, i, a;
  for (s = 0, i = t.length; s < i; ++s)
    a = t[s], n[s] = {
      x: a,
      y: e[a]
    };
  return n;
}
function isStacked(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function getStackKey(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function getUserBounds(e) {
  const { min: t, max: n, minDefined: s, maxDefined: i } = e.getUserBounds();
  return {
    min: s ? t : Number.NEGATIVE_INFINITY,
    max: i ? n : Number.POSITIVE_INFINITY
  };
}
function getOrCreateStack(e, t, n) {
  const s = e[t] || (e[t] = {});
  return s[n] || (s[n] = {});
}
function getLastIndexInStack(e, t, n, s) {
  for (const i of t.getMatchingVisibleMetas(s).reverse()) {
    const a = e[i.index];
    if (n && a > 0 || !n && a < 0)
      return i.index;
  }
  return null;
}
function updateStacks(e, t) {
  const { chart: n, _cachedMeta: s } = e, i = n._stacks || (n._stacks = {}), { iScale: a, vScale: o, index: l } = s, c = a.axis, u = o.axis, d = getStackKey(a, o, s), p = t.length;
  let f;
  for (let g = 0; g < p; ++g) {
    const C = t[g], { [c]: k, [u]: M } = C, _ = C._stacks || (C._stacks = {});
    f = _[u] = getOrCreateStack(i, d, k), f[l] = M, f._top = getLastIndexInStack(f, o, !0, s.type), f._bottom = getLastIndexInStack(f, o, !1, s.type);
    const S = f._visualValues || (f._visualValues = {});
    S[l] = M;
  }
}
function getFirstScaleId(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((s) => n[s].axis === t).shift();
}
function createDatasetContext(e, t) {
  return createContext(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function createDataContext(e, t, n) {
  return createContext(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function clearStacks(e, t) {
  const n = e.controller.index, s = e.vScale && e.vScale.axis;
  if (s) {
    t = t || e._parsed;
    for (const i of t) {
      const a = i._stacks;
      if (!a || a[s] === void 0 || a[s][n] === void 0)
        return;
      delete a[s][n], a[s]._visualValues !== void 0 && a[s]._visualValues[n] !== void 0 && delete a[s]._visualValues[n];
    }
  }
}
const isDirectUpdateMode = (e) => e === "reset" || e === "none", cloneIfNotShared = (e, t) => t ? e : Object.assign({}, e), createStack = (e, t, n) => e && !t.hidden && t._stacked && {
  keys: getSortedDatasetIndices(n, !0),
  values: null
};
class DatasetController {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = isStacked(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && clearStacks(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, s = this.getDataset(), i = (p, f, g, C) => p === "x" ? f : p === "r" ? C : g, a = n.xAxisID = valueOrDefault(s.xAxisID, getFirstScaleId(t, "x")), o = n.yAxisID = valueOrDefault(s.yAxisID, getFirstScaleId(t, "y")), l = n.rAxisID = valueOrDefault(s.rAxisID, getFirstScaleId(t, "r")), c = n.indexAxis, u = n.iAxisID = i(c, a, o, l), d = n.vAxisID = i(c, o, a, l);
    n.xScale = this.getScaleForId(a), n.yScale = this.getScaleForId(o), n.rScale = this.getScaleForId(l), n.iScale = this.getScaleForId(u), n.vScale = this.getScaleForId(d);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && unlistenArrayEvents(this._data, this), t._stacked && clearStacks(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), s = this._data;
    if (isObject(n))
      this._data = convertObjectDataToArray(n);
    else if (s !== n) {
      if (s) {
        unlistenArrayEvents(s, this);
        const i = this._cachedMeta;
        clearStacks(i), i._parsed = [];
      }
      n && Object.isExtensible(n) && listenArrayEvents(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, s = this.getDataset();
    let i = !1;
    this._dataCheck();
    const a = n._stacked;
    n._stacked = isStacked(n.vScale, n), n.stack !== s.stack && (i = !0, clearStacks(n), n.stack = s.stack), this._resyncElements(t), (i || a !== n._stacked) && updateStacks(this, n._parsed);
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), s = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(s, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: s, _data: i } = this, { iScale: a, _stacked: o } = s, l = a.axis;
    let c = t === 0 && n === i.length ? !0 : s._sorted, u = t > 0 && s._parsed[t - 1], d, p, f;
    if (this._parsing === !1)
      s._parsed = i, s._sorted = !0, f = i;
    else {
      isArray(i[t]) ? f = this.parseArrayData(s, i, t, n) : isObject(i[t]) ? f = this.parseObjectData(s, i, t, n) : f = this.parsePrimitiveData(s, i, t, n);
      const g = () => p[l] === null || u && p[l] < u[l];
      for (d = 0; d < n; ++d)
        s._parsed[d + t] = p = f[d], c && (g() && (c = !1), u = p);
      s._sorted = c;
    }
    o && updateStacks(this, f);
  }
  parsePrimitiveData(t, n, s, i) {
    const { iScale: a, vScale: o } = t, l = a.axis, c = o.axis, u = a.getLabels(), d = a === o, p = new Array(i);
    let f, g, C;
    for (f = 0, g = i; f < g; ++f)
      C = f + s, p[f] = {
        [l]: d || a.parse(u[C], C),
        [c]: o.parse(n[C], C)
      };
    return p;
  }
  parseArrayData(t, n, s, i) {
    const { xScale: a, yScale: o } = t, l = new Array(i);
    let c, u, d, p;
    for (c = 0, u = i; c < u; ++c)
      d = c + s, p = n[d], l[c] = {
        x: a.parse(p[0], d),
        y: o.parse(p[1], d)
      };
    return l;
  }
  parseObjectData(t, n, s, i) {
    const { xScale: a, yScale: o } = t, { xAxisKey: l = "x", yAxisKey: c = "y" } = this._parsing, u = new Array(i);
    let d, p, f, g;
    for (d = 0, p = i; d < p; ++d)
      f = d + s, g = n[f], u[d] = {
        x: a.parse(resolveObjectKey(g, l), f),
        y: o.parse(resolveObjectKey(g, c), f)
      };
    return u;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, s) {
    const i = this.chart, a = this._cachedMeta, o = n[t.axis], l = {
      keys: getSortedDatasetIndices(i, !0),
      values: n._stacks[t.axis]._visualValues
    };
    return applyStack(l, o, a.index, {
      mode: s
    });
  }
  updateRangeFromParsed(t, n, s, i) {
    const a = s[n.axis];
    let o = a === null ? NaN : a;
    const l = i && s._stacks[n.axis];
    i && l && (i.values = l, o = applyStack(i, a, this._cachedMeta.index)), t.min = Math.min(t.min, o), t.max = Math.max(t.max, o);
  }
  getMinMax(t, n) {
    const s = this._cachedMeta, i = s._parsed, a = s._sorted && t === s.iScale, o = i.length, l = this._getOtherScale(t), c = createStack(n, s, this.chart), u = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: d, max: p } = getUserBounds(l);
    let f, g;
    function C() {
      g = i[f];
      const k = g[l.axis];
      return !isNumberFinite(g[t.axis]) || d > k || p < k;
    }
    for (f = 0; f < o && !(!C() && (this.updateRangeFromParsed(u, t, g, c), a)); ++f)
      ;
    if (a) {
      for (f = o - 1; f >= 0; --f)
        if (!C()) {
          this.updateRangeFromParsed(u, t, g, c);
          break;
        }
    }
    return u;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, s = [];
    let i, a, o;
    for (i = 0, a = n.length; i < a; ++i)
      o = n[i][t.axis], isNumberFinite(o) && s.push(o);
    return s;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, s = n.iScale, i = n.vScale, a = this.getParsed(t);
    return {
      label: s ? "" + s.getLabelForValue(a[s.axis]) : "",
      value: i ? "" + i.getLabelForValue(a[i.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = toClip(valueOrDefault(this.options.clip, defaultClip(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, s = this._cachedMeta, i = s.data || [], a = n.chartArea, o = [], l = this._drawStart || 0, c = this._drawCount || i.length - l, u = this.options.drawActiveElementsOnTop;
    let d;
    for (s.dataset && s.dataset.draw(t, a, l, c), d = l; d < l + c; ++d) {
      const p = i[d];
      p.hidden || (p.active && u ? o.push(p) : p.draw(t, a));
    }
    for (d = 0; d < o.length; ++d)
      o[d].draw(t, a);
  }
  getStyle(t, n) {
    const s = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(s) : this.resolveDataElementOptions(t || 0, s);
  }
  getContext(t, n, s) {
    const i = this.getDataset();
    let a;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const o = this._cachedMeta.data[t];
      a = o.$context || (o.$context = createDataContext(this.getContext(), t, o)), a.parsed = this.getParsed(t), a.raw = i.data[t], a.index = a.dataIndex = t;
    } else
      a = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index)), a.dataset = i, a.index = a.datasetIndex = this.index;
    return a.active = !!n, a.mode = s, a;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", s) {
    const i = n === "active", a = this._cachedDataOpts, o = t + "-" + n, l = a[o], c = this.enableOptionSharing && defined(s);
    if (l)
      return cloneIfNotShared(l, c);
    const u = this.chart.config, d = u.datasetElementScopeKeys(this._type, t), p = i ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], f = u.getOptionScopes(this.getDataset(), d), g = Object.keys(defaults.elements[t]), C = () => this.getContext(s, i, n), k = u.resolveNamedOptions(f, g, C, p);
    return k.$shared && (k.$shared = c, a[o] = Object.freeze(cloneIfNotShared(k, c))), k;
  }
  _resolveAnimations(t, n, s) {
    const i = this.chart, a = this._cachedDataOpts, o = `animation-${n}`, l = a[o];
    if (l)
      return l;
    let c;
    if (i.options.animation !== !1) {
      const d = this.chart.config, p = d.datasetAnimationScopeKeys(this._type, n), f = d.getOptionScopes(this.getDataset(), p);
      c = d.createResolver(f, this.getContext(t, s, n));
    }
    const u = new Animations(i, c && c.animations);
    return c && c._cacheable && (a[o] = Object.freeze(u)), u;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || isDirectUpdateMode(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const s = this.resolveDataElementOptions(t, n), i = this._sharedOptions, a = this.getSharedOptions(s), o = this.includeOptions(n, a) || a !== i;
    return this.updateSharedOptions(a, n, s), {
      sharedOptions: a,
      includeOptions: o
    };
  }
  updateElement(t, n, s, i) {
    isDirectUpdateMode(i) ? Object.assign(t, s) : this._resolveAnimations(n, i).update(t, s);
  }
  updateSharedOptions(t, n, s) {
    t && !isDirectUpdateMode(n) && this._resolveAnimations(void 0, n).update(t, s);
  }
  _setStyle(t, n, s, i) {
    t.active = i;
    const a = this.getStyle(n, i);
    this._resolveAnimations(n, s, i).update(t, {
      options: !i && this.getSharedOptions(a) || a
    });
  }
  removeHoverStyle(t, n, s) {
    this._setStyle(t, s, "active", !1);
  }
  setHoverStyle(t, n, s) {
    this._setStyle(t, s, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, s = this._cachedMeta.data;
    for (const [l, c, u] of this._syncList)
      this[l](c, u);
    this._syncList = [];
    const i = s.length, a = n.length, o = Math.min(a, i);
    o && this.parse(0, o), a > i ? this._insertElements(i, a - i, t) : a < i && this._removeElements(a, i - a);
  }
  _insertElements(t, n, s = !0) {
    const i = this._cachedMeta, a = i.data, o = t + n;
    let l;
    const c = (u) => {
      for (u.length += n, l = u.length - 1; l >= o; l--)
        u[l] = u[l - n];
    };
    for (c(a), l = t; l < o; ++l)
      a[l] = new this.dataElementType();
    this._parsing && c(i._parsed), this.parse(t, n), s && this.updateElements(a, t, n, "reset");
  }
  updateElements(t, n, s, i) {
  }
  _removeElements(t, n) {
    const s = this._cachedMeta;
    if (this._parsing) {
      const i = s._parsed.splice(t, n);
      s._stacked && clearStacks(s, i);
    }
    s.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, s, i] = t;
      this[n](s, i);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, n) {
    n && this._sync([
      "_removeElements",
      t,
      n
    ]);
    const s = arguments.length - 2;
    s && this._sync([
      "_insertElements",
      t,
      s
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
pe(DatasetController, "defaults", {}), pe(DatasetController, "datasetElementType", null), pe(DatasetController, "dataElementType", null);
class LineController extends DatasetController {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: s, data: i = [], _dataset: a } = n, o = this.chart._animationsDisabled;
    let { start: l, count: c } = _getStartAndCountOfVisiblePoints(n, i, o);
    this._drawStart = l, this._drawCount = c, _scaleRangesChanged(n) && (l = 0, c = i.length), s._chart = this.chart, s._datasetIndex = this.index, s._decimated = !!a._decimated, s.points = i;
    const u = this.resolveDatasetElementOptions(t);
    this.options.showLine || (u.borderWidth = 0), u.segment = this.options.segment, this.updateElement(s, void 0, {
      animated: !o,
      options: u
    }, t), this.updateElements(i, l, c, t);
  }
  updateElements(t, n, s, i) {
    const a = i === "reset", { iScale: o, vScale: l, _stacked: c, _dataset: u } = this._cachedMeta, { sharedOptions: d, includeOptions: p } = this._getSharedOptions(n, i), f = o.axis, g = l.axis, { spanGaps: C, segment: k } = this.options, M = isNumber(C) ? C : Number.POSITIVE_INFINITY, _ = this.chart._animationsDisabled || a || i === "none", S = n + s, E = t.length;
    let P = n > 0 && this.getParsed(n - 1);
    for (let $ = 0; $ < E; ++$) {
      const A = t[$], I = _ ? A : {};
      if ($ < n || $ >= S) {
        I.skip = !0;
        continue;
      }
      const D = this.getParsed($), R = isNullOrUndef(D[g]), Y = I[f] = o.getPixelForValue(D[f], $), q = I[g] = a || R ? l.getBasePixel() : l.getPixelForValue(c ? this.applyStack(l, D, c) : D[g], $);
      I.skip = isNaN(Y) || isNaN(q) || R, I.stop = $ > 0 && Math.abs(D[f] - P[f]) > M, k && (I.parsed = D, I.raw = u.data[$]), p && (I.options = d || this.resolveDataElementOptions($, A.active ? "active" : i)), _ || this.updateElement(A, $, I, i), P = D;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, s = n.options && n.options.borderWidth || 0, i = t.data || [];
    if (!i.length)
      return s;
    const a = i[0].size(this.resolveDataElementOptions(0)), o = i[i.length - 1].size(this.resolveDataElementOptions(i.length - 1));
    return Math.max(s, a, o) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
pe(LineController, "id", "line"), pe(LineController, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), pe(LineController, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
function abstract() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class DateAdapterBase {
  constructor(t) {
    pe(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(DateAdapterBase.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return abstract();
  }
  parse() {
    return abstract();
  }
  format() {
    return abstract();
  }
  add() {
    return abstract();
  }
  diff() {
    return abstract();
  }
  startOf() {
    return abstract();
  }
  endOf() {
    return abstract();
  }
}
var adapters = {
  _date: DateAdapterBase
};
function binarySearch(e, t, n, s) {
  const { controller: i, data: a, _sorted: o } = e, l = i._cachedMeta.iScale;
  if (l && t === l.axis && t !== "r" && o && a.length) {
    const c = l._reversePixels ? _rlookupByKey : _lookupByKey;
    if (s) {
      if (i._sharedOptions) {
        const u = a[0], d = typeof u.getRange == "function" && u.getRange(t);
        if (d) {
          const p = c(a, t, n - d), f = c(a, t, n + d);
          return {
            lo: p.lo,
            hi: f.hi
          };
        }
      }
    } else
      return c(a, t, n);
  }
  return {
    lo: 0,
    hi: a.length - 1
  };
}
function evaluateInteractionItems(e, t, n, s, i) {
  const a = e.getSortedVisibleDatasetMetas(), o = n[t];
  for (let l = 0, c = a.length; l < c; ++l) {
    const { index: u, data: d } = a[l], { lo: p, hi: f } = binarySearch(a[l], t, o, i);
    for (let g = p; g <= f; ++g) {
      const C = d[g];
      C.skip || s(C, u, g);
    }
  }
}
function getDistanceMetricForAxis(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(s, i) {
    const a = t ? Math.abs(s.x - i.x) : 0, o = n ? Math.abs(s.y - i.y) : 0;
    return Math.sqrt(Math.pow(a, 2) + Math.pow(o, 2));
  };
}
function getIntersectItems(e, t, n, s, i) {
  const a = [];
  return !i && !e.isPointInArea(t) || evaluateInteractionItems(e, n, t, function(l, c, u) {
    !i && !_isPointInArea(l, e.chartArea, 0) || l.inRange(t.x, t.y, s) && a.push({
      element: l,
      datasetIndex: c,
      index: u
    });
  }, !0), a;
}
function getNearestRadialItems(e, t, n, s) {
  let i = [];
  function a(o, l, c) {
    const { startAngle: u, endAngle: d } = o.getProps([
      "startAngle",
      "endAngle"
    ], s), { angle: p } = getAngleFromPoint(o, {
      x: t.x,
      y: t.y
    });
    _angleBetween(p, u, d) && i.push({
      element: o,
      datasetIndex: l,
      index: c
    });
  }
  return evaluateInteractionItems(e, n, t, a), i;
}
function getNearestCartesianItems(e, t, n, s, i, a) {
  let o = [];
  const l = getDistanceMetricForAxis(n);
  let c = Number.POSITIVE_INFINITY;
  function u(d, p, f) {
    const g = d.inRange(t.x, t.y, i);
    if (s && !g)
      return;
    const C = d.getCenterPoint(i);
    if (!(!!a || e.isPointInArea(C)) && !g)
      return;
    const M = l(t, C);
    M < c ? (o = [
      {
        element: d,
        datasetIndex: p,
        index: f
      }
    ], c = M) : M === c && o.push({
      element: d,
      datasetIndex: p,
      index: f
    });
  }
  return evaluateInteractionItems(e, n, t, u), o;
}
function getNearestItems(e, t, n, s, i, a) {
  return !a && !e.isPointInArea(t) ? [] : n === "r" && !s ? getNearestRadialItems(e, t, n, i) : getNearestCartesianItems(e, t, n, s, i, a);
}
function getAxisItems(e, t, n, s, i) {
  const a = [], o = n === "x" ? "inXRange" : "inYRange";
  let l = !1;
  return evaluateInteractionItems(e, n, t, (c, u, d) => {
    c[o](t[n], i) && (a.push({
      element: c,
      datasetIndex: u,
      index: d
    }), l = l || c.inRange(t.x, t.y, i));
  }), s && !l ? [] : a;
}
var Interaction = {
  evaluateInteractionItems,
  modes: {
    index(e, t, n, s) {
      const i = getRelativePosition(t, e), a = n.axis || "x", o = n.includeInvisible || !1, l = n.intersect ? getIntersectItems(e, i, a, s, o) : getNearestItems(e, i, a, !1, s, o), c = [];
      return l.length ? (e.getSortedVisibleDatasetMetas().forEach((u) => {
        const d = l[0].index, p = u.data[d];
        p && !p.skip && c.push({
          element: p,
          datasetIndex: u.index,
          index: d
        });
      }), c) : [];
    },
    dataset(e, t, n, s) {
      const i = getRelativePosition(t, e), a = n.axis || "xy", o = n.includeInvisible || !1;
      let l = n.intersect ? getIntersectItems(e, i, a, s, o) : getNearestItems(e, i, a, !1, s, o);
      if (l.length > 0) {
        const c = l[0].datasetIndex, u = e.getDatasetMeta(c).data;
        l = [];
        for (let d = 0; d < u.length; ++d)
          l.push({
            element: u[d],
            datasetIndex: c,
            index: d
          });
      }
      return l;
    },
    point(e, t, n, s) {
      const i = getRelativePosition(t, e), a = n.axis || "xy", o = n.includeInvisible || !1;
      return getIntersectItems(e, i, a, s, o);
    },
    nearest(e, t, n, s) {
      const i = getRelativePosition(t, e), a = n.axis || "xy", o = n.includeInvisible || !1;
      return getNearestItems(e, i, a, n.intersect, s, o);
    },
    x(e, t, n, s) {
      const i = getRelativePosition(t, e);
      return getAxisItems(e, i, "x", n.intersect, s);
    },
    y(e, t, n, s) {
      const i = getRelativePosition(t, e);
      return getAxisItems(e, i, "y", n.intersect, s);
    }
  }
};
const STATIC_POSITIONS = [
  "left",
  "top",
  "right",
  "bottom"
];
function filterByPosition(e, t) {
  return e.filter((n) => n.pos === t);
}
function filterDynamicPositionByAxis(e, t) {
  return e.filter((n) => STATIC_POSITIONS.indexOf(n.pos) === -1 && n.box.axis === t);
}
function sortByWeight(e, t) {
  return e.sort((n, s) => {
    const i = t ? s : n, a = t ? n : s;
    return i.weight === a.weight ? i.index - a.index : i.weight - a.weight;
  });
}
function wrapBoxes(e) {
  const t = [];
  let n, s, i, a, o, l;
  for (n = 0, s = (e || []).length; n < s; ++n)
    i = e[n], { position: a, options: { stack: o, stackWeight: l = 1 } } = i, t.push({
      index: n,
      box: i,
      pos: a,
      horizontal: i.isHorizontal(),
      weight: i.weight,
      stack: o && a + o,
      stackWeight: l
    });
  return t;
}
function buildStacks(e) {
  const t = {};
  for (const n of e) {
    const { stack: s, pos: i, stackWeight: a } = n;
    if (!s || !STATIC_POSITIONS.includes(i))
      continue;
    const o = t[s] || (t[s] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    o.count++, o.weight += a;
  }
  return t;
}
function setLayoutDims(e, t) {
  const n = buildStacks(e), { vBoxMaxWidth: s, hBoxMaxHeight: i } = t;
  let a, o, l;
  for (a = 0, o = e.length; a < o; ++a) {
    l = e[a];
    const { fullSize: c } = l.box, u = n[l.stack], d = u && l.stackWeight / u.weight;
    l.horizontal ? (l.width = d ? d * s : c && t.availableWidth, l.height = i) : (l.width = s, l.height = d ? d * i : c && t.availableHeight);
  }
  return n;
}
function buildLayoutBoxes(e) {
  const t = wrapBoxes(e), n = sortByWeight(t.filter((u) => u.box.fullSize), !0), s = sortByWeight(filterByPosition(t, "left"), !0), i = sortByWeight(filterByPosition(t, "right")), a = sortByWeight(filterByPosition(t, "top"), !0), o = sortByWeight(filterByPosition(t, "bottom")), l = filterDynamicPositionByAxis(t, "x"), c = filterDynamicPositionByAxis(t, "y");
  return {
    fullSize: n,
    leftAndTop: s.concat(a),
    rightAndBottom: i.concat(c).concat(o).concat(l),
    chartArea: filterByPosition(t, "chartArea"),
    vertical: s.concat(i).concat(c),
    horizontal: a.concat(o).concat(l)
  };
}
function getCombinedMax(e, t, n, s) {
  return Math.max(e[n], t[n]) + Math.max(e[s], t[s]);
}
function updateMaxPadding(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function updateDims(e, t, n, s) {
  const { pos: i, box: a } = n, o = e.maxPadding;
  if (!isObject(i)) {
    n.size && (e[i] -= n.size);
    const p = s[n.stack] || {
      size: 0,
      count: 1
    };
    p.size = Math.max(p.size, n.horizontal ? a.height : a.width), n.size = p.size / p.count, e[i] += n.size;
  }
  a.getPadding && updateMaxPadding(o, a.getPadding());
  const l = Math.max(0, t.outerWidth - getCombinedMax(o, e, "left", "right")), c = Math.max(0, t.outerHeight - getCombinedMax(o, e, "top", "bottom")), u = l !== e.w, d = c !== e.h;
  return e.w = l, e.h = c, n.horizontal ? {
    same: u,
    other: d
  } : {
    same: d,
    other: u
  };
}
function handleMaxPadding(e) {
  const t = e.maxPadding;
  function n(s) {
    const i = Math.max(t[s] - e[s], 0);
    return e[s] += i, i;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function getMargins(e, t) {
  const n = t.maxPadding;
  function s(i) {
    const a = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return i.forEach((o) => {
      a[o] = Math.max(t[o], n[o]);
    }), a;
  }
  return s(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function fitBoxes(e, t, n, s) {
  const i = [];
  let a, o, l, c, u, d;
  for (a = 0, o = e.length, u = 0; a < o; ++a) {
    l = e[a], c = l.box, c.update(l.width || t.w, l.height || t.h, getMargins(l.horizontal, t));
    const { same: p, other: f } = updateDims(t, n, l, s);
    u |= p && i.length, d = d || f, c.fullSize || i.push(l);
  }
  return u && fitBoxes(i, t, n, s) || d;
}
function setBoxDims(e, t, n, s, i) {
  e.top = n, e.left = t, e.right = t + s, e.bottom = n + i, e.width = s, e.height = i;
}
function placeBoxes(e, t, n, s) {
  const i = n.padding;
  let { x: a, y: o } = t;
  for (const l of e) {
    const c = l.box, u = s[l.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, d = l.stackWeight / u.weight || 1;
    if (l.horizontal) {
      const p = t.w * d, f = u.size || c.height;
      defined(u.start) && (o = u.start), c.fullSize ? setBoxDims(c, i.left, o, n.outerWidth - i.right - i.left, f) : setBoxDims(c, t.left + u.placed, o, p, f), u.start = o, u.placed += p, o = c.bottom;
    } else {
      const p = t.h * d, f = u.size || c.width;
      defined(u.start) && (a = u.start), c.fullSize ? setBoxDims(c, a, i.top, f, n.outerHeight - i.bottom - i.top) : setBoxDims(c, a, t.top + u.placed, f, p), u.start = a, u.placed += p, a = c.right;
    }
  }
  t.x = a, t.y = o;
}
var layouts = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            t.draw(n);
          }
        }
      ];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, s) {
    if (!e)
      return;
    const i = toPadding(e.options.layout.padding), a = Math.max(t - i.width, 0), o = Math.max(n - i.height, 0), l = buildLayoutBoxes(e.boxes), c = l.vertical, u = l.horizontal;
    each(e.boxes, (k) => {
      typeof k.beforeLayout == "function" && k.beforeLayout();
    });
    const d = c.reduce((k, M) => M.box.options && M.box.options.display === !1 ? k : k + 1, 0) || 1, p = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: i,
      availableWidth: a,
      availableHeight: o,
      vBoxMaxWidth: a / 2 / d,
      hBoxMaxHeight: o / 2
    }), f = Object.assign({}, i);
    updateMaxPadding(f, toPadding(s));
    const g = Object.assign({
      maxPadding: f,
      w: a,
      h: o,
      x: i.left,
      y: i.top
    }, i), C = setLayoutDims(c.concat(u), p);
    fitBoxes(l.fullSize, g, p, C), fitBoxes(c, g, p, C), fitBoxes(u, g, p, C) && fitBoxes(c, g, p, C), handleMaxPadding(g), placeBoxes(l.leftAndTop, g, p, C), g.x += g.w, g.y += g.h, placeBoxes(l.rightAndBottom, g, p, C), e.chartArea = {
      left: g.left,
      top: g.top,
      right: g.left + g.w,
      bottom: g.top + g.h,
      height: g.h,
      width: g.w
    }, each(l.chartArea, (k) => {
      const M = k.box;
      Object.assign(M, e.chartArea), M.update(g.w, g.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class BasePlatform {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, s) {
  }
  removeEventListener(t, n, s) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, s, i) {
    return n = Math.max(0, n || t.width), s = s || t.height, {
      width: n,
      height: Math.max(0, i ? Math.floor(n / i) : s)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class BasicPlatform extends BasePlatform {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const EXPANDO_KEY = "$chartjs", EVENT_TYPES = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, isNullOrEmpty = (e) => e === null || e === "";
function initCanvas(e, t) {
  const n = e.style, s = e.getAttribute("height"), i = e.getAttribute("width");
  if (e[EXPANDO_KEY] = {
    initial: {
      height: s,
      width: i,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", isNullOrEmpty(i)) {
    const a = readUsedSize(e, "width");
    a !== void 0 && (e.width = a);
  }
  if (isNullOrEmpty(s))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const a = readUsedSize(e, "height");
      a !== void 0 && (e.height = a);
    }
  return e;
}
const eventListenerOptions = supportsEventListenerOptions ? {
  passive: !0
} : !1;
function addListener(e, t, n) {
  e.addEventListener(t, n, eventListenerOptions);
}
function removeListener(e, t, n) {
  e.canvas.removeEventListener(t, n, eventListenerOptions);
}
function fromNativeEvent(e, t) {
  const n = EVENT_TYPES[e.type] || e.type, { x: s, y: i } = getRelativePosition(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: s !== void 0 ? s : null,
    y: i !== void 0 ? i : null
  };
}
function nodeListContains(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function createAttachObserver(e, t, n) {
  const s = e.canvas, i = new MutationObserver((a) => {
    let o = !1;
    for (const l of a)
      o = o || nodeListContains(l.addedNodes, s), o = o && !nodeListContains(l.removedNodes, s);
    o && n();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
function createDetachObserver(e, t, n) {
  const s = e.canvas, i = new MutationObserver((a) => {
    let o = !1;
    for (const l of a)
      o = o || nodeListContains(l.removedNodes, s), o = o && !nodeListContains(l.addedNodes, s);
    o && n();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
const drpListeningCharts = /* @__PURE__ */ new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
  const e = window.devicePixelRatio;
  e !== oldDevicePixelRatio && (oldDevicePixelRatio = e, drpListeningCharts.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function listenDevicePixelRatioChanges(e, t) {
  drpListeningCharts.size || window.addEventListener("resize", onWindowResize), drpListeningCharts.set(e, t);
}
function unlistenDevicePixelRatioChanges(e) {
  drpListeningCharts.delete(e), drpListeningCharts.size || window.removeEventListener("resize", onWindowResize);
}
function createResizeObserver(e, t, n) {
  const s = e.canvas, i = s && _getParentNode(s);
  if (!i)
    return;
  const a = throttled((l, c) => {
    const u = i.clientWidth;
    n(l, c), u < i.clientWidth && n();
  }, window), o = new ResizeObserver((l) => {
    const c = l[0], u = c.contentRect.width, d = c.contentRect.height;
    u === 0 && d === 0 || a(u, d);
  });
  return o.observe(i), listenDevicePixelRatioChanges(e, a), o;
}
function releaseObserver(e, t, n) {
  n && n.disconnect(), t === "resize" && unlistenDevicePixelRatioChanges(e);
}
function createProxyAndListen(e, t, n) {
  const s = e.canvas, i = throttled((a) => {
    e.ctx !== null && n(fromNativeEvent(a, e));
  }, e);
  return addListener(s, t, i), i;
}
class DomPlatform extends BasePlatform {
  acquireContext(t, n) {
    const s = t && t.getContext && t.getContext("2d");
    return s && s.canvas === t ? (initCanvas(t, n), s) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[EXPANDO_KEY])
      return !1;
    const s = n[EXPANDO_KEY].initial;
    [
      "height",
      "width"
    ].forEach((a) => {
      const o = s[a];
      isNullOrUndef(o) ? n.removeAttribute(a) : n.setAttribute(a, o);
    });
    const i = s.style || {};
    return Object.keys(i).forEach((a) => {
      n.style[a] = i[a];
    }), n.width = n.width, delete n[EXPANDO_KEY], !0;
  }
  addEventListener(t, n, s) {
    this.removeEventListener(t, n);
    const i = t.$proxies || (t.$proxies = {}), o = {
      attach: createAttachObserver,
      detach: createDetachObserver,
      resize: createResizeObserver
    }[n] || createProxyAndListen;
    i[n] = o(t, n, s);
  }
  removeEventListener(t, n) {
    const s = t.$proxies || (t.$proxies = {}), i = s[n];
    if (!i)
      return;
    ({
      attach: releaseObserver,
      detach: releaseObserver,
      resize: releaseObserver
    }[n] || removeListener)(t, n, i), s[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, s, i) {
    return getMaximumSize(t, n, s, i);
  }
  isAttached(t) {
    const n = _getParentNode(t);
    return !!(n && n.isConnected);
  }
}
function _detectPlatform(e) {
  return !_isDomSupported() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? BasicPlatform : DomPlatform;
}
var Ke;
let Element$1 = (Ke = class {
  constructor() {
    pe(this, "x");
    pe(this, "y");
    pe(this, "active", !1);
    pe(this, "options");
    pe(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: n, y: s } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: n,
      y: s
    };
  }
  hasValue() {
    return isNumber(this.x) && isNumber(this.y);
  }
  getProps(t, n) {
    const s = this.$animations;
    if (!n || !s)
      return this;
    const i = {};
    return t.forEach((a) => {
      i[a] = s[a] && s[a].active() ? s[a]._to : this[a];
    }), i;
  }
}, pe(Ke, "defaults", {}), pe(Ke, "defaultRoutes"), Ke);
function autoSkip(e, t) {
  const n = e.options.ticks, s = determineMaxTicks(e), i = Math.min(n.maxTicksLimit || s, s), a = n.major.enabled ? getMajorIndices(t) : [], o = a.length, l = a[0], c = a[o - 1], u = [];
  if (o > i)
    return skipMajors(t, u, a, o / i), u;
  const d = calculateSpacing(a, t, i);
  if (o > 0) {
    let p, f;
    const g = o > 1 ? Math.round((c - l) / (o - 1)) : null;
    for (skip(t, u, d, isNullOrUndef(g) ? 0 : l - g, l), p = 0, f = o - 1; p < f; p++)
      skip(t, u, d, a[p], a[p + 1]);
    return skip(t, u, d, c, isNullOrUndef(g) ? t.length : c + g), u;
  }
  return skip(t, u, d), u;
}
function determineMaxTicks(e) {
  const t = e.options.offset, n = e._tickSize(), s = e._length / n + (t ? 0 : 1), i = e._maxLength / n;
  return Math.floor(Math.min(s, i));
}
function calculateSpacing(e, t, n) {
  const s = getEvenSpacing(e), i = t.length / n;
  if (!s)
    return Math.max(i, 1);
  const a = _factorize(s);
  for (let o = 0, l = a.length - 1; o < l; o++) {
    const c = a[o];
    if (c > i)
      return c;
  }
  return Math.max(i, 1);
}
function getMajorIndices(e) {
  const t = [];
  let n, s;
  for (n = 0, s = e.length; n < s; n++)
    e[n].major && t.push(n);
  return t;
}
function skipMajors(e, t, n, s) {
  let i = 0, a = n[0], o;
  for (s = Math.ceil(s), o = 0; o < e.length; o++)
    o === a && (t.push(e[o]), i++, a = n[i * s]);
}
function skip(e, t, n, s, i) {
  const a = valueOrDefault(s, 0), o = Math.min(valueOrDefault(i, e.length), e.length);
  let l = 0, c, u, d;
  for (n = Math.ceil(n), i && (c = i - s, n = c / Math.floor(c / n)), d = a; d < 0; )
    l++, d = Math.round(a + l * n);
  for (u = Math.max(a, 0); u < o; u++)
    u === d && (t.push(e[u]), l++, d = Math.round(a + l * n));
}
function getEvenSpacing(e) {
  const t = e.length;
  let n, s;
  if (t < 2)
    return !1;
  for (s = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== s)
      return !1;
  return s;
}
const reverseAlign = (e) => e === "left" ? "right" : e === "right" ? "left" : e, offsetFromEdge = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, getTicksLimit = (e, t) => Math.min(t || e, e);
function sample(e, t) {
  const n = [], s = e.length / t, i = e.length;
  let a = 0;
  for (; a < i; a += s)
    n.push(e[Math.floor(a)]);
  return n;
}
function getPixelForGridLine(e, t, n) {
  const s = e.ticks.length, i = Math.min(t, s - 1), a = e._startPixel, o = e._endPixel, l = 1e-6;
  let c = e.getPixelForTick(i), u;
  if (!(n && (s === 1 ? u = Math.max(c - a, o - c) : t === 0 ? u = (e.getPixelForTick(1) - c) / 2 : u = (c - e.getPixelForTick(i - 1)) / 2, c += i < t ? u : -u, c < a - l || c > o + l)))
    return c;
}
function garbageCollect(e, t) {
  each(e, (n) => {
    const s = n.gc, i = s.length / 2;
    let a;
    if (i > t) {
      for (a = 0; a < i; ++a)
        delete n.data[s[a]];
      s.splice(0, i);
    }
  });
}
function getTickMarkLength(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function getTitleHeight(e, t) {
  if (!e.display)
    return 0;
  const n = toFont(e.font, t), s = toPadding(e.padding);
  return (isArray(e.text) ? e.text.length : 1) * n.lineHeight + s.height;
}
function createScaleContext(e, t) {
  return createContext(e, {
    scale: t,
    type: "scale"
  });
}
function createTickContext(e, t, n) {
  return createContext(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function titleAlign(e, t, n) {
  let s = _toLeftRightCenter(e);
  return (n && t !== "right" || !n && t === "right") && (s = reverseAlign(s)), s;
}
function titleArgs(e, t, n, s) {
  const { top: i, left: a, bottom: o, right: l, chart: c } = e, { chartArea: u, scales: d } = c;
  let p = 0, f, g, C;
  const k = o - i, M = l - a;
  if (e.isHorizontal()) {
    if (g = _alignStartEnd(s, a, l), isObject(n)) {
      const _ = Object.keys(n)[0], S = n[_];
      C = d[_].getPixelForValue(S) + k - t;
    } else
      n === "center" ? C = (u.bottom + u.top) / 2 + k - t : C = offsetFromEdge(e, n, t);
    f = l - a;
  } else {
    if (isObject(n)) {
      const _ = Object.keys(n)[0], S = n[_];
      g = d[_].getPixelForValue(S) - M + t;
    } else
      n === "center" ? g = (u.left + u.right) / 2 - M + t : g = offsetFromEdge(e, n, t);
    C = _alignStartEnd(s, o, i), p = n === "left" ? -HALF_PI : HALF_PI;
  }
  return {
    titleX: g,
    titleY: C,
    maxWidth: f,
    rotation: p
  };
}
class Scale extends Element$1 {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: s, _suggestedMax: i } = this;
    return t = finiteOrDefault(t, Number.POSITIVE_INFINITY), n = finiteOrDefault(n, Number.NEGATIVE_INFINITY), s = finiteOrDefault(s, Number.POSITIVE_INFINITY), i = finiteOrDefault(i, Number.NEGATIVE_INFINITY), {
      min: finiteOrDefault(t, s),
      max: finiteOrDefault(n, i),
      minDefined: isNumberFinite(t),
      maxDefined: isNumberFinite(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: s, minDefined: i, maxDefined: a } = this.getUserBounds(), o;
    if (i && a)
      return {
        min: n,
        max: s
      };
    const l = this.getMatchingVisibleMetas();
    for (let c = 0, u = l.length; c < u; ++c)
      o = l[c].controller.getMinMax(this, t), i || (n = Math.min(n, o.min)), a || (s = Math.max(s, o.max));
    return n = a && n > s ? s : n, s = i && n > s ? n : s, {
      min: finiteOrDefault(n, finiteOrDefault(s, n)),
      max: finiteOrDefault(s, finiteOrDefault(n, s))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    callback(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, n, s) {
    const { beginAtZero: i, grace: a, ticks: o } = this.options, l = o.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = s = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, s), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + s.left + s.right : this.height + s.top + s.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = _addGrace(this, a, i), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const c = l < this.ticks.length;
    this._convertTicksToLabels(c ? sample(this.ticks, l) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), o.display && (o.autoSkip || o.source === "auto") && (this.ticks = autoSkip(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), c && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, s;
    this.isHorizontal() ? (n = this.left, s = this.right) : (n = this.top, s = this.bottom, t = !t), this._startPixel = n, this._endPixel = s, this._reversePixels = t, this._length = s - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    callback(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    callback(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    callback(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), callback(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    callback(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let s, i, a;
    for (s = 0, i = t.length; s < i; s++)
      a = t[s], a.label = callback(n.callback, [
        a.value,
        s,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    callback(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    callback(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, s = getTicksLimit(this.ticks.length, t.ticks.maxTicksLimit), i = n.minRotation || 0, a = n.maxRotation;
    let o = i, l, c, u;
    if (!this._isVisible() || !n.display || i >= a || s <= 1 || !this.isHorizontal()) {
      this.labelRotation = i;
      return;
    }
    const d = this._getLabelSizes(), p = d.widest.width, f = d.highest.height, g = _limitValue(this.chart.width - p, 0, this.maxWidth);
    l = t.offset ? this.maxWidth / s : g / (s - 1), p + 6 > l && (l = g / (s - (t.offset ? 0.5 : 1)), c = this.maxHeight - getTickMarkLength(t.grid) - n.padding - getTitleHeight(t.title, this.chart.options.font), u = Math.sqrt(p * p + f * f), o = toDegrees(Math.min(Math.asin(_limitValue((d.highest.height + 6) / l, -1, 1)), Math.asin(_limitValue(c / u, -1, 1)) - Math.asin(_limitValue(f / u, -1, 1)))), o = Math.max(i, Math.min(a, o))), this.labelRotation = o;
  }
  afterCalculateLabelRotation() {
    callback(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    callback(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: s, title: i, grid: a } } = this, o = this._isVisible(), l = this.isHorizontal();
    if (o) {
      const c = getTitleHeight(i, n.options.font);
      if (l ? (t.width = this.maxWidth, t.height = getTickMarkLength(a) + c) : (t.height = this.maxHeight, t.width = getTickMarkLength(a) + c), s.display && this.ticks.length) {
        const { first: u, last: d, widest: p, highest: f } = this._getLabelSizes(), g = s.padding * 2, C = toRadians(this.labelRotation), k = Math.cos(C), M = Math.sin(C);
        if (l) {
          const _ = s.mirror ? 0 : M * p.width + k * f.height;
          t.height = Math.min(this.maxHeight, t.height + _ + g);
        } else {
          const _ = s.mirror ? 0 : k * p.width + M * f.height;
          t.width = Math.min(this.maxWidth, t.width + _ + g);
        }
        this._calculatePadding(u, d, M, k);
      }
    }
    this._handleMargins(), l ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, s, i) {
    const { ticks: { align: a, padding: o }, position: l } = this.options, c = this.labelRotation !== 0, u = l !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const d = this.getPixelForTick(0) - this.left, p = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, g = 0;
      c ? u ? (f = i * t.width, g = s * n.height) : (f = s * t.height, g = i * n.width) : a === "start" ? g = n.width : a === "end" ? f = t.width : a !== "inner" && (f = t.width / 2, g = n.width / 2), this.paddingLeft = Math.max((f - d + o) * this.width / (this.width - d), 0), this.paddingRight = Math.max((g - p + o) * this.width / (this.width - p), 0);
    } else {
      let d = n.height / 2, p = t.height / 2;
      a === "start" ? (d = 0, p = t.height) : a === "end" && (d = n.height, p = 0), this.paddingTop = d + o, this.paddingBottom = p + o;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    callback(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, s;
    for (n = 0, s = t.length; n < s; n++)
      isNullOrUndef(t[n].label) && (t.splice(n, 1), s--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let s = this.ticks;
      n < s.length && (s = sample(s, n)), this._labelSizes = t = this._computeLabelSizes(s, s.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, n, s) {
    const { ctx: i, _longestTextCache: a } = this, o = [], l = [], c = Math.floor(n / getTicksLimit(n, s));
    let u = 0, d = 0, p, f, g, C, k, M, _, S, E, P, $;
    for (p = 0; p < n; p += c) {
      if (C = t[p].label, k = this._resolveTickFontOptions(p), i.font = M = k.string, _ = a[M] = a[M] || {
        data: {},
        gc: []
      }, S = k.lineHeight, E = P = 0, !isNullOrUndef(C) && !isArray(C))
        E = _measureText(i, _.data, _.gc, E, C), P = S;
      else if (isArray(C))
        for (f = 0, g = C.length; f < g; ++f)
          $ = C[f], !isNullOrUndef($) && !isArray($) && (E = _measureText(i, _.data, _.gc, E, $), P += S);
      o.push(E), l.push(P), u = Math.max(E, u), d = Math.max(P, d);
    }
    garbageCollect(a, n);
    const A = o.indexOf(u), I = l.indexOf(d), D = (R) => ({
      width: o[R] || 0,
      height: l[R] || 0
    });
    return {
      first: D(0),
      last: D(n - 1),
      widest: D(A),
      highest: D(I),
      widths: o,
      heights: l
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return _int16Range(this._alignToPixels ? _alignPixel(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const s = n[t];
      return s.$context || (s.$context = createTickContext(this.getContext(), t, s));
    }
    return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = toRadians(this.labelRotation), s = Math.abs(Math.cos(n)), i = Math.abs(Math.sin(n)), a = this._getLabelSizes(), o = t.autoSkipPadding || 0, l = a ? a.widest.width + o : 0, c = a ? a.highest.height + o : 0;
    return this.isHorizontal() ? c * s > l * i ? l / s : c / i : c * i < l * s ? c / s : l / i;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, s = this.chart, i = this.options, { grid: a, position: o, border: l } = i, c = a.offset, u = this.isHorizontal(), p = this.ticks.length + (c ? 1 : 0), f = getTickMarkLength(a), g = [], C = l.setContext(this.getContext()), k = C.display ? C.width : 0, M = k / 2, _ = function(H) {
      return _alignPixel(s, H, k);
    };
    let S, E, P, $, A, I, D, R, Y, q, j, X;
    if (o === "top")
      S = _(this.bottom), I = this.bottom - f, R = S - M, q = _(t.top) + M, X = t.bottom;
    else if (o === "bottom")
      S = _(this.top), q = t.top, X = _(t.bottom) - M, I = S + M, R = this.top + f;
    else if (o === "left")
      S = _(this.right), A = this.right - f, D = S - M, Y = _(t.left) + M, j = t.right;
    else if (o === "right")
      S = _(this.left), Y = t.left, j = _(t.right) - M, A = S + M, D = this.left + f;
    else if (n === "x") {
      if (o === "center")
        S = _((t.top + t.bottom) / 2 + 0.5);
      else if (isObject(o)) {
        const H = Object.keys(o)[0], F = o[H];
        S = _(this.chart.scales[H].getPixelForValue(F));
      }
      q = t.top, X = t.bottom, I = S + M, R = I + f;
    } else if (n === "y") {
      if (o === "center")
        S = _((t.left + t.right) / 2);
      else if (isObject(o)) {
        const H = Object.keys(o)[0], F = o[H];
        S = _(this.chart.scales[H].getPixelForValue(F));
      }
      A = S - M, D = A - f, Y = t.left, j = t.right;
    }
    const ee = valueOrDefault(i.ticks.maxTicksLimit, p), G = Math.max(1, Math.ceil(p / ee));
    for (E = 0; E < p; E += G) {
      const H = this.getContext(E), F = a.setContext(H), B = l.setContext(H), z = F.lineWidth, K = F.color, Z = B.dash || [], re = B.dashOffset, ae = F.tickWidth, te = F.tickColor, ue = F.tickBorderDash || [], ce = F.tickBorderDashOffset;
      P = getPixelForGridLine(this, E, c), P !== void 0 && ($ = _alignPixel(s, P, z), u ? A = D = Y = j = $ : I = R = q = X = $, g.push({
        tx1: A,
        ty1: I,
        tx2: D,
        ty2: R,
        x1: Y,
        y1: q,
        x2: j,
        y2: X,
        width: z,
        color: K,
        borderDash: Z,
        borderDashOffset: re,
        tickWidth: ae,
        tickColor: te,
        tickBorderDash: ue,
        tickBorderDashOffset: ce
      }));
    }
    return this._ticksLength = p, this._borderValue = S, g;
  }
  _computeLabelItems(t) {
    const n = this.axis, s = this.options, { position: i, ticks: a } = s, o = this.isHorizontal(), l = this.ticks, { align: c, crossAlign: u, padding: d, mirror: p } = a, f = getTickMarkLength(s.grid), g = f + d, C = p ? -d : g, k = -toRadians(this.labelRotation), M = [];
    let _, S, E, P, $, A, I, D, R, Y, q, j, X = "middle";
    if (i === "top")
      A = this.bottom - C, I = this._getXAxisLabelAlignment();
    else if (i === "bottom")
      A = this.top + C, I = this._getXAxisLabelAlignment();
    else if (i === "left") {
      const G = this._getYAxisLabelAlignment(f);
      I = G.textAlign, $ = G.x;
    } else if (i === "right") {
      const G = this._getYAxisLabelAlignment(f);
      I = G.textAlign, $ = G.x;
    } else if (n === "x") {
      if (i === "center")
        A = (t.top + t.bottom) / 2 + g;
      else if (isObject(i)) {
        const G = Object.keys(i)[0], H = i[G];
        A = this.chart.scales[G].getPixelForValue(H) + g;
      }
      I = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (i === "center")
        $ = (t.left + t.right) / 2 - g;
      else if (isObject(i)) {
        const G = Object.keys(i)[0], H = i[G];
        $ = this.chart.scales[G].getPixelForValue(H);
      }
      I = this._getYAxisLabelAlignment(f).textAlign;
    }
    n === "y" && (c === "start" ? X = "top" : c === "end" && (X = "bottom"));
    const ee = this._getLabelSizes();
    for (_ = 0, S = l.length; _ < S; ++_) {
      E = l[_], P = E.label;
      const G = a.setContext(this.getContext(_));
      D = this.getPixelForTick(_) + a.labelOffset, R = this._resolveTickFontOptions(_), Y = R.lineHeight, q = isArray(P) ? P.length : 1;
      const H = q / 2, F = G.color, B = G.textStrokeColor, z = G.textStrokeWidth;
      let K = I;
      o ? ($ = D, I === "inner" && (_ === S - 1 ? K = this.options.reverse ? "left" : "right" : _ === 0 ? K = this.options.reverse ? "right" : "left" : K = "center"), i === "top" ? u === "near" || k !== 0 ? j = -q * Y + Y / 2 : u === "center" ? j = -ee.highest.height / 2 - H * Y + Y : j = -ee.highest.height + Y / 2 : u === "near" || k !== 0 ? j = Y / 2 : u === "center" ? j = ee.highest.height / 2 - H * Y : j = ee.highest.height - q * Y, p && (j *= -1), k !== 0 && !G.showLabelBackdrop && ($ += Y / 2 * Math.sin(k))) : (A = D, j = (1 - q) * Y / 2);
      let Z;
      if (G.showLabelBackdrop) {
        const re = toPadding(G.backdropPadding), ae = ee.heights[_], te = ee.widths[_];
        let ue = j - re.top, ce = 0 - re.left;
        switch (X) {
          case "middle":
            ue -= ae / 2;
            break;
          case "bottom":
            ue -= ae;
            break;
        }
        switch (I) {
          case "center":
            ce -= te / 2;
            break;
          case "right":
            ce -= te;
            break;
        }
        Z = {
          left: ce,
          top: ue,
          width: te + re.width,
          height: ae + re.height,
          color: G.backdropColor
        };
      }
      M.push({
        label: P,
        font: R,
        textOffset: j,
        options: {
          rotation: k,
          color: F,
          strokeColor: B,
          strokeWidth: z,
          textAlign: K,
          textBaseline: X,
          translation: [
            $,
            A
          ],
          backdrop: Z
        }
      });
    }
    return M;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-toRadians(this.labelRotation))
      return t === "top" ? "left" : "right";
    let i = "center";
    return n.align === "start" ? i = "left" : n.align === "end" ? i = "right" : n.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: s, mirror: i, padding: a } } = this.options, o = this._getLabelSizes(), l = t + a, c = o.widest.width;
    let u, d;
    return n === "left" ? i ? (d = this.right + a, s === "near" ? u = "left" : s === "center" ? (u = "center", d += c / 2) : (u = "right", d += c)) : (d = this.right - l, s === "near" ? u = "right" : s === "center" ? (u = "center", d -= c / 2) : (u = "left", d = this.left)) : n === "right" ? i ? (d = this.left + a, s === "near" ? u = "right" : s === "center" ? (u = "center", d -= c / 2) : (u = "left", d -= c)) : (d = this.left + l, s === "near" ? u = "left" : s === "center" ? (u = "center", d += c / 2) : (u = "right", d = this.right)) : u = "right", {
      textAlign: u,
      x: d
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: s, top: i, width: a, height: o } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(s, i, a, o), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const i = this.ticks.findIndex((a) => a.value === t);
    return i >= 0 ? n.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, s = this.ctx, i = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let a, o;
    const l = (c, u, d) => {
      !d.width || !d.color || (s.save(), s.lineWidth = d.width, s.strokeStyle = d.color, s.setLineDash(d.borderDash || []), s.lineDashOffset = d.borderDashOffset, s.beginPath(), s.moveTo(c.x, c.y), s.lineTo(u.x, u.y), s.stroke(), s.restore());
    };
    if (n.display)
      for (a = 0, o = i.length; a < o; ++a) {
        const c = i[a];
        n.drawOnChartArea && l({
          x: c.x1,
          y: c.y1
        }, {
          x: c.x2,
          y: c.y2
        }, c), n.drawTicks && l({
          x: c.tx1,
          y: c.ty1
        }, {
          x: c.tx2,
          y: c.ty2
        }, {
          color: c.tickColor,
          width: c.tickWidth,
          borderDash: c.tickBorderDash,
          borderDashOffset: c.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { border: s, grid: i } } = this, a = s.setContext(this.getContext()), o = s.display ? a.width : 0;
    if (!o)
      return;
    const l = i.setContext(this.getContext(0)).lineWidth, c = this._borderValue;
    let u, d, p, f;
    this.isHorizontal() ? (u = _alignPixel(t, this.left, o) - o / 2, d = _alignPixel(t, this.right, l) + l / 2, p = f = c) : (p = _alignPixel(t, this.top, o) - o / 2, f = _alignPixel(t, this.bottom, l) + l / 2, u = d = c), n.save(), n.lineWidth = a.width, n.strokeStyle = a.color, n.beginPath(), n.moveTo(u, p), n.lineTo(d, f), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const s = this.ctx, i = this._computeLabelArea();
    i && clipArea(s, i);
    const a = this.getLabelItems(t);
    for (const o of a) {
      const l = o.options, c = o.font, u = o.label, d = o.textOffset;
      renderText(s, u, 0, d, c, l);
    }
    i && unclipArea(s);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: s, reverse: i } } = this;
    if (!s.display)
      return;
    const a = toFont(s.font), o = toPadding(s.padding), l = s.align;
    let c = a.lineHeight / 2;
    n === "bottom" || n === "center" || isObject(n) ? (c += o.bottom, isArray(s.text) && (c += a.lineHeight * (s.text.length - 1))) : c += o.top;
    const { titleX: u, titleY: d, maxWidth: p, rotation: f } = titleArgs(this, c, n, l);
    renderText(t, s.text, 0, 0, a, {
      color: s.color,
      maxWidth: p,
      rotation: f,
      textAlign: titleAlign(l, n, i),
      textBaseline: "middle",
      translation: [
        u,
        d
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, s = valueOrDefault(t.grid && t.grid.z, -1), i = valueOrDefault(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== Scale.prototype.draw ? [
      {
        z: n,
        draw: (a) => {
          this.draw(a);
        }
      }
    ] : [
      {
        z: s,
        draw: (a) => {
          this.drawBackground(), this.drawGrid(a), this.drawTitle();
        }
      },
      {
        z: i,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (a) => {
          this.drawLabels(a);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), s = this.axis + "AxisID", i = [];
    let a, o;
    for (a = 0, o = n.length; a < o; ++a) {
      const l = n[a];
      l[s] === this.id && (!t || l.type === t) && i.push(l);
    }
    return i;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return toFont(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class TypedRegistry {
  constructor(t, n, s) {
    this.type = t, this.scope = n, this.override = s, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let s;
    isIChartComponent(n) && (s = this.register(n));
    const i = this.items, a = t.id, o = this.scope + "." + a;
    if (!a)
      throw new Error("class does not have id: " + t);
    return a in i || (i[a] = t, registerDefaults(t, o, s), this.override && defaults.override(t.id, t.overrides)), o;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, s = t.id, i = this.scope;
    s in n && delete n[s], i && s in defaults[i] && (delete defaults[i][s], this.override && delete overrides[s]);
  }
}
function registerDefaults(e, t, n) {
  const s = merge(/* @__PURE__ */ Object.create(null), [
    n ? defaults.get(n) : {},
    defaults.get(t),
    e.defaults
  ]);
  defaults.set(t, s), e.defaultRoutes && routeDefaults(t, e.defaultRoutes), e.descriptors && defaults.describe(t, e.descriptors);
}
function routeDefaults(e, t) {
  Object.keys(t).forEach((n) => {
    const s = n.split("."), i = s.pop(), a = [
      e
    ].concat(s).join("."), o = t[n].split("."), l = o.pop(), c = o.join(".");
    defaults.route(a, i, c, l);
  });
}
function isIChartComponent(e) {
  return "id" in e && "defaults" in e;
}
class Registry {
  constructor() {
    this.controllers = new TypedRegistry(DatasetController, "datasets", !0), this.elements = new TypedRegistry(Element$1, "elements"), this.plugins = new TypedRegistry(Object, "plugins"), this.scales = new TypedRegistry(Scale, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, s) {
    [
      ...n
    ].forEach((i) => {
      const a = s || this._getRegistryForType(i);
      s || a.isForType(i) || a === this.plugins && i.id ? this._exec(t, a, i) : each(i, (o) => {
        const l = s || this._getRegistryForType(o);
        this._exec(t, l, o);
      });
    });
  }
  _exec(t, n, s) {
    const i = _capitalize(t);
    callback(s["before" + i], [], s), n[t](s), callback(s["after" + i], [], s);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const s = this._typedRegistries[n];
      if (s.isForType(t))
        return s;
    }
    return this.plugins;
  }
  _get(t, n, s) {
    const i = n.get(t);
    if (i === void 0)
      throw new Error('"' + t + '" is not a registered ' + s + ".");
    return i;
  }
}
var registry = /* @__PURE__ */ new Registry();
class PluginService {
  constructor() {
    this._init = [];
  }
  notify(t, n, s, i) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const a = i ? this._descriptors(t).filter(i) : this._descriptors(t), o = this._notify(a, t, n, s);
    return n === "afterDestroy" && (this._notify(a, t, "stop"), this._notify(this._init, t, "uninstall")), o;
  }
  _notify(t, n, s, i) {
    i = i || {};
    for (const a of t) {
      const o = a.plugin, l = o[s], c = [
        n,
        i,
        a.options
      ];
      if (callback(l, c, o) === !1 && i.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    isNullOrUndef(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const s = t && t.config, i = valueOrDefault(s.options && s.options.plugins, {}), a = allPlugins(s);
    return i === !1 && !n ? [] : createDescriptors(t, a, i, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], s = this._cache, i = (a, o) => a.filter((l) => !o.some((c) => l.plugin.id === c.plugin.id));
    this._notify(i(n, s), t, "stop"), this._notify(i(s, n), t, "start");
  }
}
function allPlugins(e) {
  const t = {}, n = [], s = Object.keys(registry.plugins.items);
  for (let a = 0; a < s.length; a++)
    n.push(registry.getPlugin(s[a]));
  const i = e.plugins || [];
  for (let a = 0; a < i.length; a++) {
    const o = i[a];
    n.indexOf(o) === -1 && (n.push(o), t[o.id] = !0);
  }
  return {
    plugins: n,
    localIds: t
  };
}
function getOpts(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function createDescriptors(e, { plugins: t, localIds: n }, s, i) {
  const a = [], o = e.getContext();
  for (const l of t) {
    const c = l.id, u = getOpts(s[c], i);
    u !== null && a.push({
      plugin: l,
      options: pluginOpts(e.config, {
        plugin: l,
        local: n[c]
      }, u, o)
    });
  }
  return a;
}
function pluginOpts(e, { plugin: t, local: n }, s, i) {
  const a = e.pluginScopeKeys(t), o = e.getOptionScopes(s, a);
  return n && t.defaults && o.push(t.defaults), e.createResolver(o, i, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function getIndexAxis(e, t) {
  const n = defaults.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function getAxisFromDefaultScaleID(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function getDefaultScaleIDFromAxis(e, t) {
  return e === t ? "_index_" : "_value_";
}
function idMatchesAxis(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function axisFromPosition(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function determineAxis(e, ...t) {
  if (idMatchesAxis(e))
    return e;
  for (const n of t) {
    const s = n.axis || axisFromPosition(n.position) || e.length > 1 && idMatchesAxis(e[0].toLowerCase());
    if (s)
      return s;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(e, t, n) {
  if (n[t + "AxisID"] === e)
    return {
      axis: t
    };
}
function retrieveAxisFromDatasets(e, t) {
  if (t.data && t.data.datasets) {
    const n = t.data.datasets.filter((s) => s.xAxisID === e || s.yAxisID === e);
    if (n.length)
      return getAxisFromDataset(e, "x", n[0]) || getAxisFromDataset(e, "y", n[0]);
  }
  return {};
}
function mergeScaleConfig(e, t) {
  const n = overrides[e.type] || {
    scales: {}
  }, s = t.scales || {}, i = getIndexAxis(e.type, t), a = /* @__PURE__ */ Object.create(null);
  return Object.keys(s).forEach((o) => {
    const l = s[o];
    if (!isObject(l))
      return console.error(`Invalid scale configuration for scale: ${o}`);
    if (l._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${o}`);
    const c = determineAxis(o, l, retrieveAxisFromDatasets(o, e), defaults.scales[l.type]), u = getDefaultScaleIDFromAxis(c, i), d = n.scales || {};
    a[o] = mergeIf(/* @__PURE__ */ Object.create(null), [
      {
        axis: c
      },
      l,
      d[c],
      d[u]
    ]);
  }), e.data.datasets.forEach((o) => {
    const l = o.type || e.type, c = o.indexAxis || getIndexAxis(l, t), d = (overrides[l] || {}).scales || {};
    Object.keys(d).forEach((p) => {
      const f = getAxisFromDefaultScaleID(p, c), g = o[f + "AxisID"] || f;
      a[g] = a[g] || /* @__PURE__ */ Object.create(null), mergeIf(a[g], [
        {
          axis: f
        },
        s[g],
        d[p]
      ]);
    });
  }), Object.keys(a).forEach((o) => {
    const l = a[o];
    mergeIf(l, [
      defaults.scales[l.type],
      defaults.scale
    ]);
  }), a;
}
function initOptions(e) {
  const t = e.options || (e.options = {});
  t.plugins = valueOrDefault(t.plugins, {}), t.scales = mergeScaleConfig(e, t);
}
function initData(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function initConfig(e) {
  return e = e || {}, e.data = initData(e.data), initOptions(e), e;
}
const keyCache = /* @__PURE__ */ new Map(), keysCached = /* @__PURE__ */ new Set();
function cachedKeys(e, t) {
  let n = keyCache.get(e);
  return n || (n = t(), keyCache.set(e, n), keysCached.add(n)), n;
}
const addIfFound = (e, t, n) => {
  const s = resolveObjectKey(t, n);
  s !== void 0 && e.add(s);
};
class Config {
  constructor(t) {
    this._config = initConfig(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = initData(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), initOptions(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return cachedKeys(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, n) {
    return cachedKeys(`${t}.transition.${n}`, () => [
      [
        `datasets.${t}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, n) {
    return cachedKeys(`${t}-${n}`, () => [
      [
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const n = t.id, s = this.type;
    return cachedKeys(`${s}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, n) {
    const s = this._scopeCache;
    let i = s.get(t);
    return (!i || n) && (i = /* @__PURE__ */ new Map(), s.set(t, i)), i;
  }
  getOptionScopes(t, n, s) {
    const { options: i, type: a } = this, o = this._cachedScopes(t, s), l = o.get(n);
    if (l)
      return l;
    const c = /* @__PURE__ */ new Set();
    n.forEach((d) => {
      t && (c.add(t), d.forEach((p) => addIfFound(c, t, p))), d.forEach((p) => addIfFound(c, i, p)), d.forEach((p) => addIfFound(c, overrides[a] || {}, p)), d.forEach((p) => addIfFound(c, defaults, p)), d.forEach((p) => addIfFound(c, descriptors, p));
    });
    const u = Array.from(c);
    return u.length === 0 && u.push(/* @__PURE__ */ Object.create(null)), keysCached.has(n) && o.set(n, u), u;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      overrides[n] || {},
      defaults.datasets[n] || {},
      {
        type: n
      },
      defaults,
      descriptors
    ];
  }
  resolveNamedOptions(t, n, s, i = [
    ""
  ]) {
    const a = {
      $shared: !0
    }, { resolver: o, subPrefixes: l } = getResolver(this._resolverCache, t, i);
    let c = o;
    if (needContext(o, n)) {
      a.$shared = !1, s = isFunction(s) ? s() : s;
      const u = this.createResolver(t, s, l);
      c = _attachContext(o, s, u);
    }
    for (const u of n)
      a[u] = c[u];
    return a;
  }
  createResolver(t, n, s = [
    ""
  ], i) {
    const { resolver: a } = getResolver(this._resolverCache, t, s);
    return isObject(n) ? _attachContext(a, n, void 0, i) : a;
  }
}
function getResolver(e, t, n) {
  let s = e.get(t);
  s || (s = /* @__PURE__ */ new Map(), e.set(t, s));
  const i = n.join();
  let a = s.get(i);
  return a || (a = {
    resolver: _createResolver(t, n),
    subPrefixes: n.filter((l) => !l.toLowerCase().includes("hover"))
  }, s.set(i, a)), a;
}
const hasFunction = (e) => isObject(e) && Object.getOwnPropertyNames(e).reduce((t, n) => t || isFunction(e[n]), !1);
function needContext(e, t) {
  const { isScriptable: n, isIndexable: s } = _descriptors(e);
  for (const i of t) {
    const a = n(i), o = s(i), l = (o || a) && e[i];
    if (a && (isFunction(l) || hasFunction(l)) || o && isArray(l))
      return !0;
  }
  return !1;
}
var version = "4.3.0";
const KNOWN_POSITIONS = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function positionIsHorizontal(e, t) {
  return e === "top" || e === "bottom" || KNOWN_POSITIONS.indexOf(e) === -1 && t === "x";
}
function compare2Level(e, t) {
  return function(n, s) {
    return n[e] === s[e] ? n[t] - s[t] : n[e] - s[e];
  };
}
function onAnimationsComplete(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), callback(n && n.onComplete, [
    e
  ], t);
}
function onAnimationProgress(e) {
  const t = e.chart, n = t.options.animation;
  callback(n && n.onProgress, [
    e
  ], t);
}
function getCanvas(e) {
  return _isDomSupported() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const instances = {}, getChart = (e) => {
  const t = getCanvas(e);
  return Object.values(instances).filter((n) => n.canvas === t).pop();
};
function moveNumericKeys(e, t, n) {
  const s = Object.keys(e);
  for (const i of s) {
    const a = +i;
    if (a >= t) {
      const o = e[i];
      delete e[i], (n > 0 || a > t) && (e[a + n] = o);
    }
  }
}
function determineLastEvent(e, t, n, s) {
  return !n || e.type === "mouseout" ? null : s ? t : e;
}
function getDatasetArea(e) {
  const { xScale: t, yScale: n } = e;
  if (t && n)
    return {
      left: t.left,
      right: t.right,
      top: n.top,
      bottom: n.bottom
    };
}
var Re;
let Chart$1 = (Re = class {
  static register(...t) {
    registry.add(...t), invalidatePlugins();
  }
  static unregister(...t) {
    registry.remove(...t), invalidatePlugins();
  }
  constructor(t, n) {
    const s = this.config = new Config(n), i = getCanvas(t), a = getChart(i);
    if (a)
      throw new Error("Canvas is already in use. Chart with ID '" + a.id + "' must be destroyed before the canvas with ID '" + a.canvas.id + "' can be reused.");
    const o = s.createResolver(s.chartOptionScopes(), this.getContext());
    this.platform = new (s.platform || _detectPlatform(i))(), this.platform.updateConfig(s);
    const l = this.platform.acquireContext(i, o.aspectRatio), c = l && l.canvas, u = c && c.height, d = c && c.width;
    if (this.id = uid(), this.ctx = l, this.canvas = c, this.width = d, this.height = u, this._options = o, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new PluginService(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = debounce((p) => this.update(p), o.resizeDelay || 0), this._dataChanges = [], instances[this.id] = this, !l || !c) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    animator.listen(this, "complete", onAnimationsComplete), animator.listen(this, "progress", onAnimationProgress), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: s, height: i, _aspectRatio: a } = this;
    return isNullOrUndef(t) ? n && a ? a : i ? s / i : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return registry;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : retinaScale(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return clearCanvas(this.canvas, this.ctx), this;
  }
  stop() {
    return animator.stop(this), this;
  }
  resize(t, n) {
    animator.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: n
    } : this._resize(t, n);
  }
  _resize(t, n) {
    const s = this.options, i = this.canvas, a = s.maintainAspectRatio && this.aspectRatio, o = this.platform.getMaximumSize(i, t, n, a), l = s.devicePixelRatio || this.platform.getDevicePixelRatio(), c = this.width ? "resize" : "attach";
    this.width = o.width, this.height = o.height, this._aspectRatio = this.aspectRatio, retinaScale(this, l, !0) && (this.notifyPlugins("resize", {
      size: o
    }), callback(s.onResize, [
      this,
      o
    ], this), this.attached && this._doResize(c) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    each(n, (s, i) => {
      s.id = i;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, s = this.scales, i = Object.keys(s).reduce((o, l) => (o[l] = !1, o), {});
    let a = [];
    n && (a = a.concat(Object.keys(n).map((o) => {
      const l = n[o], c = determineAxis(o, l), u = c === "r", d = c === "x";
      return {
        options: l,
        dposition: u ? "chartArea" : d ? "bottom" : "left",
        dtype: u ? "radialLinear" : d ? "category" : "linear"
      };
    }))), each(a, (o) => {
      const l = o.options, c = l.id, u = determineAxis(c, l), d = valueOrDefault(l.type, o.dtype);
      (l.position === void 0 || positionIsHorizontal(l.position, u) !== positionIsHorizontal(o.dposition)) && (l.position = o.dposition), i[c] = !0;
      let p = null;
      if (c in s && s[c].type === d)
        p = s[c];
      else {
        const f = registry.getScale(d);
        p = new f({
          id: c,
          type: d,
          ctx: this.ctx,
          chart: this
        }), s[p.id] = p;
      }
      p.init(l, t);
    }), each(i, (o, l) => {
      o || delete s[l];
    }), each(s, (o) => {
      layouts.configure(this, o, o.options), layouts.addBox(this, o);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, s = t.length;
    if (t.sort((i, a) => i.index - a.index), s > n) {
      for (let i = n; i < s; ++i)
        this._destroyDatasetMeta(i);
      t.splice(n, s - n);
    }
    this._sortedMetasets = t.slice(0).sort(compare2Level("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((s, i) => {
      n.filter((a) => a === s._dataset).length === 0 && this._destroyDatasetMeta(i);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let s, i;
    for (this._removeUnreferencedMetasets(), s = 0, i = n.length; s < i; s++) {
      const a = n[s];
      let o = this.getDatasetMeta(s);
      const l = a.type || this.config.type;
      if (o.type && o.type !== l && (this._destroyDatasetMeta(s), o = this.getDatasetMeta(s)), o.type = l, o.indexAxis = a.indexAxis || getIndexAxis(l, this.options), o.order = a.order || 0, o.index = s, o.label = "" + a.label, o.visible = this.isDatasetVisible(s), o.controller)
        o.controller.updateIndex(s), o.controller.linkScales();
      else {
        const c = registry.getController(l), { datasetElementType: u, dataElementType: d } = defaults.datasets[l];
        Object.assign(c, {
          dataElementType: registry.getElement(d),
          datasetElementType: u && registry.getElement(u)
        }), o.controller = new c(this, s), t.push(o.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    each(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const s = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), i = this._animationsDisabled = !s.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const a = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let o = 0;
    for (let u = 0, d = this.data.datasets.length; u < d; u++) {
      const { controller: p } = this.getDatasetMeta(u), f = !i && a.indexOf(p) === -1;
      p.buildOrUpdateElements(f), o = Math.max(+p.getMaxOverflow(), o);
    }
    o = this._minPadding = s.layout.autoPadding ? o : 0, this._updateLayout(o), i || each(a, (u) => {
      u.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(compare2Level("z", "_idx"));
    const { _active: l, _lastEvent: c } = this;
    c ? this._eventHandler(c, !0) : l.length && this._updateHoverStyles(l, l, !0), this.render();
  }
  _updateScales() {
    each(this.scales, (t) => {
      layouts.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), s = new Set(t.events);
    (!setsEqual(n, s) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: s, start: i, count: a } of n) {
      const o = s === "_removeElements" ? -a : a;
      moveNumericKeys(t, i, o);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, s = (a) => new Set(t.filter((o) => o[0] === a).map((o, l) => l + "," + o.splice(1).join(","))), i = s(0);
    for (let a = 1; a < n; a++)
      if (!setsEqual(i, s(a)))
        return;
    return Array.from(i).map((a) => a.split(",")).map((a) => ({
      method: a[1],
      start: +a[2],
      count: +a[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    layouts.update(this, this.width, this.height, t);
    const n = this.chartArea, s = n.width <= 0 || n.height <= 0;
    this._layers = [], each(this.boxes, (i) => {
      s && i.position === "chartArea" || (i.configure && i.configure(), this._layers.push(...i._layers()));
    }, this), this._layers.forEach((i, a) => {
      i._idx = a;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, s = this.data.datasets.length; n < s; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, s = this.data.datasets.length; n < s; ++n)
        this._updateDataset(n, isFunction(t) ? t({
          datasetIndex: n
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, n) {
    const s = this.getDatasetMeta(t), i = {
      meta: s,
      index: t,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", i) !== !1 && (s.controller._update(n), i.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", i));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (animator.has(this) ? this.attached && !animator.running(this) && animator.start(this) : (this.draw(), onAnimationsComplete({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: s, height: i } = this._resizeBeforeDraw;
      this._resize(s, i), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, s = [];
    let i, a;
    for (i = 0, a = n.length; i < a; ++i) {
      const o = n[i];
      (!t || o.visible) && s.push(o);
    }
    return s;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, s = t._clip, i = !s.disabled, a = getDatasetArea(t) || this.chartArea, o = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", o) !== !1 && (i && clipArea(n, {
      left: s.left === !1 ? 0 : a.left - s.left,
      right: s.right === !1 ? this.width : a.right + s.right,
      top: s.top === !1 ? 0 : a.top - s.top,
      bottom: s.bottom === !1 ? this.height : a.bottom + s.bottom
    }), t.controller.draw(), i && unclipArea(n), o.cancelable = !1, this.notifyPlugins("afterDatasetDraw", o));
  }
  isPointInArea(t) {
    return _isPointInArea(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, s, i) {
    const a = Interaction.modes[n];
    return typeof a == "function" ? a(this, t, s, i) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], s = this._metasets;
    let i = s.filter((a) => a && a._dataset === n).pop();
    return i || (i = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, s.push(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = createContext(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const s = this.getDatasetMeta(t);
    return typeof s.hidden == "boolean" ? !s.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const s = this.getDatasetMeta(t);
    s.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, s) {
    const i = s ? "show" : "hide", a = this.getDatasetMeta(t), o = a.controller._resolveAnimations(void 0, i);
    defined(n) ? (a.data[n].hidden = !s, this.update()) : (this.setDatasetVisibility(t, s), o.update(a, {
      visible: s
    }), this.update((l) => l.datasetIndex === t ? i : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), animator.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), clearCanvas(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete instances[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, s = (a, o) => {
      n.addEventListener(this, a, o), t[a] = o;
    }, i = (a, o, l) => {
      a.offsetX = o, a.offsetY = l, this._eventHandler(a);
    };
    each(this.options.events, (a) => s(a, i));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, s = (c, u) => {
      n.addEventListener(this, c, u), t[c] = u;
    }, i = (c, u) => {
      t[c] && (n.removeEventListener(this, c, u), delete t[c]);
    }, a = (c, u) => {
      this.canvas && this.resize(c, u);
    };
    let o;
    const l = () => {
      i("attach", l), this.attached = !0, this.resize(), s("resize", a), s("detach", o);
    };
    o = () => {
      this.attached = !1, i("resize", a), this._stop(), this._resize(0, 0), s("attach", l);
    }, n.isAttached(this.canvas) ? l() : o();
  }
  unbindEvents() {
    each(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, each(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, s) {
    const i = s ? "set" : "remove";
    let a, o, l, c;
    for (n === "dataset" && (a = this.getDatasetMeta(t[0].datasetIndex), a.controller["_" + i + "DatasetHoverStyle"]()), l = 0, c = t.length; l < c; ++l) {
      o = t[l];
      const u = o && this.getDatasetMeta(o.datasetIndex).controller;
      u && u[i + "HoverStyle"](o.element, o.datasetIndex, o.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], s = t.map(({ datasetIndex: a, index: o }) => {
      const l = this.getDatasetMeta(a);
      if (!l)
        throw new Error("No dataset found at index " + a);
      return {
        datasetIndex: a,
        element: l.data[o],
        index: o
      };
    });
    !_elementsEqual(s, n) && (this._active = s, this._lastEvent = null, this._updateHoverStyles(s, n));
  }
  notifyPlugins(t, n, s) {
    return this._plugins.notify(this, t, n, s);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((n) => n.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, n, s) {
    const i = this.options.hover, a = (c, u) => c.filter((d) => !u.some((p) => d.datasetIndex === p.datasetIndex && d.index === p.index)), o = a(n, t), l = s ? t : a(t, n);
    o.length && this.updateHoverStyle(o, i.mode, !1), l.length && i.mode && this.updateHoverStyle(l, i.mode, !0);
  }
  _eventHandler(t, n) {
    const s = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, i = (o) => (o.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", s, i) === !1)
      return;
    const a = this._handleEvent(t, n, s.inChartArea);
    return s.cancelable = !1, this.notifyPlugins("afterEvent", s, i), (a || s.changed) && this.render(), this;
  }
  _handleEvent(t, n, s) {
    const { _active: i = [], options: a } = this, o = n, l = this._getActiveElements(t, i, s, o), c = _isClickEvent(t), u = determineLastEvent(t, this._lastEvent, s, c);
    s && (this._lastEvent = null, callback(a.onHover, [
      t,
      l,
      this
    ], this), c && callback(a.onClick, [
      t,
      l,
      this
    ], this));
    const d = !_elementsEqual(l, i);
    return (d || n) && (this._active = l, this._updateHoverStyles(l, i, n)), this._lastEvent = u, d;
  }
  _getActiveElements(t, n, s, i) {
    if (t.type === "mouseout")
      return [];
    if (!s)
      return n;
    const a = this.options.hover;
    return this.getElementsAtEventForMode(t, a.mode, a, i);
  }
}, pe(Re, "defaults", defaults), pe(Re, "instances", instances), pe(Re, "overrides", overrides), pe(Re, "registry", registry), pe(Re, "version", version), pe(Re, "getChart", getChart), Re);
function invalidatePlugins() {
  return each(Chart$1.instances, (e) => e._plugins.invalidate());
}
function setStyle(e, t, n = t) {
  e.lineCap = valueOrDefault(n.borderCapStyle, t.borderCapStyle), e.setLineDash(valueOrDefault(n.borderDash, t.borderDash)), e.lineDashOffset = valueOrDefault(n.borderDashOffset, t.borderDashOffset), e.lineJoin = valueOrDefault(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = valueOrDefault(n.borderWidth, t.borderWidth), e.strokeStyle = valueOrDefault(n.borderColor, t.borderColor);
}
function lineTo(e, t, n) {
  e.lineTo(n.x, n.y);
}
function getLineMethod(e) {
  return e.stepped ? _steppedLineTo : e.tension || e.cubicInterpolationMode === "monotone" ? _bezierCurveTo : lineTo;
}
function pathVars(e, t, n = {}) {
  const s = e.length, { start: i = 0, end: a = s - 1 } = n, { start: o, end: l } = t, c = Math.max(i, o), u = Math.min(a, l), d = i < o && a < o || i > l && a > l;
  return {
    count: s,
    start: c,
    loop: t.loop,
    ilen: u < c && !d ? s + u - c : u - c
  };
}
function pathSegment(e, t, n, s) {
  const { points: i, options: a } = t, { count: o, start: l, loop: c, ilen: u } = pathVars(i, n, s), d = getLineMethod(a);
  let { move: p = !0, reverse: f } = s || {}, g, C, k;
  for (g = 0; g <= u; ++g)
    C = i[(l + (f ? u - g : g)) % o], !C.skip && (p ? (e.moveTo(C.x, C.y), p = !1) : d(e, k, C, f, a.stepped), k = C);
  return c && (C = i[(l + (f ? u : 0)) % o], d(e, k, C, f, a.stepped)), !!c;
}
function fastPathSegment(e, t, n, s) {
  const i = t.points, { count: a, start: o, ilen: l } = pathVars(i, n, s), { move: c = !0, reverse: u } = s || {};
  let d = 0, p = 0, f, g, C, k, M, _;
  const S = (P) => (o + (u ? l - P : P)) % a, E = () => {
    k !== M && (e.lineTo(d, M), e.lineTo(d, k), e.lineTo(d, _));
  };
  for (c && (g = i[S(0)], e.moveTo(g.x, g.y)), f = 0; f <= l; ++f) {
    if (g = i[S(f)], g.skip)
      continue;
    const P = g.x, $ = g.y, A = P | 0;
    A === C ? ($ < k ? k = $ : $ > M && (M = $), d = (p * d + P) / ++p) : (E(), e.lineTo(P, $), C = A, p = 0, k = M = $), _ = $;
  }
  E();
}
function _getSegmentMethod(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(e) {
  return e.stepped ? _steppedInterpolation : e.tension || e.cubicInterpolationMode === "monotone" ? _bezierInterpolation : _pointInLine;
}
function strokePathWithCache(e, t, n, s) {
  let i = t._path;
  i || (i = t._path = new Path2D(), t.path(i, n, s) && i.closePath()), setStyle(e, t.options), e.stroke(i);
}
function strokePathDirect(e, t, n, s) {
  const { segments: i, options: a } = t, o = _getSegmentMethod(t);
  for (const l of i)
    setStyle(e, a, l.style), e.beginPath(), o(e, t, l, {
      start: n,
      end: n + s - 1
    }) && e.closePath(), e.stroke();
}
const usePath2D = typeof Path2D == "function";
function draw(e, t, n, s) {
  usePath2D && !t.options.segment ? strokePathWithCache(e, t, n, s) : strokePathDirect(e, t, n, s);
}
class LineElement extends Element$1 {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const s = this.options;
    if ((s.tension || s.cubicInterpolationMode === "monotone") && !s.stepped && !this._pointsUpdated) {
      const i = s.spanGaps ? this._loop : this._fullLoop;
      _updateBezierControlPoints(this._points, s, t, i, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = _computeSegments(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, s = t.length;
    return s && n[t[s - 1].end];
  }
  interpolate(t, n) {
    const s = this.options, i = t[n], a = this.points, o = _boundSegments(this, {
      property: n,
      start: i,
      end: i
    });
    if (!o.length)
      return;
    const l = [], c = _getInterpolationMethod(s);
    let u, d;
    for (u = 0, d = o.length; u < d; ++u) {
      const { start: p, end: f } = o[u], g = a[p], C = a[f];
      if (g === C) {
        l.push(g);
        continue;
      }
      const k = Math.abs((i - g[n]) / (C[n] - g[n])), M = c(g, C, k, s.stepped);
      M[n] = t[n], l.push(M);
    }
    return l.length === 1 ? l[0] : l;
  }
  pathSegment(t, n, s) {
    return _getSegmentMethod(this)(t, this, n, s);
  }
  path(t, n, s) {
    const i = this.segments, a = _getSegmentMethod(this);
    let o = this._loop;
    n = n || 0, s = s || this.points.length - n;
    for (const l of i)
      o &= a(t, this, l, {
        start: n,
        end: n + s - 1
      });
    return !!o;
  }
  draw(t, n, s, i) {
    const a = this.options || {};
    (this.points || []).length && a.borderWidth && (t.save(), draw(t, this, s, i), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
pe(LineElement, "id", "line"), pe(LineElement, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), pe(LineElement, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), pe(LineElement, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function inRange$1(e, t, n, s) {
  const i = e.options, { [n]: a } = e.getProps([
    n
  ], s);
  return Math.abs(t - a) < i.radius + i.hitRadius;
}
class PointElement extends Element$1 {
  constructor(n) {
    super();
    pe(this, "parsed");
    pe(this, "skip");
    pe(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, s, i) {
    const a = this.options, { x: o, y: l } = this.getProps([
      "x",
      "y"
    ], i);
    return Math.pow(n - o, 2) + Math.pow(s - l, 2) < Math.pow(a.hitRadius + a.radius, 2);
  }
  inXRange(n, s) {
    return inRange$1(this, n, "x", s);
  }
  inYRange(n, s) {
    return inRange$1(this, n, "y", s);
  }
  getCenterPoint(n) {
    const { x: s, y: i } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: s,
      y: i
    };
  }
  size(n) {
    n = n || this.options || {};
    let s = n.radius || 0;
    s = Math.max(s, s && n.hoverRadius || 0);
    const i = s && n.borderWidth || 0;
    return (s + i) * 2;
  }
  draw(n, s) {
    const i = this.options;
    this.skip || i.radius < 0.1 || !_isPointInArea(this, s, this.size(i) / 2) || (n.strokeStyle = i.borderColor, n.lineWidth = i.borderWidth, n.fillStyle = i.backgroundColor, drawPoint(n, i, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
pe(PointElement, "id", "point"), /**
* @type {any}
*/
pe(PointElement, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
pe(PointElement, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function _segments(e, t, n) {
  const s = e.segments, i = e.points, a = t.points, o = [];
  for (const l of s) {
    let { start: c, end: u } = l;
    u = _findSegmentEnd(c, u, i);
    const d = _getBounds(n, i[c], i[u], l.loop);
    if (!t.segments) {
      o.push({
        source: l,
        target: d,
        start: i[c],
        end: i[u]
      });
      continue;
    }
    const p = _boundSegments(t, d);
    for (const f of p) {
      const g = _getBounds(n, a[f.start], a[f.end], f.loop), C = _boundSegment(l, i, g);
      for (const k of C)
        o.push({
          source: k,
          target: f,
          start: {
            [n]: _getEdge(d, g, "start", Math.max)
          },
          end: {
            [n]: _getEdge(d, g, "end", Math.min)
          }
        });
    }
  }
  return o;
}
function _getBounds(e, t, n, s) {
  if (s)
    return;
  let i = t[e], a = n[e];
  return e === "angle" && (i = _normalizeAngle(i), a = _normalizeAngle(a)), {
    property: e,
    start: i,
    end: a
  };
}
function _pointsFromSegments(e, t) {
  const { x: n = null, y: s = null } = e || {}, i = t.points, a = [];
  return t.segments.forEach(({ start: o, end: l }) => {
    l = _findSegmentEnd(o, l, i);
    const c = i[o], u = i[l];
    s !== null ? (a.push({
      x: c.x,
      y: s
    }), a.push({
      x: u.x,
      y: s
    })) : n !== null && (a.push({
      x: n,
      y: c.y
    }), a.push({
      x: n,
      y: u.y
    }));
  }), a;
}
function _findSegmentEnd(e, t, n) {
  for (; t > e; t--) {
    const s = n[t];
    if (!isNaN(s.x) && !isNaN(s.y))
      break;
  }
  return t;
}
function _getEdge(e, t, n, s) {
  return e && t ? s(e[n], t[n]) : e ? e[n] : t ? t[n] : 0;
}
function _createBoundaryLine(e, t) {
  let n = [], s = !1;
  return isArray(e) ? (s = !0, n = e) : n = _pointsFromSegments(e, t), n.length ? new LineElement({
    points: n,
    options: {
      tension: 0
    },
    _loop: s,
    _fullLoop: s
  }) : null;
}
function _shouldApplyFill(e) {
  return e && e.fill !== !1;
}
function _resolveTarget(e, t, n) {
  let i = e[t].fill;
  const a = [
    t
  ];
  let o;
  if (!n)
    return i;
  for (; i !== !1 && a.indexOf(i) === -1; ) {
    if (!isNumberFinite(i))
      return i;
    if (o = e[i], !o)
      return !1;
    if (o.visible)
      return i;
    a.push(i), i = o.fill;
  }
  return !1;
}
function _decodeFill(e, t, n) {
  const s = parseFillOption(e);
  if (isObject(s))
    return isNaN(s.value) ? !1 : s;
  let i = parseFloat(s);
  return isNumberFinite(i) && Math.floor(i) === i ? decodeTargetIndex(s[0], t, i, n) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(s) >= 0 && s;
}
function decodeTargetIndex(e, t, n, s) {
  return (e === "-" || e === "+") && (n = t + n), n === t || n < 0 || n >= s ? !1 : n;
}
function _getTargetPixel(e, t) {
  let n = null;
  return e === "start" ? n = t.bottom : e === "end" ? n = t.top : isObject(e) ? n = t.getPixelForValue(e.value) : t.getBasePixel && (n = t.getBasePixel()), n;
}
function _getTargetValue(e, t, n) {
  let s;
  return e === "start" ? s = n : e === "end" ? s = t.options.reverse ? t.min : t.max : isObject(e) ? s = e.value : s = t.getBaseValue(), s;
}
function parseFillOption(e) {
  const t = e.options, n = t.fill;
  let s = valueOrDefault(n && n.target, n);
  return s === void 0 && (s = !!t.backgroundColor), s === !1 || s === null ? !1 : s === !0 ? "origin" : s;
}
function _buildStackLine(e) {
  const { scale: t, index: n, line: s } = e, i = [], a = s.segments, o = s.points, l = getLinesBelow(t, n);
  l.push(_createBoundaryLine({
    x: null,
    y: t.bottom
  }, s));
  for (let c = 0; c < a.length; c++) {
    const u = a[c];
    for (let d = u.start; d <= u.end; d++)
      addPointsBelow(i, o[d], l);
  }
  return new LineElement({
    points: i,
    options: {}
  });
}
function getLinesBelow(e, t) {
  const n = [], s = e.getMatchingVisibleMetas("line");
  for (let i = 0; i < s.length; i++) {
    const a = s[i];
    if (a.index === t)
      break;
    a.hidden || n.unshift(a.dataset);
  }
  return n;
}
function addPointsBelow(e, t, n) {
  const s = [];
  for (let i = 0; i < n.length; i++) {
    const a = n[i], { first: o, last: l, point: c } = findPoint(a, t, "x");
    if (!(!c || o && l)) {
      if (o)
        s.unshift(c);
      else if (e.push(c), !l)
        break;
    }
  }
  e.push(...s);
}
function findPoint(e, t, n) {
  const s = e.interpolate(t, n);
  if (!s)
    return {};
  const i = s[n], a = e.segments, o = e.points;
  let l = !1, c = !1;
  for (let u = 0; u < a.length; u++) {
    const d = a[u], p = o[d.start][n], f = o[d.end][n];
    if (_isBetween(i, p, f)) {
      l = i === p, c = i === f;
      break;
    }
  }
  return {
    first: l,
    last: c,
    point: s
  };
}
class simpleArc {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, n, s) {
    const { x: i, y: a, radius: o } = this;
    return n = n || {
      start: 0,
      end: TAU
    }, t.arc(i, a, o, n.end, n.start, !0), !s.bounds;
  }
  interpolate(t) {
    const { x: n, y: s, radius: i } = this, a = t.angle;
    return {
      x: n + Math.cos(a) * i,
      y: s + Math.sin(a) * i,
      angle: a
    };
  }
}
function _getTarget(e) {
  const { chart: t, fill: n, line: s } = e;
  if (isNumberFinite(n))
    return getLineByIndex(t, n);
  if (n === "stack")
    return _buildStackLine(e);
  if (n === "shape")
    return !0;
  const i = computeBoundary(e);
  return i instanceof simpleArc ? i : _createBoundaryLine(i, s);
}
function getLineByIndex(e, t) {
  const n = e.getDatasetMeta(t);
  return n && e.isDatasetVisible(t) ? n.dataset : null;
}
function computeBoundary(e) {
  return (e.scale || {}).getPointPositionForValue ? computeCircularBoundary(e) : computeLinearBoundary(e);
}
function computeLinearBoundary(e) {
  const { scale: t = {}, fill: n } = e, s = _getTargetPixel(n, t);
  if (isNumberFinite(s)) {
    const i = t.isHorizontal();
    return {
      x: i ? s : null,
      y: i ? null : s
    };
  }
  return null;
}
function computeCircularBoundary(e) {
  const { scale: t, fill: n } = e, s = t.options, i = t.getLabels().length, a = s.reverse ? t.max : t.min, o = _getTargetValue(n, t, a), l = [];
  if (s.grid.circular) {
    const c = t.getPointPositionForValue(0, a);
    return new simpleArc({
      x: c.x,
      y: c.y,
      radius: t.getDistanceFromCenterForValue(o)
    });
  }
  for (let c = 0; c < i; ++c)
    l.push(t.getPointPositionForValue(c, o));
  return l;
}
function _drawfill(e, t, n) {
  const s = _getTarget(t), { line: i, scale: a, axis: o } = t, l = i.options, c = l.fill, u = l.backgroundColor, { above: d = u, below: p = u } = c || {};
  s && i.points.length && (clipArea(e, n), doFill(e, {
    line: i,
    target: s,
    above: d,
    below: p,
    area: n,
    scale: a,
    axis: o
  }), unclipArea(e));
}
function doFill(e, t) {
  const { line: n, target: s, above: i, below: a, area: o, scale: l } = t, c = n._loop ? "angle" : t.axis;
  e.save(), c === "x" && a !== i && (clipVertical(e, s, o.top), fill(e, {
    line: n,
    target: s,
    color: i,
    scale: l,
    property: c
  }), e.restore(), e.save(), clipVertical(e, s, o.bottom)), fill(e, {
    line: n,
    target: s,
    color: a,
    scale: l,
    property: c
  }), e.restore();
}
function clipVertical(e, t, n) {
  const { segments: s, points: i } = t;
  let a = !0, o = !1;
  e.beginPath();
  for (const l of s) {
    const { start: c, end: u } = l, d = i[c], p = i[_findSegmentEnd(c, u, i)];
    a ? (e.moveTo(d.x, d.y), a = !1) : (e.lineTo(d.x, n), e.lineTo(d.x, d.y)), o = !!t.pathSegment(e, l, {
      move: o
    }), o ? e.closePath() : e.lineTo(p.x, n);
  }
  e.lineTo(t.first().x, n), e.closePath(), e.clip();
}
function fill(e, t) {
  const { line: n, target: s, property: i, color: a, scale: o } = t, l = _segments(n, s, i);
  for (const { source: c, target: u, start: d, end: p } of l) {
    const { style: { backgroundColor: f = a } = {} } = c, g = s !== !0;
    e.save(), e.fillStyle = f, clipBounds(e, o, g && _getBounds(i, d, p)), e.beginPath();
    const C = !!n.pathSegment(e, c);
    let k;
    if (g) {
      C ? e.closePath() : interpolatedLineTo(e, s, p, i);
      const M = !!s.pathSegment(e, u, {
        move: C,
        reverse: !0
      });
      k = C && M, k || interpolatedLineTo(e, s, d, i);
    }
    e.closePath(), e.fill(k ? "evenodd" : "nonzero"), e.restore();
  }
}
function clipBounds(e, t, n) {
  const { top: s, bottom: i } = t.chart.chartArea, { property: a, start: o, end: l } = n || {};
  a === "x" && (e.beginPath(), e.rect(o, s, l - o, i - s), e.clip());
}
function interpolatedLineTo(e, t, n, s) {
  const i = t.interpolate(n, s);
  i && e.lineTo(i.x, i.y);
}
var index = {
  id: "filler",
  afterDatasetsUpdate(e, t, n) {
    const s = (e.data.datasets || []).length, i = [];
    let a, o, l, c;
    for (o = 0; o < s; ++o)
      a = e.getDatasetMeta(o), l = a.dataset, c = null, l && l.options && l instanceof LineElement && (c = {
        visible: e.isDatasetVisible(o),
        index: o,
        fill: _decodeFill(l, o, s),
        chart: e,
        axis: a.controller.options.indexAxis,
        scale: a.vScale,
        line: l
      }), a.$filler = c, i.push(c);
    for (o = 0; o < s; ++o)
      c = i[o], !(!c || c.fill === !1) && (c.fill = _resolveTarget(i, o, n.propagate));
  },
  beforeDraw(e, t, n) {
    const s = n.drawTime === "beforeDraw", i = e.getSortedVisibleDatasetMetas(), a = e.chartArea;
    for (let o = i.length - 1; o >= 0; --o) {
      const l = i[o].$filler;
      l && (l.line.updateControlPoints(a, l.axis), s && l.fill && _drawfill(e.ctx, l, a));
    }
  },
  beforeDatasetsDraw(e, t, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const s = e.getSortedVisibleDatasetMetas();
    for (let i = s.length - 1; i >= 0; --i) {
      const a = s[i].$filler;
      _shouldApplyFill(a) && _drawfill(e.ctx, a, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, n) {
    const s = t.meta.$filler;
    !_shouldApplyFill(s) || n.drawTime !== "beforeDatasetDraw" || _drawfill(e.ctx, s, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const positioners = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, s = 0, i = 0, a = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const o = e[t].element;
      if (o && o.hasValue()) {
        const l = o.tooltipPosition();
        s += l.x, i += l.y, ++a;
      }
    }
    return {
      x: s / a,
      y: i / a
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, s = t.y, i = Number.POSITIVE_INFINITY, a, o, l;
    for (a = 0, o = e.length; a < o; ++a) {
      const c = e[a].element;
      if (c && c.hasValue()) {
        const u = c.getCenterPoint(), d = distanceBetweenPoints(t, u);
        d < i && (i = d, l = c);
      }
    }
    if (l) {
      const c = l.tooltipPosition();
      n = c.x, s = c.y;
    }
    return {
      x: n,
      y: s
    };
  }
};
function pushOrConcat(e, t) {
  return t && (isArray(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function splitNewlines(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function createTooltipItem(e, t) {
  const { element: n, datasetIndex: s, index: i } = t, a = e.getDatasetMeta(s).controller, { label: o, value: l } = a.getLabelAndValue(i);
  return {
    chart: e,
    label: o,
    parsed: a.getParsed(i),
    raw: e.data.datasets[s].data[i],
    formattedValue: l,
    dataset: a.getDataset(),
    dataIndex: i,
    datasetIndex: s,
    element: n
  };
}
function getTooltipSize(e, t) {
  const n = e.chart.ctx, { body: s, footer: i, title: a } = e, { boxWidth: o, boxHeight: l } = t, c = toFont(t.bodyFont), u = toFont(t.titleFont), d = toFont(t.footerFont), p = a.length, f = i.length, g = s.length, C = toPadding(t.padding);
  let k = C.height, M = 0, _ = s.reduce((P, $) => P + $.before.length + $.lines.length + $.after.length, 0);
  if (_ += e.beforeBody.length + e.afterBody.length, p && (k += p * u.lineHeight + (p - 1) * t.titleSpacing + t.titleMarginBottom), _) {
    const P = t.displayColors ? Math.max(l, c.lineHeight) : c.lineHeight;
    k += g * P + (_ - g) * c.lineHeight + (_ - 1) * t.bodySpacing;
  }
  f && (k += t.footerMarginTop + f * d.lineHeight + (f - 1) * t.footerSpacing);
  let S = 0;
  const E = function(P) {
    M = Math.max(M, n.measureText(P).width + S);
  };
  return n.save(), n.font = u.string, each(e.title, E), n.font = c.string, each(e.beforeBody.concat(e.afterBody), E), S = t.displayColors ? o + 2 + t.boxPadding : 0, each(s, (P) => {
    each(P.before, E), each(P.lines, E), each(P.after, E);
  }), S = 0, n.font = d.string, each(e.footer, E), n.restore(), M += C.width, {
    width: M,
    height: k
  };
}
function determineYAlign(e, t) {
  const { y: n, height: s } = t;
  return n < s / 2 ? "top" : n > e.height - s / 2 ? "bottom" : "center";
}
function doesNotFitWithAlign(e, t, n, s) {
  const { x: i, width: a } = s, o = n.caretSize + n.caretPadding;
  if (e === "left" && i + a + o > t.width || e === "right" && i - a - o < 0)
    return !0;
}
function determineXAlign(e, t, n, s) {
  const { x: i, width: a } = n, { width: o, chartArea: { left: l, right: c } } = e;
  let u = "center";
  return s === "center" ? u = i <= (l + c) / 2 ? "left" : "right" : i <= a / 2 ? u = "left" : i >= o - a / 2 && (u = "right"), doesNotFitWithAlign(u, e, t, n) && (u = "center"), u;
}
function determineAlignment(e, t, n) {
  const s = n.yAlign || t.yAlign || determineYAlign(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || determineXAlign(e, t, n, s),
    yAlign: s
  };
}
function alignX(e, t) {
  let { x: n, width: s } = e;
  return t === "right" ? n -= s : t === "center" && (n -= s / 2), n;
}
function alignY(e, t, n) {
  let { y: s, height: i } = e;
  return t === "top" ? s += n : t === "bottom" ? s -= i + n : s -= i / 2, s;
}
function getBackgroundPoint(e, t, n, s) {
  const { caretSize: i, caretPadding: a, cornerRadius: o } = e, { xAlign: l, yAlign: c } = n, u = i + a, { topLeft: d, topRight: p, bottomLeft: f, bottomRight: g } = toTRBLCorners(o);
  let C = alignX(t, l);
  const k = alignY(t, c, u);
  return c === "center" ? l === "left" ? C += u : l === "right" && (C -= u) : l === "left" ? C -= Math.max(d, f) + i : l === "right" && (C += Math.max(p, g) + i), {
    x: _limitValue(C, 0, s.width - t.width),
    y: _limitValue(k, 0, s.height - t.height)
  };
}
function getAlignedX(e, t, n) {
  const s = toPadding(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - s.right : e.x + s.left;
}
function getBeforeAfterBodyLines(e) {
  return pushOrConcat([], splitNewlines(e));
}
function createTooltipContext(e, t, n) {
  return createContext(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function overrideCallbacks(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
const defaultCallbacks = {
  beforeTitle: noop,
  title(e) {
    if (e.length > 0) {
      const t = e[0], n = t.chart.data.labels, s = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (s > 0 && t.dataIndex < s)
        return n[t.dataIndex];
    }
    return "";
  },
  afterTitle: noop,
  beforeBody: noop,
  beforeLabel: noop,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let t = e.dataset.label || "";
    t && (t += ": ");
    const n = e.formattedValue;
    return isNullOrUndef(n) || (t += n), t;
  },
  labelColor(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: noop,
  afterBody: noop,
  beforeFooter: noop,
  footer: noop,
  afterFooter: noop
};
function invokeCallbackWithFallback(e, t, n, s) {
  const i = e[t].call(n, s);
  return typeof i > "u" ? defaultCallbacks[t].call(n, s) : i;
}
class Tooltip extends Element$1 {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, s = this.options.setContext(this.getContext()), i = s.enabled && n.options.animation && s.animations, a = new Animations(this.chart, i);
    return i._cacheable && (this._cachedAnimations = Object.freeze(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: s } = n, i = invokeCallbackWithFallback(s, "beforeTitle", this, t), a = invokeCallbackWithFallback(s, "title", this, t), o = invokeCallbackWithFallback(s, "afterTitle", this, t);
    let l = [];
    return l = pushOrConcat(l, splitNewlines(i)), l = pushOrConcat(l, splitNewlines(a)), l = pushOrConcat(l, splitNewlines(o)), l;
  }
  getBeforeBody(t, n) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(n.callbacks, "beforeBody", this, t));
  }
  getBody(t, n) {
    const { callbacks: s } = n, i = [];
    return each(t, (a) => {
      const o = {
        before: [],
        lines: [],
        after: []
      }, l = overrideCallbacks(s, a);
      pushOrConcat(o.before, splitNewlines(invokeCallbackWithFallback(l, "beforeLabel", this, a))), pushOrConcat(o.lines, invokeCallbackWithFallback(l, "label", this, a)), pushOrConcat(o.after, splitNewlines(invokeCallbackWithFallback(l, "afterLabel", this, a))), i.push(o);
    }), i;
  }
  getAfterBody(t, n) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(n.callbacks, "afterBody", this, t));
  }
  getFooter(t, n) {
    const { callbacks: s } = n, i = invokeCallbackWithFallback(s, "beforeFooter", this, t), a = invokeCallbackWithFallback(s, "footer", this, t), o = invokeCallbackWithFallback(s, "afterFooter", this, t);
    let l = [];
    return l = pushOrConcat(l, splitNewlines(i)), l = pushOrConcat(l, splitNewlines(a)), l = pushOrConcat(l, splitNewlines(o)), l;
  }
  _createItems(t) {
    const n = this._active, s = this.chart.data, i = [], a = [], o = [];
    let l = [], c, u;
    for (c = 0, u = n.length; c < u; ++c)
      l.push(createTooltipItem(this.chart, n[c]));
    return t.filter && (l = l.filter((d, p, f) => t.filter(d, p, f, s))), t.itemSort && (l = l.sort((d, p) => t.itemSort(d, p, s))), each(l, (d) => {
      const p = overrideCallbacks(t.callbacks, d);
      i.push(invokeCallbackWithFallback(p, "labelColor", this, d)), a.push(invokeCallbackWithFallback(p, "labelPointStyle", this, d)), o.push(invokeCallbackWithFallback(p, "labelTextColor", this, d));
    }), this.labelColors = i, this.labelPointStyles = a, this.labelTextColors = o, this.dataPoints = l, l;
  }
  update(t, n) {
    const s = this.options.setContext(this.getContext()), i = this._active;
    let a, o = [];
    if (!i.length)
      this.opacity !== 0 && (a = {
        opacity: 0
      });
    else {
      const l = positioners[s.position].call(this, i, this._eventPosition);
      o = this._createItems(s), this.title = this.getTitle(o, s), this.beforeBody = this.getBeforeBody(o, s), this.body = this.getBody(o, s), this.afterBody = this.getAfterBody(o, s), this.footer = this.getFooter(o, s);
      const c = this._size = getTooltipSize(this, s), u = Object.assign({}, l, c), d = determineAlignment(this.chart, s, u), p = getBackgroundPoint(s, u, d, this.chart);
      this.xAlign = d.xAlign, this.yAlign = d.yAlign, a = {
        opacity: 1,
        x: p.x,
        y: p.y,
        width: c.width,
        height: c.height,
        caretX: l.x,
        caretY: l.y
      };
    }
    this._tooltipItems = o, this.$context = void 0, a && this._resolveAnimations().update(this, a), t && s.external && s.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(t, n, s, i) {
    const a = this.getCaretPosition(t, s, i);
    n.lineTo(a.x1, a.y1), n.lineTo(a.x2, a.y2), n.lineTo(a.x3, a.y3);
  }
  getCaretPosition(t, n, s) {
    const { xAlign: i, yAlign: a } = this, { caretSize: o, cornerRadius: l } = s, { topLeft: c, topRight: u, bottomLeft: d, bottomRight: p } = toTRBLCorners(l), { x: f, y: g } = t, { width: C, height: k } = n;
    let M, _, S, E, P, $;
    return a === "center" ? (P = g + k / 2, i === "left" ? (M = f, _ = M - o, E = P + o, $ = P - o) : (M = f + C, _ = M + o, E = P - o, $ = P + o), S = M) : (i === "left" ? _ = f + Math.max(c, d) + o : i === "right" ? _ = f + C - Math.max(u, p) - o : _ = this.caretX, a === "top" ? (E = g, P = E - o, M = _ - o, S = _ + o) : (E = g + k, P = E + o, M = _ + o, S = _ - o), $ = E), {
      x1: M,
      x2: _,
      x3: S,
      y1: E,
      y2: P,
      y3: $
    };
  }
  drawTitle(t, n, s) {
    const i = this.title, a = i.length;
    let o, l, c;
    if (a) {
      const u = getRtlAdapter(s.rtl, this.x, this.width);
      for (t.x = getAlignedX(this, s.titleAlign, s), n.textAlign = u.textAlign(s.titleAlign), n.textBaseline = "middle", o = toFont(s.titleFont), l = s.titleSpacing, n.fillStyle = s.titleColor, n.font = o.string, c = 0; c < a; ++c)
        n.fillText(i[c], u.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + l, c + 1 === a && (t.y += s.titleMarginBottom - l);
    }
  }
  _drawColorBox(t, n, s, i, a) {
    const o = this.labelColors[s], l = this.labelPointStyles[s], { boxHeight: c, boxWidth: u } = a, d = toFont(a.bodyFont), p = getAlignedX(this, "left", a), f = i.x(p), g = c < d.lineHeight ? (d.lineHeight - c) / 2 : 0, C = n.y + g;
    if (a.usePointStyle) {
      const k = {
        radius: Math.min(u, c) / 2,
        pointStyle: l.pointStyle,
        rotation: l.rotation,
        borderWidth: 1
      }, M = i.leftForLtr(f, u) + u / 2, _ = C + c / 2;
      t.strokeStyle = a.multiKeyBackground, t.fillStyle = a.multiKeyBackground, drawPoint(t, k, M, _), t.strokeStyle = o.borderColor, t.fillStyle = o.backgroundColor, drawPoint(t, k, M, _);
    } else {
      t.lineWidth = isObject(o.borderWidth) ? Math.max(...Object.values(o.borderWidth)) : o.borderWidth || 1, t.strokeStyle = o.borderColor, t.setLineDash(o.borderDash || []), t.lineDashOffset = o.borderDashOffset || 0;
      const k = i.leftForLtr(f, u), M = i.leftForLtr(i.xPlus(f, 1), u - 2), _ = toTRBLCorners(o.borderRadius);
      Object.values(_).some((S) => S !== 0) ? (t.beginPath(), t.fillStyle = a.multiKeyBackground, addRoundedRectPath(t, {
        x: k,
        y: C,
        w: u,
        h: c,
        radius: _
      }), t.fill(), t.stroke(), t.fillStyle = o.backgroundColor, t.beginPath(), addRoundedRectPath(t, {
        x: M,
        y: C + 1,
        w: u - 2,
        h: c - 2,
        radius: _
      }), t.fill()) : (t.fillStyle = a.multiKeyBackground, t.fillRect(k, C, u, c), t.strokeRect(k, C, u, c), t.fillStyle = o.backgroundColor, t.fillRect(M, C + 1, u - 2, c - 2));
    }
    t.fillStyle = this.labelTextColors[s];
  }
  drawBody(t, n, s) {
    const { body: i } = this, { bodySpacing: a, bodyAlign: o, displayColors: l, boxHeight: c, boxWidth: u, boxPadding: d } = s, p = toFont(s.bodyFont);
    let f = p.lineHeight, g = 0;
    const C = getRtlAdapter(s.rtl, this.x, this.width), k = function(D) {
      n.fillText(D, C.x(t.x + g), t.y + f / 2), t.y += f + a;
    }, M = C.textAlign(o);
    let _, S, E, P, $, A, I;
    for (n.textAlign = o, n.textBaseline = "middle", n.font = p.string, t.x = getAlignedX(this, M, s), n.fillStyle = s.bodyColor, each(this.beforeBody, k), g = l && M !== "right" ? o === "center" ? u / 2 + d : u + 2 + d : 0, P = 0, A = i.length; P < A; ++P) {
      for (_ = i[P], S = this.labelTextColors[P], n.fillStyle = S, each(_.before, k), E = _.lines, l && E.length && (this._drawColorBox(n, t, P, C, s), f = Math.max(p.lineHeight, c)), $ = 0, I = E.length; $ < I; ++$)
        k(E[$]), f = p.lineHeight;
      each(_.after, k);
    }
    g = 0, f = p.lineHeight, each(this.afterBody, k), t.y -= a;
  }
  drawFooter(t, n, s) {
    const i = this.footer, a = i.length;
    let o, l;
    if (a) {
      const c = getRtlAdapter(s.rtl, this.x, this.width);
      for (t.x = getAlignedX(this, s.footerAlign, s), t.y += s.footerMarginTop, n.textAlign = c.textAlign(s.footerAlign), n.textBaseline = "middle", o = toFont(s.footerFont), n.fillStyle = s.footerColor, n.font = o.string, l = 0; l < a; ++l)
        n.fillText(i[l], c.x(t.x), t.y + o.lineHeight / 2), t.y += o.lineHeight + s.footerSpacing;
    }
  }
  drawBackground(t, n, s, i) {
    const { xAlign: a, yAlign: o } = this, { x: l, y: c } = t, { width: u, height: d } = s, { topLeft: p, topRight: f, bottomLeft: g, bottomRight: C } = toTRBLCorners(i.cornerRadius);
    n.fillStyle = i.backgroundColor, n.strokeStyle = i.borderColor, n.lineWidth = i.borderWidth, n.beginPath(), n.moveTo(l + p, c), o === "top" && this.drawCaret(t, n, s, i), n.lineTo(l + u - f, c), n.quadraticCurveTo(l + u, c, l + u, c + f), o === "center" && a === "right" && this.drawCaret(t, n, s, i), n.lineTo(l + u, c + d - C), n.quadraticCurveTo(l + u, c + d, l + u - C, c + d), o === "bottom" && this.drawCaret(t, n, s, i), n.lineTo(l + g, c + d), n.quadraticCurveTo(l, c + d, l, c + d - g), o === "center" && a === "left" && this.drawCaret(t, n, s, i), n.lineTo(l, c + p), n.quadraticCurveTo(l, c, l + p, c), n.closePath(), n.fill(), i.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, s = this.$animations, i = s && s.x, a = s && s.y;
    if (i || a) {
      const o = positioners[t.position].call(this, this._active, this._eventPosition);
      if (!o)
        return;
      const l = this._size = getTooltipSize(this, t), c = Object.assign({}, o, this._size), u = determineAlignment(n, t, c), d = getBackgroundPoint(t, c, u, n);
      (i._to !== d.x || a._to !== d.y) && (this.xAlign = u.xAlign, this.yAlign = u.yAlign, this.width = l.width, this.height = l.height, this.caretX = o.x, this.caretY = o.y, this._resolveAnimations().update(this, d));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let s = this.opacity;
    if (!s)
      return;
    this._updateAnimationTarget(n);
    const i = {
      width: this.width,
      height: this.height
    }, a = {
      x: this.x,
      y: this.y
    };
    s = Math.abs(s) < 1e-3 ? 0 : s;
    const o = toPadding(n.padding), l = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && l && (t.save(), t.globalAlpha = s, this.drawBackground(a, t, i, n), overrideTextDirection(t, n.textDirection), a.y += o.top, this.drawTitle(a, t, n), this.drawBody(a, t, n), this.drawFooter(a, t, n), restoreTextDirection(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const s = this._active, i = t.map(({ datasetIndex: l, index: c }) => {
      const u = this.chart.getDatasetMeta(l);
      if (!u)
        throw new Error("Cannot find a dataset at index " + l);
      return {
        datasetIndex: l,
        element: u.data[c],
        index: c
      };
    }), a = !_elementsEqual(s, i), o = this._positionChanged(i, n);
    (a || o) && (this._active = i, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, s = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const i = this.options, a = this._active || [], o = this._getActiveElements(t, a, n, s), l = this._positionChanged(o, t), c = n || !_elementsEqual(o, a) || l;
    return c && (this._active = o, (i.enabled || i.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), c;
  }
  _getActiveElements(t, n, s, i) {
    const a = this.options;
    if (t.type === "mouseout")
      return [];
    if (!i)
      return n;
    const o = this.chart.getElementsAtEventForMode(t, a.mode, a, s);
    return a.reverse && o.reverse(), o;
  }
  _positionChanged(t, n) {
    const { caretX: s, caretY: i, options: a } = this, o = positioners[a.position].call(this, t, n);
    return o !== !1 && (s !== o.x || i !== o.y);
  }
}
pe(Tooltip, "positioners", positioners);
var plugin_tooltip = {
  id: "tooltip",
  _element: Tooltip,
  positioners,
  afterInit(e, t, n) {
    n && (e.tooltip = new Tooltip({
      chart: e,
      options: n
    }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: defaultCallbacks
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const addIfString = (e, t, n, s) => (typeof t == "string" ? (n = e.push(t) - 1, s.unshift({
  index: n,
  label: t
})) : isNaN(t) && (n = null), n);
function findOrAddLabel(e, t, n, s) {
  const i = e.indexOf(t);
  if (i === -1)
    return addIfString(e, t, n, s);
  const a = e.lastIndexOf(t);
  return i !== a ? n : i;
}
const validIndex = (e, t) => e === null ? null : _limitValue(Math.round(e), 0, t);
function _getLabelForValue(e) {
  const t = this.getLabels();
  return e >= 0 && e < t.length ? t[e] : e;
}
class CategoryScale extends Scale {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const s = this.getLabels();
      for (const { index: i, label: a } of n)
        s[i] === a && s.splice(i, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (isNullOrUndef(t))
      return null;
    const s = this.getLabels();
    return n = isFinite(n) && s[n] === t ? n : findOrAddLabel(s, t, valueOrDefault(n, t), this._addedLabels), validIndex(n, s.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: s, max: i } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (s = 0), n || (i = this.getLabels().length - 1)), this.min = s, this.max = i;
  }
  buildTicks() {
    const t = this.min, n = this.max, s = this.options.offset, i = [];
    let a = this.getLabels();
    a = t === 0 && n === a.length - 1 ? a : a.slice(t, n + 1), this._valueRange = Math.max(a.length - (s ? 0 : 1), 1), this._startValue = this.min - (s ? 0.5 : 0);
    for (let o = t; o <= n; o++)
      i.push({
        value: o
      });
    return i;
  }
  getLabelForValue(t) {
    return _getLabelForValue.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
pe(CategoryScale, "id", "category"), pe(CategoryScale, "defaults", {
  ticks: {
    callback: _getLabelForValue
  }
});
function generateTicks$1(e, t) {
  const n = [], { bounds: i, step: a, min: o, max: l, precision: c, count: u, maxTicks: d, maxDigits: p, includeBounds: f } = e, g = a || 1, C = d - 1, { min: k, max: M } = t, _ = !isNullOrUndef(o), S = !isNullOrUndef(l), E = !isNullOrUndef(u), P = (M - k) / (p + 1);
  let $ = niceNum((M - k) / C / g) * g, A, I, D, R;
  if ($ < 1e-14 && !_ && !S)
    return [
      {
        value: k
      },
      {
        value: M
      }
    ];
  R = Math.ceil(M / $) - Math.floor(k / $), R > C && ($ = niceNum(R * $ / C / g) * g), isNullOrUndef(c) || (A = Math.pow(10, c), $ = Math.ceil($ * A) / A), i === "ticks" ? (I = Math.floor(k / $) * $, D = Math.ceil(M / $) * $) : (I = k, D = M), _ && S && a && almostWhole((l - o) / a, $ / 1e3) ? (R = Math.round(Math.min((l - o) / $, d)), $ = (l - o) / R, I = o, D = l) : E ? (I = _ ? o : I, D = S ? l : D, R = u - 1, $ = (D - I) / R) : (R = (D - I) / $, almostEquals(R, Math.round(R), $ / 1e3) ? R = Math.round(R) : R = Math.ceil(R));
  const Y = Math.max(_decimalPlaces($), _decimalPlaces(I));
  A = Math.pow(10, isNullOrUndef(c) ? Y : c), I = Math.round(I * A) / A, D = Math.round(D * A) / A;
  let q = 0;
  for (_ && (f && I !== o ? (n.push({
    value: o
  }), I < o && q++, almostEquals(Math.round((I + q * $) * A) / A, o, relativeLabelSize(o, P, e)) && q++) : I < o && q++); q < R; ++q) {
    const j = Math.round((I + q * $) * A) / A;
    if (S && j > l)
      break;
    n.push({
      value: j
    });
  }
  return S && f && D !== l ? n.length && almostEquals(n[n.length - 1].value, l, relativeLabelSize(l, P, e)) ? n[n.length - 1].value = l : n.push({
    value: l
  }) : (!S || D === l) && n.push({
    value: D
  }), n;
}
function relativeLabelSize(e, t, { horizontal: n, minRotation: s }) {
  const i = toRadians(s), a = (n ? Math.sin(i) : Math.cos(i)) || 1e-3, o = 0.75 * t * ("" + e).length;
  return Math.min(t / a, o);
}
class LinearScaleBase extends Scale {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return isNullOrUndef(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: s } = this.getUserBounds();
    let { min: i, max: a } = this;
    const o = (c) => i = n ? i : c, l = (c) => a = s ? a : c;
    if (t) {
      const c = sign(i), u = sign(a);
      c < 0 && u < 0 ? l(0) : c > 0 && u > 0 && o(0);
    }
    if (i === a) {
      let c = a === 0 ? 1 : Math.abs(a * 0.05);
      l(a + c), t || o(i - c);
    }
    this.min = i, this.max = a;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: s } = t, i;
    return s ? (i = Math.ceil(this.max / s) - Math.floor(this.min / s) + 1, i > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${s} would result generating up to ${i} ticks. Limiting to 1000.`), i = 1e3)) : (i = this.computeTickLimit(), n = n || 11), n && (i = Math.min(n, i)), i;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let s = this.getTickLimit();
    s = Math.max(2, s);
    const i = {
      maxTicks: s,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, a = this._range || this, o = generateTicks$1(i, a);
    return t.bounds === "ticks" && _setMinAndMaxByKey(o, this, "value"), t.reverse ? (o.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), o;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, s = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const i = (s - n) / Math.max(t.length - 1, 1) / 2;
      n -= i, s += i;
    }
    this._startValue = n, this._endValue = s, this._valueRange = s - n;
  }
  getLabelForValue(t) {
    return formatNumber(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class LinearScale extends LinearScaleBase {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = isNumberFinite(t) ? t : 0, this.max = isNumberFinite(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, s = toRadians(this.options.ticks.minRotation), i = (t ? Math.sin(s) : Math.cos(s)) || 1e-3, a = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, a.lineHeight / i));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
pe(LinearScale, "id", "linear"), pe(LinearScale, "defaults", {
  ticks: {
    callback: Ticks.formatters.numeric
  }
});
const log10Floor = (e) => Math.floor(log10(e)), changeExponent = (e, t) => Math.pow(10, log10Floor(e) + t);
function isMajor(e) {
  return e / Math.pow(10, log10Floor(e)) === 1;
}
function steps(e, t, n) {
  const s = Math.pow(10, n), i = Math.floor(e / s);
  return Math.ceil(t / s) - i;
}
function startExp(e, t) {
  const n = t - e;
  let s = log10Floor(n);
  for (; steps(e, t, s) > 10; )
    s++;
  for (; steps(e, t, s) < 10; )
    s--;
  return Math.min(s, log10Floor(e));
}
function generateTicks(e, { min: t, max: n }) {
  t = finiteOrDefault(e.min, t);
  const s = [], i = log10Floor(t);
  let a = startExp(t, n), o = a < 0 ? Math.pow(10, Math.abs(a)) : 1;
  const l = Math.pow(10, a), c = i > a ? Math.pow(10, i) : 0, u = Math.round((t - c) * o) / o, d = Math.floor((t - c) / l / 10) * l * 10;
  let p = Math.floor((u - d) / Math.pow(10, a)), f = finiteOrDefault(e.min, Math.round((c + d + p * Math.pow(10, a)) * o) / o);
  for (; f < n; )
    s.push({
      value: f,
      major: isMajor(f),
      significand: p
    }), p >= 10 ? p = p < 15 ? 15 : 20 : p++, p >= 20 && (a++, p = 2, o = a >= 0 ? 1 : o), f = Math.round((c + d + p * Math.pow(10, a)) * o) / o;
  const g = finiteOrDefault(e.max, f);
  return s.push({
    value: g,
    major: isMajor(g),
    significand: p
  }), s;
}
class LogarithmicScale extends Scale {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const s = LinearScaleBase.prototype.parse.apply(this, [
      t,
      n
    ]);
    if (s === 0) {
      this._zero = !0;
      return;
    }
    return isNumberFinite(s) && s > 0 ? s : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = isNumberFinite(t) ? Math.max(0, t) : null, this.max = isNumberFinite(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !isNumberFinite(this._userMin) && (this.min = t === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let s = this.min, i = this.max;
    const a = (l) => s = t ? s : l, o = (l) => i = n ? i : l;
    s === i && (s <= 0 ? (a(1), o(10)) : (a(changeExponent(s, -1)), o(changeExponent(i, 1)))), s <= 0 && a(changeExponent(i, -1)), i <= 0 && o(changeExponent(s, 1)), this.min = s, this.max = i;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, s = generateTicks(n, this);
    return t.bounds === "ticks" && _setMinAndMaxByKey(s, this, "value"), t.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : formatNumber(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = log10(t), this._valueRange = log10(this.max) - log10(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (log10(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
pe(LogarithmicScale, "id", "logarithmic"), pe(LogarithmicScale, "defaults", {
  ticks: {
    callback: Ticks.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function getTickBackdropHeight(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = toPadding(t.backdropPadding);
    return valueOrDefault(t.font && t.font.size, defaults.font.size) + n.height;
  }
  return 0;
}
function measureLabelSize(e, t, n) {
  return n = isArray(n) ? n : [
    n
  ], {
    w: _longestText(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function determineLimits(e, t, n, s, i) {
  return e === s || e === i ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < s || e > i ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function fitWithPointLabels(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), s = [], i = [], a = e._pointLabels.length, o = e.options.pointLabels, l = o.centerPointLabels ? PI / a : 0;
  for (let c = 0; c < a; c++) {
    const u = o.setContext(e.getPointLabelContext(c));
    i[c] = u.padding;
    const d = e.getPointPosition(c, e.drawingArea + i[c], l), p = toFont(u.font), f = measureLabelSize(e.ctx, p, e._pointLabels[c]);
    s[c] = f;
    const g = _normalizeAngle(e.getIndexAngle(c) + l), C = Math.round(toDegrees(g)), k = determineLimits(C, d.x, f.w, 0, 180), M = determineLimits(C, d.y, f.h, 90, 270);
    updateLimits(n, t, g, k, M);
  }
  e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = buildPointLabelItems(e, s, i);
}
function updateLimits(e, t, n, s, i) {
  const a = Math.abs(Math.sin(n)), o = Math.abs(Math.cos(n));
  let l = 0, c = 0;
  s.start < t.l ? (l = (t.l - s.start) / a, e.l = Math.min(e.l, t.l - l)) : s.end > t.r && (l = (s.end - t.r) / a, e.r = Math.max(e.r, t.r + l)), i.start < t.t ? (c = (t.t - i.start) / o, e.t = Math.min(e.t, t.t - c)) : i.end > t.b && (c = (i.end - t.b) / o, e.b = Math.max(e.b, t.b + c));
}
function createPointLabelItem(e, t, n) {
  const s = e.drawingArea, { extra: i, additionalAngle: a, padding: o, size: l } = n, c = e.getPointPosition(t, s + i + o, a), u = Math.round(toDegrees(_normalizeAngle(c.angle + HALF_PI))), d = yForAngle(c.y, l.h, u), p = getTextAlignForAngle(u), f = leftForTextAlign(c.x, l.w, p);
  return {
    visible: !0,
    x: c.x,
    y: d,
    textAlign: p,
    left: f,
    top: d,
    right: f + l.w,
    bottom: d + l.h
  };
}
function isNotOverlapped(e, t) {
  if (!t)
    return !0;
  const { left: n, top: s, right: i, bottom: a } = e;
  return !(_isPointInArea({
    x: n,
    y: s
  }, t) || _isPointInArea({
    x: n,
    y: a
  }, t) || _isPointInArea({
    x: i,
    y: s
  }, t) || _isPointInArea({
    x: i,
    y: a
  }, t));
}
function buildPointLabelItems(e, t, n) {
  const s = [], i = e._pointLabels.length, a = e.options, { centerPointLabels: o, display: l } = a.pointLabels, c = {
    extra: getTickBackdropHeight(a) / 2,
    additionalAngle: o ? PI / i : 0
  };
  let u;
  for (let d = 0; d < i; d++) {
    c.padding = n[d], c.size = t[d];
    const p = createPointLabelItem(e, d, c);
    s.push(p), l === "auto" && (p.visible = isNotOverlapped(p, u), p.visible && (u = p));
  }
  return s;
}
function getTextAlignForAngle(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function leftForTextAlign(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function yForAngle(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function drawPointLabelBox(e, t, n) {
  const { left: s, top: i, right: a, bottom: o } = n, { backdropColor: l } = t;
  if (!isNullOrUndef(l)) {
    const c = toTRBLCorners(t.borderRadius), u = toPadding(t.backdropPadding);
    e.fillStyle = l;
    const d = s - u.left, p = i - u.top, f = a - s + u.width, g = o - i + u.height;
    Object.values(c).some((C) => C !== 0) ? (e.beginPath(), addRoundedRectPath(e, {
      x: d,
      y: p,
      w: f,
      h: g,
      radius: c
    }), e.fill()) : e.fillRect(d, p, f, g);
  }
}
function drawPointLabels(e, t) {
  const { ctx: n, options: { pointLabels: s } } = e;
  for (let i = t - 1; i >= 0; i--) {
    const a = e._pointLabelItems[i];
    if (!a.visible)
      continue;
    const o = s.setContext(e.getPointLabelContext(i));
    drawPointLabelBox(n, o, a);
    const l = toFont(o.font), { x: c, y: u, textAlign: d } = a;
    renderText(n, e._pointLabels[i], c, u + l.lineHeight / 2, l, {
      color: o.color,
      textAlign: d,
      textBaseline: "middle"
    });
  }
}
function pathRadiusLine(e, t, n, s) {
  const { ctx: i } = e;
  if (n)
    i.arc(e.xCenter, e.yCenter, t, 0, TAU);
  else {
    let a = e.getPointPosition(0, t);
    i.moveTo(a.x, a.y);
    for (let o = 1; o < s; o++)
      a = e.getPointPosition(o, t), i.lineTo(a.x, a.y);
  }
}
function drawRadiusLine(e, t, n, s, i) {
  const a = e.ctx, o = t.circular, { color: l, lineWidth: c } = t;
  !o && !s || !l || !c || n < 0 || (a.save(), a.strokeStyle = l, a.lineWidth = c, a.setLineDash(i.dash), a.lineDashOffset = i.dashOffset, a.beginPath(), pathRadiusLine(e, n, o, s), a.closePath(), a.stroke(), a.restore());
}
function createPointLabelContext(e, t, n) {
  return createContext(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class RadialLinearScale extends LinearScaleBase {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = toPadding(getTickBackdropHeight(this.options) / 2), n = this.width = this.maxWidth - t.width, s = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + s / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, s) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = isNumberFinite(t) && !isNaN(t) ? t : 0, this.max = isNumberFinite(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
  }
  generateTickLabels(t) {
    LinearScaleBase.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, s) => {
      const i = callback(this.options.pointLabels.callback, [
        n,
        s
      ], this);
      return i || i === 0 ? i : "";
    }).filter((n, s) => this.chart.getDataVisibility(s));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? fitWithPointLabels(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, s, i) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((s - i) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, s, i));
  }
  getIndexAngle(t) {
    const n = TAU / (this._pointLabels.length || 1), s = this.options.startAngle || 0;
    return _normalizeAngle(t * n + toRadians(s));
  }
  getDistanceFromCenterForValue(t) {
    if (isNullOrUndef(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (isNullOrUndef(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const s = n[t];
      return createPointLabelContext(this.getContext(), t, s);
    }
  }
  getPointPosition(t, n, s = 0) {
    const i = this.getIndexAngle(t) - HALF_PI + s;
    return {
      x: Math.cos(i) * n + this.xCenter,
      y: Math.sin(i) * n + this.yCenter,
      angle: i
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: s, right: i, bottom: a } = this._pointLabelItems[t];
    return {
      left: n,
      top: s,
      right: i,
      bottom: a
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const s = this.ctx;
      s.save(), s.beginPath(), pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), s.closePath(), s.fillStyle = t, s.fill(), s.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: s, grid: i, border: a } = n, o = this._pointLabels.length;
    let l, c, u;
    if (n.pointLabels.display && drawPointLabels(this, o), i.display && this.ticks.forEach((d, p) => {
      if (p !== 0) {
        c = this.getDistanceFromCenterForValue(d.value);
        const f = this.getContext(p), g = i.setContext(f), C = a.setContext(f);
        drawRadiusLine(this, g, c, o, C);
      }
    }), s.display) {
      for (t.save(), l = o - 1; l >= 0; l--) {
        const d = s.setContext(this.getPointLabelContext(l)), { color: p, lineWidth: f } = d;
        !f || !p || (t.lineWidth = f, t.strokeStyle = p, t.setLineDash(d.borderDash), t.lineDashOffset = d.borderDashOffset, c = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), u = this.getPointPosition(l, c), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(u.x, u.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, s = n.ticks;
    if (!s.display)
      return;
    const i = this.getIndexAngle(0);
    let a, o;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(i), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((l, c) => {
      if (c === 0 && !n.reverse)
        return;
      const u = s.setContext(this.getContext(c)), d = toFont(u.font);
      if (a = this.getDistanceFromCenterForValue(this.ticks[c].value), u.showLabelBackdrop) {
        t.font = d.string, o = t.measureText(l.label).width, t.fillStyle = u.backdropColor;
        const p = toPadding(u.backdropPadding);
        t.fillRect(-o / 2 - p.left, -a - d.size / 2 - p.top, o + p.width, d.size + p.height);
      }
      renderText(t, l.label, 0, -a, d, {
        color: u.color
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
pe(RadialLinearScale, "id", "radialLinear"), pe(RadialLinearScale, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Ticks.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), pe(RadialLinearScale, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), pe(RadialLinearScale, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const INTERVALS = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, UNITS = /* @__PURE__ */ Object.keys(INTERVALS);
function sorter(e, t) {
  return e - t;
}
function parse$1(e, t) {
  if (isNullOrUndef(t))
    return null;
  const n = e._adapter, { parser: s, round: i, isoWeekday: a } = e._parseOpts;
  let o = t;
  return typeof s == "function" && (o = s(o)), isNumberFinite(o) || (o = typeof s == "string" ? n.parse(o, s) : n.parse(o)), o === null ? null : (i && (o = i === "week" && (isNumber(a) || a === !0) ? n.startOf(o, "isoWeek", a) : n.startOf(o, i)), +o);
}
function determineUnitForAutoTicks(e, t, n, s) {
  const i = UNITS.length;
  for (let a = UNITS.indexOf(e); a < i - 1; ++a) {
    const o = INTERVALS[UNITS[a]], l = o.steps ? o.steps : Number.MAX_SAFE_INTEGER;
    if (o.common && Math.ceil((n - t) / (l * o.size)) <= s)
      return UNITS[a];
  }
  return UNITS[i - 1];
}
function determineUnitForFormatting(e, t, n, s, i) {
  for (let a = UNITS.length - 1; a >= UNITS.indexOf(n); a--) {
    const o = UNITS[a];
    if (INTERVALS[o].common && e._adapter.diff(i, s, o) >= t - 1)
      return o;
  }
  return UNITS[n ? UNITS.indexOf(n) : 0];
}
function determineMajorUnit(e) {
  for (let t = UNITS.indexOf(e) + 1, n = UNITS.length; t < n; ++t)
    if (INTERVALS[UNITS[t]].common)
      return UNITS[t];
}
function addTick(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: s, hi: i } = _lookup(n, t), a = n[s] >= t ? n[s] : n[i];
    e[a] = !0;
  }
}
function setMajorTicks(e, t, n, s) {
  const i = e._adapter, a = +i.startOf(t[0].value, s), o = t[t.length - 1].value;
  let l, c;
  for (l = a; l <= o; l = +i.add(l, 1, s))
    c = n[l], c >= 0 && (t[c].major = !0);
  return t;
}
function ticksFromTimestamps(e, t, n) {
  const s = [], i = {}, a = t.length;
  let o, l;
  for (o = 0; o < a; ++o)
    l = t[o], i[l] = o, s.push({
      value: l,
      major: !1
    });
  return a === 0 || !n ? s : setMajorTicks(e, s, i, n);
}
class TimeScale extends Scale {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n = {}) {
    const s = t.time || (t.time = {}), i = this._adapter = new adapters._date(t.adapters.date);
    i.init(n), mergeIf(s.displayFormats, i.formats()), this._parseOpts = {
      parser: s.parser,
      round: s.round,
      isoWeekday: s.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : parse$1(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, s = t.time.unit || "day";
    let { min: i, max: a, minDefined: o, maxDefined: l } = this.getUserBounds();
    function c(u) {
      !o && !isNaN(u.min) && (i = Math.min(i, u.min)), !l && !isNaN(u.max) && (a = Math.max(a, u.max));
    }
    (!o || !l) && (c(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && c(this.getMinMax(!1))), i = isNumberFinite(i) && !isNaN(i) ? i : +n.startOf(Date.now(), s), a = isNumberFinite(a) && !isNaN(a) ? a : +n.endOf(Date.now(), s) + 1, this.min = Math.min(i, a - 1), this.max = Math.max(i + 1, a);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, s = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], s = t[t.length - 1]), {
      min: n,
      max: s
    };
  }
  buildTicks() {
    const t = this.options, n = t.time, s = t.ticks, i = s.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && i.length && (this.min = this._userMin || i[0], this.max = this._userMax || i[i.length - 1]);
    const a = this.min, o = this.max, l = _filterBetween(i, a, o);
    return this._unit = n.unit || (s.autoSkip ? determineUnitForAutoTicks(n.minUnit, this.min, this.max, this._getLabelCapacity(a)) : determineUnitForFormatting(this, l.length, n.minUnit, this.min, this.max)), this._majorUnit = !s.major.enabled || this._unit === "year" ? void 0 : determineMajorUnit(this._unit), this.initOffsets(i), t.reverse && l.reverse(), ticksFromTimestamps(this, l, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let n = 0, s = 0, i, a;
    this.options.offset && t.length && (i = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - i : n = (this.getDecimalForValue(t[1]) - i) / 2, a = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? s = a : s = (a - this.getDecimalForValue(t[t.length - 2])) / 2);
    const o = t.length < 3 ? 0.5 : 0.25;
    n = _limitValue(n, 0, o), s = _limitValue(s, 0, o), this._offsets = {
      start: n,
      end: s,
      factor: 1 / (n + 1 + s)
    };
  }
  _generate() {
    const t = this._adapter, n = this.min, s = this.max, i = this.options, a = i.time, o = a.unit || determineUnitForAutoTicks(a.minUnit, n, s, this._getLabelCapacity(n)), l = valueOrDefault(i.ticks.stepSize, 1), c = o === "week" ? a.isoWeekday : !1, u = isNumber(c) || c === !0, d = {};
    let p = n, f, g;
    if (u && (p = +t.startOf(p, "isoWeek", c)), p = +t.startOf(p, u ? "day" : o), t.diff(s, n, o) > 1e5 * l)
      throw new Error(n + " and " + s + " are too far apart with stepSize of " + l + " " + o);
    const C = i.ticks.source === "data" && this.getDataTimestamps();
    for (f = p, g = 0; f < s; f = +t.add(f, l, o), g++)
      addTick(d, f, C);
    return (f === s || i.bounds === "ticks" || g === 1) && addTick(d, f, C), Object.keys(d).sort((k, M) => k - M).map((k) => +k);
  }
  getLabelForValue(t) {
    const n = this._adapter, s = this.options.time;
    return s.tooltipFormat ? n.format(t, s.tooltipFormat) : n.format(t, s.displayFormats.datetime);
  }
  format(t, n) {
    const i = this.options.time.displayFormats, a = this._unit, o = n || i[a];
    return this._adapter.format(t, o);
  }
  _tickFormatFunction(t, n, s, i) {
    const a = this.options, o = a.ticks.callback;
    if (o)
      return callback(o, [
        t,
        n,
        s
      ], this);
    const l = a.time.displayFormats, c = this._unit, u = this._majorUnit, d = c && l[c], p = u && l[u], f = s[n], g = u && p && f && f.major;
    return this._adapter.format(t, i || (g ? p : d));
  }
  generateTickLabels(t) {
    let n, s, i;
    for (n = 0, s = t.length; n < s; ++n)
      i = t[n], i.label = this._tickFormatFunction(i.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, s = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + s) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, s = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + s * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, s = this.ctx.measureText(t).width, i = toRadians(this.isHorizontal() ? n.maxRotation : n.minRotation), a = Math.cos(i), o = Math.sin(i), l = this._resolveTickFontOptions(0).size;
    return {
      w: s * a + l * o,
      h: s * o + l * a
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, s = n.displayFormats, i = s[n.unit] || s.millisecond, a = this._tickFormatFunction(t, 0, ticksFromTimestamps(this, [
      t
    ], this._majorUnit), i), o = this._getLabelSize(a), l = Math.floor(this.isHorizontal() ? this.width / o.w : this.height / o.h) - 1;
    return l > 0 ? l : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, s;
    if (t.length)
      return t;
    const i = this.getMatchingVisibleMetas();
    if (this._normalized && i.length)
      return this._cache.data = i[0].controller.getAllParsedValues(this);
    for (n = 0, s = i.length; n < s; ++n)
      t = t.concat(i[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, s;
    if (t.length)
      return t;
    const i = this.getLabels();
    for (n = 0, s = i.length; n < s; ++n)
      t.push(parse$1(this, i[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return _arrayUnique(t.sort(sorter));
  }
}
pe(TimeScale, "id", "time"), pe(TimeScale, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function interpolate(e, t, n) {
  let s = 0, i = e.length - 1, a, o, l, c;
  n ? (t >= e[s].pos && t <= e[i].pos && ({ lo: s, hi: i } = _lookupByKey(e, "pos", t)), { pos: a, time: l } = e[s], { pos: o, time: c } = e[i]) : (t >= e[s].time && t <= e[i].time && ({ lo: s, hi: i } = _lookupByKey(e, "time", t)), { time: a, pos: l } = e[s], { time: o, pos: c } = e[i]);
  const u = o - a;
  return u ? l + (c - l) * (t - a) / u : l;
}
class TimeSeriesScale extends TimeScale {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = interpolate(n, this.min), this._tableRange = interpolate(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: s } = this, i = [], a = [];
    let o, l, c, u, d;
    for (o = 0, l = t.length; o < l; ++o)
      u = t[o], u >= n && u <= s && i.push(u);
    if (i.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: s,
          pos: 1
        }
      ];
    for (o = 0, l = i.length; o < l; ++o)
      d = i[o + 1], c = i[o - 1], u = i[o], Math.round((d + c) / 2) !== u && a.push({
        time: u,
        pos: o / (l - 1)
      });
    return a;
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), s = this.getLabelTimestamps();
    return n.length && s.length ? t = this.normalize(n.concat(s)) : t = n.length ? n : s, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (interpolate(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, s = this.getDecimalForPixel(t) / n.factor - n.end;
    return interpolate(this._table, s * this._tableRange + this._minPos, !0);
  }
}
pe(TimeSeriesScale, "id", "timeseries"), pe(TimeSeriesScale, "defaults", TimeScale.defaults);
const CommonProps = {
  data: {
    type: Object,
    required: !0
  },
  options: {
    type: Object,
    default: () => ({})
  },
  plugins: {
    type: Array,
    default: () => []
  },
  datasetIdKey: {
    type: String,
    default: "label"
  },
  updateMode: {
    type: String,
    default: void 0
  }
}, Props = {
  type: {
    type: String,
    required: !0
  },
  ...CommonProps
}, compatProps = version$1[0] === "2" ? (e, t) => Object.assign(e, {
  attrs: t
}) : (e, t) => Object.assign(e, t);
function toRawIfProxy(e) {
  return isProxy(e) ? toRaw(e) : e;
}
function cloneProxy(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e;
  return isProxy(t) ? new Proxy(e, {}) : e;
}
function setOptions(e, t) {
  const n = e.options;
  n && t && Object.assign(n, t);
}
function setLabels(e, t) {
  e.labels = t;
}
function setDatasets(e, t, n) {
  const s = [];
  e.datasets = t.map((i) => {
    const a = e.datasets.find((o) => o[n] === i[n]);
    return !a || !i.data || s.includes(a) ? {
      ...i
    } : (s.push(a), Object.assign(a, i), a);
  });
}
function cloneData(e, t) {
  const n = {
    labels: [],
    datasets: []
  };
  return setLabels(n, e.labels), setDatasets(n, e.datasets, t), n;
}
const Chart = defineComponent({
  props: Props,
  setup(e, t) {
    let { expose: n } = t;
    const s = ref(null), i = shallowRef(null);
    n({
      chart: i
    });
    const a = () => {
      if (!s.value)
        return;
      const { type: c, data: u, options: d, plugins: p, datasetIdKey: f } = e, g = cloneData(u, f), C = cloneProxy(g, u);
      i.value = new Chart$1(s.value, {
        type: c,
        data: C,
        options: {
          ...d
        },
        plugins: p
      });
    }, o = () => {
      const c = toRaw(i.value);
      c && (c.destroy(), i.value = null);
    }, l = (c) => {
      c.update(e.updateMode);
    };
    return onMounted(a), onBeforeUnmount(o), watch([
      () => e.options,
      () => e.data
    ], (c, u) => {
      let [d, p] = c, [f, g] = u;
      const C = toRaw(i.value);
      if (!C)
        return;
      let k = !1;
      if (d) {
        const M = toRawIfProxy(d), _ = toRawIfProxy(f);
        M && M !== _ && (setOptions(C, M), k = !0);
      }
      if (p) {
        const M = toRawIfProxy(p.labels), _ = toRawIfProxy(g.labels), S = toRawIfProxy(p.datasets), E = toRawIfProxy(g.datasets);
        M !== _ && (setLabels(C.config.data, M), k = !0), S && S !== E && (setDatasets(C.config.data, S, e.datasetIdKey), k = !0);
      }
      k && l(C);
    }, {
      deep: !0
    }), () => h("canvas", {
      ref: s
    });
  }
});
function createTypedChart(e, t) {
  return Chart$1.register(t), defineComponent({
    props: CommonProps,
    setup(n, s) {
      let { expose: i } = s;
      const a = shallowRef(null), o = (l) => {
        a.value = l == null ? void 0 : l.chart;
      };
      return i({
        chart: a
      }), () => h(Chart, compatProps({
        ref: o
      }, {
        type: e,
        ...n
      }));
    }
  });
}
const Line = /* @__PURE__ */ createTypedChart("line", LineController);
function _typeof(e) {
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof(e);
}
function toInteger(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function requiredArgs(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function toDate(e) {
  requiredArgs(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || _typeof(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
}
function addDays(e, t) {
  requiredArgs(2, arguments);
  var n = toDate(e), s = toInteger(t);
  return isNaN(s) ? new Date(NaN) : (s && n.setDate(n.getDate() + s), n);
}
function addMonths(e, t) {
  requiredArgs(2, arguments);
  var n = toDate(e), s = toInteger(t);
  if (isNaN(s))
    return new Date(NaN);
  if (!s)
    return n;
  var i = n.getDate(), a = new Date(n.getTime());
  a.setMonth(n.getMonth() + s + 1, 0);
  var o = a.getDate();
  return i >= o ? a : (n.setFullYear(a.getFullYear(), a.getMonth(), i), n);
}
function addMilliseconds(e, t) {
  requiredArgs(2, arguments);
  var n = toDate(e).getTime(), s = toInteger(t);
  return new Date(n + s);
}
var MILLISECONDS_IN_HOUR = 36e5;
function addHours(e, t) {
  requiredArgs(2, arguments);
  var n = toInteger(t);
  return addMilliseconds(e, n * MILLISECONDS_IN_HOUR);
}
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function startOfWeek(e, t) {
  var n, s, i, a, o, l, c, u;
  requiredArgs(1, arguments);
  var d = getDefaultOptions(), p = toInteger((n = (s = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && s !== void 0 ? s : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = toDate(e), g = f.getDay(), C = (g < p ? 7 : 0) + g - p;
  return f.setDate(f.getDate() - C), f.setHours(0, 0, 0, 0), f;
}
function getTimezoneOffsetInMilliseconds(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function startOfDay(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setHours(0, 0, 0, 0), t;
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function differenceInCalendarDays(e, t) {
  requiredArgs(2, arguments);
  var n = startOfDay(e), s = startOfDay(t), i = n.getTime() - getTimezoneOffsetInMilliseconds(n), a = s.getTime() - getTimezoneOffsetInMilliseconds(s);
  return Math.round((i - a) / MILLISECONDS_IN_DAY$1);
}
var MILLISECONDS_IN_MINUTE = 6e4;
function addMinutes(e, t) {
  requiredArgs(2, arguments);
  var n = toInteger(t);
  return addMilliseconds(e, n * MILLISECONDS_IN_MINUTE);
}
function addQuarters(e, t) {
  requiredArgs(2, arguments);
  var n = toInteger(t), s = n * 3;
  return addMonths(e, s);
}
function addSeconds(e, t) {
  requiredArgs(2, arguments);
  var n = toInteger(t);
  return addMilliseconds(e, n * 1e3);
}
function addWeeks(e, t) {
  requiredArgs(2, arguments);
  var n = toInteger(t), s = n * 7;
  return addDays(e, s);
}
function addYears(e, t) {
  requiredArgs(2, arguments);
  var n = toInteger(t);
  return addMonths(e, n * 12);
}
function compareAsc(e, t) {
  requiredArgs(2, arguments);
  var n = toDate(e), s = toDate(t), i = n.getTime() - s.getTime();
  return i < 0 ? -1 : i > 0 ? 1 : i;
}
var millisecondsInMinute = 6e4, millisecondsInHour = 36e5, millisecondsInSecond = 1e3;
function isDate(e) {
  return requiredArgs(1, arguments), e instanceof Date || _typeof(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function isValid(e) {
  if (requiredArgs(1, arguments), !isDate(e) && typeof e != "number")
    return !1;
  var t = toDate(e);
  return !isNaN(Number(t));
}
function differenceInCalendarMonths(e, t) {
  requiredArgs(2, arguments);
  var n = toDate(e), s = toDate(t), i = n.getFullYear() - s.getFullYear(), a = n.getMonth() - s.getMonth();
  return i * 12 + a;
}
function differenceInCalendarYears(e, t) {
  requiredArgs(2, arguments);
  var n = toDate(e), s = toDate(t);
  return n.getFullYear() - s.getFullYear();
}
function compareLocalAsc(e, t) {
  var n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function differenceInDays(e, t) {
  requiredArgs(2, arguments);
  var n = toDate(e), s = toDate(t), i = compareLocalAsc(n, s), a = Math.abs(differenceInCalendarDays(n, s));
  n.setDate(n.getDate() - i * a);
  var o = Number(compareLocalAsc(n, s) === -i), l = i * (a - o);
  return l === 0 ? 0 : l;
}
function differenceInMilliseconds(e, t) {
  return requiredArgs(2, arguments), toDate(e).getTime() - toDate(t).getTime();
}
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function e(t) {
    return t < 0 ? Math.ceil(t) : Math.floor(t);
  }
  // Math.trunc is not supported by IE
}, defaultRoundingMethod = "trunc";
function getRoundingMethod(e) {
  return e ? roundingMap[e] : roundingMap[defaultRoundingMethod];
}
function differenceInHours(e, t, n) {
  requiredArgs(2, arguments);
  var s = differenceInMilliseconds(e, t) / millisecondsInHour;
  return getRoundingMethod(n == null ? void 0 : n.roundingMethod)(s);
}
function differenceInMinutes(e, t, n) {
  requiredArgs(2, arguments);
  var s = differenceInMilliseconds(e, t) / millisecondsInMinute;
  return getRoundingMethod(n == null ? void 0 : n.roundingMethod)(s);
}
function endOfDay(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setHours(23, 59, 59, 999), t;
}
function endOfMonth(e) {
  requiredArgs(1, arguments);
  var t = toDate(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function isLastDayOfMonth(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return endOfDay(t).getTime() === endOfMonth(t).getTime();
}
function differenceInMonths(e, t) {
  requiredArgs(2, arguments);
  var n = toDate(e), s = toDate(t), i = compareAsc(n, s), a = Math.abs(differenceInCalendarMonths(n, s)), o;
  if (a < 1)
    o = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - i * a);
    var l = compareAsc(n, s) === -i;
    isLastDayOfMonth(toDate(e)) && a === 1 && compareAsc(e, s) === 1 && (l = !1), o = i * (a - Number(l));
  }
  return o === 0 ? 0 : o;
}
function differenceInQuarters(e, t, n) {
  requiredArgs(2, arguments);
  var s = differenceInMonths(e, t) / 3;
  return getRoundingMethod(n == null ? void 0 : n.roundingMethod)(s);
}
function differenceInSeconds(e, t, n) {
  requiredArgs(2, arguments);
  var s = differenceInMilliseconds(e, t) / 1e3;
  return getRoundingMethod(n == null ? void 0 : n.roundingMethod)(s);
}
function differenceInWeeks(e, t, n) {
  requiredArgs(2, arguments);
  var s = differenceInDays(e, t) / 7;
  return getRoundingMethod(n == null ? void 0 : n.roundingMethod)(s);
}
function differenceInYears(e, t) {
  requiredArgs(2, arguments);
  var n = toDate(e), s = toDate(t), i = compareAsc(n, s), a = Math.abs(differenceInCalendarYears(n, s));
  n.setFullYear(1584), s.setFullYear(1584);
  var o = compareAsc(n, s) === -i, l = i * (a - Number(o));
  return l === 0 ? 0 : l;
}
function startOfMinute(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setSeconds(0, 0), t;
}
function startOfQuarter(e) {
  requiredArgs(1, arguments);
  var t = toDate(e), n = t.getMonth(), s = n - n % 3;
  return t.setMonth(s, 1), t.setHours(0, 0, 0, 0), t;
}
function startOfMonth(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function endOfYear(e) {
  requiredArgs(1, arguments);
  var t = toDate(e), n = t.getFullYear();
  return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function startOfYear(e) {
  requiredArgs(1, arguments);
  var t = toDate(e), n = new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function endOfHour(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setMinutes(59, 59, 999), t;
}
function endOfWeek(e, t) {
  var n, s, i, a, o, l, c, u;
  requiredArgs(1, arguments);
  var d = getDefaultOptions(), p = toInteger((n = (s = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && s !== void 0 ? s : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = toDate(e), g = f.getDay(), C = (g < p ? -7 : 0) + 6 - (g - p);
  return f.setDate(f.getDate() + C), f.setHours(23, 59, 59, 999), f;
}
function endOfMinute(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setSeconds(59, 999), t;
}
function endOfQuarter(e) {
  requiredArgs(1, arguments);
  var t = toDate(e), n = t.getMonth(), s = n - n % 3 + 3;
  return t.setMonth(s, 0), t.setHours(23, 59, 59, 999), t;
}
function endOfSecond(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setMilliseconds(999), t;
}
function subMilliseconds(e, t) {
  requiredArgs(2, arguments);
  var n = toInteger(t);
  return addMilliseconds(e, -n);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(e) {
  requiredArgs(1, arguments);
  var t = toDate(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var s = t.getTime(), i = n - s;
  return Math.floor(i / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(e) {
  requiredArgs(1, arguments);
  var t = 1, n = toDate(e), s = n.getUTCDay(), i = (s < t ? 7 : 0) + s - t;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function getUTCISOWeekYear(e) {
  requiredArgs(1, arguments);
  var t = toDate(e), n = t.getUTCFullYear(), s = new Date(0);
  s.setUTCFullYear(n + 1, 0, 4), s.setUTCHours(0, 0, 0, 0);
  var i = startOfUTCISOWeek(s), a = new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var o = startOfUTCISOWeek(a);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function startOfUTCISOWeekYear(e) {
  requiredArgs(1, arguments);
  var t = getUTCISOWeekYear(e), n = new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var s = startOfUTCISOWeek(n);
  return s;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(e) {
  requiredArgs(1, arguments);
  var t = toDate(e), n = startOfUTCISOWeek(t).getTime() - startOfUTCISOWeekYear(t).getTime();
  return Math.round(n / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(e, t) {
  var n, s, i, a, o, l, c, u;
  requiredArgs(1, arguments);
  var d = getDefaultOptions(), p = toInteger((n = (s = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && s !== void 0 ? s : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = toDate(e), g = f.getUTCDay(), C = (g < p ? 7 : 0) + g - p;
  return f.setUTCDate(f.getUTCDate() - C), f.setUTCHours(0, 0, 0, 0), f;
}
function getUTCWeekYear(e, t) {
  var n, s, i, a, o, l, c, u;
  requiredArgs(1, arguments);
  var d = toDate(e), p = d.getUTCFullYear(), f = getDefaultOptions(), g = toInteger((n = (s = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && i !== void 0 ? i : f.firstWeekContainsDate) !== null && s !== void 0 ? s : (c = f.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var C = new Date(0);
  C.setUTCFullYear(p + 1, 0, g), C.setUTCHours(0, 0, 0, 0);
  var k = startOfUTCWeek(C, t), M = new Date(0);
  M.setUTCFullYear(p, 0, g), M.setUTCHours(0, 0, 0, 0);
  var _ = startOfUTCWeek(M, t);
  return d.getTime() >= k.getTime() ? p + 1 : d.getTime() >= _.getTime() ? p : p - 1;
}
function startOfUTCWeekYear(e, t) {
  var n, s, i, a, o, l, c, u;
  requiredArgs(1, arguments);
  var d = getDefaultOptions(), p = toInteger((n = (s = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (o = t.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && i !== void 0 ? i : d.firstWeekContainsDate) !== null && s !== void 0 ? s : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = getUTCWeekYear(e, t), g = new Date(0);
  g.setUTCFullYear(f, 0, p), g.setUTCHours(0, 0, 0, 0);
  var C = startOfUTCWeek(g, t);
  return C;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(e, t) {
  requiredArgs(1, arguments);
  var n = toDate(e), s = startOfUTCWeek(n, t).getTime() - startOfUTCWeekYear(n, t).getTime();
  return Math.round(s / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros(e, t) {
  for (var n = e < 0 ? "-" : "", s = Math.abs(e).toString(); s.length < t; )
    s = "0" + s;
  return n + s;
}
var formatters$2 = {
  // Year
  y: function e(t, n) {
    var s = t.getUTCFullYear(), i = s > 0 ? s : 1 - s;
    return addLeadingZeros(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function e(t, n) {
    var s = t.getUTCMonth();
    return n === "M" ? String(s + 1) : addLeadingZeros(s + 1, 2);
  },
  // Day of the month
  d: function e(t, n) {
    return addLeadingZeros(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function e(t, n) {
    var s = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return s.toUpperCase();
      case "aaa":
        return s;
      case "aaaaa":
        return s[0];
      case "aaaa":
      default:
        return s === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function e(t, n) {
    return addLeadingZeros(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function e(t, n) {
    return addLeadingZeros(t.getUTCHours(), n.length);
  },
  // Minute
  m: function e(t, n) {
    return addLeadingZeros(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function e(t, n) {
    return addLeadingZeros(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function e(t, n) {
    var s = n.length, i = t.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, s - 3));
    return addLeadingZeros(a, n.length);
  }
};
const formatters$3 = formatters$2;
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, formatters = {
  // Era
  G: function e(t, n, s) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return s.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return s.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return s.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function e(t, n, s) {
    if (n === "yo") {
      var i = t.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return s.ordinalNumber(a, {
        unit: "year"
      });
    }
    return formatters$3.y(t, n);
  },
  // Local week-numbering year
  Y: function e(t, n, s, i) {
    var a = getUTCWeekYear(t, i), o = a > 0 ? a : 1 - a;
    if (n === "YY") {
      var l = o % 100;
      return addLeadingZeros(l, 2);
    }
    return n === "Yo" ? s.ordinalNumber(o, {
      unit: "year"
    }) : addLeadingZeros(o, n.length);
  },
  // ISO week-numbering year
  R: function e(t, n) {
    var s = getUTCISOWeekYear(t);
    return addLeadingZeros(s, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function e(t, n) {
    var s = t.getUTCFullYear();
    return addLeadingZeros(s, n.length);
  },
  // Quarter
  Q: function e(t, n, s) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(i);
      case "QQ":
        return addLeadingZeros(i, 2);
      case "Qo":
        return s.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return s.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return s.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return s.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function e(t, n, s) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(i);
      case "qq":
        return addLeadingZeros(i, 2);
      case "qo":
        return s.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return s.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return s.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return s.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function e(t, n, s) {
    var i = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return formatters$3.M(t, n);
      case "Mo":
        return s.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return s.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return s.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return s.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function e(t, n, s) {
    var i = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(i + 1);
      case "LL":
        return addLeadingZeros(i + 1, 2);
      case "Lo":
        return s.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return s.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return s.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return s.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function e(t, n, s, i) {
    var a = getUTCWeek(t, i);
    return n === "wo" ? s.ordinalNumber(a, {
      unit: "week"
    }) : addLeadingZeros(a, n.length);
  },
  // ISO week of year
  I: function e(t, n, s) {
    var i = getUTCISOWeek(t);
    return n === "Io" ? s.ordinalNumber(i, {
      unit: "week"
    }) : addLeadingZeros(i, n.length);
  },
  // Day of the month
  d: function e(t, n, s) {
    return n === "do" ? s.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : formatters$3.d(t, n);
  },
  // Day of year
  D: function e(t, n, s) {
    var i = getUTCDayOfYear(t);
    return n === "Do" ? s.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : addLeadingZeros(i, n.length);
  },
  // Day of week
  E: function e(t, n, s) {
    var i = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return s.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return s.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return s.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return s.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function e(t, n, s, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(o);
      case "ee":
        return addLeadingZeros(o, 2);
      case "eo":
        return s.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return s.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return s.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return s.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return s.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function e(t, n, s, i) {
    var a = t.getUTCDay(), o = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(o);
      case "cc":
        return addLeadingZeros(o, n.length);
      case "co":
        return s.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return s.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return s.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return s.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return s.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function e(t, n, s) {
    var i = t.getUTCDay(), a = i === 0 ? 7 : i;
    switch (n) {
      case "i":
        return String(a);
      case "ii":
        return addLeadingZeros(a, n.length);
      case "io":
        return s.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return s.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return s.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return s.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return s.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function e(t, n, s) {
    var i = t.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return s.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return s.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return s.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function e(t, n, s) {
    var i = t.getUTCHours(), a;
    switch (i === 12 ? a = dayPeriodEnum.noon : i === 0 ? a = dayPeriodEnum.midnight : a = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return s.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return s.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return s.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function e(t, n, s) {
    var i = t.getUTCHours(), a;
    switch (i >= 17 ? a = dayPeriodEnum.evening : i >= 12 ? a = dayPeriodEnum.afternoon : i >= 4 ? a = dayPeriodEnum.morning : a = dayPeriodEnum.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function e(t, n, s) {
    if (n === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), s.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return formatters$3.h(t, n);
  },
  // Hour [0-23]
  H: function e(t, n, s) {
    return n === "Ho" ? s.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : formatters$3.H(t, n);
  },
  // Hour [0-11]
  K: function e(t, n, s) {
    var i = t.getUTCHours() % 12;
    return n === "Ko" ? s.ordinalNumber(i, {
      unit: "hour"
    }) : addLeadingZeros(i, n.length);
  },
  // Hour [1-24]
  k: function e(t, n, s) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? s.ordinalNumber(i, {
      unit: "hour"
    }) : addLeadingZeros(i, n.length);
  },
  // Minute
  m: function e(t, n, s) {
    return n === "mo" ? s.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : formatters$3.m(t, n);
  },
  // Second
  s: function e(t, n, s) {
    return n === "so" ? s.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : formatters$3.s(t, n);
  },
  // Fraction of second
  S: function e(t, n) {
    return formatters$3.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function e(t, n, s, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (n) {
      case "X":
        return formatTimezoneWithOptionalMinutes(o);
      case "XXXX":
      case "XX":
        return formatTimezone(o);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function e(t, n, s, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (n) {
      case "x":
        return formatTimezoneWithOptionalMinutes(o);
      case "xxxx":
      case "xx":
        return formatTimezone(o);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(o, ":");
    }
  },
  // Timezone (GMT)
  O: function e(t, n, s, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(o, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function e(t, n, s, i) {
    var a = i._originalDate || t, o = a.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(o, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(o, ":");
    }
  },
  // Seconds timestamp
  t: function e(t, n, s, i) {
    var a = i._originalDate || t, o = Math.floor(a.getTime() / 1e3);
    return addLeadingZeros(o, n.length);
  },
  // Milliseconds timestamp
  T: function e(t, n, s, i) {
    var a = i._originalDate || t, o = a.getTime();
    return addLeadingZeros(o, n.length);
  }
};
function formatTimezoneShort(e, t) {
  var n = e > 0 ? "-" : "+", s = Math.abs(e), i = Math.floor(s / 60), a = s % 60;
  if (a === 0)
    return n + String(i);
  var o = t || "";
  return n + String(i) + o + addLeadingZeros(a, 2);
}
function formatTimezoneWithOptionalMinutes(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + addLeadingZeros(Math.abs(e) / 60, 2);
  }
  return formatTimezone(e, t);
}
function formatTimezone(e, t) {
  var n = t || "", s = e > 0 ? "-" : "+", i = Math.abs(e), a = addLeadingZeros(Math.floor(i / 60), 2), o = addLeadingZeros(i % 60, 2);
  return s + a + n + o;
}
const formatters$1 = formatters;
var dateLongFormatter = function e(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, timeLongFormatter = function e(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, dateTimeLongFormatter = function e(t, n) {
  var s = t.match(/(P+)(p+)?/) || [], i = s[1], a = s[2];
  if (!a)
    return dateLongFormatter(t, n);
  var o;
  switch (i) {
    case "P":
      o = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = n.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", dateLongFormatter(i, n)).replace("{{time}}", timeLongFormatter(a, n));
}, longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const longFormatters$1 = longFormatters;
var protectedDayOfYearTokens = ["D", "DD"], protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(e) {
  return protectedDayOfYearTokens.indexOf(e) !== -1;
}
function isProtectedWeekYearToken(e) {
  return protectedWeekYearTokens.indexOf(e) !== -1;
}
function throwProtectedError(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, formatDistance = function e(t, n, s) {
  var i, a = formatDistanceLocale[t];
  return typeof a == "string" ? i = a : n === 1 ? i = a.one : i = a.other.replace("{{count}}", n.toString()), s != null && s.addSuffix ? s.comparison && s.comparison > 0 ? "in " + i : i + " ago" : i;
};
const formatDistance$1 = formatDistance;
function buildFormatLongFn(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, s = e.formats[n] || e.formats[e.defaultWidth];
    return s;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, formatRelative = function e(t, n, s, i) {
  return formatRelativeLocale[t];
};
const formatRelative$1 = formatRelative;
function buildLocalizeFn(e) {
  return function(t, n) {
    var s = n != null && n.context ? String(n.context) : "standalone", i;
    if (s === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, o = n != null && n.width ? String(n.width) : a;
      i = e.formattingValues[o] || e.formattingValues[a];
    } else {
      var l = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[c] || e.values[l];
    }
    var u = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[u];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ordinalNumber = function e(t, n) {
  var s = Number(t), i = s % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return s + "st";
      case 2:
        return s + "nd";
      case 3:
        return s + "rd";
    }
  return s + "th";
}, localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function e(t) {
      return t - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const localize$1 = localize;
function buildMatchFn(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = n.width, i = s && e.matchPatterns[s] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    var o = a[0], l = s && e.parsePatterns[s] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(l) ? findIndex(l, function(p) {
      return p.test(o);
    }) : findKey(l, function(p) {
      return p.test(o);
    }), u;
    u = e.valueCallback ? e.valueCallback(c) : c, u = n.valueCallback ? n.valueCallback(u) : u;
    var d = t.slice(o.length);
    return {
      value: u,
      rest: d
    };
  };
}
function findKey(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function findIndex(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function buildMatchPatternFn(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = t.match(e.matchPattern);
    if (!s)
      return null;
    var i = s[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    var o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var l = t.slice(i.length);
    return {
      value: o,
      rest: l
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i, parseOrdinalNumberPattern = /\d+/i, matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
}, matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function e(t) {
      return parseInt(t, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function e(t) {
      return t + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const match$1 = match;
var locale = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const defaultLocale = locale;
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, escapedStringRegExp$1 = /^'([^]*?)'?$/, doubleQuoteRegExp$1 = /''/g, unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format(e, t, n) {
  var s, i, a, o, l, c, u, d, p, f, g, C, k, M, _, S, E, P;
  requiredArgs(2, arguments);
  var $ = String(t), A = getDefaultOptions(), I = (s = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : A.locale) !== null && s !== void 0 ? s : defaultLocale, D = toInteger((a = (o = (l = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (u = n.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : A.firstWeekContainsDate) !== null && o !== void 0 ? o : (p = A.locale) === null || p === void 0 || (f = p.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(D >= 1 && D <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var R = toInteger((g = (C = (k = (M = n == null ? void 0 : n.weekStartsOn) !== null && M !== void 0 ? M : n == null || (_ = n.locale) === null || _ === void 0 || (S = _.options) === null || S === void 0 ? void 0 : S.weekStartsOn) !== null && k !== void 0 ? k : A.weekStartsOn) !== null && C !== void 0 ? C : (E = A.locale) === null || E === void 0 || (P = E.options) === null || P === void 0 ? void 0 : P.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(R >= 0 && R <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!I.localize)
    throw new RangeError("locale must contain localize property");
  if (!I.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var Y = toDate(e);
  if (!isValid(Y))
    throw new RangeError("Invalid time value");
  var q = getTimezoneOffsetInMilliseconds(Y), j = subMilliseconds(Y, q), X = {
    firstWeekContainsDate: D,
    weekStartsOn: R,
    locale: I,
    _originalDate: Y
  }, ee = $.match(longFormattingTokensRegExp$1).map(function(G) {
    var H = G[0];
    if (H === "p" || H === "P") {
      var F = longFormatters$1[H];
      return F(G, I.formatLong);
    }
    return G;
  }).join("").match(formattingTokensRegExp$1).map(function(G) {
    if (G === "''")
      return "'";
    var H = G[0];
    if (H === "'")
      return cleanEscapedString$1(G);
    var F = formatters$1[H];
    if (F)
      return !(n != null && n.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(G) && throwProtectedError(G, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(G) && throwProtectedError(G, t, String(e)), F(j, G, I.localize, X);
    if (H.match(unescapedLatinCharacterRegExp$1))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + H + "`");
    return G;
  }).join("");
  return ee;
}
function cleanEscapedString$1(e) {
  var t = e.match(escapedStringRegExp$1);
  return t ? t[1].replace(doubleQuoteRegExp$1, "'") : e;
}
function assign(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function _arrayLikeToArray(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, s = new Array(t); n < t; n++)
    s[n] = e[n];
  return s;
}
function _unsupportedIterableToArray(e, t) {
  if (e) {
    if (typeof e == "string")
      return _arrayLikeToArray(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return _arrayLikeToArray(e, t);
  }
}
function _createForOfIteratorHelper(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = _unsupportedIterableToArray(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var s = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return s >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[s++]
          };
        },
        e: function(u) {
          throw u;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, l;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var u = n.next();
      return a = u.done, u;
    },
    e: function(u) {
      o = !0, l = u;
    },
    f: function() {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (o)
          throw l;
      }
    }
  };
}
function _assertThisInitialized(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _setPrototypeOf(e, t) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(s, i) {
    return s.__proto__ = i, s;
  }, _setPrototypeOf(e, t);
}
function _inherits(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && _setPrototypeOf(e, t);
}
function _getPrototypeOf(e) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _getPrototypeOf(e);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _possibleConstructorReturn(e, t) {
  if (t && (_typeof(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(e);
}
function _createSuper(e) {
  var t = _isNativeReflectConstruct();
  return function() {
    var s = _getPrototypeOf(e), i;
    if (t) {
      var a = _getPrototypeOf(this).constructor;
      i = Reflect.construct(s, arguments, a);
    } else
      i = s.apply(this, arguments);
    return _possibleConstructorReturn(this, i);
  };
}
function _classCallCheck(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _toPrimitive(e, t) {
  if (_typeof(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var s = n.call(e, t || "default");
    if (_typeof(s) !== "object")
      return s;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _toPropertyKey(e) {
  var t = _toPrimitive(e, "string");
  return _typeof(t) === "symbol" ? t : String(t);
}
function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var s = t[n];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, _toPropertyKey(s.key), s);
  }
}
function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, t, n) {
  return t = _toPropertyKey(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var TIMEZONE_UNIT_PRIORITY = 10, Setter = /* @__PURE__ */ function() {
  function e() {
    _classCallCheck(this, e), _defineProperty(this, "priority", void 0), _defineProperty(this, "subPriority", 0);
  }
  return _createClass(e, [{
    key: "validate",
    value: function(n, s) {
      return !0;
    }
  }]), e;
}(), ValueSetter = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n(s, i, a, o, l) {
    var c;
    return _classCallCheck(this, n), c = t.call(this), c.value = s, c.validateValue = i, c.setValue = a, c.priority = o, l && (c.subPriority = l), c;
  }
  return _createClass(n, [{
    key: "validate",
    value: function(i, a) {
      return this.validateValue(i, this.value, a);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return this.setValue(i, a, this.value, o);
    }
  }]), n;
}(Setter), DateToSystemTimezoneSetter = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", TIMEZONE_UNIT_PRIORITY), _defineProperty(_assertThisInitialized(s), "subPriority", -1), s;
  }
  return _createClass(n, [{
    key: "set",
    value: function(i, a) {
      if (a.timestampIsSet)
        return i;
      var o = new Date(0);
      return o.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), o.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), o;
    }
  }]), n;
}(Setter), Parser = /* @__PURE__ */ function() {
  function e() {
    _classCallCheck(this, e), _defineProperty(this, "incompatibleTokens", void 0), _defineProperty(this, "priority", void 0), _defineProperty(this, "subPriority", void 0);
  }
  return _createClass(e, [{
    key: "run",
    value: function(n, s, i, a) {
      var o = this.parse(n, s, i, a);
      return o ? {
        setter: new ValueSetter(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, s, i) {
      return !0;
    }
  }]), e;
}(), EraParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 140), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["R", "u", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "G":
        case "GG":
        case "GGG":
          return o.era(i, {
            width: "abbreviated"
          }) || o.era(i, {
            width: "narrow"
          });
        case "GGGGG":
          return o.era(i, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return o.era(i, {
            width: "wide"
          }) || o.era(i, {
            width: "abbreviated"
          }) || o.era(i, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.era = o, i.setUTCFullYear(o, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser), numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function parseNumericPattern(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function parseTimezonePattern(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var s = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: s * (i * millisecondsInHour + a * millisecondsInMinute + o * millisecondsInSecond),
    rest: t.slice(n[0].length)
  };
}
function parseAnyDigitsSigned(e) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, e);
}
function parseNDigits(e, t) {
  switch (e) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, t);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, t);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, t);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, t);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function parseNDigitsSigned(e, t) {
  switch (e) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, t);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, t);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, t);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, t);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function dayPeriodEnumToHours(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(e, t) {
  var n = t > 0, s = n ? t : 1 - t, i;
  if (s <= 50)
    i = e || 100;
  else {
    var a = s + 50, o = Math.floor(a / 100) * 100, l = e >= a % 100;
    i = e + o - (l ? 100 : 0);
  }
  return n ? i : 1 - i;
}
function isLeapYearIndex$1(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var YearParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 130), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      var l = function(u) {
        return {
          year: u,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return mapValue(parseNDigits(4, i), l);
        case "yo":
          return mapValue(o.ordinalNumber(i, {
            unit: "year"
          }), l);
        default:
          return mapValue(parseNDigits(a.length, i), l);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var l = i.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var c = normalizeTwoDigitYear(o.year, l);
        return i.setUTCFullYear(c, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
      }
      var u = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return i.setUTCFullYear(u, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser), LocalWeekYearParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 130), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      var l = function(u) {
        return {
          year: u,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return mapValue(parseNDigits(4, i), l);
        case "Yo":
          return mapValue(o.ordinalNumber(i, {
            unit: "year"
          }), l);
        default:
          return mapValue(parseNDigits(a.length, i), l);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, o, l) {
      var c = getUTCWeekYear(i, l);
      if (o.isTwoDigitYear) {
        var u = normalizeTwoDigitYear(o.year, c);
        return i.setUTCFullYear(u, 0, l.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), startOfUTCWeek(i, l);
      }
      var d = !("era" in a) || a.era === 1 ? o.year : 1 - o.year;
      return i.setUTCFullYear(d, 0, l.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), startOfUTCWeek(i, l);
    }
  }]), n;
}(Parser), ISOWeekYearParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 130), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a) {
      return parseNDigitsSigned(a === "R" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var l = new Date(0);
      return l.setUTCFullYear(o, 0, 4), l.setUTCHours(0, 0, 0, 0), startOfUTCISOWeek(l);
    }
  }]), n;
}(Parser), ExtendedYearParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 130), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a) {
      return parseNDigitsSigned(a === "u" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCFullYear(o, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser), QuarterParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 120), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "Q":
        case "QQ":
          return parseNDigits(a.length, i);
        case "Qo":
          return o.ordinalNumber(i, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(i, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth((o - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser), StandAloneQuarterParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 120), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "q":
        case "qq":
          return parseNDigits(a.length, i);
        case "qo":
          return o.ordinalNumber(i, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(i, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth((o - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser), MonthParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), _defineProperty(_assertThisInitialized(s), "priority", 110), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      var l = function(u) {
        return u - 1;
      };
      switch (a) {
        case "M":
          return mapValue(parseNumericPattern(numericPatterns.month, i), l);
        case "MM":
          return mapValue(parseNDigits(2, i), l);
        case "Mo":
          return mapValue(o.ordinalNumber(i, {
            unit: "month"
          }), l);
        case "MMM":
          return o.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(i, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(i, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(i, {
            width: "wide",
            context: "formatting"
          }) || o.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(o, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser), StandAloneMonthParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 110), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      var l = function(u) {
        return u - 1;
      };
      switch (a) {
        case "L":
          return mapValue(parseNumericPattern(numericPatterns.month, i), l);
        case "LL":
          return mapValue(parseNDigits(2, i), l);
        case "Lo":
          return mapValue(o.ordinalNumber(i, {
            unit: "month"
          }), l);
        case "LLL":
          return o.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(i, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(i, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(i, {
            width: "wide",
            context: "standalone"
          }) || o.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(o, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser);
function setUTCWeek(e, t, n) {
  requiredArgs(2, arguments);
  var s = toDate(e), i = toInteger(t), a = getUTCWeek(s, n) - i;
  return s.setUTCDate(s.getUTCDate() - a * 7), s;
}
var LocalWeekParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 100), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "w":
          return parseNumericPattern(numericPatterns.week, i);
        case "wo":
          return o.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return parseNDigits(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, o, l) {
      return startOfUTCWeek(setUTCWeek(i, o, l), l);
    }
  }]), n;
}(Parser);
function setUTCISOWeek(e, t) {
  requiredArgs(2, arguments);
  var n = toDate(e), s = toInteger(t), i = getUTCISOWeek(n) - s;
  return n.setUTCDate(n.getUTCDate() - i * 7), n;
}
var ISOWeekParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 100), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "I":
          return parseNumericPattern(numericPatterns.week, i);
        case "Io":
          return o.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return parseNDigits(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return startOfUTCISOWeek(setUTCISOWeek(i, o));
    }
  }]), n;
}(Parser), DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], DateParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 90), _defineProperty(_assertThisInitialized(s), "subPriority", 1), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "d":
          return parseNumericPattern(numericPatterns.date, i);
        case "do":
          return o.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return parseNDigits(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var o = i.getUTCFullYear(), l = isLeapYearIndex$1(o), c = i.getUTCMonth();
      return l ? a >= 1 && a <= DAYS_IN_MONTH_LEAP_YEAR[c] : a >= 1 && a <= DAYS_IN_MONTH[c];
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCDate(o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser), DayOfYearParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 90), _defineProperty(_assertThisInitialized(s), "subpriority", 1), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, i);
        case "Do":
          return o.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return parseNDigits(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var o = i.getUTCFullYear(), l = isLeapYearIndex$1(o);
      return l ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMonth(0, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser);
function setUTCDay(e, t, n) {
  var s, i, a, o, l, c, u, d;
  requiredArgs(2, arguments);
  var p = getDefaultOptions(), f = toInteger((s = (i = (a = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (l = n.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && a !== void 0 ? a : p.weekStartsOn) !== null && i !== void 0 ? i : (u = p.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && s !== void 0 ? s : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var g = toDate(e), C = toInteger(t), k = g.getUTCDay(), M = C % 7, _ = (M + 7) % 7, S = (_ < f ? 7 : 0) + C - k;
  return g.setUTCDate(g.getUTCDate() + S), g;
}
var DayParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 90), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, l) {
      return i = setUTCDay(i, o, l), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser), LocalDayParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 90), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o, l) {
      var c = function(d) {
        var p = Math.floor((d - 1) / 7) * 7;
        return (d + l.weekStartsOn + 6) % 7 + p;
      };
      switch (a) {
        case "e":
        case "ee":
          return mapValue(parseNDigits(a.length, i), c);
        case "eo":
          return mapValue(o.ordinalNumber(i, {
            unit: "day"
          }), c);
        case "eee":
          return o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, l) {
      return i = setUTCDay(i, o, l), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser), StandAloneLocalDayParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 90), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o, l) {
      var c = function(d) {
        var p = Math.floor((d - 1) / 7) * 7;
        return (d + l.weekStartsOn + 6) % 7 + p;
      };
      switch (a) {
        case "c":
        case "cc":
          return mapValue(parseNDigits(a.length, i), c);
        case "co":
          return mapValue(o.ordinalNumber(i, {
            unit: "day"
          }), c);
        case "ccc":
          return o.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(i, {
            width: "wide",
            context: "standalone"
          }) || o.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(i, {
            width: "short",
            context: "standalone"
          }) || o.day(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, o, l) {
      return i = setUTCDay(i, o, l), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser);
function setUTCISODay(e, t) {
  requiredArgs(2, arguments);
  var n = toInteger(t);
  n % 7 === 0 && (n = n - 7);
  var s = 1, i = toDate(e), a = i.getUTCDay(), o = n % 7, l = (o + 7) % 7, c = (l < s ? 7 : 0) + n - a;
  return i.setUTCDate(i.getUTCDate() + c), i;
}
var ISODayParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 90), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      var l = function(u) {
        return u === 0 ? 7 : u;
      };
      switch (a) {
        case "i":
        case "ii":
          return parseNDigits(a.length, i);
        case "io":
          return o.ordinalNumber(i, {
            unit: "day"
          });
        case "iii":
          return mapValue(o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiiii":
          return mapValue(o.day(i, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiiiii":
          return mapValue(o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), l);
        case "iiii":
        default:
          return mapValue(o.day(i, {
            width: "wide",
            context: "formatting"
          }) || o.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(i, {
            width: "short",
            context: "formatting"
          }) || o.day(i, {
            width: "narrow",
            context: "formatting"
          }), l);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i = setUTCISODay(i, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
}(Parser), AMPMParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 80), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(dayPeriodEnumToHours(o), 0, 0, 0), i;
    }
  }]), n;
}(Parser), AMPMMidnightParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 80), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(dayPeriodEnumToHours(o), 0, 0, 0), i;
    }
  }]), n;
}(Parser), DayPeriodParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 80), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["a", "b", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(dayPeriodEnumToHours(o), 0, 0, 0), i;
    }
  }]), n;
}(Parser), Hour1to12Parser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 70), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["H", "K", "k", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, i);
        case "ho":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return parseNDigits(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var l = i.getUTCHours() >= 12;
      return l && o < 12 ? i.setUTCHours(o + 12, 0, 0, 0) : !l && o === 12 ? i.setUTCHours(0, 0, 0, 0) : i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), n;
}(Parser), Hour0to23Parser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 70), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, i);
        case "Ho":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return parseNDigits(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), n;
}(Parser), Hour0To11Parser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 70), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["h", "H", "k", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, i);
        case "Ko":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return parseNDigits(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var l = i.getUTCHours() >= 12;
      return l && o < 12 ? i.setUTCHours(o + 12, 0, 0, 0) : i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), n;
}(Parser), Hour1To24Parser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 70), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, i);
        case "ko":
          return o.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return parseNDigits(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      var l = o <= 24 ? o % 24 : o;
      return i.setUTCHours(l, 0, 0, 0), i;
    }
  }]), n;
}(Parser), MinuteParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 60), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, i);
        case "mo":
          return o.ordinalNumber(i, {
            unit: "minute"
          });
        default:
          return parseNDigits(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMinutes(o, 0, 0), i;
    }
  }]), n;
}(Parser), SecondParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 50), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a, o) {
      switch (a) {
        case "s":
          return parseNumericPattern(numericPatterns.second, i);
        case "so":
          return o.ordinalNumber(i, {
            unit: "second"
          });
        default:
          return parseNDigits(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCSeconds(o, 0), i;
    }
  }]), n;
}(Parser), FractionOfSecondParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 30), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["t", "T"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a) {
      var o = function(c) {
        return Math.floor(c * Math.pow(10, -a.length + 3));
      };
      return mapValue(parseNDigits(a.length, i), o);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return i.setUTCMilliseconds(o), i;
    }
  }]), n;
}(Parser), ISOTimezoneWithZParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 10), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["t", "T", "x"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, i);
        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, i);
        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, i);
        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, i);
        case "XXX":
        default:
          return parseTimezonePattern(timezonePatterns.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.timestampIsSet ? i : new Date(i.getTime() - o);
    }
  }]), n;
}(Parser), ISOTimezoneParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 10), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", ["t", "T", "X"]), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, i);
        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, i);
        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, i);
        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, i);
        case "xxx":
        default:
          return parseTimezonePattern(timezonePatterns.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return a.timestampIsSet ? i : new Date(i.getTime() - o);
    }
  }]), n;
}(Parser), TimestampSecondsParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 40), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", "*"), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i) {
      return parseAnyDigitsSigned(i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Parser), TimestampMillisecondsParser = /* @__PURE__ */ function(e) {
  _inherits(n, e);
  var t = _createSuper(n);
  function n() {
    var s;
    _classCallCheck(this, n);
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return s = t.call.apply(t, [this].concat(a)), _defineProperty(_assertThisInitialized(s), "priority", 20), _defineProperty(_assertThisInitialized(s), "incompatibleTokens", "*"), s;
  }
  return _createClass(n, [{
    key: "parse",
    value: function(i) {
      return parseAnyDigitsSigned(i);
    }
  }, {
    key: "set",
    value: function(i, a, o) {
      return [new Date(o), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Parser), parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
}, formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, escapedStringRegExp = /^'([^]*?)'?$/, doubleQuoteRegExp = /''/g, notWhitespaceRegExp = /\S/, unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(e, t, n, s) {
  var i, a, o, l, c, u, d, p, f, g, C, k, M, _, S, E, P, $;
  requiredArgs(3, arguments);
  var A = String(e), I = String(t), D = getDefaultOptions(), R = (i = (a = s == null ? void 0 : s.locale) !== null && a !== void 0 ? a : D.locale) !== null && i !== void 0 ? i : defaultLocale;
  if (!R.match)
    throw new RangeError("locale must contain match property");
  var Y = toInteger((o = (l = (c = (u = s == null ? void 0 : s.firstWeekContainsDate) !== null && u !== void 0 ? u : s == null || (d = s.locale) === null || d === void 0 || (p = d.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && c !== void 0 ? c : D.firstWeekContainsDate) !== null && l !== void 0 ? l : (f = D.locale) === null || f === void 0 || (g = f.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(Y >= 1 && Y <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var q = toInteger((C = (k = (M = (_ = s == null ? void 0 : s.weekStartsOn) !== null && _ !== void 0 ? _ : s == null || (S = s.locale) === null || S === void 0 || (E = S.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && M !== void 0 ? M : D.weekStartsOn) !== null && k !== void 0 ? k : (P = D.locale) === null || P === void 0 || ($ = P.options) === null || $ === void 0 ? void 0 : $.weekStartsOn) !== null && C !== void 0 ? C : 0);
  if (!(q >= 0 && q <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (I === "")
    return A === "" ? toDate(n) : new Date(NaN);
  var j = {
    firstWeekContainsDate: Y,
    weekStartsOn: q,
    locale: R
  }, X = [new DateToSystemTimezoneSetter()], ee = I.match(longFormattingTokensRegExp).map(function(de) {
    var le = de[0];
    if (le in longFormatters$1) {
      var me = longFormatters$1[le];
      return me(de, R.formatLong);
    }
    return de;
  }).join("").match(formattingTokensRegExp), G = [], H = _createForOfIteratorHelper(ee), F;
  try {
    var B = function() {
      var le = F.value;
      !(s != null && s.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(le) && throwProtectedError(le, I, e), !(s != null && s.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(le) && throwProtectedError(le, I, e);
      var me = le[0], ve = parsers[me];
      if (ve) {
        var be = ve.incompatibleTokens;
        if (Array.isArray(be)) {
          var oe = G.find(function(we) {
            return be.includes(we.token) || we.token === me;
          });
          if (oe)
            throw new RangeError("The format string mustn't contain `".concat(oe.fullToken, "` and `").concat(le, "` at the same time"));
        } else if (ve.incompatibleTokens === "*" && G.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(le, "` and any other token at the same time"));
        G.push({
          token: me,
          fullToken: le
        });
        var ye = ve.run(A, le, R.match, j);
        if (!ye)
          return {
            v: new Date(NaN)
          };
        X.push(ye.setter), A = ye.rest;
      } else {
        if (me.match(unescapedLatinCharacterRegExp))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + me + "`");
        if (le === "''" ? le = "'" : me === "'" && (le = cleanEscapedString(le)), A.indexOf(le) === 0)
          A = A.slice(le.length);
        else
          return {
            v: new Date(NaN)
          };
      }
    };
    for (H.s(); !(F = H.n()).done; ) {
      var z = B();
      if (_typeof(z) === "object")
        return z.v;
    }
  } catch (de) {
    H.e(de);
  } finally {
    H.f();
  }
  if (A.length > 0 && notWhitespaceRegExp.test(A))
    return new Date(NaN);
  var K = X.map(function(de) {
    return de.priority;
  }).sort(function(de, le) {
    return le - de;
  }).filter(function(de, le, me) {
    return me.indexOf(de) === le;
  }).map(function(de) {
    return X.filter(function(le) {
      return le.priority === de;
    }).sort(function(le, me) {
      return me.subPriority - le.subPriority;
    });
  }).map(function(de) {
    return de[0];
  }), Z = toDate(n);
  if (isNaN(Z.getTime()))
    return new Date(NaN);
  var re = subMilliseconds(Z, getTimezoneOffsetInMilliseconds(Z)), ae = {}, te = _createForOfIteratorHelper(K), ue;
  try {
    for (te.s(); !(ue = te.n()).done; ) {
      var ce = ue.value;
      if (!ce.validate(re, j))
        return new Date(NaN);
      var ge = ce.set(re, ae, j);
      Array.isArray(ge) ? (re = ge[0], assign(ae, ge[1])) : re = ge;
    }
  } catch (de) {
    te.e(de);
  } finally {
    te.f();
  }
  return re;
}
function cleanEscapedString(e) {
  return e.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function startOfHour(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setMinutes(0, 0, 0), t;
}
function startOfSecond(e) {
  requiredArgs(1, arguments);
  var t = toDate(e);
  return t.setMilliseconds(0), t;
}
function parseISO(e, t) {
  var n;
  requiredArgs(1, arguments);
  var s = toInteger((n = t == null ? void 0 : t.additionalDigits) !== null && n !== void 0 ? n : 2);
  if (s !== 2 && s !== 1 && s !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return new Date(NaN);
  var i = splitDateString(e), a;
  if (i.date) {
    var o = parseYear(i.date, s);
    a = parseDate(o.restDateString, o.year);
  }
  if (!a || isNaN(a.getTime()))
    return new Date(NaN);
  var l = a.getTime(), c = 0, u;
  if (i.time && (c = parseTime(i.time), isNaN(c)))
    return new Date(NaN);
  if (i.timezone) {
    if (u = parseTimezone(i.timezone), isNaN(u))
      return new Date(NaN);
  } else {
    var d = new Date(l + c), p = new Date(0);
    return p.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), p.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()), p;
  }
  return new Date(l + c + u);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(e) {
  var t = {}, n = e.split(patterns.dateTimeDelimiter), s;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? s = n[0] : (t.date = n[0], s = n[1], patterns.timeZoneDelimiter.test(t.date) && (t.date = e.split(patterns.timeZoneDelimiter)[0], s = e.substr(t.date.length, e.length))), s) {
    var i = patterns.timezone.exec(s);
    i ? (t.time = s.replace(i[1], ""), t.timezone = i[1]) : t.time = s;
  }
  return t;
}
function parseYear(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), s = e.match(n);
  if (!s)
    return {
      year: NaN,
      restDateString: ""
    };
  var i = s[1] ? parseInt(s[1]) : null, a = s[2] ? parseInt(s[2]) : null;
  return {
    year: a === null ? i : a * 100,
    restDateString: e.slice((s[1] || s[2]).length)
  };
}
function parseDate(e, t) {
  if (t === null)
    return new Date(NaN);
  var n = e.match(dateRegex);
  if (!n)
    return new Date(NaN);
  var s = !!n[4], i = parseDateUnit(n[1]), a = parseDateUnit(n[2]) - 1, o = parseDateUnit(n[3]), l = parseDateUnit(n[4]), c = parseDateUnit(n[5]) - 1;
  if (s)
    return validateWeekDate(t, l, c) ? dayOfISOWeekYear(t, l, c) : new Date(NaN);
  var u = new Date(0);
  return !validateDate(t, a, o) || !validateDayOfYearDate(t, i) ? new Date(NaN) : (u.setUTCFullYear(t, a, Math.max(i, o)), u);
}
function parseDateUnit(e) {
  return e ? parseInt(e) : 1;
}
function parseTime(e) {
  var t = e.match(timeRegex);
  if (!t)
    return NaN;
  var n = parseTimeUnit(t[1]), s = parseTimeUnit(t[2]), i = parseTimeUnit(t[3]);
  return validateTime(n, s, i) ? n * millisecondsInHour + s * millisecondsInMinute + i * 1e3 : NaN;
}
function parseTimeUnit(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function parseTimezone(e) {
  if (e === "Z")
    return 0;
  var t = e.match(timezoneRegex);
  if (!t)
    return 0;
  var n = t[1] === "+" ? -1 : 1, s = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return validateTimezone(s, i) ? n * (s * millisecondsInHour + i * millisecondsInMinute) : NaN;
}
function dayOfISOWeekYear(e, t, n) {
  var s = new Date(0);
  s.setUTCFullYear(e, 0, 4);
  var i = s.getUTCDay() || 7, a = (t - 1) * 7 + n + 1 - i;
  return s.setUTCDate(s.getUTCDate() + a), s;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function validateDate(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (daysInMonths[t] || (isLeapYearIndex(e) ? 29 : 28));
}
function validateDayOfYearDate(e, t) {
  return t >= 1 && t <= (isLeapYearIndex(e) ? 366 : 365);
}
function validateWeekDate(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function validateTime(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function validateTimezone(e, t) {
  return t >= 0 && t <= 59;
}
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const FORMATS = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
adapters._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return FORMATS;
  },
  parse: function(e, t) {
    if (e === null || typeof e > "u")
      return null;
    const n = typeof e;
    return n === "number" || e instanceof Date ? e = toDate(e) : n === "string" && (typeof t == "string" ? e = parse(e, t, new Date(), this.options) : e = parseISO(e, this.options)), isValid(e) ? e.getTime() : null;
  },
  format: function(e, t) {
    return format(e, t, this.options);
  },
  add: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return addMilliseconds(e, t);
      case "second":
        return addSeconds(e, t);
      case "minute":
        return addMinutes(e, t);
      case "hour":
        return addHours(e, t);
      case "day":
        return addDays(e, t);
      case "week":
        return addWeeks(e, t);
      case "month":
        return addMonths(e, t);
      case "quarter":
        return addQuarters(e, t);
      case "year":
        return addYears(e, t);
      default:
        return e;
    }
  },
  diff: function(e, t, n) {
    switch (n) {
      case "millisecond":
        return differenceInMilliseconds(e, t);
      case "second":
        return differenceInSeconds(e, t);
      case "minute":
        return differenceInMinutes(e, t);
      case "hour":
        return differenceInHours(e, t);
      case "day":
        return differenceInDays(e, t);
      case "week":
        return differenceInWeeks(e, t);
      case "month":
        return differenceInMonths(e, t);
      case "quarter":
        return differenceInQuarters(e, t);
      case "year":
        return differenceInYears(e, t);
      default:
        return 0;
    }
  },
  startOf: function(e, t, n) {
    switch (t) {
      case "second":
        return startOfSecond(e);
      case "minute":
        return startOfMinute(e);
      case "hour":
        return startOfHour(e);
      case "day":
        return startOfDay(e);
      case "week":
        return startOfWeek(e);
      case "isoWeek":
        return startOfWeek(e, { weekStartsOn: +n });
      case "month":
        return startOfMonth(e);
      case "quarter":
        return startOfQuarter(e);
      case "year":
        return startOfYear(e);
      default:
        return e;
    }
  },
  endOf: function(e, t) {
    switch (t) {
      case "second":
        return endOfSecond(e);
      case "minute":
        return endOfMinute(e);
      case "hour":
        return endOfHour(e);
      case "day":
        return endOfDay(e);
      case "week":
        return endOfWeek(e);
      case "month":
        return endOfMonth(e);
      case "quarter":
        return endOfQuarter(e);
      case "year":
        return endOfYear(e);
      default:
        return e;
    }
  }
});
const COLOURS = {
  TRANSPARENT: "transparent",
  WHITE: "#FFFFFF",
  BLACK: "#000000",
  LOW_EMPHASIS_GREY: "#E5E5E5",
  LOW_EMPHASIS_BLACK: "#00000066",
  MEDIUM_EMPHASIS_BLACK: "#00000099",
  HIGH_EMPHASIS_BLACK: "#000000E6",
  DISABLED: "#00000066",
  MEDIUM_EMPHASIS_DISABLED: "#D8D8D8",
  LOW_EMPHASIS_DISABLED: "#D8D8D800"
}, TRANSPARENCY = {
  40: "6B",
  100: "00"
}, DATE_FORMAT = {
  FULL_TIME: "hh:mm aa",
  FULL_DATE: "dd MMM yyyy",
  FULL_DATE_TIME: "dd MMM yyyy, hh:mm aa",
  DATE_MONTH: "dd MMM",
  MONTH_YEAR: "MMM yyyy"
}, createFadedColor = (e) => ({
  mediumEmphasis: `${e}${TRANSPARENCY[40]}`,
  lowEmphasis: `${e}${TRANSPARENCY[100]}`
}), formatXLabel = (e, t) => {
  if (t && typeof e == "number") {
    const { unit: n, displayFormats: s } = t, i = s[n];
    if (i)
      return format(new Date(e), i);
  }
  return e;
}, formatYLabel = (e, t) => {
  if (typeof e == "number" && t)
    return formatCurrency(e, {
      currency: t.currency,
      currencyLocale: t.currencyLocale
    });
}, createLinearGradient = (e, t) => e.createLinearGradient(0, 0, 0, t), handleOnHover = (e, t, n, s) => {
  if (t.length > 0) {
    const i = e[n];
    typeof i == "number" && s(i);
  }
}, tooltipHeight = 30;
plugin_tooltip.positioners.top = function(e, t) {
  return {
    x: t.x,
    y: 0
  };
};
function useChartJS(e, t) {
  const n = computed(() => e.data.length > 0), s = () => ({
    labels: e.labels,
    datasets: [
      {
        data: e.data,
        tension: e.tension,
        clip: !1,
        borderWidth: 2,
        pointRadius: 0,
        pointHoverBackgroundColor: e.colourCode,
        pointHoverBorderColor: e.colourCode,
        fill: !0,
        borderColor: e.colourCode,
        backgroundColor: ({ chart: { chartArea: c, ctx: u } }) => {
          if (!c)
            return;
          const { mediumEmphasis: d, lowEmphasis: p } = createFadedColor(
            e.colourCode || COLOURS.BLACK
          ), f = createLinearGradient(
            u,
            c.height + tooltipHeight
          );
          return f.addColorStop(0, d), f.addColorStop(1, p), f;
        }
      }
    ]
  }), i = () => ({
    responsive: !0,
    maintainAspectRatio: !1,
    animations: {
      colors: !1
    },
    layout: {
      padding: {
        top: tooltipHeight
      }
    },
    interaction: {
      mode: "index",
      intersect: !1
    },
    hover: {
      mode: "index",
      intersect: !1
    },
    events: n.value ? ["mousemove", "mouseout", "click", "touchstart", "touchmove"] : void 0,
    onHover: (c, u, { data: { datasets: d } }) => {
      if (u && u.length > 0) {
        const p = d[0].data, f = u[0].index;
        handleOnHover(p, e.data, f, t);
      }
    },
    transitions: {
      show: {
        animations: {
          x: {
            from: 0
          },
          y: {
            from: 0
          }
        }
      }
    },
    scales: {
      y: {
        position: "right",
        ticks: {
          display: e.labelDisplay.y.display && n.value,
          maxTicksLimit: 3,
          callback: (c) => formatYLabel(c, e.currencyFormat)
        },
        grid: {
          display: !1
        },
        border: {
          display: !1
        }
      },
      x: {
        type: "time",
        ...e.maxX && {
          max: e.maxX
        },
        time: {
          tooltipFormat: e.dateFormatOption.tooltipFormat || DATE_FORMAT.FULL_DATE_TIME,
          unit: e.dateFormatOption.unit,
          displayFormats: e.dateFormatOption.displayFormats
        },
        grid: {
          display: !1
        },
        border: {
          display: !1
        },
        ticks: {
          align: "inner",
          minRotation: 0,
          maxRotation: 0,
          maxTicksLimit: e.maxTicksLimit,
          callback: (c) => formatXLabel(c, e.dateFormatOption)
        }
      }
    },
    plugins: {
      tooltip: {
        position: "top",
        displayColors: !1,
        titleColor: COLOURS.WHITE,
        backgroundColor: COLOURS.HIGH_EMPHASIS_BLACK,
        bodyColor: COLOURS.WHITE,
        bodyFont: {
          size: 16,
          weight: "bold"
        },
        callbacks: {
          label: () => ""
        },
        titleMarginBottom: 0,
        caretSize: 0
      }
    }
  }), a = (c) => {
    var f;
    const u = (f = c.tooltip) == null ? void 0 : f.getActiveElements();
    if (!u || !u.length)
      return;
    const p = c.getDatasetMeta(0).data.map((g) => g.getProps(["x", "y"]));
    return {
      current: u[0],
      points: p
    };
  };
  return {
    getLineChartDataConfig: s,
    getLineChartOptions: i,
    mouseLinePlugin: {
      id: "mouseLinePlugin",
      afterDatasetDraw: (c) => {
        const { ctx: u, scales: d } = c, p = a(c);
        if (!p)
          return;
        const {
          current: {
            element: { x: f }
          }
        } = p, g = d.y.top, C = d.y.bottom;
        u.save(), u.beginPath(), u.moveTo(f, g), u.lineTo(f, C), u.lineWidth = 1, u.strokeStyle = e.colourCode || COLOURS.BLACK, u.stroke(), u.restore();
      }
    },
    horizontalLineOnEmptyDataPlugin: {
      id: "horizontalLineOnEmptyDataPlugin",
      afterDatasetDraw: ({ ctx: c, scales: u, height: d }) => {
        if (n.value)
          return;
        const p = u.x, f = u.y, g = d / 2;
        c.beginPath(), c.moveTo(0, g), c.lineTo(p.right, g), c.lineWidth = 1, c.strokeStyle = COLOURS.LOW_EMPHASIS_GREY, c.stroke(), typeof e.yLabelForEmptyState < "u" && (c.fillStyle = COLOURS.MEDIUM_EMPHASIS_BLACK, c.textAlign = "right", c.fillText(
          formatYLabel(e.yLabelForEmptyState, e.currencyFormat) || "",
          f.right,
          g
        ));
      }
    }
  };
}
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "LineChart",
  props: {
    id: null,
    labels: null,
    data: null,
    dateFormatOption: null,
    labelDisplay: null,
    colourCode: { default: void 0 },
    maxX: { default: void 0 },
    maxTicksLimit: { default: 6 },
    tension: { default: 0 },
    currencyFormat: { default: () => ({
      currencyLocale: "en-AU",
      currency: "AUD"
    }) },
    yLabelForEmptyState: { default: void 0 }
  },
  emits: ["onHover"],
  setup(e, { emit: t }) {
    const n = e;
    Chart$1.register(
      CategoryScale,
      LinearScale,
      PointElement,
      LineElement,
      TimeScale,
      TimeSeriesScale,
      plugin_tooltip,
      index
    );
    const s = (d) => {
      t("onHover", d);
    }, {
      getLineChartDataConfig: i,
      getLineChartOptions: a,
      mouseLinePlugin: o,
      horizontalLineOnEmptyDataPlugin: l
    } = useChartJS(n, s), c = computed(() => i()), u = computed(() => a());
    return (d, p) => (openBlock(), createBlock(_sfc_main$2K, null, {
      default: withCtx(() => [
        createVNode(unref(Line), {
          id: e.id,
          options: unref(u),
          data: unref(c),
          plugins: [unref(o), unref(l)],
          class: "max-w-full text-sm text-black-60 h-[255px]"
        }, null, 8, ["id", "options", "data", "plugins"])
      ]),
      _: 1
    }));
  }
}), DATA_TEST_ID = {
  LIST: "list",
  LIST_ITEM: "list-item"
}, _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "List",
  props: {
    ordered: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = computed(() => t.ordered ? "ol" : "ul"), s = () => classMerge({
      "list-disc": !t.ordered,
      "list-decimal": t.ordered
    });
    return (i, a) => (openBlock(), createBlock(_sfc_main$2K, { "padding-left": "lg" }, {
      default: withCtx(() => [
        (openBlock(), createBlock(resolveDynamicComponent(unref(n)), {
          class: normalizeClass(s()),
          "data-testid": unref(DATA_TEST_ID).LIST
        }, {
          default: withCtx(() => [
            renderSlot(i.$slots, "default")
          ]),
          _: 3
        }, 8, ["class", "data-testid"]))
      ]),
      _: 3
    }));
  }
});
export {
  _sfc_main$n as $,
  AccordionItem as A,
  _sfc_main$2J as B,
  _sfc_main$I as C,
  _sfc_main$M as D,
  _sfc_main$H as E,
  _sfc_main$G as F,
  _sfc_main$F as G,
  _sfc_main$D as H,
  _sfc_main$E as I,
  _sfc_main$B as J,
  _sfc_main$A as K,
  _sfc_main$z as L,
  _sfc_main$y as M,
  _sfc_main$w as N,
  Logo as O,
  _sfc_main$u as P,
  _sfc_main$t as Q,
  _sfc_main$r as R,
  Skeleton as S,
  Tooltip$1 as T,
  _sfc_main$q as U,
  _sfc_main$p as V,
  _sfc_main$o as W,
  SnackBarPlugin as X,
  showSnack as Y,
  vForwardRef as Z,
  _export_sfc$1 as _,
  _sfc_main$2K as a,
  _sfc_main$1q as a$,
  _sfc_main$m as a0,
  _sfc_main$l as a1,
  formatCurrency as a2,
  formatCurrencyAsDecimal as a3,
  _sfc_main$k as a4,
  _sfc_main$j as a5,
  classMerge as a6,
  _sfc_main$2 as a7,
  _sfc_main$1 as a8,
  _sfc_main as a9,
  _sfc_main$2l as aA,
  _sfc_main$1O as aB,
  _sfc_main$1N as aC,
  _sfc_main$1M as aD,
  _sfc_main$2p as aE,
  _sfc_main$1L as aF,
  _sfc_main$1K as aG,
  _sfc_main$1J as aH,
  _sfc_main$1I as aI,
  _sfc_main$1H as aJ,
  _sfc_main$1G as aK,
  _sfc_main$1F as aL,
  _sfc_main$1E as aM,
  _sfc_main$1D as aN,
  _sfc_main$1C as aO,
  _sfc_main$2k as aP,
  _sfc_main$1B as aQ,
  _sfc_main$1A as aR,
  _sfc_main$1z as aS,
  _sfc_main$1y as aT,
  _sfc_main$1x as aU,
  _sfc_main$1w as aV,
  _sfc_main$1v as aW,
  _sfc_main$1u as aX,
  _sfc_main$1t as aY,
  _sfc_main$1s as aZ,
  _sfc_main$1r as a_,
  createDateMask as aa,
  createCurrencyMask as ab,
  createUnitsMask as ac,
  createPercentageMask as ad,
  createDateOfBirthMask as ae,
  createAccountBSBMask as af,
  createAccountNumberMask as ag,
  _sfc_main$26 as ah,
  _sfc_main$23 as ai,
  _sfc_main$20 as aj,
  _sfc_main$1Z as ak,
  _sfc_main$1Y as al,
  _sfc_main$1X as am,
  _sfc_main$2m as an,
  _sfc_main$1W as ao,
  _sfc_main$1V as ap,
  _sfc_main$1U as aq,
  _sfc_main$1T as ar,
  _sfc_main$1S as as,
  _sfc_main$1R as at,
  _sfc_main$1Q as au,
  _sfc_main$2n as av,
  _sfc_main$2C as aw,
  _sfc_main$2g as ax,
  _sfc_main$2f as ay,
  _sfc_main$1P as az,
  _sfc_main$2I as b,
  _sfc_main$1p as b0,
  _sfc_main$1o as b1,
  _sfc_main$1n as b2,
  _sfc_main$1m as b3,
  _sfc_main$1l as b4,
  _sfc_main$2i as b5,
  _sfc_main$1k as b6,
  _sfc_main$1j as b7,
  _sfc_main$1i as b8,
  _sfc_main$2y as b9,
  _sfc_main$X as bA,
  _sfc_main$W as bB,
  _sfc_main$V as bC,
  _sfc_main$U as bD,
  _sfc_main$T as bE,
  _sfc_main$S as bF,
  _sfc_main$R as bG,
  _sfc_main$Q as bH,
  _sfc_main$P as bI,
  _sfc_main$O as bJ,
  _sfc_main$N as bK,
  _sfc_main$25 as bL,
  _sfc_main$21 as bM,
  _sfc_main$27 as bN,
  _sfc_main$1_ as bO,
  _sfc_main$24 as ba,
  _sfc_main$1h as bb,
  _sfc_main$1g as bc,
  _sfc_main$1f as bd,
  _sfc_main$1e as be,
  _sfc_main$1d as bf,
  _sfc_main$1c as bg,
  _sfc_main$1b as bh,
  _sfc_main$1a as bi,
  _sfc_main$19 as bj,
  _sfc_main$18 as bk,
  _sfc_main$17 as bl,
  _sfc_main$1$ as bm,
  _sfc_main$16 as bn,
  _sfc_main$29 as bo,
  _sfc_main$15 as bp,
  _sfc_main$14 as bq,
  _sfc_main$13 as br,
  _sfc_main$12 as bs,
  _sfc_main$11 as bt,
  _sfc_main$10 as bu,
  _sfc_main$$ as bv,
  _sfc_main$_ as bw,
  _sfc_main$Z as bx,
  _sfc_main$Y as by,
  _sfc_main$22 as bz,
  _sfc_main$2G as c,
  _sfc_main$2z as d,
  _sfc_main$2F as e,
  _sfc_main$2E as f,
  _sfc_main$2w as g,
  _sfc_main$2v as h,
  _sfc_main$2B as i,
  _sfc_main$2u as j,
  _sfc_main$2t as k,
  _sfc_main$2x as l,
  _sfc_main$2H as m,
  _sfc_main$2s as n,
  _sfc_main$2r as o,
  _sfc_main$2o as p,
  _sfc_main$2j as q,
  _sfc_main$2b as r,
  _sfc_main$2a as s,
  _sfc_main$2d as t,
  _sfc_main$2c as u,
  _sfc_main$2e as v,
  _sfc_main$2q as w,
  _sfc_main$K as x,
  _sfc_main$J as y,
  _sfc_main$2h as z
};
//# sourceMappingURL=index-e396d419.mjs.map
